const translations = {
  it: {
    nav: {
      overview: 'Panoramica',
      catalog: 'Catalogo',
      content: 'Contenuti AI',
      translations: 'Traduzioni',
      images: 'Immagini',
      batch: 'Operazioni Batch',
      speed: 'Speed Optimizer',
      history: 'Storico',
      usage: 'Utilizzo e Piano',
      settings: 'Impostazioni',
      support: 'Supporto',
    },
    common: {
      save: 'Salva',
      cancel: 'Annulla',
      delete: 'Elimina',
      close: 'Chiudi',
      confirm: 'Conferma',
      loading: 'Caricamento...',
      error: 'Errore',
      success: 'Successo',
      search: 'Cerca',
      filter: 'Filtra',
      all: 'Tutti',
      yes: 'Sì',
      no: 'No',
      back: 'Indietro',
      next: 'Avanti',
      apply: 'Applica',
      generate: 'Genera',
      publish: 'Pubblica',
      optimize: 'Ottimizza',
      refresh: 'Aggiorna',
    },
    settings: {
      title: 'Impostazioni',
      subtitle: 'Centro di controllo AI',
      tabs: {
        general: 'Generale',
        localization: 'Localizzazione',
        ai_engine: 'AI Engine',
        appearance: 'Aspetto',
        piano: 'Piano',
        advanced: 'Avanzate',
      },
      save_btn: 'Salva impostazioni',
      unsaved: 'Modifiche non salvate',
      action_loading: 'In corso...',
      general: {
        contents: 'Contenuti',
        default_lang: 'Lingua Default Contenuti',
        tone: 'Tono Globale dei Contenuti',
        tone_hint: 'Applicato a prodotti, collezioni, articoli e batch',
        seo_rules: 'Regole SEO',
        seo_title_max: 'Lunghezza Massima SEO Title',
        seo_title_hint: 'Raccomandato: 50–60 caratteri',
        meta_max: 'Lunghezza Massima Meta Description',
        meta_hint: 'Raccomandato: 150–160 caratteri',
        chars: 'caratteri',
        images: 'Preferenze Immagini',
        img_format: 'Formato Default',
        img_square: 'Quadrato (1:1)',
        img_landscape: 'Landscape (4:3)',
        img_portrait: 'Portrait (3:4)',
        img_quality: 'Qualità Compressione',
        img_quality_low: '50% (compressa)',
        img_quality_high: '100% (massima)',
        store_info: 'Informazioni Store',
        store_domain: 'Dominio',
        store_plan: 'Piano',
        store_installed: 'Installato',
      },
      ai: {
        strategy: 'Strategia AI',
        params_title: 'Parametri Generazione',
        creativity: 'Creatività',
        creative_low: 'Conservativa',
        creative_high: 'Creativa',
        seo_strictness: 'Rigidità SEO',
        seo_low: 'Flessibile',
        seo_high: 'Rigorosa',
        tone_label: 'Tono Globale',
        auto_title: 'Auto-Ottimizzazione AI',
        auto_hint: 'Attiva per ottimizzare automaticamente i contenuti',
        on: 'Attiva',
        off: 'Off',
        threshold: 'Soglia di Ottimizzazione',
        threshold_low: 'Ottimizza tutto',
        threshold_high: 'Solo i peggiori',
        threshold_hint: 'Interviene sugli elementi con score SEO < {{n}}',
        frequency: 'Frequenza',
        scope: 'Scope',
        triggers: 'Trigger',
        img_format: 'Formato immagine',
        img_square: 'Quadrato 1:1',
        img_square_sub: '800×800 px',
        img_landscape: 'Landscape 4:3',
        img_landscape_sub: '800×600 px',
        img_portrait: 'Portrait 3:4',
        img_portrait_sub: '600×800 px',
        img_no_resize: 'Nessun resize',
        img_no_resize_sub: 'Dimensioni originali',
        compress: 'Compressione',
        compress_hint: 'Riduci dimensione file',
        quality: 'Qualità',
        daily_credits: 'Crediti AI oggi',
        remaining: '{{n}} rimanenti',
        reset_in: 'Reset in',
        running: 'In corso — {{done}}/{{total}} prodotti',
        run_now: 'Esegui Ora',
        run_desc: 'Ottimizza elementi con score < {{threshold}} in: {{scope}}',
        preview_title: 'Anteprima — Prima / Dopo',
        before: 'Prima',
        after: 'Dopo AI',
        no_keywords: 'nessuna keyword',
        preview_note: 'Esempio su prodotto «Scarpa Running Pro X1» — aggiornamento istantaneo',
        alt_mode_label: 'Modalità generazione ALT text',
        alt_preview: 'Anteprima',
        alt_mode_ai: 'AI intelligente',
        alt_mode_ai_desc: 'OpenAI genera ALT ottimizzato per ogni immagine',
        alt_mode_template: 'Template gratuito',
        alt_mode_template_desc: 'Nessun credito AI — usa il template sotto',
        alt_mode_auto: 'Auto fallback',
        alt_mode_auto_desc: 'AI quando disponibile, template se crediti esauriti',
        alt_hint_template: 'Modalità gratuita: nessun credito AI consumato per ALT text.',
        alt_hint_auto: 'Auto fallback: AI se crediti disponibili, altrimenti template automatico.',
        pct_done: '{{pct}}% completato',
        n_errors: '{{n}} errori',
        alt_template_label: 'Template personalizzato',
        alt_vars_label: 'Variabili disponibili — clicca per inserire',
      },
      piano: {
        credits_title: 'Utilizzo Crediti',
        plan_label: 'Piano',
        extra_credits: 'Crediti Extra',
        unlimited: '∞ Crediti illimitati',
        unlimited_sub: 'Piano Elite — nessun limite mensile',
        plan_credits: 'Crediti piano',
        consumed: 'Consumati dal piano',
        residual: 'Residui piano',
        extra_available: 'Crediti extra disponibili',
        extra_sub: 'Consumati solo dopo il piano mensile',
        total_available: 'Disponibili Totali',
        consumed_cycle: 'Crediti consumati nel ciclo corrente',
        status_active: 'Attivo',
        status_pending: 'In elaborazione',
        status_frozen: '⚠ Sospeso',
        status_free: 'Free / Nessun abbonamento',
        trial_active: 'Trial attivo',
        trial_access: 'accesso completo fino al {{date}}.',
        reinstall_banner_title: 'Piano precedente rilevato',
        reinstall_banner_desc: 'Il tuo abbonamento Shopify esistente è in fase di riconciliazione. Attendi il completamento prima di cambiare piano.',
        sub_status: 'Stato abbonamento',
        next_credit_reset: 'Prossimo reset crediti',
        trial_end: 'Fine trial',
        trial_label: 'Trial gratuito',
        trial_used: 'Già utilizzato',
        trial_available: '{{n}} giorni disponibili',
        cancel_btn: 'Annulla abbonamento',
        cancelling: 'Cancellazione...',
        plans_title: 'Piani Disponibili',
        plan_active: 'Piano Attivo',
        plan_current: 'Piano Attuale',
        per_month: '/mese',
        downgrade: 'Torna a Free',
        downgrading: 'Downgrade...',
        upgrade: 'Upgrade',
        downgrade_btn: 'Downgrade',
        redirecting: 'Reindirizzo...',
        trial_btn: 'Prova gratis',
        trial_btn_days: '({{n}}gg)',
        plan_overage: 'Crediti AI aggiuntivi: {{price}} per credito',
        plan_no_overage: 'Nessun costo per crediti AI aggiuntivi',
        plan_trial_line: 'Prova gratuita di {{n}} giorni',
        plans_note: 'I piani a pagamento includono {{n}} giorni di prova gratuita. Nessun costo di attivazione. I pagamenti sono gestiti da Shopify Billing.',
        credits_section: 'Acquista Crediti Extra',
        credits_desc: 'I crediti extra si sommano al tuo piano mensile e non scadono mai. Compatibili con tutti i piani.',
        one_time: 'una tantum',
        per_credit: '¢ per credito',
        buy: 'Acquista',
        payment_note: 'Il pagamento viene elaborato in modo sicuro tramite Shopify Billing. Nessun dato di pagamento viene memorizzato sul nostro server.',
        history_title: 'Storico Acquisti Crediti',
        history_count: '{{n}} acquist{{suffix}}',
        hist_invested: 'Totale investito',
        hist_bought: 'Crediti acquistati',
        hist_available: 'Ancora disponibili',
        hist_empty: 'Nessun acquisto di crediti extra effettuato.',
        hist_date: 'Data',
        hist_pkg: 'Pacchetto',
        hist_credits: 'Crediti',
        hist_amount: 'Importo',
        hist_status: 'Stato',
        hist_completed: 'Completato',
        hist_pending: 'In attesa',
        hist_declined: 'Rifiutato',
        trend_title: 'Trend Utilizzo',
        trend_placeholder: 'Grafico utilizzo (disponibile con Shopify Billing)',
        stats_products: 'Prodotti Analizzati',
        stats_content: 'Contenuti Generati',
        stats_translations: 'Traduzioni',
        stats_images: 'Immagini Ottimizzate',
        toast_sub_pending: 'Abbonamento in elaborazione — riceverai una conferma a breve.',
        toast_sub_activated: '{{name}} attivato!',
        toast_trial_suffix: '({{n}} giorni di prova gratuita)',
        toast_sub_error: 'Errore verifica abbonamento',
        toast_purchase_duplicate: 'Acquisto già registrato.',
        toast_credits_added: '+{{n}} crediti aggiunti al tuo account!',
        toast_purchase_error: 'Errore verifica acquisto',
        toast_purchase_start_error: 'Errore avvio acquisto',
        toast_sub_start_error: 'Errore avvio abbonamento',
        toast_store_unavailable: 'Store non ancora collegato. Ricarica l\'app in Shopify Admin e riprova.',
        toast_sub_cancelled: 'Abbonamento cancellato. Piano tornato a Free.',
        toast_sub_cancel_error: 'Errore cancellazione abbonamento',
        pkg_100_label: '100 Crediti',
        pkg_100_desc: 'Ideale per uso occasionale',
        pkg_300_label: '300 Crediti',
        pkg_300_desc: 'Risparmia il 17%',
        pkg_300_badge: '⭐ Più richiesto',
        pkg_700_label: '700 Crediti',
        pkg_700_desc: 'Risparmia il 29%',
        pkg_1500_label: '1.500 Crediti',
        pkg_1500_desc: 'Risparmia il 33%',
        pkg_1500_badge: '🔥 Miglior valore',
        plan_starter_badge: '⭐ Più Popolare',
        plan_starter_benefit: 'Risparmia ore di lavoro ogni mese.',
        plan_pro_badge: '🔥 Crescita SEO',
        plan_pro_benefit: 'Migliora indicizzazione e performance SEO.',
        plan_elite_badge: '🚀 Agenzie',
        plan_elite_benefit: 'Pensato per agenzie e cataloghi enterprise.',
      },
      toast: {
        saved_at: 'Salvato alle {{time}}',
        save_error: 'Errore nel salvataggio',
        budget_exceeded: 'Credito giornaliero esaurito — {{done}} prodotti ottimizzati su {{total}}',
        autopilot_stopped: 'Autopilot interrotto — {{done}} prodotti ottimizzati su {{total}}',
        images_optimized: 'Immagini ottimizzate — {{n}} prodotti',
        images_failed: '{{n}} immagini non ottimizzate',
        autopilot_done: 'Autopilot completato — {{started}} prodotti in coda',
        autopilot_empty: 'Nessun elemento sotto la soglia indicata',
        autopilot_stopping: 'Autopilot in arresto...',
        reindex_started: 'Re-indicizzazione avviata',
        resync_started: 'Risincronizzazione avviata',
        cache_cleared: 'Cache svuotata',
        sync_reset: 'Stato sync resettato',
      },
      advanced: {
        warning: 'Le azioni seguenti influenzano il comportamento del sistema. Usale solo se necessario.',
        sync_title: 'Sincronizzazione',
        reindex: 'Re-indicizza Prodotti',
        reindex_desc: 'Ricalcola i dati SEO per tutti i prodotti nel database',
        resync: 'Risincronizza con Shopify',
        resync_desc: 'Forza la sincronizzazione completa di prodotti e collezioni',
        cache_title: 'Cache',
        clear_cache: 'Svuota Cache Applicazione',
        clear_cache_desc: 'Cancella i batch in corso nel browser. Operazioni non completate andranno perse.',
        reset_credits: 'Reset Crediti Giornalieri',
        reset_credits_desc: 'Azzera il contatore crediti AI di oggi (dev). Limite attuale: 5.000/giorno.',
        danger_zone: 'Zona Pericolosa',
        reset_sync: 'Reset Stato Sync',
        reset_sync_desc: 'Forza il reset della sincronizzazione. Usare solo se il sync è bloccato da più di 30 minuti.',
      },
    },
    ai_engine: {
      preset: {
        growth_desc: 'Massimizza conversioni e coinvolgimento',
        luxury_desc: 'Brand premium e narrativa esclusiva',
        seo_desc: 'Massimizza visibilità organica su Google',
        balanced_desc: 'Equilibrio ottimale tra qualità e SEO',
      },
      tone: {
        professional: 'Professionale',
        professional_desc: 'Formale, autorevole, crea fiducia',
        luxury: 'Luxury',
        luxury_desc: 'Elegante, esclusivo, premium',
        technical: 'Tecnico',
        technical_desc: 'Preciso, specifiche, dati misurabili',
        conversational: 'Conversazionale',
        conversational_desc: 'Diretto, friendly, coinvolgente',
      },
      frequency: {
        daily: 'Giornaliero',
        daily_desc: '1× al giorno',
        hourly: 'Ogni ora',
        hourly_desc: 'Continuo',
        realtime: 'Immediato',
        realtime_desc: 'Appena possibile',
      },
      scope: {
        products: 'Prodotti',
        collections: 'Collezioni',
        articles: 'Articoli',
        pages: 'Pagine',
      },
      trigger: {
        seo_score: 'Score SEO basso',
        missing_meta: 'Metadati mancanti',
        missing_alt: 'ALT text assente',
        outdated_desc: 'Descrizione datata',
        keywords: 'Keywords mancanti',
        image_quality: 'Immagini non ottimizzate',
      },
    },
    appearance: {
      title: 'Aspetto',
      theme_title: 'Tema',
      theme: {
        light: 'Chiaro',
        dark: 'Scuro',
        system: 'Sistema',
      },
      density_title: 'Densità Layout',
      density: {
        compact: 'Compatto',
        comfortable: 'Confortevole',
        spacious: 'Spazioso',
        compact_desc: 'Più contenuto',
        comfortable_desc: 'Bilanciato',
        spacious_desc: 'Più respiro',
      },
      sidebar_title: 'Barra Laterale',
      sidebar: {
        expanded: 'Espansa',
        collapsed: 'Ridotta',
        hidden: 'Nascosta',
        expanded_desc: 'Sempre visibile',
        collapsed_desc: 'Solo icone',
        hidden_desc: 'Su hover',
      },
    },
    localization: {
      ui_language: 'Lingua Interfaccia',
      select_language: "Seleziona la lingua dell'app",
      reload_note: 'La lingua viene applicata immediatamente',
    },
    dashboard: {
      title: 'Panoramica',
      subtitle: 'Riepilogo attività del negozio',
      products: 'Prodotti',
      optimized: 'Ottimizzati',
      pending: 'In attesa',
      seo_score: 'Punteggio SEO',
      audit_center: 'Audit Center',
      sync_products: 'Sincronizza Prodotti',
      analyze_products: 'Analizza Prodotti',
      audit_site: 'Audit Sito 360',
      syncing: 'Sync...',
      analyzing: 'Analisi...',
      auditing: 'Audit...',
      section_account: 'Account e Piano',
      section_catalog: 'Stato Catalogo',
      section_images: 'Immagini',
      section_seo_tech: 'SEO Tecnico — Audit Sito Dettagliato',
      section_ux_trust: 'UX & Trust — Highlights',
      section_actions: 'Azioni Consigliate AI',
      recent_activity: 'Attività Recenti',
      hint_plan: 'Stato del piano e dei crediti',
      hint_never_synced: 'Mai sincronizzato',
      hint_priority: 'Ordinato per priorità',
      hint_last_sync: 'Ultima sync {{date}}',
      current_plan: 'Piano Attuale',
      credits_used: 'Crediti Usati',
      credits_remaining: 'Crediti Residui',
      public_domain: 'Dominio Pubblico',
      credit_usage: 'Utilizzo crediti',
      hint_installed: 'Installato {{date}}',
      hint_pct_plan: '{{pct}}% del piano',
      hint_limit: 'Limite {{n}}',
      hint_last_audit: 'Ultimo audit {{date}}',
      hint_no_audit: 'Audit non eseguito',
      no_audit: 'Nessun audit eseguito',
      no_audit_desc: 'Lancia un audit per analizzare title, meta, H1, canonical, robots, sitemap, HTTPS, OG, JSON-LD, performance, immagini e link.',
      run_audit: 'Esegui Audit',
      in_progress: 'In corso...',
      audit_phase: 'Audit in corso (fase: {{phase}})...',
      ux_highlights: 'UX Highlights',
      trust_compliance: 'Trust & Compliance',
      mobile_viewport: 'Mobile viewport:',
      favicon: 'Favicon:',
      images_without_alt_label: 'Immagini senza ALT:',
      lazy_loading: 'Lazy loading:',
      images_suffix: 'immagini',
      internal_links: 'Link interni:',
      data_unavailable: 'Dati non disponibili: {{reason}}',
      analysis_not_run: 'Analisi non eseguita',
      not_detected: 'Non rilevato',
      no_trust_data: 'Nessun dato trust disponibile',
      no_activity: 'Nessuna attività recente.',
      activity_completed: 'Completato',
      activity_error: 'Errore',
      no_store_title: 'Nessuno Store Connesso',
      no_store_desc: "Installa l'app su uno store Shopify per iniziare",
      connect_store: 'Connetti Store Shopify',
      no_token_title: 'Token OAuth Mancante',
      no_token_desc: 'Lo store {{domain}} è registrato ma non ha un token. Reinstalla l\'app.',
      reinstall_app: 'Reinstalla App via OAuth',
      sync_in_progress: 'Sincronizzazione prodotti in corso…',
      sync_in_progress_detail: '{{synced}} / {{total}} prodotti. I dati della dashboard verranno aggiornati a fine sincronizzazione.',
      stale_data: 'Dati non aggiornati: mostrati gli ultimi numeri validi mentre la sincronizzazione è in corso.',
      catalog_score_label: 'Catalog Score',
      seo_distribution: 'Distribuzione SEO',
      n_products: '{{n}} prodotti',
      pct_of_catalog: '{{pct}}% del catalogo',
      no_description: 'Senza descrizione',
      no_meta_description: 'Senza meta description',
      seo_needs_improvement: 'SEO da migliorare',
      view: 'Vedi',
      seo_good_desc: 'Il catalogo ha una copertura SEO buona. Mantieni alto lo standard ottimizzando i nuovi prodotti.',
      seo_medium_desc: 'Il catalogo ha una copertura SEO media. Priorità: meta description e descrizioni prodotto.',
      seo_poor_desc: 'Il catalogo ha una copertura SEO bassa. Priorità: meta description, descrizioni e immagini mancanti.',
      seo_optimized: 'Ottimizzati',
      seo_medium: 'Medi',
      seo_poor: 'Da migliorare',
      content_seo_title: 'Stato SEO per tipo di contenuto',
      open_catalog: 'Apri Catalogo',
      row_collections: 'Collezioni',
      row_articles: 'Articoli',
      row_pages: 'Pagine',
      coming_soon: 'Prossimamente',
      not_synced: 'Non sincronizzate',
      seo_coverage_fmt: '{{opt}}/{{total}} ottimizzate · {{score}}/100',
      alt_coverage: 'Copertura ALT text',
      with_alt_count: '{{n}} con ALT su {{total}}',
      image_optimization_label: 'Ottimizzazione immagini',
      optimized_count: '{{n}} ottimizzate su {{total}}',
      with_alt: 'Con ALT',
      without_alt: 'Senza ALT',
      image_optimized: 'Ottimizzate',
      image_needs_improvement: 'Da migliorare',
      no_image: 'Senza immagine',
      savings: 'Risparmio',
      optimize_images_btn: 'Ottimizza immagini',
      view_no_image: 'Vedi prodotti senza immagine',
      alt_manager: 'ALT Text Manager',
      toast_sync_done: 'Sincronizzazione completata. Riconcilio catalogo...',
      toast_catalog_reconciled: 'Catalogo riconciliato: {{n}} prodotti (rimossi {{removed}} orfani)',
      toast_sync_first: 'Sincronizza prima i prodotti',
      toast_avg_score: 'Score medio {{score}}/100',
      toast_audit_done: 'Audit completato: {{score}}/100',
      toast_sync_reset: 'Stato sync azzerato',
      toast_sync_reset_error: 'Impossibile azzerare lo stato',
      op_description: 'Descrizione AI',
      op_seo_title: 'SEO Title',
      op_meta_description: 'Meta Description',
      op_keywords: 'Keywords',
      op_translation: 'Traduzione',
      op_image_opt: 'Ottimizzazione Immagine',
      op_sync: 'Sync Shopify',
      op_seo_analysis: 'Analisi SEO Store',
      op_site_audit: 'Audit Sito 360',
      prompt_domain: 'Inserisci il dominio del tuo store Shopify',
      hint_force_reset: 'Forza il reset dello stato di sincronizzazione (non elimina prodotti)',
    },
    products: {
      title: 'Catalogo Prodotti',
      search: 'Cerca prodotti...',
      all: 'Tutti',
      optimized: 'Ottimizzati',
      pending: 'In attesa',
      status_generating: 'Generazione',
      status_writing: 'Scrittura',
      status_validating: 'Validazione',
      status_failed: 'Fallito',
      status_sync_failed: 'Sync Shopify',
      status_optimized: 'Ottimizzato',
      status_medium: 'Medio',
      status_needs_improvement: 'Da Migliorare',
      type_collection_singular: 'collezione',
      type_collection_plural: 'collezioni',
      sync_collections: 'Sincronizza Collezioni',
      empty_collections: 'Nessuna collezione. Clicca "Sincronizza Collezioni" per importarle da Shopify.',
      search_collections: 'Cerca collezione per titolo o handle...',
      col_label_products: 'Prodotti',
      type_article_singular: 'articolo',
      type_article_plural: 'articoli',
      sync_articles: 'Sincronizza Articoli',
      empty_articles: 'Nessun articolo. Clicca "Sincronizza Articoli" per importarli da Shopify.',
      search_articles: 'Cerca articolo per titolo, handle o blog...',
      col_label_blog: 'Blog',
      type_page_singular: 'pagina',
      type_page_plural: 'pagine',
      sync_pages: 'Sincronizza Pagine',
      empty_pages: 'Nessuna pagina. Clicca "Sincronizza Pagine" per importarle da Shopify.',
      search_pages: 'Cerca pagina per titolo o handle...',
      col_label_author: 'Autore',
      catalog_title: 'Catalogo',
      no_store: 'Nessuno Store',
      tab_products: 'Prodotti',
      tab_collections: 'Collezioni',
      tab_articles: 'Articoli',
      tab_pages: 'Pagine',
      sort_updated: 'Aggiornato',
      sort_seo_score: 'Score SEO',
      sort_title: 'Titolo',
      sort_vendor: 'Vendor',
      sort_created: 'Creato',
      sort_desc: 'Discendente',
      sort_asc: 'Crescente',
      filter_seo_all: 'SEO: tutti',
      filter_optimized: 'Ottimizzati',
      filter_medium: 'Medi',
      filter_needs_improvement: 'Da migliorare',
      filter_image_all: 'Immagini: tutti',
      filter_image_yes: 'Con immagini',
      filter_image_no: 'Senza immagini',
      filter_meta_all: 'Meta: tutti',
      filter_meta_yes: 'Con meta',
      filter_meta_no: 'Senza meta',
      filter_desc_all: 'Descrizione: tutti',
      filter_desc_yes: 'Con descrizione',
      filter_desc_no: 'Senza descrizione',
      filter_vendor_all: 'Vendor: tutti',
      filter_collection_all: 'Collezione: tutte',
      filter_type_all: 'Tipo: tutti',
      reset_filters: 'Reset filtri',
      th_image: 'Immagine',
      th_title: 'Titolo',
      th_seo_score: 'Score SEO',
      th_alt: 'ALT',
      th_meta: 'Meta',
      th_status: 'Stato',
      th_actions: 'Azioni',
      no_products_filters: 'Nessun prodotto trovato con questi filtri',
      no_products: 'Nessun prodotto. Sincronizza dal tuo store Shopify.',
      pagination: 'Pagina {{page}} di {{total}} · {{count}} prodotti',
      batch_btn: 'Operazioni Batch',
      dialog_status: 'Stato',
      dialog_seo_score: 'Score SEO',
      dialog_shopify_id: 'ID Shopify',
      dialog_vendor: 'Vendor',
      dialog_serp: 'Anteprima SERP',
      dialog_issues: 'Problemi SEO',
      dialog_suggestions: 'Suggerimenti',
      generating: 'Generando...',
      generate_all: 'Genera Tutti i Contenuti',
      action_generate_ai: 'Genera Contenuti AI',
      action_translate: 'Traduci',
      action_optimize_image: 'Ottimizza Immagine',
      syncing: 'Sincronizzazione...',
      draft_ready: 'Bozza pronta',
      seo_ai_btn: 'SEO AI',
      batch_ops_btn: 'Operazioni Batch',
      diagnosis: 'Diagnostica',
      current_score: 'Score attuale',
      projected: '→ previsto {{score}}/100',
      meta_title: 'Meta Title',
      meta_desc_label: 'Meta Description',
      description_label: 'Descrizione',
      generate_desc_btn: 'Genera descrizione AI',
      generating_desc: 'Generazione...',
      generate_ai_btn: 'Genera con AI',
      publish_shopify_btn: 'Pubblica su Shopify',
      publishing: 'Pubblicazione...',
      discard_draft_btn: 'Scarta bozza',
      seo_ai_dialog_title: 'SEO AI',
      seo_all: 'SEO: tutti',
      seo_optimized: 'Ottimizzati',
      seo_medium: 'Medi',
      seo_needs: 'Da migliorare',
      page_of: 'Pagina {{page}} di {{total}}',
      search_placeholder: 'Cerca per titolo, SKU, EAN, vendor, handle...',
      chars_count: '{{n}}/{{max}} caratteri',
      n_selected_info: 'selezionati',
      filtered: 'filtrati',
      soon_tooltip: 'Disponibile prossimamente',
      resource_subtitle: '{{type}} Shopify e relativo stato SEO',
      articles_blog: 'Articoli (blog)',
      select_visible_title: 'Seleziona/deseleziona tutti i visibili',
      toast_draft_ready: 'Bozza SEO generata. Rivedi e pubblica.',
      toast_error_ai: 'Errore generazione AI',
      toast_desc_generated: 'Descrizione AI generata.',
      toast_error_desc: 'Errore generazione descrizione',
      toast_empty_draft: 'Genera o inserisci almeno un campo (meta title, meta description o descrizione)',
      toast_published_score: 'Pubblicato su Shopify · Score {{score}}/100',
      toast_error_publish: 'Errore pubblicazione su Shopify',
      toast_draft_discarded: 'Bozza scartata',
      toast_select_items: 'Seleziona almeno un elemento',
      toast_mode_publish: 'Pubblicazione',
      toast_mode_both: 'Genera+Pubblica',
      toast_mode_generate: 'Generazione SEO AI',
      toast_batch_launched: '{{label}} avviata su {{count}} {{type}}. Puoi cambiare sezione.',
      toast_batch_errors: '{{label}} completata con {{count}} errori',
      toast_batch_done: '{{label}} completata su {{count}} {{type}}',
      toast_synced: '{{type}} sincronizzate: {{count}}',
      toast_sync_error: 'Errore sincronizzazione {{type}}',
      toast_token_error: 'Token Shopify scaduto o senza permessi: clicca per reinstallare',
      reinstall_label: 'Reinstalla',
      toast_sync_started: 'Sincronizzazione {{type}} avviata',
      toast_error_sync_start: 'Errore avvio sincronizzazione',
      toast_perms_ok: 'Permessi ok ({{kind}})',
      toast_token_revoked: 'Token revocato',
      toast_perms_missing: 'Permessi mancanti',
      toast_diag_error: 'Errore diagnostica',
      toast_score: 'Score {{score}}/100',
      toast_error_analyze: 'Errore analisi',
      toast_generated: 'Contenuti generati',
      toast_error_generate: 'Errore generazione',
    },
    content: {
      title: 'Generazione Contenuti',
      generate: 'Genera Contenuto',
      language: 'Lingua',
      tone: 'Tono',
      subtitle: 'Genera descrizioni, SEO title, meta description e keywords con AI',
      tab_products: 'Prodotti',
      tab_collections: 'Collezioni',
      tab_articles: 'Articoli',
      tab_pages: 'Pagine',
      type_description_label: 'Descrizione',
      type_description_hint: 'Testo prodotto accattivante e SEO-friendly',
      type_seo_title_label: 'SEO Title',
      type_seo_title_hint: 'Titolo ottimizzato per SERP (max 60 car.)',
      type_meta_desc_label: 'Meta Description',
      type_meta_desc_hint: 'Snippet Google (max 160 car.)',
      type_keywords_label: 'Keywords',
      type_keywords_hint: 'Keyword principali e secondarie',
      type_body_label: 'Descrizione / Corpo',
      type_body_hint: 'Testo principale della risorsa',
      filter_all: 'Tutti',
      filter_needs: 'Da migliorare',
      filter_medium: 'Medi',
      filter_optimized: 'Ottimizzati',
      no_results_filters: 'Nessun elemento corrisponde ai filtri',
      select_all: 'Seleziona tutti',
      deselect: 'Deseleziona',
      selected_count: '{{count}} selezionati',
      selected_max: '(max)',
      deselect_all: 'Deseleziona tutti',
      pagination_of: '{{page}} / {{total}}',
      total_count: '({{count}} tot.)',
      content_type_section: 'Tipo di Contenuto',
      batch_generating: 'Generando… {{done}}/{{total}}',
      batch_generate_btn: 'Genera Batch ({{count}})',
      generating_count: 'Genera ({{count}})',
      generate_btn: 'Genera',
      generating: 'Generazione…',
      generate_all_btn: 'Tutti',
      hint_select: '← Seleziona un elemento o spunta più elementi per il batch',
      hint_batch_ready: '{{count}} elemento/i pronto/i per il batch',
      batch_done_title: '✓ Batch completato',
      batch_pending_title: 'Batch in attesa…',
      batch_in_progress_title: 'Generazione Batch in corso…',
      batch_done_msg: 'Tutti i contenuti generati. La selezione verrà cancellata automaticamente.',
      results_section: 'Risultati',
      publishing: 'Pubblicando…',
      published: 'Pubblicato',
      publish_btn: 'Pubblica su Shopify',
      clear_results: 'Cancella',
      chars_unit: 'car.',
      cache_label: 'cache',
      preview_section: 'Anteprima attuale',
      loading_detail: 'Caricamento dettaglio…',
      not_present: 'Non presente',
      not_present_plural: 'Non presenti',
      empty_state: 'Clicca un elemento per visualizzarlo, o spunta più elementi e usa Genera Batch',
      copy_btn: 'Copia',
      type_seo_title_hint_content: 'Meta title per SERP (max 60 car.)',
      no_items: 'Nessun {{type}} trovato',
      item_deselect: 'Deseleziona',
      item_select: 'Aggiungi alla selezione',
      generate_all_title: 'Genera tutti i tipi disponibili',
      prev_item: 'Elemento precedente',
      next_item: 'Elemento successivo',
      toast_load_error: 'Errore nel caricamento elementi',
      toast_batch_done: 'Batch completato: {{done}}/{{total}} prodotti',
      toast_batch_failed: 'Batch fallito: {{failed}} errori su {{total}}',
      toast_batch_cancelled: 'Batch annullato',
      toast_batch_resumed: 'Batch attivo ripreso…',
      toast_max_select: 'Massimo {{max}} elementi selezionabili',
      toast_select_item: 'Seleziona un elemento dalla lista',
      toast_select_type: 'Seleziona almeno un tipo di contenuto',
      toast_from_cache: 'Contenuto dalla cache!',
      toast_generated: 'Generato con successo!',
      toast_generate_error: 'Errore nella generazione del contenuto',
      toast_batch_running: 'Un processo batch è già in corso',
      toast_no_store: 'Store non disponibile',
      toast_batch_started: 'Batch avviato: {{n}} prodotti in coda',
      toast_batch_start_error: 'Errore avvio batch',
      toast_batch_item_error: 'Errore generazione: {{title}}',
      toast_batch_complete: 'Batch completato: {{done}}/{{total}} elementi',
      toast_cancel_error: 'Errore annullamento batch',
      toast_published: 'Contenuto pubblicato su Shopify!',
      toast_publish_error: 'Errore nella pubblicazione',
      toast_copied: 'Copiato negli appunti',
      present: 'presente',
      missing: 'mancante',
      lang_it: 'Italiano',
      lang_en: 'Inglese',
      lang_fr: 'Francese',
      lang_de: 'Tedesco',
      lang_es: 'Spagnolo',
      lang_pt: 'Portoghese',
      tone_professional: 'Professionale',
      tone_luxury: 'Luxury',
      tone_technical: 'Tecnico',
      tone_conversational: 'Conversazionale',
    },
    images: {
      title: 'Ottimizzazione Immagini',
      optimize: 'Ottimizza',
      format: 'Formato',
      compress: 'Comprimi',
      quality: 'Qualità',
      alt_mode_label: 'Modalità generazione ALT',
      alt_mode_ai: 'AI intelligente',
      alt_mode_template: 'Template gratuito',
      alt_mode_auto: 'Auto fallback',
      subtitle: 'Ottimizza immagini, gestisci ALT text e pubblica su Shopify.',
      tab_optimize: 'Ottimizza Immagini',
      tab_alt: 'ALT Text',
      alt_coverage: 'Copertura ALT',
      with_alt_count: 'con ALT su',
      stat_with_alt: 'Con ALT: {{count}}',
      stat_without_alt: 'Senza ALT: {{count}}',
      stat_no_image: 'Senza immagine: {{count}}',
      sync_alt_btn: 'Aggiorna dati ALT da Shopify',
      syncing_alt: 'Aggiornamento ALT...',
      sync_status_label: 'Stato:',
      analyzed_label: 'Analizzati:',
      last_updated_label: 'Ultimo aggiornamento:',
      stalled: 'bloccato',
      force_stop: 'Forza stop (bloccato da 60s)',
      free_badge: '● Gratuito — nessun credito',
      configure_btn: '▼ Configura',
      hide_btn: '▲ Nascondi',
      template_free_hint: 'Modalità gratuita attiva — zero crediti AI. Template:',
      template_auto_hint: 'Auto fallback — AI se crediti disponibili, template locale se esauriti.',
      template_config_title: 'Configura Template ALT',
      template_label: 'Template personalizzato',
      template_preview: 'Anteprima:',
      variables_label: 'Variabili disponibili — clicca per inserire:',
      restore_default: 'Ripristina default',
      save_config: 'Salva configurazione',
      saving: 'Salvataggio...',
      search_placeholder: 'Cerca per titolo, vendor, handle...',
      filter_all_images: 'Tutte',
      filter_with_alt: 'Con ALT',
      filter_without_alt: 'Senza ALT',
      selected_images: '{{count}} immagini selezionate (max 50 per batch)',
      generate_batch_btn: 'Genera ALT per selezionate',
      batch_alt_in_progress: 'Batch ALT in corso: {{done}} / {{total}}',
      batch_errors: '{{n}} errori',
      select_all_label: 'Seleziona tutto',
      deselect_all_label: 'Deseleziona tutto',
      total_products_label: '{{count}} prodotti',
      timeout_title: 'Il caricamento ha impiegato troppo tempo (20s)',
      timeout_desc: 'Il database sta elaborando molti prodotti. Riprova tra qualche secondo.',
      error_title: 'Errore caricamento lista',
      no_products_filter: 'Nessun prodotto corrispondente ai filtri',
      alt_placeholder: 'ALT text (max 125 caratteri)',
      status_published: 'Pubblicato',
      status_saved: 'Salvato',
      status_draft_alt: 'Bozza',
      status_missing: 'Senza ALT',
      generate_alt_btn: 'Genera ALT',
      save_alt_btn: 'Salva ALT',
      publish_alt_btn: 'Pubblica',
      prec: 'Prec',
      succ: 'Succ',
      select_products: 'Seleziona Prodotti',
      filter_collection_all: 'Collezione: tutte',
      filter_vendor_all: 'Vendor: tutti',
      filter_kb_all: 'KB: tutti',
      filter_kb_100: 'File oltre 100 KB',
      filter_kb_500: 'File oltre 500 KB',
      filter_kb_1mb: 'File oltre 1 MB',
      filter_format_all: 'Formato: tutti',
      filter_landscape: 'Width maggiore di Height',
      filter_portrait: 'Height maggiore di Width',
      filter_square: 'Quadrate',
      filter_status_all: 'Stato: tutti',
      filter_status_optimized: 'Già ottimizzate',
      filter_status_needs: 'Da ottimizzare',
      visible_total: '{{visible}} visibili · {{total}} totali',
      reset_filters: 'Reset filtri',
      clear_selection: 'Cancella selezione',
      no_image_products: 'Nessun prodotto con immagine',
      ready_badge: 'Pronta',
      settings_title: 'Impostazioni',
      format_title: 'Formato Immagine',
      format_square: 'Quadrato 1:1',
      format_landscape: 'Landscape 4:3',
      format_portrait: 'Portrait 3:4',
      format_none: 'Nessun resize',
      format_none_sub: 'Dimensioni originali',
      compress_label: 'Compressione',
      compress_desc: 'Riduci dimensione file',
      quality_label: 'Qualità',
      batch_opt_running: 'Ottimizzazione in corso',
      batch_opt_cancelled: 'Ottimizzazione annullata',
      batch_opt_completed: 'Ottimizzazione completata',
      batch_apply_running: 'Applicazione in corso',
      batch_apply_cancelled: 'Applicazione annullata',
      batch_apply_completed: 'Applicazione completata',
      background_note: 'Puoi cambiare sezione, continua in background',
      optimizing: 'Ottimizzando...',
      optimize_n: 'Ottimizza {{count}} immagini',
      optimize_one: 'Ottimizza Immagine',
      applying: 'Applicando...',
      apply_n: 'Applica {{count}} su Shopify',
      apply_one: 'Applica su Shopify',
      preview_title: 'Anteprima',
      ready_optimizations: '{{count}} ottimizzazioni pronte',
      select_preview_hint: 'Seleziona uno o più prodotti per vedere l\'anteprima',
      first_product_preview: 'Anteprima mostrata per il primo prodotto selezionato:',
      original_label: 'Originale',
      optimized_label: 'Ottimizzata',
      optimize_click_hint: 'Clicca "Ottimizza" per il risultato',
      reduction_label: 'Riduzione',
      apply_btn: 'Applica',
      history_opt_title: 'Cronologia ottimizzazioni',
      history_opt_subtitle: 'Operazioni applicate su Shopify, errori e ripristini.',
      stat_running_label: 'In corso',
      stat_completed_label: 'Completate',
      stat_errors_label: 'Incomplete',
      stat_undo_label: 'Undo',
      total_savings: 'Risparmio totale',
      history_loading: 'Caricamento cronologia...',
      no_history: 'Nessuna operazione applicata ancora.',
      restoring: 'Ripristino...',
      undo_btn: 'Undo',
      kb_warning: 'La dimensione KB non è presente nei dati locali. Per renderla precisa serve salvarla dal backend durante la sync immagini.',
      senza_vendor: 'Senza vendor',
      alt_stat_coverage: '{{n}} con ALT su {{total}}',
      apply_batch_cancelled: 'Applicazione annullata',
      apply_batch_done_label: 'Applicazione completata',
      apply_batch_running: 'Applicazione in corso',
      apply_n_btn: 'Applica {{n}} su Shopify',
      applying_btn: 'Applicando...',
      auto_fallback_hint: 'Auto fallback — AI se crediti disponibili, template locale se esauriti.',
      background_hint: 'Puoi cambiare sezione, continua in background',
      badge_draft: 'Bozza',
      badge_missing: 'Senza ALT',
      badge_published: 'Pubblicato',
      badge_ready: 'Pronta',
      badge_saved: 'Salvato',
      batch_close: 'Chiudi',
      batch_generate_btn: 'Genera ALT per selezionate',
      batch_progress: 'Batch ALT in corso: {{done}} / {{total}}',
      batch_selected: '{{n}} immagini selezionate (max 50 per batch)',
      collection_all: 'Collezione: tutte',
      compress_sub: 'Riduci dimensione file',
      config_btn: '▼ Configura',
      deselect_all: 'Deseleziona tutto',
      empty_filtered: 'Nessun prodotto corrispondente ai filtri',
      filter_all: 'Tutte',
      format_label: 'Formato Immagine',
      gen_alt_btn: 'Genera ALT',
      history_completed: 'Completate',
      history_empty: 'Nessuna operazione applicata ancora.',
      history_incomplete: 'Incomplete',
      history_running: 'In corso',
      history_savings: 'Risparmio totale',
      history_subtitle: 'Operazioni applicate su Shopify, errori e ripristini.',
      history_title: 'Cronologia ottimizzazioni',
      history_undo_label: 'Undo',
      last_update_label: 'Ultimo aggiornamento:',
      load_error: 'Errore caricamento lista',
      n_errors: '{{n}} errori',
      n_products: '{{n}} prodotti',
      n_selected: '{{n}} selezionati',
      next_page: 'Succ',
      no_products: 'Nessun prodotto con immagine',
      no_vendor: 'Senza vendor',
      opt_batch_cancelled: 'Ottimizzazione annullata',
      opt_batch_done: 'Ottimizzazione completata',
      opt_batch_running: 'Ottimizzazione in corso',
      optimize_n_btn: 'Ottimizza {{n}} immagini',
      optimize_one_btn: 'Ottimizza Immagine',
      optimizing_btn: 'Ottimizzando...',
      orientation_all: 'Formato: tutti',
      orientation_landscape: 'Width maggiore di Height',
      orientation_portrait: 'Height maggiore di Width',
      orientation_square: 'Quadrate',
      page_info: 'Pagina {{page}} di {{total}}',
      pagination: 'Pagina {{page}} di {{total}}',
      prev: 'Prec',
      publish_btn: 'Pubblica',
      retry: 'Riprova',
      select_all: 'Seleziona tutto',
      size_100kb: 'File oltre 100 KB',
      size_1mb: 'File oltre 1 MB',
      size_500kb: 'File oltre 500 KB',
      size_all: 'KB: tutti',
      status_all: 'Stato: tutti',
      status_label: 'Stato:',
      status_needs: 'Da ottimizzare',
      status_optimized: 'Già ottimizzate',
      status_stalled: 'bloccato',
      sync_btn: 'Aggiorna dati ALT da Shopify',
      sync_btn_title: 'Rilegge da Shopify le immagini e gli ALT text reali',
      syncing: 'Aggiornamento ALT...',
      template_active: 'Modalità gratuita attiva — zero crediti AI. Template:',
      template_custom_label: 'Template personalizzato',
      template_free_badge: '● Gratuito — nessun credito',
      template_preview_label: 'Anteprima:',
      template_reset: 'Ripristina default',
      template_save: 'Salva configurazione',
      template_saving: 'Salvataggio...',
      template_vars_label: 'Variabili disponibili — clicca per inserire:',
      timeout_msg: 'Il database sta elaborando molti prodotti. Riprova tra qualche secondo.',
      toast_alt_ai: 'ALT generato via AI',
      toast_alt_cancelled: 'Aggiornamento ALT annullato — puoi riavviarlo',
      toast_alt_empty: 'ALT vuoto',
      toast_alt_from_cache: 'ALT da cache',
      toast_alt_gen_error: 'Errore generazione ALT',
      toast_alt_publish_error: 'Errore pubblicazione',
      toast_alt_published: 'Pubblicato su Shopify',
      toast_alt_save_error: 'Errore salvataggio',
      toast_alt_saved: 'ALT salvato',
      toast_alt_sync_start_error: 'Errore avvio aggiornamento ALT',
      toast_alt_sync_started: 'Aggiornamento dati ALT avviato',
      toast_alt_template: 'ALT generato via template (gratuito)',
      toast_alt_template_fallback: 'ALT via template (crediti esauriti)',
      toast_alt_update_error: 'Errore aggiornamento ALT',
      toast_alt_updated: 'Dati ALT aggiornati: {{n}} prodotti analizzati',
      toast_applied: 'Immagine applicata su Shopify',
      toast_apply_batch_done: 'Applicate {{n}} immagini su Shopify',
      toast_apply_batch_errors: 'Applicazione completata con {{n}} errori',
      toast_apply_batch_started: 'Applicazione avviata: {{n}} immagini. Puoi cambiare sezione.',
      toast_batch_alt_done: 'Batch completato',
      toast_batch_alt_started: 'Batch avviato: {{n}} immagini, {{c}} alla volta',
      toast_batch_done: 'Batch completato: {{n}} immagini ottimizzate. Puoi applicarle su Shopify.',
      toast_batch_errors: '{{n}} immagini non elaborate. Riprova o controlla i log.',
      toast_batch_started: 'Batch avviato: {{n}} immagini. Puoi cambiare sezione, continua in background.',
      toast_cancel_error: 'Errore annullamento',
      toast_no_draft: 'Nessuna immagine ottimizzata da applicare',
      toast_no_images: 'Nessuna immagine selezionata',
      toast_no_ready: 'Nessuna ottimizzazione pronta da applicare',
      toast_no_store: 'Store non disponibile',
      toast_optimize_error: 'Errore ottimizzazione',
      toast_optimized: 'Immagine ottimizzata. Ora puoi applicarla su Shopify.',
      toast_select_product: 'Seleziona almeno un prodotto',
      toast_template_save_error: 'Errore salvataggio template',
      toast_template_saved: 'Configurazione template salvata',
      toast_undo_done: 'Immagine originale ripristinata',
      toast_undo_error: 'Errore durante il ripristino',
      undoing_btn: 'Ripristino...',
      vendor_all: 'Vendor: tutti',
      toast_no_product: 'Seleziona un prodotto',
      toast_no_image: "Il prodotto non ha un'immagine",
      toast_no_preview: "Prima ottimizza un'immagine",
      toast_apply_error: 'Errore applicazione su Shopify',
      n_ready: '{{n}} ottimizzazioni pronte',
      preview_hint: "Seleziona uno o più prodotti per vedere l'anteprima",
      preview_first: 'Anteprima mostrata per il primo prodotto selezionato:',
      click_optimize_hint: 'Clicca "Ottimizza" per il risultato',
      apply_single_btn: 'Applica',
    },
    alt_template: {
      section_title: 'Template ALT',
      mode_label: 'Modalità generazione ALT text',
      textarea_label: 'Template personalizzato',
      preview_label: 'Anteprima',
      vars_label: 'Variabili disponibili — clicca per inserire',
      hint_template: 'Modalità gratuita: nessun credito AI consumato per ALT text.',
      hint_auto: 'Auto fallback: AI se crediti disponibili, altrimenti template automatico.',
    },
    batch: {
      title: 'Operazioni Batch',
      start: 'Avvia',
      cancel: 'Annulla',
      subtitle: 'Elaborazione server-side persistente — continua anche se cambi pagina o chiudi il tab',
      locked_title: 'Operazioni in Blocco non disponibili',
      locked_desc: 'Le Batch Operations sono disponibili dal piano Starter. Elabora centinaia di prodotti in parallelo con un solo click.',
      upgrade_btn: 'Passa a Starter',
      op_content_label: 'Genera Contenuti AI',
      op_content_desc: 'Descrizione, SEO title, meta description, keywords',
      op_translate_label: 'Traduci Prodotti',
      op_translate_desc: 'Traduzione completa in lingua selezionata',
      op_images_label: 'Ottimizza Immagini',
      op_images_desc: 'Resize 1:1 e compressione immagini',
      field_description_label: 'Descrizione',
      field_description_hint: '150-250 parole',
      field_seo_title_label: 'SEO Title',
      field_seo_title_hint: 'max 60 caratteri',
      field_meta_desc_label: 'Meta Description',
      field_meta_desc_hint: '100-160 caratteri',
      field_keywords_label: 'Keywords',
      field_keywords_hint: '5-10 parole chiave',
      count_all: 'Tutti',
      status_pending: 'In coda',
      status_running: 'In corso',
      status_completed: 'Completato',
      status_failed_job: 'Fallito',
      status_cancelled: 'Annullato',
      opt_in_progress: 'Ottimizzazione immagini in corso…',
      batch_in_progress: 'Batch AI in corso…',
      images_progress: '{{done}} / {{total}} immagini',
      products_progress: '{{done}} / {{total}} prodotti',
      errors_count: '{{count}} errori',
      duration_label: 'Durata: {{time}}',
      starting: 'Avvio...',
      seo_gen_in_progress: 'Genera + Pubblica SEO in corso',
      gen_publish_auto: 'Generazione e pubblicazione automatica su Shopify',
      section_operation: 'Operazione',
      section_fields: 'Campi da generare',
      fields_selected: '{{count}}/{{total}} selezionati',
      fields_warning: 'Seleziona almeno un campo per avviare il batch',
      fields_hint: 'Una sola chiamata AI per prodotto genera tutti i campi selezionati — minore latency e costi ridotti.',
      section_options: 'Opzioni',
      label_language: 'Lingua',
      label_tone: 'Tono',
      tone_professional: 'Professionale',
      tone_luxury: 'Luxury',
      tone_technical: 'Tecnico',
      tone_conversational: 'Conversazionale',
      label_target_lang: 'Lingua Destinazione',
      images_note: 'Resize 1:1 (800×800) + compressione qualità 85%.',
      section_quantity: 'Quantità Prodotti',
      available_count: '{{count}} disponibili',
      catalog_selection: '{{count}} prodotti selezionati dal Catalogo',
      remove_selection: 'Rimuovi selezione',
      products_selected_count: '{{count}} prodotti selezionati',
      processing: 'Elaborazione in corso…',
      start_btn: 'Avvia Elaborazione',
      history_title: 'Cronologia Batch',
      history_subtitle: 'aggiornato dal DB',
      stat_running: 'In Corso',
      stat_completed: 'Completate',
      stat_products_ok: 'Prodotti OK',
      no_batch: 'Nessun batch eseguito',
      no_batch_hint: 'I job appariranno qui dopo la prima elaborazione',
      job_content: 'Genera Contenuti AI',
      job_translate: 'Traduzione',
      job_images: 'Ottimizzazione Immagini',
      job_products: '{{done}}/{{total}} prodotti',
      log_lang: 'Lingua:',
      log_tone: 'Tono:',
      toast_completed: 'Batch completato: {{done}}/{{total}} prodotti elaborati',
      toast_failed: 'Batch fallito: {{count}} errori',
      toast_no_products: 'Nessun prodotto disponibile',
      soon_lbl: 'presto',
      btn_analyze_seo: 'Analizza SEO',
      btn_view: 'Visualizza',
      toast_no_fields: 'Seleziona almeno un campo da generare',
      toast_images_started: 'Ottimizzazione immagini avviata: {{count}} prodotti',
      toast_started: 'Batch avviato: {{count}} prodotti',
      toast_start_error: "Errore nell'avvio",
      toast_cancelled: 'Batch annullato',
      toast_cancel_error: 'Errore annullamento',
      fields_label: 'Campi',
      log_summary: 'Log operazioni singole',
    },
    history: {
      title: 'Storico',
      empty: 'Nessuna operazione trovata',
      subtitle: 'Audit completo di tutte le esecuzioni AI — {{n}} operazioni totali',
      refresh_btn: 'Aggiorna',
      total_operations: 'Totale Operazioni',
      success_rate: 'Tasso di Successo',
      n_successes: '{{n}} successi',
      credits_today: 'Crediti Oggi',
      products_today: 'Prodotti Oggi',
      avg_duration: 'Durata Media',
      last_autopilot: 'Ultimo Autopilot',
      filters: 'Filtri',
      filters_active: 'attivi',
      reset_all: 'Azzera tutto',
      search_placeholder: 'Cerca prodotto...',
      op_all: 'Tutti i tipi',
      op_description: 'Descrizione AI',
      op_seo_title: 'SEO Title AI',
      op_meta_description: 'Meta Description AI',
      op_batch: 'Generazione Batch',
      op_translation: 'Traduzione',
      op_image: 'Immagine',
      op_sync: 'Sync Shopify',
      trigger_all: 'Tutti i trigger',
      status_all: 'Tutti gli stati',
      status_success: 'Successo',
      status_partial: 'Parziale',
      status_error: 'Errore',
      th_status: 'Stato',
      th_type: 'Tipo Operazione',
      th_product: 'Prodotto',
      th_trigger: 'Trigger',
      th_seo_delta: 'SEO Delta',
      th_credits: 'Crediti',
      th_duration: 'Durata',
      th_timestamp: 'Timestamp',
      loading: 'Caricamento...',
      remove_filters: 'Rimuovi filtri',
      load_more: 'Carica altri (mostrati {{shown}} di {{total}})',
      details_title: 'Dettagli Esecuzione',
      detail_op_id: 'ID Operazione',
      detail_product_id: 'ID Prodotto',
      detail_store_id: 'Store ID',
      detail_type: 'Tipo',
      detail_trigger: 'Trigger',
      detail_status: 'Status',
      detail_language: 'Lingua',
      detail_tone: 'Tono',
      detail_tokens: 'Token usati',
      detail_fields: 'Campi',
      detail_credits: 'Crediti',
      detail_duration: 'Durata',
      detail_seo_before: 'SEO prima',
      detail_seo_after: 'SEO dopo',
      detail_timestamp: 'Timestamp',
      error_prefix: 'Errore: ',
      label_description: 'Descrizione AI',
      label_seo_title: 'SEO Title AI',
      label_meta_description: 'Meta Description AI',
      label_keywords: 'Keywords AI',
      label_batch: 'Generazione Batch',
      label_translation: 'Traduzione',
      label_image: 'Ottimizzazione Immagine',
      label_sync: 'Sync Shopify',
      label_push: 'Pubblicazione Shopify',
    },
    batch_banner: {
      errors: 'errori',
      optimizing: 'Ottimizzazione immagini',
      optimizing_cancelled: 'Ottimizzazione annullata',
      optimizing_completed: 'Ottimizzazione completata',
      applying: 'Applicazione su Shopify',
      applying_cancelled: 'Applicazione annullata',
      applying_completed: 'Applicazione completata',
      open_images: 'Apri Immagini',
      open_catalog: 'Apri Catalogo',
      type_collections: 'Collezioni',
      type_articles: 'Articoli',
      type_pages: 'Pagine',
      type_contents: 'Contenuti',
      mode_publish: 'Pubblicazione',
      mode_both: 'Genera+Pubblica',
      mode_generate: 'Generazione SEO AI',
      state_cancelled: '(annullato)',
      state_completed: '(completato)',
    },
    app_banner: {
      expired: 'Token Shopify scaduto o revocato.',
      reconnect_desc: "Riconnetti l'app per ripristinare sync e pubblicazione.",
      detected_in: 'rilevato in',
      reconnect_btn: 'Riconnetti ora',
    },
    review_popup: {
      greeting: 'Ciao! Sono qui 👋',
      subtitle: 'Spero stia andando tutto alla grande con AI Optimizer!',
      rating_title: "Ti sta piacendo l'app?",
      rating_desc: 'La tua opinione ci aiuta a migliorare e raggiungere altri merchant Shopify.',
      rating_tap: 'Tocca una stella per valutare',
      star: {
        terrible: 'Terribile',
        bad: 'Non buono',
        average: 'Nella media',
        good: 'Buono!',
        excellent: 'Eccellente! 🚀',
      },
      positive_title: 'Fantastico! Grazie mille 🎉',
      positive_desc: 'Una recensione sullo Shopify App Store fa una differenza enorme per noi. Ci vuole solo 1 minuto!',
      negative_title: 'Grazie per il feedback 🙏',
      negative_desc: 'Stiamo lavorando per migliorare ogni giorno. Hai idee su cosa potremmo fare meglio?',
      review_btn: '⭐ Lascia una recensione',
      close_btn: 'Chiudi',
      dismiss: 'Non mostrare più',
      skip: 'Salta →',
    },
    support: {
      title: 'Supporto',
      send: 'Invia',
      placeholder: 'Scrivi il tuo messaggio...',
    },
    editor: {
      placeholder: 'Scrivi qui...',
      bold: 'Grassetto',
      italic: 'Corsivo',
      underline: 'Sottolineato',
      h2: 'Titolo H2',
      h3: 'Titolo H3',
      paragraph: 'Paragrafo',
      ul: 'Elenco puntato',
      ol: 'Elenco numerato',
      blockquote: 'Citazione',
      link: 'Inserisci link',
      remove_format: 'Rimuovi formattazione',
      link_prompt: 'URL del link',
    },
    recommendations: {
      empty: 'Nessuna azione critica al momento. Ottimo lavoro!',
      filter_all_prio: 'Tutte le priorità',
      filter_all_cat: 'Tutte le categorie',
      count_shown: '{{n}} azioni mostrate',
      see: 'Vedi',
      sev_high: 'Alta',
      sev_medium: 'Media',
      sev_low: 'Bassa',
      cat_catalog: 'Catalogo',
      missing_meta_description: '{{count}} prodotti senza meta description',
      missing_description: '{{count}} prodotti senza descrizione',
      missing_alt_text: '{{count}} immagini senza testo ALT',
      missing_product_image: '{{count}} prodotti senza immagine',
    },
    audit: {
      not_detected: 'Non rilevato',
      disabled: 'Disabilitato',
      not_scanned: 'Analisi non eseguita',
      status_warning: 'Attenzione',
      status_error: 'Errore',
      cat_performance: 'Performance',
      cat_trust: 'Trust',
      cat_catalog: 'Catalogo',
      checks_suffix: 'controlli',
      badge_err: 'err',
      badge_warn: 'warn',
      badge_ok: 'ok',
      value_label: 'Valore',
      checks: {
        title: { name: 'Titolo', hint: 'Titolo della pagina' },
        meta_description: { name: 'Meta description', hint: 'Meta description della homepage' },
        h1: { name: 'H1', hint: 'Esattamente 1 H1 per pagina è ottimale' },
        h2: { name: 'H2', hint: 'Almeno un H2 raccomandato' },
        canonical: { name: 'Canonical', hint: 'URL canonico' },
        lang: { name: 'Lingua', hint: 'Attributo lingua' },
        json_ld_structured_data: { name: 'JSON-LD / Dati Strutturati', hint: 'Dati strutturati' },
        open_graph: { name: 'Open Graph', hint: 'Meta social' },
        twitter_card: { name: 'Twitter Card', hint: 'Meta Twitter/X' },
        robots_txt: { name: 'robots.txt', hint: 'Robots' },
        sitemap_xml: { name: 'Sitemap.xml', hint: 'Sitemap' },
        status_code: { name: 'Codice di stato', hint: 'Codice HTTP' },
        indexability: { name: 'Indicizzabilità', hint: 'Indicizzabilità' },
        redirects: { name: 'Redirect', hint: 'URL finale' },
        https: { name: 'HTTPS', hint: 'HTTPS' },
        load_time: { name: 'Tempo di caricamento', hint: 'Misurato server-to-server' },
        page_weight: { name: 'Peso della pagina', hint: 'Dimensione HTML homepage' },
        image_lazy_loading: { name: 'Lazy loading immagini', hint: 'Immagini lazy' },
        mobile_viewport: { name: 'Viewport mobile', hint: 'Viewport mobile' },
        favicon: { name: 'Favicon', hint: 'Favicon' },
        images_with_alt: { name: 'Immagini con ALT', hint: 'Accessibilità immagini' },
        privacy_policy: { name: 'Privacy policy', hint: 'Privacy' },
        cookie_policy: { name: 'Cookie policy', hint: 'Cookie' },
        terms_conditions: { name: 'Termini & Condizioni', hint: 'Termini' },
        contact_page: { name: 'Pagina contatti', hint: 'Contatti' },
        shipping_policy: { name: 'Politica di spedizione', hint: 'Spedizioni' },
        returns_refunds: { name: 'Resi & Rimborsi', hint: 'Resi' },
        social_links: { name: 'Link social', hint: 'Social' },
        products_without_description: { name: 'Prodotti senza descrizione', hint: 'Descrizioni prodotto' },
        products_without_images: { name: 'Prodotti senza immagini', hint: 'Immagini prodotto' },
        products_without_meta_description: { name: 'Prodotti senza meta description', hint: 'Meta description prodotto' },
        duplicate_titles: { name: 'Titoli duplicati', hint: 'Titoli prodotto' },
        duplicate_meta_descriptions: { name: 'Meta description duplicate', hint: 'Meta description prodotto' },
        thin_content_200_char: { name: 'Contenuto scarso (<200 char)', hint: 'Contenuto prodotto' },
      },
    },
    score_card: {
      pillar_technical_seo: 'SEO Tecnico',
      pillar_ux: 'UX',
      pillar_performance: 'Performance',
      pillar_trust: 'Trust',
      pillar_catalog: 'Catalogo',
      label_excellent: 'Eccellente',
      label_good: 'Migliorabile',
      label_critical: 'Critico',
      no_audit_desc: "Audit non ancora eseguito — esegui l'audit per ottenere SEO Tecnico, UX, Trust e Performance.",
      auditing: 'Audit in corso...',
      run_audit: 'Esegui Audit Sito 360°',
      calculated_on: 'Calcolato su',
    },
    upgrade: {
      popular: '⭐ Più Popolare',
      period: '/mese',
      plan_header: 'Piano',
      cta: 'Upgrade a {{name}} — {{price}}{{period}}',
      dismiss: 'Non adesso',
      feature_available: "{{feature}} è disponibile dal piano {{plan}}.",
      reason_credits_title: 'Crediti AI esauriti',
      reason_credits_body: "Hai raggiunto il limite mensile del tuo piano. Effettua l'upgrade per continuare a generare contenuti.",
      reason_products_title: 'Limite catalogo raggiunto',
      reason_products_body: "Il catalogo Shopify supera il limite del piano attuale. Effettua l'upgrade per sincronizzare tutti i prodotti.",
      reason_feature_title: 'Funzionalità Premium',
      reason_feature_body: 'Questa funzionalità è disponibile nei piani superiori.',
    },
    gsc: {
      connect_title: 'Connetti Google Search Console',
      connect_desc: 'Monitora impressions, click, CTR e posizione media. Richiedi reindicizzazione dopo le ottimizzazioni AI.',
      connect_feat_analytics: 'Analytics di ricerca',
      connect_feat_indexing: 'Monitoraggio indicizzazione',
      connect_feat_keywords: 'Keyword tracking',
      connect_feat_sitemap: 'Sitemap manager',
      connect_btn_loading: 'Connessione in corso...',
      connect_btn: 'Connetti Google Account',
      prop_modal_title: 'Seleziona Property',
      prop_modal_desc: 'Scegli la proprietà Search Console da collegare.',
      prop_modal_empty: 'Nessuna property trovata. Verifica di avere proprietà in Google Search Console.',
      prop_modal_cancel: 'Annulla',
      prop_modal_confirm: 'Conferma',
      coming_soon_desc: 'Disponibile in {{phase}}',
      top_opp_title: 'Top Opportunità SEO',
      top_opp_sub: 'Migliori 10 query per Opportunity Score',
      copy: 'Copia',
      copied: 'Copiato!',
      badge_quick_win: '🔥 Quick Win',
      badge_low_ctr: '⚡ Basso CTR',
      badge_page_1: '🚀 Pagina 1',
      badge_high_imp: '📈 Alta visibilità',
      badge_brand: '🏷️ Brand',
      qt_category: 'Categoria',
      qt_product: 'Prodotto',
      qt_generic: 'Generico',
      qt_info: 'Info',
      qt_brand: 'Brand',
      seo_analysis: 'Analisi SEO',
      generating_ai: 'Generazione analisi AI in corso...',
      analysis_error: 'Errore generazione analisi. Riprova più tardi.',
      estimated_value: 'Valore stimato',
      clicks_monthly: 'Click/mese potenziali',
      ctr_at_pos: 'CTR a pos. {{pos}}',
      traffic_increase: 'Incremento traffico',
      current_stats: 'Attuale: {{clicks}} click/mese · +{{pts}} pp CTR stimato',
      priority_action: 'Azione prioritaria',
      content_opt: 'Ottimizzazione contenuto',
      title_seo: 'Title SEO',
      title_chars: '(50–60 caratteri)',
      title_copied: 'Title copiato!',
      h1_suggested: 'H1 suggerito',
      h1_page_title: '(titolo pagina)',
      h1_copied: 'H1 copiato!',
      meta_desc: 'Meta Description',
      meta_chars: '(150–160 caratteri)',
      meta_copied: 'Meta copiata!',
      faq_all_copied: 'Tutte le FAQ copiate!',
      faq_suggested: 'FAQ suggerite',
      copy_all: 'Copia tutte',
      faq_copied: 'FAQ copiata!',
      related_kw: 'Keyword correlate',
      click_to_copy: '· click per copiare',
      kw_copied: '"{{kw}}" copiata!',
      tech_suggestions: 'Suggerimenti tecnici',
      copy_keyword: 'Copia keyword',
      kw_copied_plain: 'Keyword copiata!',
      shopify_products: 'Prodotti Shopify',
      search_store: 'Cerca nel negozio',
      optimize_content: 'Ottimizza contenuto',
      col_impressions: 'Impressioni',
      col_position: 'Posizione',
      no_queries: 'Nessuna query trovata con i filtri correnti.',
      ai_panel_title: 'Suggerimenti AI',
      analyze_query: 'Analizza query →',
      sugg_title_improvement: 'Title tag',
      sugg_meta: 'Meta description',
      sugg_content_gap: 'Contenuto mancante',
      sugg_schema: 'Schema markup',
      sugg_links: 'Link interni',
      opp_load_err: 'Errore caricamento opportunità SEO',
      cache_updated: 'Cache aggiornata — ricarico dati',
      cache_error: 'Errore refresh cache',
      loading_data: 'Caricamento dati Search Console...',
      load_error_title: 'Impossibile caricare le opportunità',
      retry: 'Riprova',
      tracked_queries: 'Query tracciate',
      sku_excluded: '{{n}} SKU/EAN escluse',
      total_impressions: 'Impressioni totali (28gg)',
      total_clicks: 'Click totali (28gg)',
      avg_ctr: 'CTR medio',
      ai_generating: 'Analisi AI in generazione...',
      ai_generating_sub: 'I suggerimenti AI verranno mostrati qui tra qualche istante.',
      no_ai_insights: 'Nessun insight AI disponibile',
      no_ai_insights_sub: 'Non sono state trovate query con opportunità di ottimizzazione significative.',
      filter_all: 'Tutte ({{n}})',
      search_placeholder: 'Cerca query...',
      refresh_title: 'Aggiorna dati',
      page_prev: '← Prec.',
      page_info: 'Pag. {{page}} / {{total}} · {{count}} query',
      page_next: 'Succ. →',
      footer_note: 'Dati Search Console ultimi 28 giorni · cache 6h · property: {{url}}',
      footer_excluded: ' · {{n}} SKU/EAN escluse',
      verdict_pass: 'Indicizzata',
      verdict_fail: 'Non indicizzata',
      verdict_neutral: 'Esclusa',
      stato_title: 'Stato Google — Fonti Dati',
      in_sitemap: 'In sitemap',
      sitemap_registered_lbl: 'Sitemap registrate',
      sitemap_errors_lbl: 'Errori sitemap',
      with_impressions: 'Con impressioni',
      search_appear_note: 'Pagine apparse in ricerca · {{days}}gg',
      not_real_indexed: '≠ pagine realmente indicizzate',
      index_estimate_lbl: 'Stima indicizzazione',
      estimate_unavail: 'La stima sarà disponibile dopo 200 URL ispezionate. Avvia la scansione batch per raccogliere il campione.',
      inspected_lbl: 'Ispezionate',
      indexed_confirmed: 'Indicizzate confermate',
      not_indexed_lbl: 'Non indicizzate',
      excluded_lbl: 'Escluse',
      certain_data: 'Dato certo per URL ispezionate',
      batch_title: 'Scansione Batch — Inspection API',
      batch_priority: 'Priorità Analytics',
      batch_progress: 'Progresso ispezione sitemap',
      batch_stopping: 'Interruzione in corso…',
      batch_running: 'Scansione in corso…',
      batch_starting: 'Avvio...',
      batch_done_lbl: 'Sitemap completata ✓',
      batch_start_btn: 'Avvia scansione ({{n}} disponibili)',
      batch_timeout: 'Timeout — clicca per resettare',
      batch_stopping_wait: 'Interruzione in corso — attendi…',
      batch_stop_btn: 'Ferma scansione',
      batch_remaining: '{{n}} URL ancora da ispezionare',
      batch_quota_out: 'Quota giornaliera esaurita — riprova domani',
      batch_start_err: 'Errore avvio scansione',
      batch_complete: 'Scansione completata: {{n}} URL ispezionate',
      dq_title: 'Dettagli tecnici API',
      dq_api_status: 'Stato API',
      dq_daily_quota: 'Quota Giornaliera',
      dq_used_today: 'Usate oggi',
      dq_remaining: 'Rimaste',
      dq_history: 'Storico Ispezioni',
      dq_completion: 'Completamento',
      dq_days_est: 'giorni stimati',
      dq_start_for_eta: "Avvia scansione per calcolare l'ETA",
      sm_no_sitemap: 'Nessuna sitemap trovata',
      sm_no_sitemap_desc: "Aggiungi una sitemap.xml a Google Search Console per monitorare l'indicizzazione.",
      sm_submit_ok: 'Sitemap inviata a Google',
      sm_in_progress: 'In calcolo…',
      sm_submit_btn: 'Invia',
      insp_title: 'Ispeziona URL',
      insp_quota: '{{used}}/{{limit}} ispezioni oggi',
      insp_loading: 'Ispezione...',
      insp_btn: 'Ispeziona',
      insp_domain_lbl: 'Dominio property:',
      insp_domain_note: "L'URL ispezionata deve appartenervi",
      insp_last_crawl: 'Ultimo crawl',
      insp_indexing: 'Indicizzazione',
      insp_yes: 'Sì',
      insp_no: 'No',
      insp_canonical_decl: 'Canonical dichiarato',
      insp_canonical_diff: '⚠ Canonical Google (diverso)',
      insp_noindex: 'noindex rilevato',
      insp_open_gsc: 'Apri in Search Console',
      insp_err: 'Errore ispezione URL',
      cov_title: 'Coverage — Motivi',
      cov_real_data: 'Dati reali — Inspection API',
      cov_conf_high: 'Alta affidabilità',
      cov_conf_medium: 'Media affidabilità',
      cov_conf_low: 'Bassa affidabilità',
      cov_updated: 'Aggiornato:',
      cov_deselect: 'Deseleziona',
      cov_inspected_note: 'URL ispezionate · clicca per filtrare',
      cov_none_inspected: 'Nessuna ispezione',
      cov_no_data: 'Nessun dato coverage disponibile',
      cov_no_data_desc: 'I motivi di non indicizzazione si costruiscono automaticamente con ogni ispezione URL. Usa "Avvia scansione automatica" per popolare questa sezione.',
      cov_solution: 'Soluzione consigliata',
      cov_filter_active: 'Filtro attivo nella Cronologia',
      ih_worklist: 'Worklist SEO',
      ih_history: 'Cronologia ispezioni',
      ih_filter_coverage: 'Filtro Coverage',
      ih_tab_all: 'Tutte',
      ih_tab_not_ind: 'Non ind.',
      ih_tab_indexed: 'Indicizzate',
      ih_tab_excluded: 'Escluse',
      ih_tab_errors: 'Errori',
      ih_tab_with_imp: 'Con imp.',
      ih_tab_products: 'Prodotti',
      ih_tab_collections: 'Collezioni',
      ih_sort_priority: '↓ Priorità',
      ih_sort_impressions: '↓ Impressioni',
      ih_sort_clicks_est: '↓ Click stimati',
      ih_sort_date: '↓ Data',
      ih_sort_state: '↓ Stato GSC',
      ih_clear: 'Cancella',
      ih_search: 'Cerca URL…',
      ih_open: 'Apri',
      ih_indexing_state: 'Stato indicizzazione',
      ih_canonical_diff: '⚠ Canonical scelto da Google (diverso)',
      ih_canonical_same: 'Canonical Google (uguale)',
      ih_ai_fix: 'Ottimizza con AI →',
      ih_total: '{{n}} URL · {{total}} totali',
      ih_est_clicks: '· +{{n}} click/mese stimati',
      iai_title: 'Suggerimenti AI — Indicizzazione',
      iai_filter_note: '· clicca per filtrare',
      iai_prio_high: 'Alta priorità',
      iai_prio_medium: 'Media priorità',
      iai_prio_low: 'Bassa priorità',
      iai_causes: 'Possibili cause:',
      iai_actions: 'Azioni consigliate:',
      fix_apply_all: 'Applica tutto',
      fix_applied: 'Applicato',
      fix_suggestion: 'Suggerimento',
      fix_chars: 'caratteri',
      fix_content_impr: 'Miglioramenti Contenuto',
      fix_int_links: 'Link Interni Suggeriti',
      fix_open_url: 'Apri URL',
      fix_close: 'Chiudi',
      fix_seo_opt: 'Ottimizzazione SEO',
      trend_title: 'Trend Indicizzazione',
      trend_updated: 'Aggiornato al',
      trend_coverage: 'Copertura',
      trend_30d_kpi: 'Trend 30gg',
      trend_no_data: 'Dati storici in costruzione',
      trend_no_data_desc: 'Il trend sarà disponibile dopo la raccolta di almeno 2 snapshot.',
      trend_one_snap: '1 snapshot raccolto su 2.',
      trend_start_scan: 'Avvia una scansione batch per iniziare.',
      trend_ind: 'ind.',
      trend_not_ind: 'non ind.',
      trend_snap_note: 'Snapshot ad ogni scansione',
      ic_loading: 'Caricamento dati indicizzazione...',
      ic_load_err: 'Impossibile caricare i dati di indicizzazione',
      ic_clear_confirm: 'Cancellare tutta la cronologia ispezioni?',
      ic_cleared: 'Cronologia cancellata',
      ic_clear_err: 'Errore cancellazione',
      ic_seo_opp: 'Opportunità SEO — Executive Summary',
      ic_recoverable: 'URL recuperabili',
      ic_open_worklist: '⚡ Apri Worklist →',
      ic_view_all: 'Vedi tutte →',
      ic_crawled_ni: 'Crawled – non indicizzate',
      ic_crawled_ni_note: 'Google le conosce ma non le serve',
      ic_discovered_ni: 'Discovered – non indicizzate',
      ic_discovered_ni_note: 'Trovate ma mai scansionate',
      ic_with_imp_ni: 'Con impressioni GSC',
      ic_with_imp_ni_note: 'Hanno traffico ma non sono indicizzate',
      ic_other_ni: 'Altre non indicizzate',
      ic_other_ni_note: 'Sconosciute a Google o errori',
      ic_refresh: 'Aggiorna',
      rh_title: 'Cronologia modifiche',
      rh_versions: 'versioni',
      rh_confirm: "Ripristinare la versione del {{date}}?\n\nLe modifiche attuali nell'editor verranno sostituite.",
      rh_restored_ok: 'v{{v}} ripristinata nel tema Shopify',
      rh_restored_editor: "Versione v{{v}} caricata nell'editor — clicca Salva per applicarla",
      rh_restore_err: 'Errore ripristino',
      rh_current: 'corrente',
      rh_initial: 'Versione iniziale',
      rh_no_diff: 'Nessuna modifica testuale',
      rh_more_added: '+ {{n}} altre aggiunte',
      rh_more_removed: '- {{n}} altre rimosse',
      rh_restore_btn: 'Ripristina',
      rb_load_err: 'Errore caricamento robots.txt',
      rb_save_err: 'Errore salvataggio',
      rb_analyze_err: 'Errore analisi',
      rb_score_good: 'Ottimo',
      rb_score_ok: 'Da migliorare',
      rb_score_bad: 'Critico',
      rb_analysis_title: 'Analisi SEO Robots',
      rb_analyzing: 'Analisi…',
      rb_analyze: 'Analizza',
      rb_analyze_hint: 'Clicca "Analizza" per rilevare automaticamente problemi SEO e opportunità di ottimizzazione',
      rb_no_issues: 'Nessun problema rilevato',
      rb_no_issues_desc: 'Il tuo robots.txt segue le best practice per Shopify',
      rb_critical: 'CRITICO',
      rb_warning: 'AVVISO',
      rb_validation_title: 'Validazione Robots.txt',
      rb_reload: 'Ricarica',
      rb_editor_title: 'Editor Robots.txt',
      rb_modified: 'Modificato',
      rb_diff_close: 'Chiudi diff',
      rb_editor_restore: 'Ripristina',
      rb_saving: 'Salvataggio…',
      rb_save: 'Salva',
      rb_blocking_warning: '🚨 STAI BLOCCANDO TUTTO IL SITO — "Disallow: /" impedisce a Google di indicizzare qualsiasi pagina',
      rb_diff_preview: 'Anteprima modifiche:',
      rb_opportunity: 'OPPORTUNITÀ',
      rb_checker_title: 'Verifica URL',
      rb_check_btn: 'Verifica',
      rb_allowed: 'Consentito',
      rb_blocked: 'Bloccato',
      rb_sitemaps_title: 'Sitemap Dichiarate',
      ll_history_title: 'Cronologia LLMs.txt',
      ll_generated: 'Generato',
      ll_restored_editor: "Versione v{{v}} caricata nell'editor — clicca Pubblica per applicarla",
      ll_load_err: 'Errore caricamento llms.txt',
      ll_generate_err: 'Errore generazione',
      ll_saved_ok: 'LLMs.txt pubblicato e verificato nel tema Shopify',
      ll_not_configured: 'Non configurato',
      ll_validation_title: 'Validazione LLMs.txt',
      ll_not_found: 'Nessun llms.txt trovato sul sito. Usa "Genera da Shopify" per crearlo automaticamente.',
      ll_what_title: "Cos'è LLMs.txt?",
      ll_what_desc: 'Lo standard /llms.txt è un file markdown che aiuta i modelli AI (ChatGPT, Claude, Perplexity, Gemini) a capire il tuo sito e citarlo correttamente nelle risposte. Aumenta la visibilità nei motori di risposta AI.',
      ll_editor_title: 'Editor LLMs.txt',
      ll_generating: 'Generazione…',
      ll_generate_btn: 'Genera da Shopify',
      tab_jsonld: 'JSON-LD',
      jl_load_err: 'Errore caricamento panoramica JSON-LD',
      jl_sec_overview: 'Panoramica',
      jl_sec_schemas: 'Schemi',
      jl_sec_problems: 'Problemi',
      jl_sec_generate: 'Ottimizzazione AI',
      jl_sec_preview: 'Anteprima JSON',
      jl_sec_validate: 'Validazione',
      jl_sec_bulk: 'Operazioni bulk',
      jl_sec_stats: 'Statistiche',
      jl_rich_results: 'Idoneità Rich Results',
      jl_eligible: 'Idonei',
      jl_warnings: 'Parziali',
      jl_not_eligible: 'Non idonei',
      jl_field_coverage: 'Copertura campi',
      jl_what_title: "Cos'è il JSON-LD?",
      jl_what_desc: 'JSON-LD è il formato raccomandato da Google per i dati strutturati. Abilita Rich Results nella ricerca (stelle, prezzi, breadcrumb) e aiuta i modelli AI a comprendere meglio i tuoi prodotti.',
      jl_score_poor: 'Copertura scarsa',
      jl_schemas_title: 'Tipi di schema supportati',
      jl_status_valid: 'Valido',
      jl_status_partial: 'Parziale',
      jl_status_missing: 'Non configurato',
      jl_valid_items: 'validi',
      jl_issues: 'problemi',
      jl_google_test: 'Testa su Google Rich Results',
      jl_google_test_desc: "Dopo aver generato il JSON-LD, testalo direttamente nel tool di Google per verificare l'idoneità.",
      jl_problems_title: 'Problemi diagnostici',
      jl_no_problems: 'Nessun problema critico trovato. La copertura JSON-LD è buona!',
      jl_products_affected: 'prodotti interessati',
      jl_sev_critical: 'Critico',
      jl_sev_warning: 'Avviso',
      jl_prob_brand: 'Brand / fornitore mancante',
      jl_prob_desc: 'Descrizione mancante',
      jl_prob_image: 'Immagine prodotto mancante',
      jl_prob_sku: 'SKU mancante',
      jl_prob_gtin: 'GTIN / codice a barre mancante',
      jl_prob_meta: 'Meta description mancante',
      jl_prob_offers: 'Prezzo non in JSON-LD (richiede snippet nel tema Shopify)',
      jl_problems_tip: 'Correggi i campi mancanti nella sezione Prodotti oppure usa Ottimizzazione AI per compilarli automaticamente.',
      jl_gen_title: 'Genera JSON-LD',
      jl_schema_type: 'Tipo di schema',
      jl_product_id: 'ID prodotto (lascia vuoto per esempio)',
      jl_use_ai: 'Usa arricchimento AI (GPT)',
      jl_gen_btn: 'Genera JSON-LD',
      jl_gen_ok: 'JSON-LD generato',
      jl_gen_err: 'Errore di generazione',
      jl_copied: 'Copiato!',
      jl_copy: 'Copia',
      jl_preview_title: 'Anteprima JSON-LD',
      jl_preview_err: 'Errore caricamento anteprima',
      jl_load_preview: 'Carica prodotto di esempio',
      jl_preview_empty: 'Clicca "Carica prodotto di esempio" per visualizzare tutti gli schemi JSON-LD',
      jl_val_title: 'Validazione schema locale',
      jl_invalid_json: 'JSON non valido',
      jl_val_btn: 'Valida JSON-LD',
      jl_val_clear: 'Pulisci',
      jl_val_ok: 'Valido — idoneo ai Rich Results',
      jl_val_fail: 'Validazione fallita',
      jl_val_note: 'Questo validatore controlla i requisiti schema.org. Per il test ufficiale Google usa Rich Results Test.',
      jl_val_err: 'Errore di validazione',
      jl_bulk_title: 'Operazioni bulk',
      jl_bulk_gen: 'Genera tutto',
      jl_bulk_gen_desc: 'Costruisce Product JSON-LD per ogni prodotto e lo salva nel DB',
      jl_bulk_val: 'Valida tutto',
      jl_bulk_val_desc: 'Esegue la validazione schema.org sul JSON-LD esistente',
      jl_bulk_fix: 'Correggi e arricchisci',
      jl_bulk_fix_desc: 'Ricostruisce il JSON-LD per prodotti con errori',
      jl_bulk_started: 'Operazione bulk avviata',
      jl_bulk_err: 'Errore avvio operazione bulk',
      jl_bulk_running: 'In corso',
      jl_bulk_done: 'Completato',
      jl_bulk_stop: 'Ferma',
      jl_bulk_stopped: 'Operazione bulk interrotta',
      jl_errors: 'errori',
      jl_stat_total: 'Prodotti totali',
      jl_stat_eligible: 'Idonei Rich Results',
      jl_stat_gen_today: 'Generati oggi',
      jl_stat_fixed: 'Corretti oggi',
      jl_coverage_by_type: 'Copertura per tipo di contenuto',
      jl_type: 'Tipo',
      jl_total: 'Totale',
      jl_valid2: 'Validi',
      jl_missing2: 'Mancanti',

      ll_revert: 'Annulla',
      ll_publishing: 'Pubblicazione…',
      ll_publish: 'Pubblica',
      lp_filter_url: 'Filtra URL…',
      lp_copied: 'Copiato',
      lp_broken_empty: 'Nessun link rotto rilevato',
      lp_broken_empty_sub: 'Tutte le URL del negozio sono raggiungibili (404 / 410 / timeout)',
      lp_timeout: 'Timeout — nessuna risposta entro 12s',
      lp_ratelimit_empty: 'Nessun rate limit rilevato',
      lp_ratelimit_empty_sub: 'Il server non ha limitato le richieste dello scanner',
      lp_ratelimit_note: 'Pagina raggiungibile ma il server ha risposto 429 durante la scansione',
      lp_server_empty: 'Nessun errore server rilevato',
      lp_server_empty_sub: 'Tutte le URL rispondono correttamente (nessun 5xx)',
      lp_server_note: 'HTTP {{code}} — errore lato server',
      lp_redirect_empty: 'Nessun redirect rilevato',
      lp_redirect_total: 'Redirect totali',
      lp_chains: 'Catene (>1 hop)',
      lp_loops: 'Loop rilevati',
      lp_chains_header: 'Catene di redirect',
      lp_chains_badge: '{{n}} catene multiple',
      lp_final_status: 'Status finale:',
      lp_canon_ok: 'Corretto',
      lp_canon_miss: 'Mancante',
      lp_canon_wrong: 'URL errata',
      lp_canon_cross: 'Cross-domain',
      lp_canon_redir: 'Canonical→redirect',
      lp_canon_action_missing: 'Aggiungere un tag canonical nella sezione head della pagina.',
      lp_canon_action_wrong: 'Correggere il canonical verso la URL definitiva di questa pagina.',
      lp_canon_action_cross: 'Il canonical punta a un dominio esterno. Verificare se intenzionale o un errore.',
      lp_canon_action_redir: 'Il canonical punta a una URL che reindirizza. Aggiornare con la destinazione finale.',
      lp_canon_no_data: 'Dati canonical non disponibili — avvia la scansione',
      lp_canon_issues: 'Problemi Canonical ({{n}})',
      lp_canon_no_issues: 'Nessun problema canonical rilevato',
      lp_canon_sample: 'Campione analizzato: {{n}} URL del negozio (prodotti, collezioni, pagine, articoli)',
      il_tab_orphans: 'Orfane',
      il_tab_weak: 'Link Deboli',
      il_tab_deep: 'Pagine Profonde',
      il_kpi_weak: 'Link deboli ≤2',
      il_kpi_deep: 'Pag. profonde',
      il_orphan_empty: 'Nessuna pagina orfana',
      il_orphan_empty_sub: 'Tutte le pagine ricevono almeno un link interno',
      il_orphan_header: 'Pagine senza link in entrata ({{n}})',
      il_weak_empty: 'Nessuna pagina con link deboli',
      il_weak_empty_sub: 'Tutte le pagine ricevono 3+ link interni',
      il_weak_header: 'Pagine con 1–2 link in entrata ({{n}})',
      il_anchor_empty: 'Anchor text ottimizzati',
      il_anchor_empty_sub: 'Nessun anchor generico, vuoto o duplicato rilevato',
      il_anchor_generic: 'Anchor generici',
      il_anchor_generic_desc: 'Testi come "clicca qui", "qui", "scopri"',
      il_anchor_empty_type: 'Anchor vuoti',
      il_anchor_empty_desc: 'Link senza testo descrittivo',
      il_anchor_dup: 'Anchor duplicati',
      il_anchor_dup_desc: 'Stesso testo → URL diverse',
      il_anchor_lbl_gen: 'Generico',
      il_anchor_lbl_empty: 'Vuoto',
      il_anchor_lbl_dup: 'Duplicato',
      il_deep_empty: 'Nessuna pagina troppo profonda',
      il_deep_empty_sub: 'Tutte le pagine sono raggiungibili in ≤3 click dalla homepage',
      il_deep_header: 'Pagine a >3 click dalla homepage ({{n}})',
      il_deep_note: 'Le pagine con ∞ non sono raggiungibili tramite link interni. Aggiungile ai menu o collection.',
      il_hub_empty: 'Nessun dato hub disponibile',
      il_hub_empty_sub: 'Avvia una scansione per identificare le pagine hub',
      il_hub_header: 'Pagine hub — più linkate internamente',
      il_hub_count: '{{n}} link interni in entrata',
      lm_active: 'Attivo',
      lm_not_installed: 'Non installato',
      lm_install_hint: 'Installa nel tema per monitorare la navigazione reale senza crawling',
      lm_refresh: 'Aggiorna',
      lm_clear: 'Azzera dati',
      lm_remove: 'Rimuovi dal tema',
      lm_installing: 'Installazione…',
      lm_install: 'Installa nel tema',
      lm_tab_404: 'Errori 404',
      lm_tab_redirect: 'Redirect Opp.',
      lm_tab_top: 'Top Pagine',
      lm_kpi_visits: 'Visite totali',
      lm_kpi_404s: 'Errori 404 reali',
      lm_no_404: 'Nessun errore 404 rilevato dagli utenti',
      lm_visits: 'visite',
      lm_theme_prefix: 'Tema: ',
      lm_last_activity: 'Ultima attività: ',
      lm_no_activity: 'nessuna visita ancora',
      lm_installed: 'Monitor installato nel tema "{{name}}"',
      lm_err_install: 'Errore installazione',
      lm_confirm_remove: 'Rimuovere lo script di monitoraggio dal tema attivo?',
      lm_removed: 'Script rimosso dal tema',
      lm_err_remove: 'Errore rimozione',
      lm_confirm_clear: 'Cancellare tutti i dati di monitoraggio raccolti?',
      lm_cleared: 'Dati cancellati',
      lm_err_clear: 'Errore cancellazione',
      lm_modal_title: 'Crea Redirect 301',
      lm_modal_source: 'URL sorgente (404)',
      lm_modal_dest: 'Destinazione',
      lm_redirect_created: 'Redirect 301 creato su Shopify',
      lm_err_redirect: 'Errore creazione redirect',
      lm_create_redirect: 'Crea Redirect',
      lm_creating: 'Creazione…',
      lm_cancel: 'Annulla',
      lm_info_title: 'Come funziona il Live Monitor',
      lm_info_1: 'Il pulsante "Installa nel tema" aggiunge automaticamente uno script leggero al tema attivo via Shopify Themes API',
      lm_info_2: 'Per ogni visita reale raccoglie: URL, tipo pagina, link interni, errori 404, referrer interno',
      lm_info_3: 'Zero crawling — nessun HTTP 429 — dati dai visitatori reali in tempo reale',
      lm_info_4: 'Costruisce progressivamente la mappa dei link interni e rileva pagine orfane',
      lm_no_redirect: 'Nessun redirect necessario',
      lm_no_redirect_hint1: 'Il Live Monitor non ha ancora registrato visite. Le opportunità di redirect appaiono quando gli utenti reali incontrano pagine 404.',
      lm_no_redirect_hint2: 'In {{n}} visite analizzate nessun utente ha incontrato pagine 404. Ottimo!',
      lm_toolbar_ai: '{{count}} URL · {{ai}} con suggerimento AI',
      lm_toolbar_ignored: '· {{n}} ignorati',
      lm_sort_visits: 'Visite',
      lm_sort_date: 'Data',
      lm_selected: '{{n}} selezionati',
      lm_no_match: 'nessun match automatico',
      lm_create: 'Crea',
      lm_ignore: 'Ignora',
      lm_err: 'Errore',
      lm_bulk_ignored: '{{n}} URL ignorati',
      lm_bulk_created: '{{n}} redirect creati',
      lm_errors: 'errori',
      ls_scan_started: 'Scansione avviata — verrà completata in background',
      ls_scan_err: 'Errore avvio scansione',
      ls_last_scan: 'Ultima scansione: {{date}} · {{n}} URL',
      ls_no_scan_desc: 'Nessuna scansione effettuata — rileva link rotti, redirect, canonical, pagine orfane',
      ls_scanning: 'Scansione in corso…',
      ls_rescan: 'Riscansiona',
      ls_start_scan: 'Avvia scansione',
      ls_canonical_issues: 'Problemi Canonical',
      ls_scan_details: 'Dettaglio scansione',
      ls_stat_total: 'URL totali',
      ls_stat_errors: 'Errori',
      ls_no_scan: 'Nessuna scansione effettuata',
      ls_no_scan_long: 'Avvia la scansione per rilevare link rotti, catene di redirect, problemi canonical e pagine orfane senza link in entrata',
      ls_first_scan: 'Avvia prima scansione',
      db_gsc_connected: 'Google Search Console connessa!',
      db_gsc_err: 'Errore connessione GSC: {{code}}',
      db_props_err: 'Impossibile caricare le properties GSC',
      db_oauth_hint: "Completa l'autorizzazione Google nella nuova tab. La pagina si aggiornerà automaticamente.",
      db_conn_err: 'Errore connessione GSC',
      db_prop_selected: 'Property selezionata: {{url}}',
      db_prop_err: 'Errore selezione property',
      db_confirm_disconnect: 'Disconnettere Google Search Console?',
      db_disconnected: 'GSC disconnessa',
      db_disconnect_err: 'Errore disconnessione',
      db_connected: 'Search Console connessa',
      db_no_property: 'Nessuna property selezionata',
      db_not_connected: 'Non connessa',
      db_connect_hint: 'Collega GSC per sbloccare analytics e monitoraggio',
      db_change_prop: 'Cambia property',
      db_disconnect: 'Disconnetti',
      db_connect: 'Connetti GSC',
      db_idx_subtitle: 'Qualità tecnica SEO & indicizzazione',
      db_lbl_gsc: 'GSC Connessa',
      db_lbl_sitemap: 'Sitemap inviate',
      db_lbl_indexed: 'URL indicizzati',
      db_health_real: 'Basato su dati Search Console reali',
      db_health_proxy: 'Basato su qualità catalogo — connetti GSC per dati reali',
      db_lbl_position: 'Posizione',
      db_lbl_trend: 'Trend 28gg',
      db_lbl_errors: 'Errori',
      db_connect_score: 'Connetti GSC per calcolare lo score',
      db_proxy_note: 'Proxy catalogo',
      db_stat_excluded: 'URL Esclusi',
      db_stat_seo_score: 'Score SEO medio',
      db_catalog_title: 'Salute Catalogo',
      db_cat_alt: 'ALT text immagini',
      db_cat_keywords: 'Keywords assenti',
      db_cat_no_kw: '{{n}} prodotti senza keywords',
      db_cat_count: '{{n}} / {{total}} prodotti',
      tab_opportunities: 'Opportunità SEO',
      tab_indexing: 'Indicizzazione',
      locked_available: 'Disponibile dal piano {{plan}}',
      locked_upgrade: 'Passa al Piano {{plan}}',
      main_subtitle: 'SEO tecnico · Indicizzazione · Analytics · AI Automation',
      phase_3: 'Fase 3',
      interval_all: 'Tutto',
      click_monthly_est: 'click/mese stimati',
      fix_title_updated: 'Title tag aggiornato',
      fix_meta_updated: 'Meta description aggiornata',
      fix_both_updated: 'Title e Meta description aggiornati su Shopify',
      fix_apply_err: 'Errore applicazione',
      rb_save_ok: 'Robots.txt salvato e verificato nel tema Shopify',
      rb_draft_with_err: 'Bozza salvata ({{err}})',
      rb_draft_manual: 'Bozza salvata — segui le istruzioni per applicarla nel tema',
      rb_critical_confirm: '🚨 ATTENZIONE CRITICA 🚨\n\nIl robots.txt contiene "Disallow: /" che BLOCCA COMPLETAMENTE il sito:\nGoogle, Bing e tutti i bot non potranno piu scansionare nessuna pagina.\n\nQuesto puo causare la rimozione del sito dai risultati di ricerca.\n\nSei ASSOLUTAMENTE SICURO di voler procedere?',
      scan_err: 'Errore scansione: {{msg}}',
      sm_send_err: 'Errore invio',
      unknown_err: 'Sconosciuto',
      dq_today: 'Oggi',
      dq_7d: 'Ultimi 7 giorni',
      dq_30d: 'Ultimi 30 giorni',
      dq_daily_avg: 'Media giornaliera',
      dq_at_pace: 'al ritmo ~{{n}}/giorno',
      job_stopped: 'Fermato a {{n}} URL elaborate',
      job_inspected: '{{n}} ispezionate',
      job_errors: 'errori',
      quota_remaining: 'Quota rimasta:',
      lk_trend: 'Trend Indicizzazione',
      lk_batch: 'Batch Inspection (scansione massiva URL)',
      lk_ai: 'Suggerimenti AI Indicizzazione',
      footer_apis: 'Sitemaps API + Search Analytics + Inspection API',
      prod_status_lbl: 'Stato:',
      prod_desc_lbl: 'Descrizione:',
      prod_missing: 'ASSENTE',
      state_disc: 'Scoperta',
      state_crawl: 'Crawlata',
      insp_api_real: 'Inspection API ✓ reale',
      sm_count: '{{n}} sitemap registrate',
      sm_reliability: 'Affidabilità:',
      conf_high: 'Alta',
      conf_medium: 'Media',
      conf_low: 'Bassa',
      sm_urls: 'URL in Sitemap',
      sm_sample: 'Campione',
      sm_est_indexed: 'Indicizzate stim.',
      sm_est_nonidx: 'Non indicizzate stim.',
      sm_coverage: 'Copertura stimata ⓘ',
      sm_idx_of: '~{{n}} indicizzate su {{t}} URL in sitemap',
      sm_cov_est: 'Copertura stimata:',
      sm_margin_err: 'margine di errore',
      sm_indexed_of: 'indicizzate su',
      sm_sampled: 'campionate',
      sm_th_sitemap: 'Sitemap',
      sm_th_submitted: 'Inviate',
      sm_th_indexed: 'Indicizzate',
      sm_th_gap: 'Gap',
      sm_th_coverage: 'Copertura',
      sm_th_warning: 'Warning',
      sm_th_errors: 'Errori',
      sm_th_lastmod: 'Ultimo aggiornamento',
      sm_th_actions: 'Azioni',
      rb_verified_result: 'Salvato e verificato nel tema Shopify ({{theme}}) — file:',
      rb_draft_result: 'Bozza salvata. Per applicare manualmente: Shopify Admin → Temi → Modifica codice →',
      ll_draft_result: 'Bozza salvata. Per applicare manualmente: Shopify Admin → Temi → Modifica codice →',
      ls_section_redirects: 'Redirect Manager',
      rm_tab: 'Redirect Manager',
      rm_subtitle: 'Gestisci tutti i redirect del tuo store in un unico posto.',
      rm_kpi_total: 'Regole Totali',
      rm_kpi_active: 'Redirect Attivi',
      rm_kpi_pending: '404 In Attesa',
      rm_kpi_hits: 'Hit (30gg)',
      rm_kpi_chains: 'Catene',
      rm_kpi_loops: 'Loop',
      rm_section_rules: 'Regole',
      rm_section_suggest: 'Suggerimenti AI',
      rm_section_health: 'Salute',
      rm_section_import: 'Import / Export',
      rm_section_history: 'Cronologia',
      rm_create_title: 'Crea Redirect',
      rm_edit_title: 'Modifica Redirect',
      rm_old_url: 'URL Origine',
      rm_new_url: 'URL Destinazione',
      rm_old_url_ph: '/vecchio-percorso',
      rm_new_url_ph: '/nuovo-percorso',
      rm_type: 'Tipo',
      rm_type_301: '301 – Permanente',
      rm_type_302: '302 – Temporaneo',
      rm_notes: 'Note',
      rm_save: 'Salva',
      rm_cancel: 'Annulla',
      rm_create_ok: 'Redirect creato con successo.',
      rm_edit_ok: 'Redirect aggiornato con successo.',
      rm_create_err: 'Errore durante la creazione del redirect.',
      rm_edit_err: 'Errore durante il salvataggio del redirect.',
      rm_dup_err: 'Esiste già un redirect per questo URL di origine.',
      rm_empty_err: 'URL di origine e destinazione sono obbligatori.',
      rm_same_err: "L'URL di origine e destinazione non possono essere uguali.",
      rm_search_ph: 'Cerca URL…',
      rm_filter_all: 'Tutti',
      rm_filter_active: 'Attivi',
      rm_filter_disabled: 'Disabilitati',
      rm_create_btn: 'Crea Redirect',
      rm_selected_items: '{{count}} selezionati',
      rm_bulk_enable: 'Abilita',
      rm_bulk_disable: 'Disabilita',
      rm_bulk_delete: 'Elimina',
      rm_bulk_export: 'Esporta CSV',
      rm_bulk_ok: 'Operazione completata.',
      rm_table_old: 'URL Origine',
      rm_table_new: 'URL Destinazione',
      rm_table_type: 'Tipo',
      rm_table_hits: 'Hit',
      rm_table_status: 'Stato',
      rm_table_actions: 'Azioni',
      rm_edit: 'Modifica',
      rm_duplicate: 'Duplica',
      rm_delete: 'Elimina',
      rm_delete_confirm: 'Eliminare questo redirect?',
      rm_deleted_ok: 'Redirect eliminato.',
      rm_delete_err: "Errore durante l'eliminazione.",
      rm_status_active: 'Attivo',
      rm_status_disabled: 'Disabilitato',
      rm_no_data: 'Nessun redirect trovato.',
      rm_empty_state: 'Nessun redirect ancora. Crea il tuo primo redirect.',
      rm_total_redirects: '{{count}} redirect totali',
      rm_import_title: 'Importa Redirect',
      rm_import_csv: 'CSV (old_url,new_url,type)',
      rm_import_shopify: 'Shopify Export CSV',
      rm_import_sf: 'Screaming Frog CSV',
      rm_import_btn: 'Importa',
      rm_import_ok: 'Importazione completata.',
      rm_import_err: "Errore durante l'importazione.",
      rm_import_imported: '{{count}} importati',
      rm_import_skipped: '{{count}} ignorati',
      rm_export_title: 'Esporta Redirect',
      rm_export_desc: 'Scarica tutti i redirect nei formati disponibili.',
      rm_export_csv: 'Esporta CSV',
      rm_export_json: 'Esporta JSON',
      rm_ai_title: 'Suggerimenti AI',
      rm_ai_subtitle: "L'AI ha rilevato URL con 404 e suggerisce redirect verso prodotti simili.",
      rm_ai_accept: 'Accetta',
      rm_ai_reject: 'Rifiuta',
      rm_ai_accept_all: 'Accetta Tutti',
      rm_ai_loading: 'Analisi in corso…',
      rm_ai_empty: 'Nessun suggerimento disponibile al momento.',
      rm_chains_title: 'Catene di Redirect',
      rm_chains_desc: 'Più redirect concatenati rallentano il sito. Correggere subito.',
      rm_chains_fix: 'Correggi Catena',
      rm_chains_empty: 'Nessuna catena rilevata.',
      rm_chains_fixed: 'Catena corretta.',
      rm_loops_title: 'Loop di Redirect',
      rm_loops_desc: 'Loop circolari che causano errori. Richiedono correzione manuale.',
      rm_loops_fix: 'Correggi',
      rm_loops_empty: 'Nessun loop rilevato.',
      rm_gsc_title: '404 da Google Search Console',
      rm_gsc_subtitle: 'URL non trovati rilevati da GSC nelle ultime 90 giornate.',
      rm_gsc_empty: 'Nessun 404 GSC rilevato.',
      rm_history_title: 'Cronologia Attività',
      rm_history_created: 'Creato',
      rm_history_edited: 'Modificato',
      rm_history_deleted: 'Eliminato',
      rm_history_disabled: 'Disabilitato',
      rm_history_enabled: 'Abilitato',
      rm_history_imported: 'Importato',
      rm_history_bulk: 'Operazione multipla',
      rm_history_empty: 'Nessuna attività registrata.',
      rm_sync_shopify: 'Sincronizza da Shopify',
      rm_sync_shopify_desc: 'Importa tutti i redirect URL presenti in Shopify. I nuovi redirect vengono automaticamente inviati a Shopify.',
      rm_sync_btn: 'Sincronizza ora',
      error_label: 'Errore:',
      rb_checker_desc: 'Verifica se un URL è consentito o bloccato da {{bot}} in base al robots.txt corrente.',
      rb_rule: 'Regola:',
      rb_fix: 'Correggi:',
      rb_gsc_note_title: 'Integrazione Search Console',
      rb_gsc_note_body: 'Nella sezione Indicizzazione, le URL con stato "Bloccata da robots" indicano pagine che Google non può scansionare a causa di questo file.',
      rb_issues: 'problemi',
      rb_opps: 'opportunità',
      rb_savings: 'Risparmio stimato:',
      never: 'Mai',
      samples_conf: '{{n}} campioni · confidenza {{c}}',
      batch_priority_note: 'URL con impressioni Analytics ispezionate per prime · quota GSC 2.000/giorno · elaborazione in background',
      sm_samples: 'campioni',
      sm_footnote_ec: '~ Valori "In calcolo" = stima da Inspection API ({{n}} campioni · confidenza {{c}}). Sitemaps API restituisce 0 per i sitemap index.',
      sm_footnote_noec: '~ Valori "In calcolo" = stima proporzionale. Avvia scansione batch per ottenere la stima. Sitemaps API restituisce 0 per i sitemap index.',
      ic_quota_note: 'Calcolate su {{n}} URL ispezionate via Inspection API (quota 2.000/giorno). GSC Coverage mostra {{m}} URL non indicizzate nel sitemap.',
      cov_crawled_ni: 'Contenuto di bassa qualità o duplicato. Migliorare il contenuto, aggiungere testo unico, verificare il tag canonical.',
      cov_disc_ni: "Google l'ha trovata ma non ancora crawlata. Aumentare il crawl budget con internal links aggiuntivi e sitemap aggiornata.",
      cov_dup_nocanon: 'Aggiungere tag canonical che punti alla pagina principale.',
      cov_dup_googcanon: 'Google ignora il canonical dichiarato. Verificare coerenza URL e canonical tra versioni desktop/mobile.',
      cov_redirect: 'Redirect attivo. Se intenzionale, aggiornare i link interni per puntare direttamente alla destinazione.',
      cov_alternate: 'Pagina alternativa con canonical corretto — nessuna azione necessaria se intenzionale.',
      cov_noindex: 'Rimuovere il meta tag noindex se si vuole che la pagina venga indicizzata.',
      cov_robots: 'Pagina bloccata da robots.txt. Verificare le direttive Disallow e aggiornare se necessario.',
      cov_removed: 'Rimossa manualmente da GSC. Revocare la rimozione dal pannello Search Console se desiderato.',
      cov_404: 'Pagina non trovata. Ripristinare la pagina, impostare un redirect 301, o rimuovere i link interni a questa URL.',
      cov_soft404: 'Il server risponde 200 ma Google la tratta come pagina vuota. Assicurarsi che la pagina abbia contenuto rilevante.',
      cov_server_err: "Errore del server. Verificare i log del server e la disponibilità dell'hosting durante il crawl.",
      cov_unknown_url: 'Google non ha ancora scoperto questa URL. Aggiungere internal links, aggiornare la sitemap, e attendere il prossimo crawl.',
      qt_brand: 'Brand',
      qt_info: 'Info',
      qt_category: 'Categoria',
      qt_product: 'Prodotto',
      qt_generic: 'Generico',
      sugg_title_improvement: 'Tag titolo',
      sugg_meta: 'Meta description',
      sugg_content_gap: 'Contenuto mancante',
      sugg_schema: 'Schema markup',
      sugg_links: 'Link interni',
      verdict_indexed: 'Indicizzato',
      verdict_not_indexed: 'Non indicizzato',
      verdict_excluded: 'Escluso',
      badge_col_header: 'Badge',
      sitemap_label: 'Sitemap',
      ls_tab_broken: 'Link rotti',
      ls_tab_redirect: 'Reindirizzamento',
      ls_tab_rate_limited: 'Limite richieste',
      ls_tab_server_errors: 'Errori server',
      ls_tab_canonical: 'Canonical',
      ls_tab_internal: 'Link interni',
      ls_section_monitor: 'Monitor Live',
      ls_section_audit: 'Struttura sito',
      db_idx_title: 'Punteggio Indicizzazione',
      db_health_title: 'Punteggio Salute SC',
      canonical_mismatch: 'Canonical non corrispondente',
    },
    so: {
      load_err: 'Errore nel caricamento Speed Optimizer',
      analyze_timeout: 'Timeout analisi (90s) — riprova tra qualche istante',
      analyze_done: 'Analisi completata!',
      analyze_failed: 'Analisi fallita: {{error}}',
      rate_limited: 'Limite richieste raggiunto — dati aggiornati dalla cache',
      analyze_err: 'Errore analisi',
      opt_enabled: '{{label}} attivata sul tema',
      opt_disabled: '{{label}} disattivata',
      opt_err: 'Errore ottimizzazione',
      scan_err: 'Errore scansione tema',
      img_err: 'Errore analisi immagini',
      sg_protected: 'Safety Guard: Protected attivato',
      sg_standard: 'Safety Guard: Standard attivato',
      mode_err: 'Errore cambio modalità',
      plan_err: 'Errore generazione piano',
      strategy_applied: 'Strategia {{label}} applicata al tema',
      strategy_err: 'Errore applicazione strategia',
      sessions_err: 'Errore caricamento sessioni',
      rollback_done: 'Rollback completato — tema ripristinato',
      rollback_err: 'Errore rollback',
      subtitle: 'Ottimizzazioni sicure del tema Shopify con rollback istantaneo.',
      btn_rollback: 'Rollback tutto',
      btn_analyze: 'Analizza ora',
      analyzing_psi: 'Elaborazione PSI…',
      analyzing_queue: 'In coda…',
      analyzing: 'Analisi…',
      alert_no_token: 'Token Shopify mancante — le ottimizzazioni richiedono una connessione attiva allo store.',
      alert_no_scope: "Permessi tema mancanti — per applicare le ottimizzazioni devi reinstallare l'app per aggiungere l'accesso ai temi Shopify.",
      perf_empty: 'Nessuna analisi disponibile',
      perf_empty_hint: 'Clicca "Analizza ora" per misurare le performance del tuo store',
      suggestions: 'Suggerimenti',
      strategy_active: 'attiva',
      strategy_subtitle: 'Definisce il target di ottimizzazione. Clicca per vedere il piano prima di applicare.',
      sg_header: 'Limita quali operazioni possono essere eseguite dalla strategia.',
      sg_desc_protected: 'Blocca operazioni Standard — solo ottimizzazioni sicure.',
      sg_desc_standard: "Permette l'esecuzione completa della strategia selezionata.",
      quick_opts: 'Ottimizzazioni rapide',
      sg_warning: 'Safety Guard: Protected — le operazioni Standard sono bloccate. Passa a Standard nella sezione sopra.',
      lcp_section: 'Scansione Tema LCP',
      hist_section: 'Cronologia ottimizzazioni',
      hist_empty: 'Nessuna ottimizzazione ancora applicata.',
      sessions_section: 'Sessioni & Impatto Lighthouse',
      sessions_empty: "Carica sessioni per vedere l'impatto reale sui Core Web Vitals.",
      img_count: '{{n}} immagini · {{kb}} KB totali',
      img_oversized: '{{n}} immagini >300KB',
      img_no_oversized: 'Nessuna immagine oversized — ottimo!',
      img_empty: 'Clicca "Analizza immagini" per trovare immagini >300KB nel tema.',
      btn_refresh: 'Ricarica',
      btn_load_sessions: 'Carica sessioni',
      btn_refresh_sessions: 'Aggiorna',
      btn_analyze_img: 'Analizza immagini',
      btn_refresh_img: 'Aggiorna',
      modal_risk_safe: 'Sicuro — nessun impatto visivo atteso',
      modal_risk_medium: "Verifica l'aspetto del sito dopo l'attivazione",
      modal_risk_high: 'Potrebbe influire su funzionalità avanzate',
      modal_reversible: 'Reversibile in qualsiasi momento — usa "Rollback tutto" per ripristinare il tema originale.',
      modal_cancel: 'Annulla',
      modal_enable: 'Attiva ora',
      opt_no_token: 'Riconnetti lo store Shopify per usare questa funzione',
      opt_blocked_guard: 'Bloccata dal Safety Guard (Protected) — passa a Standard per abilitarla',
      opt_reversible: 'reversibile',
      opt_blocked_label: 'Bloccata dal Safety Guard — passa a Standard',
      scan_scanning: 'Scansione in corso...',
      scan_empty_title: 'Scansione tema non eseguita',
      scan_empty_desc: 'Identifica le sezioni hero e slideshow del tema per abilitare le ottimizzazioni LCP server-side.',
      scan_btn: 'Scansiona tema',
      scan_active_theme: 'Tema attivo',
      scan_files: '{{n}} file Liquid scansionati · {{s}} sezioni LCP identificate',
      scan_hero_label: 'sezione hero/LCP',
      scan_optimized: 'ottimizzato',
      scan_no_lcp: 'Nessuna sezione hero/LCP identificata automaticamente nel tema.',
      scan_reload: 'Ricarica',
      plan_title: 'Piano: {{label}}',
      plan_ops: '{{n}} operazioni previste',
      plan_action_enabled: 'già attiva',
      plan_action_enable: 'abilita',
      plan_action_disable: 'disabilita',
      plan_strategy: 'Strategia: ',
      plan_guard: 'Safety Guard: ',
      plan_active_ops: 'Operazioni attive: ',
      plan_blocked: '{{n}} bloccate da Safety Guard',
      plan_low_conf: 'Alcune ottimizzazioni hanno bassa confidence per il tema rilevato.',
      plan_cancel: 'Annulla',
      plan_apply: 'Applica strategia',
      plan_blocked_btn: 'Bloccato (score basso)',
      hist_rollback: 'Rollback completo — tutte le ottimizzazioni rimosse',
      hist_enabled: 'attivata',
      hist_disabled: 'disattivata',
      hist_active: 'attive',
      sess_no_sessions: 'Nessuna sessione di ottimizzazione registrata. Le sessioni vengono create quando applichi una strategia.',
      sess_waiting: 'in attesa PSI',
      strategy_label: 'Strategia {{s}}',
      strategy_opts: '{{n}} ottimizzazioni',
      strategy_active: 'ATTIVA',
      quota_err: 'Errore caricamento quota PSI',
      quota_api_key: 'API key configurata:',
      quota_yes: '✓ SÌ',
      quota_no: '✗ NO (usa quota pubblica)',
      quota_cache_ttl: 'Cache TTL:',
      quota_hourly: 'Limite orario:',
      quota_daily: 'Limite giornaliero:',
      quota_success: 'Successi oggi:',
      quota_hit_ratio: 'Cache hit ratio:',
      quota_circuit: 'Circuit breaker:',
      quota_circuit_open: 'APERTO ({{n}} failures)',
      quota_circuit_closed: 'chiuso',
      quota_loading: 'Caricamento...',
      diag_err: 'Errore diagnostica',
      diag_refresh: 'Aggiorna',
      diag_load: 'Carica diagnostica',
      diag_patches: 'Patch attive ({{n}})',
      diag_none: 'nessuno',
      diag_unavailable: 'non disponibile',
      diag_no_patches: 'Nessuna patch attiva',
      diag_calibrated: '📈 calibrato',
      diag_generated: 'Generato:',
      badge_server_side: 'LATO SERVER',
      badge_standard: 'STANDARD',
      badge_lcp: 'LCP',
      badge_critical: 'CRITICO',
      badge_safe: 'SICURO',
      badge_medium: 'MEDIO',
      badge_safety_guard: 'Safety Guard',
      diag_theme_fingerprint: 'Impronta tema',
      diag_engine_confidence: 'Confidenza motore',
      perf_score_label: 'Punteggio Performance',
      section_perf_overview: 'Panoramica Performance',
      section_strategy_intent: 'Intenzione Strategica',
      safety_guard_title: 'Safety Guard',
      section_script_analyzer: 'Analizzatore Script',
      script_col_file: 'File',
      script_col_size: 'Dimensione',
      script_col_impact: 'Impatto',
      script_col_defer_risk: 'Rischio differimento',
      metric_js_total: 'JS totale',
      metric_css_total: 'CSS totale',
      perf_updated: 'Aggiornato:',
      perf_stale: 'dati non aggiornati (PSI non disponibile)',
      perf_from_cache: 'dalla cache',
      perf_psi_ok: 'PSI OK',
      debug_invalid_token_title: 'Token non valido (401) — il token in MongoDB è scaduto o revocato.',
      debug_reconnect_desc: 'Il callback OAuth non ha sovrascritto il token dopo l\'ultima reinstallazione. Clicca il pulsante sottostante per avviare un nuovo OAuth.',
      debug_reconnect_btn: 'Riconnetti OAuth ora (apre Shopify)',
      debug_reconnect_note: 'Dopo aver approvato i permessi su Shopify, il callback aggiornerà automaticamente il token in MongoDB.',
    },
    drafts: {
      approved: 'Bozza approvata!',
      approve_err: "Errore nell'approvazione",
      published: 'Pubblicato su Shopify!',
      publish_err: 'Errore nella pubblicazione',
      title: 'Bozze e Risultati',
      subtitle: 'Rivedi, approva e pubblica i contenuti ottimizzati',
      empty: 'Nessuna bozza da revisionare',
      empty_hint: 'Genera contenuti AI per creare nuove bozze',
      badge_approved: 'Approvato',
      badge_draft: 'Bozza',
      field_desc: 'Descrizione',
      btn_view: 'Vedi',
      btn_approve: 'Approva',
      btn_publish: 'Pubblica',
      modal_title: 'Dettaglio Bozza',
      chars_seo: '/60 caratteri',
      chars_meta: '/160 caratteri',
      not_present: 'Non presente',
      not_present_pl: 'Non presenti',
      btn_close: 'Chiudi',
      btn_publish_shopify: 'Pubblica su Shopify',
      seo_title: 'Titolo SEO',
      meta_description: 'Meta Description',
      keywords_label: 'Parole chiave',
    },
    usage: {
      title: 'Utilizzo e Piano',
      subtitle: "Monitora l'utilizzo e gestisci il tuo abbonamento",
      plan_badge: 'Piano:',
      current: 'Utilizzo Corrente',
      credits: 'Crediti AI',
      used: 'Utilizzati:',
      unlimited: 'Illimitati ∞',
      remaining: 'Rimanenti: {{n}}',
      products_sync: 'Prodotti sincronizzati',
      plans_heading: 'Piani Disponibili',
      most_popular: '⭐ Più Popolare',
      active_plan: 'Piano Attivo',
      current_plan: 'Piano Corrente',
      btn_upgrade: 'Upgrade a {{name}}',
      trend_heading: 'Trend Utilizzo',
      trend_coming: 'Grafico utilizzo (prossimamente)',
      stat_products: 'Prodotti Analizzati',
      stat_content: 'Contenuti Generati',
      stat_translations: 'Traduzioni',
      stat_images: 'Immagini Ottimizzate',
    },
    support: {
      msg_sent: 'Messaggio inviato!',
      msg_err: "Errore nell'invio del messaggio",
      status_open: 'Aperto',
      status_progress: 'In lavorazione',
      status_closed: 'Chiuso',
      title: 'Supporto',
      subtitle: 'FAQ, guide e chat con il nostro team',
      faq_heading: 'Domande Frequenti',
      guide_heading: 'Guida Rapida',
      chat_heading: 'Chat Supporto',
      no_msgs: 'Nessun messaggio',
      no_msgs_hint: 'Inizia una conversazione con il supporto',
      placeholder: 'Scrivi un messaggio...',
      contacts_heading: 'Contatti',
      contact_hours_label: 'Orari',
      contact_hours: 'Lun-Ven 9:00-18:00 CET',
      contact_response_label: 'Tempo di risposta',
      contact_response: 'Entro 24 ore',
      guide_step1: 'Vai nella sezione',
      guide_products: 'Prodotti',
      guide_step1b: 'per vedere i tuoi prodotti',
      guide_step2: 'Seleziona un prodotto e vai su',
      guide_ai_content: 'Contenuti AI',
      guide_step3: 'Genera descrizione, SEO title, meta description e keywords',
      guide_step4: 'Consulta i risultati in',
      guide_history: 'Storico',
    },
    transl: {
      load_err: 'Errore nel caricamento elementi',
      published: 'Traduzione pubblicata su Shopify!',
      pub_err: 'Errore nella pubblicazione',
      err_no_items: 'Seleziona almeno un elemento',
      err_no_fields: 'Seleziona almeno un campo da tradurre',
      item_err: 'Errore traduzione',
      done_one: 'Traduzione completata!',
      done_many: '{{n}} elementi tradotti!',
      copied: 'Copiato negli appunti',
      title: 'Traduzioni',
      gate_plan: 'Disponibile dal piano Starter',
      gate_desc: 'Traduci prodotti, collezioni e articoli in 8 lingue con AI',
      gate_btn: 'Passa al Piano Starter',
      subtitle: 'Traduci prodotti, collezioni, articoli e pagine in più lingue con AI',
      translating: 'Traducendo…',
      search_placeholder: 'Cerca per titolo…',
      select_page: 'Seleziona pagina',
      sel_abbrev: 'sel.',
      total_items: 'totali',
      loading: 'Caricamento…',
      no_results: 'Nessun risultato per questa ricerca',
      prev: '← Prec',
      tot_abbrev: 'tot.',
      next: 'Succ →',
      deselect_all: 'Deseleziona tutti',
      lang_heading: 'Lingua destinazione',
      fields_heading: 'Campi da tradurre',
      select_hint: 'Seleziona elementi dalla lista per abilitare la traduzione',
      results_heading: 'Risultati',
      clear_results: 'Cancella risultati',
      badge_published: 'Pubblicato',
      publishing: 'Pubblicando…',
      done: 'Fatto',
      publish: 'Pubblica',
      copy: 'Copia',
      tab_products: 'Prodotti',
      tab_collections: 'Collezioni',
      tab_articles: 'Articoli',
      tab_pages: 'Pagine',
      field_title: 'Titolo',
      field_description: 'Descrizione',
      field_seo_title: 'SEO Title',
      field_meta_description: 'Meta Description',
      field_body_html: 'Descrizione / Corpo',
      empty_hint_select: 'Seleziona uno o più elementi dalla lista, scegli la lingua e clicca',
      translate_label: 'Traduci',
      items_selected: 'elementi',
      item_selected: 'elemento',
      selected_label: 'selezionato/i',
      choose_fields_hint: 'scegli i campi e clicca Traduci',
    },
  },

  en: {
    nav: {
      overview: 'Overview',
      catalog: 'Catalog',
      content: 'AI Content',
      translations: 'Translations',
      images: 'Images',
      batch: 'Batch Operations',
      speed: 'Speed Optimizer',
      history: 'History',
      usage: 'Usage & Plan',
      settings: 'Settings',
      support: 'Support',
    },
    common: {
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      close: 'Close',
      confirm: 'Confirm',
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      search: 'Search',
      filter: 'Filter',
      all: 'All',
      yes: 'Yes',
      no: 'No',
      back: 'Back',
      next: 'Next',
      apply: 'Apply',
      generate: 'Generate',
      publish: 'Publish',
      optimize: 'Optimize',
      refresh: 'Refresh',
    },
    settings: {
      title: 'Settings',
      subtitle: 'AI Control Center',
      tabs: {
        general: 'General',
        localization: 'Localization',
        ai_engine: 'AI Engine',
        appearance: 'Appearance',
        piano: 'Plan',
        advanced: 'Advanced',
      },
      save_btn: 'Save settings',
      unsaved: 'Unsaved changes',
      action_loading: 'Processing...',
      general: {
        contents: 'Content',
        default_lang: 'Default Content Language',
        tone: 'Global Content Tone',
        tone_hint: 'Applied to products, collections, articles and batches',
        seo_rules: 'SEO Rules',
        seo_title_max: 'Max SEO Title Length',
        seo_title_hint: 'Recommended: 50–60 characters',
        meta_max: 'Max Meta Description Length',
        meta_hint: 'Recommended: 150–160 characters',
        chars: 'characters',
        images: 'Image Preferences',
        img_format: 'Default Format',
        img_square: 'Square (1:1)',
        img_landscape: 'Landscape (4:3)',
        img_portrait: 'Portrait (3:4)',
        img_quality: 'Compression Quality',
        img_quality_low: '50% (compressed)',
        img_quality_high: '100% (maximum)',
        store_info: 'Store Information',
        store_domain: 'Domain',
        store_plan: 'Plan',
        store_installed: 'Installed',
      },
      ai: {
        strategy: 'AI Strategy',
        params_title: 'Generation Parameters',
        creativity: 'Creativity',
        creative_low: 'Conservative',
        creative_high: 'Creative',
        seo_strictness: 'SEO Strictness',
        seo_low: 'Flexible',
        seo_high: 'Strict',
        tone_label: 'Global Tone',
        auto_title: 'AI Auto-Optimization',
        auto_hint: 'Enable to automatically optimize content',
        on: 'Active',
        off: 'Off',
        threshold: 'Optimization Threshold',
        threshold_low: 'Optimize all',
        threshold_high: 'Only the worst',
        threshold_hint: 'Acts on items with SEO score < {{n}}',
        frequency: 'Frequency',
        scope: 'Scope',
        triggers: 'Triggers',
        img_format: 'Image format',
        img_square: 'Square 1:1',
        img_square_sub: '800×800 px',
        img_landscape: 'Landscape 4:3',
        img_landscape_sub: '800×600 px',
        img_portrait: 'Portrait 3:4',
        img_portrait_sub: '600×800 px',
        img_no_resize: 'No resize',
        img_no_resize_sub: 'Original dimensions',
        compress: 'Compression',
        compress_hint: 'Reduce file size',
        quality: 'Quality',
        daily_credits: 'AI credits today',
        remaining: '{{n}} remaining',
        reset_in: 'Reset in',
        running: 'In progress — {{done}}/{{total}} products',
        run_now: 'Run Now',
        run_desc: 'Optimize items with score < {{threshold}} in: {{scope}}',
        preview_title: 'Preview — Before / After',
        before: 'Before',
        after: 'After AI',
        no_keywords: 'no keywords',
        preview_note: 'Example on product «Running Shoe Pro X1» — instant update',
        alt_mode_label: 'ALT text generation mode',
        alt_preview: 'Preview',
        alt_mode_ai: 'Smart AI',
        alt_mode_ai_desc: 'OpenAI generates optimized ALT for each image',
        alt_mode_template: 'Free template',
        alt_mode_template_desc: 'No AI credits — uses the template below',
        alt_mode_auto: 'Auto fallback',
        alt_mode_auto_desc: 'AI when available, template if credits exhausted',
        alt_hint_template: 'Free mode: no AI credits consumed for ALT text.',
        alt_hint_auto: 'Auto fallback: AI if credits available, otherwise automatic template.',
        pct_done: '{{pct}}% complete',
        n_errors: '{{n}} errors',
        alt_template_label: 'Custom template',
        alt_vars_label: 'Available variables — click to insert',
      },
      piano: {
        credits_title: 'Credit Usage',
        plan_label: 'Plan',
        extra_credits: 'Extra Credits',
        unlimited: '∞ Unlimited credits',
        unlimited_sub: 'Elite plan — no monthly limit',
        plan_credits: 'Plan credits',
        consumed: 'Consumed from plan',
        residual: 'Plan remaining',
        extra_available: 'Extra credits available',
        extra_sub: 'Consumed only after monthly plan',
        total_available: 'Total Available',
        consumed_cycle: 'Credits consumed in current cycle',
        status_active: 'Active',
        status_pending: 'Processing',
        status_frozen: '⚠ Suspended',
        status_free: 'Free / No subscription',
        trial_active: 'Trial active',
        trial_access: 'full access until {{date}}.',
        reinstall_banner_title: 'Previous plan detected',
        reinstall_banner_desc: 'Your existing Shopify subscription is being reconciled. Please wait for it to complete before changing plans.',
        sub_status: 'Subscription status',
        next_credit_reset: 'Next credit reset',
        trial_end: 'Trial end',
        trial_label: 'Free trial',
        trial_used: 'Already used',
        trial_available: '{{n}} days available',
        cancel_btn: 'Cancel subscription',
        cancelling: 'Cancelling...',
        plans_title: 'Available Plans',
        plan_active: 'Active Plan',
        plan_current: 'Current Plan',
        per_month: '/month',
        downgrade: 'Back to Free',
        downgrading: 'Downgrading...',
        upgrade: 'Upgrade',
        downgrade_btn: 'Downgrade',
        redirecting: 'Redirecting...',
        trial_btn: 'Try free',
        trial_btn_days: '({{n}}d)',
        plan_overage: 'Additional AI credits: {{price}} per credit',
        plan_no_overage: 'No AI credit overage charges',
        plan_trial_line: '{{n}}-day free trial',
        plans_note: 'Paid plans include a {{n}}-day free trial. No activation fee. Payments are managed by Shopify Billing.',
        credits_section: 'Buy Extra Credits',
        credits_desc: 'Extra credits are added to your monthly plan and never expire. Compatible with all plans.',
        one_time: 'one-time',
        per_credit: '¢ per credit',
        buy: 'Buy',
        payment_note: 'Payment is processed securely via Shopify Billing. No payment data is stored on our server.',
        history_title: 'Credit Purchase History',
        history_count: '{{n}} purchase{{suffix}}',
        hist_invested: 'Total invested',
        hist_bought: 'Credits purchased',
        hist_available: 'Still available',
        hist_empty: 'No extra credit purchases made.',
        hist_date: 'Date',
        hist_pkg: 'Package',
        hist_credits: 'Credits',
        hist_amount: 'Amount',
        hist_status: 'Status',
        hist_completed: 'Completed',
        hist_pending: 'Pending',
        hist_declined: 'Declined',
        trend_title: 'Usage Trend',
        trend_placeholder: 'Usage chart (available with Shopify Billing)',
        stats_products: 'Products Analyzed',
        stats_content: 'Content Generated',
        stats_translations: 'Translations',
        stats_images: 'Images Optimized',
        toast_sub_pending: 'Subscription processing — you will receive a confirmation shortly.',
        toast_sub_activated: '{{name}} activated!',
        toast_trial_suffix: '({{n}} days free trial)',
        toast_sub_error: 'Subscription verification error',
        toast_purchase_duplicate: 'Purchase already recorded.',
        toast_credits_added: '+{{n}} credits added to your account!',
        toast_purchase_error: 'Purchase verification error',
        toast_purchase_start_error: 'Error starting purchase',
        toast_sub_start_error: 'Error starting subscription',
        toast_store_unavailable: 'Store not connected yet. Reload the app in Shopify Admin and try again.',
        toast_sub_cancelled: 'Subscription cancelled. Plan returned to Free.',
        toast_sub_cancel_error: 'Subscription cancellation error',
        pkg_100_label: '100 Credits',
        pkg_100_desc: 'Ideal for occasional use',
        pkg_300_label: '300 Credits',
        pkg_300_desc: 'Save 17%',
        pkg_300_badge: '⭐ Most popular',
        pkg_700_label: '700 Credits',
        pkg_700_desc: 'Save 29%',
        pkg_1500_label: '1,500 Credits',
        pkg_1500_desc: 'Save 33%',
        pkg_1500_badge: '🔥 Best value',
        plan_starter_badge: '⭐ Most Popular',
        plan_starter_benefit: 'Save hours of work every month.',
        plan_pro_badge: '🔥 SEO Growth',
        plan_pro_benefit: 'Improve indexing and SEO performance.',
        plan_elite_badge: '🚀 Agencies',
        plan_elite_benefit: 'Designed for agencies and enterprise catalogs.',
      },
      toast: {
        saved_at: 'Saved at {{time}}',
        save_error: 'Save error',
        budget_exceeded: 'Daily credit exhausted — {{done}} products optimized out of {{total}}',
        autopilot_stopped: 'Autopilot stopped — {{done}} products optimized out of {{total}}',
        images_optimized: 'Images optimized — {{n}} products',
        images_failed: '{{n}} images not optimized',
        autopilot_done: 'Autopilot completed — {{started}} products queued',
        autopilot_empty: 'No items below the threshold',
        autopilot_stopping: 'Autopilot stopping...',
        reindex_started: 'Re-indexing started',
        resync_started: 'Re-sync started',
        cache_cleared: 'Cache cleared',
        sync_reset: 'Sync state reset',
      },
      advanced: {
        warning: 'The following actions affect system behavior. Use only if necessary.',
        sync_title: 'Synchronization',
        reindex: 'Re-index Products',
        reindex_desc: 'Recalculate SEO data for all products in the database',
        resync: 'Re-sync with Shopify',
        resync_desc: 'Force complete synchronization of products and collections',
        cache_title: 'Cache',
        clear_cache: 'Clear Application Cache',
        clear_cache_desc: 'Clears in-progress batches in the browser. Incomplete operations will be lost.',
        reset_credits: 'Reset Daily Credits',
        reset_credits_desc: 'Reset today\'s AI credit counter (dev). Current limit: 5,000/day.',
        danger_zone: 'Danger Zone',
        reset_sync: 'Reset Sync State',
        reset_sync_desc: 'Force sync reset. Use only if sync has been stuck for more than 30 minutes.',
      },
    },
    ai_engine: {
      preset: {
        growth_desc: 'Maximize conversions and engagement',
        luxury_desc: 'Premium brand and exclusive narrative',
        seo_desc: 'Maximize organic visibility on Google',
        balanced_desc: 'Optimal balance between quality and SEO',
      },
      tone: {
        professional: 'Professional',
        professional_desc: 'Formal, authoritative, builds trust',
        luxury: 'Luxury',
        luxury_desc: 'Elegant, exclusive, premium',
        technical: 'Technical',
        technical_desc: 'Precise, specs, measurable data',
        conversational: 'Conversational',
        conversational_desc: 'Direct, friendly, engaging',
      },
      frequency: {
        daily: 'Daily',
        daily_desc: '1× per day',
        hourly: 'Hourly',
        hourly_desc: 'Continuous',
        realtime: 'Immediate',
        realtime_desc: 'As soon as possible',
      },
      scope: {
        products: 'Products',
        collections: 'Collections',
        articles: 'Articles',
        pages: 'Pages',
      },
      trigger: {
        seo_score: 'Low SEO Score',
        missing_meta: 'Missing Metadata',
        missing_alt: 'Missing ALT text',
        outdated_desc: 'Outdated description',
        keywords: 'Missing keywords',
        image_quality: 'Unoptimized images',
      },
    },
    appearance: {
      title: 'Appearance',
      theme_title: 'Theme',
      theme: {
        light: 'Light',
        dark: 'Dark',
        system: 'System',
      },
      density_title: 'Layout Density',
      density: {
        compact: 'Compact',
        comfortable: 'Comfortable',
        spacious: 'Spacious',
        compact_desc: 'More content',
        comfortable_desc: 'Balanced',
        spacious_desc: 'More breathing room',
      },
      sidebar_title: 'Sidebar',
      sidebar: {
        expanded: 'Expanded',
        collapsed: 'Collapsed',
        hidden: 'Hidden',
        expanded_desc: 'Always visible',
        collapsed_desc: 'Icons only',
        hidden_desc: 'On hover',
      },
    },
    localization: {
      ui_language: 'Interface Language',
      select_language: 'Select the app language',
      reload_note: 'Language is applied immediately',
    },
    dashboard: {
      title: 'Overview',
      subtitle: 'Store activity summary',
      products: 'Products',
      optimized: 'Optimized',
      pending: 'Pending',
      seo_score: 'SEO Score',
      audit_center: 'Audit Center',
      sync_products: 'Sync Products',
      analyze_products: 'Analyze Products',
      audit_site: 'Site Audit 360',
      syncing: 'Syncing...',
      analyzing: 'Analyzing...',
      auditing: 'Auditing...',
      section_account: 'Account & Plan',
      section_catalog: 'Catalog Status',
      section_images: 'Images',
      section_seo_tech: 'Technical SEO — Detailed Site Audit',
      section_ux_trust: 'UX & Trust — Highlights',
      section_actions: 'AI Recommended Actions',
      recent_activity: 'Recent Activity',
      hint_plan: 'Plan and credit status',
      hint_never_synced: 'Never synced',
      hint_priority: 'Sorted by priority',
      hint_last_sync: 'Last sync {{date}}',
      current_plan: 'Current Plan',
      credits_used: 'Credits Used',
      credits_remaining: 'Credits Remaining',
      public_domain: 'Public Domain',
      credit_usage: 'Credit usage',
      hint_installed: 'Installed {{date}}',
      hint_pct_plan: '{{pct}}% of plan',
      hint_limit: 'Limit {{n}}',
      hint_last_audit: 'Last audit {{date}}',
      hint_no_audit: 'Audit not run',
      no_audit: 'No audit run',
      no_audit_desc: 'Run an audit to analyze title, meta, H1, canonical, robots, sitemap, HTTPS, OG, JSON-LD, performance, images and links.',
      run_audit: 'Run Audit',
      in_progress: 'In progress...',
      audit_phase: 'Audit in progress (phase: {{phase}})...',
      ux_highlights: 'UX Highlights',
      trust_compliance: 'Trust & Compliance',
      mobile_viewport: 'Mobile viewport:',
      favicon: 'Favicon:',
      images_without_alt_label: 'Images without ALT:',
      lazy_loading: 'Lazy loading:',
      images_suffix: 'images',
      internal_links: 'Internal links:',
      data_unavailable: 'Data unavailable: {{reason}}',
      analysis_not_run: 'Analysis not run',
      not_detected: 'Not detected',
      no_trust_data: 'No trust data available',
      no_activity: 'No recent activity.',
      activity_completed: 'Completed',
      activity_error: 'Error',
      no_store_title: 'No Store Connected',
      no_store_desc: 'Install the app on a Shopify store to get started',
      connect_store: 'Connect Shopify Store',
      no_token_title: 'OAuth Token Missing',
      no_token_desc: 'Store {{domain}} is registered but has no token. Reinstall the app.',
      reinstall_app: 'Reinstall App via OAuth',
      sync_in_progress: 'Product sync in progress…',
      sync_in_progress_detail: '{{synced}} / {{total}} products. Dashboard data will update when sync completes.',
      stale_data: 'Stale data: showing last valid numbers while sync is running.',
      catalog_score_label: 'Catalog Score',
      seo_distribution: 'SEO Distribution',
      n_products: '{{n}} products',
      pct_of_catalog: '{{pct}}% of catalog',
      no_description: 'No description',
      no_meta_description: 'No meta description',
      seo_needs_improvement: 'SEO needs improvement',
      view: 'View',
      seo_good_desc: 'The catalog has good SEO coverage. Keep the standard high by optimizing new products.',
      seo_medium_desc: 'The catalog has medium SEO coverage. Priority: meta descriptions and product descriptions.',
      seo_poor_desc: 'The catalog has low SEO coverage. Priority: meta descriptions, descriptions and missing images.',
      seo_optimized: 'Optimized',
      seo_medium: 'Medium',
      seo_poor: 'Needs improvement',
      content_seo_title: 'SEO status by content type',
      open_catalog: 'Open Catalog',
      row_collections: 'Collections',
      row_articles: 'Articles',
      row_pages: 'Pages',
      coming_soon: 'Coming soon',
      not_synced: 'Not synced',
      seo_coverage_fmt: '{{opt}}/{{total}} optimized · {{score}}/100',
      alt_coverage: 'ALT text coverage',
      with_alt_count: '{{n}} with ALT out of {{total}}',
      image_optimization_label: 'Image optimization',
      optimized_count: '{{n}} optimized out of {{total}}',
      with_alt: 'With ALT',
      without_alt: 'Without ALT',
      image_optimized: 'Optimized',
      image_needs_improvement: 'Needs improvement',
      no_image: 'No image',
      savings: 'Savings',
      optimize_images_btn: 'Optimize images',
      view_no_image: 'View products without image',
      alt_manager: 'ALT Text Manager',
      toast_sync_done: 'Sync complete. Reconciling catalog...',
      toast_catalog_reconciled: 'Catalog reconciled: {{n}} products (removed {{removed}} orphans)',
      toast_sync_first: 'Sync products first',
      toast_avg_score: 'Average score {{score}}/100',
      toast_audit_done: 'Audit complete: {{score}}/100',
      toast_sync_reset: 'Sync state reset',
      toast_sync_reset_error: 'Unable to reset sync state',
      op_description: 'AI Description',
      op_seo_title: 'SEO Title',
      op_meta_description: 'Meta Description',
      op_keywords: 'Keywords',
      op_translation: 'Translation',
      op_image_opt: 'Image Optimization',
      op_sync: 'Shopify Sync',
      op_seo_analysis: 'Store SEO Analysis',
      op_site_audit: 'Site Audit 360',
      prompt_domain: 'Enter your Shopify store domain',
      hint_force_reset: 'Force sync state reset (does not delete products)',
    },
    products: {
      title: 'Product Catalog',
      search: 'Search products...',
      all: 'All',
      optimized: 'Optimized',
      pending: 'Pending',
      status_generating: 'Generating',
      status_writing: 'Writing',
      status_validating: 'Validating',
      status_failed: 'Failed',
      status_sync_failed: 'Shopify Sync',
      status_optimized: 'Optimized',
      status_medium: 'Medium',
      status_needs_improvement: 'Needs Improvement',
      type_collection_singular: 'collection',
      type_collection_plural: 'collections',
      sync_collections: 'Sync Collections',
      empty_collections: 'No collections. Click "Sync Collections" to import from Shopify.',
      search_collections: 'Search collection by title or handle...',
      col_label_products: 'Products',
      type_article_singular: 'article',
      type_article_plural: 'articles',
      sync_articles: 'Sync Articles',
      empty_articles: 'No articles. Click "Sync Articles" to import from Shopify.',
      search_articles: 'Search article by title, handle or blog...',
      col_label_blog: 'Blog',
      type_page_singular: 'page',
      type_page_plural: 'pages',
      sync_pages: 'Sync Pages',
      empty_pages: 'No pages. Click "Sync Pages" to import from Shopify.',
      search_pages: 'Search page by title or handle...',
      col_label_author: 'Author',
      catalog_title: 'Catalog',
      no_store: 'No Store',
      tab_products: 'Products',
      tab_collections: 'Collections',
      tab_articles: 'Articles',
      tab_pages: 'Pages',
      sort_updated: 'Updated',
      sort_seo_score: 'SEO Score',
      sort_title: 'Title',
      sort_vendor: 'Vendor',
      sort_created: 'Created',
      sort_desc: 'Descending',
      sort_asc: 'Ascending',
      filter_seo_all: 'SEO: all',
      filter_optimized: 'Optimized',
      filter_medium: 'Medium',
      filter_needs_improvement: 'Needs improvement',
      filter_image_all: 'Images: all',
      filter_image_yes: 'With images',
      filter_image_no: 'Without images',
      filter_meta_all: 'Meta: all',
      filter_meta_yes: 'With meta',
      filter_meta_no: 'Without meta',
      filter_desc_all: 'Description: all',
      filter_desc_yes: 'With description',
      filter_desc_no: 'Without description',
      filter_vendor_all: 'Vendor: all',
      filter_collection_all: 'Collection: all',
      filter_type_all: 'Type: all',
      reset_filters: 'Reset filters',
      th_image: 'Image',
      th_title: 'Title',
      th_seo_score: 'SEO Score',
      th_alt: 'ALT',
      th_meta: 'Meta',
      th_status: 'Status',
      th_actions: 'Actions',
      no_products_filters: 'No products found with these filters',
      no_products: 'No products. Sync from your Shopify store.',
      pagination: 'Page {{page}} of {{total}} · {{count}} products',
      batch_btn: 'Batch Operations',
      dialog_status: 'Status',
      dialog_seo_score: 'SEO Score',
      dialog_shopify_id: 'Shopify ID',
      dialog_vendor: 'Vendor',
      dialog_serp: 'SERP Preview',
      dialog_issues: 'SEO Issues',
      dialog_suggestions: 'Suggestions',
      generating: 'Generating...',
      generate_all: 'Generate All Content',
      action_generate_ai: 'Generate AI Content',
      action_translate: 'Translate',
      action_optimize_image: 'Optimize Image',
      syncing: 'Syncing...',
      draft_ready: 'Draft ready',
      seo_ai_btn: 'SEO AI',
      batch_ops_btn: 'Batch Operations',
      diagnosis: 'Diagnostics',
      current_score: 'Current score',
      projected: '→ projected {{score}}/100',
      meta_title: 'Meta Title',
      meta_desc_label: 'Meta Description',
      description_label: 'Description',
      generate_desc_btn: 'Generate AI description',
      generating_desc: 'Generating...',
      generate_ai_btn: 'Generate with AI',
      publish_shopify_btn: 'Publish to Shopify',
      publishing: 'Publishing...',
      discard_draft_btn: 'Discard draft',
      seo_ai_dialog_title: 'SEO AI',
      seo_all: 'SEO: all',
      seo_optimized: 'Optimized',
      seo_medium: 'Medium',
      seo_needs: 'Needs improvement',
      page_of: 'Page {{page}} of {{total}}',
      search_placeholder: 'Search by title, SKU, EAN, vendor, handle...',
      chars_count: '{{n}}/{{max}} characters',
      n_selected_info: 'selected',
      filtered: 'filtered',
      soon_tooltip: 'Coming soon',
      resource_subtitle: '{{type}} Shopify and their SEO status',
      articles_blog: 'Articles (blog)',
      select_visible_title: 'Select/deselect all visible',
      toast_draft_ready: 'SEO draft generated. Review and publish.',
      toast_error_ai: 'AI generation error',
      toast_desc_generated: 'AI description generated.',
      toast_error_desc: 'Description generation error',
      toast_empty_draft: 'Generate or enter at least one field (meta title, meta description or description)',
      toast_published_score: 'Published to Shopify · Score {{score}}/100',
      toast_error_publish: 'Error publishing to Shopify',
      toast_draft_discarded: 'Draft discarded',
      toast_select_items: 'Select at least one item',
      toast_mode_publish: 'Publishing',
      toast_mode_both: 'Generate+Publish',
      toast_mode_generate: 'AI SEO Generation',
      toast_batch_launched: '{{label}} started on {{count}} {{type}}. You can change section.',
      toast_batch_errors: '{{label}} completed with {{count}} errors',
      toast_batch_done: '{{label}} completed on {{count}} {{type}}',
      toast_synced: '{{type}} synced: {{count}}',
      toast_sync_error: 'Sync error {{type}}',
      toast_token_error: 'Shopify token expired or missing permissions: click to reinstall',
      reinstall_label: 'Reinstall',
      toast_sync_started: '{{type}} sync started',
      toast_error_sync_start: 'Error starting sync',
      toast_perms_ok: 'Permissions ok ({{kind}})',
      toast_token_revoked: 'Token revoked',
      toast_perms_missing: 'Missing permissions',
      toast_diag_error: 'Diagnostic error',
      toast_score: 'Score {{score}}/100',
      toast_error_analyze: 'Analysis error',
      toast_generated: 'Content generated',
      toast_error_generate: 'Generation error',
    },
    content: {
      title: 'Content Generation',
      generate: 'Generate Content',
      language: 'Language',
      tone: 'Tone',
      subtitle: 'Generate descriptions, SEO title, meta description and keywords with AI',
      tab_products: 'Products',
      tab_collections: 'Collections',
      tab_articles: 'Articles',
      tab_pages: 'Pages',
      type_description_label: 'Description',
      type_description_hint: 'Engaging and SEO-friendly product text',
      type_seo_title_label: 'SEO Title',
      type_seo_title_hint: 'SERP-optimized title (max 60 chars)',
      type_meta_desc_label: 'Meta Description',
      type_meta_desc_hint: 'Google snippet (max 160 chars)',
      type_keywords_label: 'Keywords',
      type_keywords_hint: 'Primary and secondary keywords',
      type_body_label: 'Description / Body',
      type_body_hint: 'Main resource text',
      filter_all: 'All',
      filter_needs: 'Needs improvement',
      filter_medium: 'Medium',
      filter_optimized: 'Optimized',
      no_results_filters: 'No items match the filters',
      select_all: 'Select all',
      deselect: 'Deselect',
      selected_count: '{{count}} selected',
      selected_max: '(max)',
      deselect_all: 'Deselect all',
      pagination_of: '{{page}} / {{total}}',
      total_count: '({{count}} total)',
      content_type_section: 'Content Type',
      batch_generating: 'Generating… {{done}}/{{total}}',
      batch_generate_btn: 'Generate Batch ({{count}})',
      generating_count: 'Generate ({{count}})',
      generate_btn: 'Generate',
      generating: 'Generating…',
      generate_all_btn: 'All',
      hint_select: '← Select an item or tick multiple items for batch',
      hint_batch_ready: '{{count}} item(s) ready for batch',
      batch_done_title: '✓ Batch completed',
      batch_pending_title: 'Batch pending…',
      batch_in_progress_title: 'Batch Generation in progress…',
      batch_done_msg: 'All content generated. Selection will be cleared automatically.',
      results_section: 'Results',
      publishing: 'Publishing…',
      published: 'Published',
      publish_btn: 'Publish to Shopify',
      clear_results: 'Clear',
      chars_unit: 'chars',
      cache_label: 'cache',
      preview_section: 'Current preview',
      loading_detail: 'Loading detail…',
      not_present: 'Not present',
      not_present_plural: 'Not present',
      empty_state: 'Click an item to view it, or tick multiple items and use Generate Batch',
      copy_btn: 'Copy',
      type_seo_title_hint_content: 'Meta title for SERP (max 60 chars)',
      no_items: 'No {{type}} found',
      item_deselect: 'Deselect',
      item_select: 'Add to selection',
      generate_all_title: 'Generate all available types',
      prev_item: 'Previous item',
      next_item: 'Next item',
      toast_load_error: 'Error loading items',
      toast_batch_done: 'Batch completed: {{done}}/{{total}} products',
      toast_batch_failed: 'Batch failed: {{failed}} errors out of {{total}}',
      toast_batch_cancelled: 'Batch cancelled',
      toast_batch_resumed: 'Active batch resumed…',
      toast_max_select: 'Maximum {{max}} items selectable',
      toast_select_item: 'Select an item from the list',
      toast_select_type: 'Select at least one content type',
      toast_from_cache: 'Content from cache!',
      toast_generated: 'Generated successfully!',
      toast_generate_error: 'Error generating content',
      toast_batch_running: 'A batch process is already running',
      toast_no_store: 'Store not available',
      toast_batch_started: 'Batch started: {{n}} products queued',
      toast_batch_start_error: 'Error starting batch',
      toast_batch_item_error: 'Generation error: {{title}}',
      toast_batch_complete: 'Batch completed: {{done}}/{{total}} items',
      toast_cancel_error: 'Error cancelling batch',
      toast_published: 'Content published to Shopify!',
      toast_publish_error: 'Error publishing content',
      toast_copied: 'Copied to clipboard',
      present: 'present',
      missing: 'missing',
      lang_it: 'Italian',
      lang_en: 'English',
      lang_fr: 'French',
      lang_de: 'German',
      lang_es: 'Spanish',
      lang_pt: 'Portuguese',
      tone_professional: 'Professional',
      tone_luxury: 'Luxury',
      tone_technical: 'Technical',
      tone_conversational: 'Conversational',
    },
    images: {
      title: 'Image Optimization',
      optimize: 'Optimize',
      format: 'Format',
      compress: 'Compress',
      quality: 'Quality',
      alt_mode_label: 'ALT generation mode',
      alt_mode_ai: 'AI intelligent',
      alt_mode_template: 'Free template',
      alt_mode_auto: 'Auto fallback',
      subtitle: 'Optimize images, manage ALT text and publish to Shopify.',
      tab_optimize: 'Optimize Images',
      tab_alt: 'ALT Text',
      alt_coverage: 'ALT Coverage',
      with_alt_count: 'with ALT out of',
      stat_with_alt: 'With ALT: {{count}}',
      stat_without_alt: 'Without ALT: {{count}}',
      stat_no_image: 'Without image: {{count}}',
      sync_alt_btn: 'Update ALT data from Shopify',
      syncing_alt: 'Updating ALT...',
      sync_status_label: 'Status:',
      analyzed_label: 'Analyzed:',
      last_updated_label: 'Last update:',
      stalled: 'stalled',
      force_stop: 'Force stop (stalled for 60s)',
      free_badge: '● Free — no credits',
      configure_btn: '▼ Configure',
      hide_btn: '▲ Hide',
      template_free_hint: 'Free mode active — zero AI credits. Template:',
      template_auto_hint: 'Auto fallback — AI if credits available, local template if exhausted.',
      template_config_title: 'Configure ALT Template',
      template_label: 'Custom template',
      template_preview: 'Preview:',
      variables_label: 'Available variables — click to insert:',
      restore_default: 'Restore default',
      save_config: 'Save configuration',
      saving: 'Saving...',
      search_placeholder: 'Search by title, vendor, handle...',
      filter_all_images: 'All',
      filter_with_alt: 'With ALT',
      filter_without_alt: 'Without ALT',
      selected_images: '{{count}} images selected (max 50 per batch)',
      generate_batch_btn: 'Generate ALT for selected',
      batch_alt_in_progress: 'ALT Batch in progress: {{done}} / {{total}}',
      batch_errors: '{{n}} errors',
      select_all_label: 'Select all',
      deselect_all_label: 'Deselect all',
      total_products_label: '{{count}} products',
      timeout_title: 'Loading took too long (20s)',
      timeout_desc: 'The database is processing many products. Try again in a few seconds.',
      error_title: 'List loading error',
      no_products_filter: 'No products matching the filters',
      alt_placeholder: 'ALT text (max 125 characters)',
      status_published: 'Published',
      status_saved: 'Saved',
      status_draft_alt: 'Draft',
      status_missing: 'No ALT',
      generate_alt_btn: 'Generate ALT',
      save_alt_btn: 'Save ALT',
      publish_alt_btn: 'Publish',
      prec: 'Prev',
      succ: 'Next',
      select_products: 'Select Products',
      filter_collection_all: 'Collection: all',
      filter_vendor_all: 'Vendor: all',
      filter_kb_all: 'KB: all',
      filter_kb_100: 'Files over 100 KB',
      filter_kb_500: 'Files over 500 KB',
      filter_kb_1mb: 'Files over 1 MB',
      filter_format_all: 'Format: all',
      filter_landscape: 'Width greater than Height',
      filter_portrait: 'Height greater than Width',
      filter_square: 'Square',
      filter_status_all: 'Status: all',
      filter_status_optimized: 'Already optimized',
      filter_status_needs: 'To optimize',
      visible_total: '{{visible}} visible · {{total}} total',
      reset_filters: 'Reset filters',
      clear_selection: 'Clear selection',
      no_image_products: 'No products with image',
      ready_badge: 'Ready',
      settings_title: 'Settings',
      format_title: 'Image Format',
      format_square: 'Square 1:1',
      format_landscape: 'Landscape 4:3',
      format_portrait: 'Portrait 3:4',
      format_none: 'No resize',
      format_none_sub: 'Original dimensions',
      compress_label: 'Compression',
      compress_desc: 'Reduce file size',
      quality_label: 'Quality',
      batch_opt_running: 'Optimization in progress',
      batch_opt_cancelled: 'Optimization cancelled',
      batch_opt_completed: 'Optimization completed',
      batch_apply_running: 'Application in progress',
      batch_apply_cancelled: 'Application cancelled',
      batch_apply_completed: 'Application completed',
      background_note: 'You can change section, continues in background',
      optimizing: 'Optimizing...',
      optimize_n: 'Optimize {{count}} images',
      optimize_one: 'Optimize Image',
      applying: 'Applying...',
      apply_n: 'Apply {{count}} to Shopify',
      apply_one: 'Apply to Shopify',
      preview_title: 'Preview',
      ready_optimizations: '{{count}} optimizations ready',
      select_preview_hint: 'Select one or more products to see the preview',
      first_product_preview: 'Preview shown for the first selected product:',
      original_label: 'Original',
      optimized_label: 'Optimized',
      optimize_click_hint: 'Click "Optimize" for the result',
      reduction_label: 'Reduction',
      apply_btn: 'Apply',
      history_opt_title: 'Optimization history',
      history_opt_subtitle: 'Operations applied to Shopify, errors and restores.',
      stat_running_label: 'Running',
      stat_completed_label: 'Completed',
      stat_errors_label: 'Incomplete',
      stat_undo_label: 'Undo',
      total_savings: 'Total savings',
      history_loading: 'Loading history...',
      no_history: 'No operations applied yet.',
      restoring: 'Restoring...',
      undo_btn: 'Undo',
      kb_warning: 'KB size is not in local data. To make it accurate it needs to be saved by the backend during image sync.',
      senza_vendor: 'No vendor',
      alt_stat_coverage: '{{n}} with ALT out of {{total}}',
      apply_batch_cancelled: 'Application cancelled',
      apply_batch_done_label: 'Application completed',
      apply_batch_running: 'Application in progress',
      apply_n_btn: 'Apply {{n}} to Shopify',
      applying_btn: 'Applying...',
      auto_fallback_hint: 'Auto fallback — AI if credits available, local template if exhausted.',
      background_hint: 'You can change section, continues in background',
      badge_draft: 'Draft',
      badge_missing: 'No ALT',
      badge_published: 'Published',
      badge_ready: 'Ready',
      badge_saved: 'Saved',
      batch_close: 'Close',
      batch_generate_btn: 'Generate ALT for selected',
      batch_progress: 'ALT Batch in progress: {{done}} / {{total}}',
      batch_selected: '{{n}} images selected (max 50 per batch)',
      collection_all: 'Collection: all',
      compress_sub: 'Reduce file size',
      config_btn: '▼ Configure',
      deselect_all: 'Deselect all',
      empty_filtered: 'No products matching the filters',
      filter_all: 'All',
      format_label: 'Image Format',
      gen_alt_btn: 'Generate ALT',
      history_completed: 'Completed',
      history_empty: 'No operations applied yet.',
      history_incomplete: 'Incomplete',
      history_running: 'Running',
      history_savings: 'Total savings',
      history_subtitle: 'Operations applied to Shopify, errors and restores.',
      history_title: 'Optimization history',
      history_undo_label: 'Undo',
      last_update_label: 'Last update:',
      load_error: 'List loading error',
      n_errors: '{{n}} errors',
      n_products: '{{n}} products',
      n_selected: '{{n}} selected',
      next_page: 'Next',
      no_products: 'No products with image',
      no_vendor: 'No vendor',
      opt_batch_cancelled: 'Optimization cancelled',
      opt_batch_done: 'Optimization completed',
      opt_batch_running: 'Optimization in progress',
      optimize_n_btn: 'Optimize {{n}} images',
      optimize_one_btn: 'Optimize Image',
      optimizing_btn: 'Optimizing...',
      orientation_all: 'Format: all',
      orientation_landscape: 'Width greater than Height',
      orientation_portrait: 'Height greater than Width',
      orientation_square: 'Square',
      page_info: 'Page {{page}} of {{total}}',
      pagination: 'Page {{page}} of {{total}}',
      prev: 'Prev',
      publish_btn: 'Publish',
      retry: 'Retry',
      select_all: 'Select all',
      size_100kb: 'Files over 100 KB',
      size_1mb: 'Files over 1 MB',
      size_500kb: 'Files over 500 KB',
      size_all: 'KB: all',
      status_all: 'Status: all',
      status_label: 'Status:',
      status_needs: 'To optimize',
      status_optimized: 'Already optimized',
      status_stalled: 'stalled',
      sync_btn: 'Update ALT data from Shopify',
      sync_btn_title: 'Re-reads images and ALT texts from Shopify',
      syncing: 'Updating ALT...',
      template_active: 'Free mode active — zero AI credits. Template:',
      template_custom_label: 'Custom template',
      template_free_badge: '● Free — no credits',
      template_preview_label: 'Preview:',
      template_reset: 'Restore default',
      template_save: 'Save configuration',
      template_saving: 'Saving...',
      template_vars_label: 'Available variables — click to insert:',
      timeout_msg: 'The database is processing many products. Try again in a few seconds.',
      toast_alt_ai: 'ALT generated via AI',
      toast_alt_cancelled: 'ALT update cancelled — you can restart it',
      toast_alt_empty: 'Empty ALT',
      toast_alt_from_cache: 'ALT from cache',
      toast_alt_gen_error: 'ALT generation error',
      toast_alt_publish_error: 'Publish error',
      toast_alt_published: 'Published to Shopify',
      toast_alt_save_error: 'Save error',
      toast_alt_saved: 'ALT saved',
      toast_alt_sync_start_error: 'Error starting ALT update',
      toast_alt_sync_started: 'ALT data update started',
      toast_alt_template: 'ALT generated via template (free)',
      toast_alt_template_fallback: 'ALT via template (credits exhausted)',
      toast_alt_update_error: 'ALT update error',
      toast_alt_updated: 'ALT data updated: {{n}} products analyzed',
      toast_applied: 'Image applied to Shopify',
      toast_apply_batch_done: 'Applied {{n}} images to Shopify',
      toast_apply_batch_errors: 'Apply completed with {{n}} errors',
      toast_apply_batch_started: 'Apply started: {{n}} images. You can change section.',
      toast_batch_alt_done: 'Batch completed',
      toast_batch_alt_started: 'Batch started: {{n}} images, {{c}} at a time',
      toast_batch_done: 'Batch completed: {{n}} images optimized. You can apply them to Shopify.',
      toast_batch_errors: '{{n}} images not processed. Retry or check logs.',
      toast_batch_started: 'Batch started: {{n}} images. You can change section, continues in background.',
      toast_cancel_error: 'Cancellation error',
      toast_no_draft: 'No optimized image to apply',
      toast_no_images: 'No image selected',
      toast_no_ready: 'No optimization ready to apply',
      toast_no_store: 'Store not available',
      toast_optimize_error: 'Optimization error',
      toast_optimized: 'Image optimized. You can now apply it to Shopify.',
      toast_select_product: 'Select at least one product',
      toast_template_save_error: 'Template save error',
      toast_template_saved: 'Template configuration saved',
      toast_undo_done: 'Original image restored',
      toast_undo_error: 'Error during restore',
      undoing_btn: 'Restoring...',
      vendor_all: 'Vendor: all',
      toast_no_product: 'Select a product',
      toast_no_image: 'The product has no image',
      toast_no_preview: 'Optimize an image first',
      toast_apply_error: 'Error applying to Shopify',
      n_ready: '{{n}} optimizations ready',
      preview_hint: 'Select one or more products to see the preview',
      preview_first: 'Preview shown for the first selected product:',
      click_optimize_hint: 'Click "Optimize" for the result',
      apply_single_btn: 'Apply',
    },
    alt_template: {
      section_title: 'ALT Template',
      mode_label: 'ALT text generation mode',
      textarea_label: 'Custom template',
      preview_label: 'Preview',
      vars_label: 'Available variables — click to insert',
      hint_template: 'Free mode: no AI credits used for ALT text.',
      hint_auto: 'Auto fallback: AI when credits available, otherwise automatic template.',
    },
    batch: {
      title: 'Batch Operations',
      start: 'Start',
      cancel: 'Cancel',
      subtitle: 'Persistent server-side processing — continues even if you change page or close the tab',
      locked_title: 'Batch Operations not available',
      locked_desc: 'Batch Operations are available from the Starter plan. Process hundreds of products in parallel with one click.',
      upgrade_btn: 'Upgrade to Starter',
      op_content_label: 'Generate AI Content',
      op_content_desc: 'Description, SEO title, meta description, keywords',
      op_translate_label: 'Translate Products',
      op_translate_desc: 'Full translation into selected language',
      op_images_label: 'Optimize Images',
      op_images_desc: '1:1 resize and image compression',
      field_description_label: 'Description',
      field_description_hint: '150-250 words',
      field_seo_title_label: 'SEO Title',
      field_seo_title_hint: 'max 60 characters',
      field_meta_desc_label: 'Meta Description',
      field_meta_desc_hint: '100-160 characters',
      field_keywords_label: 'Keywords',
      field_keywords_hint: '5-10 keywords',
      count_all: 'All',
      status_pending: 'Queued',
      status_running: 'Running',
      status_completed: 'Completed',
      status_failed_job: 'Failed',
      status_cancelled: 'Cancelled',
      opt_in_progress: 'Image optimization in progress…',
      batch_in_progress: 'AI Batch in progress…',
      images_progress: '{{done}} / {{total}} images',
      products_progress: '{{done}} / {{total}} products',
      errors_count: '{{count}} errors',
      duration_label: 'Duration: {{time}}',
      starting: 'Starting...',
      seo_gen_in_progress: 'Generate + Publish SEO in progress',
      gen_publish_auto: 'Automatic generation and publishing to Shopify',
      section_operation: 'Operation',
      section_fields: 'Fields to generate',
      fields_selected: '{{count}}/{{total}} selected',
      fields_warning: 'Select at least one field to start the batch',
      fields_hint: 'One AI call per product generates all selected fields — lower latency and reduced costs.',
      section_options: 'Options',
      label_language: 'Language',
      label_tone: 'Tone',
      tone_professional: 'Professional',
      tone_luxury: 'Luxury',
      tone_technical: 'Technical',
      tone_conversational: 'Conversational',
      label_target_lang: 'Target Language',
      images_note: '1:1 resize (800×800) + 85% quality compression.',
      section_quantity: 'Product Quantity',
      available_count: '{{count}} available',
      catalog_selection: '{{count}} product(s) selected from Catalog',
      remove_selection: 'Remove selection',
      products_selected_count: '{{count}} product(s) selected',
      processing: 'Processing…',
      start_btn: 'Start Processing',
      history_title: 'Batch History',
      history_subtitle: 'updated from DB',
      stat_running: 'Running',
      stat_completed: 'Completed',
      stat_products_ok: 'Products OK',
      no_batch: 'No batch executed',
      no_batch_hint: 'Jobs will appear here after the first processing',
      job_content: 'Generate AI Content',
      job_translate: 'Translation',
      job_images: 'Image Optimization',
      job_products: '{{done}}/{{total}} products',
      log_lang: 'Language:',
      log_tone: 'Tone:',
      toast_completed: 'Batch completed: {{done}}/{{total}} products processed',
      toast_failed: 'Batch failed: {{count}} errors',
      toast_no_products: 'No products available',
      soon_lbl: 'soon',
      btn_analyze_seo: 'Analyze SEO',
      btn_view: 'View',
      toast_no_fields: 'Select at least one field to generate',
      toast_images_started: 'Image optimization started: {{count}} products',
      toast_started: 'Batch started: {{count}} products',
      toast_start_error: 'Error starting',
      toast_cancelled: 'Batch cancelled',
      toast_cancel_error: 'Cancellation error',
      fields_label: 'Fields',
      log_summary: 'Single operation logs',
    },
    history: {
      title: 'History',
      empty: 'No operations found',
      subtitle: 'Complete audit of all AI executions — {{n}} total operations',
      refresh_btn: 'Refresh',
      total_operations: 'Total Operations',
      success_rate: 'Success Rate',
      n_successes: '{{n}} successes',
      credits_today: 'Credits Today',
      products_today: 'Products Today',
      avg_duration: 'Avg Duration',
      last_autopilot: 'Last Autopilot',
      filters: 'Filters',
      filters_active: 'active',
      reset_all: 'Reset all',
      search_placeholder: 'Search product...',
      op_all: 'All types',
      op_description: 'AI Description',
      op_seo_title: 'SEO Title AI',
      op_meta_description: 'Meta Description AI',
      op_batch: 'Batch Generation',
      op_translation: 'Translation',
      op_image: 'Image',
      op_sync: 'Shopify Sync',
      trigger_all: 'All triggers',
      status_all: 'All statuses',
      status_success: 'Success',
      status_partial: 'Partial',
      status_error: 'Error',
      th_status: 'Status',
      th_type: 'Operation Type',
      th_product: 'Product',
      th_trigger: 'Trigger',
      th_seo_delta: 'SEO Delta',
      th_credits: 'Credits',
      th_duration: 'Duration',
      th_timestamp: 'Timestamp',
      loading: 'Loading...',
      remove_filters: 'Remove filters',
      load_more: 'Load more (showing {{shown}} of {{total}})',
      details_title: 'Execution Details',
      detail_op_id: 'Operation ID',
      detail_product_id: 'Product ID',
      detail_store_id: 'Store ID',
      detail_type: 'Type',
      detail_trigger: 'Trigger',
      detail_status: 'Status',
      detail_language: 'Language',
      detail_tone: 'Tone',
      detail_tokens: 'Tokens used',
      detail_fields: 'Fields',
      detail_credits: 'Credits',
      detail_duration: 'Duration',
      detail_seo_before: 'SEO before',
      detail_seo_after: 'SEO after',
      detail_timestamp: 'Timestamp',
      error_prefix: 'Error: ',
      label_description: 'AI Description',
      label_seo_title: 'SEO Title AI',
      label_meta_description: 'Meta Description AI',
      label_keywords: 'Keywords AI',
      label_batch: 'Batch Generation',
      label_translation: 'Translation',
      label_image: 'Image Optimization',
      label_sync: 'Shopify Sync',
      label_push: 'Shopify Publish',
    },
    batch_banner: {
      errors: 'errors',
      optimizing: 'Image optimization',
      optimizing_cancelled: 'Optimization cancelled',
      optimizing_completed: 'Optimization completed',
      applying: 'Applying to Shopify',
      applying_cancelled: 'Application cancelled',
      applying_completed: 'Application completed',
      open_images: 'Open Images',
      open_catalog: 'Open Catalog',
      type_collections: 'Collections',
      type_articles: 'Articles',
      type_pages: 'Pages',
      type_contents: 'Contents',
      mode_publish: 'Publishing',
      mode_both: 'Generate+Publish',
      mode_generate: 'AI SEO Generation',
      state_cancelled: '(cancelled)',
      state_completed: '(completed)',
    },
    app_banner: {
      expired: 'Shopify token expired or revoked.',
      reconnect_desc: 'Reconnect the app to restore sync and publishing.',
      detected_in: 'detected in',
      reconnect_btn: 'Reconnect now',
    },
    review_popup: {
      greeting: 'Hi! I am here 👋',
      subtitle: 'I hope everything is going great with AI Optimizer!',
      rating_title: 'Are you enjoying the app?',
      rating_desc: 'Your opinion helps us improve and reach other Shopify merchants.',
      rating_tap: 'Tap a star to rate',
      star: {
        terrible: 'Terrible',
        bad: 'Not good',
        average: 'Average',
        good: 'Good!',
        excellent: 'Excellent! 🚀',
      },
      positive_title: 'Fantastic! Thank you so much 🎉',
      positive_desc: 'A review on the Shopify App Store makes a huge difference for us. It only takes 1 minute!',
      negative_title: 'Thanks for the feedback 🙏',
      negative_desc: 'We work every day to improve. Do you have ideas on what we could do better?',
      review_btn: '⭐ Leave a review',
      close_btn: 'Close',
      dismiss: 'Do not show again',
      skip: 'Skip →',
    },
    support: {
      title: 'Support',
      send: 'Send',
      placeholder: 'Write your message...',
    },
    editor: {
      placeholder: 'Write here...',
      bold: 'Bold',
      italic: 'Italic',
      underline: 'Underline',
      h2: 'Heading H2',
      h3: 'Heading H3',
      paragraph: 'Paragraph',
      ul: 'Bullet list',
      ol: 'Numbered list',
      blockquote: 'Quote',
      link: 'Insert link',
      remove_format: 'Remove formatting',
      link_prompt: 'Link URL',
    },
    recommendations: {
      empty: 'No critical actions at the moment. Great job!',
      filter_all_prio: 'All priorities',
      filter_all_cat: 'All categories',
      count_shown: '{{n}} actions shown',
      see: 'View',
      sev_high: 'High',
      sev_medium: 'Medium',
      sev_low: 'Low',
      cat_catalog: 'Catalog',
      missing_meta_description: '{{count}} products without meta description',
      missing_description: '{{count}} products without description',
      missing_alt_text: '{{count}} images without ALT text',
      missing_product_image: '{{count}} products without image',
    },
    audit: {
      not_detected: 'Not detected',
      disabled: 'Disabled',
      not_scanned: 'Analysis not performed',
      status_warning: 'Warning',
      status_error: 'Error',
      cat_performance: 'Performance',
      cat_trust: 'Trust',
      cat_catalog: 'Catalog',
      checks_suffix: 'checks',
      badge_err: 'err',
      badge_warn: 'warn',
      badge_ok: 'ok',
      value_label: 'Value',
      checks: {
        title: { name: 'Title', hint: 'Page title' },
        meta_description: { name: 'Meta description', hint: 'Homepage meta description' },
        h1: { name: 'H1', hint: 'Exactly 1 H1 per page is optimal' },
        h2: { name: 'H2', hint: 'At least one H2 recommended' },
        canonical: { name: 'Canonical', hint: 'Canonical URL' },
        lang: { name: 'Language', hint: 'Language attribute' },
        json_ld_structured_data: { name: 'JSON-LD / Structured Data', hint: 'Structured data' },
        open_graph: { name: 'Open Graph', hint: 'Social meta' },
        twitter_card: { name: 'Twitter Card', hint: 'Meta Twitter/X' },
        robots_txt: { name: 'robots.txt', hint: 'Robots' },
        sitemap_xml: { name: 'Sitemap.xml', hint: 'Sitemap' },
        status_code: { name: 'Status code', hint: 'HTTP status code' },
        indexability: { name: 'Indexability', hint: 'Indexability' },
        redirects: { name: 'Redirects', hint: 'Final URL' },
        https: { name: 'HTTPS', hint: 'HTTPS' },
        load_time: { name: 'Load time', hint: 'Measured server-to-server' },
        page_weight: { name: 'Page weight', hint: 'Homepage HTML size' },
        image_lazy_loading: { name: 'Image lazy loading', hint: 'Lazy images' },
        mobile_viewport: { name: 'Mobile viewport', hint: 'Mobile viewport' },
        favicon: { name: 'Favicon', hint: 'Favicon' },
        images_with_alt: { name: 'Images with ALT', hint: 'Image accessibility' },
        privacy_policy: { name: 'Privacy policy', hint: 'Privacy' },
        cookie_policy: { name: 'Cookie policy', hint: 'Cookie' },
        terms_conditions: { name: 'Terms & Conditions', hint: 'Terms' },
        contact_page: { name: 'Contact page', hint: 'Contact' },
        shipping_policy: { name: 'Shipping policy', hint: 'Shipping' },
        returns_refunds: { name: 'Returns & Refunds', hint: 'Returns' },
        social_links: { name: 'Social links', hint: 'Social' },
        products_without_description: { name: 'Products without description', hint: 'Product descriptions' },
        products_without_images: { name: 'Products without images', hint: 'Product images' },
        products_without_meta_description: { name: 'Products without meta description', hint: 'Product meta descriptions' },
        duplicate_titles: { name: 'Duplicate titles', hint: 'Product titles' },
        duplicate_meta_descriptions: { name: 'Duplicate meta descriptions', hint: 'Product meta descriptions' },
        thin_content_200_char: { name: 'Thin content (<200 chars)', hint: 'Product content' },
      },
    },
    score_card: {
      pillar_technical_seo: 'Technical SEO',
      pillar_ux: 'UX',
      pillar_performance: 'Performance',
      pillar_trust: 'Trust',
      pillar_catalog: 'Catalog',
      label_excellent: 'Excellent',
      label_good: 'Improvable',
      label_critical: 'Critical',
      no_audit_desc: 'Audit not yet run — run the audit to get Technical SEO, UX, Trust and Performance.',
      auditing: 'Audit in progress...',
      run_audit: 'Run Site Audit 360°',
      calculated_on: 'Calculated on',
    },
    upgrade: {
      popular: '⭐ Most Popular',
      period: '/month',
      plan_header: 'Plan',
      cta: 'Upgrade to {{name}} — {{price}}{{period}}',
      dismiss: 'Not now',
      feature_available: '{{feature}} is available from the {{plan}} plan.',
      reason_credits_title: 'AI Credits exhausted',
      reason_credits_body: "You have reached your plan's monthly limit. Upgrade to continue generating content.",
      reason_products_title: 'Catalog limit reached',
      reason_products_body: 'Your Shopify catalog exceeds the current plan limit. Upgrade to sync all products.',
      reason_feature_title: 'Premium Feature',
      reason_feature_body: 'This feature is available in higher plans.',
    },
    gsc: {
      connect_title: 'Connect Google Search Console',
      connect_desc: 'Monitor impressions, clicks, CTR and average position. Request re-indexing after AI optimizations.',
      connect_feat_analytics: 'Search analytics',
      connect_feat_indexing: 'Indexing monitoring',
      connect_feat_keywords: 'Keyword tracking',
      connect_feat_sitemap: 'Sitemap manager',
      connect_btn_loading: 'Connecting...',
      connect_btn: 'Connect Google Account',
      prop_modal_title: 'Select Property',
      prop_modal_desc: 'Choose the Search Console property to connect.',
      prop_modal_empty: 'No properties found. Make sure you have properties in Google Search Console.',
      prop_modal_cancel: 'Cancel',
      prop_modal_confirm: 'Confirm',
      coming_soon_desc: 'Available in {{phase}}',
      top_opp_title: 'Top SEO Opportunities',
      top_opp_sub: 'Top 10 queries by Opportunity Score',
      copy: 'Copy',
      copied: 'Copied!',
      badge_quick_win: '🔥 Quick Win',
      badge_low_ctr: '⚡ Low CTR',
      badge_page_1: '🚀 Page 1',
      badge_high_imp: '📈 High visibility',
      badge_brand: '🏷️ Brand',
      qt_category: 'Category',
      qt_product: 'Product',
      qt_generic: 'Generic',
      qt_info: 'Info',
      qt_brand: 'Brand',
      seo_analysis: 'SEO Analysis',
      generating_ai: 'Generating AI analysis...',
      analysis_error: 'Error generating analysis. Try again later.',
      estimated_value: 'Estimated value',
      clicks_monthly: 'Potential clicks/month',
      ctr_at_pos: 'CTR at pos. {{pos}}',
      traffic_increase: 'Traffic increase',
      current_stats: 'Current: {{clicks}} clicks/month · +{{pts}} pp estimated CTR',
      priority_action: 'Priority action',
      content_opt: 'Content optimization',
      title_seo: 'Title SEO',
      title_chars: '(50–60 characters)',
      title_copied: 'Title copied!',
      h1_suggested: 'Suggested H1',
      h1_page_title: '(page title)',
      h1_copied: 'H1 copied!',
      meta_desc: 'Meta Description',
      meta_chars: '(150–160 characters)',
      meta_copied: 'Meta copied!',
      faq_all_copied: 'All FAQs copied!',
      faq_suggested: 'Suggested FAQs',
      copy_all: 'Copy all',
      faq_copied: 'FAQ copied!',
      related_kw: 'Related keywords',
      click_to_copy: '· click to copy',
      kw_copied: '"{{kw}}" copied!',
      tech_suggestions: 'Technical suggestions',
      copy_keyword: 'Copy keyword',
      kw_copied_plain: 'Keyword copied!',
      shopify_products: 'Shopify Products',
      search_store: 'Search in store',
      optimize_content: 'Optimize content',
      col_impressions: 'Impressions',
      col_position: 'Position',
      no_queries: 'No queries found with current filters.',
      ai_panel_title: 'AI Suggestions',
      analyze_query: 'Analyze query →',
      sugg_title_improvement: 'Title tag',
      sugg_meta: 'Meta description',
      sugg_content_gap: 'Missing content',
      sugg_schema: 'Schema markup',
      sugg_links: 'Internal links',
      opp_load_err: 'Error loading SEO opportunities',
      cache_updated: 'Cache updated — reloading data',
      cache_error: 'Cache refresh error',
      loading_data: 'Loading Search Console data...',
      load_error_title: 'Unable to load opportunities',
      retry: 'Retry',
      tracked_queries: 'Tracked queries',
      sku_excluded: '{{n}} SKU/EAN excluded',
      total_impressions: 'Total impressions (28d)',
      total_clicks: 'Total clicks (28d)',
      avg_ctr: 'Avg CTR',
      ai_generating: 'AI analysis generating...',
      ai_generating_sub: 'AI suggestions will appear here in a few moments.',
      no_ai_insights: 'No AI insights available',
      no_ai_insights_sub: 'No queries with significant optimization opportunities were found.',
      filter_all: 'All ({{n}})',
      search_placeholder: 'Search queries...',
      refresh_title: 'Refresh data',
      page_prev: '← Prev.',
      page_info: 'Page {{page}} / {{total}} · {{count}} queries',
      page_next: 'Next →',
      footer_note: 'Search Console data last 28 days · 6h cache · property: {{url}}',
      footer_excluded: ' · {{n}} SKU/EAN excluded',
      verdict_pass: 'Indexed',
      verdict_fail: 'Not indexed',
      verdict_neutral: 'Excluded',
      stato_title: 'Google Status — Data Sources',
      in_sitemap: 'In sitemap',
      sitemap_registered_lbl: 'Registered sitemaps',
      sitemap_errors_lbl: 'Sitemap errors',
      with_impressions: 'With impressions',
      search_appear_note: 'Pages appearing in search · {{days}}d',
      not_real_indexed: '≠ pages actually indexed',
      index_estimate_lbl: 'Indexing estimate',
      estimate_unavail: 'Estimate available after 200 inspected URLs. Start batch scan to collect the sample.',
      inspected_lbl: 'Inspected',
      indexed_confirmed: 'Confirmed indexed',
      not_indexed_lbl: 'Not indexed',
      excluded_lbl: 'Excluded',
      certain_data: 'Certain data for inspected URLs',
      batch_title: 'Batch Scan — Inspection API',
      batch_priority: 'Analytics Priority',
      batch_progress: 'Sitemap inspection progress',
      batch_stopping: 'Stopping…',
      batch_running: 'Scanning…',
      batch_starting: 'Starting...',
      batch_done_lbl: 'Sitemap complete ✓',
      batch_start_btn: 'Start scan ({{n}} available)',
      batch_timeout: 'Timeout — click to reset',
      batch_stopping_wait: 'Stopping — please wait…',
      batch_stop_btn: 'Stop scan',
      batch_remaining: '{{n}} URLs still to inspect',
      batch_quota_out: 'Daily quota exhausted — retry tomorrow',
      batch_start_err: 'Error starting scan',
      batch_complete: 'Scan complete: {{n}} URLs inspected',
      dq_title: 'API Technical Details',
      dq_api_status: 'API Status',
      dq_daily_quota: 'Daily Quota',
      dq_used_today: 'Used today',
      dq_remaining: 'Remaining',
      dq_history: 'Inspection History',
      dq_completion: 'Completion',
      dq_days_est: 'estimated days',
      dq_start_for_eta: 'Start scan to calculate ETA',
      sm_no_sitemap: 'No sitemap found',
      sm_no_sitemap_desc: 'Add a sitemap.xml to Google Search Console to monitor indexing.',
      sm_submit_ok: 'Sitemap submitted to Google',
      sm_in_progress: 'Calculating…',
      sm_submit_btn: 'Submit',
      insp_title: 'Inspect URL',
      insp_quota: '{{used}}/{{limit}} inspections today',
      insp_loading: 'Inspecting...',
      insp_btn: 'Inspect',
      insp_domain_lbl: 'Property domain:',
      insp_domain_note: 'The inspected URL must belong to it',
      insp_last_crawl: 'Last crawl',
      insp_indexing: 'Indexing',
      insp_yes: 'Yes',
      insp_no: 'No',
      insp_canonical_decl: 'Declared canonical',
      insp_canonical_diff: '⚠ Google canonical (different)',
      insp_noindex: 'noindex detected',
      insp_open_gsc: 'Open in Search Console',
      insp_err: 'URL inspection error',
      cov_title: 'Coverage — Reasons',
      cov_real_data: 'Real data — Inspection API',
      cov_conf_high: 'High reliability',
      cov_conf_medium: 'Medium reliability',
      cov_conf_low: 'Low reliability',
      cov_updated: 'Updated:',
      cov_deselect: 'Deselect',
      cov_inspected_note: 'Inspected URLs · click to filter',
      cov_none_inspected: 'No inspections',
      cov_no_data: 'No coverage data available',
      cov_no_data_desc: 'Non-indexing reasons are built automatically with each URL inspection. Use "Start automatic scan" to populate this section.',
      cov_solution: 'Recommended fix',
      cov_filter_active: 'Filter active in History',
      ih_worklist: 'SEO Worklist',
      ih_history: 'Inspection history',
      ih_filter_coverage: 'Coverage Filter',
      ih_tab_all: 'All',
      ih_tab_not_ind: 'Not ind.',
      ih_tab_indexed: 'Indexed',
      ih_tab_excluded: 'Excluded',
      ih_tab_errors: 'Errors',
      ih_tab_with_imp: 'With imp.',
      ih_tab_products: 'Products',
      ih_tab_collections: 'Collections',
      ih_sort_priority: '↓ Priority',
      ih_sort_impressions: '↓ Impressions',
      ih_sort_clicks_est: '↓ Est. clicks',
      ih_sort_date: '↓ Date',
      ih_sort_state: '↓ GSC state',
      ih_clear: 'Clear',
      ih_search: 'Search URL…',
      ih_open: 'Open',
      ih_indexing_state: 'Indexing state',
      ih_canonical_diff: '⚠ Google canonical (chosen, different)',
      ih_canonical_same: 'Google canonical (same)',
      ih_ai_fix: 'Optimize with AI →',
      ih_total: '{{n}} URLs · {{total}} total',
      ih_est_clicks: '· +{{n}} est. clicks/month',
      iai_title: 'AI Suggestions — Indexing',
      iai_filter_note: '· click to filter',
      iai_prio_high: 'High priority',
      iai_prio_medium: 'Medium priority',
      iai_prio_low: 'Low priority',
      iai_causes: 'Possible causes:',
      iai_actions: 'Recommended actions:',
      fix_apply_all: 'Apply all',
      fix_applied: 'Applied',
      fix_suggestion: 'Suggestion',
      fix_chars: 'chars',
      fix_content_impr: 'Content Improvements',
      fix_int_links: 'Suggested Internal Links',
      fix_open_url: 'Open URL',
      fix_close: 'Close',
      fix_seo_opt: 'SEO Optimization',
      trend_title: 'Indexing Trend',
      trend_updated: 'Updated to',
      trend_coverage: 'Coverage',
      trend_30d_kpi: '30d Trend',
      trend_no_data: 'Historical data being built',
      trend_no_data_desc: 'The trend will be available after at least 2 snapshots are collected.',
      trend_one_snap: '1 snapshot collected out of 2.',
      trend_start_scan: 'Start a batch scan to begin.',
      trend_ind: 'ind.',
      trend_not_ind: 'not ind.',
      trend_snap_note: 'Snapshot per scan',
      ic_loading: 'Loading indexing data...',
      ic_load_err: 'Unable to load indexing data',
      ic_clear_confirm: 'Clear all inspection history?',
      ic_cleared: 'History cleared',
      ic_clear_err: 'Clear error',
      ic_seo_opp: 'SEO Opportunities — Executive Summary',
      ic_recoverable: 'Recoverable URLs',
      ic_open_worklist: '⚡ Open Worklist →',
      ic_view_all: 'View all →',
      ic_crawled_ni: 'Crawled – not indexed',
      ic_crawled_ni_note: 'Google knows them but does not serve them',
      ic_discovered_ni: 'Discovered – not indexed',
      ic_discovered_ni_note: 'Found but never crawled',
      ic_with_imp_ni: 'With GSC impressions',
      ic_with_imp_ni_note: 'Have traffic but are not indexed',
      ic_other_ni: 'Other not indexed',
      ic_other_ni_note: 'Unknown to Google or errors',
      ic_refresh: 'Refresh',
      rh_title: 'Change history',
      rh_versions: 'versions',
      rh_confirm: "Restore version from {{date}}?\n\nCurrent editor changes will be replaced.",
      rh_restored_ok: 'v{{v}} restored in Shopify theme',
      rh_restored_editor: 'Version v{{v}} loaded in editor — click Save to apply it',
      rh_restore_err: 'Restore error',
      rh_current: 'current',
      rh_initial: 'Initial version',
      rh_no_diff: 'No text changes',
      rh_more_added: '+ {{n}} more added',
      rh_more_removed: '- {{n}} more removed',
      rh_restore_btn: 'Restore',
      rb_load_err: 'Error loading robots.txt',
      rb_save_err: 'Save error',
      rb_analyze_err: 'Analysis error',
      rb_score_good: 'Excellent',
      rb_score_ok: 'Needs improvement',
      rb_score_bad: 'Critical',
      rb_analysis_title: 'SEO Robots Analysis',
      rb_analyzing: 'Analyzing…',
      rb_analyze: 'Analyze',
      rb_analyze_hint: 'Click "Analyze" to automatically detect SEO issues and optimization opportunities',
      rb_no_issues: 'No issues detected',
      rb_no_issues_desc: 'Your robots.txt follows Shopify best practices',
      rb_critical: 'CRITICAL',
      rb_warning: 'WARNING',
      rb_validation_title: 'Robots.txt Validation',
      rb_reload: 'Reload',
      rb_editor_title: 'Robots.txt Editor',
      rb_modified: 'Modified',
      rb_diff_close: 'Close diff',
      rb_editor_restore: 'Restore',
      rb_saving: 'Saving…',
      rb_save: 'Save',
      rb_blocking_warning: '🚨 YOU ARE BLOCKING THE ENTIRE SITE — "Disallow: /" prevents Google from indexing any page',
      rb_diff_preview: 'Changes preview:',
      rb_opportunity: 'OPPORTUNITY',
      rb_checker_title: 'URL Check',
      rb_check_btn: 'Check',
      rb_allowed: 'Allowed',
      rb_blocked: 'Blocked',
      rb_sitemaps_title: 'Declared Sitemaps',
      ll_history_title: 'LLMs.txt History',
      ll_generated: 'Generated',
      ll_restored_editor: 'Version v{{v}} loaded in editor — click Publish to apply it',
      ll_load_err: 'Error loading llms.txt',
      ll_generate_err: 'Generation error',
      ll_saved_ok: 'LLMs.txt published and verified in Shopify theme',
      ll_not_configured: 'Not configured',
      ll_validation_title: 'LLMs.txt Validation',
      ll_not_found: 'No llms.txt found on the site. Use "Generate from Shopify" to create it automatically.',
      ll_what_title: 'What is LLMs.txt?',
      ll_what_desc: 'The /llms.txt standard is a markdown file that helps AI models (ChatGPT, Claude, Perplexity, Gemini) understand your site and cite it correctly in responses. Increases visibility in AI answer engines.',
      ll_editor_title: 'LLMs.txt Editor',
      ll_generating: 'Generating…',
      ll_generate_btn: 'Generate from Shopify',
      tab_jsonld: 'JSON-LD',
      jl_load_err: 'Error loading JSON-LD overview',
      jl_sec_overview: 'Overview',
      jl_sec_schemas: 'Schemas',
      jl_sec_problems: 'Problems',
      jl_sec_generate: 'AI Optimization',
      jl_sec_preview: 'JSON Preview',
      jl_sec_validate: 'Validation',
      jl_sec_bulk: 'Bulk Operations',
      jl_sec_stats: 'Statistics',
      jl_rich_results: 'Rich Results Eligibility',
      jl_eligible: 'Eligible',
      jl_warnings: 'Partial',
      jl_not_eligible: 'Not eligible',
      jl_field_coverage: 'Field Coverage',
      jl_what_title: 'What is JSON-LD?',
      jl_what_desc: "JSON-LD is Google's recommended format for structured data. It enables Rich Results in search (stars, prices, breadcrumbs) and helps AI models understand your products better.",
      jl_score_poor: 'Poor coverage',
      jl_schemas_title: 'Supported Schema Types',
      jl_status_valid: 'Valid',
      jl_status_partial: 'Partial',
      jl_status_missing: 'Not configured',
      jl_valid_items: 'valid',
      jl_issues: 'issues',
      jl_google_test: 'Test in Google Rich Results',
      jl_google_test_desc: "After generating your JSON-LD, test it directly in Google's Rich Results Test tool to verify eligibility.",
      jl_problems_title: 'Diagnostic Issues',
      jl_no_problems: 'No critical issues found. Your JSON-LD coverage looks good!',
      jl_products_affected: 'products affected',
      jl_sev_critical: 'Critical',
      jl_sev_warning: 'Warning',
      jl_prob_brand: 'Missing brand / vendor',
      jl_prob_desc: 'Missing description',
      jl_prob_image: 'Missing product image',
      jl_prob_sku: 'Missing SKU',
      jl_prob_gtin: 'Missing GTIN / barcode',
      jl_prob_meta: 'Missing meta description',
      jl_prob_offers: 'Price not in JSON-LD (needs Shopify theme snippet)',
      jl_problems_tip: 'Fix missing fields in the Products section or use AI Optimization to auto-fill them.',
      jl_gen_title: 'Generate JSON-LD',
      jl_schema_type: 'Schema type',
      jl_product_id: 'Product ID (leave empty for sample)',
      jl_use_ai: 'Use AI enrichment (GPT)',
      jl_gen_btn: 'Generate JSON-LD',
      jl_gen_ok: 'JSON-LD generated',
      jl_gen_err: 'Generation error',
      jl_copied: 'Copied!',
      jl_copy: 'Copy',
      jl_preview_title: 'JSON-LD Preview',
      jl_preview_err: 'Error loading preview',
      jl_load_preview: 'Load sample product',
      jl_preview_empty: 'Click "Load sample product" to preview all JSON-LD schemas',
      jl_val_title: 'Local Schema Validation',
      jl_invalid_json: 'Invalid JSON',
      jl_val_btn: 'Validate JSON-LD',
      jl_val_clear: 'Clear',
      jl_val_ok: 'Valid — Rich Results eligible',
      jl_val_fail: 'Validation failed',
      jl_val_note: 'This validator checks schema.org requirements. For the official Google test use the Rich Results Test above.',
      jl_val_err: 'Validation error',
      jl_bulk_title: 'Bulk Operations',
      jl_bulk_gen: 'Generate all',
      jl_bulk_gen_desc: 'Build Product JSON-LD for every product and save to DB',
      jl_bulk_val: 'Validate all',
      jl_bulk_val_desc: 'Run schema.org validation on existing JSON-LD',
      jl_bulk_fix: 'Fix & enrich',
      jl_bulk_fix_desc: 'Rebuild JSON-LD for products with errors',
      jl_bulk_started: 'Bulk operation started',
      jl_bulk_err: 'Error starting bulk operation',
      jl_bulk_running: 'In progress',
      jl_bulk_done: 'Completed',
      jl_bulk_stop: 'Stop',
      jl_bulk_stopped: 'Bulk operation stopped',
      jl_errors: 'errors',
      jl_stat_total: 'Total products',
      jl_stat_eligible: 'Rich Results eligible',
      jl_stat_gen_today: 'Generated today',
      jl_stat_fixed: 'Fixed today',
      jl_coverage_by_type: 'Coverage by content type',
      jl_type: 'Type',
      jl_total: 'Total',
      jl_valid2: 'Valid',
      jl_missing2: 'Missing',

      ll_revert: 'Revert',
      ll_publishing: 'Publishing…',
      ll_publish: 'Publish',
      lp_filter_url: 'Filter URL…',
      lp_copied: 'Copied',
      lp_broken_empty: 'No broken links detected',
      lp_broken_empty_sub: 'All store URLs are reachable (404 / 410 / timeout)',
      lp_timeout: 'Timeout — no response within 12s',
      lp_ratelimit_empty: 'No rate limiting detected',
      lp_ratelimit_empty_sub: 'The server did not limit scanner requests',
      lp_ratelimit_note: 'Page reachable but server responded 429 during scan',
      lp_server_empty: 'No server errors detected',
      lp_server_empty_sub: 'All URLs respond correctly (no 5xx)',
      lp_server_note: 'HTTP {{code}} — server-side error',
      lp_redirect_empty: 'No redirects detected',
      lp_redirect_total: 'Total redirects',
      lp_chains: 'Chains (>1 hop)',
      lp_loops: 'Loops detected',
      lp_chains_header: 'Redirect chains',
      lp_chains_badge: '{{n}} multi-hop chains',
      lp_final_status: 'Final status:',
      lp_canon_ok: 'Correct',
      lp_canon_miss: 'Missing',
      lp_canon_wrong: 'Wrong URL',
      lp_canon_cross: 'Cross-domain',
      lp_canon_redir: 'Canonical→redirect',
      lp_canon_action_missing: 'Add a canonical link tag pointing to this page URL in the head section.',
      lp_canon_action_wrong: 'Fix the canonical to point to the definitive URL of this page.',
      lp_canon_action_cross: 'The canonical points to an external domain. Check if intentional (e.g. syndication) or an error.',
      lp_canon_action_redir: 'The canonical points to a URL that redirects. Update it with the final redirect destination.',
      lp_canon_no_data: 'Canonical data not available — run the scan',
      lp_canon_issues: 'Canonical Issues ({{n}})',
      lp_canon_no_issues: 'No canonical issues detected',
      lp_canon_sample: 'Sample analyzed: {{n}} URLs from your store (products, collections, pages, articles)',
      il_tab_orphans: 'Orphan Pages',
      il_tab_weak: 'Weak Links',
      il_tab_deep: 'Deep Pages',
      il_kpi_weak: 'Weak links ≤2',
      il_kpi_deep: 'Deep pages',
      il_orphan_empty: 'No orphan pages',
      il_orphan_empty_sub: 'All pages receive at least one internal link',
      il_orphan_header: 'Pages with no incoming links ({{n}})',
      il_weak_empty: 'No pages with weak links',
      il_weak_empty_sub: 'All pages receive 3+ internal links',
      il_weak_header: 'Pages with 1–2 incoming links ({{n}})',
      il_anchor_empty: 'Anchor texts optimized',
      il_anchor_empty_sub: 'No generic, empty or duplicate anchors detected',
      il_anchor_generic: 'Generic anchors',
      il_anchor_generic_desc: 'Texts like "click here", "here", "discover"',
      il_anchor_empty_type: 'Empty anchors',
      il_anchor_empty_desc: 'Links without descriptive text',
      il_anchor_dup: 'Duplicate anchors',
      il_anchor_dup_desc: 'Same text → different URLs',
      il_anchor_lbl_gen: 'Generic',
      il_anchor_lbl_empty: 'Empty',
      il_anchor_lbl_dup: 'Duplicate',
      il_deep_empty: 'No overly deep pages',
      il_deep_empty_sub: 'All pages are reachable in ≤3 clicks from homepage',
      il_deep_header: 'Pages >3 clicks from homepage ({{n}})',
      il_deep_note: 'Pages with ∞ are not reachable via internal links. Add them to menus or collections.',
      il_hub_empty: 'No hub data available',
      il_hub_empty_sub: 'Run a scan to identify hub pages',
      il_hub_header: 'Hub pages — most internally linked',
      il_hub_count: '{{n}} internal incoming links',
      lm_active: 'Active',
      lm_not_installed: 'Not installed',
      lm_install_hint: 'Install in theme to monitor real navigation without crawling',
      lm_refresh: 'Refresh',
      lm_clear: 'Clear data',
      lm_remove: 'Remove from theme',
      lm_installing: 'Installing…',
      lm_install: 'Install in theme',
      lm_tab_404: '404 Errors',
      lm_tab_redirect: 'Redirect Opp.',
      lm_tab_top: 'Top Pages',
      lm_kpi_visits: 'Total visits',
      lm_kpi_404s: 'Real 404 errors',
      lm_no_404: 'No 404 errors detected by users',
      lm_visits: 'visits',
      lm_theme_prefix: 'Theme: ',
      lm_last_activity: 'Last activity: ',
      lm_no_activity: 'no visits yet',
      lm_installed: 'Monitor installed in theme "{{name}}"',
      lm_err_install: 'Installation error',
      lm_confirm_remove: 'Remove the monitoring script from the active theme?',
      lm_removed: 'Script removed from theme',
      lm_err_remove: 'Removal error',
      lm_confirm_clear: 'Delete all collected monitoring data?',
      lm_cleared: 'Data deleted',
      lm_err_clear: 'Deletion error',
      lm_modal_title: 'Create Redirect 301',
      lm_modal_source: 'Source URL (404)',
      lm_modal_dest: 'Destination',
      lm_redirect_created: 'Redirect 301 created on Shopify',
      lm_err_redirect: 'Redirect creation error',
      lm_create_redirect: 'Create Redirect',
      lm_creating: 'Creating…',
      lm_cancel: 'Cancel',
      lm_info_title: 'How Live Monitor works',
      lm_info_1: 'The "Install in theme" button automatically adds a lightweight script to the active theme via Shopify Themes API',
      lm_info_2: 'For each real visit it collects: URL, page type, internal links, 404 errors, internal referrer',
      lm_info_3: 'Zero crawling — no HTTP 429 — data from real visitors in real time',
      lm_info_4: 'Progressively builds the internal link map and detects orphan pages',
      lm_no_redirect: 'No redirect needed',
      lm_no_redirect_hint1: 'Live Monitor has not yet recorded visits. Redirect opportunities appear when real users encounter 404 pages.',
      lm_no_redirect_hint2: 'In {{n}} visits analyzed no user encountered 404 pages. Great!',
      lm_toolbar_ai: '{{count}} URL · {{ai}} with AI suggestion',
      lm_toolbar_ignored: '· {{n}} ignored',
      lm_sort_visits: 'Visits',
      lm_sort_date: 'Date',
      lm_selected: '{{n}} selected',
      lm_no_match: 'no automatic match',
      lm_create: 'Create',
      lm_ignore: 'Ignore',
      lm_err: 'Error',
      lm_bulk_ignored: '{{n}} URL(s) ignored',
      lm_bulk_created: '{{n}} redirects created',
      lm_errors: 'errors',
      ls_scan_started: 'Scan started — will complete in background',
      ls_scan_err: 'Error starting scan',
      ls_last_scan: 'Last scan: {{date}} · {{n}} URL',
      ls_no_scan_desc: 'No scan performed — detects broken links, redirects, canonicals, orphan pages',
      ls_scanning: 'Scanning…',
      ls_rescan: 'Rescan',
      ls_start_scan: 'Start scan',
      ls_canonical_issues: 'Canonical Issues',
      ls_scan_details: 'Scan details',
      ls_stat_total: 'Total URLs',
      ls_stat_errors: 'Errors',
      ls_no_scan: 'No scan performed',
      ls_no_scan_long: 'Start the scan to detect broken links, redirect chains, canonical issues and orphan pages without incoming links',
      ls_first_scan: 'Start first scan',
      db_gsc_connected: 'Google Search Console connected!',
      db_gsc_err: 'GSC connection error: {{code}}',
      db_props_err: 'Unable to load GSC properties',
      db_oauth_hint: 'Complete Google authorization in the new tab. The page will refresh automatically.',
      db_conn_err: 'GSC connection error',
      db_prop_selected: 'Property selected: {{url}}',
      db_prop_err: 'Property selection error',
      db_confirm_disconnect: 'Disconnect Google Search Console?',
      db_disconnected: 'GSC disconnected',
      db_disconnect_err: 'Disconnection error',
      db_connected: 'Search Console connected',
      db_no_property: 'No property selected',
      db_not_connected: 'Not connected',
      db_connect_hint: 'Connect GSC to unlock analytics and monitoring',
      db_change_prop: 'Change property',
      db_disconnect: 'Disconnect',
      db_connect: 'Connect GSC',
      db_idx_subtitle: 'Technical SEO quality & indexing',
      db_lbl_gsc: 'GSC Connected',
      db_lbl_sitemap: 'Sitemaps submitted',
      db_lbl_indexed: 'Indexed URLs',
      db_health_real: 'Based on real Search Console data',
      db_health_proxy: 'Based on catalog quality — connect GSC for real data',
      db_lbl_position: 'Position',
      db_lbl_trend: 'Trend 28d',
      db_lbl_errors: 'Errors',
      db_connect_score: 'Connect GSC to calculate the score',
      db_proxy_note: 'Catalog proxy',
      db_stat_excluded: 'Excluded URLs',
      db_stat_seo_score: 'Average SEO score',
      db_catalog_title: 'Catalog health',
      db_cat_alt: 'Image ALT text',
      db_cat_keywords: 'Missing keywords',
      db_cat_no_kw: '{{n}} products without keywords',
      db_cat_count: '{{n}} / {{total}} products',
      tab_opportunities: 'SEO Opportunities',
      tab_indexing: 'Indexing',
      locked_available: 'Available from the {{plan}} plan',
      locked_upgrade: 'Upgrade to {{plan}} plan',
      main_subtitle: 'Technical SEO · Indexing · Analytics · AI Automation',
      phase_3: 'Phase 3',
      interval_all: 'All',
      click_monthly_est: 'est. clicks/month',
      fix_title_updated: 'Title tag updated',
      fix_meta_updated: 'Meta description updated',
      fix_both_updated: 'Title and Meta description updated in Shopify',
      fix_apply_err: 'Application error',
      rb_save_ok: 'Robots.txt saved and verified in Shopify theme',
      rb_draft_with_err: 'Draft saved ({{err}})',
      rb_draft_manual: 'Draft saved — follow instructions to apply in theme',
      rb_critical_confirm: '🚨 CRITICAL WARNING 🚨\n\nYour robots.txt contains "Disallow: /" which COMPLETELY BLOCKS the site:\nGoogle, Bing and all bots will no longer be able to crawl any page.\n\nThis can cause the site to be removed from search results.\n\nAre you ABSOLUTELY SURE you want to proceed?',
      scan_err: 'Scan error: {{msg}}',
      sm_send_err: 'Send error',
      unknown_err: 'Unknown',
      dq_today: 'Today',
      dq_7d: 'Last 7 days',
      dq_30d: 'Last 30 days',
      dq_daily_avg: 'Daily avg',
      dq_at_pace: 'at ~{{n}}/day',
      job_stopped: 'Stopped at {{n}} URLs processed',
      job_inspected: '{{n}} inspected',
      job_errors: 'errors',
      quota_remaining: 'Remaining quota:',
      lk_trend: 'Indexing Trend History',
      lk_batch: 'Batch Inspection (mass URL scan)',
      lk_ai: 'AI Indexing Suggestions',
      footer_apis: 'Sitemaps API + Search Analytics + Inspection API',
      prod_status_lbl: 'Status:',
      prod_desc_lbl: 'Description:',
      prod_missing: 'MISSING',
      state_disc: 'Disc.',
      state_crawl: 'Crawl.',
      insp_api_real: 'Inspection API ✓ real',
      sm_count: '{{n}} sitemaps',
      sm_reliability: 'Reliability:',
      conf_high: 'High',
      conf_medium: 'Medium',
      conf_low: 'Low',
      sm_urls: 'URLs in Sitemap',
      sm_sample: 'Sample',
      sm_est_indexed: 'Est. indexed',
      sm_est_nonidx: 'Est. not indexed',
      sm_coverage: 'Est. coverage ⓘ',
      sm_idx_of: '~{{n}} indexed out of {{t}} sitemap URLs',
      sm_cov_est: 'Est. coverage:',
      sm_margin_err: 'margin of error',
      sm_indexed_of: 'indexed out of',
      sm_sampled: 'sampled',
      sm_th_sitemap: 'Sitemap',
      sm_th_submitted: 'Submitted',
      sm_th_indexed: 'Indexed',
      sm_th_gap: 'Gap',
      sm_th_coverage: 'Coverage',
      sm_th_warning: 'Warning',
      sm_th_errors: 'Errors',
      sm_th_lastmod: 'Last updated',
      sm_th_actions: 'Actions',
      rb_verified_result: 'Saved and verified in Shopify theme ({{theme}}) — file:',
      rb_draft_result: 'Draft saved. To apply manually: Shopify Admin → Themes → Edit code →',
      ll_draft_result: 'Draft saved. To apply manually: Shopify Admin → Themes → Edit code →',
      ls_section_redirects: 'Redirect Manager',
      rm_tab: 'Redirect Manager',
      rm_subtitle: 'Manage all your store redirects in one place.',
      rm_kpi_total: 'Total Rules',
      rm_kpi_active: 'Active Redirects',
      rm_kpi_pending: 'Pending 404s',
      rm_kpi_hits: 'Hits (30d)',
      rm_kpi_chains: 'Chains',
      rm_kpi_loops: 'Loops',
      rm_section_rules: 'Rules',
      rm_section_suggest: 'AI Suggestions',
      rm_section_health: 'Health',
      rm_section_import: 'Import / Export',
      rm_section_history: 'History',
      rm_create_title: 'Create Redirect',
      rm_edit_title: 'Edit Redirect',
      rm_old_url: 'Old URL',
      rm_new_url: 'New URL',
      rm_old_url_ph: '/old-path',
      rm_new_url_ph: '/new-path',
      rm_type: 'Type',
      rm_type_301: '301 – Permanent',
      rm_type_302: '302 – Temporary',
      rm_notes: 'Notes',
      rm_save: 'Save',
      rm_cancel: 'Cancel',
      rm_create_ok: 'Redirect created successfully.',
      rm_edit_ok: 'Redirect updated successfully.',
      rm_create_err: 'Error creating redirect.',
      rm_edit_err: 'Error saving redirect.',
      rm_dup_err: 'A redirect for this source URL already exists.',
      rm_empty_err: 'Source and destination URLs are required.',
      rm_same_err: 'Source and destination URLs cannot be the same.',
      rm_search_ph: 'Search URLs…',
      rm_filter_all: 'All',
      rm_filter_active: 'Active',
      rm_filter_disabled: 'Disabled',
      rm_create_btn: 'Create Redirect',
      rm_selected_items: '{{count}} selected',
      rm_bulk_enable: 'Enable',
      rm_bulk_disable: 'Disable',
      rm_bulk_delete: 'Delete',
      rm_bulk_export: 'Export CSV',
      rm_bulk_ok: 'Operation completed.',
      rm_table_old: 'Old URL',
      rm_table_new: 'New URL',
      rm_table_type: 'Type',
      rm_table_hits: 'Hits',
      rm_table_status: 'Status',
      rm_table_actions: 'Actions',
      rm_edit: 'Edit',
      rm_duplicate: 'Duplicate',
      rm_delete: 'Delete',
      rm_delete_confirm: 'Delete this redirect?',
      rm_deleted_ok: 'Redirect deleted.',
      rm_delete_err: 'Error deleting redirect.',
      rm_status_active: 'Active',
      rm_status_disabled: 'Disabled',
      rm_no_data: 'No redirects found.',
      rm_empty_state: 'No redirects yet. Create your first redirect.',
      rm_total_redirects: '{{count}} total redirects',
      rm_import_title: 'Import Redirects',
      rm_import_csv: 'CSV (old_url,new_url,type)',
      rm_import_shopify: 'Shopify Export CSV',
      rm_import_sf: 'Screaming Frog CSV',
      rm_import_btn: 'Import',
      rm_import_ok: 'Import completed.',
      rm_import_err: 'Error during import.',
      rm_import_imported: '{{count}} imported',
      rm_import_skipped: '{{count}} skipped',
      rm_export_title: 'Export Redirects',
      rm_export_desc: 'Download all redirects in available formats.',
      rm_export_csv: 'Export CSV',
      rm_export_json: 'Export JSON',
      rm_ai_title: 'AI Suggestions',
      rm_ai_subtitle: 'AI detected 404 URLs and suggests redirects to similar products.',
      rm_ai_accept: 'Accept',
      rm_ai_reject: 'Reject',
      rm_ai_accept_all: 'Accept All',
      rm_ai_loading: 'Analyzing…',
      rm_ai_empty: 'No suggestions available at the moment.',
      rm_chains_title: 'Redirect Chains',
      rm_chains_desc: 'Multiple chained redirects slow down your site. Fix them now.',
      rm_chains_fix: 'Fix Chain',
      rm_chains_empty: 'No chains detected.',
      rm_chains_fixed: 'Chain fixed.',
      rm_loops_title: 'Redirect Loops',
      rm_loops_desc: 'Circular loops causing errors. Require manual fix.',
      rm_loops_fix: 'Fix',
      rm_loops_empty: 'No loops detected.',
      rm_gsc_title: '404s from Google Search Console',
      rm_gsc_subtitle: 'Not-found URLs detected by GSC in the last 90 days.',
      rm_gsc_empty: 'No GSC 404s detected.',
      rm_history_title: 'Activity History',
      rm_history_created: 'Created',
      rm_history_edited: 'Edited',
      rm_history_deleted: 'Deleted',
      rm_history_disabled: 'Disabled',
      rm_history_enabled: 'Enabled',
      rm_history_imported: 'Imported',
      rm_history_bulk: 'Bulk operation',
      rm_history_empty: 'No activity recorded.',
      rm_sync_shopify: 'Sync from Shopify',
      rm_sync_shopify_desc: 'Import all URL redirects from Shopify. New redirects you create are automatically pushed to Shopify.',
      rm_sync_btn: 'Sync now',
      error_label: 'Error:',
      rb_checker_desc: 'Check if a URL is allowed or blocked by {{bot}} based on the current robots.txt in the editor.',
      rb_rule: 'Rule:',
      rb_fix: 'Fix:',
      rb_gsc_note_title: 'Search Console Integration',
      rb_gsc_note_body: 'In the Indexing section, URLs with status "Blocked by robots" indicate pages Google cannot crawl due to this file.',
      rb_issues: 'issues',
      rb_opps: 'opportunities',
      rb_savings: 'Estimated savings:',
      never: 'Never',
      samples_conf: '{{n}} samples · confidence {{c}}',
      batch_priority_note: 'URLs with Analytics impressions inspected first · GSC quota 2,000/day · background processing',
      sm_samples: 'samples',
      sm_footnote_ec: '~ "In progress" values = estimate from Inspection API ({{n}} samples · confidence {{c}}). Sitemaps API returns 0 for sitemap index.',
      sm_footnote_noec: '~ "In progress" values = estimate from Inspection API. Start batch scan to get estimate. Sitemaps API returns 0 for sitemap index.',
      ic_quota_note: 'Calculated on {{n}} URLs inspected via Inspection API (quota 2,000/day). GSC Coverage shows {{m}} non-indexed URLs in sitemap.',
      cov_crawled_ni: 'Low quality or duplicate content. Improve content, add unique text, verify canonical tag.',
      cov_disc_ni: 'Google found it but has not crawled it yet. Increase crawl budget with additional internal links and updated sitemap.',
      cov_dup_nocanon: 'Add canonical tag pointing to the main page.',
      cov_dup_googcanon: 'Google ignores the declared canonical. Verify URL and canonical consistency between desktop/mobile versions.',
      cov_redirect: 'Active redirect. If intentional, update internal links to point directly to the destination.',
      cov_alternate: 'Alternate page with correct canonical — no action needed if intentional.',
      cov_noindex: 'Remove the noindex meta tag if you want the page to be indexed.',
      cov_robots: 'Page blocked by robots.txt. Verify Disallow directives and update if necessary.',
      cov_removed: 'Manually removed from GSC. Revoke the removal from the Search Console panel if desired.',
      cov_404: 'Page not found. Restore the page, set a 301 redirect, or remove internal links to this URL.',
      cov_soft404: 'Server returns 200 but Google treats it as an empty page. Ensure the page has relevant content.',
      cov_server_err: 'Server error. Check server logs and hosting availability during crawl.',
      cov_unknown_url: 'Google has not yet discovered this URL. Add internal links, update the sitemap, and wait for the next crawl.',
      qt_brand: 'Brand',
      qt_info: 'Info',
      qt_category: 'Category',
      qt_product: 'Product',
      qt_generic: 'Generic',
      sugg_title_improvement: 'Title tag',
      sugg_meta: 'Meta description',
      sugg_content_gap: 'Missing content',
      sugg_schema: 'Schema markup',
      sugg_links: 'Internal links',
      verdict_indexed: 'Indexed',
      verdict_not_indexed: 'Not indexed',
      verdict_excluded: 'Excluded',
      badge_col_header: 'Badge',
      sitemap_label: 'Sitemap',
      ls_tab_broken: 'Broken Links',
      ls_tab_redirect: 'Redirect',
      ls_tab_rate_limited: 'Rate Limited',
      ls_tab_server_errors: 'Server Errors',
      ls_tab_canonical: 'Canonical',
      ls_tab_internal: 'Internal Links',
      ls_section_monitor: 'Live Monitor',
      ls_section_audit: 'Site Structure',
      db_idx_title: 'Index Score',
      db_health_title: 'SC Health Score',
      canonical_mismatch: 'Canonical mismatch',
    },
    so: {
      load_err: 'Speed Optimizer loading error',
      analyze_timeout: 'Analysis timed out (90s) — please retry',
      analyze_done: 'Analysis complete!',
      analyze_failed: 'Analysis failed: {{error}}',
      rate_limited: 'Rate limit reached — data updated from cache',
      analyze_err: 'Analysis error',
      opt_enabled: '{{label}} enabled on theme',
      opt_disabled: '{{label}} disabled',
      opt_err: 'Optimization error',
      scan_err: 'Theme scan error',
      img_err: 'Image analysis error',
      sg_protected: 'Safety Guard: Protected enabled',
      sg_standard: 'Safety Guard: Standard enabled',
      mode_err: 'Mode change error',
      plan_err: 'Plan generation error',
      strategy_applied: 'Strategy {{label}} applied to theme',
      strategy_err: 'Strategy application error',
      sessions_err: 'Sessions loading error',
      rollback_done: 'Rollback complete — theme restored',
      rollback_err: 'Rollback error',
      subtitle: 'Safe Shopify theme optimizations with instant rollback.',
      btn_rollback: 'Rollback all',
      btn_analyze: 'Analyze now',
      analyzing_psi: 'PSI processing…',
      analyzing_queue: 'In queue…',
      analyzing: 'Analyzing…',
      alert_no_token: 'Shopify token missing — optimizations require an active store connection.',
      alert_no_scope: 'Theme permissions missing — to apply optimizations you must reinstall the app to add Shopify theme access.',
      perf_empty: 'No analysis available',
      perf_empty_hint: 'Click "Analyze now" to measure your store performance',
      suggestions: 'Suggestions',
      strategy_active: 'active',
      strategy_subtitle: 'Sets the optimization target. Click to preview the plan before applying.',
      sg_header: 'Limits what operations the strategy can perform.',
      sg_desc_protected: 'Blocks Standard operations — safe optimizations only.',
      sg_desc_standard: 'Allows full execution of the selected strategy.',
      quick_opts: 'Quick Optimizations',
      sg_warning: 'Safety Guard: Protected — Standard operations are blocked. Switch to Standard above.',
      lcp_section: 'LCP Theme Scan',
      hist_section: 'Optimization history',
      hist_empty: 'No optimizations applied yet.',
      sessions_section: 'Sessions & Lighthouse Impact',
      sessions_empty: 'Load sessions to see the real impact on Core Web Vitals.',
      img_count: '{{n}} images · {{kb}} KB total',
      img_oversized: '{{n}} images >300KB',
      img_no_oversized: 'No oversized images — great!',
      img_empty: 'Click "Analyze images" to find images >300KB in the theme.',
      btn_refresh: 'Reload',
      btn_load_sessions: 'Load sessions',
      btn_refresh_sessions: 'Refresh',
      btn_analyze_img: 'Analyze images',
      btn_refresh_img: 'Refresh',
      modal_risk_safe: 'Safe — no visual impact expected',
      modal_risk_medium: 'Check the site appearance after activation',
      modal_risk_high: 'May affect advanced functionality',
      modal_reversible: 'Reversible at any time — use "Rollback all" to restore the original theme.',
      modal_cancel: 'Cancel',
      modal_enable: 'Enable now',
      opt_no_token: 'Reconnect the Shopify store to use this feature',
      opt_blocked_guard: 'Blocked by Safety Guard (Protected) — switch to Standard to enable',
      opt_reversible: 'reversible',
      opt_blocked_label: 'Blocked by Safety Guard — switch to Standard',
      scan_scanning: 'Scanning in progress...',
      scan_empty_title: 'Theme scan not run',
      scan_empty_desc: 'Identifies hero and slideshow sections in the theme to enable server-side LCP optimizations.',
      scan_btn: 'Scan theme',
      scan_active_theme: 'Active theme',
      scan_files: '{{n}} Liquid files scanned · {{s}} LCP sections identified',
      scan_hero_label: 'hero/LCP section',
      scan_optimized: 'optimized',
      scan_no_lcp: 'No hero/LCP sections identified automatically in the theme.',
      scan_reload: 'Reload',
      plan_title: 'Plan: {{label}}',
      plan_ops: '{{n}} operations planned',
      plan_action_enabled: 'already active',
      plan_action_enable: 'enable',
      plan_action_disable: 'disable',
      plan_strategy: 'Strategy: ',
      plan_guard: 'Safety Guard: ',
      plan_active_ops: 'Active operations: ',
      plan_blocked: '{{n}} blocked by Safety Guard',
      plan_low_conf: 'Some optimizations have low confidence for the detected theme.',
      plan_cancel: 'Cancel',
      plan_apply: 'Apply strategy',
      plan_blocked_btn: 'Blocked (low score)',
      hist_rollback: 'Full rollback — all optimizations removed',
      hist_enabled: 'enabled',
      hist_disabled: 'disabled',
      hist_active: 'active',
      sess_no_sessions: 'No optimization sessions recorded. Sessions are created when you apply a strategy.',
      sess_waiting: 'waiting PSI',
      strategy_label: 'Strategy {{s}}',
      strategy_opts: '{{n}} optimizations',
      strategy_active: 'ACTIVE',
      quota_err: 'Error loading PSI quota',
      quota_api_key: 'API key configured:',
      quota_yes: '✓ YES',
      quota_no: '✗ NO (uses public quota)',
      quota_cache_ttl: 'Cache TTL:',
      quota_hourly: 'Hourly limit:',
      quota_daily: 'Daily limit:',
      quota_success: 'Successes today:',
      quota_hit_ratio: 'Cache hit ratio:',
      quota_circuit: 'Circuit breaker:',
      quota_circuit_open: 'OPEN ({{n}} failures)',
      quota_circuit_closed: 'closed',
      quota_loading: 'Loading...',
      diag_err: 'Diagnostics error',
      diag_refresh: 'Refresh',
      diag_load: 'Load diagnostics',
      diag_patches: 'Active patches ({{n}})',
      diag_none: 'none',
      diag_unavailable: 'unavailable',
      diag_no_patches: 'No active patches',
      diag_calibrated: '📈 calibrated',
      diag_generated: 'Generated:',
      badge_server_side: 'SERVER-SIDE',
      badge_standard: 'STANDARD',
      badge_lcp: 'LCP',
      badge_critical: 'CRITICAL',
      badge_safe: 'SAFE',
      badge_medium: 'MEDIUM',
      badge_safety_guard: 'Safety Guard',
      diag_theme_fingerprint: 'Theme Fingerprint',
      diag_engine_confidence: 'Engine Confidence',
      perf_score_label: 'Performance Score',
      section_perf_overview: 'Performance Overview',
      section_strategy_intent: 'Strategy Intent',
      safety_guard_title: 'Safety Guard',
      section_script_analyzer: 'Script Impact Analyzer',
      script_col_file: 'File',
      script_col_size: 'Size',
      script_col_impact: 'Impact',
      script_col_defer_risk: 'Defer risk',
      metric_js_total: 'Total JS',
      metric_css_total: 'Total CSS',
      perf_updated: 'Updated:',
      perf_stale: 'stale data (PSI unavailable)',
      perf_from_cache: 'from cache',
      perf_psi_ok: 'PSI OK',
      debug_invalid_token_title: 'Invalid token (401) — the token in MongoDB has expired or been revoked.',
      debug_reconnect_desc: 'The OAuth callback did NOT overwrite the token after the last reinstall. Click the button below to start a fresh OAuth.',
      debug_reconnect_btn: 'Reconnect OAuth now (opens Shopify)',
      debug_reconnect_note: 'After approving permissions on Shopify, the callback will update the token in MongoDB automatically.',
    },
    drafts: {
      approved: 'Draft approved!',
      approve_err: 'Approval error',
      published: 'Published on Shopify!',
      publish_err: 'Publication error',
      title: 'Drafts & Results',
      subtitle: 'Review, approve and publish optimized content',
      empty: 'No drafts to review',
      empty_hint: 'Generate AI content to create new drafts',
      badge_approved: 'Approved',
      badge_draft: 'Draft',
      field_desc: 'Description',
      btn_view: 'View',
      btn_approve: 'Approve',
      btn_publish: 'Publish',
      modal_title: 'Draft Detail',
      chars_seo: '/60 characters',
      chars_meta: '/160 characters',
      not_present: 'Not present',
      not_present_pl: 'Not present',
      btn_close: 'Close',
      btn_publish_shopify: 'Publish to Shopify',
      seo_title: 'SEO Title',
      meta_description: 'Meta Description',
      keywords_label: 'Keywords',
    },
    usage: {
      title: 'Usage & Plan',
      subtitle: 'Monitor usage and manage your subscription',
      plan_badge: 'Plan:',
      current: 'Current Usage',
      credits: 'AI Credits',
      used: 'Used:',
      unlimited: 'Unlimited ∞',
      remaining: 'Remaining: {{n}}',
      products_sync: 'Synced products',
      plans_heading: 'Available Plans',
      most_popular: '⭐ Most Popular',
      active_plan: 'Active Plan',
      current_plan: 'Current Plan',
      btn_upgrade: 'Upgrade to {{name}}',
      trend_heading: 'Usage Trend',
      trend_coming: 'Usage chart (coming soon)',
      stat_products: 'Analyzed Products',
      stat_content: 'Generated Content',
      stat_translations: 'Translations',
      stat_images: 'Optimized Images',
    },
    support: {
      msg_sent: 'Message sent!',
      msg_err: 'Error sending message',
      status_open: 'Open',
      status_progress: 'In progress',
      status_closed: 'Closed',
      title: 'Support',
      subtitle: 'FAQ, guides and chat with our team',
      faq_heading: 'Frequently Asked Questions',
      guide_heading: 'Quick Guide',
      chat_heading: 'Support Chat',
      no_msgs: 'No messages',
      no_msgs_hint: 'Start a conversation with support',
      placeholder: 'Write a message...',
      contacts_heading: 'Contacts',
      contact_hours_label: 'Hours',
      contact_hours: 'Mon-Fri 9:00-18:00 CET',
      contact_response_label: 'Response time',
      contact_response: 'Within 24 hours',
      guide_step1: 'Go to the',
      guide_products: 'Products',
      guide_step1b: 'section to see your products',
      guide_step2: 'Select a product and go to',
      guide_ai_content: 'AI Content',
      guide_step3: 'Generate description, SEO title, meta description and keywords',
      guide_step4: 'Check the results in',
      guide_history: 'History',
    },
    transl: {
      load_err: 'Error loading items',
      published: 'Translation published to Shopify!',
      pub_err: 'Publication error',
      err_no_items: 'Select at least one item',
      err_no_fields: 'Select at least one field to translate',
      item_err: 'Translation error',
      done_one: 'Translation complete!',
      done_many: '{{n}} items translated!',
      copied: 'Copied to clipboard',
      title: 'Translations',
      gate_plan: 'Available from the Starter plan',
      gate_desc: 'Translate products, collections and articles into 8 languages with AI',
      gate_btn: 'Switch to Starter Plan',
      subtitle: 'Translate products, collections, articles and pages into multiple languages with AI',
      translating: 'Translating…',
      search_placeholder: 'Search by title…',
      select_page: 'Select page',
      sel_abbrev: 'sel.',
      total_items: 'total',
      loading: 'Loading…',
      no_results: 'No results for this search',
      prev: '← Prev',
      tot_abbrev: 'tot.',
      next: 'Next →',
      deselect_all: 'Deselect all',
      lang_heading: 'Target language',
      fields_heading: 'Fields to translate',
      select_hint: 'Select items from the list to enable translation',
      results_heading: 'Results',
      clear_results: 'Clear results',
      badge_published: 'Published',
      publishing: 'Publishing…',
      done: 'Done',
      publish: 'Publish',
      copy: 'Copy',
      tab_products: 'Products',
      tab_collections: 'Collections',
      tab_articles: 'Articles',
      tab_pages: 'Pages',
      field_title: 'Title',
      field_description: 'Description',
      field_seo_title: 'SEO Title',
      field_meta_description: 'Meta Description',
      field_body_html: 'Description / Body',
      empty_hint_select: 'Select one or more items from the list, choose the language and click',
      translate_label: 'Translate',
      items_selected: 'items',
      item_selected: 'item',
      selected_label: 'selected',
      choose_fields_hint: 'choose the fields and click Translate',
    },
  },

  de: {
    nav: {
      overview: 'Übersicht',
      catalog: 'Katalog',
      content: 'KI-Inhalte',
      translations: 'Übersetzungen',
      images: 'Bilder',
      batch: 'Batch-Operationen',
      speed: 'Speed Optimizer',
      history: 'Verlauf',
      usage: 'Nutzung & Plan',
      settings: 'Einstellungen',
      support: 'Support',
    },
    common: {
      save: 'Speichern',
      cancel: 'Abbrechen',
      delete: 'Löschen',
      close: 'Schließen',
      confirm: 'Bestätigen',
      loading: 'Wird geladen...',
      error: 'Fehler',
      success: 'Erfolg',
      search: 'Suchen',
      filter: 'Filtern',
      all: 'Alle',
      yes: 'Ja',
      no: 'Nein',
      back: 'Zurück',
      next: 'Weiter',
      apply: 'Anwenden',
      generate: 'Generieren',
      publish: 'Veröffentlichen',
      optimize: 'Optimieren',
      refresh: 'Aktualisieren',
    },
    settings: {
      title: 'Einstellungen',
      subtitle: 'KI-Kontrollzentrum',
      tabs: {
        general: 'Allgemein',
        localization: 'Lokalisierung',
        ai_engine: 'KI-Engine',
        appearance: 'Erscheinungsbild',
        piano: 'Plan',
        advanced: 'Erweitert',
      },
      save_btn: 'Einstellungen speichern',
      unsaved: 'Nicht gespeicherte Änderungen',
      action_loading: 'Wird verarbeitet...',
      general: {
        contents: 'Inhalte',
        default_lang: 'Standard-Inhaltssprache',
        tone: 'Globaler Inhaltston',
        tone_hint: 'Gilt für Produkte, Kollektionen, Artikel und Batches',
        seo_rules: 'SEO-Regeln',
        seo_title_max: 'Maximale SEO-Titellänge',
        seo_title_hint: 'Empfohlen: 50–60 Zeichen',
        meta_max: 'Maximale Meta-Beschreibungslänge',
        meta_hint: 'Empfohlen: 150–160 Zeichen',
        chars: 'Zeichen',
        images: 'Bildeinstellungen',
        img_format: 'Standardformat',
        img_square: 'Quadrat (1:1)',
        img_landscape: 'Querformat (4:3)',
        img_portrait: 'Hochformat (3:4)',
        img_quality: 'Komprimierungsqualität',
        img_quality_low: '50% (komprimiert)',
        img_quality_high: '100% (maximal)',
        store_info: 'Shop-Informationen',
        store_domain: 'Domain',
        store_plan: 'Plan',
        store_installed: 'Installiert',
      },
      ai: {
        strategy: 'KI-Strategie',
        params_title: 'Generierungsparameter',
        creativity: 'Kreativität',
        creative_low: 'Konservativ',
        creative_high: 'Kreativ',
        seo_strictness: 'SEO-Strenge',
        seo_low: 'Flexibel',
        seo_high: 'Streng',
        tone_label: 'Globaler Ton',
        auto_title: 'KI-Auto-Optimierung',
        auto_hint: 'Aktivieren um Inhalte automatisch zu optimieren',
        on: 'Aktiv',
        off: 'Aus',
        threshold: 'Optimierungsschwelle',
        threshold_low: 'Alles optimieren',
        threshold_high: 'Nur die schlechtesten',
        threshold_hint: 'Wirkt auf Elemente mit SEO-Score < {{n}}',
        frequency: 'Häufigkeit',
        scope: 'Umfang',
        triggers: 'Auslöser',
        img_format: 'Bildformat',
        img_square: 'Quadrat 1:1',
        img_square_sub: '800×800 px',
        img_landscape: 'Querformat 4:3',
        img_landscape_sub: '800×600 px',
        img_portrait: 'Hochformat 3:4',
        img_portrait_sub: '600×800 px',
        img_no_resize: 'Kein Resize',
        img_no_resize_sub: 'Originalgröße',
        compress: 'Komprimierung',
        compress_hint: 'Dateigröße reduzieren',
        quality: 'Qualität',
        daily_credits: 'KI-Credits heute',
        remaining: '{{n}} verbleibend',
        reset_in: 'Reset in',
        running: 'Läuft — {{done}}/{{total}} Produkte',
        run_now: 'Jetzt ausführen',
        run_desc: 'Elemente mit Score < {{threshold}} in: {{scope}} optimieren',
        preview_title: 'Vorschau — Vorher / Nachher',
        before: 'Vorher',
        after: 'Nach KI',
        no_keywords: 'keine Keywords',
        preview_note: 'Beispiel für Produkt «Laufschuh Pro X1» — sofortige Aktualisierung',
        alt_mode_label: 'ALT-Text-Generierungsmodus',
        alt_preview: 'Vorschau',
        alt_mode_ai: 'Intelligente KI',
        alt_mode_ai_desc: 'OpenAI generiert optimierten ALT für jedes Bild',
        alt_mode_template: 'Kostenloses Template',
        alt_mode_template_desc: 'Keine KI-Credits — verwendet das Template unten',
        alt_mode_auto: 'Auto-Fallback',
        alt_mode_auto_desc: 'KI wenn verfügbar, Template wenn Credits erschöpft',
        alt_hint_template: 'Kostenmodus: keine KI-Credits für ALT-Text verbraucht.',
        alt_hint_auto: 'Auto-Fallback: KI wenn Credits verfügbar, sonst automatisches Template.',
        pct_done: '{{pct}}% abgeschlossen',
        n_errors: '{{n}} Fehler',
        alt_template_label: 'Benutzerdefiniertes Template',
        alt_vars_label: 'Verfügbare Variablen — zum Einfügen klicken',
      },
      piano: {
        credits_title: 'Kreditverwendung',
        plan_label: 'Plan',
        extra_credits: 'Extrakredite',
        unlimited: '∞ Unbegrenzte Credits',
        unlimited_sub: 'Elite-Plan — kein monatliches Limit',
        plan_credits: 'Plan-Credits',
        consumed: 'Vom Plan verbraucht',
        residual: 'Plan-Rest',
        extra_available: 'Verfügbare Extrakredite',
        extra_sub: 'Erst nach dem Monatsplan verbraucht',
        total_available: 'Gesamt verfügbar',
        consumed_cycle: 'Im aktuellen Zyklus verbrauchte Credits',
        status_active: 'Aktiv',
        status_pending: 'Wird verarbeitet',
        status_frozen: '⚠ Gesperrt',
        status_free: 'Free / Kein Abonnement',
        trial_active: 'Testphase aktiv',
        trial_access: 'Vollzugriff bis {{date}}.',
        sub_status: 'Abonnementstatus',
        next_credit_reset: 'Nächster Kredit-Reset',
        trial_end: 'Testphasenende',
        trial_label: 'Kostenlose Testphase',
        trial_used: 'Bereits genutzt',
        trial_available: '{{n}} Tage verfügbar',
        cancel_btn: 'Abonnement kündigen',
        cancelling: 'Wird gekündigt...',
        plans_title: 'Verfügbare Pläne',
        plan_active: 'Aktiver Plan',
        plan_current: 'Aktueller Plan',
        per_month: '/Monat',
        downgrade: 'Zu Free wechseln',
        downgrading: 'Downgrade...',
        upgrade: 'Upgrade',
        downgrade_btn: 'Downgrade',
        redirecting: 'Weiterleitung...',
        trial_btn: 'Kostenlos testen',
        trial_btn_days: '({{n}}T)',
        plan_overage: 'Zusätzliche KI-Credits: {{price}} pro Credit',
        plan_no_overage: 'Keine Zusatzkosten für KI-Credits',
        plan_trial_line: '{{n}} Tage kostenlos testen',
        plans_note: 'Kostenpflichtige Pläne beinhalten eine {{n}}-tägige kostenlose Testphase. Keine Aktivierungsgebühr. Zahlungen über Shopify Billing.',
        credits_section: 'Extrakredite kaufen',
        credits_desc: 'Extrakredite werden zu Ihrem Monatsplan addiert und verfallen nie. Kompatibel mit allen Plänen.',
        one_time: 'einmalig',
        per_credit: '¢ pro Credit',
        buy: 'Kaufen',
        payment_note: 'Die Zahlung wird sicher über Shopify Billing abgewickelt. Keine Zahlungsdaten auf unserem Server.',
        history_title: 'Credit-Kaufhistorie',
        history_count: '{{n}} Kauf{{suffix}}',
        hist_invested: 'Gesamtinvestition',
        hist_bought: 'Gekaufte Credits',
        hist_available: 'Noch verfügbar',
        hist_empty: 'Keine Extrakreditkäufe getätigt.',
        hist_date: 'Datum',
        hist_pkg: 'Paket',
        hist_credits: 'Credits',
        hist_amount: 'Betrag',
        hist_status: 'Status',
        hist_completed: 'Abgeschlossen',
        hist_pending: 'Ausstehend',
        hist_declined: 'Abgelehnt',
        trend_title: 'Nutzungstrend',
        trend_placeholder: 'Nutzungsdiagramm (verfügbar mit Shopify Billing)',
        stats_products: 'Analysierte Produkte',
        stats_content: 'Generierte Inhalte',
        stats_translations: 'Übersetzungen',
        stats_images: 'Optimierte Bilder',
        toast_sub_pending: 'Abonnement wird verarbeitet — Sie erhalten in Kürze eine Bestätigung.',
        toast_sub_activated: '{{name}} aktiviert!',
        toast_trial_suffix: '({{n}} Tage kostenlose Testphase)',
        toast_sub_error: 'Fehler bei der Abonnementverifizierung',
        toast_purchase_duplicate: 'Kauf bereits registriert.',
        toast_credits_added: '+{{n}} Credits zu Ihrem Konto hinzugefügt!',
        toast_purchase_error: 'Fehler bei der Kaufverifizierung',
        toast_purchase_start_error: 'Fehler beim Starten des Kaufs',
        toast_sub_start_error: 'Fehler beim Starten des Abonnements',
        toast_store_unavailable: 'Shop noch nicht verbunden. Lade die App im Shopify Admin neu und versuche es erneut.',
        toast_sub_cancelled: 'Abonnement gekündigt. Plan auf Free zurückgesetzt.',
        toast_sub_cancel_error: 'Fehler bei der Abonnementkündigung',
        pkg_100_label: '100 Credits',
        pkg_100_desc: 'Ideal für gelegentliche Nutzung',
        pkg_300_label: '300 Credits',
        pkg_300_desc: '17% sparen',
        pkg_300_badge: '⭐ Am beliebtesten',
        pkg_700_label: '700 Credits',
        pkg_700_desc: '29% sparen',
        pkg_1500_label: '1.500 Credits',
        pkg_1500_desc: '33% sparen',
        pkg_1500_badge: '🔥 Bestes Angebot',
        plan_starter_badge: '⭐ Beliebtester Plan',
        plan_starter_benefit: 'Spart Stunden Arbeit jeden Monat.',
        plan_pro_badge: '🔥 SEO-Wachstum',
        plan_pro_benefit: 'Verbessert Indexierung und SEO-Performance.',
        plan_elite_badge: '🚀 Agenturen',
        plan_elite_benefit: 'Für Agenturen und Enterprise-Kataloge konzipiert.',
      },
      toast: {
        saved_at: 'Gespeichert um {{time}}',
        save_error: 'Speicherfehler',
        budget_exceeded: 'Tageskreditlimit erschöpft — {{done}} von {{total}} Produkten optimiert',
        autopilot_stopped: 'Autopilot gestoppt — {{done}} von {{total}} Produkten optimiert',
        images_optimized: 'Bilder optimiert — {{n}} Produkte',
        images_failed: '{{n}} Bilder nicht optimiert',
        autopilot_done: 'Autopilot abgeschlossen — {{started}} Produkte in der Warteschlange',
        autopilot_empty: 'Keine Elemente unterhalb der Schwelle',
        autopilot_stopping: 'Autopilot wird gestoppt...',
        reindex_started: 'Neuindizierung gestartet',
        resync_started: 'Neusynchronisierung gestartet',
        cache_cleared: 'Cache geleert',
        sync_reset: 'Sync-Status zurückgesetzt',
      },
      advanced: {
        warning: 'Die folgenden Aktionen beeinflussen das Systemverhalten. Nur bei Bedarf verwenden.',
        sync_title: 'Synchronisierung',
        reindex: 'Produkte neu indizieren',
        reindex_desc: 'SEO-Daten für alle Produkte in der Datenbank neu berechnen',
        resync: 'Mit Shopify neu synchronisieren',
        resync_desc: 'Vollständige Synchronisierung von Produkten und Kollektionen erzwingen',
        cache_title: 'Cache',
        clear_cache: 'Anwendungscache leeren',
        clear_cache_desc: 'Laufende Batches im Browser löschen. Unvollständige Operationen gehen verloren.',
        reset_credits: 'Tageskredite zurücksetzen',
        reset_credits_desc: 'KI-Credit-Zähler von heute zurücksetzen (dev). Limit: 5.000/Tag.',
        danger_zone: 'Gefahrenzone',
        reset_sync: 'Sync-Status zurücksetzen',
        reset_sync_desc: 'Sync-Reset erzwingen. Nur wenn Sync seit über 30 Minuten blockiert.',
      },
    },
    ai_engine: {
      preset: {
        growth_desc: 'Maximiert Conversions und Engagement',
        luxury_desc: 'Premium-Marke und exklusive Narrative',
        seo_desc: 'Maximiert organische Sichtbarkeit auf Google',
        balanced_desc: 'Optimale Balance zwischen Qualität und SEO',
      },
      tone: {
        professional: 'Professionell',
        professional_desc: 'Formell, autoritativ, baut Vertrauen auf',
        luxury: 'Luxury',
        luxury_desc: 'Elegant, exklusiv, premium',
        technical: 'Technisch',
        technical_desc: 'Präzise, Spezifikationen, messbare Daten',
        conversational: 'Konversationell',
        conversational_desc: 'Direkt, freundlich, ansprechend',
      },
      frequency: {
        daily: 'Täglich',
        daily_desc: '1× pro Tag',
        hourly: 'Stündlich',
        hourly_desc: 'Kontinuierlich',
        realtime: 'Sofort',
        realtime_desc: 'So bald wie möglich',
      },
      scope: {
        products: 'Produkte',
        collections: 'Kollektionen',
        articles: 'Artikel',
        pages: 'Seiten',
      },
      trigger: {
        seo_score: 'Niedriger SEO-Score',
        missing_meta: 'Fehlende Metadaten',
        missing_alt: 'Fehlender ALT-Text',
        outdated_desc: 'Veraltete Beschreibung',
        keywords: 'Fehlende Keywords',
        image_quality: 'Nicht optimierte Bilder',
      },
    },
    appearance: {
      title: 'Erscheinungsbild',
      theme_title: 'Design',
      theme: {
        light: 'Hell',
        dark: 'Dunkel',
        system: 'System',
      },
      density_title: 'Layout-Dichte',
      density: {
        compact: 'Kompakt',
        comfortable: 'Komfortabel',
        spacious: 'Geräumig',
        compact_desc: 'Mehr Inhalt',
        comfortable_desc: 'Ausgewogen',
        spacious_desc: 'Mehr Freiraum',
      },
      sidebar_title: 'Seitenleiste',
      sidebar: {
        expanded: 'Erweitert',
        collapsed: 'Reduziert',
        hidden: 'Versteckt',
        expanded_desc: 'Immer sichtbar',
        collapsed_desc: 'Nur Icons',
        hidden_desc: 'Bei Hover',
      },
    },
    localization: {
      ui_language: 'Oberflächensprache',
      select_language: 'App-Sprache auswählen',
      reload_note: 'Die Sprache wird sofort angewendet',
    },
    dashboard: {
      title: 'Übersicht',
      subtitle: 'Shop-Aktivitätszusammenfassung',
      products: 'Produkte',
      optimized: 'Optimiert',
      pending: 'Ausstehend',
      seo_score: 'SEO-Bewertung',
      audit_center: 'Audit Center',
      sync_products: 'Produkte synchronisieren',
      analyze_products: 'Produkte analysieren',
      audit_site: 'Site-Audit 360',
      syncing: 'Sync...',
      analyzing: 'Analyse...',
      auditing: 'Audit...',
      section_account: 'Konto & Plan',
      section_catalog: 'Katalogstatus',
      section_images: 'Bilder',
      section_seo_tech: 'Technisches SEO — Detaillierter Site-Audit',
      section_ux_trust: 'UX & Trust — Highlights',
      section_actions: 'KI-empfohlene Aktionen',
      recent_activity: 'Letzte Aktivitäten',
      hint_plan: 'Plan- und Kreditstatus',
      hint_never_synced: 'Nie synchronisiert',
      hint_priority: 'Nach Priorität sortiert',
      hint_last_sync: 'Letzte Sync {{date}}',
      current_plan: 'Aktueller Plan',
      credits_used: 'Verwendete Credits',
      credits_remaining: 'Verbleibende Credits',
      public_domain: 'Öffentliche Domain',
      credit_usage: 'Kreditnutzung',
      hint_installed: 'Installiert {{date}}',
      hint_pct_plan: '{{pct}}% des Plans',
      hint_limit: 'Limit {{n}}',
      hint_last_audit: 'Letzter Audit {{date}}',
      hint_no_audit: 'Kein Audit durchgeführt',
      no_audit: 'Kein Audit durchgeführt',
      no_audit_desc: 'Führen Sie einen Audit durch, um Title, Meta, H1, Canonical, Robots, Sitemap, HTTPS, OG, JSON-LD, Performance, Bilder und Links zu analysieren.',
      run_audit: 'Audit starten',
      in_progress: 'Läuft...',
      audit_phase: 'Audit läuft (Phase: {{phase}})...',
      ux_highlights: 'UX Highlights',
      trust_compliance: 'Trust & Compliance',
      mobile_viewport: 'Mobile Viewport:',
      favicon: 'Favicon:',
      images_without_alt_label: 'Bilder ohne ALT:',
      lazy_loading: 'Lazy Loading:',
      images_suffix: 'Bilder',
      internal_links: 'Interne Links:',
      data_unavailable: 'Daten nicht verfügbar: {{reason}}',
      analysis_not_run: 'Analyse nicht durchgeführt',
      not_detected: 'Nicht erkannt',
      no_trust_data: 'Keine Trust-Daten verfügbar',
      no_activity: 'Keine aktuellen Aktivitäten.',
      activity_completed: 'Abgeschlossen',
      activity_error: 'Fehler',
      no_store_title: 'Kein Shop verbunden',
      no_store_desc: 'Installieren Sie die App in einem Shopify-Shop, um zu beginnen',
      connect_store: 'Shopify-Shop verbinden',
      no_token_title: 'OAuth-Token fehlt',
      no_token_desc: 'Shop {{domain}} ist registriert, hat aber kein Token. Installieren Sie die App neu.',
      reinstall_app: 'App über OAuth neu installieren',
      sync_in_progress: 'Produktsynchronisierung läuft…',
      sync_in_progress_detail: '{{synced}} / {{total}} Produkte. Dashboard-Daten werden nach Abschluss aktualisiert.',
      stale_data: 'Veraltete Daten: Letzte gültige Zahlen werden angezeigt, während die Synchronisierung läuft.',
      catalog_score_label: 'Katalog-Score',
      seo_distribution: 'SEO-Verteilung',
      n_products: '{{n}} Produkte',
      pct_of_catalog: '{{pct}}% des Katalogs',
      no_description: 'Keine Beschreibung',
      no_meta_description: 'Keine Meta-Beschreibung',
      seo_needs_improvement: 'SEO verbesserungsbedürftig',
      view: 'Anzeigen',
      seo_good_desc: 'Der Katalog hat eine gute SEO-Abdeckung. Halten Sie den Standard hoch, indem Sie neue Produkte optimieren.',
      seo_medium_desc: 'Der Katalog hat eine mittlere SEO-Abdeckung. Priorität: Meta-Beschreibungen und Produktbeschreibungen.',
      seo_poor_desc: 'Der Katalog hat eine niedrige SEO-Abdeckung. Priorität: Meta-Beschreibungen, Beschreibungen und fehlende Bilder.',
      seo_optimized: 'Optimiert',
      seo_medium: 'Mittel',
      seo_poor: 'Verbesserungsbedürftig',
      content_seo_title: 'SEO-Status nach Inhaltstyp',
      open_catalog: 'Katalog öffnen',
      row_collections: 'Kollektionen',
      row_articles: 'Artikel',
      row_pages: 'Seiten',
      coming_soon: 'Demnächst',
      not_synced: 'Nicht synchronisiert',
      seo_coverage_fmt: '{{opt}}/{{total}} optimiert · {{score}}/100',
      alt_coverage: 'ALT-Text-Abdeckung',
      with_alt_count: '{{n}} mit ALT von {{total}}',
      image_optimization_label: 'Bildoptimierung',
      optimized_count: '{{n}} optimiert von {{total}}',
      with_alt: 'Mit ALT',
      without_alt: 'Ohne ALT',
      image_optimized: 'Optimiert',
      image_needs_improvement: 'Verbesserungsbedürftig',
      no_image: 'Kein Bild',
      savings: 'Einsparungen',
      optimize_images_btn: 'Bilder optimieren',
      view_no_image: 'Produkte ohne Bild anzeigen',
      alt_manager: 'ALT Text Manager',
      toast_sync_done: 'Synchronisierung abgeschlossen. Katalog wird abgeglichen...',
      toast_catalog_reconciled: 'Katalog abgeglichen: {{n}} Produkte ({{removed}} verwaiste entfernt)',
      toast_sync_first: 'Zuerst Produkte synchronisieren',
      toast_avg_score: 'Durchschnittlicher Score {{score}}/100',
      toast_audit_done: 'Audit abgeschlossen: {{score}}/100',
      toast_sync_reset: 'Sync-Status zurückgesetzt',
      toast_sync_reset_error: 'Sync-Status konnte nicht zurückgesetzt werden',
      op_description: 'KI-Beschreibung',
      op_seo_title: 'SEO-Titel',
      op_meta_description: 'Meta-Beschreibung',
      op_keywords: 'Keywords',
      op_translation: 'Übersetzung',
      op_image_opt: 'Bildoptimierung',
      op_sync: 'Shopify-Sync',
      op_seo_analysis: 'Shop-SEO-Analyse',
      op_site_audit: 'Site-Audit 360',
      prompt_domain: 'Gib die Domain deines Shopify-Shops ein',
      hint_force_reset: 'Sync-Status zurücksetzen (löscht keine Produkte)',
    },
    products: {
      title: 'Produktkatalog',
      search: 'Produkte suchen...',
      all: 'Alle',
      optimized: 'Optimiert',
      pending: 'Ausstehend',
      status_generating: 'Generierung',
      status_writing: 'Schreiben',
      status_validating: 'Validierung',
      status_failed: 'Fehlgeschlagen',
      status_sync_failed: 'Shopify Sync',
      status_optimized: 'Optimiert',
      status_medium: 'Mittel',
      status_needs_improvement: 'Zu verbessern',
      type_collection_singular: 'Kollektion',
      type_collection_plural: 'Kollektionen',
      sync_collections: 'Kollektionen synchronisieren',
      empty_collections: 'Keine Kollektionen. Klicke auf "Kollektionen synchronisieren" um sie von Shopify zu importieren.',
      search_collections: 'Kollektion nach Titel oder Handle suchen...',
      col_label_products: 'Produkte',
      type_article_singular: 'Artikel',
      type_article_plural: 'Artikel',
      sync_articles: 'Artikel synchronisieren',
      empty_articles: 'Keine Artikel. Klicke auf "Artikel synchronisieren" um sie von Shopify zu importieren.',
      search_articles: 'Artikel nach Titel, Handle oder Blog suchen...',
      col_label_blog: 'Blog',
      type_page_singular: 'Seite',
      type_page_plural: 'Seiten',
      sync_pages: 'Seiten synchronisieren',
      empty_pages: 'Keine Seiten. Klicke auf "Seiten synchronisieren" um sie von Shopify zu importieren.',
      search_pages: 'Seite nach Titel oder Handle suchen...',
      col_label_author: 'Autor',
      catalog_title: 'Katalog',
      no_store: 'Kein Store',
      tab_products: 'Produkte',
      tab_collections: 'Kollektionen',
      tab_articles: 'Artikel',
      tab_pages: 'Seiten',
      sort_updated: 'Aktualisiert',
      sort_seo_score: 'SEO-Score',
      sort_title: 'Titel',
      sort_vendor: 'Vendor',
      sort_created: 'Erstellt',
      sort_desc: 'Absteigend',
      sort_asc: 'Aufsteigend',
      filter_seo_all: 'SEO: alle',
      filter_optimized: 'Optimiert',
      filter_medium: 'Mittel',
      filter_needs_improvement: 'Zu verbessern',
      filter_image_all: 'Bilder: alle',
      filter_image_yes: 'Mit Bildern',
      filter_image_no: 'Ohne Bilder',
      filter_meta_all: 'Meta: alle',
      filter_meta_yes: 'Mit Meta',
      filter_meta_no: 'Ohne Meta',
      filter_desc_all: 'Beschreibung: alle',
      filter_desc_yes: 'Mit Beschreibung',
      filter_desc_no: 'Ohne Beschreibung',
      filter_vendor_all: 'Vendor: alle',
      filter_collection_all: 'Kollektion: alle',
      filter_type_all: 'Typ: alle',
      reset_filters: 'Filter zurücksetzen',
      th_image: 'Bild',
      th_title: 'Titel',
      th_seo_score: 'SEO-Score',
      th_alt: 'ALT',
      th_meta: 'Meta',
      th_status: 'Status',
      th_actions: 'Aktionen',
      no_products_filters: 'Keine Produkte mit diesen Filtern gefunden',
      no_products: 'Keine Produkte. Synchronisiere von deinem Shopify-Shop.',
      pagination: 'Seite {{page}} von {{total}} · {{count}} Produkte',
      batch_btn: 'Batch-Operationen',
      dialog_status: 'Status',
      dialog_seo_score: 'SEO-Score',
      dialog_shopify_id: 'Shopify-ID',
      dialog_vendor: 'Vendor',
      dialog_serp: 'SERP-Vorschau',
      dialog_issues: 'SEO-Probleme',
      dialog_suggestions: 'Vorschläge',
      generating: 'Generiere...',
      generate_all: 'Alle Inhalte generieren',
      action_generate_ai: 'KI-Inhalte generieren',
      action_translate: 'Übersetzen',
      action_optimize_image: 'Bild optimieren',
      syncing: 'Synchronisierung...',
      draft_ready: 'Entwurf bereit',
      seo_ai_btn: 'SEO KI',
      batch_ops_btn: 'Batch-Operationen',
      diagnosis: 'Diagnose',
      current_score: 'Aktueller Score',
      projected: '→ erwartet {{score}}/100',
      meta_title: 'Meta-Titel',
      meta_desc_label: 'Meta-Beschreibung',
      description_label: 'Beschreibung',
      generate_desc_btn: 'KI-Beschreibung generieren',
      generating_desc: 'Generiere...',
      generate_ai_btn: 'Mit KI generieren',
      publish_shopify_btn: 'Auf Shopify veröffentlichen',
      publishing: 'Veröffentlichen...',
      discard_draft_btn: 'Entwurf verwerfen',
      seo_ai_dialog_title: 'SEO KI',
      seo_all: 'SEO: alle',
      seo_optimized: 'Optimiert',
      seo_medium: 'Mittel',
      seo_needs: 'Zu verbessern',
      page_of: 'Seite {{page}} von {{total}}',
      search_placeholder: 'Suche nach Titel, SKU, EAN, Hersteller, Handle...',
      chars_count: '{{n}}/{{max}} Zeichen',
      n_selected_info: 'ausgewählt',
      filtered: 'gefiltert',
      soon_tooltip: 'Demnächst verfügbar',
      resource_subtitle: '{{type}} Shopify und ihr SEO-Status',
      articles_blog: 'Artikel (Blog)',
      select_visible_title: 'Alle sichtbaren aus-/abwählen',
      toast_draft_ready: 'SEO-Entwurf erstellt. Überprüfen und veröffentlichen.',
      toast_error_ai: 'KI-Generierungsfehler',
      toast_desc_generated: 'KI-Beschreibung generiert.',
      toast_error_desc: 'Fehler bei der Beschreibungsgenerierung',
      toast_empty_draft: 'Mindestens ein Feld generieren oder ausfüllen',
      toast_published_score: 'Auf Shopify veröffentlicht · Score {{score}}/100',
      toast_error_publish: 'Fehler beim Veröffentlichen auf Shopify',
      toast_draft_discarded: 'Entwurf verworfen',
      toast_select_items: 'Mindestens ein Element auswählen',
      toast_mode_publish: 'Veröffentlichung',
      toast_mode_both: 'Generieren+Veröffentlichen',
      toast_mode_generate: 'KI SEO-Generierung',
      toast_batch_launched: '{{label}} auf {{count}} {{type}} gestartet.',
      toast_batch_errors: '{{label}} mit {{count}} Fehlern abgeschlossen',
      toast_batch_done: '{{label}} auf {{count}} {{type}} abgeschlossen',
      toast_synced: '{{type}} synchronisiert: {{count}}',
      toast_sync_error: 'Synchronisierungsfehler {{type}}',
      toast_token_error: 'Shopify-Token abgelaufen oder fehlende Berechtigungen',
      reinstall_label: 'Neuinstallieren',
      toast_sync_started: '{{type}} Synchronisierung gestartet',
      toast_error_sync_start: 'Fehler beim Starten der Synchronisierung',
      toast_perms_ok: 'Berechtigungen ok ({{kind}})',
      toast_token_revoked: 'Token widerrufen',
      toast_perms_missing: 'Fehlende Berechtigungen',
      toast_diag_error: 'Diagnosefehler',
      toast_score: 'Score {{score}}/100',
      toast_error_analyze: 'Analysefehler',
      toast_generated: 'Inhalte generiert',
      toast_error_generate: 'Generierungsfehler',
    },
    content: {
      title: 'Inhaltsgenerierung',
      generate: 'Inhalt generieren',
      language: 'Sprache',
      tone: 'Ton',
      subtitle: 'Beschreibungen, SEO-Titel, Meta-Beschreibung und Keywords mit KI generieren',
      tab_products: 'Produkte',
      tab_collections: 'Kollektionen',
      tab_articles: 'Artikel',
      tab_pages: 'Seiten',
      type_description_label: 'Beschreibung',
      type_description_hint: 'Ansprechender und SEO-freundlicher Produkttext',
      type_seo_title_label: 'SEO-Titel',
      type_seo_title_hint: 'Für SERP optimierter Titel (max. 60 Zeichen)',
      type_meta_desc_label: 'Meta-Beschreibung',
      type_meta_desc_hint: 'Google-Snippet (max. 160 Zeichen)',
      type_keywords_label: 'Keywords',
      type_keywords_hint: 'Primäre und sekundäre Keywords',
      type_body_label: 'Beschreibung / Text',
      type_body_hint: 'Haupttext der Ressource',
      filter_all: 'Alle',
      filter_needs: 'Zu verbessern',
      filter_medium: 'Mittel',
      filter_optimized: 'Optimiert',
      no_results_filters: 'Keine Elemente entsprechen den Filtern',
      select_all: 'Alle auswählen',
      deselect: 'Abwählen',
      selected_count: '{{count}} ausgewählt',
      selected_max: '(max)',
      deselect_all: 'Alle abwählen',
      pagination_of: '{{page}} / {{total}}',
      total_count: '({{count}} ges.)',
      content_type_section: 'Inhaltstyp',
      batch_generating: 'Generiere… {{done}}/{{total}}',
      batch_generate_btn: 'Batch generieren ({{count}})',
      generating_count: 'Generiere ({{count}})',
      generate_btn: 'Generieren',
      generating: 'Generiere…',
      generate_all_btn: 'Alle',
      hint_select: '← Element auswählen oder mehrere für Batch ankreuzen',
      hint_batch_ready: '{{count}} Element(e) bereit für Batch',
      batch_done_title: '✓ Batch abgeschlossen',
      batch_pending_title: 'Batch ausstehend…',
      batch_in_progress_title: 'Batch-Generierung läuft…',
      batch_done_msg: 'Alle Inhalte generiert. Die Auswahl wird automatisch geleert.',
      results_section: 'Ergebnisse',
      publishing: 'Veröffentliche…',
      published: 'Veröffentlicht',
      publish_btn: 'Auf Shopify veröffentlichen',
      clear_results: 'Löschen',
      chars_unit: 'Zeichen',
      cache_label: 'Cache',
      preview_section: 'Aktuelle Vorschau',
      loading_detail: 'Detail laden…',
      not_present: 'Nicht vorhanden',
      not_present_plural: 'Nicht vorhanden',
      empty_state: 'Element anklicken zum Ansehen, oder mehrere ankreuzen und Batch generieren verwenden',
      copy_btn: 'Kopieren',
      type_seo_title_hint_content: 'Meta-Titel für SERP (max. 60 Zeichen)',
      no_items: 'Keine {{type}} gefunden',
      item_deselect: 'Abwählen',
      item_select: 'Zur Auswahl hinzufügen',
      generate_all_title: 'Alle verfügbaren Typen generieren',
      prev_item: 'Vorheriges Element',
      next_item: 'Nächstes Element',
      toast_load_error: 'Fehler beim Laden der Elemente',
      toast_batch_done: 'Batch abgeschlossen: {{done}}/{{total}} Produkte',
      toast_batch_failed: 'Batch fehlgeschlagen: {{failed}} Fehler von {{total}}',
      toast_batch_cancelled: 'Batch abgebrochen',
      toast_batch_resumed: 'Aktiver Batch wieder aufgenommen…',
      toast_max_select: 'Maximal {{max}} Elemente auswählbar',
      toast_select_item: 'Ein Element aus der Liste auswählen',
      toast_select_type: 'Mindestens einen Inhaltstyp auswählen',
      toast_from_cache: 'Inhalt aus dem Cache!',
      toast_generated: 'Erfolgreich generiert!',
      toast_generate_error: 'Fehler bei der Inhaltsgenerierung',
      toast_batch_running: 'Ein Batch-Prozess läuft bereits',
      toast_no_store: 'Shop nicht verfügbar',
      toast_batch_started: 'Batch gestartet: {{n}} Produkte in der Warteschlange',
      toast_batch_start_error: 'Fehler beim Starten des Batches',
      toast_batch_item_error: 'Generierungsfehler: {{title}}',
      toast_batch_complete: 'Batch abgeschlossen: {{done}}/{{total}} Elemente',
      toast_cancel_error: 'Fehler beim Abbrechen des Batches',
      toast_published: 'Inhalt bei Shopify veröffentlicht!',
      toast_publish_error: 'Fehler beim Veröffentlichen',
      toast_copied: 'In die Zwischenablage kopiert',
      present: 'vorhanden',
      missing: 'fehlend',
      lang_it: 'Italienisch',
      lang_en: 'Englisch',
      lang_fr: 'Französisch',
      lang_de: 'Deutsch',
      lang_es: 'Spanisch',
      lang_pt: 'Portugiesisch',
      tone_professional: 'Professionell',
      tone_luxury: 'Luxus',
      tone_technical: 'Technisch',
      tone_conversational: 'Konversationell',
    },
    images: {
      title: 'Bildoptimierung',
      optimize: 'Optimieren',
      format: 'Format',
      compress: 'Komprimieren',
      quality: 'Qualität',
      alt_mode_label: 'ALT-Generierungsmodus',
      alt_mode_ai: 'KI-intelligent',
      alt_mode_template: 'Kostenloses Template',
      alt_mode_auto: 'Auto Fallback',
      subtitle: 'Bilder optimieren, ALT-Text verwalten und auf Shopify veröffentlichen.',
      tab_optimize: 'Bilder optimieren',
      tab_alt: 'ALT-Text',
      alt_coverage: 'ALT-Abdeckung',
      with_alt_count: 'mit ALT von',
      stat_with_alt: 'Mit ALT: {{count}}',
      stat_without_alt: 'Ohne ALT: {{count}}',
      stat_no_image: 'Ohne Bild: {{count}}',
      sync_alt_btn: 'ALT-Daten von Shopify aktualisieren',
      syncing_alt: 'ALT wird aktualisiert...',
      sync_status_label: 'Status:',
      analyzed_label: 'Analysiert:',
      last_updated_label: 'Letztes Update:',
      stalled: 'blockiert',
      force_stop: 'Stopp erzwingen (60s blockiert)',
      free_badge: '● Kostenlos — keine Credits',
      configure_btn: '▼ Konfigurieren',
      hide_btn: '▲ Ausblenden',
      template_free_hint: 'Kostenloser Modus aktiv — null KI-Credits. Template:',
      template_auto_hint: 'Auto-Fallback — KI wenn Credits verfügbar, sonst lokales Template.',
      template_config_title: 'ALT-Template konfigurieren',
      template_label: 'Benutzerdefiniertes Template',
      template_preview: 'Vorschau:',
      variables_label: 'Verfügbare Variablen — klicke zum Einfügen:',
      restore_default: 'Standard wiederherstellen',
      save_config: 'Konfiguration speichern',
      saving: 'Speichere...',
      search_placeholder: 'Nach Titel, Vendor, Handle suchen...',
      filter_all_images: 'Alle',
      filter_with_alt: 'Mit ALT',
      filter_without_alt: 'Ohne ALT',
      selected_images: '{{count}} Bilder ausgewählt (max. 50 pro Batch)',
      generate_batch_btn: 'ALT für Ausgewählte generieren',
      batch_alt_in_progress: 'ALT-Batch läuft: {{done}} / {{total}}',
      batch_errors: '{{n}} Fehler',
      select_all_label: 'Alle auswählen',
      deselect_all_label: 'Alle abwählen',
      total_products_label: '{{count}} Produkte',
      timeout_title: 'Laden hat zu lange gedauert (20s)',
      timeout_desc: 'Die Datenbank verarbeitet viele Produkte. Versuche es in einigen Sekunden erneut.',
      error_title: 'Fehler beim Laden der Liste',
      no_products_filter: 'Keine Produkte entsprechen den Filtern',
      alt_placeholder: 'ALT-Text (max. 125 Zeichen)',
      status_published: 'Veröffentlicht',
      status_saved: 'Gespeichert',
      status_draft_alt: 'Entwurf',
      status_missing: 'Kein ALT',
      generate_alt_btn: 'ALT generieren',
      save_alt_btn: 'ALT speichern',
      publish_alt_btn: 'Veröffentlichen',
      prec: 'Zurück',
      succ: 'Weiter',
      select_products: 'Produkte auswählen',
      filter_collection_all: 'Kollektion: alle',
      filter_vendor_all: 'Vendor: alle',
      filter_kb_all: 'KB: alle',
      filter_kb_100: 'Dateien über 100 KB',
      filter_kb_500: 'Dateien über 500 KB',
      filter_kb_1mb: 'Dateien über 1 MB',
      filter_format_all: 'Format: alle',
      filter_landscape: 'Breite größer als Höhe',
      filter_portrait: 'Höhe größer als Breite',
      filter_square: 'Quadratisch',
      filter_status_all: 'Status: alle',
      filter_status_optimized: 'Bereits optimiert',
      filter_status_needs: 'Zu optimieren',
      visible_total: '{{visible}} sichtbar · {{total}} gesamt',
      reset_filters: 'Filter zurücksetzen',
      clear_selection: 'Auswahl leeren',
      no_image_products: 'Keine Produkte mit Bild',
      ready_badge: 'Bereit',
      settings_title: 'Einstellungen',
      format_title: 'Bildformat',
      format_square: 'Quadrat 1:1',
      format_landscape: 'Landscape 4:3',
      format_portrait: 'Portrait 3:4',
      format_none: 'Kein Resize',
      format_none_sub: 'Originalgröße',
      compress_label: 'Komprimierung',
      compress_desc: 'Dateigröße reduzieren',
      quality_label: 'Qualität',
      batch_opt_running: 'Optimierung läuft',
      batch_opt_cancelled: 'Optimierung abgebrochen',
      batch_opt_completed: 'Optimierung abgeschlossen',
      batch_apply_running: 'Anwendung läuft',
      batch_apply_cancelled: 'Anwendung abgebrochen',
      batch_apply_completed: 'Anwendung abgeschlossen',
      background_note: 'Du kannst die Sektion wechseln, läuft im Hintergrund weiter',
      optimizing: 'Optimiere...',
      optimize_n: '{{count}} Bilder optimieren',
      optimize_one: 'Bild optimieren',
      applying: 'Wende an...',
      apply_n: '{{count}} auf Shopify anwenden',
      apply_one: 'Auf Shopify anwenden',
      preview_title: 'Vorschau',
      ready_optimizations: '{{count}} Optimierungen bereit',
      select_preview_hint: 'Wähle ein oder mehrere Produkte um die Vorschau zu sehen',
      first_product_preview: 'Vorschau für das erste ausgewählte Produkt:',
      original_label: 'Original',
      optimized_label: 'Optimiert',
      optimize_click_hint: 'Klicke auf "Optimieren" für das Ergebnis',
      reduction_label: 'Reduzierung',
      apply_btn: 'Anwenden',
      history_opt_title: 'Optimierungsverlauf',
      history_opt_subtitle: 'Auf Shopify angewendete Operationen, Fehler und Wiederherstellungen.',
      stat_running_label: 'Laufend',
      stat_completed_label: 'Abgeschlossen',
      stat_errors_label: 'Unvollständig',
      stat_undo_label: 'Rückgängig',
      total_savings: 'Gesamtersparnis',
      history_loading: 'Verlauf laden...',
      no_history: 'Noch keine Operationen angewendet.',
      restoring: 'Wiederherstelle...',
      undo_btn: 'Rückgängig',
      kb_warning: 'KB-Größe ist nicht in lokalen Daten. Für Genauigkeit muss sie vom Backend beim Bild-Sync gespeichert werden.',
      senza_vendor: 'Kein Vendor',
      alt_stat_coverage: '{{n}} mit ALT von {{total}}',
      apply_batch_cancelled: 'Anwendung abgebrochen',
      apply_batch_done_label: 'Anwendung abgeschlossen',
      apply_batch_running: 'Anwendung läuft',
      apply_n_btn: '{{n}} auf Shopify anwenden',
      applying_btn: 'Wende an...',
      auto_fallback_hint: 'Auto-Fallback — KI wenn Credits verfügbar, sonst lokales Template.',
      background_hint: 'Du kannst die Sektion wechseln, läuft im Hintergrund weiter',
      badge_draft: 'Entwurf',
      badge_missing: 'Kein ALT',
      badge_published: 'Veröffentlicht',
      badge_ready: 'Bereit',
      badge_saved: 'Gespeichert',
      batch_close: 'Schließen',
      batch_generate_btn: 'ALT für Ausgewählte generieren',
      batch_progress: 'ALT-Batch läuft: {{done}} / {{total}}',
      batch_selected: '{{n}} Bilder ausgewählt (max. 50 pro Batch)',
      collection_all: 'Kollektion: alle',
      compress_sub: 'Dateigröße reduzieren',
      config_btn: '▼ Konfigurieren',
      deselect_all: 'Alle abwählen',
      empty_filtered: 'Keine Produkte entsprechen den Filtern',
      filter_all: 'Alle',
      format_label: 'Bildformat',
      gen_alt_btn: 'ALT generieren',
      history_completed: 'Abgeschlossen',
      history_empty: 'Noch keine Operationen angewendet.',
      history_incomplete: 'Unvollständig',
      history_running: 'Laufend',
      history_savings: 'Gesamtersparnis',
      history_subtitle: 'Auf Shopify angewendete Operationen, Fehler und Wiederherstellungen.',
      history_title: 'Optimierungsverlauf',
      history_undo_label: 'Rückgängig',
      last_update_label: 'Letztes Update:',
      load_error: 'Fehler beim Laden der Liste',
      n_errors: '{{n}} Fehler',
      n_products: '{{n}} Produkte',
      n_selected: '{{n}} ausgewählt',
      next_page: 'Weiter',
      no_products: 'Keine Produkte mit Bild',
      no_vendor: 'Kein Vendor',
      opt_batch_cancelled: 'Optimierung abgebrochen',
      opt_batch_done: 'Optimierung abgeschlossen',
      opt_batch_running: 'Optimierung läuft',
      optimize_n_btn: '{{n}} Bilder optimieren',
      optimize_one_btn: 'Bild optimieren',
      optimizing_btn: 'Optimiere...',
      orientation_all: 'Format: alle',
      orientation_landscape: 'Breite größer als Höhe',
      orientation_portrait: 'Höhe größer als Breite',
      orientation_square: 'Quadratisch',
      page_info: 'Seite {{page}} von {{total}}',
      pagination: 'Seite {{page}} von {{total}}',
      prev: 'Zurück',
      publish_btn: 'Veröffentlichen',
      retry: 'Wiederholen',
      select_all: 'Alle auswählen',
      size_100kb: 'Dateien über 100 KB',
      size_1mb: 'Dateien über 1 MB',
      size_500kb: 'Dateien über 500 KB',
      size_all: 'KB: alle',
      status_all: 'Status: alle',
      status_label: 'Status:',
      status_needs: 'Zu optimieren',
      status_optimized: 'Bereits optimiert',
      status_stalled: 'blockiert',
      sync_btn: 'ALT-Daten von Shopify aktualisieren',
      sync_btn_title: 'Liest Bilder und ALT-Texte erneut von Shopify',
      syncing: 'ALT wird aktualisiert...',
      template_active: 'Kostenloser Modus aktiv — null KI-Credits. Template:',
      template_custom_label: 'Benutzerdefiniertes Template',
      template_free_badge: '● Kostenlos — keine Credits',
      template_preview_label: 'Vorschau:',
      template_reset: 'Standard wiederherstellen',
      template_save: 'Konfiguration speichern',
      template_saving: 'Speichere...',
      template_vars_label: 'Verfügbare Variablen — klicke zum Einfügen:',
      timeout_msg: 'Die Datenbank verarbeitet viele Produkte. Versuche es in einigen Sekunden erneut.',
      toast_alt_ai: 'ALT über KI generiert',
      toast_alt_cancelled: 'ALT-Aktualisierung abgebrochen — du kannst es neu starten',
      toast_alt_empty: 'Leerer ALT',
      toast_alt_from_cache: 'ALT aus Cache',
      toast_alt_gen_error: 'ALT-Generierungsfehler',
      toast_alt_publish_error: 'Veröffentlichungsfehler',
      toast_alt_published: 'Auf Shopify veröffentlicht',
      toast_alt_save_error: 'Speicherfehler',
      toast_alt_saved: 'ALT gespeichert',
      toast_alt_sync_start_error: 'Fehler beim Starten der ALT-Aktualisierung',
      toast_alt_sync_started: 'ALT-Datenaktualisierung gestartet',
      toast_alt_template: 'ALT über Template generiert (kostenlos)',
      toast_alt_template_fallback: 'ALT über Template (Credits erschöpft)',
      toast_alt_update_error: 'ALT-Aktualisierungsfehler',
      toast_alt_updated: 'ALT-Daten aktualisiert: {{n}} Produkte analysiert',
      toast_applied: 'Bild auf Shopify angewendet',
      toast_apply_batch_done: '{{n}} Bilder auf Shopify angewendet',
      toast_apply_batch_errors: 'Anwendung abgeschlossen mit {{n}} Fehlern',
      toast_apply_batch_started: 'Anwendung gestartet: {{n}} Bilder. Du kannst die Sektion wechseln.',
      toast_batch_alt_done: 'Batch abgeschlossen',
      toast_batch_alt_started: 'Batch gestartet: {{n}} Bilder, {{c}} gleichzeitig',
      toast_batch_done: 'Batch abgeschlossen: {{n}} Bilder optimiert. Du kannst sie auf Shopify anwenden.',
      toast_batch_errors: '{{n}} Bilder nicht verarbeitet. Wiederholen oder Logs prüfen.',
      toast_batch_started: 'Batch gestartet: {{n}} Bilder. Du kannst die Sektion wechseln, läuft im Hintergrund.',
      toast_cancel_error: 'Abbruchfehler',
      toast_no_draft: 'Kein optimiertes Bild zum Anwenden',
      toast_no_images: 'Kein Bild ausgewählt',
      toast_no_ready: 'Keine Optimierung bereit zum Anwenden',
      toast_no_store: 'Store nicht verfügbar',
      toast_optimize_error: 'Optimierungsfehler',
      toast_optimized: 'Bild optimiert. Du kannst es jetzt auf Shopify anwenden.',
      toast_select_product: 'Mindestens ein Produkt auswählen',
      toast_template_save_error: 'Fehler beim Speichern des Templates',
      toast_template_saved: 'Template-Konfiguration gespeichert',
      toast_undo_done: 'Originalbild wiederhergestellt',
      toast_undo_error: 'Fehler bei der Wiederherstellung',
      undoing_btn: 'Wiederherstelle...',
      vendor_all: 'Vendor: alle',
      toast_no_product: 'Produkt auswählen',
      toast_no_image: 'Das Produkt hat kein Bild',
      toast_no_preview: 'Zuerst ein Bild optimieren',
      toast_apply_error: 'Fehler beim Anwenden auf Shopify',
      n_ready: '{{n}} Optimierungen bereit',
      preview_hint: 'Wähle ein oder mehrere Produkte um die Vorschau zu sehen',
      preview_first: 'Vorschau für das erste ausgewählte Produkt:',
      click_optimize_hint: 'Klicke auf "Optimieren" für das Ergebnis',
      apply_single_btn: 'Anwenden',
    },
    alt_template: {
      section_title: 'ALT-Template',
      mode_label: 'ALT-Text-Generierungsmodus',
      textarea_label: 'Benutzerdefiniertes Template',
      preview_label: 'Vorschau',
      vars_label: 'Verfügbare Variablen — klicken zum Einfügen',
      hint_template: 'Kostenloser Modus: keine KI-Credits für ALT-Text.',
      hint_auto: 'Auto Fallback: KI wenn Credits vorhanden, sonst lokales Template.',
    },
    batch: {
      title: 'Batch-Operationen',
      start: 'Starten',
      cancel: 'Abbrechen',
      subtitle: 'Persistente serverseitige Verarbeitung — läuft weiter auch beim Seitenwechsel',
      locked_title: 'Batch-Operationen nicht verfügbar',
      locked_desc: 'Batch-Operationen sind ab dem Starter-Plan verfügbar. Verarbeite Hunderte von Produkten parallel mit einem Klick.',
      upgrade_btn: 'Zu Starter wechseln',
      op_content_label: 'KI-Inhalte generieren',
      op_content_desc: 'Beschreibung, SEO-Titel, Meta-Beschreibung, Keywords',
      op_translate_label: 'Produkte übersetzen',
      op_translate_desc: 'Vollständige Übersetzung in die gewählte Sprache',
      op_images_label: 'Bilder optimieren',
      op_images_desc: '1:1-Größenanpassung und Bildkomprimierung',
      field_description_label: 'Beschreibung',
      field_description_hint: '150-250 Wörter',
      field_seo_title_label: 'SEO-Titel',
      field_seo_title_hint: 'max. 60 Zeichen',
      field_meta_desc_label: 'Meta-Beschreibung',
      field_meta_desc_hint: '100-160 Zeichen',
      field_keywords_label: 'Keywords',
      field_keywords_hint: '5-10 Keywords',
      count_all: 'Alle',
      status_pending: 'In Warteschlange',
      status_running: 'Läuft',
      status_completed: 'Abgeschlossen',
      status_failed_job: 'Fehlgeschlagen',
      status_cancelled: 'Abgebrochen',
      opt_in_progress: 'Bildoptimierung läuft…',
      batch_in_progress: 'KI-Batch läuft…',
      images_progress: '{{done}} / {{total}} Bilder',
      products_progress: '{{done}} / {{total}} Produkte',
      errors_count: '{{count}} Fehler',
      duration_label: 'Dauer: {{time}}',
      starting: 'Starte...',
      seo_gen_in_progress: 'SEO generieren + veröffentlichen läuft',
      gen_publish_auto: 'Automatische Generierung und Veröffentlichung auf Shopify',
      section_operation: 'Operation',
      section_fields: 'Zu generierende Felder',
      fields_selected: '{{count}}/{{total}} ausgewählt',
      fields_warning: 'Wähle mindestens ein Feld um den Batch zu starten',
      fields_hint: 'Ein KI-Aufruf pro Produkt generiert alle ausgewählten Felder — geringere Latenz und reduzierte Kosten.',
      section_options: 'Optionen',
      label_language: 'Sprache',
      label_tone: 'Ton',
      tone_professional: 'Professionell',
      tone_luxury: 'Luxury',
      tone_technical: 'Technisch',
      tone_conversational: 'Konversationell',
      label_target_lang: 'Zielsprache',
      images_note: '1:1-Größenanpassung (800×800) + 85% Qualitätskomprimierung.',
      section_quantity: 'Produktmenge',
      available_count: '{{count}} verfügbar',
      catalog_selection: '{{count}} Produkt(e) aus dem Katalog ausgewählt',
      remove_selection: 'Auswahl aufheben',
      products_selected_count: '{{count}} Produkt(e) ausgewählt',
      processing: 'Verarbeitung läuft…',
      start_btn: 'Verarbeitung starten',
      history_title: 'Batch-Verlauf',
      history_subtitle: 'aus DB aktualisiert',
      stat_running: 'Laufend',
      stat_completed: 'Abgeschlossen',
      stat_products_ok: 'Produkte OK',
      no_batch: 'Kein Batch ausgeführt',
      no_batch_hint: 'Jobs erscheinen hier nach der ersten Verarbeitung',
      job_content: 'KI-Inhalte generieren',
      job_translate: 'Übersetzung',
      job_images: 'Bildoptimierung',
      job_products: '{{done}}/{{total}} Produkte',
      log_lang: 'Sprache:',
      log_tone: 'Ton:',
      toast_completed: 'Batch abgeschlossen: {{done}}/{{total}} Produkte verarbeitet',
      toast_failed: 'Batch fehlgeschlagen: {{count}} Fehler',
      toast_no_products: 'Keine Produkte verfügbar',
      soon_lbl: 'bald',
      btn_analyze_seo: 'SEO analysieren',
      btn_view: 'Ansehen',
      toast_no_fields: 'Mindestens ein zu generierendes Feld auswählen',
      toast_images_started: 'Bildoptimierung gestartet: {{count}} Produkte',
      toast_started: 'Batch gestartet: {{count}} Produkte',
      toast_start_error: 'Fehler beim Starten',
      toast_cancelled: 'Batch abgebrochen',
      toast_cancel_error: 'Abbruchfehler',
      fields_label: 'Felder',
      log_summary: 'Einzeloperationsprotokoll',
    },
    history: {
      title: 'Verlauf',
      empty: 'Keine Operationen gefunden',
      subtitle: 'Vollständiges Audit aller KI-Ausführungen — {{n}} Operationen insgesamt',
      refresh_btn: 'Aktualisieren',
      total_operations: 'Gesamt Operationen',
      success_rate: 'Erfolgsrate',
      n_successes: '{{n}} Erfolge',
      credits_today: 'Credits heute',
      products_today: 'Produkte heute',
      avg_duration: 'Ø Dauer',
      last_autopilot: 'Letzter Autopilot',
      filters: 'Filter',
      filters_active: 'aktiv',
      reset_all: 'Alle zurücksetzen',
      search_placeholder: 'Produkt suchen...',
      op_all: 'Alle Typen',
      op_description: 'KI-Beschreibung',
      op_seo_title: 'SEO-Titel KI',
      op_meta_description: 'Meta-Beschreibung KI',
      op_batch: 'Batch-Generierung',
      op_translation: 'Übersetzung',
      op_image: 'Bild',
      op_sync: 'Shopify-Sync',
      trigger_all: 'Alle Trigger',
      status_all: 'Alle Status',
      status_success: 'Erfolg',
      status_partial: 'Teilweise',
      status_error: 'Fehler',
      th_status: 'Status',
      th_type: 'Operationstyp',
      th_product: 'Produkt',
      th_trigger: 'Trigger',
      th_seo_delta: 'SEO Delta',
      th_credits: 'Credits',
      th_duration: 'Dauer',
      th_timestamp: 'Zeitstempel',
      loading: 'Wird geladen...',
      remove_filters: 'Filter entfernen',
      load_more: 'Mehr laden ({{shown}} von {{total}} angezeigt)',
      details_title: 'Ausführungsdetails',
      detail_op_id: 'Vorgangs-ID',
      detail_product_id: 'Produkt-ID',
      detail_store_id: 'Shop-ID',
      detail_type: 'Typ',
      detail_trigger: 'Trigger',
      detail_status: 'Status',
      detail_language: 'Sprache',
      detail_tone: 'Ton',
      detail_tokens: 'Verwendete Token',
      detail_fields: 'Felder',
      detail_credits: 'Credits',
      detail_duration: 'Dauer',
      detail_seo_before: 'SEO vorher',
      detail_seo_after: 'SEO nachher',
      detail_timestamp: 'Zeitstempel',
      error_prefix: 'Fehler: ',
      label_description: 'KI-Beschreibung',
      label_seo_title: 'SEO-Titel KI',
      label_meta_description: 'Meta-Beschreibung KI',
      label_keywords: 'Keywords KI',
      label_batch: 'Batch-Generierung',
      label_translation: 'Übersetzung',
      label_image: 'Bildoptimierung',
      label_sync: 'Shopify-Sync',
      label_push: 'Shopify-Veröffentlichung',
    },
    batch_banner: {
      errors: 'Fehler',
      optimizing: 'Bildoptimierung',
      optimizing_cancelled: 'Optimierung abgebrochen',
      optimizing_completed: 'Optimierung abgeschlossen',
      applying: 'Anwendung auf Shopify',
      applying_cancelled: 'Anwendung abgebrochen',
      applying_completed: 'Anwendung abgeschlossen',
      open_images: 'Bilder öffnen',
      open_catalog: 'Katalog öffnen',
      type_collections: 'Kollektionen',
      type_articles: 'Artikel',
      type_pages: 'Seiten',
      type_contents: 'Inhalte',
      mode_publish: 'Veröffentlichung',
      mode_both: 'Generieren+Veröffentlichen',
      mode_generate: 'KI SEO-Generierung',
      state_cancelled: '(abgebrochen)',
      state_completed: '(abgeschlossen)',
    },
    app_banner: {
      expired: 'Shopify-Token abgelaufen oder widerrufen.',
      reconnect_desc: 'App neu verbinden, um Sync und Veröffentlichung wiederherzustellen.',
      detected_in: 'erkannt in',
      reconnect_btn: 'Jetzt neu verbinden',
    },
    review_popup: {
      greeting: 'Hallo! Ich bin hier 👋',
      subtitle: 'Ich hoffe, alles läuft super mit AI Optimizer!',
      rating_title: 'Gefällt dir die App?',
      rating_desc: 'Deine Meinung hilft uns, uns zu verbessern und andere Shopify-Händler zu erreichen.',
      rating_tap: 'Tippe auf einen Stern zum Bewerten',
      star: {
        terrible: 'Schrecklich',
        bad: 'Nicht gut',
        average: 'Durchschnittlich',
        good: 'Gut!',
        excellent: 'Ausgezeichnet! 🚀',
      },
      positive_title: 'Fantastisch! Vielen Dank 🎉',
      positive_desc: 'Eine Bewertung im Shopify App Store macht einen riesigen Unterschied für uns. Es dauert nur 1 Minute!',
      negative_title: 'Danke für das Feedback 🙏',
      negative_desc: 'Hast du Ideen, was wir besser machen könnten?',
      review_btn: '⭐ Bewertung abgeben',
      close_btn: 'Schließen',
      dismiss: 'Nicht mehr anzeigen',
      skip: 'Überspringen →',
    },
    support: {
      title: 'Support',
      send: 'Senden',
      placeholder: 'Schreiben Sie Ihre Nachricht...',
    },
    editor: {
      placeholder: 'Hier schreiben...',
      bold: 'Fett',
      italic: 'Kursiv',
      underline: 'Unterstrichen',
      h2: 'Überschrift H2',
      h3: 'Überschrift H3',
      paragraph: 'Absatz',
      ul: 'Aufzählungsliste',
      ol: 'Nummerierte Liste',
      blockquote: 'Zitat',
      link: 'Link einfügen',
      remove_format: 'Formatierung entfernen',
      link_prompt: 'Link-URL',
    },
    recommendations: {
      empty: 'Keine kritischen Aktionen im Moment. Gut gemacht!',
      filter_all_prio: 'Alle Prioritäten',
      filter_all_cat: 'Alle Kategorien',
      count_shown: '{{n}} Aktionen angezeigt',
      see: 'Ansehen',
      sev_high: 'Hoch',
      sev_medium: 'Mittel',
      sev_low: 'Niedrig',
      cat_catalog: 'Katalog',
      missing_meta_description: '{{count}} Produkte ohne Meta-Beschreibung',
      missing_description: '{{count}} Produkte ohne Beschreibung',
      missing_alt_text: '{{count}} Bilder ohne ALT-Text',
      missing_product_image: '{{count}} Produkte ohne Bild',
    },
    audit: {
      not_detected: 'Nicht erkannt',
      disabled: 'Deaktiviert',
      not_scanned: 'Analyse nicht durchgeführt',
      status_warning: 'Warnung',
      status_error: 'Fehler',
      cat_performance: 'Performance',
      cat_trust: 'Vertrauen',
      cat_catalog: 'Katalog',
      checks_suffix: 'Prüfungen',
      badge_err: 'Err',
      badge_warn: 'Warn',
      badge_ok: 'OK',
      value_label: 'Wert',
      checks: {
        title: { name: 'Titel', hint: 'Seitentitel' },
        meta_description: { name: 'Meta-Beschreibung', hint: 'Meta-Beschreibung der Startseite' },
        h1: { name: 'H1', hint: 'Genau 1 H1 pro Seite ist optimal' },
        h2: { name: 'H2', hint: 'Mindestens ein H2 empfohlen' },
        canonical: { name: 'Canonical', hint: 'Kanonische URL' },
        lang: { name: 'Sprache', hint: 'Sprachattribut' },
        json_ld_structured_data: { name: 'JSON-LD / Strukturierte Daten', hint: 'Strukturierte Daten' },
        open_graph: { name: 'Open Graph', hint: 'Social Meta' },
        twitter_card: { name: 'Twitter Card', hint: 'Meta Twitter/X' },
        robots_txt: { name: 'robots.txt', hint: 'Robots' },
        sitemap_xml: { name: 'Sitemap.xml', hint: 'Sitemap' },
        status_code: { name: 'Statuscode', hint: 'HTTP-Statuscode' },
        indexability: { name: 'Indexierbarkeit', hint: 'Indexierbarkeit' },
        redirects: { name: 'Weiterleitungen', hint: 'Finale URL' },
        https: { name: 'HTTPS', hint: 'HTTPS' },
        load_time: { name: 'Ladezeit', hint: 'Server-zu-Server gemessen' },
        page_weight: { name: 'Seitengewicht', hint: 'HTML-Größe der Startseite' },
        image_lazy_loading: { name: 'Lazy Loading Bilder', hint: 'Lazy-Bilder' },
        mobile_viewport: { name: 'Mobile Viewport', hint: 'Mobile Viewport' },
        favicon: { name: 'Favicon', hint: 'Favicon' },
        images_with_alt: { name: 'Bilder mit ALT', hint: 'Bild-Zugänglichkeit' },
        privacy_policy: { name: 'Datenschutzrichtlinie', hint: 'Datenschutz' },
        cookie_policy: { name: 'Cookie-Richtlinie', hint: 'Cookie' },
        terms_conditions: { name: 'AGB', hint: 'Bedingungen' },
        contact_page: { name: 'Kontaktseite', hint: 'Kontakt' },
        shipping_policy: { name: 'Versandrichtlinie', hint: 'Versand' },
        returns_refunds: { name: 'Rückgabe & Erstattung', hint: 'Rückgaben' },
        social_links: { name: 'Social-Links', hint: 'Social' },
        products_without_description: { name: 'Produkte ohne Beschreibung', hint: 'Produktbeschreibungen' },
        products_without_images: { name: 'Produkte ohne Bilder', hint: 'Produktbilder' },
        products_without_meta_description: { name: 'Produkte ohne Meta-Beschreibung', hint: 'Produkt-Meta-Beschreibungen' },
        duplicate_titles: { name: 'Doppelte Titel', hint: 'Produkttitel' },
        duplicate_meta_descriptions: { name: 'Doppelte Meta-Beschreibungen', hint: 'Produkt-Meta-Beschreibungen' },
        thin_content_200_char: { name: 'Dünner Inhalt (<200 Zeichen)', hint: 'Produktinhalt' },
      },
    },
    score_card: {
      pillar_technical_seo: 'Technisches SEO',
      pillar_ux: 'UX',
      pillar_performance: 'Performance',
      pillar_trust: 'Trust',
      pillar_catalog: 'Katalog',
      label_excellent: 'Hervorragend',
      label_good: 'Verbesserbar',
      label_critical: 'Kritisch',
      no_audit_desc: 'Audit noch nicht ausgeführt — führen Sie das Audit aus, um technisches SEO, UX, Trust und Performance zu erhalten.',
      auditing: 'Audit läuft...',
      run_audit: 'Site-Audit 360° ausführen',
      calculated_on: 'Berechnet für',
    },
    upgrade: {
      popular: '⭐ Beliebtester',
      period: '/Monat',
      plan_header: 'Plan',
      cta: 'Upgrade zu {{name}} — {{price}}{{period}}',
      dismiss: 'Nicht jetzt',
      feature_available: '{{feature}} ist ab dem Plan {{plan}} verfügbar.',
      reason_credits_title: 'KI-Credits erschöpft',
      reason_credits_body: 'Sie haben das monatliche Limit Ihres Plans erreicht. Führen Sie ein Upgrade durch, um weiterhin Inhalte zu generieren.',
      reason_products_title: 'Kataloglimit erreicht',
      reason_products_body: 'Ihr Shopify-Katalog überschreitet das aktuelle Planlimit. Führen Sie ein Upgrade durch, um alle Produkte zu synchronisieren.',
      reason_feature_title: 'Premium-Funktion',
      reason_feature_body: 'Diese Funktion ist in höheren Plänen verfügbar.',
    },
    gsc: {
      connect_title: 'Google Search Console verbinden',
      connect_desc: 'Impressionen, Klicks, CTR und durchschnittliche Position überwachen. Neuindexierung nach KI-Optimierungen anfordern.',
      connect_feat_analytics: 'Suchanalysen',
      connect_feat_indexing: 'Indexierungs-Monitoring',
      connect_feat_keywords: 'Keyword-Tracking',
      connect_feat_sitemap: 'Sitemap-Manager',
      connect_btn_loading: 'Verbindung wird hergestellt...',
      connect_btn: 'Google-Konto verbinden',
      prop_modal_title: 'Property auswählen',
      prop_modal_desc: 'Wähle die Search Console Property aus, die verknüpft werden soll.',
      prop_modal_empty: 'Keine Properties gefunden. Stelle sicher, dass du Properties in Google Search Console hast.',
      prop_modal_cancel: 'Abbrechen',
      prop_modal_confirm: 'Bestätigen',
      coming_soon_desc: 'Verfügbar in {{phase}}',
      top_opp_title: 'Top SEO-Chancen',
      top_opp_sub: 'Top 10 Abfragen nach Opportunity Score',
      copy: 'Kopieren',
      copied: 'Kopiert!',
      badge_quick_win: '🔥 Quick Win',
      badge_low_ctr: '⚡ Niedriger CTR',
      badge_page_1: '🚀 Seite 1',
      badge_high_imp: '📈 Hohe Sichtbarkeit',
      badge_brand: '🏷️ Brand',
      qt_category: 'Kategorie',
      qt_product: 'Produkt',
      qt_generic: 'Generisch',
      qt_info: 'Info',
      qt_brand: 'Brand',
      seo_analysis: 'SEO-Analyse',
      generating_ai: 'KI-Analyse wird generiert...',
      analysis_error: 'Fehler beim Generieren der Analyse. Später erneut versuchen.',
      estimated_value: 'Geschätzter Wert',
      clicks_monthly: 'Potenzielle Klicks/Monat',
      ctr_at_pos: 'CTR bei Pos. {{pos}}',
      traffic_increase: 'Traffic-Steigerung',
      current_stats: 'Aktuell: {{clicks}} Klicks/Monat · +{{pts}} pp geschätzter CTR',
      priority_action: 'Prioritätsaktion',
      content_opt: 'Inhaltsoptimierung',
      title_seo: 'Title SEO',
      title_chars: '(50–60 Zeichen)',
      title_copied: 'Title kopiert!',
      h1_suggested: 'Vorgeschlagenes H1',
      h1_page_title: '(Seitentitel)',
      h1_copied: 'H1 kopiert!',
      meta_desc: 'Meta Description',
      meta_chars: '(150–160 Zeichen)',
      meta_copied: 'Meta kopiert!',
      faq_all_copied: 'Alle FAQs kopiert!',
      faq_suggested: 'Vorgeschlagene FAQs',
      copy_all: 'Alle kopieren',
      faq_copied: 'FAQ kopiert!',
      related_kw: 'Verwandte Keywords',
      click_to_copy: '· klicken zum Kopieren',
      kw_copied: '"{{kw}}" kopiert!',
      tech_suggestions: 'Technische Vorschläge',
      copy_keyword: 'Keyword kopieren',
      kw_copied_plain: 'Keyword kopiert!',
      shopify_products: 'Shopify-Produkte',
      search_store: 'Im Shop suchen',
      optimize_content: 'Inhalt optimieren',
      col_impressions: 'Impressionen',
      col_position: 'Position',
      no_queries: 'Keine Abfragen mit den aktuellen Filtern gefunden.',
      ai_panel_title: 'KI-Vorschläge',
      analyze_query: 'Abfrage analysieren →',
      sugg_title_improvement: 'Title tag',
      sugg_meta: 'Meta description',
      sugg_content_gap: 'Fehlender Inhalt',
      sugg_schema: 'Schema markup',
      sugg_links: 'Interne Links',
      opp_load_err: 'Fehler beim Laden der SEO-Chancen',
      cache_updated: 'Cache aktualisiert — Daten werden neu geladen',
      cache_error: 'Fehler beim Cache-Refresh',
      loading_data: 'Search Console-Daten werden geladen...',
      load_error_title: 'Chancen können nicht geladen werden',
      retry: 'Erneut versuchen',
      tracked_queries: 'Verfolgte Abfragen',
      sku_excluded: '{{n}} SKU/EAN ausgeschlossen',
      total_impressions: 'Impressionen gesamt (28T)',
      total_clicks: 'Klicks gesamt (28T)',
      avg_ctr: 'Durchschn. CTR',
      ai_generating: 'KI-Analyse wird generiert...',
      ai_generating_sub: 'KI-Vorschläge werden in Kürze hier angezeigt.',
      no_ai_insights: 'Keine KI-Erkenntnisse verfügbar',
      no_ai_insights_sub: 'Es wurden keine Abfragen mit signifikanten Optimierungsmöglichkeiten gefunden.',
      filter_all: 'Alle ({{n}})',
      search_placeholder: 'Abfragen suchen...',
      refresh_title: 'Daten aktualisieren',
      page_prev: '← Vorh.',
      page_info: 'S. {{page}} / {{total}} · {{count}} Abfragen',
      page_next: 'Nächste →',
      footer_note: 'Search Console-Daten letzte 28 Tage · 6h Cache · Property: {{url}}',
      footer_excluded: ' · {{n}} SKU/EAN ausgeschlossen',
      verdict_pass: 'Indexiert',
      verdict_fail: 'Nicht indexiert',
      verdict_neutral: 'Ausgeschlossen',
      stato_title: 'Google-Status — Datenquellen',
      in_sitemap: 'In Sitemap',
      sitemap_registered_lbl: 'Registrierte Sitemaps',
      sitemap_errors_lbl: 'Sitemap-Fehler',
      with_impressions: 'Mit Impressionen',
      search_appear_note: 'In Suche erschienene Seiten · {{days}}T',
      not_real_indexed: '≠ tatsächlich indexierte Seiten',
      index_estimate_lbl: 'Indexierungsschätzung',
      estimate_unavail: 'Schätzung verfügbar nach 200 inspizierten URLs. Batch-Scan starten, um die Stichprobe zu erfassen.',
      inspected_lbl: 'Inspiziert',
      indexed_confirmed: 'Bestätigt indexiert',
      not_indexed_lbl: 'Nicht indexiert',
      excluded_lbl: 'Ausgeschlossen',
      certain_data: 'Sichere Daten für inspizierte URLs',
      batch_title: 'Batch-Scan — Inspection API',
      batch_priority: 'Analytics-Priorität',
      batch_progress: 'Fortschritt der Sitemap-Inspektion',
      batch_stopping: 'Wird gestoppt…',
      batch_running: 'Scannen…',
      batch_starting: 'Starten...',
      batch_done_lbl: 'Sitemap abgeschlossen ✓',
      batch_start_btn: 'Scan starten ({{n}} verfügbar)',
      batch_timeout: 'Timeout — zum Zurücksetzen klicken',
      batch_stopping_wait: 'Stoppen — bitte warten…',
      batch_stop_btn: 'Scan stoppen',
      batch_remaining: '{{n}} URLs noch zu inspizieren',
      batch_quota_out: 'Tageskontingent erschöpft — morgen erneut versuchen',
      batch_start_err: 'Fehler beim Starten des Scans',
      batch_complete: 'Scan abgeschlossen: {{n}} URLs inspiziert',
      dq_title: 'API Technische Details',
      dq_api_status: 'API-Status',
      dq_daily_quota: 'Tageskontingent',
      dq_used_today: 'Heute verwendet',
      dq_remaining: 'Verbleibend',
      dq_history: 'Inspektionsverlauf',
      dq_completion: 'Fertigstellung',
      dq_days_est: 'geschätzte Tage',
      dq_start_for_eta: 'Scan starten, um ETA zu berechnen',
      sm_no_sitemap: 'Keine Sitemap gefunden',
      sm_no_sitemap_desc: 'Fügen Sie eine sitemap.xml zu Google Search Console hinzu, um die Indexierung zu überwachen.',
      sm_submit_ok: 'Sitemap an Google übermittelt',
      sm_in_progress: 'Wird berechnet…',
      sm_submit_btn: 'Einreichen',
      insp_title: 'URL prüfen',
      insp_quota: '{{used}}/{{limit}} Prüfungen heute',
      insp_loading: 'Prüfung...',
      insp_btn: 'Prüfen',
      insp_domain_lbl: 'Property-Domain:',
      insp_domain_note: 'Die geprüfte URL muss dazu gehören',
      insp_last_crawl: 'Letztes Crawl',
      insp_indexing: 'Indexierung',
      insp_yes: 'Ja',
      insp_no: 'Nein',
      insp_canonical_decl: 'Angegebener Canonical',
      insp_canonical_diff: '⚠ Google Canonical (abweichend)',
      insp_noindex: 'noindex erkannt',
      insp_open_gsc: 'In Search Console öffnen',
      insp_err: 'URL-Prüfungsfehler',
      cov_title: 'Coverage — Gründe',
      cov_real_data: 'Echte Daten — Inspection API',
      cov_conf_high: 'Hohe Zuverlässigkeit',
      cov_conf_medium: 'Mittlere Zuverlässigkeit',
      cov_conf_low: 'Geringe Zuverlässigkeit',
      cov_updated: 'Aktualisiert:',
      cov_deselect: 'Abwählen',
      cov_inspected_note: 'Geprüfte URLs · zum Filtern klicken',
      cov_none_inspected: 'Keine Prüfungen',
      cov_no_data: 'Keine Coverage-Daten verfügbar',
      cov_no_data_desc: 'Nicht-Indexierungsgründe werden automatisch bei jeder URL-Prüfung erstellt. Starten Sie den automatischen Scan, um diesen Bereich zu befüllen.',
      cov_solution: 'Empfohlene Lösung',
      cov_filter_active: 'Filter aktiv in der Chronik',
      ih_worklist: 'SEO-Aufgabenliste',
      ih_history: 'Inspektionsverlauf',
      ih_filter_coverage: 'Coverage-Filter',
      ih_tab_all: 'Alle',
      ih_tab_not_ind: 'Nicht ind.',
      ih_tab_indexed: 'Indexiert',
      ih_tab_excluded: 'Ausgeschlossen',
      ih_tab_errors: 'Fehler',
      ih_tab_with_imp: 'Mit Impr.',
      ih_tab_products: 'Produkte',
      ih_tab_collections: 'Kollektionen',
      ih_sort_priority: '↓ Priorität',
      ih_sort_impressions: '↓ Impressionen',
      ih_sort_clicks_est: '↓ Gesch. Klicks',
      ih_sort_date: '↓ Datum',
      ih_sort_state: '↓ GSC-Status',
      ih_clear: 'Löschen',
      ih_search: 'URL suchen…',
      ih_open: 'Öffnen',
      ih_indexing_state: 'Indexierungsstatus',
      ih_canonical_diff: '⚠ Google Canonical (gewählt, abweichend)',
      ih_canonical_same: 'Google Canonical (gleich)',
      ih_ai_fix: 'Mit AI optimieren →',
      ih_total: '{{n}} URLs · {{total}} insgesamt',
      ih_est_clicks: '· +{{n}} gesch. Klicks/Monat',
      iai_title: 'AI-Vorschläge — Indexierung',
      iai_filter_note: '· zum Filtern klicken',
      iai_prio_high: 'Hohe Priorität',
      iai_prio_medium: 'Mittlere Priorität',
      iai_prio_low: 'Niedrige Priorität',
      iai_causes: 'Mögliche Ursachen:',
      iai_actions: 'Empfohlene Maßnahmen:',
      fix_apply_all: 'Alle anwenden',
      fix_applied: 'Angewendet',
      fix_suggestion: 'Vorschlag',
      fix_chars: 'Zeichen',
      fix_content_impr: 'Inhaltsverbesserungen',
      fix_int_links: 'Empfohlene interne Links',
      fix_open_url: 'URL öffnen',
      fix_close: 'Schließen',
      fix_seo_opt: 'SEO-Optimierung',
      trend_title: 'Indexierungstrend',
      trend_updated: 'Aktualisiert zum',
      trend_coverage: 'Abdeckung',
      trend_30d_kpi: 'Trend 30T',
      trend_no_data: 'Historische Daten werden aufgebaut',
      trend_no_data_desc: 'Der Trend ist verfügbar, nachdem mindestens 2 Snapshots gesammelt wurden.',
      trend_one_snap: '1 Snapshot von 2 gesammelt.',
      trend_start_scan: 'Starten Sie einen Batch-Scan, um zu beginnen.',
      trend_ind: 'ind.',
      trend_not_ind: 'nicht ind.',
      trend_snap_note: 'Snapshot pro Scan',
      ic_loading: 'Indexierungsdaten werden geladen...',
      ic_load_err: 'Indexierungsdaten können nicht geladen werden',
      ic_clear_confirm: 'Gesamten Inspektionsverlauf löschen?',
      ic_cleared: 'Verlauf gelöscht',
      ic_clear_err: 'Löschfehler',
      ic_seo_opp: 'SEO-Chancen — Executive Summary',
      ic_recoverable: 'Wiederherstellbare URLs',
      ic_open_worklist: '⚡ Aufgabenliste öffnen →',
      ic_view_all: 'Alle anzeigen →',
      ic_crawled_ni: 'Gecrawlt – nicht indexiert',
      ic_crawled_ni_note: 'Google kennt sie, liefert sie aber nicht aus',
      ic_discovered_ni: 'Entdeckt – nicht indexiert',
      ic_discovered_ni_note: 'Gefunden aber nie gecrawlt',
      ic_with_imp_ni: 'Mit GSC-Impressionen',
      ic_with_imp_ni_note: 'Haben Traffic, sind aber nicht indexiert',
      ic_other_ni: 'Andere nicht indexierte',
      ic_other_ni_note: 'Google unbekannt oder Fehler',
      ic_refresh: 'Aktualisieren',
      rh_title: 'Änderungshistorie',
      rh_versions: 'Versionen',
      rh_confirm: "Version vom {{date}} wiederherstellen?\n\nDie aktuellen Änderungen im Editor werden ersetzt.",
      rh_restored_ok: 'v{{v}} im Shopify-Theme wiederhergestellt',
      rh_restored_editor: 'Version v{{v}} im Editor geladen — klicken Sie auf Speichern, um sie anzuwenden',
      rh_restore_err: 'Wiederherstellungsfehler',
      rh_current: 'aktuell',
      rh_initial: 'Anfangsversion',
      rh_no_diff: 'Keine Textänderungen',
      rh_more_added: '+ {{n}} weitere hinzugefügt',
      rh_more_removed: '- {{n}} weitere entfernt',
      rh_restore_btn: 'Wiederherstellen',
      rb_load_err: 'Fehler beim Laden von robots.txt',
      rb_save_err: 'Speicherfehler',
      rb_analyze_err: 'Analysefehler',
      rb_score_good: 'Ausgezeichnet',
      rb_score_ok: 'Verbesserungsbedarf',
      rb_score_bad: 'Kritisch',
      rb_analysis_title: 'SEO-Robots-Analyse',
      rb_analyzing: 'Analysiere…',
      rb_analyze: 'Analysieren',
      rb_analyze_hint: 'Klicken Sie auf "Analysieren", um SEO-Probleme und Optimierungsmöglichkeiten automatisch zu erkennen',
      rb_no_issues: 'Keine Probleme erkannt',
      rb_no_issues_desc: 'Ihre robots.txt folgt den Shopify-Best-Practices',
      rb_critical: 'KRITISCH',
      rb_warning: 'WARNUNG',
      rb_validation_title: 'Robots.txt-Validierung',
      rb_reload: 'Neu laden',
      rb_editor_title: 'Robots.txt-Editor',
      rb_modified: 'Geändert',
      rb_diff_close: 'Diff schließen',
      rb_editor_restore: 'Wiederherstellen',
      rb_saving: 'Speichern…',
      rb_save: 'Speichern',
      rb_blocking_warning: '🚨 SIE BLOCKIEREN DIE GESAMTE WEBSITE — "Disallow: /" verhindert, dass Google eine Seite indexiert',
      rb_diff_preview: 'Änderungsvorschau:',
      rb_opportunity: 'CHANCE',
      rb_checker_title: 'URL prüfen',
      rb_check_btn: 'Prüfen',
      rb_allowed: 'Erlaubt',
      rb_blocked: 'Gesperrt',
      rb_sitemaps_title: 'Deklarierte Sitemaps',
      ll_history_title: 'LLMs.txt-Verlauf',
      ll_generated: 'Generiert',
      ll_restored_editor: 'Version v{{v}} im Editor geladen — klicken Sie auf Veröffentlichen, um sie anzuwenden',
      ll_load_err: 'Fehler beim Laden von llms.txt',
      ll_generate_err: 'Generierungsfehler',
      ll_saved_ok: 'LLMs.txt veröffentlicht und im Shopify-Theme verifiziert',
      ll_not_configured: 'Nicht konfiguriert',
      ll_validation_title: 'LLMs.txt-Validierung',
      ll_not_found: 'Kein llms.txt auf der Website gefunden. Verwenden Sie "Aus Shopify generieren" um es automatisch zu erstellen.',
      ll_what_title: 'Was ist LLMs.txt?',
      ll_what_desc: 'Der /llms.txt-Standard ist eine Markdown-Datei, die KI-Modellen (ChatGPT, Claude, Perplexity, Gemini) hilft, Ihre Website zu verstehen und sie in Antworten korrekt zu zitieren. Erhöht die Sichtbarkeit in KI-Antwortsystemen.',
      ll_editor_title: 'LLMs.txt-Editor',
      ll_generating: 'Generierung…',
      ll_generate_btn: 'Aus Shopify generieren',
      tab_jsonld: 'JSON-LD',
      jl_load_err: 'Fehler beim Laden der JSON-LD-Übersicht',
      jl_sec_overview: 'Übersicht',
      jl_sec_schemas: 'Schemata',
      jl_sec_problems: 'Probleme',
      jl_sec_generate: 'KI-Optimierung',
      jl_sec_preview: 'JSON-Vorschau',
      jl_sec_validate: 'Validierung',
      jl_sec_bulk: 'Massenoperationen',
      jl_sec_stats: 'Statistiken',
      jl_rich_results: 'Rich-Results-Berechtigung',
      jl_eligible: 'Berechtigt',
      jl_warnings: 'Teilweise',
      jl_not_eligible: 'Nicht berechtigt',
      jl_field_coverage: 'Feldabdeckung',
      jl_what_title: 'Was ist JSON-LD?',
      jl_what_desc: 'JSON-LD ist das von Google empfohlene Format für strukturierte Daten. Es ermöglicht Rich Results in der Suche (Sterne, Preise, Breadcrumbs) und hilft KI-Modellen, Ihre Produkte besser zu verstehen.',
      jl_score_poor: 'Schlechte Abdeckung',
      jl_schemas_title: 'Unterstützte Schema-Typen',
      jl_status_valid: 'Gültig',
      jl_status_partial: 'Teilweise',
      jl_status_missing: 'Nicht konfiguriert',
      jl_valid_items: 'gültig',
      jl_issues: 'Probleme',
      jl_google_test: 'In Google Rich Results testen',
      jl_google_test_desc: 'Nach der JSON-LD-Generierung direkt im Google-Tool auf Berechtigung prüfen.',
      jl_problems_title: 'Diagnoseprobleme',
      jl_no_problems: 'Keine kritischen Probleme gefunden. Ihre JSON-LD-Abdeckung sieht gut aus!',
      jl_products_affected: 'betroffene Produkte',
      jl_sev_critical: 'Kritisch',
      jl_sev_warning: 'Warnung',
      jl_prob_brand: 'Fehlende Marke / Hersteller',
      jl_prob_desc: 'Fehlende Beschreibung',
      jl_prob_image: 'Fehlendes Produktbild',
      jl_prob_sku: 'Fehlende SKU',
      jl_prob_gtin: 'Fehlender GTIN / Barcode',
      jl_prob_meta: 'Fehlende Meta-Beschreibung',
      jl_prob_offers: 'Preis nicht in JSON-LD (Shopify-Theme-Snippet erforderlich)',
      jl_problems_tip: 'Fehlende Felder im Produktbereich korrigieren oder KI-Optimierung verwenden.',
      jl_gen_title: 'JSON-LD generieren',
      jl_schema_type: 'Schema-Typ',
      jl_product_id: 'Produkt-ID (leer für Beispiel)',
      jl_use_ai: 'KI-Anreicherung verwenden (GPT)',
      jl_gen_btn: 'JSON-LD generieren',
      jl_gen_ok: 'JSON-LD generiert',
      jl_gen_err: 'Generierungsfehler',
      jl_copied: 'Kopiert!',
      jl_copy: 'Kopieren',
      jl_preview_title: 'JSON-LD-Vorschau',
      jl_preview_err: 'Fehler beim Laden der Vorschau',
      jl_load_preview: 'Beispielprodukt laden',
      jl_preview_empty: 'Klicken Sie auf "Beispielprodukt laden" um alle JSON-LD-Schemata anzuzeigen',
      jl_val_title: 'Lokale Schema-Validierung',
      jl_invalid_json: 'Ungültiges JSON',
      jl_val_btn: 'JSON-LD validieren',
      jl_val_clear: 'Leeren',
      jl_val_ok: 'Gültig — Rich Results berechtigt',
      jl_val_fail: 'Validierung fehlgeschlagen',
      jl_val_note: 'Dieser Validator prüft schema.org-Anforderungen. Für den offiziellen Google-Test den Rich Results Test verwenden.',
      jl_val_err: 'Validierungsfehler',
      jl_bulk_title: 'Massenoperationen',
      jl_bulk_gen: 'Alle generieren',
      jl_bulk_gen_desc: 'Product JSON-LD für jedes Produkt erstellen und in DB speichern',
      jl_bulk_val: 'Alle validieren',
      jl_bulk_val_desc: 'schema.org-Validierung für vorhandenes JSON-LD ausführen',
      jl_bulk_fix: 'Korrigieren & anreichern',
      jl_bulk_fix_desc: 'JSON-LD für Produkte mit Fehlern neu erstellen',
      jl_bulk_started: 'Massenoperation gestartet',
      jl_bulk_err: 'Fehler beim Starten der Massenoperation',
      jl_bulk_running: 'In Bearbeitung',
      jl_bulk_done: 'Abgeschlossen',
      jl_bulk_stop: 'Stopp',
      jl_bulk_stopped: 'Massenoperation gestoppt',
      jl_errors: 'Fehler',
      jl_stat_total: 'Produkte gesamt',
      jl_stat_eligible: 'Rich-Results-berechtigt',
      jl_stat_gen_today: 'Heute generiert',
      jl_stat_fixed: 'Heute behoben',
      jl_coverage_by_type: 'Abdeckung nach Inhaltstyp',
      jl_type: 'Typ',
      jl_total: 'Gesamt',
      jl_valid2: 'Gültig',
      jl_missing2: 'Fehlend',

      ll_revert: 'Rückgängig',
      ll_publishing: 'Veröffentlichung…',
      ll_publish: 'Veröffentlichen',
      lp_filter_url: 'URL filtern…',
      lp_copied: 'Kopiert',
      lp_broken_empty: 'Keine toten Links gefunden',
      lp_broken_empty_sub: 'Alle Store-URLs sind erreichbar (404 / 410 / Timeout)',
      lp_timeout: 'Timeout — keine Antwort innerhalb von 12s',
      lp_ratelimit_empty: 'Kein Rate-Limiting erkannt',
      lp_ratelimit_empty_sub: 'Der Server hat die Scanner-Anfragen nicht begrenzt',
      lp_ratelimit_note: 'Seite erreichbar, aber Server antwortete 429 während des Scans',
      lp_server_empty: 'Keine Serverfehler erkannt',
      lp_server_empty_sub: 'Alle URLs antworten korrekt (kein 5xx)',
      lp_server_note: 'HTTP {{code}} — serverseitiger Fehler',
      lp_redirect_empty: 'Keine Weiterleitungen erkannt',
      lp_redirect_total: 'Weiterleitungen gesamt',
      lp_chains: 'Ketten (>1 Hop)',
      lp_loops: 'Schleifen erkannt',
      lp_chains_header: 'Weiterleitungsketten',
      lp_chains_badge: '{{n}} Mehrfachketten',
      lp_final_status: 'Endstatus:',
      lp_canon_ok: 'Korrekt',
      lp_canon_miss: 'Fehlend',
      lp_canon_wrong: 'Falsche URL',
      lp_canon_cross: 'Cross-domain',
      lp_canon_redir: 'Canonical→Redirect',
      lp_canon_action_missing: 'Canonical-Link-Tag im head-Bereich der Seite hinzufügen.',
      lp_canon_action_wrong: 'Canonical korrigieren, sodass er auf die endgültige URL dieser Seite zeigt.',
      lp_canon_action_cross: 'Der Canonical zeigt auf eine externe Domain. Prüfen ob beabsichtigt oder ein Fehler.',
      lp_canon_action_redir: 'Der Canonical zeigt auf eine weiterleitende URL. Mit der endgültigen Weiterleitungsadresse aktualisieren.',
      lp_canon_no_data: 'Canonical-Daten nicht verfügbar — Scan starten',
      lp_canon_issues: 'Canonical-Probleme ({{n}})',
      lp_canon_no_issues: 'Keine Canonical-Probleme erkannt',
      lp_canon_sample: 'Analysierte Stichprobe: {{n}} URLs aus Ihrem Store (Produkte, Kollektionen, Seiten, Artikel)',
      il_tab_orphans: 'Verwaiste Seiten',
      il_tab_weak: 'Schwache Links',
      il_tab_deep: 'Tiefe Seiten',
      il_kpi_weak: 'Schwache Links ≤2',
      il_kpi_deep: 'Tiefe Seiten',
      il_orphan_empty: 'Keine verwaisten Seiten',
      il_orphan_empty_sub: 'Alle Seiten erhalten mindestens einen internen Link',
      il_orphan_header: 'Seiten ohne eingehende Links ({{n}})',
      il_weak_empty: 'Keine Seiten mit schwachen Links',
      il_weak_empty_sub: 'Alle Seiten erhalten 3+ interne Links',
      il_weak_header: 'Seiten mit 1–2 eingehenden Links ({{n}})',
      il_anchor_empty: 'Anchor-Texte optimiert',
      il_anchor_empty_sub: 'Keine generischen, leeren oder doppelten Anchor erkannt',
      il_anchor_generic: 'Generische Anchor',
      il_anchor_generic_desc: 'Texte wie "hier klicken", "hier", "entdecken"',
      il_anchor_empty_type: 'Leere Anchor',
      il_anchor_empty_desc: 'Links ohne beschreibenden Text',
      il_anchor_dup: 'Doppelte Anchor',
      il_anchor_dup_desc: 'Gleicher Text → verschiedene URLs',
      il_anchor_lbl_gen: 'Generisch',
      il_anchor_lbl_empty: 'Leer',
      il_anchor_lbl_dup: 'Doppelt',
      il_deep_empty: 'Keine zu tiefen Seiten',
      il_deep_empty_sub: 'Alle Seiten sind in ≤3 Klicks von der Startseite erreichbar',
      il_deep_header: 'Seiten >3 Klicks von der Startseite ({{n}})',
      il_deep_note: 'Seiten mit ∞ sind über interne Links nicht erreichbar. Zu Menüs oder Kollektionen hinzufügen.',
      il_hub_empty: 'Keine Hub-Daten verfügbar',
      il_hub_empty_sub: 'Scan starten um Hub-Seiten zu identifizieren',
      il_hub_header: 'Hub-Seiten — am stärksten intern verlinkt',
      il_hub_count: '{{n}} eingehende interne Links',
      lm_active: 'Aktiv',
      lm_not_installed: 'Nicht installiert',
      lm_install_hint: 'Im Theme installieren um echte Navigation ohne Crawling zu überwachen',
      lm_refresh: 'Aktualisieren',
      lm_clear: 'Daten löschen',
      lm_remove: 'Aus Theme entfernen',
      lm_installing: 'Installation…',
      lm_install: 'Im Theme installieren',
      lm_tab_404: '404-Fehler',
      lm_tab_redirect: 'Redirect Opp.',
      lm_tab_top: 'Top-Seiten',
      lm_kpi_visits: 'Besuche gesamt',
      lm_kpi_404s: 'Echte 404-Fehler',
      lm_no_404: 'Keine 404-Fehler von Nutzern erkannt',
      lm_visits: 'Besuche',
      lm_theme_prefix: 'Theme: ',
      lm_last_activity: 'Letzte Aktivität: ',
      lm_no_activity: 'noch keine Besuche',
      lm_installed: 'Monitor im Theme "{{name}}" installiert',
      lm_err_install: 'Installationsfehler',
      lm_confirm_remove: 'Monitoring-Skript aus dem aktiven Theme entfernen?',
      lm_removed: 'Skript aus Theme entfernt',
      lm_err_remove: 'Entfernungsfehler',
      lm_confirm_clear: 'Alle gesammelten Monitoring-Daten löschen?',
      lm_cleared: 'Daten gelöscht',
      lm_err_clear: 'Löschfehler',
      lm_modal_title: 'Redirect 301 erstellen',
      lm_modal_source: 'Quell-URL (404)',
      lm_modal_dest: 'Ziel',
      lm_redirect_created: 'Redirect 301 auf Shopify erstellt',
      lm_err_redirect: 'Fehler beim Erstellen des Redirects',
      lm_create_redirect: 'Redirect erstellen',
      lm_creating: 'Erstellen…',
      lm_cancel: 'Abbrechen',
      lm_info_title: 'So funktioniert der Live Monitor',
      lm_info_1: 'Der Button "Im Theme installieren" fügt automatisch ein leichtes Skript über die Shopify Themes API zum aktiven Theme hinzu',
      lm_info_2: 'Für jeden echten Besuch sammelt es: URL, Seitentyp, interne Links, 404-Fehler, interner Referrer',
      lm_info_3: 'Kein Crawling — kein HTTP 429 — Daten von echten Besuchern in Echtzeit',
      lm_info_4: 'Baut progressiv die interne Linkkarte auf und erkennt verwaiste Seiten',
      lm_no_redirect: 'Keine Weiterleitung erforderlich',
      lm_no_redirect_hint1: 'Der Live Monitor hat noch keine Besuche aufgezeichnet. Weiterleitungsoptionen erscheinen wenn echte Nutzer 404-Seiten begegnen.',
      lm_no_redirect_hint2: 'In {{n}} analysierten Besuchen hat kein Nutzer 404-Seiten angetroffen. Hervorragend!',
      lm_toolbar_ai: '{{count}} URL · {{ai}} mit KI-Vorschlag',
      lm_toolbar_ignored: '· {{n}} ignoriert',
      lm_sort_visits: 'Besuche',
      lm_sort_date: 'Datum',
      lm_selected: '{{n}} ausgewählt',
      lm_no_match: 'keine automatische Übereinstimmung',
      lm_create: 'Erstellen',
      lm_ignore: 'Ignorieren',
      lm_err: 'Fehler',
      lm_bulk_ignored: '{{n}} URL(s) ignoriert',
      lm_bulk_created: '{{n}} Weiterleitungen erstellt',
      lm_errors: 'Fehler',
      ls_scan_started: 'Scan gestartet — wird im Hintergrund abgeschlossen',
      ls_scan_err: 'Fehler beim Starten des Scans',
      ls_last_scan: 'Letzter Scan: {{date}} · {{n}} URL',
      ls_no_scan_desc: 'Kein Scan durchgeführt — erkennt defekte Links, Weiterleitungen, Kanonische, verwaiste Seiten',
      ls_scanning: 'Scan läuft…',
      ls_rescan: 'Erneut scannen',
      ls_start_scan: 'Scan starten',
      ls_canonical_issues: 'Canonical-Probleme',
      ls_scan_details: 'Scan-Details',
      ls_stat_total: 'URLs gesamt',
      ls_stat_errors: 'Fehler',
      ls_no_scan: 'Kein Scan durchgeführt',
      ls_no_scan_long: 'Starten Sie den Scan um defekte Links, Weiterleitungsketten, Canonical-Probleme und verwaiste Seiten ohne eingehende Links zu erkennen',
      ls_first_scan: 'Ersten Scan starten',
      db_gsc_connected: 'Google Search Console verbunden!',
      db_gsc_err: 'GSC Verbindungsfehler: {{code}}',
      db_props_err: 'GSC-Properties konnten nicht geladen werden',
      db_oauth_hint: 'Schließen Sie die Google-Autorisierung im neuen Tab ab. Die Seite wird automatisch aktualisiert.',
      db_conn_err: 'GSC Verbindungsfehler',
      db_prop_selected: 'Property ausgewählt: {{url}}',
      db_prop_err: 'Fehler bei der Property-Auswahl',
      db_confirm_disconnect: 'Google Search Console trennen?',
      db_disconnected: 'GSC getrennt',
      db_disconnect_err: 'Trennungsfehler',
      db_connected: 'Search Console verbunden',
      db_no_property: 'Keine Property ausgewählt',
      db_not_connected: 'Nicht verbunden',
      db_connect_hint: 'GSC verbinden um Analytics und Monitoring freizuschalten',
      db_change_prop: 'Property wechseln',
      db_disconnect: 'Trennen',
      db_connect: 'GSC verbinden',
      db_idx_subtitle: 'Technische SEO-Qualität & Indexierung',
      db_lbl_gsc: 'GSC verbunden',
      db_lbl_sitemap: 'Sitemaps eingereicht',
      db_lbl_indexed: 'Indexierte URLs',
      db_health_real: 'Basiert auf echten Search Console-Daten',
      db_health_proxy: 'Basiert auf Katalogqualität — GSC verbinden für echte Daten',
      db_lbl_position: 'Position',
      db_lbl_trend: 'Trend 28T',
      db_lbl_errors: 'Fehler',
      db_connect_score: 'GSC verbinden um den Score zu berechnen',
      db_proxy_note: 'Katalog-Proxy',
      db_stat_excluded: 'Ausgeschlossene URLs',
      db_stat_seo_score: 'Durchschnittlicher SEO-Score',
      db_catalog_title: 'Kataloggesundheit',
      db_cat_alt: 'Bilder ALT-Text',
      db_cat_keywords: 'Fehlende Keywords',
      db_cat_no_kw: '{{n}} Produkte ohne Keywords',
      db_cat_count: '{{n}} / {{total}} Produkte',
      tab_opportunities: 'SEO-Möglichkeiten',
      tab_indexing: 'Indexierung',
      locked_available: 'Verfügbar ab dem {{plan}}-Plan',
      locked_upgrade: 'Auf {{plan}}-Plan upgraden',
      main_subtitle: 'Technisches SEO · Indexierung · Analytics · KI-Automatisierung',
      phase_3: 'Phase 3',
      interval_all: 'Alles',
      click_monthly_est: 'gesch. Klicks/Monat',
      fix_title_updated: 'Title-Tag aktualisiert',
      fix_meta_updated: 'Meta-Beschreibung aktualisiert',
      fix_both_updated: 'Title und Meta-Beschreibung in Shopify aktualisiert',
      fix_apply_err: 'Anwendungsfehler',
      rb_save_ok: 'Robots.txt im Shopify-Theme gespeichert und verifiziert',
      rb_draft_with_err: 'Entwurf gespeichert ({{err}})',
      rb_draft_manual: 'Entwurf gespeichert — Anleitung zur Anwendung im Theme befolgen',
      rb_critical_confirm: '🚨 KRITISCHE WARNUNG 🚨\n\nIhre robots.txt enthält "Disallow: /" das die gesamte Website KOMPLETT BLOCKIERT:\nGoogle, Bing und alle Bots können keine Seite mehr crawlen.\n\nDies kann dazu führen, dass die Website aus den Suchergebnissen entfernt wird.\n\nSind Sie ABSOLUT SICHER, dass Sie fortfahren möchten?',
      scan_err: 'Scanfehler: {{msg}}',
      sm_send_err: 'Sendefehler',
      unknown_err: 'Unbekannt',
      dq_today: 'Heute',
      dq_7d: 'Letzte 7 Tage',
      dq_30d: 'Letzte 30 Tage',
      dq_daily_avg: 'Tagesdurchschnitt',
      dq_at_pace: 'bei ca. {{n}}/Tag',
      job_stopped: 'Gestoppt bei {{n}} verarbeiteten URLs',
      job_inspected: '{{n}} geprüft',
      job_errors: 'Fehler',
      quota_remaining: 'Verbleibendes Kontingent:',
      lk_trend: 'Indexierungs-Trend',
      lk_batch: 'Batch-Inspektion (Massen-URL-Scan)',
      lk_ai: 'KI-Indexierungsvorschläge',
      footer_apis: 'Sitemaps-API + Search Analytics + Inspection API',
      prod_status_lbl: 'Status:',
      prod_desc_lbl: 'Beschreibung:',
      prod_missing: 'FEHLT',
      state_disc: 'Entd.',
      state_crawl: 'Gecrawlt',
      insp_api_real: 'Inspection API ✓ real',
      sm_count: '{{n}} Sitemaps',
      sm_reliability: 'Zuverlässigkeit:',
      conf_high: 'Hoch',
      conf_medium: 'Mittel',
      conf_low: 'Niedrig',
      sm_urls: 'URLs in Sitemap',
      sm_sample: 'Stichprobe',
      sm_est_indexed: 'Gesch. indexiert',
      sm_est_nonidx: 'Gesch. nicht indexiert',
      sm_coverage: 'Gesch. Abdeckung ⓘ',
      sm_idx_of: '~{{n}} indexiert von {{t}} Sitemap-URLs',
      sm_cov_est: 'Gesch. Abdeckung:',
      sm_margin_err: 'Fehlerquote',
      sm_indexed_of: 'indexiert von',
      sm_sampled: 'gesampled',
      sm_th_sitemap: 'Sitemap',
      sm_th_submitted: 'Übermittelt',
      sm_th_indexed: 'Indexiert',
      sm_th_gap: 'Lücke',
      sm_th_coverage: 'Abdeckung',
      sm_th_warning: 'Warnung',
      sm_th_errors: 'Fehler',
      sm_th_lastmod: 'Letzte Aktualisierung',
      sm_th_actions: 'Aktionen',
      rb_verified_result: 'Im Shopify-Theme gespeichert und verifiziert ({{theme}}) — Datei:',
      rb_draft_result: 'Entwurf gespeichert. Manuell anwenden: Shopify Admin → Themes → Code bearbeiten →',
      ll_draft_result: 'Entwurf gespeichert. Manuell anwenden: Shopify Admin → Themes → Code bearbeiten →',
      ls_section_redirects: 'Redirect Manager',
      rm_tab: 'Redirect Manager',
      rm_subtitle: 'Verwalte alle Weiterleitungen deines Shops an einem Ort.',
      rm_kpi_total: 'Regeln gesamt',
      rm_kpi_active: 'Aktive Weiterleitungen',
      rm_kpi_pending: 'Ausstehende 404s',
      rm_kpi_hits: 'Treffer (30T)',
      rm_kpi_chains: 'Ketten',
      rm_kpi_loops: 'Schleifen',
      rm_section_rules: 'Regeln',
      rm_section_suggest: 'KI-Vorschläge',
      rm_section_health: 'Gesundheit',
      rm_section_import: 'Import / Export',
      rm_section_history: 'Verlauf',
      rm_create_title: 'Weiterleitung erstellen',
      rm_edit_title: 'Weiterleitung bearbeiten',
      rm_old_url: 'Alte URL',
      rm_new_url: 'Neue URL',
      rm_old_url_ph: '/alter-pfad',
      rm_new_url_ph: '/neuer-pfad',
      rm_type: 'Typ',
      rm_type_301: '301 – Permanent',
      rm_type_302: '302 – Temporär',
      rm_notes: 'Notizen',
      rm_save: 'Speichern',
      rm_cancel: 'Abbrechen',
      rm_create_ok: 'Weiterleitung erfolgreich erstellt.',
      rm_edit_ok: 'Weiterleitung erfolgreich aktualisiert.',
      rm_create_err: 'Fehler beim Erstellen der Weiterleitung.',
      rm_edit_err: 'Fehler beim Speichern der Weiterleitung.',
      rm_dup_err: 'Eine Weiterleitung für diese Quell-URL existiert bereits.',
      rm_empty_err: 'Quell- und Ziel-URL sind erforderlich.',
      rm_same_err: 'Quell- und Ziel-URL dürfen nicht identisch sein.',
      rm_search_ph: 'URLs suchen…',
      rm_filter_all: 'Alle',
      rm_filter_active: 'Aktiv',
      rm_filter_disabled: 'Deaktiviert',
      rm_create_btn: 'Weiterleitung erstellen',
      rm_selected_items: '{{count}} ausgewählt',
      rm_bulk_enable: 'Aktivieren',
      rm_bulk_disable: 'Deaktivieren',
      rm_bulk_delete: 'Löschen',
      rm_bulk_export: 'CSV exportieren',
      rm_bulk_ok: 'Vorgang abgeschlossen.',
      rm_table_old: 'Alte URL',
      rm_table_new: 'Neue URL',
      rm_table_type: 'Typ',
      rm_table_hits: 'Treffer',
      rm_table_status: 'Status',
      rm_table_actions: 'Aktionen',
      rm_edit: 'Bearbeiten',
      rm_duplicate: 'Duplizieren',
      rm_delete: 'Löschen',
      rm_delete_confirm: 'Diese Weiterleitung löschen?',
      rm_deleted_ok: 'Weiterleitung gelöscht.',
      rm_delete_err: 'Fehler beim Löschen.',
      rm_status_active: 'Aktiv',
      rm_status_disabled: 'Deaktiviert',
      rm_no_data: 'Keine Weiterleitungen gefunden.',
      rm_empty_state: 'Noch keine Weiterleitungen. Erstelle deine erste.',
      rm_total_redirects: '{{count}} Weiterleitungen gesamt',
      rm_import_title: 'Weiterleitungen importieren',
      rm_import_csv: 'CSV (old_url,new_url,type)',
      rm_import_shopify: 'Shopify Export CSV',
      rm_import_sf: 'Screaming Frog CSV',
      rm_import_btn: 'Importieren',
      rm_import_ok: 'Import abgeschlossen.',
      rm_import_err: 'Fehler beim Import.',
      rm_import_imported: '{{count}} importiert',
      rm_import_skipped: '{{count}} übersprungen',
      rm_export_title: 'Weiterleitungen exportieren',
      rm_export_desc: 'Alle Weiterleitungen in verfügbaren Formaten herunterladen.',
      rm_export_csv: 'CSV exportieren',
      rm_export_json: 'JSON exportieren',
      rm_ai_title: 'KI-Vorschläge',
      rm_ai_subtitle: 'KI hat 404-URLs erkannt und schlägt Weiterleitungen zu ähnlichen Produkten vor.',
      rm_ai_accept: 'Annehmen',
      rm_ai_reject: 'Ablehnen',
      rm_ai_accept_all: 'Alle annehmen',
      rm_ai_loading: 'Analyse läuft…',
      rm_ai_empty: 'Derzeit keine Vorschläge verfügbar.',
      rm_chains_title: 'Weiterleitungsketten',
      rm_chains_desc: 'Mehrfach verkettete Weiterleitungen verlangsamen die Seite.',
      rm_chains_fix: 'Kette reparieren',
      rm_chains_empty: 'Keine Ketten erkannt.',
      rm_chains_fixed: 'Kette repariert.',
      rm_loops_title: 'Weiterleitungsschleifen',
      rm_loops_desc: 'Zirkuläre Schleifen verursachen Fehler. Manuell beheben.',
      rm_loops_fix: 'Reparieren',
      rm_loops_empty: 'Keine Schleifen erkannt.',
      rm_gsc_title: '404s von Google Search Console',
      rm_gsc_subtitle: 'Von GSC erkannte nicht gefundene URLs der letzten 90 Tage.',
      rm_gsc_empty: 'Keine GSC-404s erkannt.',
      rm_history_title: 'Aktivitätsverlauf',
      rm_history_created: 'Erstellt',
      rm_history_edited: 'Bearbeitet',
      rm_history_deleted: 'Gelöscht',
      rm_history_disabled: 'Deaktiviert',
      rm_history_enabled: 'Aktiviert',
      rm_history_imported: 'Importiert',
      rm_history_bulk: 'Massenvorgang',
      rm_history_empty: 'Keine Aktivität aufgezeichnet.',
      rm_sync_shopify: 'Von Shopify synchronisieren',
      rm_sync_shopify_desc: 'Alle URL-Weiterleitungen aus Shopify importieren. Neu erstellte Weiterleitungen werden automatisch an Shopify übertragen.',
      rm_sync_btn: 'Jetzt synchronisieren',
      error_label: 'Fehler:',
      rb_checker_desc: 'Prüfen ob eine URL von {{bot}} auf Basis der aktuellen robots.txt erlaubt oder gesperrt ist.',
      rb_rule: 'Regel:',
      rb_fix: 'Beheben:',
      rb_gsc_note_title: 'Search Console Integration',
      rb_gsc_note_body: 'Im Abschnitt Indexierung zeigen URLs mit Status "Durch robots gesperrt" Seiten an, die Google nicht crawlen kann.',
      rb_issues: 'Probleme',
      rb_opps: 'Chancen',
      rb_savings: 'Geschätztes Einsparpotenzial:',
      never: 'Nie',
      samples_conf: '{{n}} Stichproben · Konfidenz {{c}}',
      batch_priority_note: 'URLs mit Analytics-Impressionen zuerst inspiziert · GSC-Quote 2.000/Tag · Hintergrundverarbeitung',
      sm_samples: 'Stichproben',
      sm_footnote_ec: '~ "In Berechnung"-Werte = Schätzung der Inspection API ({{n}} Stichproben · Konfidenz {{c}}). Sitemaps API gibt 0 für Sitemap-Indizes zurück.',
      sm_footnote_noec: '~ "In Berechnung"-Werte = proportionale Schätzung. Batch-Scan starten. Sitemaps API gibt 0 für Sitemap-Indizes zurück.',
      ic_quota_note: 'Berechnet aus {{n}} über Inspection API geprüften URLs (Quote 2.000/Tag). GSC-Abdeckung zeigt {{m}} nicht indexierte URLs in der Sitemap.',
      cov_crawled_ni: 'Geringe Qualität oder Duplikat. Inhalt verbessern, einzigartigen Text hinzufügen, Canonical-Tag prüfen.',
      cov_disc_ni: 'Google hat sie gefunden, aber noch nicht gecrawlt. Crawl-Budget mit internen Links und aktueller Sitemap erhöhen.',
      cov_dup_nocanon: 'Canonical-Tag hinzufügen, der auf die Hauptseite verweist.',
      cov_dup_googcanon: 'Google ignoriert den deklarierten Canonical. URL- und Canonical-Konsistenz zwischen Desktop/Mobile-Versionen prüfen.',
      cov_redirect: 'Aktive Weiterleitung. Falls beabsichtigt, interne Links direkt auf das Ziel aktualisieren.',
      cov_alternate: 'Alternativseite mit korrektem Canonical — keine Maßnahmen erforderlich, wenn beabsichtigt.',
      cov_noindex: 'Meta-Tag noindex entfernen, wenn die Seite indexiert werden soll.',
      cov_robots: 'Seite durch robots.txt blockiert. Disallow-Direktiven prüfen und bei Bedarf aktualisieren.',
      cov_removed: 'Manuell aus GSC entfernt. Entfernung im Search Console-Panel widerrufen, falls gewünscht.',
      cov_404: 'Seite nicht gefunden. Seite wiederherstellen, 301-Weiterleitung einrichten oder interne Links entfernen.',
      cov_soft404: 'Server gibt 200 zurück, aber Google behandelt sie als leere Seite. Sicherstellen, dass die Seite relevante Inhalte hat.',
      cov_server_err: 'Serverfehler. Server-Logs und Hosting-Verfügbarkeit während des Crawls prüfen.',
      cov_unknown_url: 'Google hat diese URL noch nicht entdeckt. Interne Links hinzufügen, Sitemap aktualisieren und den nächsten Crawl abwarten.',
      qt_brand: 'Marke',
      qt_info: 'Info',
      qt_category: 'Kategorie',
      qt_product: 'Produkt',
      qt_generic: 'Generisch',
      sugg_title_improvement: 'Titel-Tag',
      sugg_meta: 'Meta-Beschreibung',
      sugg_content_gap: 'Fehlender Inhalt',
      sugg_schema: 'Schema-Markup',
      sugg_links: 'Interne Links',
      verdict_indexed: 'Indexiert',
      verdict_not_indexed: 'Nicht indexiert',
      verdict_excluded: 'Ausgeschlossen',
      badge_col_header: 'Badge',
      sitemap_label: 'Sitemap',
      ls_tab_broken: 'Kaputte Links',
      ls_tab_redirect: 'Weiterleitung',
      ls_tab_rate_limited: 'Ratenlimitierung',
      ls_tab_server_errors: 'Serverfehler',
      ls_tab_canonical: 'Kanonisch',
      ls_tab_internal: 'Interne Links',
      ls_section_monitor: 'Live-Monitor',
      ls_section_audit: 'Websitestruktur',
      db_idx_title: 'Indexierungs-Score',
      db_health_title: 'SC-Gesundheitsscore',
      canonical_mismatch: 'Canonical-Abweichung',
    },
    so: {
      load_err: 'Ladefehler Speed Optimizer',
      analyze_timeout: 'Analyse-Timeout (90s) — bitte erneut versuchen',
      analyze_done: 'Analyse abgeschlossen!',
      analyze_failed: 'Analyse fehlgeschlagen: {{error}}',
      rate_limited: 'Anfragelimit erreicht — Daten aus Cache aktualisiert',
      analyze_err: 'Analysefehler',
      opt_enabled: '{{label}} im Theme aktiviert',
      opt_disabled: '{{label}} deaktiviert',
      opt_err: 'Optimierungsfehler',
      scan_err: 'Theme-Scan-Fehler',
      img_err: 'Bildanalysefehler',
      sg_protected: 'Safety Guard: Protected aktiviert',
      sg_standard: 'Safety Guard: Standard aktiviert',
      mode_err: 'Fehler beim Moduswechsel',
      plan_err: 'Fehler bei der Plangenerierung',
      strategy_applied: 'Strategie {{label}} auf Theme angewendet',
      strategy_err: 'Fehler bei der Strategieanwendung',
      sessions_err: 'Fehler beim Laden der Sitzungen',
      rollback_done: 'Rollback abgeschlossen — Theme wiederhergestellt',
      rollback_err: 'Rollback-Fehler',
      subtitle: 'Sichere Shopify-Theme-Optimierungen mit sofortigem Rollback.',
      btn_rollback: 'Alles zurücksetzen',
      btn_analyze: 'Jetzt analysieren',
      analyzing_psi: 'PSI-Verarbeitung…',
      analyzing_queue: 'In der Warteschlange…',
      analyzing: 'Analysiere…',
      alert_no_token: 'Shopify-Token fehlt — Optimierungen erfordern eine aktive Store-Verbindung.',
      alert_no_scope: 'Theme-Berechtigungen fehlen — um Optimierungen anzuwenden, müssen Sie die App neu installieren.',
      perf_empty: 'Keine Analyse verfügbar',
      perf_empty_hint: 'Klicken Sie auf "Jetzt analysieren" um die Store-Performance zu messen',
      suggestions: 'Empfehlungen',
      strategy_active: 'aktiv',
      strategy_subtitle: 'Legt das Optimierungsziel fest. Klicken Sie, um den Plan vor der Anwendung zu sehen.',
      sg_header: 'Begrenzt welche Operationen die Strategie ausführen kann.',
      sg_desc_protected: 'Blockiert Standard-Operationen — nur sichere Optimierungen.',
      sg_desc_standard: 'Ermöglicht die vollständige Ausführung der ausgewählten Strategie.',
      quick_opts: 'Schnelle Optimierungen',
      sg_warning: 'Safety Guard: Protected — Standard-Operationen sind blockiert. Oben zu Standard wechseln.',
      lcp_section: 'LCP-Theme-Scan',
      hist_section: 'Optimierungsverlauf',
      hist_empty: 'Noch keine Optimierungen angewendet.',
      sessions_section: 'Sitzungen & Lighthouse-Auswirkung',
      sessions_empty: 'Sitzungen laden, um die tatsächliche Auswirkung auf Core Web Vitals zu sehen.',
      img_count: '{{n}} Bilder · {{kb}} KB gesamt',
      img_oversized: '{{n}} Bilder >300KB',
      img_no_oversized: 'Keine zu großen Bilder — großartig!',
      img_empty: 'Klicken Sie auf "Bilder analysieren" um Bilder >300KB im Theme zu finden.',
      btn_refresh: 'Neu laden',
      btn_load_sessions: 'Sitzungen laden',
      btn_refresh_sessions: 'Aktualisieren',
      btn_analyze_img: 'Bilder analysieren',
      btn_refresh_img: 'Aktualisieren',
      modal_risk_safe: 'Sicher — kein visueller Einfluss erwartet',
      modal_risk_medium: 'Überprüfen Sie das Site-Erscheinungsbild nach der Aktivierung',
      modal_risk_high: 'Könnte erweiterte Funktionen beeinflussen',
      modal_reversible: 'Jederzeit umkehrbar — "Alles zurücksetzen" zum Wiederherstellen.',
      modal_cancel: 'Abbrechen',
      modal_enable: 'Jetzt aktivieren',
      opt_no_token: 'Shopify-Store neu verbinden um diese Funktion zu nutzen',
      opt_blocked_guard: 'Durch Safety Guard (Protected) blockiert — zu Standard wechseln',
      opt_reversible: 'umkehrbar',
      opt_blocked_label: 'Durch Safety Guard blockiert — zu Standard wechseln',
      scan_scanning: 'Scan läuft...',
      scan_empty_title: 'Theme-Scan nicht ausgeführt',
      scan_empty_desc: 'Identifiziert Hero- und Slideshow-Sektionen im Theme für Server-seitige LCP-Optimierungen.',
      scan_btn: 'Theme scannen',
      scan_active_theme: 'Aktives Theme',
      scan_files: '{{n}} Liquid-Dateien gescannt · {{s}} LCP-Sektionen identifiziert',
      scan_hero_label: 'Hero/LCP-Sektion',
      scan_optimized: 'optimiert',
      scan_no_lcp: 'Keine Hero/LCP-Sektionen im Theme automatisch identifiziert.',
      scan_reload: 'Neu laden',
      plan_title: 'Plan: {{label}}',
      plan_ops: '{{n}} Operationen geplant',
      plan_action_enabled: 'bereits aktiv',
      plan_action_enable: 'aktivieren',
      plan_action_disable: 'deaktivieren',
      plan_strategy: 'Strategie: ',
      plan_guard: 'Safety Guard: ',
      plan_active_ops: 'Aktive Operationen: ',
      plan_blocked: '{{n}} durch Safety Guard blockiert',
      plan_low_conf: 'Einige Optimierungen haben niedrige Konfidenz für das erkannte Theme.',
      plan_cancel: 'Abbrechen',
      plan_apply: 'Strategie anwenden',
      plan_blocked_btn: 'Blockiert (niedriger Score)',
      hist_rollback: 'Vollständiger Rollback — alle Optimierungen entfernt',
      hist_enabled: 'aktiviert',
      hist_disabled: 'deaktiviert',
      hist_active: 'aktiv',
      sess_no_sessions: 'Keine Optimierungssitzungen aufgezeichnet. Sitzungen werden erstellt, wenn Sie eine Strategie anwenden.',
      sess_waiting: 'wartet auf PSI',
      strategy_label: 'Strategie {{s}}',
      strategy_opts: '{{n}} Optimierungen',
      strategy_active: 'AKTIV',
      quota_err: 'Fehler beim Laden des PSI-Kontingents',
      quota_api_key: 'API-Schlüssel konfiguriert:',
      quota_yes: '✓ JA',
      quota_no: '✗ NEIN (öffentliches Kontingent)',
      quota_cache_ttl: 'Cache-TTL:',
      quota_hourly: 'Stündliches Limit:',
      quota_daily: 'Tägliches Limit:',
      quota_success: 'Erfolge heute:',
      quota_hit_ratio: 'Cache-Trefferquote:',
      quota_circuit: 'Trennschalter:',
      quota_circuit_open: 'OFFEN ({{n}} Fehler)',
      quota_circuit_closed: 'geschlossen',
      quota_loading: 'Laden...',
      diag_err: 'Diagnosefehler',
      diag_refresh: 'Aktualisieren',
      diag_load: 'Diagnose laden',
      diag_patches: 'Aktive Patches ({{n}})',
      diag_none: 'keiner',
      diag_unavailable: 'nicht verfügbar',
      diag_no_patches: 'Keine aktiven Patches',
      diag_calibrated: '📈 kalibriert',
      diag_generated: 'Erstellt:',
      badge_server_side: 'SERVERSEITIG',
      badge_standard: 'STANDARD',
      badge_lcp: 'LCP',
      badge_critical: 'KRITISCH',
      badge_safe: 'SICHER',
      badge_medium: 'MITTEL',
      badge_safety_guard: 'Sicherheitswächter',
      diag_theme_fingerprint: 'Theme-Fingerabdruck',
      diag_engine_confidence: 'Engine-Konfidenz',
      perf_score_label: 'Performance-Score',
      section_perf_overview: 'Performance-Übersicht',
      section_strategy_intent: 'Strategieabsicht',
      safety_guard_title: 'Sicherheitswächter',
      section_script_analyzer: 'Script-Einfluss-Analyse',
      script_col_file: 'Datei',
      script_col_size: 'Größe',
      script_col_impact: 'Auswirkung',
      script_col_defer_risk: 'Verzögerungsrisiko',
      metric_js_total: 'JS gesamt',
      metric_css_total: 'CSS gesamt',
      perf_updated: 'Aktualisiert:',
      perf_stale: 'veraltete Daten (PSI nicht verfügbar)',
      perf_from_cache: 'aus Cache',
      perf_psi_ok: 'PSI OK',
      debug_invalid_token_title: 'Ungültiges Token (401) — das Token in MongoDB ist abgelaufen oder widerrufen.',
      debug_reconnect_desc: 'Der OAuth-Callback hat das Token nach der letzten Neuinstallation NICHT überschrieben. Klicken Sie auf die Schaltfläche unten, um ein neues OAuth zu starten.',
      debug_reconnect_btn: 'OAuth jetzt erneut verbinden (öffnet Shopify)',
      debug_reconnect_note: 'Nach der Genehmigung der Berechtigungen in Shopify aktualisiert der Callback das Token in MongoDB automatisch.',
    },
    drafts: {
      approved: 'Entwurf genehmigt!',
      approve_err: 'Genehmigungsfehler',
      published: 'Auf Shopify veröffentlicht!',
      publish_err: 'Veröffentlichungsfehler',
      title: 'Entwürfe & Ergebnisse',
      subtitle: 'Inhalte überprüfen, genehmigen und veröffentlichen',
      empty: 'Keine Entwürfe zur Überprüfung',
      empty_hint: 'KI-Inhalte generieren, um neue Entwürfe zu erstellen',
      badge_approved: 'Genehmigt',
      badge_draft: 'Entwurf',
      field_desc: 'Beschreibung',
      btn_view: 'Ansehen',
      btn_approve: 'Genehmigen',
      btn_publish: 'Veröffentlichen',
      modal_title: 'Entwurfsdetail',
      chars_seo: '/60 Zeichen',
      chars_meta: '/160 Zeichen',
      not_present: 'Nicht vorhanden',
      not_present_pl: 'Nicht vorhanden',
      btn_close: 'Schließen',
      btn_publish_shopify: 'Auf Shopify veröffentlichen',
      seo_title: 'SEO-Titel',
      meta_description: 'Meta-Beschreibung',
      keywords_label: 'Schlüsselwörter',
    },
    usage: {
      title: 'Nutzung & Plan',
      subtitle: 'Nutzung überwachen und Abonnement verwalten',
      plan_badge: 'Plan:',
      current: 'Aktuelle Nutzung',
      credits: 'KI-Credits',
      used: 'Verwendet:',
      unlimited: 'Unbegrenzt ∞',
      remaining: 'Verbleibend: {{n}}',
      products_sync: 'Synchronisierte Produkte',
      plans_heading: 'Verfügbare Pläne',
      most_popular: '⭐ Am beliebtesten',
      active_plan: 'Aktiver Plan',
      current_plan: 'Aktueller Plan',
      btn_upgrade: 'Upgrade auf {{name}}',
      trend_heading: 'Nutzungstrend',
      trend_coming: 'Nutzungsdiagramm (demnächst)',
      stat_products: 'Analysierte Produkte',
      stat_content: 'Generierte Inhalte',
      stat_translations: 'Übersetzungen',
      stat_images: 'Optimierte Bilder',
    },
    support: {
      msg_sent: 'Nachricht gesendet!',
      msg_err: 'Fehler beim Senden der Nachricht',
      status_open: 'Offen',
      status_progress: 'In Bearbeitung',
      status_closed: 'Geschlossen',
      title: 'Support',
      subtitle: 'FAQ, Anleitungen und Chat mit unserem Team',
      faq_heading: 'Häufig gestellte Fragen',
      guide_heading: 'Schnellstart',
      chat_heading: 'Support-Chat',
      no_msgs: 'Keine Nachrichten',
      no_msgs_hint: 'Starten Sie ein Gespräch mit dem Support',
      placeholder: 'Nachricht schreiben...',
      contacts_heading: 'Kontakt',
      contact_hours_label: 'Zeiten',
      contact_hours: 'Mo-Fr 9:00-18:00 CET',
      contact_response_label: 'Reaktionszeit',
      contact_response: 'Innerhalb von 24 Stunden',
      guide_step1: 'Gehen Sie zum',
      guide_products: 'Produkte',
      guide_step1b: 'Bereich, um Ihre Produkte zu sehen',
      guide_step2: 'Wählen Sie ein Produkt aus und gehen Sie zu',
      guide_ai_content: 'KI-Inhalte',
      guide_step3: 'Generieren Sie Beschreibung, SEO-Titel, Meta-Beschreibung und Keywords',
      guide_step4: 'Überprüfen Sie die Ergebnisse in',
      guide_history: 'Verlauf',
    },
    transl: {
      load_err: 'Fehler beim Laden der Elemente',
      published: 'Übersetzung auf Shopify veröffentlicht!',
      pub_err: 'Veröffentlichungsfehler',
      err_no_items: 'Mindestens ein Element auswählen',
      err_no_fields: 'Mindestens ein Feld zum Übersetzen auswählen',
      item_err: 'Übersetzungsfehler',
      done_one: 'Übersetzung abgeschlossen!',
      done_many: '{{n}} Elemente übersetzt!',
      copied: 'In die Zwischenablage kopiert',
      title: 'Übersetzungen',
      gate_plan: 'Ab Starter-Plan verfügbar',
      gate_desc: 'Produkte, Kollektionen und Artikel in 8 Sprachen mit AI übersetzen',
      gate_btn: 'Zu Starter-Plan wechseln',
      subtitle: 'Produkte, Kollektionen, Artikel und Seiten in mehrere Sprachen mit AI übersetzen',
      translating: 'Übersetze…',
      search_placeholder: 'Nach Titel suchen…',
      select_page: 'Seite auswählen',
      sel_abbrev: 'Ausw.',
      total_items: 'gesamt',
      loading: 'Laden…',
      no_results: 'Keine Ergebnisse für diese Suche',
      prev: '← Zurück',
      tot_abbrev: 'ges.',
      next: 'Weiter →',
      deselect_all: 'Alle abwählen',
      lang_heading: 'Zielsprache',
      fields_heading: 'Zu übersetzende Felder',
      select_hint: 'Elemente aus der Liste auswählen, um die Übersetzung zu aktivieren',
      results_heading: 'Ergebnisse',
      clear_results: 'Ergebnisse löschen',
      badge_published: 'Veröffentlicht',
      publishing: 'Veröffentliche…',
      done: 'Fertig',
      publish: 'Veröffentlichen',
      copy: 'Kopieren',
      tab_products: 'Produkte',
      tab_collections: 'Kollektionen',
      tab_articles: 'Artikel',
      tab_pages: 'Seiten',
      field_title: 'Titel',
      field_description: 'Beschreibung',
      field_seo_title: 'SEO Title',
      field_meta_description: 'Meta Description',
      field_body_html: 'Beschreibung / Inhalt',
      empty_hint_select: 'Wählen Sie ein oder mehrere Elemente aus der Liste, wählen Sie die Sprache und klicken Sie auf',
      translate_label: 'Übersetzen',
      items_selected: 'Elemente',
      item_selected: 'Element',
      selected_label: 'ausgewählt',
      choose_fields_hint: 'Felder auswählen und auf Übersetzen klicken',
    },
  },

  fr: {
    nav: {
      overview: 'Vue d\'ensemble',
      catalog: 'Catalogue',
      content: 'Contenu IA',
      translations: 'Traductions',
      images: 'Images',
      batch: 'Opérations en lot',
      speed: 'Optimiseur de vitesse',
      history: 'Historique',
      usage: 'Utilisation et Plan',
      settings: 'Paramètres',
      support: 'Support',
    },
    common: {
      save: 'Enregistrer',
      cancel: 'Annuler',
      delete: 'Supprimer',
      close: 'Fermer',
      confirm: 'Confirmer',
      loading: 'Chargement...',
      error: 'Erreur',
      success: 'Succès',
      search: 'Rechercher',
      filter: 'Filtrer',
      all: 'Tous',
      yes: 'Oui',
      no: 'Non',
      back: 'Retour',
      next: 'Suivant',
      apply: 'Appliquer',
      generate: 'Générer',
      publish: 'Publier',
      optimize: 'Optimiser',
      refresh: 'Actualiser',
    },
    settings: {
      title: 'Paramètres',
      subtitle: 'Centre de contrôle IA',
      tabs: {
        general: 'Général',
        localization: 'Localisation',
        ai_engine: 'Moteur IA',
        appearance: 'Apparence',
        piano: 'Plan',
        advanced: 'Avancé',
      },
      save_btn: 'Enregistrer les paramètres',
      unsaved: 'Modifications non enregistrées',
      action_loading: 'En cours...',
      general: {
        contents: 'Contenus',
        default_lang: 'Langue de contenu par défaut',
        tone: 'Ton de contenu global',
        tone_hint: 'Appliqué aux produits, collections, articles et lots',
        seo_rules: 'Règles SEO',
        seo_title_max: 'Longueur maximale du titre SEO',
        seo_title_hint: 'Recommandé : 50–60 caractères',
        meta_max: 'Longueur maximale de la meta description',
        meta_hint: 'Recommandé : 150–160 caractères',
        chars: 'caractères',
        images: 'Préférences d\'image',
        img_format: 'Format par défaut',
        img_square: 'Carré (1:1)',
        img_landscape: 'Paysage (4:3)',
        img_portrait: 'Portrait (3:4)',
        img_quality: 'Qualité de compression',
        img_quality_low: '50% (compressé)',
        img_quality_high: '100% (maximum)',
        store_info: 'Informations de la boutique',
        store_domain: 'Domaine',
        store_plan: 'Plan',
        store_installed: 'Installé',
      },
      ai: {
        strategy: 'Stratégie IA',
        params_title: 'Paramètres de génération',
        creativity: 'Créativité',
        creative_low: 'Conservateur',
        creative_high: 'Créatif',
        seo_strictness: 'Rigueur SEO',
        seo_low: 'Flexible',
        seo_high: 'Rigoureux',
        tone_label: 'Ton global',
        auto_title: 'Auto-optimisation IA',
        auto_hint: 'Activer pour optimiser automatiquement les contenus',
        on: 'Actif',
        off: 'Off',
        threshold: 'Seuil d\'optimisation',
        threshold_low: 'Tout optimiser',
        threshold_high: 'Seulement les pires',
        threshold_hint: 'Intervient sur les éléments avec score SEO < {{n}}',
        frequency: 'Fréquence',
        scope: 'Portée',
        triggers: 'Déclencheurs',
        img_format: 'Format d\'image',
        img_square: 'Carré 1:1',
        img_square_sub: '800×800 px',
        img_landscape: 'Paysage 4:3',
        img_landscape_sub: '800×600 px',
        img_portrait: 'Portrait 3:4',
        img_portrait_sub: '600×800 px',
        img_no_resize: 'Pas de redimensionnement',
        img_no_resize_sub: 'Dimensions originales',
        compress: 'Compression',
        compress_hint: 'Réduire la taille du fichier',
        quality: 'Qualité',
        daily_credits: 'Crédits IA aujourd\'hui',
        remaining: '{{n}} restants',
        reset_in: 'Réinitialisation dans',
        running: 'En cours — {{done}}/{{total}} produits',
        run_now: 'Exécuter maintenant',
        run_desc: 'Optimiser les éléments avec score < {{threshold}} dans : {{scope}}',
        preview_title: 'Aperçu — Avant / Après',
        before: 'Avant',
        after: 'Après IA',
        no_keywords: 'aucun mot-clé',
        preview_note: 'Exemple sur le produit «Chaussure Running Pro X1» — mise à jour instantanée',
        alt_mode_label: 'Mode de génération de texte ALT',
        alt_preview: 'Aperçu',
        alt_mode_ai: 'IA intelligente',
        alt_mode_ai_desc: 'OpenAI génère un ALT optimisé pour chaque image',
        alt_mode_template: 'Modèle gratuit',
        alt_mode_template_desc: 'Aucun crédit IA — utilise le modèle ci-dessous',
        alt_mode_auto: 'Fallback automatique',
        alt_mode_auto_desc: 'IA si disponible, modèle si crédits épuisés',
        alt_hint_template: 'Mode gratuit : aucun crédit IA consommé pour le texte ALT.',
        alt_hint_auto: 'Fallback auto : IA si crédits disponibles, sinon modèle automatique.',
        pct_done: '{{pct}}% terminé',
        n_errors: '{{n}} erreurs',
        alt_template_label: 'Modèle personnalisé',
        alt_vars_label: 'Variables disponibles — cliquer pour insérer',
      },
      piano: {
        credits_title: 'Utilisation des crédits',
        plan_label: 'Plan',
        extra_credits: 'Crédits supplémentaires',
        unlimited: '∞ Crédits illimités',
        unlimited_sub: 'Plan Elite — aucune limite mensuelle',
        plan_credits: 'Crédits du plan',
        consumed: 'Consommés du plan',
        residual: 'Reste du plan',
        extra_available: 'Crédits supplémentaires disponibles',
        extra_sub: 'Consommés seulement après le plan mensuel',
        total_available: 'Total disponible',
        consumed_cycle: 'Crédits consommés dans le cycle actuel',
        status_active: 'Actif',
        status_pending: 'En cours de traitement',
        status_frozen: '⚠ Suspendu',
        status_free: 'Gratuit / Aucun abonnement',
        trial_active: 'Essai actif',
        trial_access: 'accès complet jusqu\'au {{date}}.',
        sub_status: 'Statut de l\'abonnement',
        next_credit_reset: 'Prochain reset des crédits',
        trial_end: 'Fin d\'essai',
        trial_label: 'Essai gratuit',
        trial_used: 'Déjà utilisé',
        trial_available: '{{n}} jours disponibles',
        cancel_btn: 'Annuler l\'abonnement',
        cancelling: 'Annulation...',
        plans_title: 'Plans disponibles',
        plan_active: 'Plan actif',
        plan_current: 'Plan actuel',
        per_month: '/mois',
        downgrade: 'Retour au gratuit',
        downgrading: 'Rétrogradation...',
        upgrade: 'Mise à niveau',
        downgrade_btn: 'Rétrograder',
        redirecting: 'Redirection...',
        trial_btn: 'Essai gratuit',
        trial_btn_days: '({{n}}j)',
        plan_overage: 'Crédits IA supplémentaires : {{price}} par crédit',
        plan_no_overage: 'Aucun frais de dépassement de crédits IA',
        plan_trial_line: 'Essai gratuit de {{n}} jours',
        plans_note: 'Les plans payants incluent un essai gratuit de {{n}} jours. Aucun frais d\'activation. Paiements via Shopify Billing.',
        credits_section: 'Acheter des crédits supplémentaires',
        credits_desc: 'Les crédits supplémentaires s\'ajoutent à votre plan mensuel et n\'expirent jamais.',
        one_time: 'unique',
        per_credit: '¢ par crédit',
        buy: 'Acheter',
        payment_note: 'Paiement traité de manière sécurisée via Shopify Billing. Aucune donnée stockée sur notre serveur.',
        history_title: 'Historique des achats de crédits',
        history_count: '{{n}} achat{{suffix}}',
        hist_invested: 'Total investi',
        hist_bought: 'Crédits achetés',
        hist_available: 'Encore disponibles',
        hist_empty: 'Aucun achat de crédits supplémentaires effectué.',
        hist_date: 'Date',
        hist_pkg: 'Package',
        hist_credits: 'Crédits',
        hist_amount: 'Montant',
        hist_status: 'Statut',
        hist_completed: 'Complété',
        hist_pending: 'En attente',
        hist_declined: 'Refusé',
        trend_title: 'Tendance d\'utilisation',
        trend_placeholder: 'Graphique d\'utilisation (disponible avec Shopify Billing)',
        stats_products: 'Produits analysés',
        stats_content: 'Contenu généré',
        stats_translations: 'Traductions',
        stats_images: 'Images optimisées',
        toast_sub_pending: 'Abonnement en cours de traitement — vous recevrez une confirmation sous peu.',
        toast_sub_activated: '{{name}} activé !',
        toast_trial_suffix: '({{n}} jours d\'essai gratuit)',
        toast_sub_error: 'Erreur de vérification de l\'abonnement',
        toast_purchase_duplicate: 'Achat déjà enregistré.',
        toast_credits_added: '+{{n}} crédits ajoutés à votre compte !',
        toast_purchase_error: 'Erreur de vérification de l\'achat',
        toast_purchase_start_error: 'Erreur lors du démarrage de l\'achat',
        toast_sub_start_error: 'Erreur lors du démarrage de l\'abonnement',
        toast_store_unavailable: 'Boutique pas encore connectée. Rechargez l\'application dans Shopify Admin et réessayez.',
        toast_sub_cancelled: 'Abonnement annulé. Plan revenu au gratuit.',
        toast_sub_cancel_error: 'Erreur d\'annulation de l\'abonnement',
        pkg_100_label: '100 Crédits',
        pkg_100_desc: 'Idéal pour usage occasionnel',
        pkg_300_label: '300 Crédits',
        pkg_300_desc: 'Économisez 17%',
        pkg_300_badge: '⭐ Le plus demandé',
        pkg_700_label: '700 Crédits',
        pkg_700_desc: 'Économisez 29%',
        pkg_1500_label: '1 500 Crédits',
        pkg_1500_desc: 'Économisez 33%',
        pkg_1500_badge: '🔥 Meilleure valeur',
        plan_starter_badge: '⭐ Le plus populaire',
        plan_starter_benefit: 'Économisez des heures de travail chaque mois.',
        plan_pro_badge: '🔥 Croissance SEO',
        plan_pro_benefit: "Améliore l'indexation et les performances SEO.",
        plan_elite_badge: '🚀 Agences',
        plan_elite_benefit: 'Conçu pour les agences et les catalogues enterprise.',
      },
      toast: {
        saved_at: 'Enregistré à {{time}}',
        save_error: 'Erreur d\'enregistrement',
        budget_exceeded: 'Crédit quotidien épuisé — {{done}} produits optimisés sur {{total}}',
        autopilot_stopped: 'Autopilot arrêté — {{done}} produits optimisés sur {{total}}',
        images_optimized: 'Images optimisées — {{n}} produits',
        images_failed: '{{n}} images non optimisées',
        autopilot_done: 'Autopilot terminé — {{started}} produits en file d\'attente',
        autopilot_empty: 'Aucun élément en dessous du seuil',
        autopilot_stopping: 'Autopilot en cours d\'arrêt...',
        reindex_started: 'Réindexation démarrée',
        resync_started: 'Resynchronisation démarrée',
        cache_cleared: 'Cache vidé',
        sync_reset: 'État de synchronisation réinitialisé',
      },
      advanced: {
        warning: 'Les actions suivantes affectent le comportement du système. Utilisez-les uniquement si nécessaire.',
        sync_title: 'Synchronisation',
        reindex: 'Réindexer les produits',
        reindex_desc: 'Recalculer les données SEO pour tous les produits de la base de données',
        resync: 'Resynchroniser avec Shopify',
        resync_desc: 'Forcer la synchronisation complète des produits et des collections',
        cache_title: 'Cache',
        clear_cache: 'Vider le cache de l\'application',
        clear_cache_desc: 'Efface les lots en cours dans le navigateur. Les opérations non terminées seront perdues.',
        reset_credits: 'Réinitialiser les crédits quotidiens',
        reset_credits_desc: 'Réinitialise le compteur de crédits IA d\'aujourd\'hui (dev). Limite : 5 000/jour.',
        danger_zone: 'Zone dangereuse',
        reset_sync: 'Réinitialiser la synchronisation',
        reset_sync_desc: 'Forcer la réinitialisation. À utiliser si la synchronisation est bloquée depuis plus de 30 minutes.',
      },
    },
    ai_engine: {
      preset: {
        growth_desc: "Maximise les conversions et l'engagement",
        luxury_desc: 'Marque premium et narrative exclusive',
        seo_desc: 'Maximise la visibilité organique sur Google',
        balanced_desc: 'Équilibre optimal entre qualité et SEO',
      },
      tone: {
        professional: 'Professionnel',
        professional_desc: 'Formel, autoritaire, inspire confiance',
        luxury: 'Luxury',
        luxury_desc: 'Élégant, exclusif, premium',
        technical: 'Technique',
        technical_desc: 'Précis, spécifications, données mesurables',
        conversational: 'Conversationnel',
        conversational_desc: 'Direct, convivial, engageant',
      },
      frequency: {
        daily: 'Quotidien',
        daily_desc: '1× par jour',
        hourly: 'Horaire',
        hourly_desc: 'Continu',
        realtime: 'Immédiat',
        realtime_desc: 'Dès que possible',
      },
      scope: {
        products: 'Produits',
        collections: 'Collections',
        articles: 'Articles',
        pages: 'Pages',
      },
      trigger: {
        seo_score: 'Score SEO faible',
        missing_meta: 'Métadonnées manquantes',
        missing_alt: 'Texte ALT manquant',
        outdated_desc: 'Description obsolète',
        keywords: 'Mots-clés manquants',
        image_quality: 'Images non optimisées',
      },
    },
    appearance: {
      title: 'Apparence',
      theme_title: 'Thème',
      theme: {
        light: 'Clair',
        dark: 'Sombre',
        system: 'Système',
      },
      density_title: 'Densité',
      density: {
        compact: 'Compact',
        comfortable: 'Confortable',
        spacious: 'Spacieux',
        compact_desc: 'Plus de contenu',
        comfortable_desc: 'Équilibré',
        spacious_desc: 'Plus de respiration',
      },
      sidebar_title: 'Barre latérale',
      sidebar: {
        expanded: 'Étendue',
        collapsed: 'Réduite',
        hidden: 'Masquée',
        expanded_desc: 'Toujours visible',
        collapsed_desc: 'Icônes seulement',
        hidden_desc: 'Au survol',
      },
    },
    localization: {
      ui_language: 'Langue de l\'interface',
      select_language: 'Sélectionner la langue de l\'application',
      reload_note: 'La langue est appliquée immédiatement',
    },
    dashboard: {
      title: 'Vue d\'ensemble',
      subtitle: 'Résumé de l\'activité de la boutique',
      products: 'Produits',
      optimized: 'Optimisés',
      pending: 'En attente',
      seo_score: 'Score SEO',
      audit_center: 'Audit Center',
      sync_products: 'Synchroniser les produits',
      analyze_products: 'Analyser les produits',
      audit_site: 'Audit Site 360',
      syncing: 'Sync...',
      analyzing: 'Analyse...',
      auditing: 'Audit...',
      section_account: 'Compte et Plan',
      section_catalog: 'État du catalogue',
      section_images: 'Images',
      section_seo_tech: 'SEO Technique — Audit Site Détaillé',
      section_ux_trust: 'UX & Trust — Highlights',
      section_actions: 'Actions recommandées par l\'IA',
      recent_activity: 'Activité récente',
      hint_plan: 'État du plan et des crédits',
      hint_never_synced: 'Jamais synchronisé',
      hint_priority: 'Trié par priorité',
      hint_last_sync: 'Dernière sync {{date}}',
      current_plan: 'Plan actuel',
      credits_used: 'Crédits utilisés',
      credits_remaining: 'Crédits restants',
      public_domain: 'Domaine public',
      credit_usage: 'Utilisation des crédits',
      hint_installed: 'Installé le {{date}}',
      hint_pct_plan: '{{pct}}% du plan',
      hint_limit: 'Limite {{n}}',
      hint_last_audit: 'Dernier audit {{date}}',
      hint_no_audit: 'Audit non effectué',
      no_audit: 'Aucun audit effectué',
      no_audit_desc: 'Lancez un audit pour analyser le title, meta, H1, canonical, robots, sitemap, HTTPS, OG, JSON-LD, performance, images et liens.',
      run_audit: 'Lancer l\'audit',
      in_progress: 'En cours...',
      audit_phase: 'Audit en cours (phase : {{phase}})...',
      ux_highlights: 'UX Highlights',
      trust_compliance: 'Trust & Compliance',
      mobile_viewport: 'Mobile viewport :',
      favicon: 'Favicon :',
      images_without_alt_label: 'Images sans ALT :',
      lazy_loading: 'Lazy loading :',
      images_suffix: 'images',
      internal_links: 'Liens internes :',
      data_unavailable: 'Données indisponibles : {{reason}}',
      analysis_not_run: 'Analyse non effectuée',
      not_detected: 'Non détecté',
      no_trust_data: 'Aucune donnée trust disponible',
      no_activity: 'Aucune activité récente.',
      activity_completed: 'Terminé',
      activity_error: 'Erreur',
      no_store_title: 'Aucune boutique connectée',
      no_store_desc: 'Installez l\'application sur une boutique Shopify pour commencer',
      connect_store: 'Connecter une boutique Shopify',
      no_token_title: 'Token OAuth manquant',
      no_token_desc: 'La boutique {{domain}} est enregistrée mais n\'a pas de token. Réinstallez l\'application.',
      reinstall_app: 'Réinstaller l\'application via OAuth',
      sync_in_progress: 'Synchronisation des produits en cours…',
      sync_in_progress_detail: '{{synced}} / {{total}} produits. Les données du tableau de bord seront mises à jour à la fin de la synchronisation.',
      stale_data: 'Données obsolètes : affichage des derniers chiffres valides pendant la synchronisation.',
      catalog_score_label: 'Catalog Score',
      seo_distribution: 'Distribution SEO',
      n_products: '{{n}} produits',
      pct_of_catalog: '{{pct}}% du catalogue',
      no_description: 'Sans description',
      no_meta_description: 'Sans meta description',
      seo_needs_improvement: 'SEO à améliorer',
      view: 'Voir',
      seo_good_desc: 'Le catalogue a une bonne couverture SEO. Maintenez le standard en optimisant les nouveaux produits.',
      seo_medium_desc: 'Le catalogue a une couverture SEO moyenne. Priorité : meta descriptions et descriptions produit.',
      seo_poor_desc: 'Le catalogue a une faible couverture SEO. Priorité : meta descriptions, descriptions et images manquantes.',
      seo_optimized: 'Optimisés',
      seo_medium: 'Moyens',
      seo_poor: 'À améliorer',
      content_seo_title: 'État SEO par type de contenu',
      open_catalog: 'Ouvrir le catalogue',
      row_collections: 'Collections',
      row_articles: 'Articles',
      row_pages: 'Pages',
      coming_soon: 'Bientôt disponible',
      not_synced: 'Non synchronisés',
      seo_coverage_fmt: '{{opt}}/{{total}} optimisés · {{score}}/100',
      alt_coverage: 'Couverture ALT text',
      with_alt_count: '{{n}} avec ALT sur {{total}}',
      image_optimization_label: 'Optimisation des images',
      optimized_count: '{{n}} optimisées sur {{total}}',
      with_alt: 'Avec ALT',
      without_alt: 'Sans ALT',
      image_optimized: 'Optimisées',
      image_needs_improvement: 'À améliorer',
      no_image: 'Sans image',
      savings: 'Économies',
      optimize_images_btn: 'Optimiser les images',
      view_no_image: 'Voir les produits sans image',
      alt_manager: 'ALT Text Manager',
      toast_sync_done: 'Synchronisation terminée. Réconciliation du catalogue...',
      toast_catalog_reconciled: 'Catalogue réconcilié : {{n}} produits ({{removed}} orphelins supprimés)',
      toast_sync_first: 'Synchronisez d\'abord les produits',
      toast_avg_score: 'Score moyen {{score}}/100',
      toast_audit_done: 'Audit terminé : {{score}}/100',
      toast_sync_reset: 'État de sync réinitialisé',
      toast_sync_reset_error: 'Impossible de réinitialiser l\'état',
      op_description: 'Description IA',
      op_seo_title: 'SEO Title',
      op_meta_description: 'Meta Description',
      op_keywords: 'Keywords',
      op_translation: 'Traduction',
      op_image_opt: 'Optimisation d\'image',
      op_sync: 'Sync Shopify',
      op_seo_analysis: 'Analyse SEO boutique',
      op_site_audit: 'Audit Site 360',
      prompt_domain: 'Entrez le domaine de votre boutique Shopify',
      hint_force_reset: "Forcer la réinitialisation de l'état de sync (ne supprime pas les produits)",
    },
    products: {
      title: 'Catalogue de produits',
      search: 'Rechercher des produits...',
      all: 'Tous',
      optimized: 'Optimisés',
      pending: 'En attente',
      status_generating: 'Génération',
      status_writing: 'Rédaction',
      status_validating: 'Validation',
      status_failed: 'Échoué',
      status_sync_failed: 'Sync Shopify',
      status_optimized: 'Optimisé',
      status_medium: 'Moyen',
      status_needs_improvement: 'À améliorer',
      type_collection_singular: 'collection',
      type_collection_plural: 'collections',
      sync_collections: 'Synchroniser les collections',
      empty_collections: 'Aucune collection. Cliquez sur "Synchroniser les collections" pour les importer depuis Shopify.',
      search_collections: 'Rechercher une collection par titre ou handle...',
      col_label_products: 'Produits',
      type_article_singular: 'article',
      type_article_plural: 'articles',
      sync_articles: 'Synchroniser les articles',
      empty_articles: 'Aucun article. Cliquez sur "Synchroniser les articles" pour les importer depuis Shopify.',
      search_articles: 'Rechercher un article par titre, handle ou blog...',
      col_label_blog: 'Blog',
      type_page_singular: 'page',
      type_page_plural: 'pages',
      sync_pages: 'Synchroniser les pages',
      empty_pages: 'Aucune page. Cliquez sur "Synchroniser les pages" pour les importer depuis Shopify.',
      search_pages: 'Rechercher une page par titre ou handle...',
      col_label_author: 'Auteur',
      catalog_title: 'Catalogue',
      no_store: 'Aucune boutique',
      tab_products: 'Produits',
      tab_collections: 'Collections',
      tab_articles: 'Articles',
      tab_pages: 'Pages',
      sort_updated: 'Mis à jour',
      sort_seo_score: 'Score SEO',
      sort_title: 'Titre',
      sort_vendor: 'Fournisseur',
      sort_created: 'Créé',
      sort_desc: 'Décroissant',
      sort_asc: 'Croissant',
      filter_seo_all: 'SEO: tous',
      filter_optimized: 'Optimisés',
      filter_medium: 'Moyens',
      filter_needs_improvement: 'À améliorer',
      filter_image_all: 'Images: tous',
      filter_image_yes: 'Avec images',
      filter_image_no: 'Sans images',
      filter_meta_all: 'Meta: tous',
      filter_meta_yes: 'Avec meta',
      filter_meta_no: 'Sans meta',
      filter_desc_all: 'Description: tous',
      filter_desc_yes: 'Avec description',
      filter_desc_no: 'Sans description',
      filter_vendor_all: 'Fournisseur: tous',
      filter_collection_all: 'Collection: toutes',
      filter_type_all: 'Type: tous',
      reset_filters: 'Réinitialiser les filtres',
      th_image: 'Image',
      th_title: 'Titre',
      th_seo_score: 'Score SEO',
      th_alt: 'ALT',
      th_meta: 'Meta',
      th_status: 'Statut',
      th_actions: 'Actions',
      no_products_filters: 'Aucun produit trouvé avec ces filtres',
      no_products: 'Aucun produit. Synchronisez depuis votre boutique Shopify.',
      pagination: 'Page {{page}} sur {{total}} · {{count}} produits',
      batch_btn: 'Opérations en lot',
      dialog_status: 'Statut',
      dialog_seo_score: 'Score SEO',
      dialog_shopify_id: 'ID Shopify',
      dialog_vendor: 'Fournisseur',
      dialog_serp: 'Aperçu SERP',
      dialog_issues: 'Problèmes SEO',
      dialog_suggestions: 'Suggestions',
      generating: 'Génération...',
      generate_all: 'Générer tout le contenu',
      action_generate_ai: 'Générer du contenu IA',
      action_translate: 'Traduire',
      action_optimize_image: "Optimiser l'image",
      syncing: 'Synchronisation...',
      draft_ready: 'Brouillon prêt',
      seo_ai_btn: 'SEO IA',
      batch_ops_btn: 'Opérations en lot',
      diagnosis: 'Diagnostics',
      current_score: 'Score actuel',
      projected: '→ prévu {{score}}/100',
      meta_title: 'Meta Title',
      meta_desc_label: 'Meta Description',
      description_label: 'Description',
      generate_desc_btn: 'Générer une description IA',
      generating_desc: 'Génération...',
      generate_ai_btn: "Générer avec l'IA",
      publish_shopify_btn: 'Publier sur Shopify',
      publishing: 'Publication...',
      discard_draft_btn: 'Supprimer le brouillon',
      seo_ai_dialog_title: 'SEO IA',
      seo_all: 'SEO: tous',
      seo_optimized: 'Optimisés',
      seo_medium: 'Moyens',
      seo_needs: 'À améliorer',
      page_of: 'Page {{page}} sur {{total}}',
      search_placeholder: 'Rechercher par titre, SKU, EAN, fournisseur, handle...',
      chars_count: '{{n}}/{{max}} caractères',
      n_selected_info: 'sélectionnés',
      filtered: 'filtrés',
      soon_tooltip: 'Disponible bientôt',
      resource_subtitle: '{{type}} Shopify et leur statut SEO',
      articles_blog: 'Articles (blog)',
      select_visible_title: 'Sélectionner/désélectionner tous les visibles',
      toast_draft_ready: 'Brouillon SEO généré. Vérifiez et publiez.',
      toast_error_ai: 'Erreur de génération IA',
      toast_desc_generated: 'Description IA générée.',
      toast_error_desc: 'Erreur de génération de description',
      toast_empty_draft: 'Générez ou remplissez au moins un champ',
      toast_published_score: 'Publié sur Shopify · Score {{score}}/100',
      toast_error_publish: 'Erreur de publication sur Shopify',
      toast_draft_discarded: 'Brouillon supprimé',
      toast_select_items: 'Sélectionnez au moins un élément',
      toast_mode_publish: 'Publication',
      toast_mode_both: 'Générer+Publier',
      toast_mode_generate: 'Génération SEO IA',
      toast_batch_launched: '{{label}} démarrée sur {{count}} {{type}}.',
      toast_batch_errors: '{{label}} terminée avec {{count}} erreurs',
      toast_batch_done: '{{label}} terminée sur {{count}} {{type}}',
      toast_synced: '{{type}} synchronisés : {{count}}',
      toast_sync_error: 'Erreur de synchronisation {{type}}',
      toast_token_error: 'Token Shopify expiré ou permissions manquantes',
      reinstall_label: 'Réinstaller',
      toast_sync_started: 'Synchronisation {{type}} démarrée',
      toast_error_sync_start: 'Erreur au démarrage de la synchronisation',
      toast_perms_ok: 'Permissions ok ({{kind}})',
      toast_token_revoked: 'Token révoqué',
      toast_perms_missing: 'Permissions manquantes',
      toast_diag_error: 'Erreur de diagnostic',
      toast_score: 'Score {{score}}/100',
      toast_error_analyze: "Erreur d'analyse",
      toast_generated: 'Contenu généré',
      toast_error_generate: 'Erreur de génération',
    },
    content: {
      title: 'Génération de contenu',
      generate: 'Générer du contenu',
      language: 'Langue',
      tone: 'Ton',
      subtitle: 'Générer des descriptions, SEO title, meta description et keywords avec IA',
      tab_products: 'Produits',
      tab_collections: 'Collections',
      tab_articles: 'Articles',
      tab_pages: 'Pages',
      type_description_label: 'Description',
      type_description_hint: 'Texte produit attrayant et optimisé pour le SEO',
      type_seo_title_label: 'SEO Title',
      type_seo_title_hint: 'Titre optimisé pour la SERP (max 60 car.)',
      type_meta_desc_label: 'Meta Description',
      type_meta_desc_hint: 'Extrait Google (max 160 car.)',
      type_keywords_label: 'Keywords',
      type_keywords_hint: 'Mots-clés principaux et secondaires',
      type_body_label: 'Description / Corps',
      type_body_hint: 'Texte principal de la ressource',
      filter_all: 'Tous',
      filter_needs: 'À améliorer',
      filter_medium: 'Moyens',
      filter_optimized: 'Optimisés',
      no_results_filters: 'Aucun élément ne correspond aux filtres',
      select_all: 'Tout sélectionner',
      deselect: 'Désélectionner',
      selected_count: '{{count}} sélectionnés',
      selected_max: '(max)',
      deselect_all: 'Tout désélectionner',
      pagination_of: '{{page}} / {{total}}',
      total_count: '({{count}} au total)',
      content_type_section: 'Type de contenu',
      batch_generating: 'Génération… {{done}}/{{total}}',
      batch_generate_btn: 'Générer en lot ({{count}})',
      generating_count: 'Générer ({{count}})',
      generate_btn: 'Générer',
      generating: 'Génération…',
      generate_all_btn: 'Tous',
      hint_select: '← Sélectionnez un élément ou cochez plusieurs pour le lot',
      hint_batch_ready: '{{count}} élément(s) prêt(s) pour le lot',
      batch_done_title: '✓ Lot terminé',
      batch_pending_title: 'Lot en attente…',
      batch_in_progress_title: 'Génération en lot en cours…',
      batch_done_msg: 'Tout le contenu généré. La sélection sera effacée automatiquement.',
      results_section: 'Résultats',
      publishing: 'Publication…',
      published: 'Publié',
      publish_btn: 'Publier sur Shopify',
      clear_results: 'Effacer',
      chars_unit: 'car.',
      cache_label: 'cache',
      preview_section: 'Aperçu actuel',
      loading_detail: 'Chargement du détail…',
      not_present: 'Non présent',
      not_present_plural: 'Non présents',
      empty_state: 'Cliquez sur un élément pour le voir, ou cochez plusieurs éléments et utilisez Générer en lot',
      copy_btn: 'Copier',
      type_seo_title_hint_content: 'Méta-titre pour SERP (max 60 car.)',
      no_items: 'Aucun {{type}} trouvé',
      item_deselect: 'Désélectionner',
      item_select: 'Ajouter à la sélection',
      generate_all_title: 'Générer tous les types disponibles',
      prev_item: 'Élément précédent',
      next_item: 'Élément suivant',
      toast_load_error: 'Erreur de chargement des éléments',
      toast_batch_done: 'Batch terminé : {{done}}/{{total}} produits',
      toast_batch_failed: 'Batch échoué : {{failed}} erreurs sur {{total}}',
      toast_batch_cancelled: 'Batch annulé',
      toast_batch_resumed: 'Batch actif repris…',
      toast_max_select: 'Maximum {{max}} éléments sélectionnables',
      toast_select_item: 'Sélectionnez un élément dans la liste',
      toast_select_type: 'Sélectionnez au moins un type de contenu',
      toast_from_cache: 'Contenu depuis le cache !',
      toast_generated: 'Généré avec succès !',
      toast_generate_error: 'Erreur lors de la génération du contenu',
      toast_batch_running: 'Un processus batch est déjà en cours',
      toast_no_store: 'Boutique non disponible',
      toast_batch_started: "Batch démarré : {{n}} produits en file d'attente",
      toast_batch_start_error: 'Erreur de démarrage du batch',
      toast_batch_item_error: 'Erreur de génération : {{title}}',
      toast_batch_complete: 'Batch terminé : {{done}}/{{total}} éléments',
      toast_cancel_error: "Erreur d'annulation du batch",
      toast_published: 'Contenu publié sur Shopify !',
      toast_publish_error: 'Erreur lors de la publication',
      toast_copied: 'Copié dans le presse-papiers',
      present: 'présent',
      missing: 'manquant',
      lang_it: 'Italien',
      lang_en: 'Anglais',
      lang_fr: 'Français',
      lang_de: 'Allemand',
      lang_es: 'Espagnol',
      lang_pt: 'Portugais',
      tone_professional: 'Professionnel',
      tone_luxury: 'Luxe',
      tone_technical: 'Technique',
      tone_conversational: 'Conversationnel',
    },
    images: {
      title: 'Optimisation des images',
      optimize: 'Optimiser',
      format: 'Format',
      compress: 'Compresser',
      quality: 'Qualité',
      alt_mode_label: 'Mode de génération ALT',
      alt_mode_ai: 'IA intelligente',
      alt_mode_template: 'Template gratuit',
      alt_mode_auto: 'Auto fallback',
      subtitle: 'Optimisez les images, gérez le texte ALT et publiez sur Shopify.',
      tab_optimize: 'Optimiser les images',
      tab_alt: 'Texte ALT',
      alt_coverage: 'Couverture ALT',
      with_alt_count: 'avec ALT sur',
      stat_with_alt: 'Avec ALT: {{count}}',
      stat_without_alt: 'Sans ALT: {{count}}',
      stat_no_image: 'Sans image: {{count}}',
      sync_alt_btn: 'Mettre à jour les données ALT depuis Shopify',
      syncing_alt: 'Mise à jour ALT...',
      sync_status_label: 'Statut:',
      analyzed_label: 'Analysés:',
      last_updated_label: 'Dernière mise à jour:',
      stalled: 'bloqué',
      force_stop: 'Forcer l\'arrêt (bloqué depuis 60s)',
      free_badge: '● Gratuit — aucun crédit',
      configure_btn: '▼ Configurer',
      hide_btn: '▲ Masquer',
      template_free_hint: 'Mode gratuit actif — zéro crédit IA. Template:',
      template_auto_hint: 'Repli automatique — IA si crédits disponibles, template local sinon.',
      template_config_title: 'Configurer le template ALT',
      template_label: 'Template personnalisé',
      template_preview: 'Aperçu:',
      variables_label: 'Variables disponibles — cliquez pour insérer:',
      restore_default: 'Restaurer par défaut',
      save_config: 'Enregistrer la configuration',
      saving: 'Enregistrement...',
      search_placeholder: 'Rechercher par titre, fournisseur, handle...',
      filter_all_images: 'Toutes',
      filter_with_alt: 'Avec ALT',
      filter_without_alt: 'Sans ALT',
      selected_images: '{{count}} images sélectionnées (max 50 par lot)',
      generate_batch_btn: 'Générer ALT pour la sélection',
      batch_alt_in_progress: 'Lot ALT en cours: {{done}} / {{total}}',
      batch_errors: '{{n}} erreurs',
      select_all_label: 'Tout sélectionner',
      deselect_all_label: 'Tout désélectionner',
      total_products_label: '{{count}} produits',
      timeout_title: 'Le chargement a pris trop de temps (20s)',
      timeout_desc: 'La base de données traite de nombreux produits. Réessayez dans quelques secondes.',
      error_title: 'Erreur de chargement de la liste',
      no_products_filter: 'Aucun produit correspondant aux filtres',
      alt_placeholder: 'Texte ALT (max 125 caractères)',
      status_published: 'Publié',
      status_saved: 'Enregistré',
      status_draft_alt: 'Brouillon',
      status_missing: 'Sans ALT',
      generate_alt_btn: 'Générer ALT',
      save_alt_btn: 'Enregistrer ALT',
      publish_alt_btn: 'Publier',
      prec: 'Préc.',
      succ: 'Suiv.',
      select_products: 'Sélectionner des produits',
      filter_collection_all: 'Collection: toutes',
      filter_vendor_all: 'Fournisseur: tous',
      filter_kb_all: 'KB: tous',
      filter_kb_100: 'Fichiers plus de 100 KB',
      filter_kb_500: 'Fichiers plus de 500 KB',
      filter_kb_1mb: 'Fichiers plus de 1 MB',
      filter_format_all: 'Format: tous',
      filter_landscape: 'Largeur supérieure à la hauteur',
      filter_portrait: 'Hauteur supérieure à la largeur',
      filter_square: 'Carré',
      filter_status_all: 'Statut: tous',
      filter_status_optimized: 'Déjà optimisées',
      filter_status_needs: 'À optimiser',
      visible_total: '{{visible}} visibles · {{total}} totaux',
      reset_filters: 'Réinitialiser les filtres',
      clear_selection: 'Effacer la sélection',
      no_image_products: 'Aucun produit avec image',
      ready_badge: 'Prête',
      settings_title: 'Paramètres',
      format_title: "Format d'image",
      format_square: 'Carré 1:1',
      format_landscape: 'Paysage 4:3',
      format_portrait: 'Portrait 3:4',
      format_none: 'Pas de redimensionnement',
      format_none_sub: 'Dimensions originales',
      compress_label: 'Compression',
      compress_desc: 'Réduire la taille du fichier',
      quality_label: 'Qualité',
      batch_opt_running: 'Optimisation en cours',
      batch_opt_cancelled: 'Optimisation annulée',
      batch_opt_completed: 'Optimisation terminée',
      batch_apply_running: 'Application en cours',
      batch_apply_cancelled: 'Application annulée',
      batch_apply_completed: 'Application terminée',
      background_note: 'Vous pouvez changer de section, continue en arrière-plan',
      optimizing: 'Optimisation...',
      optimize_n: 'Optimiser {{count}} images',
      optimize_one: "Optimiser l'image",
      applying: 'Application...',
      apply_n: 'Appliquer {{count}} sur Shopify',
      apply_one: 'Appliquer sur Shopify',
      preview_title: 'Aperçu',
      ready_optimizations: '{{count}} optimisations prêtes',
      select_preview_hint: 'Sélectionnez un ou plusieurs produits pour voir l\'aperçu',
      first_product_preview: 'Aperçu affiché pour le premier produit sélectionné:',
      original_label: 'Original',
      optimized_label: 'Optimisée',
      optimize_click_hint: 'Cliquez sur "Optimiser" pour le résultat',
      reduction_label: 'Réduction',
      apply_btn: 'Appliquer',
      history_opt_title: "Historique des optimisations",
      history_opt_subtitle: 'Opérations appliquées sur Shopify, erreurs et restaurations.',
      stat_running_label: 'En cours',
      stat_completed_label: 'Terminées',
      stat_errors_label: 'Incomplètes',
      stat_undo_label: 'Annuler',
      total_savings: 'Économies totales',
      history_loading: "Chargement de l'historique...",
      no_history: 'Aucune opération appliquée encore.',
      restoring: 'Restauration...',
      undo_btn: 'Annuler',
      kb_warning: 'La taille KB n\'est pas dans les données locales. Pour la rendre précise, elle doit être enregistrée par le backend lors de la synchronisation des images.',
      senza_vendor: 'Sans fournisseur',
      alt_stat_coverage: '{{n}} avec ALT sur {{total}}',
      apply_batch_cancelled: 'Application annulée',
      apply_batch_done_label: 'Application terminée',
      apply_batch_running: 'Application en cours',
      apply_n_btn: 'Appliquer {{n}} sur Shopify',
      applying_btn: 'Application...',
      auto_fallback_hint: 'Auto fallback — IA si crédits disponibles, template local si épuisés.',
      background_hint: 'Vous pouvez changer de section, continue en arrière-plan',
      badge_draft: 'Brouillon',
      badge_missing: 'Sans ALT',
      badge_published: 'Publié',
      badge_ready: 'Prête',
      badge_saved: 'Enregistré',
      batch_close: 'Fermer',
      batch_generate_btn: 'Générer ALT pour la sélection',
      batch_progress: 'Lot ALT en cours: {{done}} / {{total}}',
      batch_selected: '{{n}} images sélectionnées (max 50 par lot)',
      collection_all: 'Collection: toutes',
      compress_sub: 'Réduire la taille du fichier',
      config_btn: '▼ Configurer',
      deselect_all: 'Tout désélectionner',
      empty_filtered: 'Aucun produit correspondant aux filtres',
      filter_all: 'Toutes',
      format_label: "Format d'image",
      gen_alt_btn: 'Générer ALT',
      history_completed: 'Terminées',
      history_empty: 'Aucune opération appliquée encore.',
      history_incomplete: 'Incomplètes',
      history_running: 'En cours',
      history_savings: 'Économies totales',
      history_subtitle: 'Opérations appliquées sur Shopify, erreurs et restaurations.',
      history_title: 'Historique des optimisations',
      history_undo_label: 'Annuler',
      last_update_label: 'Dernière mise à jour:',
      load_error: 'Erreur de chargement de la liste',
      n_errors: '{{n}} erreurs',
      n_products: '{{n}} produits',
      n_selected: '{{n}} sélectionnés',
      next_page: 'Suiv.',
      no_products: 'Aucun produit avec image',
      no_vendor: 'Sans fournisseur',
      opt_batch_cancelled: 'Optimisation annulée',
      opt_batch_done: 'Optimisation terminée',
      opt_batch_running: 'Optimisation en cours',
      optimize_n_btn: 'Optimiser {{n}} images',
      optimize_one_btn: "Optimiser l'image",
      optimizing_btn: 'Optimisation...',
      orientation_all: 'Format: tous',
      orientation_landscape: 'Largeur supérieure à la hauteur',
      orientation_portrait: 'Hauteur supérieure à la largeur',
      orientation_square: 'Carré',
      page_info: 'Page {{page}} sur {{total}}',
      pagination: 'Page {{page}} sur {{total}}',
      prev: 'Préc.',
      publish_btn: 'Publier',
      retry: 'Réessayer',
      select_all: 'Tout sélectionner',
      size_100kb: 'Fichiers plus de 100 KB',
      size_1mb: 'Fichiers plus de 1 MB',
      size_500kb: 'Fichiers plus de 500 KB',
      size_all: 'KB: tous',
      status_all: 'Statut: tous',
      status_label: 'Statut:',
      status_needs: 'À optimiser',
      status_optimized: 'Déjà optimisées',
      status_stalled: 'bloqué',
      sync_btn: 'Mettre à jour les données ALT depuis Shopify',
      sync_btn_title: 'Relit depuis Shopify les images et les textes ALT réels',
      syncing: 'Mise à jour ALT...',
      template_active: 'Mode gratuit actif — zéro crédit IA. Template:',
      template_custom_label: 'Template personnalisé',
      template_free_badge: '● Gratuit — aucun crédit',
      template_preview_label: 'Aperçu:',
      template_reset: 'Restaurer par défaut',
      template_save: 'Enregistrer la configuration',
      template_saving: 'Enregistrement...',
      template_vars_label: 'Variables disponibles — cliquez pour insérer:',
      timeout_msg: 'La base de données traite de nombreux produits. Réessayez dans quelques secondes.',
      toast_alt_ai: 'ALT généré via IA',
      toast_alt_cancelled: 'Mise à jour ALT annulée — vous pouvez la redémarrer',
      toast_alt_empty: 'ALT vide',
      toast_alt_from_cache: 'ALT depuis le cache',
      toast_alt_gen_error: 'Erreur de génération ALT',
      toast_alt_publish_error: 'Erreur de publication',
      toast_alt_published: 'Publié sur Shopify',
      toast_alt_save_error: 'Erreur de sauvegarde',
      toast_alt_saved: 'ALT sauvegardé',
      toast_alt_sync_start_error: 'Erreur de démarrage de la mise à jour ALT',
      toast_alt_sync_started: 'Mise à jour des données ALT démarrée',
      toast_alt_template: 'ALT généré via template (gratuit)',
      toast_alt_template_fallback: 'ALT via template (crédits épuisés)',
      toast_alt_update_error: 'Erreur de mise à jour ALT',
      toast_alt_updated: 'Données ALT mises à jour: {{n}} produits analysés',
      toast_applied: 'Image appliquée sur Shopify',
      toast_apply_batch_done: '{{n}} images appliquées sur Shopify',
      toast_apply_batch_errors: 'Application terminée avec {{n}} erreurs',
      toast_apply_batch_started: 'Application démarrée: {{n}} images. Vous pouvez changer de section.',
      toast_batch_alt_done: 'Lot terminé',
      toast_batch_alt_started: 'Lot démarré: {{n}} images, {{c}} à la fois',
      toast_batch_done: 'Lot terminé: {{n}} images optimisées. Vous pouvez les appliquer sur Shopify.',
      toast_batch_errors: '{{n}} images non traitées. Réessayez ou vérifiez les journaux.',
      toast_batch_started: 'Lot démarré: {{n}} images. Vous pouvez changer de section, continue en arrière-plan.',
      toast_cancel_error: "Erreur d'annulation",
      toast_no_draft: 'Aucune image optimisée à appliquer',
      toast_no_images: 'Aucune image sélectionnée',
      toast_no_ready: 'Aucune optimisation prête à appliquer',
      toast_no_store: 'Boutique non disponible',
      toast_optimize_error: "Erreur d'optimisation",
      toast_optimized: "Image optimisée. Vous pouvez maintenant l'appliquer sur Shopify.",
      toast_select_product: 'Sélectionnez au moins un produit',
      toast_template_save_error: 'Erreur de sauvegarde du template',
      toast_template_saved: 'Configuration du template sauvegardée',
      toast_undo_done: 'Image originale restaurée',
      toast_undo_error: 'Erreur lors de la restauration',
      undoing_btn: 'Restauration...',
      vendor_all: 'Fournisseur: tous',
      toast_no_product: 'Sélectionnez un produit',
      toast_no_image: "Le produit n'a pas d'image",
      toast_no_preview: "Optimisez d'abord une image",
      toast_apply_error: "Erreur d'application sur Shopify",
      n_ready: '{{n}} optimisations prêtes',
      preview_hint: "Sélectionnez un ou plusieurs produits pour voir l'aperçu",
      preview_first: 'Aperçu affiché pour le premier produit sélectionné:',
      click_optimize_hint: 'Cliquez sur "Optimiser" pour le résultat',
      apply_single_btn: 'Appliquer',
    },
    alt_template: {
      section_title: 'Template ALT',
      mode_label: 'Mode de génération du texte ALT',
      textarea_label: 'Template personnalisé',
      preview_label: 'Aperçu',
      vars_label: 'Variables disponibles — cliquer pour insérer',
      hint_template: 'Mode gratuit : aucun crédit IA consommé pour le texte ALT.',
      hint_auto: 'Auto fallback : IA si crédits disponibles, sinon template local.',
    },
    batch: {
      title: 'Opérations en lot',
      start: 'Démarrer',
      cancel: 'Annuler',
      subtitle: 'Traitement côté serveur persistant — continue même si vous changez de page ou fermez l\'onglet',
      locked_title: 'Opérations en lot non disponibles',
      locked_desc: 'Les opérations en lot sont disponibles à partir du plan Starter. Traitez des centaines de produits en parallèle en un clic.',
      upgrade_btn: 'Passer à Starter',
      op_content_label: 'Générer du contenu IA',
      op_content_desc: 'Description, SEO title, meta description, keywords',
      op_translate_label: 'Traduire les produits',
      op_translate_desc: 'Traduction complète dans la langue sélectionnée',
      op_images_label: 'Optimiser les images',
      op_images_desc: 'Redimensionnement 1:1 et compression des images',
      field_description_label: 'Description',
      field_description_hint: '150-250 mots',
      field_seo_title_label: 'SEO Title',
      field_seo_title_hint: 'max 60 caractères',
      field_meta_desc_label: 'Meta Description',
      field_meta_desc_hint: '100-160 caractères',
      field_keywords_label: 'Keywords',
      field_keywords_hint: '5-10 mots-clés',
      count_all: 'Tous',
      status_pending: 'En file d\'attente',
      status_running: 'En cours',
      status_completed: 'Terminé',
      status_failed_job: 'Échoué',
      status_cancelled: 'Annulé',
      opt_in_progress: 'Optimisation des images en cours…',
      batch_in_progress: 'Lot IA en cours…',
      images_progress: '{{done}} / {{total}} images',
      products_progress: '{{done}} / {{total}} produits',
      errors_count: '{{count}} erreurs',
      duration_label: 'Durée: {{time}}',
      starting: 'Démarrage...',
      seo_gen_in_progress: 'Génération + Publication SEO en cours',
      gen_publish_auto: 'Génération et publication automatique sur Shopify',
      section_operation: 'Opération',
      section_fields: 'Champs à générer',
      fields_selected: '{{count}}/{{total}} sélectionnés',
      fields_warning: 'Sélectionnez au moins un champ pour démarrer le lot',
      fields_hint: 'Un seul appel IA par produit génère tous les champs sélectionnés — latence réduite et coûts diminués.',
      section_options: 'Options',
      label_language: 'Langue',
      label_tone: 'Ton',
      tone_professional: 'Professionnel',
      tone_luxury: 'Luxe',
      tone_technical: 'Technique',
      tone_conversational: 'Conversationnel',
      label_target_lang: 'Langue cible',
      images_note: 'Redimensionnement 1:1 (800×800) + compression qualité 85%.',
      section_quantity: 'Quantité de produits',
      available_count: '{{count}} disponibles',
      catalog_selection: '{{count}} produit(s) sélectionné(s) depuis le catalogue',
      remove_selection: 'Supprimer la sélection',
      products_selected_count: '{{count}} produit(s) sélectionné(s)',
      processing: 'Traitement en cours…',
      start_btn: 'Démarrer le traitement',
      history_title: 'Historique des lots',
      history_subtitle: 'mis à jour depuis la BDD',
      stat_running: 'En cours',
      stat_completed: 'Terminés',
      stat_products_ok: 'Produits OK',
      no_batch: 'Aucun lot exécuté',
      no_batch_hint: 'Les tâches apparaîtront ici après le premier traitement',
      job_content: 'Générer du contenu IA',
      job_translate: 'Traduction',
      job_images: 'Optimisation des images',
      job_products: '{{done}}/{{total}} produits',
      log_lang: 'Langue:',
      log_tone: 'Ton:',
      toast_completed: 'Lot terminé : {{done}}/{{total}} produits traités',
      toast_failed: 'Lot échoué : {{count}} erreurs',
      toast_no_products: 'Aucun produit disponible',
      soon_lbl: 'bientôt',
      btn_analyze_seo: 'Analyser SEO',
      btn_view: 'Voir',
      toast_no_fields: 'Sélectionnez au moins un champ à générer',
      toast_images_started: 'Optimisation des images démarrée : {{count}} produits',
      toast_started: 'Lot démarré : {{count}} produits',
      toast_start_error: 'Erreur de démarrage',
      toast_cancelled: 'Lot annulé',
      toast_cancel_error: "Erreur d'annulation",
      fields_label: 'Champs',
      log_summary: 'Journaux opérations individuelles',
    },
    history: {
      title: 'Historique',
      empty: 'Aucune opération trouvée',
      subtitle: 'Audit complet de toutes les exécutions IA — {{n}} opérations au total',
      refresh_btn: 'Actualiser',
      total_operations: 'Total des opérations',
      success_rate: 'Taux de succès',
      n_successes: '{{n}} succès',
      credits_today: 'Crédits aujourd\'hui',
      products_today: 'Produits aujourd\'hui',
      avg_duration: 'Durée moyenne',
      last_autopilot: 'Dernier Autopilot',
      filters: 'Filtres',
      filters_active: 'actifs',
      reset_all: 'Tout réinitialiser',
      search_placeholder: 'Rechercher un produit...',
      op_all: 'Tous les types',
      op_description: 'Description IA',
      op_seo_title: 'SEO Title IA',
      op_meta_description: 'Meta Description IA',
      op_batch: 'Génération en lot',
      op_translation: 'Traduction',
      op_image: 'Image',
      op_sync: 'Sync Shopify',
      trigger_all: 'Tous les déclencheurs',
      status_all: 'Tous les statuts',
      status_success: 'Succès',
      status_partial: 'Partiel',
      status_error: 'Erreur',
      th_status: 'Statut',
      th_type: 'Type d\'opération',
      th_product: 'Produit',
      th_trigger: 'Déclencheur',
      th_seo_delta: 'SEO Delta',
      th_credits: 'Crédits',
      th_duration: 'Durée',
      th_timestamp: 'Horodatage',
      loading: 'Chargement...',
      remove_filters: 'Supprimer les filtres',
      load_more: 'Charger plus ({{shown}} sur {{total}} affichés)',
      details_title: 'Détails de l\'exécution',
      detail_op_id: 'ID opération',
      detail_product_id: 'ID produit',
      detail_store_id: 'Store ID',
      detail_type: 'Type',
      detail_trigger: 'Déclencheur',
      detail_status: 'Statut',
      detail_language: 'Langue',
      detail_tone: 'Ton',
      detail_tokens: 'Tokens utilisés',
      detail_fields: 'Champs',
      detail_credits: 'Crédits',
      detail_duration: 'Durée',
      detail_seo_before: 'SEO avant',
      detail_seo_after: 'SEO après',
      detail_timestamp: 'Horodatage',
      error_prefix: 'Erreur : ',
      label_description: 'Description IA',
      label_seo_title: 'SEO Title IA',
      label_meta_description: 'Meta Description IA',
      label_keywords: 'Keywords IA',
      label_batch: 'Génération en lot',
      label_translation: 'Traduction',
      label_image: 'Optimisation d\'image',
      label_sync: 'Sync Shopify',
      label_push: 'Publication Shopify',
    },
    batch_banner: {
      errors: 'erreurs',
      optimizing: 'Optimisation des images',
      optimizing_cancelled: 'Optimisation annulée',
      optimizing_completed: 'Optimisation terminée',
      applying: 'Application sur Shopify',
      applying_cancelled: 'Application annulée',
      applying_completed: 'Application terminée',
      open_images: 'Ouvrir les images',
      open_catalog: 'Ouvrir le catalogue',
      type_collections: 'Collections',
      type_articles: 'Articles',
      type_pages: 'Pages',
      type_contents: 'Contenus',
      mode_publish: 'Publication',
      mode_both: 'Générer+Publier',
      mode_generate: 'Génération SEO IA',
      state_cancelled: '(annulé)',
      state_completed: '(terminé)',
    },
    app_banner: {
      expired: 'Token Shopify expiré ou révoqué.',
      reconnect_desc: "Reconnectez l'application pour restaurer la synchronisation et la publication.",
      detected_in: 'détecté dans',
      reconnect_btn: 'Reconnecter maintenant',
    },
    review_popup: {
      greeting: 'Bonjour ! Je suis là 👋',
      subtitle: "J'espère que tout se passe très bien avec AI Optimizer !",
      rating_title: "L'app vous plaît-elle ?",
      rating_desc: "Votre avis nous aide à nous améliorer et à atteindre d'autres marchands Shopify.",
      rating_tap: 'Appuyez sur une étoile pour noter',
      star: {
        terrible: 'Terrible',
        bad: 'Pas bien',
        average: 'Moyen',
        good: 'Bien !',
        excellent: 'Excellent ! 🚀',
      },
      positive_title: 'Fantastique ! Merci beaucoup 🎉',
      positive_desc: "Un avis sur le Shopify App Store fait une énorme différence pour nous. Ça ne prend qu'1 minute !",
      negative_title: 'Merci pour le retour 🙏',
      negative_desc: 'Avez-vous des idées sur ce que nous pourrions faire mieux ?',
      review_btn: '⭐ Laisser un avis',
      close_btn: 'Fermer',
      dismiss: 'Ne plus afficher',
      skip: 'Ignorer →',
    },
    support: {
      title: 'Support',
      send: 'Envoyer',
      placeholder: 'Écrivez votre message...',
    },
    editor: {
      placeholder: 'Écrivez ici...',
      bold: 'Gras',
      italic: 'Italique',
      underline: 'Souligné',
      h2: 'Titre H2',
      h3: 'Titre H3',
      paragraph: 'Paragraphe',
      ul: 'Liste à puces',
      ol: 'Liste numérotée',
      blockquote: 'Citation',
      link: 'Insérer un lien',
      remove_format: 'Supprimer la mise en forme',
      link_prompt: 'URL du lien',
    },
    recommendations: {
      empty: 'Aucune action critique pour le moment. Excellent travail !',
      filter_all_prio: 'Toutes les priorités',
      filter_all_cat: 'Toutes les catégories',
      count_shown: '{{n}} actions affichées',
      see: 'Voir',
      sev_high: 'Haute',
      sev_medium: 'Moyenne',
      sev_low: 'Basse',
      cat_catalog: 'Catalogue',
      missing_meta_description: '{{count}} produits sans méta description',
      missing_description: '{{count}} produits sans description',
      missing_alt_text: '{{count}} images sans texte ALT',
      missing_product_image: '{{count}} produits sans image',
    },
    audit: {
      not_detected: 'Non détecté',
      disabled: 'Désactivé',
      not_scanned: 'Analyse non effectuée',
      status_warning: 'Avertissement',
      status_error: 'Erreur',
      cat_performance: 'Performance',
      cat_trust: 'Confiance',
      cat_catalog: 'Catalogue',
      checks_suffix: 'vérifications',
      badge_err: 'err',
      badge_warn: 'avert',
      badge_ok: 'ok',
      value_label: 'Valeur',
      checks: {
        title: { name: 'Titre', hint: 'Titre de la page' },
        meta_description: { name: 'Méta description', hint: 'Méta description de la page d\'accueil' },
        h1: { name: 'H1', hint: 'Exactement 1 H1 par page est optimal' },
        h2: { name: 'H2', hint: 'Au moins un H2 recommandé' },
        canonical: { name: 'Canonical', hint: 'URL canonique' },
        lang: { name: 'Langue', hint: 'Attribut langue' },
        json_ld_structured_data: { name: 'JSON-LD / Données Structurées', hint: 'Données structurées' },
        open_graph: { name: 'Open Graph', hint: 'Méta social' },
        twitter_card: { name: 'Twitter Card', hint: 'Méta Twitter/X' },
        robots_txt: { name: 'robots.txt', hint: 'Robots' },
        sitemap_xml: { name: 'Sitemap.xml', hint: 'Sitemap' },
        status_code: { name: 'Code de statut', hint: 'Code HTTP' },
        indexability: { name: 'Indexabilité', hint: 'Indexabilité' },
        redirects: { name: 'Redirections', hint: 'URL finale' },
        https: { name: 'HTTPS', hint: 'HTTPS' },
        load_time: { name: 'Temps de chargement', hint: 'Mesuré serveur-à-serveur' },
        page_weight: { name: 'Poids de la page', hint: 'Taille HTML de la page d\'accueil' },
        image_lazy_loading: { name: 'Chargement différé des images', hint: 'Images lazy' },
        mobile_viewport: { name: 'Viewport mobile', hint: 'Viewport mobile' },
        favicon: { name: 'Favicon', hint: 'Favicon' },
        images_with_alt: { name: 'Images avec ALT', hint: 'Accessibilité des images' },
        privacy_policy: { name: 'Politique de confidentialité', hint: 'Confidentialité' },
        cookie_policy: { name: 'Politique de cookies', hint: 'Cookie' },
        terms_conditions: { name: 'Conditions générales', hint: 'Conditions' },
        contact_page: { name: 'Page de contact', hint: 'Contact' },
        shipping_policy: { name: 'Politique d\'expédition', hint: 'Expédition' },
        returns_refunds: { name: 'Retours & Remboursements', hint: 'Retours' },
        social_links: { name: 'Liens sociaux', hint: 'Social' },
        products_without_description: { name: 'Produits sans description', hint: 'Descriptions produit' },
        products_without_images: { name: 'Produits sans images', hint: 'Images produit' },
        products_without_meta_description: { name: 'Produits sans méta description', hint: 'Méta descriptions produit' },
        duplicate_titles: { name: 'Titres en double', hint: 'Titres produit' },
        duplicate_meta_descriptions: { name: 'Méta descriptions en double', hint: 'Méta descriptions produit' },
        thin_content_200_char: { name: 'Contenu mince (<200 car.)', hint: 'Contenu produit' },
      },
    },
    score_card: {
      pillar_technical_seo: 'SEO Technique',
      pillar_ux: 'UX',
      pillar_performance: 'Performance',
      pillar_trust: 'Trust',
      pillar_catalog: 'Catalogue',
      label_excellent: 'Excellent',
      label_good: 'Améliorable',
      label_critical: 'Critique',
      no_audit_desc: "Audit pas encore effectué — lancez l'audit pour obtenir le SEO Technique, UX, Trust et Performance.",
      auditing: 'Audit en cours...',
      run_audit: 'Lancer Audit Site 360°',
      calculated_on: 'Calculé pour',
    },
    upgrade: {
      popular: '⭐ Le Plus Populaire',
      period: '/mois',
      plan_header: 'Plan',
      cta: 'Mettre à niveau vers {{name}} — {{price}}{{period}}',
      dismiss: 'Pas maintenant',
      feature_available: '{{feature}} est disponible à partir du plan {{plan}}.',
      reason_credits_title: 'Crédits AI épuisés',
      reason_credits_body: "Vous avez atteint la limite mensuelle de votre plan. Mettez à niveau pour continuer à générer du contenu.",
      reason_products_title: 'Limite du catalogue atteinte',
      reason_products_body: "Votre catalogue Shopify dépasse la limite du plan actuel. Mettez à niveau pour synchroniser tous les produits.",
      reason_feature_title: 'Fonctionnalité Premium',
      reason_feature_body: 'Cette fonctionnalité est disponible dans les plans supérieurs.',
    },
    gsc: {
      connect_title: 'Connecter Google Search Console',
      connect_desc: "Surveillez les impressions, clics, CTR et position moyenne. Demandez la réindexation après les optimisations IA.",
      connect_feat_analytics: 'Analytiques de recherche',
      connect_feat_indexing: "Surveillance de l'indexation",
      connect_feat_keywords: 'Suivi des mots-clés',
      connect_feat_sitemap: 'Gestionnaire de sitemap',
      connect_btn_loading: 'Connexion en cours...',
      connect_btn: 'Connecter le compte Google',
      prop_modal_title: 'Sélectionner une propriété',
      prop_modal_desc: 'Choisissez la propriété Search Console à connecter.',
      prop_modal_empty: 'Aucune propriété trouvée. Vérifiez que vous avez des propriétés dans Google Search Console.',
      prop_modal_cancel: 'Annuler',
      prop_modal_confirm: 'Confirmer',
      coming_soon_desc: 'Disponible en {{phase}}',
      top_opp_title: 'Top opportunités SEO',
      top_opp_sub: 'Top 10 requêtes par Opportunity Score',
      copy: 'Copier',
      copied: 'Copié !',
      badge_quick_win: '🔥 Quick Win',
      badge_low_ctr: '⚡ CTR faible',
      badge_page_1: '🚀 Page 1',
      badge_high_imp: '📈 Haute visibilité',
      badge_brand: '🏷️ Brand',
      qt_category: 'Catégorie',
      qt_product: 'Produit',
      qt_generic: 'Générique',
      qt_info: 'Info',
      qt_brand: 'Brand',
      seo_analysis: 'Analyse SEO',
      generating_ai: "Génération de l'analyse IA en cours...",
      analysis_error: "Erreur lors de la génération de l'analyse. Réessayez plus tard.",
      estimated_value: 'Valeur estimée',
      clicks_monthly: 'Clics potentiels/mois',
      ctr_at_pos: 'CTR à pos. {{pos}}',
      traffic_increase: 'Augmentation du trafic',
      current_stats: 'Actuel : {{clicks}} clics/mois · +{{pts}} pp CTR estimé',
      priority_action: 'Action prioritaire',
      content_opt: 'Optimisation du contenu',
      title_seo: 'Title SEO',
      title_chars: '(50–60 caractères)',
      title_copied: 'Title copié !',
      h1_suggested: 'H1 suggéré',
      h1_page_title: '(titre de la page)',
      h1_copied: 'H1 copié !',
      meta_desc: 'Meta Description',
      meta_chars: '(150–160 caractères)',
      meta_copied: 'Meta copiée !',
      faq_all_copied: 'Toutes les FAQ copiées !',
      faq_suggested: 'FAQ suggérées',
      copy_all: 'Tout copier',
      faq_copied: 'FAQ copiée !',
      related_kw: 'Mots-clés associés',
      click_to_copy: '· cliquer pour copier',
      kw_copied: '"{{kw}}" copié !',
      tech_suggestions: 'Suggestions techniques',
      copy_keyword: 'Copier le mot-clé',
      kw_copied_plain: 'Mot-clé copié !',
      shopify_products: 'Produits Shopify',
      search_store: 'Rechercher dans la boutique',
      optimize_content: 'Optimiser le contenu',
      col_impressions: 'Impressions',
      col_position: 'Position',
      no_queries: 'Aucune requête trouvée avec les filtres actuels.',
      ai_panel_title: 'Suggestions IA',
      analyze_query: 'Analyser la requête →',
      sugg_title_improvement: 'Title tag',
      sugg_meta: 'Meta description',
      sugg_content_gap: 'Contenu manquant',
      sugg_schema: 'Schema markup',
      sugg_links: 'Liens internes',
      opp_load_err: 'Erreur de chargement des opportunités SEO',
      cache_updated: 'Cache mis à jour — rechargement des données',
      cache_error: 'Erreur de rafraîchissement du cache',
      loading_data: 'Chargement des données Search Console...',
      load_error_title: 'Impossible de charger les opportunités',
      retry: 'Réessayer',
      tracked_queries: 'Requêtes suivies',
      sku_excluded: '{{n}} SKU/EAN exclus',
      total_impressions: 'Impressions totales (28j)',
      total_clicks: 'Clics totaux (28j)',
      avg_ctr: 'CTR moyen',
      ai_generating: "Analyse IA en cours de génération...",
      ai_generating_sub: 'Les suggestions IA apparaîtront ici dans quelques instants.',
      no_ai_insights: 'Aucun insight IA disponible',
      no_ai_insights_sub: "Aucune requête avec des opportunités d'optimisation significatives n'a été trouvée.",
      filter_all: 'Tout ({{n}})',
      search_placeholder: 'Rechercher des requêtes...',
      refresh_title: 'Actualiser les données',
      page_prev: '← Préc.',
      page_info: 'Page {{page}} / {{total}} · {{count}} requêtes',
      page_next: 'Suiv. →',
      footer_note: 'Données Search Console 28 derniers jours · cache 6h · propriété : {{url}}',
      footer_excluded: ' · {{n}} SKU/EAN exclus',
      verdict_pass: 'Indexée',
      verdict_fail: 'Non indexée',
      verdict_neutral: 'Exclue',
      stato_title: 'Statut Google — Sources de données',
      in_sitemap: 'Dans le sitemap',
      sitemap_registered_lbl: 'Sitemaps enregistrés',
      sitemap_errors_lbl: 'Erreurs de sitemap',
      with_impressions: 'Avec impressions',
      search_appear_note: 'Pages apparues en recherche · {{days}}j',
      not_real_indexed: '≠ pages réellement indexées',
      index_estimate_lbl: "Estimation d'indexation",
      estimate_unavail: 'Estimation disponible après 200 URL inspectées. Lancer le scan par lots pour collecter le sample.',
      inspected_lbl: 'Inspectées',
      indexed_confirmed: 'Indexées confirmées',
      not_indexed_lbl: 'Non indexées',
      excluded_lbl: 'Exclues',
      certain_data: 'Donnée certaine pour les URL inspectées',
      batch_title: 'Scan par lots — Inspection API',
      batch_priority: 'Priorité Analytics',
      batch_progress: "Progression de l'inspection du sitemap",
      batch_stopping: 'Arrêt en cours…',
      batch_running: 'Scan en cours…',
      batch_starting: 'Démarrage...',
      batch_done_lbl: 'Sitemap terminé ✓',
      batch_start_btn: 'Lancer le scan ({{n}} disponibles)',
      batch_timeout: 'Timeout — cliquer pour réinitialiser',
      batch_stopping_wait: 'Arrêt en cours — veuillez patienter…',
      batch_stop_btn: 'Arrêter le scan',
      batch_remaining: '{{n}} URL encore à inspecter',
      batch_quota_out: 'Quota journalier épuisé — réessayer demain',
      batch_start_err: 'Erreur de démarrage du scan',
      batch_complete: 'Scan terminé : {{n}} URL inspectées',
      dq_title: 'Détails techniques API',
      dq_api_status: 'Statut API',
      dq_daily_quota: 'Quota journalier',
      dq_used_today: "Utilisées aujourd'hui",
      dq_remaining: 'Restantes',
      dq_history: 'Historique des inspections',
      dq_completion: 'Achèvement',
      dq_days_est: 'jours estimés',
      dq_start_for_eta: "Lancer le scan pour calculer l'ETA",
      sm_no_sitemap: 'Aucun sitemap trouvé',
      sm_no_sitemap_desc: "Ajoutez un sitemap.xml à Google Search Console pour surveiller l'indexation.",
      sm_submit_ok: 'Sitemap soumis à Google',
      sm_in_progress: 'En cours de calcul…',
      sm_submit_btn: 'Soumettre',
      insp_title: "Inspecter l'URL",
      insp_quota: "{{used}}/{{limit}} inspections aujourd'hui",
      insp_loading: 'Inspection...',
      insp_btn: 'Inspecter',
      insp_domain_lbl: 'Domaine property :',
      insp_domain_note: "L'URL inspectée doit lui appartenir",
      insp_last_crawl: 'Dernier crawl',
      insp_indexing: 'Indexation',
      insp_yes: 'Oui',
      insp_no: 'Non',
      insp_canonical_decl: 'Canonical déclaré',
      insp_canonical_diff: '⚠ Canonical Google (différent)',
      insp_noindex: 'noindex détecté',
      insp_open_gsc: 'Ouvrir dans Search Console',
      insp_err: "Erreur d'inspection URL",
      cov_title: 'Coverage — Raisons',
      cov_real_data: 'Données réelles — Inspection API',
      cov_conf_high: 'Haute fiabilité',
      cov_conf_medium: 'Fiabilité moyenne',
      cov_conf_low: 'Faible fiabilité',
      cov_updated: 'Mis à jour :',
      cov_deselect: 'Désélectionner',
      cov_inspected_note: "URL inspectées · cliquer pour filtrer",
      cov_none_inspected: 'Aucune inspection',
      cov_no_data: 'Aucune donnée de coverage disponible',
      cov_no_data_desc: "Les raisons de non-indexation sont construites automatiquement à chaque inspection d'URL. Utilisez «Lancer le scan automatique» pour remplir cette section.",
      cov_solution: 'Solution recommandée',
      cov_filter_active: "Filtre actif dans l'historique",
      ih_worklist: 'Liste de tâches SEO',
      ih_history: 'Historique des inspections',
      ih_filter_coverage: 'Filtre Coverage',
      ih_tab_all: 'Toutes',
      ih_tab_not_ind: 'Non ind.',
      ih_tab_indexed: 'Indexées',
      ih_tab_excluded: 'Exclues',
      ih_tab_errors: 'Erreurs',
      ih_tab_with_imp: 'Avec impr.',
      ih_tab_products: 'Produits',
      ih_tab_collections: 'Collections',
      ih_sort_priority: '↓ Priorité',
      ih_sort_impressions: '↓ Impressions',
      ih_sort_clicks_est: '↓ Clics est.',
      ih_sort_date: '↓ Date',
      ih_sort_state: '↓ État GSC',
      ih_clear: 'Effacer',
      ih_search: 'Rechercher URL…',
      ih_open: 'Ouvrir',
      ih_indexing_state: "État d'indexation",
      ih_canonical_diff: '⚠ Canonical Google (choisi, différent)',
      ih_canonical_same: 'Canonical Google (identique)',
      ih_ai_fix: 'Optimiser avec AI →',
      ih_total: '{{n}} URL · {{total}} au total',
      ih_est_clicks: '· +{{n}} clics/mois estimés',
      iai_title: 'Suggestions AI — Indexation',
      iai_filter_note: '· cliquer pour filtrer',
      iai_prio_high: 'Haute priorité',
      iai_prio_medium: 'Priorité moyenne',
      iai_prio_low: 'Basse priorité',
      iai_causes: 'Causes possibles :',
      iai_actions: 'Actions recommandées :',
      fix_apply_all: 'Tout appliquer',
      fix_applied: 'Appliqué',
      fix_suggestion: 'Suggestion',
      fix_chars: 'caractères',
      fix_content_impr: 'Améliorations du contenu',
      fix_int_links: 'Liens internes suggérés',
      fix_open_url: "Ouvrir l'URL",
      fix_close: 'Fermer',
      fix_seo_opt: 'Optimisation SEO',
      trend_title: "Tendance d'indexation",
      trend_updated: 'Mis à jour au',
      trend_coverage: 'Couverture',
      trend_30d_kpi: 'Tendance 30j',
      trend_no_data: 'Données historiques en construction',
      trend_no_data_desc: "La tendance sera disponible après la collecte d'au moins 2 snapshots.",
      trend_one_snap: '1 snapshot collecté sur 2.',
      trend_start_scan: 'Lancez un scan par lots pour commencer.',
      trend_ind: 'ind.',
      trend_not_ind: 'non ind.',
      trend_snap_note: 'Snapshot par scan',
      ic_loading: "Chargement des données d'indexation...",
      ic_load_err: "Impossible de charger les données d'indexation",
      ic_clear_confirm: "Effacer tout l'historique des inspections ?",
      ic_cleared: 'Historique effacé',
      ic_clear_err: 'Erreur de suppression',
      ic_seo_opp: 'Opportunités SEO — Executive Summary',
      ic_recoverable: 'URLs récupérables',
      ic_open_worklist: '⚡ Ouvrir la liste de tâches →',
      ic_view_all: 'Tout voir →',
      ic_crawled_ni: 'Crawlées – non indexées',
      ic_crawled_ni_note: 'Google les connaît mais ne les sert pas',
      ic_discovered_ni: 'Découvertes – non indexées',
      ic_discovered_ni_note: 'Trouvées mais jamais crawlées',
      ic_with_imp_ni: 'Avec impressions GSC',
      ic_with_imp_ni_note: 'Ont du trafic mais ne sont pas indexées',
      ic_other_ni: 'Autres non indexées',
      ic_other_ni_note: 'Inconnues de Google ou erreurs',
      ic_refresh: 'Actualiser',
      rh_title: 'Historique des modifications',
      rh_versions: 'versions',
      rh_confirm: "Restaurer la version du {{date}} ?\n\nLes modifications actuelles de l'éditeur seront remplacées.",
      rh_restored_ok: 'v{{v}} restaurée dans le thème Shopify',
      rh_restored_editor: "Version v{{v}} chargée dans l'éditeur — cliquez sur Enregistrer pour l'appliquer",
      rh_restore_err: 'Erreur de restauration',
      rh_current: 'actuelle',
      rh_initial: 'Version initiale',
      rh_no_diff: 'Aucune modification textuelle',
      rh_more_added: '+ {{n}} ajouts supplémentaires',
      rh_more_removed: '- {{n}} suppressions supplémentaires',
      rh_restore_btn: 'Restaurer',
      rb_load_err: 'Erreur de chargement de robots.txt',
      rb_save_err: "Erreur d'enregistrement",
      rb_analyze_err: "Erreur d'analyse",
      rb_score_good: 'Excellent',
      rb_score_ok: 'À améliorer',
      rb_score_bad: 'Critique',
      rb_analysis_title: 'Analyse SEO Robots',
      rb_analyzing: 'Analyse…',
      rb_analyze: 'Analyser',
      rb_analyze_hint: "Cliquez sur «Analyser» pour détecter automatiquement les problèmes SEO et les opportunités d'optimisation",
      rb_no_issues: 'Aucun problème détecté',
      rb_no_issues_desc: 'Votre robots.txt suit les meilleures pratiques Shopify',
      rb_critical: 'CRITIQUE',
      rb_warning: 'AVERTISSEMENT',
      rb_validation_title: 'Validation du Robots.txt',
      rb_reload: 'Recharger',
      rb_editor_title: 'Éditeur Robots.txt',
      rb_modified: 'Modifié',
      rb_diff_close: 'Fermer le diff',
      rb_editor_restore: 'Restaurer',
      rb_saving: 'Enregistrement…',
      rb_save: 'Enregistrer',
      rb_blocking_warning: "🚨 VOUS BLOQUEZ TOUT LE SITE — \"Disallow: /\" empêche Google d'indexer toute page",
      rb_diff_preview: 'Aperçu des modifications :',
      rb_opportunity: 'OPPORTUNITÉ',
      rb_checker_title: 'Vérification URL',
      rb_check_btn: 'Vérifier',
      rb_allowed: 'Autorisé',
      rb_blocked: 'Bloqué',
      rb_sitemaps_title: 'Sitemaps déclarées',
      ll_history_title: 'Historique LLMs.txt',
      ll_generated: 'Généré',
      ll_restored_editor: "Version v{{v}} chargée dans l'éditeur — cliquez sur Publier pour l'appliquer",
      ll_load_err: 'Erreur de chargement de llms.txt',
      ll_generate_err: 'Erreur de génération',
      ll_saved_ok: 'LLMs.txt publié et vérifié dans le thème Shopify',
      ll_not_configured: 'Non configuré',
      ll_validation_title: 'Validation LLMs.txt',
      ll_not_found: "Aucun llms.txt trouvé sur le site. Utilisez «Générer depuis Shopify» pour le créer automatiquement.",
      ll_what_title: "Qu'est-ce que LLMs.txt ?",
      ll_what_desc: "Le standard /llms.txt est un fichier markdown qui aide les modèles AI (ChatGPT, Claude, Perplexity, Gemini) à comprendre votre site et à le citer correctement dans les réponses. Augmente la visibilité dans les moteurs de réponse AI.",
      ll_editor_title: 'Éditeur LLMs.txt',
      ll_generating: 'Génération…',
      ll_generate_btn: 'Générer depuis Shopify',
      tab_jsonld: 'JSON-LD',
      jl_load_err: "Erreur de chargement de l'aperçu JSON-LD",
      jl_sec_overview: "Vue d'ensemble",
      jl_sec_schemas: 'Schémas',
      jl_sec_problems: 'Problèmes',
      jl_sec_generate: 'Optimisation IA',
      jl_sec_preview: 'Aperçu JSON',
      jl_sec_validate: 'Validation',
      jl_sec_bulk: 'Opérations en masse',
      jl_sec_stats: 'Statistiques',
      jl_rich_results: 'Éligibilité Rich Results',
      jl_eligible: 'Éligibles',
      jl_warnings: 'Partiels',
      jl_not_eligible: 'Non éligibles',
      jl_field_coverage: 'Couverture des champs',
      jl_what_title: "Qu'est-ce que le JSON-LD?",
      jl_what_desc: "Le JSON-LD est le format recommandé par Google pour les données structurées. Il active les Rich Results dans la recherche (étoiles, prix, fils d'Ariane) et aide les modèles IA à mieux comprendre vos produits.",
      jl_score_poor: 'Couverture insuffisante',
      jl_schemas_title: 'Types de schémas pris en charge',
      jl_status_valid: 'Valide',
      jl_status_partial: 'Partiel',
      jl_status_missing: 'Non configuré',
      jl_valid_items: 'valides',
      jl_issues: 'problèmes',
      jl_google_test: 'Tester dans Google Rich Results',
      jl_google_test_desc: "Après avoir généré votre JSON-LD, testez-le directement dans l'outil Google pour vérifier l'éligibilité.",
      jl_problems_title: 'Problèmes de diagnostic',
      jl_no_problems: 'Aucun problème critique trouvé. Votre couverture JSON-LD est bonne!',
      jl_products_affected: 'produits affectés',
      jl_sev_critical: 'Critique',
      jl_sev_warning: 'Avertissement',
      jl_prob_brand: 'Marque / fournisseur manquant',
      jl_prob_desc: 'Description manquante',
      jl_prob_image: 'Image produit manquante',
      jl_prob_sku: 'SKU manquant',
      jl_prob_gtin: 'GTIN / code-barres manquant',
      jl_prob_meta: 'Méta-description manquante',
      jl_prob_offers: 'Prix absent du JSON-LD (nécessite un snippet dans le thème Shopify)',
      jl_problems_tip: "Corrigez les champs manquants dans la section Produits ou utilisez l'optimisation IA.",
      jl_gen_title: 'Générer le JSON-LD',
      jl_schema_type: 'Type de schéma',
      jl_product_id: 'ID produit (laisser vide pour exemple)',
      jl_use_ai: "Utiliser l'enrichissement IA (GPT)",
      jl_gen_btn: 'Générer le JSON-LD',
      jl_gen_ok: 'JSON-LD généré',
      jl_gen_err: 'Erreur de génération',
      jl_copied: 'Copié!',
      jl_copy: 'Copier',
      jl_preview_title: 'Aperçu JSON-LD',
      jl_preview_err: "Erreur de chargement de l'aperçu",
      jl_load_preview: 'Charger un produit exemple',
      jl_preview_empty: 'Cliquez sur "Charger un produit exemple" pour prévisualiser tous les schémas JSON-LD',
      jl_val_title: 'Validation de schéma locale',
      jl_invalid_json: 'JSON invalide',
      jl_val_btn: 'Valider le JSON-LD',
      jl_val_clear: 'Effacer',
      jl_val_ok: 'Valide — éligible aux Rich Results',
      jl_val_fail: 'Validation échouée',
      jl_val_note: 'Ce validateur vérifie les exigences schema.org. Pour le test Google officiel, utilisez le Rich Results Test.',
      jl_val_err: 'Erreur de validation',
      jl_bulk_title: 'Opérations en masse',
      jl_bulk_gen: 'Tout générer',
      jl_bulk_gen_desc: "Créer le JSON-LD Produit pour chaque produit et l'enregistrer en DB",
      jl_bulk_val: 'Tout valider',
      jl_bulk_val_desc: 'Exécuter la validation schema.org sur le JSON-LD existant',
      jl_bulk_fix: 'Corriger et enrichir',
      jl_bulk_fix_desc: 'Reconstruire le JSON-LD pour les produits avec des erreurs',
      jl_bulk_started: 'Opération en masse démarrée',
      jl_bulk_err: "Erreur lors du démarrage de l'opération en masse",
      jl_bulk_running: 'En cours',
      jl_bulk_done: 'Terminé',
      jl_bulk_stop: 'Arrêter',
      jl_bulk_stopped: 'Opération en masse arrêtée',
      jl_errors: 'erreurs',
      jl_stat_total: 'Produits totaux',
      jl_stat_eligible: 'Éligibles Rich Results',
      jl_stat_gen_today: "Générés aujourd'hui",
      jl_stat_fixed: "Corrigés aujourd'hui",
      jl_coverage_by_type: 'Couverture par type de contenu',
      jl_type: 'Type',
      jl_total: 'Total',
      jl_valid2: 'Valides',
      jl_missing2: 'Manquants',

      ll_revert: 'Annuler',
      ll_publishing: 'Publication…',
      ll_publish: 'Publier',
      lp_filter_url: 'Filtrer URL…',
      lp_copied: 'Copié',
      lp_broken_empty: 'Aucun lien cassé détecté',
      lp_broken_empty_sub: 'Toutes les URLs de la boutique sont accessibles (404 / 410 / timeout)',
      lp_timeout: 'Timeout — aucune réponse dans les 12s',
      lp_ratelimit_empty: 'Aucune limitation de débit détectée',
      lp_ratelimit_empty_sub: "Le serveur n'a pas limité les requêtes du scanner",
      lp_ratelimit_note: 'Page accessible mais le serveur a répondu 429 pendant le scan',
      lp_server_empty: 'Aucune erreur serveur détectée',
      lp_server_empty_sub: 'Toutes les URLs répondent correctement (pas de 5xx)',
      lp_server_note: 'HTTP {{code}} — erreur côté serveur',
      lp_redirect_empty: 'Aucune redirection détectée',
      lp_redirect_total: 'Redirections totales',
      lp_chains: 'Chaînes (>1 saut)',
      lp_loops: 'Boucles détectées',
      lp_chains_header: 'Chaînes de redirection',
      lp_chains_badge: '{{n}} chaînes multiples',
      lp_final_status: 'Statut final :',
      lp_canon_ok: 'Correct',
      lp_canon_miss: 'Manquant',
      lp_canon_wrong: 'URL incorrecte',
      lp_canon_cross: 'Cross-domain',
      lp_canon_redir: 'Canonical→redirection',
      lp_canon_action_missing: 'Ajouter une balise canonical dans la section head de la page.',
      lp_canon_action_wrong: "Corriger le canonical pour qu'il pointe vers l'URL définitive de cette page.",
      lp_canon_action_cross: "Le canonical pointe vers un domaine externe. Vérifier si c'est intentionnel ou une erreur.",
      lp_canon_action_redir: 'Le canonical pointe vers une URL qui redirige. Mettre à jour avec la destination finale.',
      lp_canon_no_data: 'Données canonical non disponibles — lancer le scan',
      lp_canon_issues: 'Problèmes Canonical ({{n}})',
      lp_canon_no_issues: 'Aucun problème canonical détecté',
      lp_canon_sample: 'Échantillon analysé : {{n}} URL de votre boutique (produits, collections, pages, articles)',
      il_tab_orphans: 'Pages orphelines',
      il_tab_weak: 'Liens faibles',
      il_tab_deep: 'Pages profondes',
      il_kpi_weak: 'Liens faibles ≤2',
      il_kpi_deep: 'Pages profondes',
      il_orphan_empty: 'Aucune page orpheline',
      il_orphan_empty_sub: 'Toutes les pages reçoivent au moins un lien interne',
      il_orphan_header: 'Pages sans liens entrants ({{n}})',
      il_weak_empty: 'Aucune page avec des liens faibles',
      il_weak_empty_sub: 'Toutes les pages reçoivent 3+ liens internes',
      il_weak_header: 'Pages avec 1–2 liens entrants ({{n}})',
      il_anchor_empty: 'Textes ancre optimisés',
      il_anchor_empty_sub: 'Aucun ancre générique, vide ou dupliqué détecté',
      il_anchor_generic: 'Ancres génériques',
      il_anchor_generic_desc: 'Textes comme "cliquer ici", "ici", "découvrir"',
      il_anchor_empty_type: 'Ancres vides',
      il_anchor_empty_desc: 'Liens sans texte descriptif',
      il_anchor_dup: 'Ancres dupliquées',
      il_anchor_dup_desc: 'Même texte → URLs différentes',
      il_anchor_lbl_gen: 'Générique',
      il_anchor_lbl_empty: 'Vide',
      il_anchor_lbl_dup: 'Dupliqué',
      il_deep_empty: 'Aucune page trop profonde',
      il_deep_empty_sub: 'Toutes les pages sont accessibles en ≤3 clics depuis la page principale',
      il_deep_header: 'Pages à >3 clics de la page principale ({{n}})',
      il_deep_note: 'Les pages avec ∞ ne sont pas accessibles via les liens internes. Les ajouter aux menus ou collections.',
      il_hub_empty: 'Aucune donnée hub disponible',
      il_hub_empty_sub: 'Lancer un scan pour identifier les pages hub',
      il_hub_header: 'Pages hub — les plus liées en interne',
      il_hub_count: '{{n}} liens internes entrants',
      lm_active: 'Actif',
      lm_not_installed: 'Non installé',
      lm_install_hint: 'Installer dans le thème pour surveiller la navigation réelle sans crawling',
      lm_refresh: 'Actualiser',
      lm_clear: 'Effacer les données',
      lm_remove: 'Supprimer du thème',
      lm_installing: 'Installation…',
      lm_install: 'Installer dans le thème',
      lm_tab_404: 'Erreurs 404',
      lm_tab_redirect: 'Opp. Redirection',
      lm_tab_top: 'Pages populaires',
      lm_kpi_visits: 'Visites totales',
      lm_kpi_404s: 'Vraies erreurs 404',
      lm_no_404: 'Aucune erreur 404 détectée par les utilisateurs',
      lm_visits: 'visites',
      lm_theme_prefix: 'Thème : ',
      lm_last_activity: 'Dernière activité : ',
      lm_no_activity: 'aucune visite encore',
      lm_installed: 'Monitor installé dans le thème "{{name}}"',
      lm_err_install: "Erreur d'installation",
      lm_confirm_remove: 'Supprimer le script de surveillance du thème actif ?',
      lm_removed: 'Script supprimé du thème',
      lm_err_remove: 'Erreur de suppression',
      lm_confirm_clear: 'Effacer toutes les données de surveillance collectées ?',
      lm_cleared: 'Données effacées',
      lm_err_clear: 'Erreur de suppression des données',
      lm_modal_title: 'Créer une Redirection 301',
      lm_modal_source: 'URL source (404)',
      lm_modal_dest: 'Destination',
      lm_redirect_created: 'Redirection 301 créée sur Shopify',
      lm_err_redirect: 'Erreur de création de la redirection',
      lm_create_redirect: 'Créer la redirection',
      lm_creating: 'Création…',
      lm_cancel: 'Annuler',
      lm_info_title: 'Comment fonctionne le Live Monitor',
      lm_info_1: "Le bouton «Installer dans le thème» ajoute automatiquement un script léger au thème actif via l'API Shopify Themes",
      lm_info_2: 'Pour chaque visite réelle, il collecte : URL, type de page, liens internes, erreurs 404, référent interne',
      lm_info_3: 'Zéro crawling — aucun HTTP 429 — données de vrais visiteurs en temps réel',
      lm_info_4: 'Construit progressivement la carte des liens internes et détecte les pages orphelines',
      lm_no_redirect: 'Aucune redirection nécessaire',
      lm_no_redirect_hint1: "Le Live Monitor n'a pas encore enregistré de visites. Les opportunités de redirection apparaissent lorsque les utilisateurs réels rencontrent des pages 404.",
      lm_no_redirect_hint2: "En {{n}} visites analysées, aucun utilisateur n'a rencontré des pages 404. Excellent !",
      lm_toolbar_ai: '{{count}} URL · {{ai}} avec suggestion IA',
      lm_toolbar_ignored: '· {{n}} ignorés',
      lm_sort_visits: 'Visites',
      lm_sort_date: 'Date',
      lm_selected: '{{n}} sélectionné(s)',
      lm_no_match: 'aucune correspondance automatique',
      lm_create: 'Créer',
      lm_ignore: 'Ignorer',
      lm_err: 'Erreur',
      lm_bulk_ignored: '{{n}} URL ignoré(s)',
      lm_bulk_created: '{{n}} redirections créées',
      lm_errors: 'erreurs',
      ls_scan_started: 'Analyse démarrée — sera terminée en arrière-plan',
      ls_scan_err: "Erreur au démarrage de l'analyse",
      ls_last_scan: 'Dernière analyse : {{date}} · {{n}} URL',
      ls_no_scan_desc: 'Aucune analyse effectuée — détecte les liens cassés, redirections, canoniques, pages orphelines',
      ls_scanning: 'Analyse en cours…',
      ls_rescan: 'Réanalyser',
      ls_start_scan: "Démarrer l'analyse",
      ls_canonical_issues: 'Problèmes canoniques',
      ls_scan_details: "Détail de l'analyse",
      ls_stat_total: 'URL totales',
      ls_stat_errors: 'Erreurs',
      ls_no_scan: 'Aucune analyse effectuée',
      ls_no_scan_long: "Démarrez l'analyse pour détecter les liens cassés, chaînes de redirection, problèmes canoniques et pages orphelines",
      ls_first_scan: 'Démarrer la première analyse',
      db_gsc_connected: 'Google Search Console connectée !',
      db_gsc_err: 'Erreur de connexion GSC : {{code}}',
      db_props_err: 'Impossible de charger les propriétés GSC',
      db_oauth_hint: "Complétez l'autorisation Google dans le nouvel onglet. La page se rechargera automatiquement.",
      db_conn_err: 'Erreur de connexion GSC',
      db_prop_selected: 'Propriété sélectionnée : {{url}}',
      db_prop_err: 'Erreur de sélection de propriété',
      db_confirm_disconnect: 'Déconnecter Google Search Console ?',
      db_disconnected: 'GSC déconnectée',
      db_disconnect_err: 'Erreur de déconnexion',
      db_connected: 'Search Console connectée',
      db_no_property: 'Aucune propriété sélectionnée',
      db_not_connected: 'Non connectée',
      db_connect_hint: 'Connectez GSC pour accéder aux analyses et à la surveillance',
      db_change_prop: 'Changer de propriété',
      db_disconnect: 'Déconnecter',
      db_connect: 'Connecter GSC',
      db_idx_subtitle: 'Qualité technique SEO & indexation',
      db_lbl_gsc: 'GSC connectée',
      db_lbl_sitemap: 'Sitemaps soumis',
      db_lbl_indexed: 'URLs indexées',
      db_health_real: 'Basé sur les données réelles de Search Console',
      db_health_proxy: 'Basé sur la qualité du catalogue — connectez GSC pour les données réelles',
      db_lbl_position: 'Position',
      db_lbl_trend: 'Tendance 28j',
      db_lbl_errors: 'Erreurs',
      db_connect_score: 'Connectez GSC pour calculer le score',
      db_proxy_note: 'Proxy catalogue',
      db_stat_excluded: 'URLs exclues',
      db_stat_seo_score: 'Score SEO moyen',
      db_catalog_title: 'Santé du catalogue',
      db_cat_alt: 'Texte ALT des images',
      db_cat_keywords: 'Mots-clés manquants',
      db_cat_no_kw: '{{n}} produits sans mots-clés',
      db_cat_count: '{{n}} / {{total}} produits',
      tab_opportunities: 'Opportunités SEO',
      tab_indexing: 'Indexation',
      locked_available: 'Disponible à partir du plan {{plan}}',
      locked_upgrade: 'Passer au plan {{plan}}',
      main_subtitle: 'SEO technique · Indexation · Analytics · Automatisation IA',
      phase_3: 'Phase 3',
      interval_all: 'Tout',
      click_monthly_est: 'clics/mois est.',
      fix_title_updated: 'Balise titre mise a jour',
      fix_meta_updated: 'Meta-description mise a jour',
      fix_both_updated: 'Titre et meta-description mis a jour sur Shopify',
      fix_apply_err: "Erreur d'application",
      rb_save_ok: 'Robots.txt sauvegarde et verifie dans le theme Shopify',
      rb_draft_with_err: 'Brouillon sauvegarde ({{err}})',
      rb_draft_manual: "Brouillon sauvegarde — suivre les instructions pour l'appliquer au theme",
      rb_critical_confirm: '🚨 AVERTISSEMENT CRITIQUE 🚨\n\nVotre robots.txt contient "Disallow: /" qui BLOQUE COMPLETEMENT le site :\nGoogle, Bing et tous les bots ne pourront plus explorer aucune page.\n\nCela peut entrainer la suppression du site des resultats de recherche.\n\nEtes-vous ABSOLUMENT SUR de vouloir continuer ?',
      scan_err: 'Erreur de scan : {{msg}}',
      sm_send_err: "Erreur d'envoi",
      unknown_err: 'Inconnu',
      dq_today: "Aujourd'hui",
      dq_7d: '7 derniers jours',
      dq_30d: '30 derniers jours',
      dq_daily_avg: 'Moy. journalière',
      dq_at_pace: 'au rythme de ~{{n}}/jour',
      job_stopped: '{{n}} URL traitées — arrêté',
      job_inspected: '{{n}} inspectées',
      job_errors: 'erreurs',
      quota_remaining: 'Quota restant :',
      lk_trend: "Tendance d'indexation",
      lk_batch: 'Inspection par lot (scan massif)',
      lk_ai: "Suggestions IA d'indexation",
      footer_apis: 'Sitemaps API + Search Analytics + Inspection API',
      prod_status_lbl: 'Statut :',
      prod_desc_lbl: 'Description :',
      prod_missing: 'ABSENT',
      state_disc: 'Déc.',
      state_crawl: 'Crawlé',
      insp_api_real: 'Inspection API ✓ réelle',
      sm_count: '{{n}} sitemaps',
      sm_reliability: 'Fiabilité :',
      conf_high: 'Élevée',
      conf_medium: 'Moyenne',
      conf_low: 'Faible',
      sm_urls: 'URLs dans le sitemap',
      sm_sample: 'Échantillon',
      sm_est_indexed: 'Indexées estim.',
      sm_est_nonidx: 'Non indexées estim.',
      sm_coverage: 'Couverture estim. ⓘ',
      sm_idx_of: '~{{n}} indexées sur {{t}} URLs du sitemap',
      sm_cov_est: 'Couverture estimée :',
      sm_margin_err: "marge d'erreur",
      sm_indexed_of: 'indexées sur',
      sm_sampled: 'échantillonnées',
      sm_th_sitemap: 'Sitemap',
      sm_th_submitted: 'Soumises',
      sm_th_indexed: 'Indexées',
      sm_th_gap: 'Écart',
      sm_th_coverage: 'Couverture',
      sm_th_warning: 'Avertissement',
      sm_th_errors: 'Erreurs',
      sm_th_lastmod: 'Dernière mise à jour',
      sm_th_actions: 'Actions',
      rb_verified_result: 'Enregistré et vérifié dans le thème Shopify ({{theme}}) — fichier :',
      rb_draft_result: 'Brouillon enregistré. Pour appliquer manuellement : Shopify Admin → Thèmes → Modifier le code →',
      ll_draft_result: 'Brouillon enregistré. Pour appliquer manuellement : Shopify Admin → Thèmes → Modifier le code →',
      ls_section_redirects: 'Gestionnaire de redirections',
      rm_tab: 'Gestionnaire de redirections',
      rm_subtitle: 'Gérez toutes les redirections de votre boutique en un seul endroit.',
      rm_kpi_total: 'Règles totales',
      rm_kpi_active: 'Redirections actives',
      rm_kpi_pending: '404 en attente',
      rm_kpi_hits: 'Hits (30j)',
      rm_kpi_chains: 'Chaînes',
      rm_kpi_loops: 'Boucles',
      rm_section_rules: 'Règles',
      rm_section_suggest: 'Suggestions IA',
      rm_section_health: 'Santé',
      rm_section_import: 'Import / Export',
      rm_section_history: 'Historique',
      rm_create_title: 'Créer une redirection',
      rm_edit_title: 'Modifier la redirection',
      rm_old_url: 'Ancienne URL',
      rm_new_url: 'Nouvelle URL',
      rm_old_url_ph: '/ancien-chemin',
      rm_new_url_ph: '/nouveau-chemin',
      rm_type: 'Type',
      rm_type_301: '301 – Permanente',
      rm_type_302: '302 – Temporaire',
      rm_notes: 'Notes',
      rm_save: 'Enregistrer',
      rm_cancel: 'Annuler',
      rm_create_ok: 'Redirection créée avec succès.',
      rm_edit_ok: 'Redirection mise à jour avec succès.',
      rm_create_err: 'Erreur lors de la création de la redirection.',
      rm_edit_err: "Erreur lors de l'enregistrement de la redirection.",
      rm_dup_err: 'Une redirection pour cette URL source existe déjà.',
      rm_empty_err: "Les URL source et destination sont obligatoires.",
      rm_same_err: "Les URL source et destination ne peuvent pas être identiques.",
      rm_search_ph: 'Rechercher des URL…',
      rm_filter_all: 'Tous',
      rm_filter_active: 'Actives',
      rm_filter_disabled: 'Désactivées',
      rm_create_btn: 'Créer une redirection',
      rm_selected_items: '{{count}} sélectionnés',
      rm_bulk_enable: 'Activer',
      rm_bulk_disable: 'Désactiver',
      rm_bulk_delete: 'Supprimer',
      rm_bulk_export: 'Exporter CSV',
      rm_bulk_ok: 'Opération terminée.',
      rm_table_old: 'Ancienne URL',
      rm_table_new: 'Nouvelle URL',
      rm_table_type: 'Type',
      rm_table_hits: 'Hits',
      rm_table_status: 'Statut',
      rm_table_actions: 'Actions',
      rm_edit: 'Modifier',
      rm_duplicate: 'Dupliquer',
      rm_delete: 'Supprimer',
      rm_delete_confirm: 'Supprimer cette redirection ?',
      rm_deleted_ok: 'Redirection supprimée.',
      rm_delete_err: 'Erreur lors de la suppression.',
      rm_status_active: 'Active',
      rm_status_disabled: 'Désactivée',
      rm_no_data: 'Aucune redirection trouvée.',
      rm_empty_state: 'Aucune redirection encore. Créez la première.',
      rm_total_redirects: '{{count}} redirections au total',
      rm_import_title: 'Importer des redirections',
      rm_import_csv: 'CSV (old_url,new_url,type)',
      rm_import_shopify: 'Shopify Export CSV',
      rm_import_sf: 'Screaming Frog CSV',
      rm_import_btn: 'Importer',
      rm_import_ok: 'Import terminé.',
      rm_import_err: "Erreur lors de l'import.",
      rm_import_imported: '{{count}} importés',
      rm_import_skipped: '{{count}} ignorés',
      rm_export_title: 'Exporter les redirections',
      rm_export_desc: 'Téléchargez toutes les redirections dans les formats disponibles.',
      rm_export_csv: 'Exporter CSV',
      rm_export_json: 'Exporter JSON',
      rm_ai_title: 'Suggestions IA',
      rm_ai_subtitle: "L'IA a détecté des URL 404 et suggère des redirections vers des produits similaires.",
      rm_ai_accept: 'Accepter',
      rm_ai_reject: 'Refuser',
      rm_ai_accept_all: 'Tout accepter',
      rm_ai_loading: 'Analyse en cours…',
      rm_ai_empty: 'Aucune suggestion disponible pour le moment.',
      rm_chains_title: 'Chaînes de redirections',
      rm_chains_desc: 'Des redirections enchaînées ralentissent votre site. Corrigez-les maintenant.',
      rm_chains_fix: 'Corriger la chaîne',
      rm_chains_empty: 'Aucune chaîne détectée.',
      rm_chains_fixed: 'Chaîne corrigée.',
      rm_loops_title: 'Boucles de redirections',
      rm_loops_desc: 'Des boucles circulaires provoquent des erreurs. Correction manuelle requise.',
      rm_loops_fix: 'Corriger',
      rm_loops_empty: 'Aucune boucle détectée.',
      rm_gsc_title: '404 depuis Google Search Console',
      rm_gsc_subtitle: 'URL introuvables détectées par GSC ces 90 derniers jours.',
      rm_gsc_empty: 'Aucun 404 GSC détecté.',
      rm_history_title: "Historique d'activité",
      rm_history_created: 'Créé',
      rm_history_edited: 'Modifié',
      rm_history_deleted: 'Supprimé',
      rm_history_disabled: 'Désactivé',
      rm_history_enabled: 'Activé',
      rm_history_imported: 'Importé',
      rm_history_bulk: 'Opération groupée',
      rm_history_empty: 'Aucune activité enregistrée.',
      rm_sync_shopify: 'Synchroniser depuis Shopify',
      rm_sync_shopify_desc: 'Importer toutes les redirections URL de Shopify. Les nouvelles redirections sont automatiquement envoyées à Shopify.',
      rm_sync_btn: 'Synchroniser maintenant',
      error_label: 'Erreur :',
      rb_checker_desc: "Vérifiez si une URL est autorisée ou bloquée par {{bot}} d'après le robots.txt actuel.",
      rb_rule: 'Règle :',
      rb_fix: 'Corriger :',
      rb_gsc_note_title: 'Intégration Search Console',
      rb_gsc_note_body: 'Dans la section Indexation, les URLs avec le statut "Bloquée par robots" indiquent des pages que Google ne peut pas explorer.',
      rb_issues: 'problèmes',
      rb_opps: 'opportunités',
      rb_savings: 'Économies estimées :',
      never: 'Jamais',
      samples_conf: '{{n}} échantillons · confiance {{c}}',
      batch_priority_note: 'URLs avec impressions Analytics inspectées en premier · quota GSC 2 000/jour · traitement en arrière-plan',
      sm_samples: 'échantillons',
      sm_footnote_ec: '~ Valeurs "En calcul" = estimation de Inspection API ({{n}} échantillons · confiance {{c}}). Sitemaps API renvoie 0 pour les index de sitemap.',
      sm_footnote_noec: '~ Valeurs "En calcul" = estimation proportionnelle. Démarrez le scan par lot. Sitemaps API renvoie 0 pour les index de sitemap.',
      ic_quota_note: 'Calculé sur {{n}} URLs inspectées via Inspection API (quota 2 000/jour). GSC Coverage affiche {{m}} URLs non indexées dans le sitemap.',
      cov_crawled_ni: 'Contenu de faible qualité ou dupliqué. Améliorer le contenu, ajouter du texte unique, vérifier la balise canonical.',
      cov_disc_ni: "Google l'a trouvée mais ne l'a pas encore crawlée. Augmenter le budget de crawl avec des liens internes supplémentaires et un sitemap mis à jour.",
      cov_dup_nocanon: 'Ajouter une balise canonical pointant vers la page principale.',
      cov_dup_googcanon: 'Google ignore le canonical déclaré. Vérifier la cohérence des URL et canonical entre les versions desktop/mobile.',
      cov_redirect: 'Redirection active. Si intentionnelle, mettre à jour les liens internes pour pointer directement vers la destination.',
      cov_alternate: 'Page alternative avec canonical correct — aucune action requise si intentionnelle.',
      cov_noindex: 'Supprimer la balise meta noindex si vous souhaitez que la page soit indexée.',
      cov_robots: 'Page bloquée par robots.txt. Vérifier les directives Disallow et mettre à jour si nécessaire.',
      cov_removed: 'Supprimée manuellement de GSC. Révoquer la suppression dans le panneau Search Console si souhaité.',
      cov_404: 'Page introuvable. Restaurer la page, configurer une redirection 301 ou supprimer les liens internes vers cette URL.',
      cov_soft404: 'Le serveur renvoie 200 mais Google la traite comme une page vide. Vérifier que la page a du contenu pertinent.',
      cov_server_err: "Erreur de serveur. Vérifier les journaux du serveur et la disponibilité de l'hébergement lors du crawl.",
      cov_unknown_url: "Google n'a pas encore découvert cette URL. Ajouter des liens internes, mettre à jour le sitemap et attendre le prochain crawl.",
      qt_brand: 'Marque',
      qt_info: 'Info',
      qt_category: 'Catégorie',
      qt_product: 'Produit',
      qt_generic: 'Générique',
      sugg_title_improvement: 'Balise titre',
      sugg_meta: 'Méta-description',
      sugg_content_gap: 'Contenu manquant',
      sugg_schema: 'Balisage schema',
      sugg_links: 'Liens internes',
      verdict_indexed: 'Indexé',
      verdict_not_indexed: 'Non indexé',
      verdict_excluded: 'Exclu',
      badge_col_header: 'Badge',
      sitemap_label: 'Plan du site',
      ls_tab_broken: 'Liens brisés',
      ls_tab_redirect: 'Redirection',
      ls_tab_rate_limited: 'Limite de débit',
      ls_tab_server_errors: 'Erreurs serveur',
      ls_tab_canonical: 'Canonique',
      ls_tab_internal: 'Liens internes',
      ls_section_monitor: 'Moniteur en direct',
      ls_section_audit: 'Structure du site',
      db_idx_title: 'Score d\'indexation',
      db_health_title: 'Score de santé SC',
      canonical_mismatch: 'Discordance canonique',
    },
    so: {
      load_err: 'Erreur de chargement de Speed Optimizer',
      analyze_timeout: "Délai d'analyse dépassé (90s) — veuillez réessayer",
      analyze_done: 'Analyse terminée!',
      analyze_failed: 'Analyse échouée: {{error}}',
      rate_limited: 'Limite de requêtes atteinte — données mises à jour depuis le cache',
      analyze_err: "Erreur d'analyse",
      opt_enabled: '{{label}} activé sur le thème',
      opt_disabled: '{{label}} désactivé',
      opt_err: "Erreur d'optimisation",
      scan_err: 'Erreur de scan du thème',
      img_err: "Erreur d'analyse des images",
      sg_protected: 'Safety Guard: Protected activé',
      sg_standard: 'Safety Guard: Standard activé',
      mode_err: 'Erreur de changement de mode',
      plan_err: 'Erreur de génération du plan',
      strategy_applied: 'Stratégie {{label}} appliquée au thème',
      strategy_err: "Erreur lors de l'application de la stratégie",
      sessions_err: 'Erreur de chargement des sessions',
      rollback_done: 'Rollback terminé — thème restauré',
      rollback_err: 'Erreur de rollback',
      subtitle: "Optimisations sécurisées du thème Shopify avec rollback instantané.",
      btn_rollback: 'Tout annuler',
      btn_analyze: 'Analyser maintenant',
      analyzing_psi: 'Traitement PSI…',
      analyzing_queue: 'En file…',
      analyzing: 'Analyse en cours…',
      alert_no_token: "Token Shopify manquant — les optimisations nécessitent une connexion active au store.",
      alert_no_scope: "Permissions de thème manquantes — pour appliquer les optimisations, réinstallez l'application.",
      perf_empty: 'Aucune analyse disponible',
      perf_empty_hint: 'Cliquez sur "Analyser maintenant" pour mesurer les performances de votre store',
      suggestions: 'Suggestions',
      strategy_active: 'active',
      strategy_subtitle: "Définit l'objectif d'optimisation. Cliquez pour voir le plan avant d'appliquer.",
      sg_header: 'Limite les opérations que la stratégie peut exécuter.',
      sg_desc_protected: 'Bloque les opérations Standard — optimisations sûres uniquement.',
      sg_desc_standard: "Permet l'exécution complète de la stratégie sélectionnée.",
      quick_opts: 'Optimisations rapides',
      sg_warning: 'Safety Guard: Protected — les opérations Standard sont bloquées. Passez à Standard ci-dessus.',
      lcp_section: 'Scan LCP du thème',
      hist_section: "Historique des optimisations",
      hist_empty: "Aucune optimisation encore appliquée.",
      sessions_section: 'Sessions & Impact Lighthouse',
      sessions_empty: "Chargez les sessions pour voir l'impact réel sur les Core Web Vitals.",
      img_count: '{{n}} images · {{kb}} Ko au total',
      img_oversized: '{{n}} images >300Ko',
      img_no_oversized: "Aucune image surdimensionnée — excellent!",
      img_empty: 'Cliquez sur "Analyser les images" pour trouver des images >300Ko dans le thème.',
      btn_refresh: 'Recharger',
      btn_load_sessions: 'Charger les sessions',
      btn_refresh_sessions: 'Actualiser',
      btn_analyze_img: 'Analyser les images',
      btn_refresh_img: 'Actualiser',
      modal_risk_safe: "Sûr — aucun impact visuel attendu",
      modal_risk_medium: "Vérifiez l'apparence du site après l'activation",
      modal_risk_high: 'Peut affecter les fonctionnalités avancées',
      modal_reversible: 'Réversible à tout moment — utilisez "Tout annuler" pour restaurer le thème original.',
      modal_cancel: 'Annuler',
      modal_enable: 'Activer maintenant',
      opt_no_token: 'Reconnectez le store Shopify pour utiliser cette fonctionnalité',
      opt_blocked_guard: 'Bloqué par Safety Guard (Protected) — passez à Standard pour activer',
      opt_reversible: 'réversible',
      opt_blocked_label: 'Bloqué par Safety Guard — passez à Standard',
      scan_scanning: 'Scan en cours...',
      scan_empty_title: 'Scan du thème non effectué',
      scan_empty_desc: "Identifie les sections hero et slideshow du thème pour activer les optimisations LCP côté serveur.",
      scan_btn: 'Scanner le thème',
      scan_active_theme: 'Thème actif',
      scan_files: '{{n}} fichiers Liquid scannés · {{s}} sections LCP identifiées',
      scan_hero_label: 'section hero/LCP',
      scan_optimized: 'optimisé',
      scan_no_lcp: 'Aucune section hero/LCP identifiée automatiquement dans le thème.',
      scan_reload: 'Recharger',
      plan_title: 'Plan: {{label}}',
      plan_ops: '{{n}} opérations prévues',
      plan_action_enabled: 'déjà active',
      plan_action_enable: 'activer',
      plan_action_disable: 'désactiver',
      plan_strategy: 'Stratégie: ',
      plan_guard: 'Safety Guard: ',
      plan_active_ops: 'Opérations actives: ',
      plan_blocked: '{{n}} bloquées par Safety Guard',
      plan_low_conf: "Certaines optimisations ont une faible confiance pour le thème détecté.",
      plan_cancel: 'Annuler',
      plan_apply: 'Appliquer la stratégie',
      plan_blocked_btn: 'Bloqué (score faible)',
      hist_rollback: 'Rollback complet — toutes les optimisations supprimées',
      hist_enabled: 'activée',
      hist_disabled: 'désactivée',
      hist_active: 'actives',
      sess_no_sessions: "Aucune session d'optimisation enregistrée. Les sessions sont créées quand vous appliquez une stratégie.",
      sess_waiting: 'en attente PSI',
      strategy_label: 'Stratégie {{s}}',
      strategy_opts: '{{n}} optimisations',
      strategy_active: 'ACTIVE',
      quota_err: 'Erreur de chargement du quota PSI',
      quota_api_key: 'Clé API configurée:',
      quota_yes: '✓ OUI',
      quota_no: '✗ NON (quota public)',
      quota_cache_ttl: 'Cache TTL:',
      quota_hourly: 'Limite horaire:',
      quota_daily: 'Limite quotidienne:',
      quota_success: "Succès aujourd'hui:",
      quota_hit_ratio: 'Taux de succès cache:',
      quota_circuit: 'Disjoncteur:',
      quota_circuit_open: 'OUVERT ({{n}} pannes)',
      quota_circuit_closed: 'fermé',
      quota_loading: 'Chargement...',
      diag_err: 'Erreur de diagnostic',
      diag_refresh: 'Actualiser',
      diag_load: 'Charger les diagnostics',
      diag_patches: 'Patches actifs ({{n}})',
      diag_none: 'aucun',
      diag_unavailable: 'indisponible',
      diag_no_patches: 'Aucun patch actif',
      diag_calibrated: '📈 calibré',
      diag_generated: 'Généré:',
      badge_server_side: 'CÔTÉ SERVEUR',
      badge_standard: 'STANDARD',
      badge_lcp: 'LCP',
      badge_critical: 'CRITIQUE',
      badge_safe: 'SÛR',
      badge_medium: 'MOYEN',
      badge_safety_guard: 'Garde de sécurité',
      diag_theme_fingerprint: 'Empreinte du thème',
      diag_engine_confidence: 'Confiance du moteur',
      perf_score_label: 'Score de performance',
      section_perf_overview: 'Aperçu des performances',
      section_strategy_intent: 'Intention de stratégie',
      safety_guard_title: 'Garde de sécurité',
      section_script_analyzer: 'Analyseur d\'impact des scripts',
      script_col_file: 'Fichier',
      script_col_size: 'Taille',
      script_col_impact: 'Impact',
      script_col_defer_risk: 'Risque de report',
      metric_js_total: 'JS total',
      metric_css_total: 'CSS total',
      perf_updated: 'Mis à jour :',
      perf_stale: 'données obsolètes (PSI indisponible)',
      perf_from_cache: 'depuis le cache',
      perf_psi_ok: 'PSI OK',
      debug_invalid_token_title: 'Jeton invalide (401) — le jeton dans MongoDB a expiré ou a été révoqué.',
      debug_reconnect_desc: 'Le callback OAuth n\'a PAS écrasé le token après la dernière réinstallation. Cliquez sur le bouton ci-dessous pour démarrer un nouveau OAuth.',
      debug_reconnect_btn: 'Reconnecter OAuth maintenant (ouvre Shopify)',
      debug_reconnect_note: 'Après avoir approuvé les autorisations sur Shopify, le callback mettra automatiquement à jour le token dans MongoDB.',
    },
    drafts: {
      approved: 'Brouillon approuvé !',
      approve_err: "Erreur d'approbation",
      published: 'Publié sur Shopify !',
      publish_err: 'Erreur de publication',
      title: 'Brouillons & Résultats',
      subtitle: 'Révisez, approuvez et publiez le contenu optimisé',
      empty: 'Aucun brouillon à réviser',
      empty_hint: 'Générez du contenu IA pour créer de nouveaux brouillons',
      badge_approved: 'Approuvé',
      badge_draft: 'Brouillon',
      field_desc: 'Description',
      btn_view: 'Voir',
      btn_approve: 'Approuver',
      btn_publish: 'Publier',
      modal_title: 'Détail du brouillon',
      chars_seo: '/60 caractères',
      chars_meta: '/160 caractères',
      not_present: 'Non présent',
      not_present_pl: 'Non présents',
      btn_close: 'Fermer',
      btn_publish_shopify: 'Publier sur Shopify',
      seo_title: 'Titre SEO',
      meta_description: 'Méta-description',
      keywords_label: 'Mots-clés',
    },
    usage: {
      title: 'Utilisation & Plan',
      subtitle: "Surveillez l'utilisation et gérez votre abonnement",
      plan_badge: 'Plan:',
      current: 'Utilisation actuelle',
      credits: 'Crédits IA',
      used: 'Utilisés:',
      unlimited: 'Illimité ∞',
      remaining: 'Restants: {{n}}',
      products_sync: 'Produits synchronisés',
      plans_heading: 'Plans disponibles',
      most_popular: '⭐ Plus populaire',
      active_plan: 'Plan actif',
      current_plan: 'Plan actuel',
      btn_upgrade: 'Passer au {{name}}',
      trend_heading: "Tendance d'utilisation",
      trend_coming: "Graphique d'utilisation (bientôt)",
      stat_products: 'Produits analysés',
      stat_content: 'Contenu généré',
      stat_translations: 'Traductions',
      stat_images: 'Images optimisées',
    },
    support: {
      msg_sent: 'Message envoyé !',
      msg_err: "Erreur lors de l'envoi du message",
      status_open: 'Ouvert',
      status_progress: 'En cours',
      status_closed: 'Fermé',
      title: 'Support',
      subtitle: 'FAQ, guides et chat avec notre équipe',
      faq_heading: 'Questions fréquentes',
      guide_heading: 'Guide rapide',
      chat_heading: 'Chat de support',
      no_msgs: 'Aucun message',
      no_msgs_hint: 'Commencez une conversation avec le support',
      placeholder: 'Écrire un message...',
      contacts_heading: 'Contacts',
      contact_hours_label: 'Horaires',
      contact_hours: 'Lun-Ven 9:00-18:00 CET',
      contact_response_label: 'Temps de réponse',
      contact_response: 'Sous 24 heures',
      guide_step1: 'Allez dans la section',
      guide_products: 'Produits',
      guide_step1b: 'pour voir vos produits',
      guide_step2: 'Sélectionnez un produit et allez sur',
      guide_ai_content: 'Contenu IA',
      guide_step3: 'Générez description, titre SEO, méta-description et mots-clés',
      guide_step4: 'Consultez les résultats dans',
      guide_history: 'Historique',
    },
    transl: {
      load_err: 'Erreur de chargement des éléments',
      published: 'Traduction publiée sur Shopify !',
      pub_err: 'Erreur de publication',
      err_no_items: 'Sélectionnez au moins un élément',
      err_no_fields: 'Sélectionnez au moins un champ à traduire',
      item_err: 'Erreur de traduction',
      done_one: 'Traduction terminée !',
      done_many: '{{n}} éléments traduits !',
      copied: 'Copié dans le presse-papiers',
      title: 'Traductions',
      gate_plan: 'Disponible à partir du plan Starter',
      gate_desc: 'Traduire des produits, collections et articles en 8 langues avec AI',
      gate_btn: 'Passer au plan Starter',
      subtitle: 'Traduire des produits, collections, articles et pages en plusieurs langues avec AI',
      translating: 'Traduction en cours…',
      search_placeholder: 'Rechercher par titre…',
      select_page: 'Sélectionner la page',
      sel_abbrev: 'sél.',
      total_items: 'total',
      loading: 'Chargement…',
      no_results: 'Aucun résultat pour cette recherche',
      prev: '← Préc',
      tot_abbrev: 'tot.',
      next: 'Suiv →',
      deselect_all: 'Tout désélectionner',
      lang_heading: 'Langue cible',
      fields_heading: 'Champs à traduire',
      select_hint: 'Sélectionnez des éléments dans la liste pour activer la traduction',
      results_heading: 'Résultats',
      clear_results: 'Effacer les résultats',
      badge_published: 'Publié',
      publishing: 'Publication…',
      done: 'Fait',
      publish: 'Publier',
      copy: 'Copier',
      tab_products: 'Produits',
      tab_collections: 'Collections',
      tab_articles: 'Articles',
      tab_pages: 'Pages',
      field_title: 'Titre',
      field_description: 'Description',
      field_seo_title: 'SEO Title',
      field_meta_description: 'Meta Description',
      field_body_html: 'Description / Corps',
      empty_hint_select: 'Sélectionnez un ou plusieurs éléments, choisissez la langue et cliquez sur',
      translate_label: 'Traduire',
      items_selected: 'éléments',
      item_selected: 'élément',
      selected_label: 'sélectionné(s)',
      choose_fields_hint: 'choisissez les champs et cliquez sur Traduire',
    },
  },

  es: {
    nav: {
      overview: 'Resumen',
      catalog: 'Catálogo',
      content: 'Contenido IA',
      translations: 'Traducciones',
      images: 'Imágenes',
      batch: 'Operaciones en lote',
      speed: 'Optimizador de velocidad',
      history: 'Historial',
      usage: 'Uso y Plan',
      settings: 'Configuración',
      support: 'Soporte',
    },
    common: {
      save: 'Guardar',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      close: 'Cerrar',
      confirm: 'Confirmar',
      loading: 'Cargando...',
      error: 'Error',
      success: 'Éxito',
      search: 'Buscar',
      filter: 'Filtrar',
      all: 'Todos',
      yes: 'Sí',
      no: 'No',
      back: 'Atrás',
      next: 'Siguiente',
      apply: 'Aplicar',
      generate: 'Generar',
      publish: 'Publicar',
      optimize: 'Optimizar',
      refresh: 'Actualizar',
    },
    settings: {
      title: 'Configuración',
      subtitle: 'Centro de control de IA',
      tabs: {
        general: 'General',
        localization: 'Localización',
        ai_engine: 'Motor de IA',
        appearance: 'Apariencia',
        piano: 'Plan',
        advanced: 'Avanzado',
      },
      save_btn: 'Guardar configuración',
      unsaved: 'Cambios no guardados',
      action_loading: 'En curso...',
      general: {
        contents: 'Contenidos',
        default_lang: 'Idioma de contenido predeterminado',
        tone: 'Tono de contenido global',
        tone_hint: 'Aplicado a productos, colecciones, artículos y lotes',
        seo_rules: 'Reglas SEO',
        seo_title_max: 'Longitud máxima del título SEO',
        seo_title_hint: 'Recomendado: 50–60 caracteres',
        meta_max: 'Longitud máxima de la meta descripción',
        meta_hint: 'Recomendado: 150–160 caracteres',
        chars: 'caracteres',
        images: 'Preferencias de imagen',
        img_format: 'Formato predeterminado',
        img_square: 'Cuadrado (1:1)',
        img_landscape: 'Horizontal (4:3)',
        img_portrait: 'Vertical (3:4)',
        img_quality: 'Calidad de compresión',
        img_quality_low: '50% (comprimida)',
        img_quality_high: '100% (máxima)',
        store_info: 'Información de la tienda',
        store_domain: 'Dominio',
        store_plan: 'Plan',
        store_installed: 'Instalado',
      },
      ai: {
        strategy: 'Estrategia IA',
        params_title: 'Parámetros de generación',
        creativity: 'Creatividad',
        creative_low: 'Conservador',
        creative_high: 'Creativo',
        seo_strictness: 'Rigurosidad SEO',
        seo_low: 'Flexible',
        seo_high: 'Riguroso',
        tone_label: 'Tono global',
        auto_title: 'Auto-optimización IA',
        auto_hint: 'Activar para optimizar automáticamente los contenidos',
        on: 'Activo',
        off: 'Off',
        threshold: 'Umbral de optimización',
        threshold_low: 'Optimizar todo',
        threshold_high: 'Solo los peores',
        threshold_hint: 'Actúa en elementos con puntuación SEO < {{n}}',
        frequency: 'Frecuencia',
        scope: 'Alcance',
        triggers: 'Disparadores',
        img_format: 'Formato de imagen',
        img_square: 'Cuadrado 1:1',
        img_square_sub: '800×800 px',
        img_landscape: 'Horizontal 4:3',
        img_landscape_sub: '800×600 px',
        img_portrait: 'Vertical 3:4',
        img_portrait_sub: '600×800 px',
        img_no_resize: 'Sin redimensión',
        img_no_resize_sub: 'Dimensiones originales',
        compress: 'Compresión',
        compress_hint: 'Reducir tamaño del archivo',
        quality: 'Calidad',
        daily_credits: 'Créditos IA hoy',
        remaining: '{{n}} restantes',
        reset_in: 'Reinicio en',
        running: 'En curso — {{done}}/{{total}} productos',
        run_now: 'Ejecutar ahora',
        run_desc: 'Optimizar elementos con puntuación < {{threshold}} en: {{scope}}',
        preview_title: 'Vista previa — Antes / Después',
        before: 'Antes',
        after: 'Después IA',
        no_keywords: 'sin palabras clave',
        preview_note: 'Ejemplo en producto «Zapatilla Running Pro X1» — actualización instantánea',
        alt_mode_label: 'Modo de generación de texto ALT',
        alt_preview: 'Vista previa',
        alt_mode_ai: 'IA inteligente',
        alt_mode_ai_desc: 'OpenAI genera ALT optimizado para cada imagen',
        alt_mode_template: 'Plantilla gratuita',
        alt_mode_template_desc: 'Sin créditos IA — usa la plantilla de abajo',
        alt_mode_auto: 'Fallback automático',
        alt_mode_auto_desc: 'IA cuando disponible, plantilla si créditos agotados',
        alt_hint_template: 'Modo gratuito: sin créditos IA consumidos para texto ALT.',
        alt_hint_auto: 'Fallback auto: IA si hay créditos disponibles, si no plantilla automática.',
        pct_done: '{{pct}}% completado',
        n_errors: '{{n}} errores',
        alt_template_label: 'Plantilla personalizada',
        alt_vars_label: 'Variables disponibles — clic para insertar',
      },
      piano: {
        credits_title: 'Uso de créditos',
        plan_label: 'Plan',
        extra_credits: 'Créditos adicionales',
        unlimited: '∞ Créditos ilimitados',
        unlimited_sub: 'Plan Elite — sin límite mensual',
        plan_credits: 'Créditos del plan',
        consumed: 'Consumidos del plan',
        residual: 'Restantes del plan',
        extra_available: 'Créditos adicionales disponibles',
        extra_sub: 'Consumidos solo después del plan mensual',
        total_available: 'Total disponible',
        consumed_cycle: 'Créditos consumidos en el ciclo actual',
        status_active: 'Activo',
        status_pending: 'En procesamiento',
        status_frozen: '⚠ Suspendido',
        status_free: 'Free / Sin suscripción',
        trial_active: 'Prueba activa',
        trial_access: 'acceso completo hasta el {{date}}.',
        sub_status: 'Estado de suscripción',
        next_credit_reset: 'Próximo reinicio de créditos',
        trial_end: 'Fin de prueba',
        trial_label: 'Prueba gratuita',
        trial_used: 'Ya utilizado',
        trial_available: '{{n}} días disponibles',
        cancel_btn: 'Cancelar suscripción',
        cancelling: 'Cancelando...',
        plans_title: 'Planes disponibles',
        plan_active: 'Plan activo',
        plan_current: 'Plan actual',
        per_month: '/mes',
        downgrade: 'Volver a Free',
        downgrading: 'Bajando de plan...',
        upgrade: 'Upgrade',
        downgrade_btn: 'Downgrade',
        redirecting: 'Redirigiendo...',
        trial_btn: 'Probar gratis',
        trial_btn_days: '({{n}}d)',
        plan_overage: 'Créditos IA adicionales: {{price}} por crédito',
        plan_no_overage: 'Sin cargos por créditos IA adicionales',
        plan_trial_line: 'Prueba gratuita de {{n}} días',
        plans_note: 'Los planes de pago incluyen una prueba gratuita de {{n}} días. Sin coste de activación. Pagos gestionados por Shopify Billing.',
        credits_section: 'Comprar créditos adicionales',
        credits_desc: 'Los créditos adicionales se suman a tu plan mensual y nunca caducan. Compatibles con todos los planes.',
        one_time: 'único',
        per_credit: '¢ por crédito',
        buy: 'Comprar',
        payment_note: 'Pago procesado de forma segura vía Shopify Billing. Sin datos de pago en nuestro servidor.',
        history_title: 'Historial de compras de créditos',
        history_count: '{{n}} compra{{suffix}}',
        hist_invested: 'Total invertido',
        hist_bought: 'Créditos comprados',
        hist_available: 'Todavía disponibles',
        hist_empty: 'No se han realizado compras de créditos adicionales.',
        hist_date: 'Fecha',
        hist_pkg: 'Paquete',
        hist_credits: 'Créditos',
        hist_amount: 'Importe',
        hist_status: 'Estado',
        hist_completed: 'Completado',
        hist_pending: 'Pendiente',
        hist_declined: 'Rechazado',
        trend_title: 'Tendencia de uso',
        trend_placeholder: 'Gráfico de uso (disponible con Shopify Billing)',
        stats_products: 'Productos analizados',
        stats_content: 'Contenido generado',
        stats_translations: 'Traducciones',
        stats_images: 'Imágenes optimizadas',
        toast_sub_pending: 'Suscripción en procesamiento — recibirás una confirmación en breve.',
        toast_sub_activated: '¡{{name}} activado!',
        toast_trial_suffix: '({{n}} días de prueba gratuita)',
        toast_sub_error: 'Error de verificación de suscripción',
        toast_purchase_duplicate: 'Compra ya registrada.',
        toast_credits_added: '¡+{{n}} créditos añadidos a tu cuenta!',
        toast_purchase_error: 'Error de verificación de compra',
        toast_purchase_start_error: 'Error al iniciar la compra',
        toast_sub_start_error: 'Error al iniciar la suscripción',
        toast_store_unavailable: 'Tienda aún no conectada. Recarga la aplicación en Shopify Admin e inténtalo de nuevo.',
        toast_sub_cancelled: 'Suscripción cancelada. Plan vuelto a Free.',
        toast_sub_cancel_error: 'Error de cancelación de suscripción',
        pkg_100_label: '100 Créditos',
        pkg_100_desc: 'Ideal para uso ocasional',
        pkg_300_label: '300 Créditos',
        pkg_300_desc: 'Ahorra el 17%',
        pkg_300_badge: '⭐ Más solicitado',
        pkg_700_label: '700 Créditos',
        pkg_700_desc: 'Ahorra el 29%',
        pkg_1500_label: '1.500 Créditos',
        pkg_1500_desc: 'Ahorra el 33%',
        pkg_1500_badge: '🔥 Mejor valor',
        plan_starter_badge: '⭐ Más Popular',
        plan_starter_benefit: 'Ahorra horas de trabajo cada mes.',
        plan_pro_badge: '🔥 Crecimiento SEO',
        plan_pro_benefit: 'Mejora la indexación y el rendimiento SEO.',
        plan_elite_badge: '🚀 Agencias',
        plan_elite_benefit: 'Diseñado para agencias y catálogos enterprise.',
      },
      toast: {
        saved_at: 'Guardado a las {{time}}',
        save_error: 'Error al guardar',
        budget_exceeded: 'Crédito diario agotado — {{done}} productos optimizados de {{total}}',
        autopilot_stopped: 'Autopilot detenido — {{done}} productos optimizados de {{total}}',
        images_optimized: 'Imágenes optimizadas — {{n}} productos',
        images_failed: '{{n}} imágenes no optimizadas',
        autopilot_done: 'Autopilot completado — {{started}} productos en cola',
        autopilot_empty: 'Ningún elemento por debajo del umbral',
        autopilot_stopping: 'Autopilot deteniéndose...',
        reindex_started: 'Re-indexación iniciada',
        resync_started: 'Re-sincronización iniciada',
        cache_cleared: 'Caché borrado',
        sync_reset: 'Estado de sincronización restablecido',
      },
      advanced: {
        warning: 'Las siguientes acciones afectan el comportamiento del sistema. Úsalas solo si es necesario.',
        sync_title: 'Sincronización',
        reindex: 'Re-indexar productos',
        reindex_desc: 'Recalcular datos SEO para todos los productos de la base de datos',
        resync: 'Re-sincronizar con Shopify',
        resync_desc: 'Forzar sincronización completa de productos y colecciones',
        cache_title: 'Caché',
        clear_cache: 'Vaciar caché de la aplicación',
        clear_cache_desc: 'Elimina los lotes en curso en el navegador. Las operaciones no completadas se perderán.',
        reset_credits: 'Reiniciar créditos diarios',
        reset_credits_desc: 'Restablece el contador de créditos IA de hoy (dev). Límite: 5.000/día.',
        danger_zone: 'Zona peligrosa',
        reset_sync: 'Restablecer estado de sincronización',
        reset_sync_desc: 'Forzar restablecimiento. Usar solo si la sincronización está bloqueada más de 30 minutos.',
      },
    },
    ai_engine: {
      preset: {
        growth_desc: 'Maximiza conversiones y engagement',
        luxury_desc: 'Marca premium y narrativa exclusiva',
        seo_desc: 'Maximiza la visibilidad orgánica en Google',
        balanced_desc: 'Equilibrio óptimo entre calidad y SEO',
      },
      tone: {
        professional: 'Profesional',
        professional_desc: 'Formal, autoritativo, genera confianza',
        luxury: 'Luxury',
        luxury_desc: 'Elegante, exclusivo, premium',
        technical: 'Técnico',
        technical_desc: 'Preciso, especificaciones, datos medibles',
        conversational: 'Conversacional',
        conversational_desc: 'Directo, amigable, atractivo',
      },
      frequency: {
        daily: 'Diario',
        daily_desc: '1× al día',
        hourly: 'Cada hora',
        hourly_desc: 'Continuo',
        realtime: 'Inmediato',
        realtime_desc: 'Tan pronto como sea posible',
      },
      scope: {
        products: 'Productos',
        collections: 'Colecciones',
        articles: 'Artículos',
        pages: 'Páginas',
      },
      trigger: {
        seo_score: 'Puntuación SEO baja',
        missing_meta: 'Metadatos faltantes',
        missing_alt: 'Texto ALT ausente',
        outdated_desc: 'Descripción desactualizada',
        keywords: 'Palabras clave faltantes',
        image_quality: 'Imágenes no optimizadas',
      },
    },
    appearance: {
      title: 'Apariencia',
      theme_title: 'Tema',
      theme: {
        light: 'Claro',
        dark: 'Oscuro',
        system: 'Sistema',
      },
      density_title: 'Densidad',
      density: {
        compact: 'Compacto',
        comfortable: 'Cómodo',
        spacious: 'Espacioso',
        compact_desc: 'Más contenido',
        comfortable_desc: 'Equilibrado',
        spacious_desc: 'Más espacio',
      },
      sidebar_title: 'Barra lateral',
      sidebar: {
        expanded: 'Expandida',
        collapsed: 'Reducida',
        hidden: 'Oculta',
        expanded_desc: 'Siempre visible',
        collapsed_desc: 'Solo iconos',
        hidden_desc: 'Al pasar el cursor',
      },
    },
    localization: {
      ui_language: 'Idioma de la interfaz',
      select_language: 'Seleccionar el idioma de la aplicación',
      reload_note: 'El idioma se aplica de inmediato',
    },
    dashboard: {
      title: 'Resumen',
      subtitle: 'Resumen de actividad de la tienda',
      products: 'Productos',
      optimized: 'Optimizados',
      pending: 'Pendientes',
      seo_score: 'Puntuación SEO',
      audit_center: 'Audit Center',
      sync_products: 'Sincronizar productos',
      analyze_products: 'Analizar productos',
      audit_site: 'Auditoría del sitio 360',
      syncing: 'Sync...',
      analyzing: 'Analizando...',
      auditing: 'Audit...',
      section_account: 'Cuenta y Plan',
      section_catalog: 'Estado del catálogo',
      section_images: 'Imágenes',
      section_seo_tech: 'SEO Técnico — Auditoría detallada del sitio',
      section_ux_trust: 'UX & Trust — Highlights',
      section_actions: 'Acciones recomendadas por IA',
      recent_activity: 'Actividad reciente',
      hint_plan: 'Estado del plan y los créditos',
      hint_never_synced: 'Nunca sincronizado',
      hint_priority: 'Ordenado por prioridad',
      hint_last_sync: 'Última sync {{date}}',
      current_plan: 'Plan actual',
      credits_used: 'Créditos usados',
      credits_remaining: 'Créditos restantes',
      public_domain: 'Dominio público',
      credit_usage: 'Uso de créditos',
      hint_installed: 'Instalado el {{date}}',
      hint_pct_plan: '{{pct}}% del plan',
      hint_limit: 'Límite {{n}}',
      hint_last_audit: 'Última auditoría {{date}}',
      hint_no_audit: 'Auditoría no realizada',
      no_audit: 'Ninguna auditoría realizada',
      no_audit_desc: 'Ejecuta una auditoría para analizar title, meta, H1, canonical, robots, sitemap, HTTPS, OG, JSON-LD, rendimiento, imágenes y enlaces.',
      run_audit: 'Ejecutar auditoría',
      in_progress: 'En curso...',
      audit_phase: 'Auditoría en curso (fase: {{phase}})...',
      ux_highlights: 'UX Highlights',
      trust_compliance: 'Trust & Compliance',
      mobile_viewport: 'Mobile viewport:',
      favicon: 'Favicon:',
      images_without_alt_label: 'Imágenes sin ALT:',
      lazy_loading: 'Lazy loading:',
      images_suffix: 'imágenes',
      internal_links: 'Enlaces internos:',
      data_unavailable: 'Datos no disponibles: {{reason}}',
      analysis_not_run: 'Análisis no ejecutado',
      not_detected: 'No detectado',
      no_trust_data: 'Sin datos de confianza disponibles',
      no_activity: 'Sin actividad reciente.',
      activity_completed: 'Completado',
      activity_error: 'Error',
      no_store_title: 'Sin tienda conectada',
      no_store_desc: 'Instala la aplicación en una tienda Shopify para comenzar',
      connect_store: 'Conectar tienda Shopify',
      no_token_title: 'Token OAuth faltante',
      no_token_desc: 'La tienda {{domain}} está registrada pero no tiene token. Reinstala la aplicación.',
      reinstall_app: 'Reinstalar la aplicación via OAuth',
      sync_in_progress: 'Sincronización de productos en curso…',
      sync_in_progress_detail: '{{synced}} / {{total}} productos. Los datos del panel se actualizarán al finalizar la sincronización.',
      stale_data: 'Datos desactualizados: se muestran los últimos números válidos mientras la sincronización está en curso.',
      catalog_score_label: 'Catalog Score',
      seo_distribution: 'Distribución SEO',
      n_products: '{{n}} productos',
      pct_of_catalog: '{{pct}}% del catálogo',
      no_description: 'Sin descripción',
      no_meta_description: 'Sin meta description',
      seo_needs_improvement: 'SEO por mejorar',
      view: 'Ver',
      seo_good_desc: 'El catálogo tiene una buena cobertura SEO. Mantén el estándar optimizando los nuevos productos.',
      seo_medium_desc: 'El catálogo tiene una cobertura SEO media. Prioridad: meta descriptions y descripciones de producto.',
      seo_poor_desc: 'El catálogo tiene una cobertura SEO baja. Prioridad: meta descriptions, descripciones e imágenes faltantes.',
      seo_optimized: 'Optimizados',
      seo_medium: 'Medios',
      seo_poor: 'Por mejorar',
      content_seo_title: 'Estado SEO por tipo de contenido',
      open_catalog: 'Abrir catálogo',
      row_collections: 'Colecciones',
      row_articles: 'Artículos',
      row_pages: 'Páginas',
      coming_soon: 'Próximamente',
      not_synced: 'No sincronizados',
      seo_coverage_fmt: '{{opt}}/{{total}} optimizados · {{score}}/100',
      alt_coverage: 'Cobertura ALT text',
      with_alt_count: '{{n}} con ALT de {{total}}',
      image_optimization_label: 'Optimización de imágenes',
      optimized_count: '{{n}} optimizadas de {{total}}',
      with_alt: 'Con ALT',
      without_alt: 'Sin ALT',
      image_optimized: 'Optimizadas',
      image_needs_improvement: 'Por mejorar',
      no_image: 'Sin imagen',
      savings: 'Ahorro',
      optimize_images_btn: 'Optimizar imágenes',
      view_no_image: 'Ver productos sin imagen',
      alt_manager: 'ALT Text Manager',
      toast_sync_done: 'Sincronización completada. Reconciliando catálogo...',
      toast_catalog_reconciled: 'Catálogo reconciliado: {{n}} productos ({{removed}} huérfanos eliminados)',
      toast_sync_first: 'Sincroniza primero los productos',
      toast_avg_score: 'Score medio {{score}}/100',
      toast_audit_done: 'Auditoría completada: {{score}}/100',
      toast_sync_reset: 'Estado de sync restablecido',
      toast_sync_reset_error: 'No se pudo restablecer el estado',
      op_description: 'Descripción IA',
      op_seo_title: 'SEO Title',
      op_meta_description: 'Meta Description',
      op_keywords: 'Keywords',
      op_translation: 'Traducción',
      op_image_opt: 'Optimización de imagen',
      op_sync: 'Sync Shopify',
      op_seo_analysis: 'Análisis SEO tienda',
      op_site_audit: 'Auditoría del sitio 360',
      prompt_domain: 'Ingresa el dominio de tu tienda Shopify',
      hint_force_reset: 'Forzar restablecimiento del estado de sincronización (no elimina productos)',
    },
    products: {
      title: 'Catálogo de productos',
      search: 'Buscar productos...',
      all: 'Todos',
      optimized: 'Optimizados',
      pending: 'Pendientes',
      status_generating: 'Generando',
      status_writing: 'Escribiendo',
      status_validating: 'Validando',
      status_failed: 'Fallido',
      status_sync_failed: 'Sync Shopify',
      status_optimized: 'Optimizado',
      status_medium: 'Medio',
      status_needs_improvement: 'Por mejorar',
      type_collection_singular: 'colección',
      type_collection_plural: 'colecciones',
      sync_collections: 'Sincronizar colecciones',
      empty_collections: 'Sin colecciones. Haz clic en "Sincronizar colecciones" para importarlas desde Shopify.',
      search_collections: 'Buscar colección por título o handle...',
      col_label_products: 'Productos',
      type_article_singular: 'artículo',
      type_article_plural: 'artículos',
      sync_articles: 'Sincronizar artículos',
      empty_articles: 'Sin artículos. Haz clic en "Sincronizar artículos" para importarlos desde Shopify.',
      search_articles: 'Buscar artículo por título, handle o blog...',
      col_label_blog: 'Blog',
      type_page_singular: 'página',
      type_page_plural: 'páginas',
      sync_pages: 'Sincronizar páginas',
      empty_pages: 'Sin páginas. Haz clic en "Sincronizar páginas" para importarlas desde Shopify.',
      search_pages: 'Buscar página por título o handle...',
      col_label_author: 'Autor',
      catalog_title: 'Catálogo',
      no_store: 'Sin tienda',
      tab_products: 'Productos',
      tab_collections: 'Colecciones',
      tab_articles: 'Artículos',
      tab_pages: 'Páginas',
      sort_updated: 'Actualizado',
      sort_seo_score: 'Score SEO',
      sort_title: 'Título',
      sort_vendor: 'Vendor',
      sort_created: 'Creado',
      sort_desc: 'Descendente',
      sort_asc: 'Ascendente',
      filter_seo_all: 'SEO: todos',
      filter_optimized: 'Optimizados',
      filter_medium: 'Medios',
      filter_needs_improvement: 'Por mejorar',
      filter_image_all: 'Imágenes: todos',
      filter_image_yes: 'Con imágenes',
      filter_image_no: 'Sin imágenes',
      filter_meta_all: 'Meta: todos',
      filter_meta_yes: 'Con meta',
      filter_meta_no: 'Sin meta',
      filter_desc_all: 'Descripción: todos',
      filter_desc_yes: 'Con descripción',
      filter_desc_no: 'Sin descripción',
      filter_vendor_all: 'Vendor: todos',
      filter_collection_all: 'Colección: todas',
      filter_type_all: 'Tipo: todos',
      reset_filters: 'Restablecer filtros',
      th_image: 'Imagen',
      th_title: 'Título',
      th_seo_score: 'Score SEO',
      th_alt: 'ALT',
      th_meta: 'Meta',
      th_status: 'Estado',
      th_actions: 'Acciones',
      no_products_filters: 'No se encontraron productos con estos filtros',
      no_products: 'Sin productos. Sincroniza desde tu tienda Shopify.',
      pagination: 'Página {{page}} de {{total}} · {{count}} productos',
      batch_btn: 'Operaciones en lote',
      dialog_status: 'Estado',
      dialog_seo_score: 'Score SEO',
      dialog_shopify_id: 'ID Shopify',
      dialog_vendor: 'Vendor',
      dialog_serp: 'Vista previa SERP',
      dialog_issues: 'Problemas SEO',
      dialog_suggestions: 'Sugerencias',
      generating: 'Generando...',
      generate_all: 'Generar todo el contenido',
      action_generate_ai: 'Generar contenido IA',
      action_translate: 'Traducir',
      action_optimize_image: 'Optimizar imagen',
      syncing: 'Sincronizando...',
      draft_ready: 'Borrador listo',
      seo_ai_btn: 'SEO IA',
      batch_ops_btn: 'Operaciones en lote',
      diagnosis: 'Diagnóstico',
      current_score: 'Score actual',
      projected: '→ previsto {{score}}/100',
      meta_title: 'Meta Title',
      meta_desc_label: 'Meta Description',
      description_label: 'Descripción',
      generate_desc_btn: 'Generar descripción IA',
      generating_desc: 'Generando...',
      generate_ai_btn: 'Generar con IA',
      publish_shopify_btn: 'Publicar en Shopify',
      publishing: 'Publicando...',
      discard_draft_btn: 'Descartar borrador',
      seo_ai_dialog_title: 'SEO IA',
      seo_all: 'SEO: todos',
      seo_optimized: 'Optimizados',
      seo_medium: 'Medios',
      seo_needs: 'Por mejorar',
      page_of: 'Página {{page}} de {{total}}',
      search_placeholder: 'Buscar por título, SKU, EAN, proveedor, handle...',
      chars_count: '{{n}}/{{max}} caracteres',
      n_selected_info: 'seleccionados',
      filtered: 'filtrados',
      soon_tooltip: 'Disponible próximamente',
      resource_subtitle: '{{type}} Shopify y su estado SEO',
      articles_blog: 'Artículos (blog)',
      select_visible_title: 'Seleccionar/deseleccionar todos los visibles',
      toast_draft_ready: 'Borrador SEO generado. Revisa y publica.',
      toast_error_ai: 'Error de generación de IA',
      toast_desc_generated: 'Descripción de IA generada.',
      toast_error_desc: 'Error al generar la descripción',
      toast_empty_draft: 'Genera o rellena al menos un campo',
      toast_published_score: 'Publicado en Shopify · Score {{score}}/100',
      toast_error_publish: 'Error al publicar en Shopify',
      toast_draft_discarded: 'Borrador descartado',
      toast_select_items: 'Selecciona al menos un elemento',
      toast_mode_publish: 'Publicación',
      toast_mode_both: 'Generar+Publicar',
      toast_mode_generate: 'Generación SEO AI',
      toast_batch_launched: '{{label}} iniciada en {{count}} {{type}}.',
      toast_batch_errors: '{{label}} completada con {{count}} errores',
      toast_batch_done: '{{label}} completada en {{count}} {{type}}',
      toast_synced: '{{type}} sincronizados: {{count}}',
      toast_sync_error: 'Error de sincronización {{type}}',
      toast_token_error: 'Token de Shopify expirado o sin permisos',
      reinstall_label: 'Reinstalar',
      toast_sync_started: 'Sincronización de {{type}} iniciada',
      toast_error_sync_start: 'Error al iniciar la sincronización',
      toast_perms_ok: 'Permisos ok ({{kind}})',
      toast_token_revoked: 'Token revocado',
      toast_perms_missing: 'Permisos faltantes',
      toast_diag_error: 'Error de diagnóstico',
      toast_score: 'Score {{score}}/100',
      toast_error_analyze: 'Error de análisis',
      toast_generated: 'Contenido generado',
      toast_error_generate: 'Error de generación',
    },
    content: {
      title: 'Generación de contenido',
      generate: 'Generar contenido',
      language: 'Idioma',
      tone: 'Tono',
      subtitle: 'Genera descripciones, SEO title, meta description y keywords con IA',
      tab_products: 'Productos',
      tab_collections: 'Colecciones',
      tab_articles: 'Artículos',
      tab_pages: 'Páginas',
      type_description_label: 'Descripción',
      type_description_hint: 'Texto de producto atractivo y optimizado para SEO',
      type_seo_title_label: 'SEO Title',
      type_seo_title_hint: 'Título optimizado para SERP (max 60 car.)',
      type_meta_desc_label: 'Meta Description',
      type_meta_desc_hint: 'Fragmento de Google (max 160 car.)',
      type_keywords_label: 'Keywords',
      type_keywords_hint: 'Palabras clave principales y secundarias',
      type_body_label: 'Descripción / Cuerpo',
      type_body_hint: 'Texto principal del recurso',
      filter_all: 'Todos',
      filter_needs: 'Por mejorar',
      filter_medium: 'Medios',
      filter_optimized: 'Optimizados',
      no_results_filters: 'Ningún elemento coincide con los filtros',
      select_all: 'Seleccionar todo',
      deselect: 'Deseleccionar',
      selected_count: '{{count}} seleccionados',
      selected_max: '(max)',
      deselect_all: 'Deseleccionar todo',
      pagination_of: '{{page}} / {{total}}',
      total_count: '({{count}} total)',
      content_type_section: 'Tipo de contenido',
      batch_generating: 'Generando… {{done}}/{{total}}',
      batch_generate_btn: 'Generar en lote ({{count}})',
      generating_count: 'Generar ({{count}})',
      generate_btn: 'Generar',
      generating: 'Generando…',
      generate_all_btn: 'Todos',
      hint_select: '← Selecciona un elemento o marca varios para el lote',
      hint_batch_ready: '{{count}} elemento(s) listo(s) para el lote',
      batch_done_title: '✓ Lote completado',
      batch_pending_title: 'Lote en espera…',
      batch_in_progress_title: 'Generación en lote en curso…',
      batch_done_msg: 'Todo el contenido generado. La selección se borrará automáticamente.',
      results_section: 'Resultados',
      publishing: 'Publicando…',
      published: 'Publicado',
      publish_btn: 'Publicar en Shopify',
      clear_results: 'Borrar',
      chars_unit: 'car.',
      cache_label: 'caché',
      preview_section: 'Vista previa actual',
      loading_detail: 'Cargando detalle…',
      not_present: 'No presente',
      not_present_plural: 'No presentes',
      empty_state: 'Haz clic en un elemento para verlo, o marca varios y usa Generar en lote',
      copy_btn: 'Copiar',
      type_seo_title_hint_content: 'Metatítulo para SERP (máx. 60 car.)',
      no_items: 'No se encontró ningún {{type}}',
      item_deselect: 'Deseleccionar',
      item_select: 'Añadir a la selección',
      generate_all_title: 'Generar todos los tipos disponibles',
      prev_item: 'Elemento anterior',
      next_item: 'Elemento siguiente',
      toast_load_error: 'Error al cargar los elementos',
      toast_batch_done: 'Lote completado: {{done}}/{{total}} productos',
      toast_batch_failed: 'Lote fallido: {{failed}} errores de {{total}}',
      toast_batch_cancelled: 'Lote cancelado',
      toast_batch_resumed: 'Lote activo reanudado…',
      toast_max_select: 'Máximo {{max}} elementos seleccionables',
      toast_select_item: 'Seleccione un elemento de la lista',
      toast_select_type: 'Seleccione al menos un tipo de contenido',
      toast_from_cache: '¡Contenido desde la caché!',
      toast_generated: '¡Generado con éxito!',
      toast_generate_error: 'Error al generar el contenido',
      toast_batch_running: 'Ya hay un proceso por lotes en curso',
      toast_no_store: 'Tienda no disponible',
      toast_batch_started: 'Lote iniciado: {{n}} productos en cola',
      toast_batch_start_error: 'Error al iniciar el lote',
      toast_batch_item_error: 'Error de generación: {{title}}',
      toast_batch_complete: 'Lote completado: {{done}}/{{total}} elementos',
      toast_cancel_error: 'Error al cancelar el lote',
      toast_published: '¡Contenido publicado en Shopify!',
      toast_publish_error: 'Error al publicar el contenido',
      toast_copied: 'Copiado al portapapeles',
      present: 'presente',
      missing: 'ausente',
      lang_it: 'Italiano',
      lang_en: 'Inglés',
      lang_fr: 'Francés',
      lang_de: 'Alemán',
      lang_es: 'Español',
      lang_pt: 'Portugués',
      tone_professional: 'Profesional',
      tone_luxury: 'Lujo',
      tone_technical: 'Técnico',
      tone_conversational: 'Conversacional',
    },
    images: {
      title: 'Optimización de imágenes',
      optimize: 'Optimizar',
      format: 'Formato',
      compress: 'Comprimir',
      quality: 'Calidad',
      alt_mode_label: 'Modo de generación ALT',
      alt_mode_ai: 'IA inteligente',
      alt_mode_template: 'Plantilla gratuita',
      alt_mode_auto: 'Auto fallback',
      subtitle: 'Optimiza imágenes, gestiona el texto ALT y publica en Shopify.',
      tab_optimize: 'Optimizar imágenes',
      tab_alt: 'Texto ALT',
      alt_coverage: 'Cobertura ALT',
      with_alt_count: 'con ALT de',
      stat_with_alt: 'Con ALT: {{count}}',
      stat_without_alt: 'Sin ALT: {{count}}',
      stat_no_image: 'Sin imagen: {{count}}',
      sync_alt_btn: 'Actualizar datos ALT desde Shopify',
      syncing_alt: 'Actualizando ALT...',
      sync_status_label: 'Estado:',
      analyzed_label: 'Analizados:',
      last_updated_label: 'Última actualización:',
      stalled: 'bloqueado',
      force_stop: 'Forzar parada (bloqueado 60s)',
      free_badge: '● Gratuito — sin créditos',
      configure_btn: '▼ Configurar',
      hide_btn: '▲ Ocultar',
      template_free_hint: 'Modo gratuito activo — cero créditos IA. Template:',
      template_auto_hint: 'Respaldo automático — IA si hay créditos, template local si están agotados.',
      template_config_title: 'Configurar template ALT',
      template_label: 'Template personalizado',
      template_preview: 'Vista previa:',
      variables_label: 'Variables disponibles — haz clic para insertar:',
      restore_default: 'Restaurar predeterminado',
      save_config: 'Guardar configuración',
      saving: 'Guardando...',
      search_placeholder: 'Buscar por título, vendor, handle...',
      filter_all_images: 'Todas',
      filter_with_alt: 'Con ALT',
      filter_without_alt: 'Sin ALT',
      selected_images: '{{count}} imágenes seleccionadas (max 50 por lote)',
      generate_batch_btn: 'Generar ALT para seleccionadas',
      batch_alt_in_progress: 'Lote ALT en curso: {{done}} / {{total}}',
      batch_errors: '{{n}} errores',
      select_all_label: 'Seleccionar todo',
      deselect_all_label: 'Deseleccionar todo',
      total_products_label: '{{count}} productos',
      timeout_title: 'La carga tardó demasiado (20s)',
      timeout_desc: 'La base de datos está procesando muchos productos. Inténtalo de nuevo en unos segundos.',
      error_title: 'Error al cargar la lista',
      no_products_filter: 'Ningún producto coincide con los filtros',
      alt_placeholder: 'Texto ALT (max 125 caracteres)',
      status_published: 'Publicado',
      status_saved: 'Guardado',
      status_draft_alt: 'Borrador',
      status_missing: 'Sin ALT',
      generate_alt_btn: 'Generar ALT',
      save_alt_btn: 'Guardar ALT',
      publish_alt_btn: 'Publicar',
      prec: 'Ant.',
      succ: 'Sig.',
      select_products: 'Seleccionar productos',
      filter_collection_all: 'Colección: todas',
      filter_vendor_all: 'Vendor: todos',
      filter_kb_all: 'KB: todos',
      filter_kb_100: 'Archivos más de 100 KB',
      filter_kb_500: 'Archivos más de 500 KB',
      filter_kb_1mb: 'Archivos más de 1 MB',
      filter_format_all: 'Formato: todos',
      filter_landscape: 'Ancho mayor que Alto',
      filter_portrait: 'Alto mayor que Ancho',
      filter_square: 'Cuadradas',
      filter_status_all: 'Estado: todos',
      filter_status_optimized: 'Ya optimizadas',
      filter_status_needs: 'Por optimizar',
      visible_total: '{{visible}} visibles · {{total}} totales',
      reset_filters: 'Restablecer filtros',
      clear_selection: 'Borrar selección',
      no_image_products: 'Ningún producto con imagen',
      ready_badge: 'Lista',
      settings_title: 'Configuración',
      format_title: 'Formato de imagen',
      format_square: 'Cuadrado 1:1',
      format_landscape: 'Landscape 4:3',
      format_portrait: 'Portrait 3:4',
      format_none: 'Sin redimensionar',
      format_none_sub: 'Dimensiones originales',
      compress_label: 'Compresión',
      compress_desc: 'Reducir tamaño de archivo',
      quality_label: 'Calidad',
      batch_opt_running: 'Optimización en curso',
      batch_opt_cancelled: 'Optimización cancelada',
      batch_opt_completed: 'Optimización completada',
      batch_apply_running: 'Aplicación en curso',
      batch_apply_cancelled: 'Aplicación cancelada',
      batch_apply_completed: 'Aplicación completada',
      background_note: 'Puedes cambiar de sección, continúa en segundo plano',
      optimizing: 'Optimizando...',
      optimize_n: 'Optimizar {{count}} imágenes',
      optimize_one: 'Optimizar imagen',
      applying: 'Aplicando...',
      apply_n: 'Aplicar {{count}} en Shopify',
      apply_one: 'Aplicar en Shopify',
      preview_title: 'Vista previa',
      ready_optimizations: '{{count}} optimizaciones listas',
      select_preview_hint: 'Selecciona uno o más productos para ver la vista previa',
      first_product_preview: 'Vista previa del primer producto seleccionado:',
      original_label: 'Original',
      optimized_label: 'Optimizada',
      optimize_click_hint: 'Haz clic en "Optimizar" para el resultado',
      reduction_label: 'Reducción',
      apply_btn: 'Aplicar',
      history_opt_title: 'Historial de optimizaciones',
      history_opt_subtitle: 'Operaciones aplicadas en Shopify, errores y restauraciones.',
      stat_running_label: 'En curso',
      stat_completed_label: 'Completadas',
      stat_errors_label: 'Incompletas',
      stat_undo_label: 'Deshacer',
      total_savings: 'Ahorro total',
      history_loading: 'Cargando historial...',
      no_history: 'Ninguna operación aplicada aún.',
      restoring: 'Restaurando...',
      undo_btn: 'Deshacer',
      kb_warning: 'El tamaño KB no está en los datos locales. Para hacerlo preciso debe guardarse por el backend durante la sincronización de imágenes.',
      senza_vendor: 'Sin vendor',
      alt_stat_coverage: '{{n}} con ALT de {{total}}',
      apply_batch_cancelled: 'Aplicación cancelada',
      apply_batch_done_label: 'Aplicación completada',
      apply_batch_running: 'Aplicación en curso',
      apply_n_btn: 'Aplicar {{n}} en Shopify',
      applying_btn: 'Aplicando...',
      auto_fallback_hint: 'Auto fallback — IA si hay créditos disponibles, template local si se agotan.',
      background_hint: 'Puede cambiar de sección, continúa en segundo plano',
      badge_draft: 'Borrador',
      badge_missing: 'Sin ALT',
      badge_published: 'Publicado',
      badge_ready: 'Listo',
      badge_saved: 'Guardado',
      batch_close: 'Cerrar',
      batch_generate_btn: 'Generar ALT para seleccionados',
      batch_progress: 'Batch ALT en curso: {{done}} / {{total}}',
      batch_selected: '{{n}} imágenes seleccionadas (máx. 50 por batch)',
      collection_all: 'Colección: todas',
      compress_sub: 'Reducir el tamaño del archivo',
      config_btn: '▼ Configurar',
      deselect_all: 'Deseleccionar todo',
      empty_filtered: 'Ningún producto coincide con los filtros',
      filter_all: 'Todas',
      format_label: 'Formato de imagen',
      gen_alt_btn: 'Generar ALT',
      history_completed: 'Completadas',
      history_empty: 'Ninguna operación aplicada aún.',
      history_incomplete: 'Incompletas',
      history_running: 'En curso',
      history_savings: 'Ahorro total',
      history_subtitle: 'Operaciones aplicadas en Shopify, errores y restauraciones.',
      history_title: 'Historial de optimizaciones',
      history_undo_label: 'Deshacer',
      last_update_label: 'Última actualización:',
      load_error: 'Error al cargar la lista',
      n_errors: '{{n}} errores',
      n_products: '{{n}} productos',
      n_selected: '{{n}} seleccionados',
      next_page: 'Sig.',
      no_products: 'Ningún producto con imagen',
      no_vendor: 'Sin vendor',
      opt_batch_cancelled: 'Optimización cancelada',
      opt_batch_done: 'Optimización completada',
      opt_batch_running: 'Optimización en curso',
      optimize_n_btn: 'Optimizar {{n}} imágenes',
      optimize_one_btn: 'Optimizar imagen',
      optimizing_btn: 'Optimizando...',
      orientation_all: 'Formato: todos',
      orientation_landscape: 'Ancho mayor que alto',
      orientation_portrait: 'Alto mayor que ancho',
      orientation_square: 'Cuadrado',
      page_info: 'Página {{page}} de {{total}}',
      pagination: 'Página {{page}} de {{total}}',
      prev: 'Ant.',
      publish_btn: 'Publicar',
      retry: 'Reintentar',
      select_all: 'Seleccionar todo',
      size_100kb: 'Archivos de más de 100 KB',
      size_1mb: 'Archivos de más de 1 MB',
      size_500kb: 'Archivos de más de 500 KB',
      size_all: 'KB: todos',
      status_all: 'Estado: todos',
      status_label: 'Estado:',
      status_needs: 'Por optimizar',
      status_optimized: 'Ya optimizadas',
      status_stalled: 'bloqueado',
      sync_btn: 'Actualizar datos ALT desde Shopify',
      sync_btn_title: 'Relee desde Shopify las imágenes y los ALT texts reales',
      syncing: 'Actualizando ALT...',
      template_active: 'Modo gratuito activo — cero créditos IA. Template:',
      template_custom_label: 'Template personalizado',
      template_free_badge: '● Gratuito — sin créditos',
      template_preview_label: 'Vista previa:',
      template_reset: 'Restaurar predeterminado',
      template_save: 'Guardar configuración',
      template_saving: 'Guardando...',
      template_vars_label: 'Variables disponibles — haz clic para insertar:',
      timeout_msg: 'La base de datos está procesando muchos productos. Inténtalo de nuevo en unos segundos.',
      toast_alt_ai: 'ALT generado mediante IA',
      toast_alt_cancelled: 'Actualización ALT cancelada — puedes reiniciarla',
      toast_alt_empty: 'ALT vacío',
      toast_alt_from_cache: 'ALT desde caché',
      toast_alt_gen_error: 'Error de generación ALT',
      toast_alt_publish_error: 'Error de publicación',
      toast_alt_published: 'Publicado en Shopify',
      toast_alt_save_error: 'Error de guardado',
      toast_alt_saved: 'ALT guardado',
      toast_alt_sync_start_error: 'Error al iniciar la actualización ALT',
      toast_alt_sync_started: 'Actualización de datos ALT iniciada',
      toast_alt_template: 'ALT generado mediante template (gratuito)',
      toast_alt_template_fallback: 'ALT mediante template (créditos agotados)',
      toast_alt_update_error: 'Error de actualización ALT',
      toast_alt_updated: 'Datos ALT actualizados: {{n}} productos analizados',
      toast_applied: 'Imagen aplicada en Shopify',
      toast_apply_batch_done: '{{n}} imágenes aplicadas en Shopify',
      toast_apply_batch_errors: 'Aplicación completada con {{n}} errores',
      toast_apply_batch_started: 'Aplicación iniciada: {{n}} imágenes. Puedes cambiar de sección.',
      toast_batch_alt_done: 'Batch completado',
      toast_batch_alt_started: 'Batch iniciado: {{n}} imágenes, {{c}} a la vez',
      toast_batch_done: 'Batch completado: {{n}} imágenes optimizadas. Puedes aplicarlas en Shopify.',
      toast_batch_errors: '{{n}} imágenes no procesadas. Reintenta o revisa los logs.',
      toast_batch_started: 'Batch iniciado: {{n}} imágenes. Puedes cambiar de sección, continúa en segundo plano.',
      toast_cancel_error: 'Error de cancelación',
      toast_no_draft: 'Ninguna imagen optimizada para aplicar',
      toast_no_images: 'Ninguna imagen seleccionada',
      toast_no_ready: 'Ninguna optimización lista para aplicar',
      toast_no_store: 'Tienda no disponible',
      toast_optimize_error: 'Error de optimización',
      toast_optimized: 'Imagen optimizada. Ahora puedes aplicarla en Shopify.',
      toast_select_product: 'Selecciona al menos un producto',
      toast_template_save_error: 'Error al guardar el template',
      toast_template_saved: 'Configuración del template guardada',
      toast_undo_done: 'Imagen original restaurada',
      toast_undo_error: 'Error durante la restauración',
      undoing_btn: 'Restaurando...',
      vendor_all: 'Vendor: todos',
      toast_no_product: 'Selecciona un producto',
      toast_no_image: 'El producto no tiene imagen',
      toast_no_preview: 'Primero optimiza una imagen',
      toast_apply_error: 'Error al aplicar en Shopify',
      n_ready: '{{n}} optimizaciones listas',
      preview_hint: 'Selecciona uno o más productos para ver la vista previa',
      preview_first: 'Vista previa del primer producto seleccionado:',
      click_optimize_hint: 'Haz clic en "Optimizar" para el resultado',
      apply_single_btn: 'Aplicar',
    },
    alt_template: {
      section_title: 'Plantilla ALT',
      mode_label: 'Modo de generación de texto ALT',
      textarea_label: 'Plantilla personalizada',
      preview_label: 'Vista previa',
      vars_label: 'Variables disponibles — haz clic para insertar',
      hint_template: 'Modo gratuito: sin créditos de IA para texto ALT.',
      hint_auto: 'Auto fallback: IA si hay créditos, sino plantilla local.',
    },
    batch: {
      title: 'Operaciones en lote',
      start: 'Iniciar',
      cancel: 'Cancelar',
      subtitle: 'Procesamiento persistente en servidor — continúa aunque cambies de página o cierres la pestaña',
      locked_title: 'Operaciones en lote no disponibles',
      locked_desc: 'Las operaciones en lote están disponibles desde el plan Starter. Procesa cientos de productos en paralelo con un solo clic.',
      upgrade_btn: 'Pasar a Starter',
      op_content_label: 'Generar contenido IA',
      op_content_desc: 'Descripción, SEO title, meta description, keywords',
      op_translate_label: 'Traducir productos',
      op_translate_desc: 'Traducción completa al idioma seleccionado',
      op_images_label: 'Optimizar imágenes',
      op_images_desc: 'Redimensionado 1:1 y compresión de imágenes',
      field_description_label: 'Descripción',
      field_description_hint: '150-250 palabras',
      field_seo_title_label: 'SEO Title',
      field_seo_title_hint: 'max 60 caracteres',
      field_meta_desc_label: 'Meta Description',
      field_meta_desc_hint: '100-160 caracteres',
      field_keywords_label: 'Keywords',
      field_keywords_hint: '5-10 palabras clave',
      count_all: 'Todos',
      status_pending: 'En cola',
      status_running: 'En curso',
      status_completed: 'Completado',
      status_failed_job: 'Fallido',
      status_cancelled: 'Cancelado',
      opt_in_progress: 'Optimización de imágenes en curso…',
      batch_in_progress: 'Lote IA en curso…',
      images_progress: '{{done}} / {{total}} imágenes',
      products_progress: '{{done}} / {{total}} productos',
      errors_count: '{{count}} errores',
      duration_label: 'Duración: {{time}}',
      starting: 'Iniciando...',
      seo_gen_in_progress: 'Generar + Publicar SEO en curso',
      gen_publish_auto: 'Generación y publicación automática en Shopify',
      section_operation: 'Operación',
      section_fields: 'Campos a generar',
      fields_selected: '{{count}}/{{total}} seleccionados',
      fields_warning: 'Selecciona al menos un campo para iniciar el lote',
      fields_hint: 'Una sola llamada IA por producto genera todos los campos seleccionados — menor latencia y costes reducidos.',
      section_options: 'Opciones',
      label_language: 'Idioma',
      label_tone: 'Tono',
      tone_professional: 'Profesional',
      tone_luxury: 'Lujo',
      tone_technical: 'Técnico',
      tone_conversational: 'Conversacional',
      label_target_lang: 'Idioma de destino',
      images_note: 'Redimensionado 1:1 (800×800) + compresión calidad 85%.',
      section_quantity: 'Cantidad de productos',
      available_count: '{{count}} disponibles',
      catalog_selection: '{{count}} producto(s) seleccionado(s) del catálogo',
      remove_selection: 'Quitar selección',
      products_selected_count: '{{count}} producto(s) seleccionado(s)',
      processing: 'Procesando…',
      start_btn: 'Iniciar procesamiento',
      history_title: 'Historial de lotes',
      history_subtitle: 'actualizado desde DB',
      stat_running: 'En curso',
      stat_completed: 'Completados',
      stat_products_ok: 'Productos OK',
      no_batch: 'Ningún lote ejecutado',
      no_batch_hint: 'Los trabajos aparecerán aquí tras el primer procesamiento',
      job_content: 'Generar contenido IA',
      job_translate: 'Traducción',
      job_images: 'Optimización de imágenes',
      job_products: '{{done}}/{{total}} productos',
      log_lang: 'Idioma:',
      log_tone: 'Tono:',
      toast_completed: 'Lote completado: {{done}}/{{total}} productos procesados',
      toast_failed: 'Lote fallido: {{count}} errores',
      toast_no_products: 'No hay productos disponibles',
      soon_lbl: 'pronto',
      btn_analyze_seo: 'Analizar SEO',
      btn_view: 'Ver',
      toast_no_fields: 'Selecciona al menos un campo para generar',
      toast_images_started: 'Optimización de imágenes iniciada: {{count}} productos',
      toast_started: 'Lote iniciado: {{count}} productos',
      toast_start_error: 'Error al iniciar',
      toast_cancelled: 'Lote cancelado',
      toast_cancel_error: 'Error de cancelación',
      fields_label: 'Campos',
      log_summary: 'Registros de operaciones individuales',
    },
    history: {
      title: 'Historial',
      empty: 'No se encontraron operaciones',
      subtitle: 'Auditoría completa de todas las ejecuciones IA — {{n}} operaciones en total',
      refresh_btn: 'Actualizar',
      total_operations: 'Total de operaciones',
      success_rate: 'Tasa de éxito',
      n_successes: '{{n}} éxitos',
      credits_today: 'Créditos hoy',
      products_today: 'Productos hoy',
      avg_duration: 'Duración media',
      last_autopilot: 'Último Autopilot',
      filters: 'Filtros',
      filters_active: 'activos',
      reset_all: 'Restablecer todo',
      search_placeholder: 'Buscar producto...',
      op_all: 'Todos los tipos',
      op_description: 'Descripción IA',
      op_seo_title: 'SEO Title IA',
      op_meta_description: 'Meta Description IA',
      op_batch: 'Generación en lote',
      op_translation: 'Traducción',
      op_image: 'Imagen',
      op_sync: 'Sync Shopify',
      trigger_all: 'Todos los disparadores',
      status_all: 'Todos los estados',
      status_success: 'Éxito',
      status_partial: 'Parcial',
      status_error: 'Error',
      th_status: 'Estado',
      th_type: 'Tipo de operación',
      th_product: 'Producto',
      th_trigger: 'Disparador',
      th_seo_delta: 'SEO Delta',
      th_credits: 'Créditos',
      th_duration: 'Duración',
      th_timestamp: 'Marca de tiempo',
      loading: 'Cargando...',
      remove_filters: 'Quitar filtros',
      load_more: 'Cargar más (mostrando {{shown}} de {{total}})',
      details_title: 'Detalles de la ejecución',
      detail_op_id: 'ID de operación',
      detail_product_id: 'ID de producto',
      detail_store_id: 'Store ID',
      detail_type: 'Tipo',
      detail_trigger: 'Disparador',
      detail_status: 'Estado',
      detail_language: 'Idioma',
      detail_tone: 'Tono',
      detail_tokens: 'Tokens usados',
      detail_fields: 'Campos',
      detail_credits: 'Créditos',
      detail_duration: 'Duración',
      detail_seo_before: 'SEO antes',
      detail_seo_after: 'SEO después',
      detail_timestamp: 'Marca de tiempo',
      error_prefix: 'Error: ',
      label_description: 'Descripción IA',
      label_seo_title: 'SEO Title IA',
      label_meta_description: 'Meta Description IA',
      label_keywords: 'Keywords IA',
      label_batch: 'Generación en lote',
      label_translation: 'Traducción',
      label_image: 'Optimización de imagen',
      label_sync: 'Sync Shopify',
      label_push: 'Publicación Shopify',
    },
    batch_banner: {
      errors: 'errores',
      optimizing: 'Optimización de imágenes',
      optimizing_cancelled: 'Optimización cancelada',
      optimizing_completed: 'Optimización completada',
      applying: 'Aplicando en Shopify',
      applying_cancelled: 'Aplicación cancelada',
      applying_completed: 'Aplicación completada',
      open_images: 'Abrir Imágenes',
      open_catalog: 'Abrir Catálogo',
      type_collections: 'Colecciones',
      type_articles: 'Artículos',
      type_pages: 'Páginas',
      type_contents: 'Contenidos',
      mode_publish: 'Publicación',
      mode_both: 'Generar+Publicar',
      mode_generate: 'Generación SEO AI',
      state_cancelled: '(cancelado)',
      state_completed: '(completado)',
    },
    app_banner: {
      expired: 'Token de Shopify expirado o revocado.',
      reconnect_desc: 'Reconecta la app para restaurar la sincronización y publicación.',
      detected_in: 'detectado en',
      reconnect_btn: 'Reconectar ahora',
    },
    review_popup: {
      greeting: '¡Hola! Estoy aquí 👋',
      subtitle: '¡Espero que todo vaya genial con AI Optimizer!',
      rating_title: '¿Te está gustando la app?',
      rating_desc: 'Tu opinión nos ayuda a mejorar y llegar a otros comerciantes de Shopify.',
      rating_tap: 'Toca una estrella para valorar',
      star: {
        terrible: 'Terrible',
        bad: 'No es bueno',
        average: 'Promedio',
        good: '¡Bueno!',
        excellent: '¡Excelente! 🚀',
      },
      positive_title: '¡Fantástico! Muchas gracias 🎉',
      positive_desc: '¡Solo tarda 1 minuto!',
      negative_title: 'Gracias por los comentarios 🙏',
      negative_desc: '¿Tienes ideas sobre qué podríamos mejorar?',
      review_btn: '⭐ Dejar una reseña',
      close_btn: 'Cerrar',
      dismiss: 'No mostrar más',
      skip: 'Omitir →',
    },
    support: {
      title: 'Soporte',
      send: 'Enviar',
      placeholder: 'Escribe tu mensaje...',
    },
    editor: {
      placeholder: 'Escribe aquí...',
      bold: 'Negrita',
      italic: 'Cursiva',
      underline: 'Subrayado',
      h2: 'Título H2',
      h3: 'Título H3',
      paragraph: 'Párrafo',
      ul: 'Lista de viñetas',
      ol: 'Lista numerada',
      blockquote: 'Cita',
      link: 'Insertar enlace',
      remove_format: 'Eliminar formato',
      link_prompt: 'URL del enlace',
    },
    recommendations: {
      empty: 'Sin acciones críticas por ahora. ¡Gran trabajo!',
      filter_all_prio: 'Todas las prioridades',
      filter_all_cat: 'Todas las categorías',
      count_shown: '{{n}} acciones mostradas',
      see: 'Ver',
      sev_high: 'Alta',
      sev_medium: 'Media',
      sev_low: 'Baja',
      cat_catalog: 'Catálogo',
      missing_meta_description: '{{count}} productos sin meta descripción',
      missing_description: '{{count}} productos sin descripción',
      missing_alt_text: '{{count}} imágenes sin texto ALT',
      missing_product_image: '{{count}} productos sin imagen',
    },
    audit: {
      not_detected: 'No detectado',
      disabled: 'Desactivado',
      not_scanned: 'Análisis no realizado',
      status_warning: 'Advertencia',
      status_error: 'Error',
      cat_performance: 'Rendimiento',
      cat_trust: 'Confianza',
      cat_catalog: 'Catálogo',
      checks_suffix: 'comprobaciones',
      badge_err: 'err',
      badge_warn: 'advert',
      badge_ok: 'ok',
      value_label: 'Valor',
      checks: {
        title: { name: 'Título', hint: 'Título de la página' },
        meta_description: { name: 'Meta descripción', hint: 'Meta descripción de la página principal' },
        h1: { name: 'H1', hint: 'Exactamente 1 H1 por página es óptimo' },
        h2: { name: 'H2', hint: 'Al menos un H2 recomendado' },
        canonical: { name: 'Canonical', hint: 'URL canónica' },
        lang: { name: 'Idioma', hint: 'Atributo de idioma' },
        json_ld_structured_data: { name: 'JSON-LD / Datos Estructurados', hint: 'Datos estructurados' },
        open_graph: { name: 'Open Graph', hint: 'Meta social' },
        twitter_card: { name: 'Twitter Card', hint: 'Meta Twitter/X' },
        robots_txt: { name: 'robots.txt', hint: 'Robots' },
        sitemap_xml: { name: 'Sitemap.xml', hint: 'Sitemap' },
        status_code: { name: 'Código de estado', hint: 'Código HTTP' },
        indexability: { name: 'Indexabilidad', hint: 'Indexabilidad' },
        redirects: { name: 'Redirecciones', hint: 'URL final' },
        https: { name: 'HTTPS', hint: 'HTTPS' },
        load_time: { name: 'Tiempo de carga', hint: 'Medido servidor a servidor' },
        page_weight: { name: 'Peso de la página', hint: 'Tamaño HTML de la página principal' },
        image_lazy_loading: { name: 'Carga diferida de imágenes', hint: 'Imágenes lazy' },
        mobile_viewport: { name: 'Viewport móvil', hint: 'Viewport móvil' },
        favicon: { name: 'Favicon', hint: 'Favicon' },
        images_with_alt: { name: 'Imágenes con ALT', hint: 'Accesibilidad de imágenes' },
        privacy_policy: { name: 'Política de privacidad', hint: 'Privacidad' },
        cookie_policy: { name: 'Política de cookies', hint: 'Cookie' },
        terms_conditions: { name: 'Términos y Condiciones', hint: 'Términos' },
        contact_page: { name: 'Página de contacto', hint: 'Contacto' },
        shipping_policy: { name: 'Política de envío', hint: 'Envíos' },
        returns_refunds: { name: 'Devoluciones y Reembolsos', hint: 'Devoluciones' },
        social_links: { name: 'Enlaces sociales', hint: 'Social' },
        products_without_description: { name: 'Productos sin descripción', hint: 'Descripciones de producto' },
        products_without_images: { name: 'Productos sin imágenes', hint: 'Imágenes de producto' },
        products_without_meta_description: { name: 'Productos sin meta descripción', hint: 'Meta descripciones de producto' },
        duplicate_titles: { name: 'Títulos duplicados', hint: 'Títulos de producto' },
        duplicate_meta_descriptions: { name: 'Meta descripciones duplicadas', hint: 'Meta descripciones de producto' },
        thin_content_200_char: { name: 'Contenido delgado (<200 car.)', hint: 'Contenido de producto' },
      },
    },
    score_card: {
      pillar_technical_seo: 'SEO Técnico',
      pillar_ux: 'UX',
      pillar_performance: 'Performance',
      pillar_trust: 'Trust',
      pillar_catalog: 'Catálogo',
      label_excellent: 'Excelente',
      label_good: 'Mejorable',
      label_critical: 'Crítico',
      no_audit_desc: 'Auditoría no ejecutada aún — ejecute la auditoría para obtener SEO Técnico, UX, Trust y Performance.',
      auditing: 'Auditoría en curso...',
      run_audit: 'Ejecutar Auditoría 360°',
      calculated_on: 'Calculado en',
    },
    upgrade: {
      popular: '⭐ Más Popular',
      period: '/mes',
      plan_header: 'Plan',
      cta: 'Actualizar a {{name}} — {{price}}{{period}}',
      dismiss: 'Ahora no',
      feature_available: '{{feature}} está disponible desde el plan {{plan}}.',
      reason_credits_title: 'Créditos AI agotados',
      reason_credits_body: 'Ha alcanzado el límite mensual de su plan. Actualice para continuar generando contenido.',
      reason_products_title: 'Límite de catálogo alcanzado',
      reason_products_body: 'Su catálogo de Shopify supera el límite del plan actual. Actualice para sincronizar todos los productos.',
      reason_feature_title: 'Funcionalidad Premium',
      reason_feature_body: 'Esta funcionalidad está disponible en planes superiores.',
    },
    gsc: {
      connect_title: 'Conectar Google Search Console',
      connect_desc: 'Monitorea impresiones, clics, CTR y posición media. Solicita reindexación tras optimizaciones IA.',
      connect_feat_analytics: 'Analíticas de búsqueda',
      connect_feat_indexing: 'Monitoreo de indexación',
      connect_feat_keywords: 'Seguimiento de keywords',
      connect_feat_sitemap: 'Gestor de sitemap',
      connect_btn_loading: 'Conectando...',
      connect_btn: 'Conectar cuenta Google',
      prop_modal_title: 'Seleccionar propiedad',
      prop_modal_desc: 'Elige la propiedad de Search Console a conectar.',
      prop_modal_empty: 'No se encontraron propiedades. Verifica que tienes propiedades en Google Search Console.',
      prop_modal_cancel: 'Cancelar',
      prop_modal_confirm: 'Confirmar',
      coming_soon_desc: 'Disponible en {{phase}}',
      top_opp_title: 'Top oportunidades SEO',
      top_opp_sub: 'Top 10 consultas por Opportunity Score',
      copy: 'Copiar',
      copied: '¡Copiado!',
      badge_quick_win: '🔥 Quick Win',
      badge_low_ctr: '⚡ CTR bajo',
      badge_page_1: '🚀 Página 1',
      badge_high_imp: '📈 Alta visibilidad',
      badge_brand: '🏷️ Brand',
      qt_category: 'Categoría',
      qt_product: 'Producto',
      qt_generic: 'Genérico',
      qt_info: 'Info',
      qt_brand: 'Brand',
      seo_analysis: 'Análisis SEO',
      generating_ai: 'Generando análisis IA...',
      analysis_error: 'Error al generar análisis. Inténtalo más tarde.',
      estimated_value: 'Valor estimado',
      clicks_monthly: 'Clics potenciales/mes',
      ctr_at_pos: 'CTR en pos. {{pos}}',
      traffic_increase: 'Incremento de tráfico',
      current_stats: 'Actual: {{clicks}} clics/mes · +{{pts}} pp CTR estimado',
      priority_action: 'Acción prioritaria',
      content_opt: 'Optimización de contenido',
      title_seo: 'Title SEO',
      title_chars: '(50–60 caracteres)',
      title_copied: '¡Title copiado!',
      h1_suggested: 'H1 sugerido',
      h1_page_title: '(título de página)',
      h1_copied: '¡H1 copiado!',
      meta_desc: 'Meta Description',
      meta_chars: '(150–160 caracteres)',
      meta_copied: '¡Meta copiada!',
      faq_all_copied: '¡Todas las FAQ copiadas!',
      faq_suggested: 'FAQ sugeridas',
      copy_all: 'Copiar todo',
      faq_copied: '¡FAQ copiada!',
      related_kw: 'Keywords relacionadas',
      click_to_copy: '· clic para copiar',
      kw_copied: '"{{kw}}" copiada!',
      tech_suggestions: 'Sugerencias técnicas',
      copy_keyword: 'Copiar keyword',
      kw_copied_plain: '¡Keyword copiada!',
      shopify_products: 'Productos Shopify',
      search_store: 'Buscar en la tienda',
      optimize_content: 'Optimizar contenido',
      col_impressions: 'Impresiones',
      col_position: 'Posición',
      no_queries: 'No se encontraron consultas con los filtros actuales.',
      ai_panel_title: 'Sugerencias IA',
      analyze_query: 'Analizar consulta →',
      sugg_title_improvement: 'Title tag',
      sugg_meta: 'Meta description',
      sugg_content_gap: 'Contenido faltante',
      sugg_schema: 'Schema markup',
      sugg_links: 'Enlaces internos',
      opp_load_err: 'Error al cargar oportunidades SEO',
      cache_updated: 'Caché actualizada — recargando datos',
      cache_error: 'Error al actualizar caché',
      loading_data: 'Cargando datos de Search Console...',
      load_error_title: 'No se pueden cargar las oportunidades',
      retry: 'Reintentar',
      tracked_queries: 'Consultas rastreadas',
      sku_excluded: '{{n}} SKU/EAN excluidas',
      total_impressions: 'Impresiones totales (28d)',
      total_clicks: 'Clics totales (28d)',
      avg_ctr: 'CTR promedio',
      ai_generating: 'Generando análisis IA...',
      ai_generating_sub: 'Las sugerencias IA aparecerán aquí en unos instantes.',
      no_ai_insights: 'No hay insights IA disponibles',
      no_ai_insights_sub: 'No se encontraron consultas con oportunidades de optimización significativas.',
      filter_all: 'Todas ({{n}})',
      search_placeholder: 'Buscar consultas...',
      refresh_title: 'Actualizar datos',
      page_prev: '← Ant.',
      page_info: 'Pág. {{page}} / {{total}} · {{count}} consultas',
      page_next: 'Sig. →',
      footer_note: 'Datos Search Console últimos 28 días · caché 6h · propiedad: {{url}}',
      footer_excluded: ' · {{n}} SKU/EAN excluidas',
      verdict_pass: 'Indexada',
      verdict_fail: 'No indexada',
      verdict_neutral: 'Excluida',
      stato_title: 'Estado Google — Fuentes de datos',
      in_sitemap: 'En sitemap',
      sitemap_registered_lbl: 'Sitemaps registrados',
      sitemap_errors_lbl: 'Errores de sitemap',
      with_impressions: 'Con impresiones',
      search_appear_note: 'Páginas aparecidas en búsqueda · {{days}}d',
      not_real_indexed: '≠ páginas realmente indexadas',
      index_estimate_lbl: 'Estimación de indexación',
      estimate_unavail: 'Estimación disponible tras 200 URL inspeccionadas. Inicia el escaneo por lotes para recoger la muestra.',
      inspected_lbl: 'Inspeccionadas',
      indexed_confirmed: 'Indexadas confirmadas',
      not_indexed_lbl: 'No indexadas',
      excluded_lbl: 'Excluidas',
      certain_data: 'Dato seguro para URL inspeccionadas',
      batch_title: 'Escaneo por lotes — Inspection API',
      batch_priority: 'Prioridad Analytics',
      batch_progress: 'Progreso de inspección del sitemap',
      batch_stopping: 'Deteniéndose…',
      batch_running: 'Escaneando…',
      batch_starting: 'Iniciando...',
      batch_done_lbl: 'Sitemap completado ✓',
      batch_start_btn: 'Iniciar escaneo ({{n}} disponibles)',
      batch_timeout: 'Timeout — clic para restablecer',
      batch_stopping_wait: 'Deteniéndose — por favor espera…',
      batch_stop_btn: 'Detener escaneo',
      batch_remaining: '{{n}} URL aún por inspeccionar',
      batch_quota_out: 'Cuota diaria agotada — reintentar mañana',
      batch_start_err: 'Error al iniciar el escaneo',
      batch_complete: 'Escaneo completo: {{n}} URL inspeccionadas',
      dq_title: 'Detalles técnicos API',
      dq_api_status: 'Estado API',
      dq_daily_quota: 'Cuota diaria',
      dq_used_today: 'Usadas hoy',
      dq_remaining: 'Restantes',
      dq_history: 'Historial de inspecciones',
      dq_completion: 'Completado',
      dq_days_est: 'días estimados',
      dq_start_for_eta: 'Iniciar escaneo para calcular ETA',
      sm_no_sitemap: 'No se encontró ningún sitemap',
      sm_no_sitemap_desc: 'Agrega un sitemap.xml a Google Search Console para monitorear la indexación.',
      sm_submit_ok: 'Sitemap enviado a Google',
      sm_in_progress: 'Calculando…',
      sm_submit_btn: 'Enviar',
      insp_title: 'Inspeccionar URL',
      insp_quota: '{{used}}/{{limit}} inspecciones hoy',
      insp_loading: 'Inspeccionando...',
      insp_btn: 'Inspeccionar',
      insp_domain_lbl: 'Dominio property:',
      insp_domain_note: 'La URL inspeccionada debe pertenecerle',
      insp_last_crawl: 'Último crawl',
      insp_indexing: 'Indexación',
      insp_yes: 'Sí',
      insp_no: 'No',
      insp_canonical_decl: 'Canonical declarado',
      insp_canonical_diff: '⚠ Canonical Google (diferente)',
      insp_noindex: 'noindex detectado',
      insp_open_gsc: 'Abrir en Search Console',
      insp_err: 'Error de inspección URL',
      cov_title: 'Coverage — Razones',
      cov_real_data: 'Datos reales — Inspection API',
      cov_conf_high: 'Alta confiabilidad',
      cov_conf_medium: 'Confiabilidad media',
      cov_conf_low: 'Baja confiabilidad',
      cov_updated: 'Actualizado:',
      cov_deselect: 'Deseleccionar',
      cov_inspected_note: 'URLs inspeccionadas · clic para filtrar',
      cov_none_inspected: 'Sin inspecciones',
      cov_no_data: 'No hay datos de coverage disponibles',
      cov_no_data_desc: 'Las razones de no indexación se crean automáticamente con cada inspección de URL. Usa "Iniciar escaneo automático" para rellenar esta sección.',
      cov_solution: 'Solución recomendada',
      cov_filter_active: 'Filtro activo en el historial',
      ih_worklist: 'Lista de tareas SEO',
      ih_history: 'Historial de inspecciones',
      ih_filter_coverage: 'Filtro Coverage',
      ih_tab_all: 'Todas',
      ih_tab_not_ind: 'No ind.',
      ih_tab_indexed: 'Indexadas',
      ih_tab_excluded: 'Excluidas',
      ih_tab_errors: 'Errores',
      ih_tab_with_imp: 'Con impr.',
      ih_tab_products: 'Productos',
      ih_tab_collections: 'Colecciones',
      ih_sort_priority: '↓ Prioridad',
      ih_sort_impressions: '↓ Impresiones',
      ih_sort_clicks_est: '↓ Clics est.',
      ih_sort_date: '↓ Fecha',
      ih_sort_state: '↓ Estado GSC',
      ih_clear: 'Borrar',
      ih_search: 'Buscar URL…',
      ih_open: 'Abrir',
      ih_indexing_state: 'Estado de indexación',
      ih_canonical_diff: '⚠ Canonical Google (elegido, diferente)',
      ih_canonical_same: 'Canonical Google (igual)',
      ih_ai_fix: 'Optimizar con AI →',
      ih_total: '{{n}} URL · {{total}} totales',
      ih_est_clicks: '· +{{n}} clics/mes estimados',
      iai_title: 'Sugerencias AI — Indexación',
      iai_filter_note: '· clic para filtrar',
      iai_prio_high: 'Alta prioridad',
      iai_prio_medium: 'Prioridad media',
      iai_prio_low: 'Baja prioridad',
      iai_causes: 'Posibles causas:',
      iai_actions: 'Acciones recomendadas:',
      fix_apply_all: 'Aplicar todo',
      fix_applied: 'Aplicado',
      fix_suggestion: 'Sugerencia',
      fix_chars: 'caracteres',
      fix_content_impr: 'Mejoras de contenido',
      fix_int_links: 'Links internos sugeridos',
      fix_open_url: 'Abrir URL',
      fix_close: 'Cerrar',
      fix_seo_opt: 'Optimización SEO',
      trend_title: 'Tendencia de indexación',
      trend_updated: 'Actualizado al',
      trend_coverage: 'Cobertura',
      trend_30d_kpi: 'Tendencia 30d',
      trend_no_data: 'Datos históricos en construcción',
      trend_no_data_desc: 'La tendencia estará disponible tras recopilar al menos 2 snapshots.',
      trend_one_snap: '1 snapshot recopilado de 2.',
      trend_start_scan: 'Inicia un escaneo por lotes para comenzar.',
      trend_ind: 'ind.',
      trend_not_ind: 'no ind.',
      trend_snap_note: 'Snapshot por escaneo',
      ic_loading: 'Cargando datos de indexación...',
      ic_load_err: 'No se pueden cargar los datos de indexación',
      ic_clear_confirm: '¿Borrar todo el historial de inspecciones?',
      ic_cleared: 'Historial borrado',
      ic_clear_err: 'Error al borrar',
      ic_seo_opp: 'Oportunidades SEO — Executive Summary',
      ic_recoverable: 'URLs recuperables',
      ic_open_worklist: '⚡ Abrir lista de tareas →',
      ic_view_all: 'Ver todas →',
      ic_crawled_ni: 'Rastreadas – no indexadas',
      ic_crawled_ni_note: 'Google las conoce pero no las sirve',
      ic_discovered_ni: 'Descubiertas – no indexadas',
      ic_discovered_ni_note: 'Encontradas pero nunca rastreadas',
      ic_with_imp_ni: 'Con impresiones GSC',
      ic_with_imp_ni_note: 'Tienen tráfico pero no están indexadas',
      ic_other_ni: 'Otras no indexadas',
      ic_other_ni_note: 'Desconocidas para Google o errores',
      ic_refresh: 'Actualizar',
      rh_title: 'Historial de cambios',
      rh_versions: 'versiones',
      rh_confirm: "¿Restaurar la versión del {{date}}?\n\nLos cambios actuales del editor serán reemplazados.",
      rh_restored_ok: 'v{{v}} restaurada en el tema Shopify',
      rh_restored_editor: 'Versión v{{v}} cargada en el editor — haz clic en Guardar para aplicarla',
      rh_restore_err: 'Error de restauración',
      rh_current: 'actual',
      rh_initial: 'Versión inicial',
      rh_no_diff: 'Sin cambios de texto',
      rh_more_added: '+ {{n}} más añadidas',
      rh_more_removed: '- {{n}} más eliminadas',
      rh_restore_btn: 'Restaurar',
      rb_load_err: 'Error al cargar robots.txt',
      rb_save_err: 'Error de guardado',
      rb_analyze_err: 'Error de análisis',
      rb_score_good: 'Excelente',
      rb_score_ok: 'Mejorable',
      rb_score_bad: 'Crítico',
      rb_analysis_title: 'Análisis SEO Robots',
      rb_analyzing: 'Analizando…',
      rb_analyze: 'Analizar',
      rb_analyze_hint: 'Haz clic en "Analizar" para detectar automáticamente problemas SEO y oportunidades de optimización',
      rb_no_issues: 'No se detectaron problemas',
      rb_no_issues_desc: 'Tu robots.txt sigue las mejores prácticas de Shopify',
      rb_critical: 'CRÍTICO',
      rb_warning: 'AVISO',
      rb_validation_title: 'Validación Robots.txt',
      rb_reload: 'Recargar',
      rb_editor_title: 'Editor Robots.txt',
      rb_modified: 'Modificado',
      rb_diff_close: 'Cerrar diff',
      rb_editor_restore: 'Restaurar',
      rb_saving: 'Guardando…',
      rb_save: 'Guardar',
      rb_blocking_warning: '🚨 ESTÁS BLOQUEANDO TODO EL SITIO — "Disallow: /" impide que Google indexe cualquier página',
      rb_diff_preview: 'Vista previa de cambios:',
      rb_opportunity: 'OPORTUNIDAD',
      rb_checker_title: 'Verificar URL',
      rb_check_btn: 'Verificar',
      rb_allowed: 'Permitido',
      rb_blocked: 'Bloqueado',
      rb_sitemaps_title: 'Sitemaps declarados',
      ll_history_title: 'Historial LLMs.txt',
      ll_generated: 'Generado',
      ll_restored_editor: 'Versión v{{v}} cargada en el editor — haz clic en Publicar para aplicarla',
      ll_load_err: 'Error al cargar llms.txt',
      ll_generate_err: 'Error de generación',
      ll_saved_ok: 'LLMs.txt publicado y verificado en el tema Shopify',
      ll_not_configured: 'No configurado',
      ll_validation_title: 'Validación LLMs.txt',
      ll_not_found: 'No se encontró llms.txt en el sitio. Usa "Generar desde Shopify" para crearlo automáticamente.',
      ll_what_title: '¿Qué es LLMs.txt?',
      ll_what_desc: 'El estándar /llms.txt es un archivo markdown que ayuda a los modelos AI (ChatGPT, Claude, Perplexity, Gemini) a entender tu sitio y citarlo correctamente en las respuestas. Aumenta la visibilidad en los motores de respuesta AI.',
      ll_editor_title: 'Editor LLMs.txt',
      ll_generating: 'Generando…',
      ll_generate_btn: 'Generar desde Shopify',
      tab_jsonld: 'JSON-LD',
      jl_load_err: 'Error al cargar el resumen JSON-LD',
      jl_sec_overview: 'Resumen',
      jl_sec_schemas: 'Esquemas',
      jl_sec_problems: 'Problemas',
      jl_sec_generate: 'Optimización IA',
      jl_sec_preview: 'Vista previa JSON',
      jl_sec_validate: 'Validación',
      jl_sec_bulk: 'Operaciones masivas',
      jl_sec_stats: 'Estadísticas',
      jl_rich_results: 'Elegibilidad Rich Results',
      jl_eligible: 'Elegibles',
      jl_warnings: 'Parciales',
      jl_not_eligible: 'No elegibles',
      jl_field_coverage: 'Cobertura de campos',
      jl_what_title: '¿Qué es JSON-LD?',
      jl_what_desc: 'JSON-LD es el formato recomendado por Google para datos estructurados. Permite Rich Results en la búsqueda (estrellas, precios, breadcrumbs) y ayuda a los modelos IA a comprender mejor tus productos.',
      jl_score_poor: 'Cobertura deficiente',
      jl_schemas_title: 'Tipos de esquema soportados',
      jl_status_valid: 'Válido',
      jl_status_partial: 'Parcial',
      jl_status_missing: 'No configurado',
      jl_valid_items: 'válidos',
      jl_issues: 'problemas',
      jl_google_test: 'Probar en Google Rich Results',
      jl_google_test_desc: 'Después de generar tu JSON-LD, pruébalo directamente en la herramienta de Google para verificar la elegibilidad.',
      jl_problems_title: 'Problemas de diagnóstico',
      jl_no_problems: '¡No se encontraron problemas críticos. Tu cobertura JSON-LD está bien!',
      jl_products_affected: 'productos afectados',
      jl_sev_critical: 'Crítico',
      jl_sev_warning: 'Advertencia',
      jl_prob_brand: 'Marca / proveedor faltante',
      jl_prob_desc: 'Descripción faltante',
      jl_prob_image: 'Imagen de producto faltante',
      jl_prob_sku: 'SKU faltante',
      jl_prob_gtin: 'GTIN / código de barras faltante',
      jl_prob_meta: 'Meta descripción faltante',
      jl_prob_offers: 'Precio no en JSON-LD (requiere snippet en el tema Shopify)',
      jl_problems_tip: 'Corrige los campos faltantes en la sección Productos o usa la Optimización IA para completarlos automáticamente.',
      jl_gen_title: 'Generar JSON-LD',
      jl_schema_type: 'Tipo de esquema',
      jl_product_id: 'ID de producto (dejar vacío para ejemplo)',
      jl_use_ai: 'Usar enriquecimiento IA (GPT)',
      jl_gen_btn: 'Generar JSON-LD',
      jl_gen_ok: 'JSON-LD generado',
      jl_gen_err: 'Error de generación',
      jl_copied: '¡Copiado!',
      jl_copy: 'Copiar',
      jl_preview_title: 'Vista previa JSON-LD',
      jl_preview_err: 'Error al cargar vista previa',
      jl_load_preview: 'Cargar producto de ejemplo',
      jl_preview_empty: 'Haz clic en "Cargar producto de ejemplo" para previsualizar todos los esquemas JSON-LD',
      jl_val_title: 'Validación de esquema local',
      jl_invalid_json: 'JSON inválido',
      jl_val_btn: 'Validar JSON-LD',
      jl_val_clear: 'Limpiar',
      jl_val_ok: 'Válido — elegible para Rich Results',
      jl_val_fail: 'Validación fallida',
      jl_val_note: 'Este validador comprueba los requisitos de schema.org. Para el test oficial de Google usa el Rich Results Test.',
      jl_val_err: 'Error de validación',
      jl_bulk_title: 'Operaciones masivas',
      jl_bulk_gen: 'Generar todo',
      jl_bulk_gen_desc: 'Construir Product JSON-LD para cada producto y guardar en DB',
      jl_bulk_val: 'Validar todo',
      jl_bulk_val_desc: 'Ejecutar validación schema.org en JSON-LD existente',
      jl_bulk_fix: 'Corregir y enriquecer',
      jl_bulk_fix_desc: 'Reconstruir JSON-LD para productos con errores',
      jl_bulk_started: 'Operación masiva iniciada',
      jl_bulk_err: 'Error al iniciar operación masiva',
      jl_bulk_running: 'En progreso',
      jl_bulk_done: 'Completado',
      jl_bulk_stop: 'Detener',
      jl_bulk_stopped: 'Operación masiva detenida',
      jl_errors: 'errores',
      jl_stat_total: 'Productos totales',
      jl_stat_eligible: 'Elegibles Rich Results',
      jl_stat_gen_today: 'Generados hoy',
      jl_stat_fixed: 'Corregidos hoy',
      jl_coverage_by_type: 'Cobertura por tipo de contenido',
      jl_type: 'Tipo',
      jl_total: 'Total',
      jl_valid2: 'Válidos',
      jl_missing2: 'Faltantes',

      ll_revert: 'Deshacer',
      ll_publishing: 'Publicando…',
      ll_publish: 'Publicar',
      lp_filter_url: 'Filtrar URL…',
      lp_copied: 'Copiado',
      lp_broken_empty: 'No se detectaron enlaces rotos',
      lp_broken_empty_sub: 'Todas las URLs de la tienda son accesibles (404 / 410 / timeout)',
      lp_timeout: 'Timeout — sin respuesta en 12s',
      lp_ratelimit_empty: 'No se detectó limitación de velocidad',
      lp_ratelimit_empty_sub: 'El servidor no limitó las solicitudes del escáner',
      lp_ratelimit_note: 'Página accesible pero el servidor respondió 429 durante el escaneo',
      lp_server_empty: 'No se detectaron errores de servidor',
      lp_server_empty_sub: 'Todas las URLs responden correctamente (sin 5xx)',
      lp_server_note: 'HTTP {{code}} — error del lado del servidor',
      lp_redirect_empty: 'No se detectaron redirecciones',
      lp_redirect_total: 'Redirecciones totales',
      lp_chains: 'Cadenas (>1 salto)',
      lp_loops: 'Bucles detectados',
      lp_chains_header: 'Cadenas de redirección',
      lp_chains_badge: '{{n}} cadenas múltiples',
      lp_final_status: 'Estado final:',
      lp_canon_ok: 'Correcto',
      lp_canon_miss: 'Faltante',
      lp_canon_wrong: 'URL incorrecta',
      lp_canon_cross: 'Cross-domain',
      lp_canon_redir: 'Canonical→redirección',
      lp_canon_action_missing: 'Agregar una etiqueta canonical en la sección head de la página.',
      lp_canon_action_wrong: 'Corregir el canonical para que apunte a la URL definitiva de esta página.',
      lp_canon_action_cross: 'El canonical apunta a un dominio externo. Verificar si es intencional o un error.',
      lp_canon_action_redir: 'El canonical apunta a una URL que redirige. Actualizar con el destino final del redirect.',
      lp_canon_no_data: 'Datos canonical no disponibles — iniciar el análisis',
      lp_canon_issues: 'Problemas Canonical ({{n}})',
      lp_canon_no_issues: 'Ningún problema canonical detectado',
      lp_canon_sample: 'Muestra analizada: {{n}} URL de tu tienda (productos, colecciones, páginas, artículos)',
      il_tab_orphans: 'Páginas huérfanas',
      il_tab_weak: 'Enlaces débiles',
      il_tab_deep: 'Páginas profundas',
      il_kpi_weak: 'Enlaces débiles ≤2',
      il_kpi_deep: 'Págs. profundas',
      il_orphan_empty: 'Sin páginas huérfanas',
      il_orphan_empty_sub: 'Todas las páginas reciben al menos un enlace interno',
      il_orphan_header: 'Páginas sin enlaces entrantes ({{n}})',
      il_weak_empty: 'Sin páginas con enlaces débiles',
      il_weak_empty_sub: 'Todas las páginas reciben 3+ enlaces internos',
      il_weak_header: 'Páginas con 1–2 enlaces entrantes ({{n}})',
      il_anchor_empty: 'Textos ancla optimizados',
      il_anchor_empty_sub: 'No se detectaron anclas genéricas, vacías o duplicadas',
      il_anchor_generic: 'Anclas genéricas',
      il_anchor_generic_desc: 'Textos como "haz clic aquí", "aquí", "descubrir"',
      il_anchor_empty_type: 'Anclas vacías',
      il_anchor_empty_desc: 'Enlaces sin texto descriptivo',
      il_anchor_dup: 'Anclas duplicadas',
      il_anchor_dup_desc: 'Mismo texto → URLs diferentes',
      il_anchor_lbl_gen: 'Genérico',
      il_anchor_lbl_empty: 'Vacío',
      il_anchor_lbl_dup: 'Duplicado',
      il_deep_empty: 'Sin páginas demasiado profundas',
      il_deep_empty_sub: 'Todas las páginas son accesibles en ≤3 clics desde la página principal',
      il_deep_header: 'Páginas a >3 clics de la página principal ({{n}})',
      il_deep_note: 'Las páginas con ∞ no son accesibles mediante enlaces internos. Agregarlas a menús o colecciones.',
      il_hub_empty: 'Sin datos hub disponibles',
      il_hub_empty_sub: 'Iniciar un análisis para identificar páginas hub',
      il_hub_header: 'Páginas hub — las más enlazadas internamente',
      il_hub_count: '{{n}} enlaces internos entrantes',
      lm_active: 'Activo',
      lm_not_installed: 'No instalado',
      lm_install_hint: 'Instalar en el tema para monitorear la navegación real sin crawling',
      lm_refresh: 'Actualizar',
      lm_clear: 'Borrar datos',
      lm_remove: 'Eliminar del tema',
      lm_installing: 'Instalando…',
      lm_install: 'Instalar en el tema',
      lm_tab_404: 'Errores 404',
      lm_tab_redirect: 'Oport. Redirección',
      lm_tab_top: 'Páginas principales',
      lm_kpi_visits: 'Visitas totales',
      lm_kpi_404s: 'Errores 404 reales',
      lm_no_404: 'No se detectaron errores 404 por usuarios',
      lm_visits: 'visitas',
      lm_theme_prefix: 'Tema: ',
      lm_last_activity: 'Última actividad: ',
      lm_no_activity: 'sin visitas aún',
      lm_installed: 'Monitor instalado en el tema "{{name}}"',
      lm_err_install: 'Error de instalación',
      lm_confirm_remove: '¿Eliminar el script de monitoreo del tema activo?',
      lm_removed: 'Script eliminado del tema',
      lm_err_remove: 'Error de eliminación',
      lm_confirm_clear: '¿Eliminar todos los datos de monitoreo recopilados?',
      lm_cleared: 'Datos eliminados',
      lm_err_clear: 'Error al eliminar',
      lm_modal_title: 'Crear Redirección 301',
      lm_modal_source: 'URL de origen (404)',
      lm_modal_dest: 'Destino',
      lm_redirect_created: 'Redirección 301 creada en Shopify',
      lm_err_redirect: 'Error al crear la redirección',
      lm_create_redirect: 'Crear Redirección',
      lm_creating: 'Creando…',
      lm_cancel: 'Cancelar',
      lm_info_title: 'Cómo funciona el Live Monitor',
      lm_info_1: 'El botón "Instalar en el tema" agrega automáticamente un script ligero al tema activo via la API de Shopify Themes',
      lm_info_2: 'Por cada visita real recopila: URL, tipo de página, enlaces internos, errores 404, referente interno',
      lm_info_3: 'Cero crawling — sin HTTP 429 — datos de visitantes reales en tiempo real',
      lm_info_4: 'Construye progresivamente el mapa de enlaces internos y detecta páginas huérfanas',
      lm_no_redirect: 'No se necesita redirección',
      lm_no_redirect_hint1: 'El Live Monitor aún no ha registrado visitas. Las oportunidades de redirección aparecen cuando usuarios reales encuentran páginas 404.',
      lm_no_redirect_hint2: 'En {{n}} visitas analizadas ningún usuario encontró páginas 404. ¡Excelente!',
      lm_toolbar_ai: '{{count}} URL · {{ai}} con sugerencia IA',
      lm_toolbar_ignored: '· {{n}} ignorados',
      lm_sort_visits: 'Visitas',
      lm_sort_date: 'Fecha',
      lm_selected: '{{n}} seleccionado(s)',
      lm_no_match: 'sin coincidencia automática',
      lm_create: 'Crear',
      lm_ignore: 'Ignorar',
      lm_err: 'Error',
      lm_bulk_ignored: '{{n}} URL ignorada(s)',
      lm_bulk_created: '{{n}} redirecciones creadas',
      lm_errors: 'errores',
      ls_scan_started: 'Análisis iniciado — se completará en segundo plano',
      ls_scan_err: 'Error al iniciar el análisis',
      ls_last_scan: 'Último análisis: {{date}} · {{n}} URL',
      ls_no_scan_desc: 'Ningún análisis realizado — detecta enlaces rotos, redirecciones, canónicos, páginas huérfanas',
      ls_scanning: 'Analizando…',
      ls_rescan: 'Reanalizar',
      ls_start_scan: 'Iniciar análisis',
      ls_canonical_issues: 'Problemas Canónicos',
      ls_scan_details: 'Detalles del análisis',
      ls_stat_total: 'URLs totales',
      ls_stat_errors: 'Errores',
      ls_no_scan: 'Ningún análisis realizado',
      ls_no_scan_long: 'Inicia el análisis para detectar enlaces rotos, cadenas de redirección, problemas canónicos y páginas huérfanas sin enlaces entrantes',
      ls_first_scan: 'Iniciar primer análisis',
      db_gsc_connected: '¡Google Search Console conectada!',
      db_gsc_err: 'Error de conexión GSC: {{code}}',
      db_props_err: 'No se pudieron cargar las propiedades GSC',
      db_oauth_hint: 'Complete la autorización de Google en la nueva pestaña. La página se actualizará automáticamente.',
      db_conn_err: 'Error de conexión GSC',
      db_prop_selected: 'Propiedad seleccionada: {{url}}',
      db_prop_err: 'Error al seleccionar propiedad',
      db_confirm_disconnect: '¿Desconectar Google Search Console?',
      db_disconnected: 'GSC desconectada',
      db_disconnect_err: 'Error de desconexión',
      db_connected: 'Search Console conectada',
      db_no_property: 'Ninguna propiedad seleccionada',
      db_not_connected: 'No conectada',
      db_connect_hint: 'Conecta GSC para desbloquear análisis y monitoreo',
      db_change_prop: 'Cambiar propiedad',
      db_disconnect: 'Desconectar',
      db_connect: 'Conectar GSC',
      db_idx_subtitle: 'Calidad técnica SEO & indexación',
      db_lbl_gsc: 'GSC conectada',
      db_lbl_sitemap: 'Sitemaps enviados',
      db_lbl_indexed: 'URLs indexadas',
      db_health_real: 'Basado en datos reales de Search Console',
      db_health_proxy: 'Basado en calidad del catálogo — conecta GSC para datos reales',
      db_lbl_position: 'Posición',
      db_lbl_trend: 'Tendencia 28d',
      db_lbl_errors: 'Errores',
      db_connect_score: 'Conecta GSC para calcular el score',
      db_proxy_note: 'Proxy catálogo',
      db_stat_excluded: 'URLs excluidas',
      db_stat_seo_score: 'Score SEO promedio',
      db_catalog_title: 'Salud del catálogo',
      db_cat_alt: 'Texto ALT de imágenes',
      db_cat_keywords: 'Keywords ausentes',
      db_cat_no_kw: '{{n}} productos sin keywords',
      db_cat_count: '{{n}} / {{total}} productos',
      tab_opportunities: 'Oportunidades SEO',
      tab_indexing: 'Indexación',
      locked_available: 'Disponible desde el plan {{plan}}',
      locked_upgrade: 'Cambiar al plan {{plan}}',
      main_subtitle: 'SEO técnico · Indexación · Analytics · Automatización IA',
      phase_3: 'Fase 3',
      interval_all: 'Todo',
      click_monthly_est: 'clics/mes est.',
      fix_title_updated: 'Etiqueta de titulo actualizada',
      fix_meta_updated: 'Meta descripcion actualizada',
      fix_both_updated: 'Titulo y meta descripcion actualizados en Shopify',
      fix_apply_err: 'Error de aplicacion',
      rb_save_ok: 'Robots.txt guardado y verificado en el tema de Shopify',
      rb_draft_with_err: 'Borrador guardado ({{err}})',
      rb_draft_manual: 'Borrador guardado — sigue las instrucciones para aplicarlo al tema',
      rb_critical_confirm: '🚨 ADVERTENCIA CRITICA 🚨\n\nTu robots.txt contiene "Disallow: /" que BLOQUEA COMPLETAMENTE el sitio:\nGoogle, Bing y todos los bots no podran rastrear ninguna pagina.\n\nEsto puede causar la eliminacion del sitio de los resultados de busqueda.\n\nEstas ABSOLUTAMENTE SEGURO de que deseas continuar?',
      scan_err: 'Error de escaneo: {{msg}}',
      sm_send_err: 'Error de envio',
      unknown_err: 'Desconocido',
      dq_today: 'Hoy',
      dq_7d: 'Últimos 7 días',
      dq_30d: 'Últimos 30 días',
      dq_daily_avg: 'Promedio diario',
      dq_at_pace: 'a un ritmo de ~{{n}}/día',
      job_stopped: 'Detenido en {{n}} URLs procesadas',
      job_inspected: '{{n}} inspeccionadas',
      job_errors: 'errores',
      quota_remaining: 'Cuota restante:',
      lk_trend: 'Tendencia de indexación',
      lk_batch: 'Inspección por lotes (análisis masivo)',
      lk_ai: 'Sugerencias IA de indexación',
      footer_apis: 'Sitemaps API + Search Analytics + Inspection API',
      prod_status_lbl: 'Estado:',
      prod_desc_lbl: 'Descripción:',
      prod_missing: 'AUSENTE',
      state_disc: 'Desc.',
      state_crawl: 'Rastreada',
      insp_api_real: 'Inspection API ✓ real',
      sm_count: '{{n}} sitemaps',
      sm_reliability: 'Fiabilidad:',
      conf_high: 'Alta',
      conf_medium: 'Media',
      conf_low: 'Baja',
      sm_urls: 'URLs en el sitemap',
      sm_sample: 'Muestra',
      sm_est_indexed: 'Indexadas estim.',
      sm_est_nonidx: 'No indexadas estim.',
      sm_coverage: 'Cobertura estim. ⓘ',
      sm_idx_of: '~{{n}} indexadas de {{t}} URLs del sitemap',
      sm_cov_est: 'Cobertura estimada:',
      sm_margin_err: 'margen de error',
      sm_indexed_of: 'indexadas de',
      sm_sampled: 'muestreadas',
      sm_th_sitemap: 'Sitemap',
      sm_th_submitted: 'Enviadas',
      sm_th_indexed: 'Indexadas',
      sm_th_gap: 'Brecha',
      sm_th_coverage: 'Cobertura',
      sm_th_warning: 'Advertencia',
      sm_th_errors: 'Errores',
      sm_th_lastmod: 'Última actualización',
      sm_th_actions: 'Acciones',
      rb_verified_result: 'Guardado y verificado en el tema Shopify ({{theme}}) — archivo:',
      rb_draft_result: 'Borrador guardado. Para aplicar manualmente: Shopify Admin → Temas → Editar código →',
      ll_draft_result: 'Borrador guardado. Para aplicar manualmente: Shopify Admin → Temas → Editar código →',
      ls_section_redirects: 'Gestor de redirecciones',
      rm_tab: 'Gestor de redirecciones',
      rm_subtitle: 'Gestiona todas las redirecciones de tu tienda en un solo lugar.',
      rm_kpi_total: 'Reglas totales',
      rm_kpi_active: 'Redireccionamentos activos',
      rm_kpi_pending: '404 pendientes',
      rm_kpi_hits: 'Hits (30d)',
      rm_kpi_chains: 'Cadenas',
      rm_kpi_loops: 'Bucles',
      rm_section_rules: 'Reglas',
      rm_section_suggest: 'Sugerencias IA',
      rm_section_health: 'Salud',
      rm_section_import: 'Importar / Exportar',
      rm_section_history: 'Historial',
      rm_create_title: 'Crear redirección',
      rm_edit_title: 'Editar redirección',
      rm_old_url: 'URL antigua',
      rm_new_url: 'URL nueva',
      rm_old_url_ph: '/ruta-antigua',
      rm_new_url_ph: '/ruta-nueva',
      rm_type: 'Tipo',
      rm_type_301: '301 – Permanente',
      rm_type_302: '302 – Temporal',
      rm_notes: 'Notas',
      rm_save: 'Guardar',
      rm_cancel: 'Cancelar',
      rm_create_ok: 'Redirección creada correctamente.',
      rm_edit_ok: 'Redirección actualizada correctamente.',
      rm_create_err: 'Error al crear la redirección.',
      rm_edit_err: 'Error al guardar la redirección.',
      rm_dup_err: 'Ya existe una redirección para esta URL de origen.',
      rm_empty_err: 'Las URL de origen y destino son obligatorias.',
      rm_same_err: 'La URL de origen y destino no pueden ser iguales.',
      rm_search_ph: 'Buscar URL…',
      rm_filter_all: 'Todas',
      rm_filter_active: 'Activas',
      rm_filter_disabled: 'Desactivadas',
      rm_create_btn: 'Crear redirección',
      rm_selected_items: '{{count}} seleccionados',
      rm_bulk_enable: 'Activar',
      rm_bulk_disable: 'Desactivar',
      rm_bulk_delete: 'Eliminar',
      rm_bulk_export: 'Exportar CSV',
      rm_bulk_ok: 'Operación completada.',
      rm_table_old: 'URL antigua',
      rm_table_new: 'URL nueva',
      rm_table_type: 'Tipo',
      rm_table_hits: 'Hits',
      rm_table_status: 'Estado',
      rm_table_actions: 'Acciones',
      rm_edit: 'Editar',
      rm_duplicate: 'Duplicar',
      rm_delete: 'Eliminar',
      rm_delete_confirm: '¿Eliminar esta redirección?',
      rm_deleted_ok: 'Redirección eliminada.',
      rm_delete_err: 'Error al eliminar.',
      rm_status_active: 'Activa',
      rm_status_disabled: 'Desactivada',
      rm_no_data: 'No se encontraron redirecciones.',
      rm_empty_state: 'Sin redirecciones aún. Crea la primera.',
      rm_total_redirects: '{{count}} redirecciones en total',
      rm_import_title: 'Importar redirecciones',
      rm_import_csv: 'CSV (old_url,new_url,type)',
      rm_import_shopify: 'Shopify Export CSV',
      rm_import_sf: 'Screaming Frog CSV',
      rm_import_btn: 'Importar',
      rm_import_ok: 'Importación completada.',
      rm_import_err: 'Error durante la importación.',
      rm_import_imported: '{{count}} importados',
      rm_import_skipped: '{{count}} omitidos',
      rm_export_title: 'Exportar redirecciones',
      rm_export_desc: 'Descarga todas las redirecciones en los formatos disponibles.',
      rm_export_csv: 'Exportar CSV',
      rm_export_json: 'Exportar JSON',
      rm_ai_title: 'Sugerencias IA',
      rm_ai_subtitle: 'La IA detectó URLs con 404 y sugiere redirecciones a productos similares.',
      rm_ai_accept: 'Aceptar',
      rm_ai_reject: 'Rechazar',
      rm_ai_accept_all: 'Aceptar todas',
      rm_ai_loading: 'Analizando…',
      rm_ai_empty: 'No hay sugerencias disponibles en este momento.',
      rm_chains_title: 'Cadenas de redirección',
      rm_chains_desc: 'Varias redirecciones encadenadas ralentizan el sitio. Corrígelas ahora.',
      rm_chains_fix: 'Corregir cadena',
      rm_chains_empty: 'No se detectaron cadenas.',
      rm_chains_fixed: 'Cadena corregida.',
      rm_loops_title: 'Bucles de redirección',
      rm_loops_desc: 'Bucles circulares que causan errores. Requieren corrección manual.',
      rm_loops_fix: 'Corregir',
      rm_loops_empty: 'No se detectaron bucles.',
      rm_gsc_title: '404 de Google Search Console',
      rm_gsc_subtitle: 'URLs no encontradas detectadas por GSC en los últimos 90 días.',
      rm_gsc_empty: 'No se detectaron 404 de GSC.',
      rm_history_title: 'Historial de actividad',
      rm_history_created: 'Creado',
      rm_history_edited: 'Editado',
      rm_history_deleted: 'Eliminado',
      rm_history_disabled: 'Desactivado',
      rm_history_enabled: 'Activado',
      rm_history_imported: 'Importado',
      rm_history_bulk: 'Operación masiva',
      rm_history_empty: 'No hay actividad registrada.',
      rm_sync_shopify: 'Sincronizar desde Shopify',
      rm_sync_shopify_desc: 'Importar todas las redirecciones URL de Shopify. Las nuevas redirecciones se envían automáticamente a Shopify.',
      rm_sync_btn: 'Sincronizar ahora',
      error_label: 'Error:',
      rb_checker_desc: 'Comprueba si una URL está permitida o bloqueada por {{bot}} según el robots.txt actual.',
      rb_rule: 'Regla:',
      rb_fix: 'Corregir:',
      rb_gsc_note_title: 'Integración Search Console',
      rb_gsc_note_body: 'En la sección Indexación, las URLs con estado "Bloqueada por robots" indican páginas que Google no puede rastrear.',
      rb_issues: 'problemas',
      rb_opps: 'oportunidades',
      rb_savings: 'Ahorro estimado:',
      never: 'Nunca',
      samples_conf: '{{n}} muestras · confianza {{c}}',
      batch_priority_note: 'URLs con impresiones de Analytics inspeccionadas primero · cuota GSC 2.000/día · procesamiento en segundo plano',
      sm_samples: 'muestras',
      sm_footnote_ec: '~ Valores "En cálculo" = estimación de Inspection API ({{n}} muestras · confianza {{c}}). Sitemaps API devuelve 0 para índices de sitemap.',
      sm_footnote_noec: '~ Valores "En cálculo" = estimación proporcional. Inicia el análisis por lotes. Sitemaps API devuelve 0 para índices de sitemap.',
      ic_quota_note: 'Calculado sobre {{n}} URLs inspeccionadas vía Inspection API (cuota 2.000/día). GSC Coverage muestra {{m}} URLs no indexadas en el sitemap.',
      cov_crawled_ni: 'Contenido de baja calidad o duplicado. Mejorar el contenido, agregar texto único, verificar la etiqueta canonical.',
      cov_disc_ni: 'Google la encontró pero aún no la rastreó. Aumentar el presupuesto de rastreo con enlaces internos adicionales y sitemap actualizado.',
      cov_dup_nocanon: 'Agregar etiqueta canonical que apunte a la página principal.',
      cov_dup_googcanon: 'Google ignora el canonical declarado. Verificar coherencia de URL y canonical entre versiones de escritorio/móvil.',
      cov_redirect: 'Redirección activa. Si es intencional, actualizar los enlaces internos para apuntar directamente al destino.',
      cov_alternate: 'Página alternativa con canonical correcto — no se requiere acción si es intencional.',
      cov_noindex: 'Eliminar la metaetiqueta noindex si deseas que la página sea indexada.',
      cov_robots: 'Página bloqueada por robots.txt. Verificar las directivas Disallow y actualizar si es necesario.',
      cov_removed: 'Eliminada manualmente de GSC. Revocar la eliminación en el panel de Search Console si se desea.',
      cov_404: 'Página no encontrada. Restaurar la página, configurar una redirección 301 o eliminar los enlaces internos a esta URL.',
      cov_soft404: 'El servidor devuelve 200 pero Google la trata como una página vacía. Asegurarse de que la página tenga contenido relevante.',
      cov_server_err: 'Error del servidor. Verificar los registros del servidor y la disponibilidad del hosting durante el rastreo.',
      cov_unknown_url: 'Google aún no ha descubierto esta URL. Agregar enlaces internos, actualizar el sitemap y esperar el próximo rastreo.',
      qt_brand: 'Marca',
      qt_info: 'Info',
      qt_category: 'Categoría',
      qt_product: 'Producto',
      qt_generic: 'Genérico',
      sugg_title_improvement: 'Etiqueta de título',
      sugg_meta: 'Meta descripción',
      sugg_content_gap: 'Contenido faltante',
      sugg_schema: 'Marcado de schema',
      sugg_links: 'Links internos',
      verdict_indexed: 'Indexado',
      verdict_not_indexed: 'No indexado',
      verdict_excluded: 'Excluido',
      badge_col_header: 'Insignia',
      sitemap_label: 'Mapa del sitio',
      ls_tab_broken: 'Links rotos',
      ls_tab_redirect: 'Redirección',
      ls_tab_rate_limited: 'Límite de tasa',
      ls_tab_server_errors: 'Errores de servidor',
      ls_tab_canonical: 'Canónico',
      ls_tab_internal: 'Links internos',
      ls_section_monitor: 'Monitor en vivo',
      ls_section_audit: 'Estructura del sitio',
      db_idx_title: 'Puntuación de indexación',
      db_health_title: 'Puntuación de salud SC',
      canonical_mismatch: 'Discrepancia canónica',
    },
    so: {
      load_err: 'Error al cargar Speed Optimizer',
      analyze_timeout: 'Tiempo de análisis agotado (90s) — por favor reintenta',
      analyze_done: '¡Análisis completado!',
      analyze_failed: 'Análisis fallido: {{error}}',
      rate_limited: 'Límite de solicitudes alcanzado — datos actualizados desde caché',
      analyze_err: 'Error de análisis',
      opt_enabled: '{{label}} activado en el tema',
      opt_disabled: '{{label}} desactivado',
      opt_err: 'Error de optimización',
      scan_err: 'Error de escaneo del tema',
      img_err: 'Error de análisis de imágenes',
      sg_protected: 'Safety Guard: Protected activado',
      sg_standard: 'Safety Guard: Standard activado',
      mode_err: 'Error al cambiar modo',
      plan_err: 'Error al generar plan',
      strategy_applied: 'Estrategia {{label}} aplicada al tema',
      strategy_err: 'Error al aplicar estrategia',
      sessions_err: 'Error al cargar sesiones',
      rollback_done: 'Rollback completado — tema restaurado',
      rollback_err: 'Error de rollback',
      subtitle: 'Optimizaciones seguras del tema Shopify con rollback instantáneo.',
      btn_rollback: 'Revertir todo',
      btn_analyze: 'Analizar ahora',
      analyzing_psi: 'Procesando PSI…',
      analyzing_queue: 'En cola…',
      analyzing: 'Analizando…',
      alert_no_token: 'Token de Shopify faltante — las optimizaciones requieren una conexión activa al store.',
      alert_no_scope: 'Permisos de tema faltantes — para aplicar optimizaciones debes reinstalar la app.',
      perf_empty: 'No hay análisis disponible',
      perf_empty_hint: 'Haz clic en "Analizar ahora" para medir el rendimiento de tu store',
      suggestions: 'Sugerencias',
      strategy_active: 'activa',
      strategy_subtitle: 'Define el objetivo de optimización. Haz clic para ver el plan antes de aplicar.',
      sg_header: 'Limita qué operaciones puede ejecutar la estrategia.',
      sg_desc_protected: 'Bloquea operaciones Standard — solo optimizaciones seguras.',
      sg_desc_standard: 'Permite la ejecución completa de la estrategia seleccionada.',
      quick_opts: 'Optimizaciones rápidas',
      sg_warning: 'Safety Guard: Protected — las operaciones Standard están bloqueadas. Cambia a Standard arriba.',
      lcp_section: 'Escaneo de tema LCP',
      hist_section: 'Historial de optimizaciones',
      hist_empty: 'Ninguna optimización aplicada aún.',
      sessions_section: 'Sesiones & Impacto Lighthouse',
      sessions_empty: 'Carga sesiones para ver el impacto real en Core Web Vitals.',
      img_count: '{{n}} imágenes · {{kb}} KB totales',
      img_oversized: '{{n}} imágenes >300KB',
      img_no_oversized: '¡Sin imágenes sobredimensionadas — excelente!',
      img_empty: 'Haz clic en "Analizar imágenes" para encontrar imágenes >300KB en el tema.',
      btn_refresh: 'Recargar',
      btn_load_sessions: 'Cargar sesiones',
      btn_refresh_sessions: 'Actualizar',
      btn_analyze_img: 'Analizar imágenes',
      btn_refresh_img: 'Actualizar',
      modal_risk_safe: 'Seguro — sin impacto visual esperado',
      modal_risk_medium: 'Verifica la apariencia del sitio tras la activación',
      modal_risk_high: 'Puede afectar funcionalidades avanzadas',
      modal_reversible: 'Reversible en cualquier momento — usa "Revertir todo" para restaurar el tema original.',
      modal_cancel: 'Cancelar',
      modal_enable: 'Activar ahora',
      opt_no_token: 'Reconecta el store Shopify para usar esta función',
      opt_blocked_guard: 'Bloqueado por Safety Guard (Protected) — cambia a Standard para habilitar',
      opt_reversible: 'reversible',
      opt_blocked_label: 'Bloqueado por Safety Guard — cambia a Standard',
      scan_scanning: 'Escaneo en curso...',
      scan_empty_title: 'Escaneo del tema no ejecutado',
      scan_empty_desc: 'Identifica secciones hero y slideshow en el tema para habilitar optimizaciones LCP del lado del servidor.',
      scan_btn: 'Escanear tema',
      scan_active_theme: 'Tema activo',
      scan_files: '{{n}} archivos Liquid escaneados · {{s}} secciones LCP identificadas',
      scan_hero_label: 'sección hero/LCP',
      scan_optimized: 'optimizado',
      scan_no_lcp: 'Ninguna sección hero/LCP identificada automáticamente en el tema.',
      scan_reload: 'Recargar',
      plan_title: 'Plan: {{label}}',
      plan_ops: '{{n}} operaciones previstas',
      plan_action_enabled: 'ya activa',
      plan_action_enable: 'habilitar',
      plan_action_disable: 'deshabilitar',
      plan_strategy: 'Estrategia: ',
      plan_guard: 'Safety Guard: ',
      plan_active_ops: 'Operaciones activas: ',
      plan_blocked: '{{n}} bloqueadas por Safety Guard',
      plan_low_conf: 'Algunas optimizaciones tienen baja confianza para el tema detectado.',
      plan_cancel: 'Cancelar',
      plan_apply: 'Aplicar estrategia',
      plan_blocked_btn: 'Bloqueado (score bajo)',
      hist_rollback: 'Rollback completo — todas las optimizaciones eliminadas',
      hist_enabled: 'activada',
      hist_disabled: 'desactivada',
      hist_active: 'activas',
      sess_no_sessions: 'No hay sesiones de optimización registradas. Las sesiones se crean al aplicar una estrategia.',
      sess_waiting: 'esperando PSI',
      strategy_label: 'Estrategia {{s}}',
      strategy_opts: '{{n}} optimizaciones',
      strategy_active: 'ACTIVA',
      quota_err: 'Error al cargar la cuota PSI',
      quota_api_key: 'Clave API configurada:',
      quota_yes: '✓ SÍ',
      quota_no: '✗ NO (usa cuota pública)',
      quota_cache_ttl: 'Cache TTL:',
      quota_hourly: 'Límite por hora:',
      quota_daily: 'Límite diario:',
      quota_success: 'Éxitos hoy:',
      quota_hit_ratio: 'Tasa de aciertos cache:',
      quota_circuit: 'Disyuntor:',
      quota_circuit_open: 'ABIERTO ({{n}} fallos)',
      quota_circuit_closed: 'cerrado',
      quota_loading: 'Cargando...',
      diag_err: 'Error de diagnóstico',
      diag_refresh: 'Actualizar',
      diag_load: 'Cargar diagnósticos',
      diag_patches: 'Parches activos ({{n}})',
      diag_none: 'ninguno',
      diag_unavailable: 'no disponible',
      diag_no_patches: 'No hay parches activos',
      diag_calibrated: '📈 calibrado',
      diag_generated: 'Generado:',
      badge_server_side: 'EN SERVIDOR',
      badge_standard: 'ESTÁNDAR',
      badge_lcp: 'LCP',
      badge_critical: 'CRÍTICO',
      badge_safe: 'SEGURO',
      badge_medium: 'MEDIO',
      badge_safety_guard: 'Guardia de seguridad',
      diag_theme_fingerprint: 'Huella del tema',
      diag_engine_confidence: 'Confianza del motor',
      perf_score_label: 'Puntuación de rendimiento',
      section_perf_overview: 'Resumen de rendimiento',
      section_strategy_intent: 'Intención de estrategia',
      safety_guard_title: 'Guardia de seguridad',
      section_script_analyzer: 'Analizador de impacto de scripts',
      script_col_file: 'Archivo',
      script_col_size: 'Tamaño',
      script_col_impact: 'Impacto',
      script_col_defer_risk: 'Riesgo de aplazamiento',
      metric_js_total: 'JS total',
      metric_css_total: 'CSS total',
      perf_updated: 'Actualizado:',
      perf_stale: 'datos obsoletos (PSI no disponible)',
      perf_from_cache: 'desde caché',
      perf_psi_ok: 'PSI OK',
      debug_invalid_token_title: 'Token inválido (401) — el token en MongoDB ha expirado o sido revocado.',
      debug_reconnect_desc: 'El callback de OAuth NO sobrescribió el token después de la última reinstalación. Haz clic en el botón de abajo para iniciar un nuevo OAuth.',
      debug_reconnect_btn: 'Reconectar OAuth ahora (abre Shopify)',
      debug_reconnect_note: 'Después de aprobar los permisos en Shopify, el callback actualizará el token en MongoDB automáticamente.',
    },
    drafts: {
      approved: '¡Borrador aprobado!',
      approve_err: 'Error de aprobación',
      published: '¡Publicado en Shopify!',
      publish_err: 'Error de publicación',
      title: 'Borradores y Resultados',
      subtitle: 'Revisa, aprueba y publica el contenido optimizado',
      empty: 'No hay borradores que revisar',
      empty_hint: 'Genera contenido IA para crear nuevos borradores',
      badge_approved: 'Aprobado',
      badge_draft: 'Borrador',
      field_desc: 'Descripción',
      btn_view: 'Ver',
      btn_approve: 'Aprobar',
      btn_publish: 'Publicar',
      modal_title: 'Detalle del borrador',
      chars_seo: '/60 caracteres',
      chars_meta: '/160 caracteres',
      not_present: 'No presente',
      not_present_pl: 'No presentes',
      btn_close: 'Cerrar',
      btn_publish_shopify: 'Publicar en Shopify',
      seo_title: 'Título SEO',
      meta_description: 'Meta descripción',
      keywords_label: 'Palabras clave',
    },
    usage: {
      title: 'Uso y Plan',
      subtitle: 'Monitorea el uso y gestiona tu suscripción',
      plan_badge: 'Plan:',
      current: 'Uso actual',
      credits: 'Créditos IA',
      used: 'Usados:',
      unlimited: 'Ilimitado ∞',
      remaining: 'Restantes: {{n}}',
      products_sync: 'Productos sincronizados',
      plans_heading: 'Planes disponibles',
      most_popular: '⭐ Más popular',
      active_plan: 'Plan activo',
      current_plan: 'Plan actual',
      btn_upgrade: 'Upgrade a {{name}}',
      trend_heading: 'Tendencia de uso',
      trend_coming: 'Gráfico de uso (próximamente)',
      stat_products: 'Productos analizados',
      stat_content: 'Contenido generado',
      stat_translations: 'Traducciones',
      stat_images: 'Imágenes optimizadas',
    },
    support: {
      msg_sent: '¡Mensaje enviado!',
      msg_err: 'Error al enviar el mensaje',
      status_open: 'Abierto',
      status_progress: 'En curso',
      status_closed: 'Cerrado',
      title: 'Soporte',
      subtitle: 'FAQ, guías y chat con nuestro equipo',
      faq_heading: 'Preguntas frecuentes',
      guide_heading: 'Guía rápida',
      chat_heading: 'Chat de soporte',
      no_msgs: 'Sin mensajes',
      no_msgs_hint: 'Inicia una conversación con el soporte',
      placeholder: 'Escribe un mensaje...',
      contacts_heading: 'Contactos',
      contact_hours_label: 'Horario',
      contact_hours: 'Lun-Vie 9:00-18:00 CET',
      contact_response_label: 'Tiempo de respuesta',
      contact_response: 'En 24 horas',
      guide_step1: 'Ve a la sección',
      guide_products: 'Productos',
      guide_step1b: 'para ver tus productos',
      guide_step2: 'Selecciona un producto y ve a',
      guide_ai_content: 'Contenido AI',
      guide_step3: 'Genera descripción, título SEO, meta descripción y keywords',
      guide_step4: 'Consulta los resultados en',
      guide_history: 'Historial',
    },
    transl: {
      load_err: 'Error al cargar elementos',
      published: '¡Traducción publicada en Shopify!',
      pub_err: 'Error de publicación',
      err_no_items: 'Selecciona al menos un elemento',
      err_no_fields: 'Selecciona al menos un campo para traducir',
      item_err: 'Error de traducción',
      done_one: '¡Traducción completada!',
      done_many: '¡{{n}} elementos traducidos!',
      copied: 'Copiado al portapapeles',
      title: 'Traducciones',
      gate_plan: 'Disponible desde el plan Starter',
      gate_desc: 'Traduce productos, colecciones y artículos en 8 idiomas con AI',
      gate_btn: 'Cambiar al Plan Starter',
      subtitle: 'Traduce productos, colecciones, artículos y páginas a varios idiomas con AI',
      translating: 'Traduciendo…',
      search_placeholder: 'Buscar por título…',
      select_page: 'Seleccionar página',
      sel_abbrev: 'sel.',
      total_items: 'total',
      loading: 'Cargando…',
      no_results: 'No hay resultados para esta búsqueda',
      prev: '← Ant',
      tot_abbrev: 'tot.',
      next: 'Sig →',
      deselect_all: 'Deseleccionar todo',
      lang_heading: 'Idioma destino',
      fields_heading: 'Campos a traducir',
      select_hint: 'Selecciona elementos de la lista para habilitar la traducción',
      results_heading: 'Resultados',
      clear_results: 'Borrar resultados',
      badge_published: 'Publicado',
      publishing: 'Publicando…',
      done: 'Hecho',
      publish: 'Publicar',
      copy: 'Copiar',
      tab_products: 'Productos',
      tab_collections: 'Colecciones',
      tab_articles: 'Artículos',
      tab_pages: 'Páginas',
      field_title: 'Título',
      field_description: 'Descripción',
      field_seo_title: 'SEO Title',
      field_meta_description: 'Meta Description',
      field_body_html: 'Descripción / Cuerpo',
      empty_hint_select: 'Selecciona uno o más elementos, elige el idioma y haz clic en',
      translate_label: 'Traducir',
      items_selected: 'elementos',
      item_selected: 'elemento',
      selected_label: 'seleccionado(s)',
      choose_fields_hint: 'elige los campos y haz clic en Traducir',
    },
  },

  pt: {
    nav: {
      overview: 'Visão geral',
      catalog: 'Catálogo',
      content: 'Conteúdo IA',
      translations: 'Traduções',
      images: 'Imagens',
      batch: 'Operações em lote',
      speed: 'Otimizador de velocidade',
      history: 'Histórico',
      usage: 'Uso e Plano',
      settings: 'Configurações',
      support: 'Suporte',
    },
    common: {
      save: 'Salvar',
      cancel: 'Cancelar',
      delete: 'Excluir',
      close: 'Fechar',
      confirm: 'Confirmar',
      loading: 'Carregando...',
      error: 'Erro',
      success: 'Sucesso',
      search: 'Pesquisar',
      filter: 'Filtrar',
      all: 'Todos',
      yes: 'Sim',
      no: 'Não',
      back: 'Voltar',
      next: 'Próximo',
      apply: 'Aplicar',
      generate: 'Gerar',
      publish: 'Publicar',
      optimize: 'Otimizar',
      refresh: 'Atualizar',
    },
    settings: {
      title: 'Configurações',
      subtitle: 'Centro de controle de IA',
      tabs: {
        general: 'Geral',
        localization: 'Localização',
        ai_engine: 'Motor de IA',
        appearance: 'Aparência',
        piano: 'Plano',
        advanced: 'Avançado',
      },
      save_btn: 'Salvar configurações',
      unsaved: 'Alterações não salvas',
      action_loading: 'Em andamento...',
      general: {
        contents: 'Conteúdos',
        default_lang: 'Idioma de conteúdo padrão',
        tone: 'Tom de conteúdo global',
        tone_hint: 'Aplicado a produtos, coleções, artigos e lotes',
        seo_rules: 'Regras SEO',
        seo_title_max: 'Comprimento máximo do título SEO',
        seo_title_hint: 'Recomendado: 50–60 caracteres',
        meta_max: 'Comprimento máximo da meta descrição',
        meta_hint: 'Recomendado: 150–160 caracteres',
        chars: 'caracteres',
        images: 'Preferências de imagem',
        img_format: 'Formato padrão',
        img_square: 'Quadrado (1:1)',
        img_landscape: 'Paisagem (4:3)',
        img_portrait: 'Retrato (3:4)',
        img_quality: 'Qualidade de compressão',
        img_quality_low: '50% (comprimida)',
        img_quality_high: '100% (máxima)',
        store_info: 'Informações da loja',
        store_domain: 'Domínio',
        store_plan: 'Plano',
        store_installed: 'Instalado',
      },
      ai: {
        strategy: 'Estratégia IA',
        params_title: 'Parâmetros de geração',
        creativity: 'Criatividade',
        creative_low: 'Conservador',
        creative_high: 'Criativo',
        seo_strictness: 'Rigor SEO',
        seo_low: 'Flexível',
        seo_high: 'Rigoroso',
        tone_label: 'Tom global',
        auto_title: 'Auto-otimização IA',
        auto_hint: 'Ativar para otimizar automaticamente os conteúdos',
        on: 'Ativo',
        off: 'Off',
        threshold: 'Limiar de otimização',
        threshold_low: 'Otimizar tudo',
        threshold_high: 'Somente os piores',
        threshold_hint: 'Atua em elementos com pontuação SEO < {{n}}',
        frequency: 'Frequência',
        scope: 'Escopo',
        triggers: 'Gatilhos',
        img_format: 'Formato de imagem',
        img_square: 'Quadrado 1:1',
        img_square_sub: '800×800 px',
        img_landscape: 'Paisagem 4:3',
        img_landscape_sub: '800×600 px',
        img_portrait: 'Retrato 3:4',
        img_portrait_sub: '600×800 px',
        img_no_resize: 'Sem redimensionar',
        img_no_resize_sub: 'Dimensões originais',
        compress: 'Compressão',
        compress_hint: 'Reduzir tamanho do arquivo',
        quality: 'Qualidade',
        daily_credits: 'Créditos IA hoje',
        remaining: '{{n}} restantes',
        reset_in: 'Reset em',
        running: 'Em andamento — {{done}}/{{total}} produtos',
        run_now: 'Executar agora',
        run_desc: 'Otimizar elementos com pontuação < {{threshold}} em: {{scope}}',
        preview_title: 'Pré-visualização — Antes / Depois',
        before: 'Antes',
        after: 'Depois IA',
        no_keywords: 'sem palavras-chave',
        preview_note: 'Exemplo no produto «Tênis Running Pro X1» — atualização instantânea',
        alt_mode_label: 'Modo de geração de texto ALT',
        alt_preview: 'Pré-visualização',
        alt_mode_ai: 'IA inteligente',
        alt_mode_ai_desc: 'OpenAI gera ALT otimizado para cada imagem',
        alt_mode_template: 'Modelo gratuito',
        alt_mode_template_desc: 'Sem créditos IA — usa o modelo abaixo',
        alt_mode_auto: 'Fallback automático',
        alt_mode_auto_desc: 'IA quando disponível, modelo se créditos esgotados',
        alt_hint_template: 'Modo gratuito: sem créditos IA consumidos para texto ALT.',
        alt_hint_auto: 'Fallback auto: IA se créditos disponíveis, senão modelo automático.',
        pct_done: '{{pct}}% concluído',
        n_errors: '{{n}} erros',
        alt_template_label: 'Modelo personalizado',
        alt_vars_label: 'Variáveis disponíveis — clique para inserir',
      },
      piano: {
        credits_title: 'Uso de créditos',
        plan_label: 'Plano',
        extra_credits: 'Créditos extras',
        unlimited: '∞ Créditos ilimitados',
        unlimited_sub: 'Plano Elite — sem limite mensal',
        plan_credits: 'Créditos do plano',
        consumed: 'Consumidos do plano',
        residual: 'Restantes do plano',
        extra_available: 'Créditos extras disponíveis',
        extra_sub: 'Consumidos somente após o plano mensal',
        total_available: 'Total disponível',
        consumed_cycle: 'Créditos consumidos no ciclo atual',
        status_active: 'Ativo',
        status_pending: 'Em processamento',
        status_frozen: '⚠ Suspenso',
        status_free: 'Free / Sem assinatura',
        trial_active: 'Teste ativo',
        trial_access: 'acesso completo até {{date}}.',
        sub_status: 'Status da assinatura',
        next_credit_reset: 'Próxima redefinição de créditos',
        trial_end: 'Fim do teste',
        trial_label: 'Teste gratuito',
        trial_used: 'Já utilizado',
        trial_available: '{{n}} dias disponíveis',
        cancel_btn: 'Cancelar assinatura',
        cancelling: 'Cancelando...',
        plans_title: 'Planos disponíveis',
        plan_active: 'Plano ativo',
        plan_current: 'Plano atual',
        per_month: '/mês',
        downgrade: 'Voltar ao Free',
        downgrading: 'Downgrade...',
        upgrade: 'Upgrade',
        downgrade_btn: 'Downgrade',
        redirecting: 'Redirecionando...',
        trial_btn: 'Testar grátis',
        trial_btn_days: '({{n}}d)',
        plan_overage: 'Créditos de IA adicionais: {{price}} por crédito',
        plan_no_overage: 'Sem custos por créditos de IA excedentes',
        plan_trial_line: 'Teste gratuito de {{n}} dias',
        plans_note: 'Os planos pagos incluem {{n}} dias de teste gratuito. Sem taxa de ativação. Pagamentos via Shopify Billing.',
        credits_section: 'Comprar créditos extras',
        credits_desc: 'Os créditos extras são adicionados ao seu plano mensal e nunca expiram. Compatíveis com todos os planos.',
        one_time: 'único',
        per_credit: '¢ por crédito',
        buy: 'Comprar',
        payment_note: 'Pagamento processado com segurança via Shopify Billing. Nenhum dado de pagamento armazenado em nosso servidor.',
        history_title: 'Histórico de compras de créditos',
        history_count: '{{n}} compra{{suffix}}',
        hist_invested: 'Total investido',
        hist_bought: 'Créditos comprados',
        hist_available: 'Ainda disponíveis',
        hist_empty: 'Nenhuma compra de créditos extras realizada.',
        hist_date: 'Data',
        hist_pkg: 'Pacote',
        hist_credits: 'Créditos',
        hist_amount: 'Valor',
        hist_status: 'Status',
        hist_completed: 'Concluído',
        hist_pending: 'Pendente',
        hist_declined: 'Recusado',
        trend_title: 'Tendência de uso',
        trend_placeholder: 'Gráfico de uso (disponível com Shopify Billing)',
        stats_products: 'Produtos analisados',
        stats_content: 'Conteúdo gerado',
        stats_translations: 'Traduções',
        stats_images: 'Imagens otimizadas',
        toast_sub_pending: 'Assinatura em processamento — você receberá uma confirmação em breve.',
        toast_sub_activated: '{{name}} ativado!',
        toast_trial_suffix: '({{n}} dias de teste gratuito)',
        toast_sub_error: 'Erro de verificação de assinatura',
        toast_purchase_duplicate: 'Compra já registrada.',
        toast_credits_added: '+{{n}} créditos adicionados à sua conta!',
        toast_purchase_error: 'Erro de verificação de compra',
        toast_purchase_start_error: 'Erro ao iniciar compra',
        toast_sub_start_error: 'Erro ao iniciar assinatura',
        toast_store_unavailable: 'Loja ainda não conectada. Recarregue o app no Shopify Admin e tente novamente.',
        toast_sub_cancelled: 'Assinatura cancelada. Plano voltou ao Free.',
        toast_sub_cancel_error: 'Erro de cancelamento de assinatura',
        pkg_100_label: '100 Créditos',
        pkg_100_desc: 'Ideal para uso ocasional',
        pkg_300_label: '300 Créditos',
        pkg_300_desc: 'Economize 17%',
        pkg_300_badge: '⭐ Mais solicitado',
        pkg_700_label: '700 Créditos',
        pkg_700_desc: 'Economize 29%',
        pkg_1500_label: '1.500 Créditos',
        pkg_1500_desc: 'Economize 33%',
        pkg_1500_badge: '🔥 Melhor valor',
        plan_starter_badge: '⭐ Mais Popular',
        plan_starter_benefit: 'Economize horas de trabalho todo mês.',
        plan_pro_badge: '🔥 Crescimento SEO',
        plan_pro_benefit: 'Melhora a indexação e o desempenho SEO.',
        plan_elite_badge: '🚀 Agências',
        plan_elite_benefit: 'Projetado para agências e catálogos enterprise.',
      },
      toast: {
        saved_at: 'Salvo às {{time}}',
        save_error: 'Erro ao salvar',
        budget_exceeded: 'Crédito diário esgotado — {{done}} produtos otimizados de {{total}}',
        autopilot_stopped: 'Autopilot parado — {{done}} produtos otimizados de {{total}}',
        images_optimized: 'Imagens otimizadas — {{n}} produtos',
        images_failed: '{{n}} imagens não otimizadas',
        autopilot_done: 'Autopilot concluído — {{started}} produtos na fila',
        autopilot_empty: 'Nenhum elemento abaixo do limiar',
        autopilot_stopping: 'Autopilot parando...',
        reindex_started: 'Re-indexação iniciada',
        resync_started: 'Re-sincronização iniciada',
        cache_cleared: 'Cache limpo',
        sync_reset: 'Estado de sincronização redefinido',
      },
      advanced: {
        warning: 'As ações a seguir afetam o comportamento do sistema. Use somente se necessário.',
        sync_title: 'Sincronização',
        reindex: 'Re-indexar produtos',
        reindex_desc: 'Recalcular dados SEO para todos os produtos do banco de dados',
        resync: 'Re-sincronizar com Shopify',
        resync_desc: 'Forçar sincronização completa de produtos e coleções',
        cache_title: 'Cache',
        clear_cache: 'Limpar cache da aplicação',
        clear_cache_desc: 'Apaga os lotes em andamento no navegador. Operações incompletas serão perdidas.',
        reset_credits: 'Redefinir créditos diários',
        reset_credits_desc: 'Redefine o contador de créditos IA de hoje (dev). Limite: 5.000/dia.',
        danger_zone: 'Zona de perigo',
        reset_sync: 'Redefinir estado de sincronização',
        reset_sync_desc: 'Forçar redefinição. Usar somente se a sincronização estiver bloqueada por mais de 30 minutos.',
      },
    },
    ai_engine: {
      preset: {
        growth_desc: 'Maximiza conversões e engajamento',
        luxury_desc: 'Marca premium e narrativa exclusiva',
        seo_desc: 'Maximiza a visibilidade orgânica no Google',
        balanced_desc: 'Equilíbrio ideal entre qualidade e SEO',
      },
      tone: {
        professional: 'Profissional',
        professional_desc: 'Formal, autoritativo, gera confiança',
        luxury: 'Luxury',
        luxury_desc: 'Elegante, exclusivo, premium',
        technical: 'Técnico',
        technical_desc: 'Preciso, especificações, dados mensuráveis',
        conversational: 'Conversacional',
        conversational_desc: 'Direto, amigável, envolvente',
      },
      frequency: {
        daily: 'Diário',
        daily_desc: '1× por dia',
        hourly: 'A cada hora',
        hourly_desc: 'Contínuo',
        realtime: 'Imediato',
        realtime_desc: 'O mais rápido possível',
      },
      scope: {
        products: 'Produtos',
        collections: 'Coleções',
        articles: 'Artigos',
        pages: 'Páginas',
      },
      trigger: {
        seo_score: 'Pontuação SEO baixa',
        missing_meta: 'Metadados ausentes',
        missing_alt: 'Texto ALT ausente',
        outdated_desc: 'Descrição desatualizada',
        keywords: 'Palavras-chave ausentes',
        image_quality: 'Imagens não otimizadas',
      },
    },
    appearance: {
      title: 'Aparência',
      theme_title: 'Tema',
      theme: {
        light: 'Claro',
        dark: 'Escuro',
        system: 'Sistema',
      },
      density_title: 'Densidade',
      density: {
        compact: 'Compacto',
        comfortable: 'Confortável',
        spacious: 'Espaçoso',
        compact_desc: 'Mais conteúdo',
        comfortable_desc: 'Equilibrado',
        spacious_desc: 'Mais espaço',
      },
      sidebar_title: 'Barra lateral',
      sidebar: {
        expanded: 'Expandida',
        collapsed: 'Recolhida',
        hidden: 'Oculta',
        expanded_desc: 'Sempre visível',
        collapsed_desc: 'Apenas ícones',
        hidden_desc: 'Ao passar o mouse',
      },
    },
    localization: {
      ui_language: 'Idioma da interface',
      select_language: 'Selecionar o idioma do aplicativo',
      reload_note: 'O idioma é aplicado imediatamente',
    },
    dashboard: {
      title: 'Visão geral',
      subtitle: 'Resumo da atividade da loja',
      products: 'Produtos',
      optimized: 'Otimizados',
      pending: 'Pendentes',
      seo_score: 'Pontuação SEO',
      audit_center: 'Audit Center',
      sync_products: 'Sincronizar produtos',
      analyze_products: 'Analisar produtos',
      audit_site: 'Auditoria do site 360',
      syncing: 'Sync...',
      analyzing: 'Analisando...',
      auditing: 'Audit...',
      section_account: 'Conta e Plano',
      section_catalog: 'Status do catálogo',
      section_images: 'Imagens',
      section_seo_tech: 'SEO Técnico — Auditoria detalhada do site',
      section_ux_trust: 'UX & Trust — Highlights',
      section_actions: 'Ações recomendadas pela IA',
      recent_activity: 'Atividade recente',
      hint_plan: 'Status do plano e dos créditos',
      hint_never_synced: 'Nunca sincronizado',
      hint_priority: 'Ordenado por prioridade',
      hint_last_sync: 'Último sync {{date}}',
      current_plan: 'Plano atual',
      credits_used: 'Créditos usados',
      credits_remaining: 'Créditos restantes',
      public_domain: 'Domínio público',
      credit_usage: 'Uso de créditos',
      hint_installed: 'Instalado em {{date}}',
      hint_pct_plan: '{{pct}}% do plano',
      hint_limit: 'Limite {{n}}',
      hint_last_audit: 'Última auditoria {{date}}',
      hint_no_audit: 'Auditoria não realizada',
      no_audit: 'Nenhuma auditoria realizada',
      no_audit_desc: 'Execute uma auditoria para analisar title, meta, H1, canonical, robots, sitemap, HTTPS, OG, JSON-LD, desempenho, imagens e links.',
      run_audit: 'Executar auditoria',
      in_progress: 'Em andamento...',
      audit_phase: 'Auditoria em andamento (fase: {{phase}})...',
      ux_highlights: 'UX Highlights',
      trust_compliance: 'Trust & Compliance',
      mobile_viewport: 'Mobile viewport:',
      favicon: 'Favicon:',
      images_without_alt_label: 'Imagens sem ALT:',
      lazy_loading: 'Lazy loading:',
      images_suffix: 'imagens',
      internal_links: 'Links internos:',
      data_unavailable: 'Dados indisponíveis: {{reason}}',
      analysis_not_run: 'Análise não executada',
      not_detected: 'Não detectado',
      no_trust_data: 'Nenhum dado de confiança disponível',
      no_activity: 'Nenhuma atividade recente.',
      activity_completed: 'Concluído',
      activity_error: 'Erro',
      no_store_title: 'Nenhuma loja conectada',
      no_store_desc: 'Instale o aplicativo em uma loja Shopify para começar',
      connect_store: 'Conectar loja Shopify',
      no_token_title: 'Token OAuth ausente',
      no_token_desc: 'A loja {{domain}} está registrada mas não possui token. Reinstale o aplicativo.',
      reinstall_app: 'Reinstalar aplicativo via OAuth',
      sync_in_progress: 'Sincronização de produtos em andamento…',
      sync_in_progress_detail: '{{synced}} / {{total}} produtos. Os dados do painel serão atualizados ao final da sincronização.',
      stale_data: 'Dados desatualizados: exibindo os últimos números válidos enquanto a sincronização está em andamento.',
      catalog_score_label: 'Catalog Score',
      seo_distribution: 'Distribuição SEO',
      n_products: '{{n}} produtos',
      pct_of_catalog: '{{pct}}% do catálogo',
      no_description: 'Sem descrição',
      no_meta_description: 'Sem meta description',
      seo_needs_improvement: 'SEO a melhorar',
      view: 'Ver',
      seo_good_desc: 'O catálogo tem uma boa cobertura SEO. Mantenha o padrão otimizando os novos produtos.',
      seo_medium_desc: 'O catálogo tem uma cobertura SEO média. Prioridade: meta descriptions e descrições de produto.',
      seo_poor_desc: 'O catálogo tem uma cobertura SEO baixa. Prioridade: meta descriptions, descrições e imagens ausentes.',
      seo_optimized: 'Otimizados',
      seo_medium: 'Médios',
      seo_poor: 'A melhorar',
      content_seo_title: 'Status SEO por tipo de conteúdo',
      open_catalog: 'Abrir catálogo',
      row_collections: 'Coleções',
      row_articles: 'Artigos',
      row_pages: 'Páginas',
      coming_soon: 'Em breve',
      not_synced: 'Não sincronizados',
      seo_coverage_fmt: '{{opt}}/{{total}} otimizados · {{score}}/100',
      alt_coverage: 'Cobertura ALT text',
      with_alt_count: '{{n}} com ALT de {{total}}',
      image_optimization_label: 'Otimização de imagens',
      optimized_count: '{{n}} otimizadas de {{total}}',
      with_alt: 'Com ALT',
      without_alt: 'Sem ALT',
      image_optimized: 'Otimizadas',
      image_needs_improvement: 'A melhorar',
      no_image: 'Sem imagem',
      savings: 'Economia',
      optimize_images_btn: 'Otimizar imagens',
      view_no_image: 'Ver produtos sem imagem',
      alt_manager: 'ALT Text Manager',
      toast_sync_done: 'Sincronização concluída. Reconciliando catálogo...',
      toast_catalog_reconciled: 'Catálogo reconciliado: {{n}} produtos ({{removed}} órfãos removidos)',
      toast_sync_first: 'Sincronize os produtos primeiro',
      toast_avg_score: 'Score médio {{score}}/100',
      toast_audit_done: 'Auditoria concluída: {{score}}/100',
      toast_sync_reset: 'Estado de sync redefinido',
      toast_sync_reset_error: 'Não foi possível redefinir o estado',
      op_description: 'Descrição IA',
      op_seo_title: 'SEO Title',
      op_meta_description: 'Meta Description',
      op_keywords: 'Keywords',
      op_translation: 'Tradução',
      op_image_opt: 'Otimização de imagem',
      op_sync: 'Sync Shopify',
      op_seo_analysis: 'Análise SEO da loja',
      op_site_audit: 'Auditoria do site 360',
      prompt_domain: 'Insira o domínio da sua loja Shopify',
      hint_force_reset: 'Forçar redefinição do estado de sincronização (não exclui produtos)',
    },
    products: {
      title: 'Catálogo de produtos',
      search: 'Pesquisar produtos...',
      all: 'Todos',
      optimized: 'Otimizados',
      pending: 'Pendentes',
      status_generating: 'Gerando',
      status_writing: 'Escrevendo',
      status_validating: 'Validando',
      status_failed: 'Falhou',
      status_sync_failed: 'Sync Shopify',
      status_optimized: 'Otimizado',
      status_medium: 'Médio',
      status_needs_improvement: 'A melhorar',
      type_collection_singular: 'coleção',
      type_collection_plural: 'coleções',
      sync_collections: 'Sincronizar coleções',
      empty_collections: 'Sem coleções. Clique em "Sincronizar coleções" para importá-las do Shopify.',
      search_collections: 'Pesquisar coleção por título ou handle...',
      col_label_products: 'Produtos',
      type_article_singular: 'artigo',
      type_article_plural: 'artigos',
      sync_articles: 'Sincronizar artigos',
      empty_articles: 'Sem artigos. Clique em "Sincronizar artigos" para importá-los do Shopify.',
      search_articles: 'Pesquisar artigo por título, handle ou blog...',
      col_label_blog: 'Blog',
      type_page_singular: 'página',
      type_page_plural: 'páginas',
      sync_pages: 'Sincronizar páginas',
      empty_pages: 'Sem páginas. Clique em "Sincronizar páginas" para importá-las do Shopify.',
      search_pages: 'Pesquisar página por título ou handle...',
      col_label_author: 'Autor',
      catalog_title: 'Catálogo',
      no_store: 'Nenhuma loja',
      tab_products: 'Produtos',
      tab_collections: 'Coleções',
      tab_articles: 'Artigos',
      tab_pages: 'Páginas',
      sort_updated: 'Atualizado',
      sort_seo_score: 'Score SEO',
      sort_title: 'Título',
      sort_vendor: 'Vendor',
      sort_created: 'Criado',
      sort_desc: 'Descendente',
      sort_asc: 'Ascendente',
      filter_seo_all: 'SEO: todos',
      filter_optimized: 'Otimizados',
      filter_medium: 'Médios',
      filter_needs_improvement: 'A melhorar',
      filter_image_all: 'Imagens: todos',
      filter_image_yes: 'Com imagens',
      filter_image_no: 'Sem imagens',
      filter_meta_all: 'Meta: todos',
      filter_meta_yes: 'Com meta',
      filter_meta_no: 'Sem meta',
      filter_desc_all: 'Descrição: todos',
      filter_desc_yes: 'Com descrição',
      filter_desc_no: 'Sem descrição',
      filter_vendor_all: 'Vendor: todos',
      filter_collection_all: 'Coleção: todas',
      filter_type_all: 'Tipo: todos',
      reset_filters: 'Redefinir filtros',
      th_image: 'Imagem',
      th_title: 'Título',
      th_seo_score: 'Score SEO',
      th_alt: 'ALT',
      th_meta: 'Meta',
      th_status: 'Status',
      th_actions: 'Ações',
      no_products_filters: 'Nenhum produto encontrado com estes filtros',
      no_products: 'Sem produtos. Sincronize da sua loja Shopify.',
      pagination: 'Página {{page}} de {{total}} · {{count}} produtos',
      batch_btn: 'Operações em lote',
      dialog_status: 'Status',
      dialog_seo_score: 'Score SEO',
      dialog_shopify_id: 'ID Shopify',
      dialog_vendor: 'Vendor',
      dialog_serp: 'Pré-visualização SERP',
      dialog_issues: 'Problemas SEO',
      dialog_suggestions: 'Sugestões',
      generating: 'Gerando...',
      generate_all: 'Gerar todo o conteúdo',
      action_generate_ai: 'Gerar conteúdo IA',
      action_translate: 'Traduzir',
      action_optimize_image: 'Otimizar imagem',
      syncing: 'Sincronizando...',
      draft_ready: 'Rascunho pronto',
      seo_ai_btn: 'SEO IA',
      batch_ops_btn: 'Operações em lote',
      diagnosis: 'Diagnóstico',
      current_score: 'Score atual',
      projected: '→ previsto {{score}}/100',
      meta_title: 'Meta Title',
      meta_desc_label: 'Meta Description',
      description_label: 'Descrição',
      generate_desc_btn: 'Gerar descrição IA',
      generating_desc: 'Gerando...',
      generate_ai_btn: 'Gerar com IA',
      publish_shopify_btn: 'Publicar no Shopify',
      publishing: 'Publicando...',
      discard_draft_btn: 'Descartar rascunho',
      seo_ai_dialog_title: 'SEO IA',
      seo_all: 'SEO: todos',
      seo_optimized: 'Otimizados',
      seo_medium: 'Médios',
      seo_needs: 'A melhorar',
      page_of: 'Página {{page}} de {{total}}',
      search_placeholder: 'Pesquisar por título, SKU, EAN, fornecedor, handle...',
      chars_count: '{{n}}/{{max}} caracteres',
      n_selected_info: 'selecionados',
      filtered: 'filtrados',
      soon_tooltip: 'Disponível em breve',
      resource_subtitle: '{{type}} Shopify e seu estado de SEO',
      articles_blog: 'Artigos (blog)',
      select_visible_title: 'Selecionar/desmarcar todos os visíveis',
      toast_draft_ready: 'Rascunho SEO gerado. Revise e publique.',
      toast_error_ai: 'Erro de geração de IA',
      toast_desc_generated: 'Descrição de IA gerada.',
      toast_error_desc: 'Erro ao gerar a descrição',
      toast_empty_draft: 'Gere ou preencha pelo menos um campo',
      toast_published_score: 'Publicado no Shopify · Score {{score}}/100',
      toast_error_publish: 'Erro ao publicar no Shopify',
      toast_draft_discarded: 'Rascunho descartado',
      toast_select_items: 'Selecione pelo menos um item',
      toast_mode_publish: 'Publicação',
      toast_mode_both: 'Gerar+Publicar',
      toast_mode_generate: 'Geração SEO AI',
      toast_batch_launched: '{{label}} iniciada em {{count}} {{type}}.',
      toast_batch_errors: '{{label}} concluída com {{count}} erros',
      toast_batch_done: '{{label}} concluída em {{count}} {{type}}',
      toast_synced: '{{type}} sincronizados: {{count}}',
      toast_sync_error: 'Erro de sincronização {{type}}',
      toast_token_error: 'Token do Shopify expirado ou sem permissões',
      reinstall_label: 'Reinstalar',
      toast_sync_started: 'Sincronização de {{type}} iniciada',
      toast_error_sync_start: 'Erro ao iniciar a sincronização',
      toast_perms_ok: 'Permissões ok ({{kind}})',
      toast_token_revoked: 'Token revogado',
      toast_perms_missing: 'Permissões em falta',
      toast_diag_error: 'Erro de diagnóstico',
      toast_score: 'Score {{score}}/100',
      toast_error_analyze: 'Erro de análise',
      toast_generated: 'Conteúdo gerado',
      toast_error_generate: 'Erro de geração',
    },
    content: {
      title: 'Geração de conteúdo',
      generate: 'Gerar conteúdo',
      language: 'Idioma',
      tone: 'Tom',
      subtitle: 'Gere descrições, SEO title, meta description e keywords com IA',
      tab_products: 'Produtos',
      tab_collections: 'Coleções',
      tab_articles: 'Artigos',
      tab_pages: 'Páginas',
      type_description_label: 'Descrição',
      type_description_hint: 'Texto de produto atraente e otimizado para SEO',
      type_seo_title_label: 'SEO Title',
      type_seo_title_hint: 'Título otimizado para SERP (max 60 car.)',
      type_meta_desc_label: 'Meta Description',
      type_meta_desc_hint: 'Snippet do Google (max 160 car.)',
      type_keywords_label: 'Keywords',
      type_keywords_hint: 'Palavras-chave principais e secundárias',
      type_body_label: 'Descrição / Corpo',
      type_body_hint: 'Texto principal do recurso',
      filter_all: 'Todos',
      filter_needs: 'A melhorar',
      filter_medium: 'Médios',
      filter_optimized: 'Otimizados',
      no_results_filters: 'Nenhum item corresponde aos filtros',
      select_all: 'Selecionar tudo',
      deselect: 'Desselecionar',
      selected_count: '{{count}} selecionados',
      selected_max: '(max)',
      deselect_all: 'Desselecionar tudo',
      pagination_of: '{{page}} / {{total}}',
      total_count: '({{count}} total)',
      content_type_section: 'Tipo de conteúdo',
      batch_generating: 'Gerando… {{done}}/{{total}}',
      batch_generate_btn: 'Gerar em lote ({{count}})',
      generating_count: 'Gerar ({{count}})',
      generate_btn: 'Gerar',
      generating: 'Gerando…',
      generate_all_btn: 'Todos',
      hint_select: '← Selecione um item ou marque vários para o lote',
      hint_batch_ready: '{{count}} item(ns) pronto(s) para o lote',
      batch_done_title: '✓ Lote concluído',
      batch_pending_title: 'Lote pendente…',
      batch_in_progress_title: 'Geração em lote em andamento…',
      batch_done_msg: 'Todo o conteúdo gerado. A seleção será limpa automaticamente.',
      results_section: 'Resultados',
      publishing: 'Publicando…',
      published: 'Publicado',
      publish_btn: 'Publicar no Shopify',
      clear_results: 'Limpar',
      chars_unit: 'car.',
      cache_label: 'cache',
      preview_section: 'Pré-visualização atual',
      loading_detail: 'Carregando detalhe…',
      not_present: 'Não presente',
      not_present_plural: 'Não presentes',
      empty_state: 'Clique em um item para visualizá-lo, ou marque vários e use Gerar em lote',
      copy_btn: 'Copiar',
      type_seo_title_hint_content: 'Metatítulo para SERP (máx. 60 car.)',
      no_items: 'Nenhum {{type}} encontrado',
      item_deselect: 'Desmarcar',
      item_select: 'Adicionar à seleção',
      generate_all_title: 'Gerar todos os tipos disponíveis',
      prev_item: 'Item anterior',
      next_item: 'Próximo item',
      toast_load_error: 'Erro ao carregar itens',
      toast_batch_done: 'Lote concluído: {{done}}/{{total}} produtos',
      toast_batch_failed: 'Lote falhou: {{failed}} erros de {{total}}',
      toast_batch_cancelled: 'Lote cancelado',
      toast_batch_resumed: 'Lote ativo retomado…',
      toast_max_select: 'Máximo {{max}} itens selecionáveis',
      toast_select_item: 'Selecione um item da lista',
      toast_select_type: 'Selecione pelo menos um tipo de conteúdo',
      toast_from_cache: 'Conteúdo do cache!',
      toast_generated: 'Gerado com sucesso!',
      toast_generate_error: 'Erro ao gerar conteúdo',
      toast_batch_running: 'Um processo em lote já está em execução',
      toast_no_store: 'Loja não disponível',
      toast_batch_started: 'Lote iniciado: {{n}} produtos na fila',
      toast_batch_start_error: 'Erro ao iniciar lote',
      toast_batch_item_error: 'Erro de geração: {{title}}',
      toast_batch_complete: 'Lote concluído: {{done}}/{{total}} itens',
      toast_cancel_error: 'Erro ao cancelar lote',
      toast_published: 'Conteúdo publicado no Shopify!',
      toast_publish_error: 'Erro ao publicar conteúdo',
      toast_copied: 'Copiado para a área de transferência',
      present: 'presente',
      missing: 'ausente',
      lang_it: 'Italiano',
      lang_en: 'Inglês',
      lang_fr: 'Francês',
      lang_de: 'Alemão',
      lang_es: 'Espanhol',
      lang_pt: 'Português',
      tone_professional: 'Profissional',
      tone_luxury: 'Luxo',
      tone_technical: 'Técnico',
      tone_conversational: 'Conversacional',
    },
    images: {
      title: 'Otimização de imagens',
      optimize: 'Otimizar',
      format: 'Formato',
      compress: 'Comprimir',
      quality: 'Qualidade',
      alt_mode_label: 'Modo de geração de ALT',
      alt_mode_ai: 'IA inteligente',
      alt_mode_template: 'Modelo gratuito',
      alt_mode_auto: 'Fallback automático',
      subtitle: 'Otimize imagens, gerencie texto ALT e publique no Shopify.',
      tab_optimize: 'Otimizar imagens',
      tab_alt: 'Texto ALT',
      alt_coverage: 'Cobertura ALT',
      with_alt_count: 'com ALT de',
      stat_with_alt: 'Com ALT: {{count}}',
      stat_without_alt: 'Sem ALT: {{count}}',
      stat_no_image: 'Sem imagem: {{count}}',
      sync_alt_btn: 'Atualizar dados ALT do Shopify',
      syncing_alt: 'Atualizando ALT...',
      sync_status_label: 'Status:',
      analyzed_label: 'Analisados:',
      last_updated_label: 'Última atualização:',
      stalled: 'parado',
      force_stop: 'Forçar parada (parado há 60s)',
      free_badge: '● Gratuito — sem créditos',
      configure_btn: '▼ Configurar',
      hide_btn: '▲ Ocultar',
      template_free_hint: 'Modo gratuito ativo — zero créditos IA. Template:',
      template_auto_hint: 'Fallback automático — IA se houver créditos, template local se esgotados.',
      template_config_title: 'Configurar template ALT',
      template_label: 'Template personalizado',
      template_preview: 'Pré-visualização:',
      variables_label: 'Variáveis disponíveis — clique para inserir:',
      restore_default: 'Restaurar padrão',
      save_config: 'Salvar configuração',
      saving: 'Salvando...',
      search_placeholder: 'Pesquisar por título, vendor, handle...',
      filter_all_images: 'Todas',
      filter_with_alt: 'Com ALT',
      filter_without_alt: 'Sem ALT',
      selected_images: '{{count}} imagens selecionadas (max 50 por lote)',
      generate_batch_btn: 'Gerar ALT para selecionadas',
      batch_alt_in_progress: 'Lote ALT em andamento: {{done}} / {{total}}',
      batch_errors: '{{n}} erros',
      select_all_label: 'Selecionar tudo',
      deselect_all_label: 'Desselecionar tudo',
      total_products_label: '{{count}} produtos',
      timeout_title: 'O carregamento demorou muito (20s)',
      timeout_desc: 'O banco de dados está processando muitos produtos. Tente novamente em alguns segundos.',
      error_title: 'Erro ao carregar a lista',
      no_products_filter: 'Nenhum produto corresponde aos filtros',
      alt_placeholder: 'Texto ALT (max 125 caracteres)',
      status_published: 'Publicado',
      status_saved: 'Salvo',
      status_draft_alt: 'Rascunho',
      status_missing: 'Sem ALT',
      generate_alt_btn: 'Gerar ALT',
      save_alt_btn: 'Salvar ALT',
      publish_alt_btn: 'Publicar',
      prec: 'Ant.',
      succ: 'Próx.',
      select_products: 'Selecionar produtos',
      filter_collection_all: 'Coleção: todas',
      filter_vendor_all: 'Vendor: todos',
      filter_kb_all: 'KB: todos',
      filter_kb_100: 'Arquivos acima de 100 KB',
      filter_kb_500: 'Arquivos acima de 500 KB',
      filter_kb_1mb: 'Arquivos acima de 1 MB',
      filter_format_all: 'Formato: todos',
      filter_landscape: 'Largura maior que Altura',
      filter_portrait: 'Altura maior que Largura',
      filter_square: 'Quadradas',
      filter_status_all: 'Status: todos',
      filter_status_optimized: 'Já otimizadas',
      filter_status_needs: 'A otimizar',
      visible_total: '{{visible}} visíveis · {{total}} totais',
      reset_filters: 'Redefinir filtros',
      clear_selection: 'Limpar seleção',
      no_image_products: 'Nenhum produto com imagem',
      ready_badge: 'Pronta',
      settings_title: 'Configurações',
      format_title: 'Formato de imagem',
      format_square: 'Quadrado 1:1',
      format_landscape: 'Landscape 4:3',
      format_portrait: 'Portrait 3:4',
      format_none: 'Sem redimensionar',
      format_none_sub: 'Dimensões originais',
      compress_label: 'Compressão',
      compress_desc: 'Reduzir tamanho do arquivo',
      quality_label: 'Qualidade',
      batch_opt_running: 'Otimização em andamento',
      batch_opt_cancelled: 'Otimização cancelada',
      batch_opt_completed: 'Otimização concluída',
      batch_apply_running: 'Aplicação em andamento',
      batch_apply_cancelled: 'Aplicação cancelada',
      batch_apply_completed: 'Aplicação concluída',
      background_note: 'Você pode mudar de seção, continua em segundo plano',
      optimizing: 'Otimizando...',
      optimize_n: 'Otimizar {{count}} imagens',
      optimize_one: 'Otimizar imagem',
      applying: 'Aplicando...',
      apply_n: 'Aplicar {{count}} no Shopify',
      apply_one: 'Aplicar no Shopify',
      preview_title: 'Pré-visualização',
      ready_optimizations: '{{count}} otimizações prontas',
      select_preview_hint: 'Selecione um ou mais produtos para ver a pré-visualização',
      first_product_preview: 'Pré-visualização do primeiro produto selecionado:',
      original_label: 'Original',
      optimized_label: 'Otimizada',
      optimize_click_hint: 'Clique em "Otimizar" para o resultado',
      reduction_label: 'Redução',
      apply_btn: 'Aplicar',
      history_opt_title: 'Histórico de otimizações',
      history_opt_subtitle: 'Operações aplicadas no Shopify, erros e restaurações.',
      stat_running_label: 'Em andamento',
      stat_completed_label: 'Concluídas',
      stat_errors_label: 'Incompletas',
      stat_undo_label: 'Desfazer',
      total_savings: 'Economia total',
      no_history: 'Nenhuma operação aplicada ainda.',
      restoring: 'Restaurando...',
      undo_btn: 'Desfazer',
      kb_warning: 'O tamanho em KB não está nos dados locais. Para torná-lo preciso, precisa ser salvo pelo backend durante a sincronização de imagens.',
      senza_vendor: 'Sem vendor',
      alt_stat_coverage: '{{n}} com ALT de {{total}}',
      apply_batch_cancelled: 'Aplicação cancelada',
      apply_batch_done_label: 'Aplicação concluída',
      apply_batch_running: 'Aplicação em curso',
      apply_n_btn: 'Aplicar {{n}} no Shopify',
      applying_btn: 'Aplicando...',
      auto_fallback_hint: 'Auto fallback — IA se houver créditos disponíveis, template local se esgotados.',
      background_hint: 'Pode mudar de seção, continua em segundo plano',
      badge_draft: 'Rascunho',
      badge_missing: 'Sem ALT',
      badge_published: 'Publicado',
      badge_ready: 'Pronto',
      badge_saved: 'Guardado',
      batch_close: 'Fechar',
      batch_generate_btn: 'Gerar ALT para selecionados',
      batch_progress: 'Batch ALT em curso: {{done}} / {{total}}',
      batch_selected: '{{n}} imagens selecionadas (máx. 50 por batch)',
      collection_all: 'Coleção: todas',
      compress_sub: 'Reduzir tamanho do arquivo',
      config_btn: '▼ Configurar',
      deselect_all: 'Desselecionar tudo',
      empty_filtered: 'Nenhum produto corresponde aos filtros',
      filter_all: 'Todas',
      format_label: 'Formato de imagem',
      gen_alt_btn: 'Gerar ALT',
      history_completed: 'Concluídas',
      history_empty: 'Nenhuma operação aplicada ainda.',
      history_incomplete: 'Incompletas',
      history_loading: 'A carregar histórico...',
      history_running: 'Em curso',
      history_savings: 'Poupança total',
      history_subtitle: 'Operações aplicadas no Shopify, erros e restaurações.',
      history_title: 'Histórico de otimizações',
      history_undo_label: 'Desfazer',
      last_update_label: 'Última atualização:',
      load_error: 'Erro ao carregar a lista',
      n_errors: '{{n}} erros',
      n_products: '{{n}} produtos',
      n_selected: '{{n}} selecionados',
      next_page: 'Próx.',
      no_products: 'Nenhum produto com imagem',
      no_vendor: 'Sem vendor',
      opt_batch_cancelled: 'Otimização cancelada',
      opt_batch_done: 'Otimização concluída',
      opt_batch_running: 'Otimização em curso',
      optimize_n_btn: 'Otimizar {{n}} imagens',
      optimize_one_btn: 'Otimizar imagem',
      optimizing_btn: 'Otimizando...',
      orientation_all: 'Formato: todos',
      orientation_landscape: 'Largura maior que altura',
      orientation_portrait: 'Altura maior que largura',
      orientation_square: 'Quadrado',
      page_info: 'Página {{page}} de {{total}}',
      pagination: 'Página {{page}} de {{total}}',
      prev: 'Ant.',
      publish_btn: 'Publicar',
      retry: 'Tentar novamente',
      select_all: 'Selecionar tudo',
      size_100kb: 'Arquivos com mais de 100 KB',
      size_1mb: 'Arquivos com mais de 1 MB',
      size_500kb: 'Arquivos com mais de 500 KB',
      size_all: 'KB: todos',
      status_all: 'Estado: todos',
      status_label: 'Estado:',
      status_needs: 'Para otimizar',
      status_optimized: 'Já otimizadas',
      status_stalled: 'bloqueado',
      sync_btn: 'Atualizar dados ALT do Shopify',
      sync_btn_title: 'Relê do Shopify as imagens e os ALT texts reais',
      syncing: 'A atualizar ALT...',
      template_active: 'Modo gratuito ativo — zero créditos IA. Template:',
      template_custom_label: 'Template personalizado',
      template_free_badge: '● Gratuito — sem créditos',
      template_preview_label: 'Pré-visualização:',
      template_reset: 'Restaurar predefinição',
      template_save: 'Guardar configuração',
      template_saving: 'A guardar...',
      template_vars_label: 'Variáveis disponíveis — clique para inserir:',
      timeout_msg: 'A base de dados está a processar muitos produtos. Tente novamente em alguns segundos.',
      toast_alt_ai: 'ALT gerado via IA',
      toast_alt_cancelled: 'Atualização ALT cancelada — pode reiniciá-la',
      toast_alt_empty: 'ALT vazio',
      toast_alt_from_cache: 'ALT da cache',
      toast_alt_gen_error: 'Erro de geração ALT',
      toast_alt_publish_error: 'Erro de publicação',
      toast_alt_published: 'Publicado no Shopify',
      toast_alt_save_error: 'Erro ao guardar',
      toast_alt_saved: 'ALT guardado',
      toast_alt_sync_start_error: 'Erro ao iniciar atualização ALT',
      toast_alt_sync_started: 'Atualização de dados ALT iniciada',
      toast_alt_template: 'ALT gerado via template (gratuito)',
      toast_alt_template_fallback: 'ALT via template (créditos esgotados)',
      toast_alt_update_error: 'Erro de atualização ALT',
      toast_alt_updated: 'Dados ALT atualizados: {{n}} produtos analisados',
      toast_applied: 'Imagem aplicada no Shopify',
      toast_apply_batch_done: '{{n}} imagens aplicadas no Shopify',
      toast_apply_batch_errors: 'Aplicação concluída com {{n}} erros',
      toast_apply_batch_started: 'Aplicação iniciada: {{n}} imagens. Pode mudar de seção.',
      toast_batch_alt_done: 'Batch concluído',
      toast_batch_alt_started: 'Batch iniciado: {{n}} imagens, {{c}} de cada vez',
      toast_batch_done: 'Batch concluído: {{n}} imagens otimizadas. Pode aplicá-las no Shopify.',
      toast_batch_errors: '{{n}} imagens não processadas. Tente novamente ou verifique os logs.',
      toast_batch_started: 'Batch iniciado: {{n}} imagens. Pode mudar de seção, continua em segundo plano.',
      toast_cancel_error: 'Erro de cancelamento',
      toast_no_draft: 'Nenhuma imagem otimizada para aplicar',
      toast_no_images: 'Nenhuma imagem selecionada',
      toast_no_ready: 'Nenhuma otimização pronta para aplicar',
      toast_no_store: 'Loja não disponível',
      toast_optimize_error: 'Erro de otimização',
      toast_optimized: 'Imagem otimizada. Agora pode aplicá-la no Shopify.',
      toast_select_product: 'Selecione pelo menos um produto',
      toast_template_save_error: 'Erro ao guardar o template',
      toast_template_saved: 'Configuração do template guardada',
      toast_undo_done: 'Imagem original restaurada',
      toast_undo_error: 'Erro durante a restauração',
      undoing_btn: 'A restaurar...',
      vendor_all: 'Vendor: todos',
      toast_no_product: 'Selecione um produto',
      toast_no_image: 'O produto não tem imagem',
      toast_no_preview: 'Otimize primeiro uma imagem',
      toast_apply_error: 'Erro ao aplicar no Shopify',
      n_ready: '{{n}} otimizações prontas',
      preview_hint: 'Selecione um ou mais produtos para ver a pré-visualização',
      preview_first: 'Pré-visualização do primeiro produto selecionado:',
      click_optimize_hint: 'Clique em "Otimizar" para o resultado',
      apply_single_btn: 'Aplicar',
    },
    alt_template: {
      section_title: 'Modelo ALT',
      mode_label: 'Modo de geração de texto ALT',
      textarea_label: 'Modelo personalizado',
      preview_label: 'Pré-visualização',
      vars_label: 'Variáveis disponíveis — clique para inserir',
      hint_template: 'Modo gratuito: sem créditos de IA para texto ALT.',
      hint_auto: 'Fallback automático: IA se há créditos, caso contrário modelo local.',
    },
    batch: {
      title: 'Operações em lote',
      start: 'Iniciar',
      cancel: 'Cancelar',
      subtitle: 'Processamento persistente no servidor — continua mesmo que mude de página ou feche a aba',
      locked_title: 'Operações em lote não disponíveis',
      locked_desc: 'As operações em lote estão disponíveis a partir do plano Starter. Processe centenas de produtos em paralelo com um clique.',
      upgrade_btn: 'Passar para Starter',
      op_content_label: 'Gerar conteúdo IA',
      op_content_desc: 'Descrição, SEO title, meta description, keywords',
      op_translate_label: 'Traduzir produtos',
      op_translate_desc: 'Tradução completa para o idioma selecionado',
      op_images_label: 'Otimizar imagens',
      op_images_desc: 'Redimensionamento 1:1 e compressão de imagens',
      field_description_label: 'Descrição',
      field_description_hint: '150-250 palavras',
      field_seo_title_label: 'SEO Title',
      field_seo_title_hint: 'max 60 caracteres',
      field_meta_desc_label: 'Meta Description',
      field_meta_desc_hint: '100-160 caracteres',
      field_keywords_label: 'Keywords',
      field_keywords_hint: '5-10 palavras-chave',
      count_all: 'Todos',
      status_pending: 'Na fila',
      status_running: 'Em andamento',
      status_completed: 'Concluído',
      status_failed_job: 'Falhou',
      status_cancelled: 'Cancelado',
      opt_in_progress: 'Otimização de imagens em andamento…',
      batch_in_progress: 'Lote IA em andamento…',
      images_progress: '{{done}} / {{total}} imagens',
      products_progress: '{{done}} / {{total}} produtos',
      errors_count: '{{count}} erros',
      duration_label: 'Duração: {{time}}',
      starting: 'Iniciando...',
      seo_gen_in_progress: 'Gerar + Publicar SEO em andamento',
      gen_publish_auto: 'Geração e publicação automática no Shopify',
      section_operation: 'Operação',
      section_fields: 'Campos a gerar',
      fields_selected: '{{count}}/{{total}} selecionados',
      fields_warning: 'Selecione pelo menos um campo para iniciar o lote',
      fields_hint: 'Uma única chamada IA por produto gera todos os campos selecionados — menor latência e custos reduzidos.',
      section_options: 'Opções',
      label_language: 'Idioma',
      label_tone: 'Tom',
      tone_professional: 'Profissional',
      tone_luxury: 'Luxo',
      tone_technical: 'Técnico',
      tone_conversational: 'Conversacional',
      label_target_lang: 'Idioma de destino',
      images_note: 'Redimensionamento 1:1 (800×800) + compressão qualidade 85%.',
      section_quantity: 'Quantidade de produtos',
      available_count: '{{count}} disponíveis',
      catalog_selection: '{{count}} produto(s) selecionado(s) do catálogo',
      remove_selection: 'Remover seleção',
      products_selected_count: '{{count}} produto(s) selecionado(s)',
      processing: 'Processando…',
      start_btn: 'Iniciar processamento',
      history_title: 'Histórico de lotes',
      history_subtitle: 'atualizado do BD',
      stat_running: 'Em andamento',
      stat_completed: 'Concluídos',
      stat_products_ok: 'Produtos OK',
      no_batch: 'Nenhum lote executado',
      no_batch_hint: 'Os trabalhos aparecerão aqui após o primeiro processamento',
      job_content: 'Gerar conteúdo IA',
      job_translate: 'Tradução',
      job_images: 'Otimização de imagens',
      job_products: '{{done}}/{{total}} produtos',
      log_lang: 'Idioma:',
      log_tone: 'Tom:',
      toast_completed: 'Lote concluído: {{done}}/{{total}} produtos processados',
      toast_failed: 'Lote falhado: {{count}} erros',
      toast_no_products: 'Nenhum produto disponível',
      soon_lbl: 'em breve',
      btn_analyze_seo: 'Analisar SEO',
      btn_view: 'Ver',
      toast_no_fields: 'Selecione pelo menos um campo para gerar',
      toast_images_started: 'Otimização de imagens iniciada: {{count}} produtos',
      toast_started: 'Lote iniciado: {{count}} produtos',
      toast_start_error: 'Erro ao iniciar',
      toast_cancelled: 'Lote cancelado',
      toast_cancel_error: 'Erro de cancelamento',
      fields_label: 'Campos',
      log_summary: 'Registros de operações individuais',
    },
    history: {
      title: 'Histórico',
      empty: 'Nenhuma operação encontrada',
      subtitle: 'Auditoria completa de todas as execuções IA — {{n}} operações no total',
      refresh_btn: 'Atualizar',
      total_operations: 'Total de operações',
      success_rate: 'Taxa de sucesso',
      n_successes: '{{n}} sucessos',
      credits_today: 'Créditos hoje',
      products_today: 'Produtos hoje',
      avg_duration: 'Duração média',
      last_autopilot: 'Último Autopilot',
      filters: 'Filtros',
      filters_active: 'ativos',
      reset_all: 'Redefinir tudo',
      search_placeholder: 'Buscar produto...',
      op_all: 'Todos os tipos',
      op_description: 'Descrição IA',
      op_seo_title: 'SEO Title IA',
      op_meta_description: 'Meta Description IA',
      op_batch: 'Geração em lote',
      op_translation: 'Tradução',
      op_image: 'Imagem',
      op_sync: 'Sync Shopify',
      trigger_all: 'Todos os gatilhos',
      status_all: 'Todos os status',
      status_success: 'Sucesso',
      status_partial: 'Parcial',
      status_error: 'Erro',
      th_status: 'Status',
      th_type: 'Tipo de operação',
      th_product: 'Produto',
      th_trigger: 'Gatilho',
      th_seo_delta: 'SEO Delta',
      th_credits: 'Créditos',
      th_duration: 'Duração',
      th_timestamp: 'Timestamp',
      loading: 'Carregando...',
      remove_filters: 'Remover filtros',
      load_more: 'Carregar mais (exibindo {{shown}} de {{total}})',
      details_title: 'Detalhes da execução',
      detail_op_id: 'ID da operação',
      detail_product_id: 'ID do produto',
      detail_store_id: 'Store ID',
      detail_type: 'Tipo',
      detail_trigger: 'Gatilho',
      detail_status: 'Status',
      detail_language: 'Idioma',
      detail_tone: 'Tom',
      detail_tokens: 'Tokens usados',
      detail_fields: 'Campos',
      detail_credits: 'Créditos',
      detail_duration: 'Duração',
      detail_seo_before: 'SEO antes',
      detail_seo_after: 'SEO depois',
      detail_timestamp: 'Timestamp',
      error_prefix: 'Erro: ',
      label_description: 'Descrição IA',
      label_seo_title: 'SEO Title IA',
      label_meta_description: 'Meta Description IA',
      label_keywords: 'Keywords IA',
      label_batch: 'Geração em lote',
      label_translation: 'Tradução',
      label_image: 'Otimização de imagem',
      label_sync: 'Sync Shopify',
      label_push: 'Publicação Shopify',
    },
    batch_banner: {
      errors: 'erros',
      optimizing: 'Otimização de imagens',
      optimizing_cancelled: 'Otimização cancelada',
      optimizing_completed: 'Otimização concluída',
      applying: 'Aplicando no Shopify',
      applying_cancelled: 'Aplicação cancelada',
      applying_completed: 'Aplicação concluída',
      open_images: 'Abrir Imagens',
      open_catalog: 'Abrir Catálogo',
      type_collections: 'Coleções',
      type_articles: 'Artigos',
      type_pages: 'Páginas',
      type_contents: 'Conteúdos',
      mode_publish: 'Publicação',
      mode_both: 'Gerar+Publicar',
      mode_generate: 'Geração SEO AI',
      state_cancelled: '(cancelado)',
      state_completed: '(concluído)',
    },
    app_banner: {
      expired: 'Token do Shopify expirado ou revogado.',
      reconnect_desc: 'Reconecte a app para restaurar a sincronização e publicação.',
      detected_in: 'detetado em',
      reconnect_btn: 'Reconectar agora',
    },
    review_popup: {
      greeting: 'Olá! Estou aqui 👋',
      subtitle: 'Espero que tudo esteja a correr bem com o AI Optimizer!',
      rating_title: 'Está a gostar da app?',
      rating_desc: 'A sua opinião ajuda-nos a melhorar e a chegar a outros comerciantes do Shopify.',
      rating_tap: 'Toque numa estrela para avaliar',
      star: {
        terrible: 'Terrível',
        bad: 'Não é bom',
        average: 'Médio',
        good: 'Bom!',
        excellent: 'Excelente! 🚀',
      },
      positive_title: 'Fantástico! Muito obrigado 🎉',
      positive_desc: 'Demora apenas 1 minuto!',
      negative_title: 'Obrigado pelo feedback 🙏',
      negative_desc: 'Tem ideias sobre o que poderíamos melhorar?',
      review_btn: '⭐ Deixar uma avaliação',
      close_btn: 'Fechar',
      dismiss: 'Não mostrar mais',
      skip: 'Ignorar →',
    },
    support: {
      title: 'Suporte',
      send: 'Enviar',
      placeholder: 'Escreva sua mensagem...',
    },
    editor: {
      placeholder: 'Escreva aqui...',
      bold: 'Negrito',
      italic: 'Itálico',
      underline: 'Sublinhado',
      h2: 'Título H2',
      h3: 'Título H3',
      paragraph: 'Parágrafo',
      ul: 'Lista de marcadores',
      ol: 'Lista numerada',
      blockquote: 'Citação',
      link: 'Inserir link',
      remove_format: 'Remover formatação',
      link_prompt: 'URL do link',
    },
    recommendations: {
      empty: 'Nenhuma ação crítica no momento. Ótimo trabalho!',
      filter_all_prio: 'Todas as prioridades',
      filter_all_cat: 'Todas as categorias',
      count_shown: '{{n}} ações exibidas',
      see: 'Ver',
      sev_high: 'Alta',
      sev_medium: 'Média',
      sev_low: 'Baixa',
      cat_catalog: 'Catálogo',
      missing_meta_description: '{{count}} produtos sem meta descrição',
      missing_description: '{{count}} produtos sem descrição',
      missing_alt_text: '{{count}} imagens sem texto ALT',
      missing_product_image: '{{count}} produtos sem imagem',
    },
    audit: {
      not_detected: 'Não detectado',
      disabled: 'Desativado',
      not_scanned: 'Análise não realizada',
      status_warning: 'Aviso',
      status_error: 'Erro',
      cat_performance: 'Performance',
      cat_trust: 'Confiança',
      cat_catalog: 'Catálogo',
      checks_suffix: 'verificações',
      badge_err: 'err',
      badge_warn: 'aviso',
      badge_ok: 'ok',
      value_label: 'Valor',
      checks: {
        title: { name: 'Título', hint: 'Título da página' },
        meta_description: { name: 'Meta descrição', hint: 'Meta descrição da página inicial' },
        h1: { name: 'H1', hint: 'Exatamente 1 H1 por página é ideal' },
        h2: { name: 'H2', hint: 'Pelo menos um H2 recomendado' },
        canonical: { name: 'Canonical', hint: 'URL canônica' },
        lang: { name: 'Idioma', hint: 'Atributo de idioma' },
        json_ld_structured_data: { name: 'JSON-LD / Dados Estruturados', hint: 'Dados estruturados' },
        open_graph: { name: 'Open Graph', hint: 'Meta social' },
        twitter_card: { name: 'Twitter Card', hint: 'Meta Twitter/X' },
        robots_txt: { name: 'robots.txt', hint: 'Robots' },
        sitemap_xml: { name: 'Sitemap.xml', hint: 'Sitemap' },
        status_code: { name: 'Código de status', hint: 'Código HTTP' },
        indexability: { name: 'Indexabilidade', hint: 'Indexabilidade' },
        redirects: { name: 'Redirecionamentos', hint: 'URL final' },
        https: { name: 'HTTPS', hint: 'HTTPS' },
        load_time: { name: 'Tempo de carregamento', hint: 'Medido servidor a servidor' },
        page_weight: { name: 'Peso da página', hint: 'Tamanho HTML da página inicial' },
        image_lazy_loading: { name: 'Carregamento tardio de imagens', hint: 'Imagens lazy' },
        mobile_viewport: { name: 'Viewport móvel', hint: 'Viewport móvel' },
        favicon: { name: 'Favicon', hint: 'Favicon' },
        images_with_alt: { name: 'Imagens com ALT', hint: 'Acessibilidade de imagens' },
        privacy_policy: { name: 'Política de privacidade', hint: 'Privacidade' },
        cookie_policy: { name: 'Política de cookies', hint: 'Cookie' },
        terms_conditions: { name: 'Termos e Condições', hint: 'Termos' },
        contact_page: { name: 'Página de contato', hint: 'Contato' },
        shipping_policy: { name: 'Política de envio', hint: 'Envios' },
        returns_refunds: { name: 'Devoluções e Reembolsos', hint: 'Devoluções' },
        social_links: { name: 'Links sociais', hint: 'Social' },
        products_without_description: { name: 'Produtos sem descrição', hint: 'Descrições de produto' },
        products_without_images: { name: 'Produtos sem imagens', hint: 'Imagens de produto' },
        products_without_meta_description: { name: 'Produtos sem meta descrição', hint: 'Meta descrições de produto' },
        duplicate_titles: { name: 'Títulos duplicados', hint: 'Títulos de produto' },
        duplicate_meta_descriptions: { name: 'Meta descrições duplicadas', hint: 'Meta descrições de produto' },
        thin_content_200_char: { name: 'Conteúdo raro (<200 car.)', hint: 'Conteúdo de produto' },
      },
    },
    score_card: {
      pillar_technical_seo: 'SEO Técnico',
      pillar_ux: 'UX',
      pillar_performance: 'Performance',
      pillar_trust: 'Trust',
      pillar_catalog: 'Catálogo',
      label_excellent: 'Excelente',
      label_good: 'Melhorável',
      label_critical: 'Crítico',
      no_audit_desc: 'Auditoria ainda não executada — execute a auditoria para obter SEO Técnico, UX, Trust e Performance.',
      auditing: 'Auditoria em andamento...',
      run_audit: 'Executar Auditoria 360°',
      calculated_on: 'Calculado em',
    },
    upgrade: {
      popular: '⭐ Mais Popular',
      period: '/mês',
      plan_header: 'Plano',
      cta: 'Atualizar para {{name}} — {{price}}{{period}}',
      dismiss: 'Agora não',
      feature_available: '{{feature}} está disponível a partir do plano {{plan}}.',
      reason_credits_title: 'Créditos AI esgotados',
      reason_credits_body: 'Você atingiu o limite mensal do seu plano. Atualize para continuar gerando conteúdo.',
      reason_products_title: 'Limite de catálogo atingido',
      reason_products_body: 'Seu catálogo Shopify excede o limite do plano atual. Atualize para sincronizar todos os produtos.',
      reason_feature_title: 'Funcionalidade Premium',
      reason_feature_body: 'Esta funcionalidade está disponível nos planos superiores.',
    },
    gsc: {
      connect_title: 'Conectar Google Search Console',
      connect_desc: 'Monitore impressões, cliques, CTR e posição média. Solicite reindexação após otimizações por IA.',
      connect_feat_analytics: 'Análises de pesquisa',
      connect_feat_indexing: 'Monitoramento de indexação',
      connect_feat_keywords: 'Rastreamento de keywords',
      connect_feat_sitemap: 'Gerenciador de sitemap',
      connect_btn_loading: 'Conectando...',
      connect_btn: 'Conectar conta Google',
      prop_modal_title: 'Selecionar propriedade',
      prop_modal_desc: 'Escolha a propriedade do Search Console a conectar.',
      prop_modal_empty: 'Nenhuma propriedade encontrada. Verifique se você tem propriedades no Google Search Console.',
      prop_modal_cancel: 'Cancelar',
      prop_modal_confirm: 'Confirmar',
      coming_soon_desc: 'Disponível em {{phase}}',
      top_opp_title: 'Top oportunidades SEO',
      top_opp_sub: 'Top 10 consultas por Opportunity Score',
      copy: 'Copiar',
      copied: 'Copiado!',
      badge_quick_win: '🔥 Quick Win',
      badge_low_ctr: '⚡ CTR baixo',
      badge_page_1: '🚀 Página 1',
      badge_high_imp: '📈 Alta visibilidade',
      badge_brand: '🏷️ Brand',
      qt_category: 'Categoria',
      qt_product: 'Produto',
      qt_generic: 'Genérico',
      qt_info: 'Info',
      qt_brand: 'Brand',
      seo_analysis: 'Análise SEO',
      generating_ai: 'Gerando análise IA...',
      analysis_error: 'Erro ao gerar análise. Tente novamente mais tarde.',
      estimated_value: 'Valor estimado',
      clicks_monthly: 'Cliques potenciais/mês',
      ctr_at_pos: 'CTR na pos. {{pos}}',
      traffic_increase: 'Aumento de tráfego',
      current_stats: 'Atual: {{clicks}} cliques/mês · +{{pts}} pp CTR estimado',
      priority_action: 'Ação prioritária',
      content_opt: 'Otimização de conteúdo',
      title_seo: 'Title SEO',
      title_chars: '(50–60 caracteres)',
      title_copied: 'Title copiado!',
      h1_suggested: 'H1 sugerido',
      h1_page_title: '(título da página)',
      h1_copied: 'H1 copiado!',
      meta_desc: 'Meta Description',
      meta_chars: '(150–160 caracteres)',
      meta_copied: 'Meta copiada!',
      faq_all_copied: 'Todos os FAQs copiados!',
      faq_suggested: 'FAQs sugeridas',
      copy_all: 'Copiar tudo',
      faq_copied: 'FAQ copiada!',
      related_kw: 'Keywords relacionadas',
      click_to_copy: '· clique para copiar',
      kw_copied: '"{{kw}}" copiada!',
      tech_suggestions: 'Sugestões técnicas',
      copy_keyword: 'Copiar keyword',
      kw_copied_plain: 'Keyword copiada!',
      shopify_products: 'Produtos Shopify',
      search_store: 'Pesquisar na loja',
      optimize_content: 'Otimizar conteúdo',
      col_impressions: 'Impressões',
      col_position: 'Posição',
      no_queries: 'Nenhuma consulta encontrada com os filtros atuais.',
      ai_panel_title: 'Sugestões IA',
      analyze_query: 'Analisar consulta →',
      sugg_title_improvement: 'Title tag',
      sugg_meta: 'Meta description',
      sugg_content_gap: 'Conteúdo ausente',
      sugg_schema: 'Schema markup',
      sugg_links: 'Links internos',
      opp_load_err: 'Erro ao carregar oportunidades SEO',
      cache_updated: 'Cache atualizado — recarregando dados',
      cache_error: 'Erro ao atualizar cache',
      loading_data: 'Carregando dados do Search Console...',
      load_error_title: 'Não foi possível carregar as oportunidades',
      retry: 'Tentar novamente',
      tracked_queries: 'Consultas rastreadas',
      sku_excluded: '{{n}} SKU/EAN excluídas',
      total_impressions: 'Impressões totais (28d)',
      total_clicks: 'Cliques totais (28d)',
      avg_ctr: 'CTR médio',
      ai_generating: 'Gerando análise IA...',
      ai_generating_sub: 'As sugestões IA aparecerão aqui em instantes.',
      no_ai_insights: 'Nenhum insight IA disponível',
      no_ai_insights_sub: 'Não foram encontradas consultas com oportunidades de otimização significativas.',
      filter_all: 'Todas ({{n}})',
      search_placeholder: 'Buscar consultas...',
      refresh_title: 'Atualizar dados',
      page_prev: '← Ant.',
      page_info: 'Pág. {{page}} / {{total}} · {{count}} consultas',
      page_next: 'Próx. →',
      footer_note: 'Dados Search Console últimos 28 dias · cache 6h · propriedade: {{url}}',
      footer_excluded: ' · {{n}} SKU/EAN excluídas',
      verdict_pass: 'Indexada',
      verdict_fail: 'Não indexada',
      verdict_neutral: 'Excluída',
      stato_title: 'Status Google — Fontes de dados',
      in_sitemap: 'No sitemap',
      sitemap_registered_lbl: 'Sitemaps registrados',
      sitemap_errors_lbl: 'Erros de sitemap',
      with_impressions: 'Com impressões',
      search_appear_note: 'Páginas aparecidas na busca · {{days}}d',
      not_real_indexed: '≠ páginas realmente indexadas',
      index_estimate_lbl: 'Estimativa de indexação',
      estimate_unavail: 'Estimativa disponível após 200 URLs inspecionadas. Inicie o scan em lote para coletar a amostra.',
      inspected_lbl: 'Inspecionadas',
      indexed_confirmed: 'Indexadas confirmadas',
      not_indexed_lbl: 'Não indexadas',
      excluded_lbl: 'Excluídas',
      certain_data: 'Dado certo para URLs inspecionadas',
      batch_title: 'Scan em lote — Inspection API',
      batch_priority: 'Prioridade Analytics',
      batch_progress: 'Progresso da inspeção do sitemap',
      batch_stopping: 'Parando…',
      batch_running: 'Escaneando…',
      batch_starting: 'Iniciando...',
      batch_done_lbl: 'Sitemap concluído ✓',
      batch_start_btn: 'Iniciar scan ({{n}} disponíveis)',
      batch_timeout: 'Timeout — clique para redefinir',
      batch_stopping_wait: 'Parando — por favor aguarde…',
      batch_stop_btn: 'Parar scan',
      batch_remaining: '{{n}} URLs ainda a inspecionar',
      batch_quota_out: 'Cota diária esgotada — tente novamente amanhã',
      batch_start_err: 'Erro ao iniciar o scan',
      batch_complete: 'Scan concluído: {{n}} URLs inspecionadas',
      dq_title: 'Detalhes técnicos da API',
      dq_api_status: 'Status da API',
      dq_daily_quota: 'Cota diária',
      dq_used_today: 'Usadas hoje',
      dq_remaining: 'Restantes',
      dq_history: 'Histórico de inspeções',
      dq_completion: 'Conclusão',
      dq_days_est: 'dias estimados',
      dq_start_for_eta: 'Iniciar scan para calcular ETA',
      sm_no_sitemap: 'Nenhum sitemap encontrado',
      sm_no_sitemap_desc: 'Adicione um sitemap.xml ao Google Search Console para monitorar a indexação.',
      sm_submit_ok: 'Sitemap enviado ao Google',
      sm_in_progress: 'Calculando…',
      sm_submit_btn: 'Enviar',
      insp_title: 'Inspecionar URL',
      insp_quota: '{{used}}/{{limit}} inspeções hoje',
      insp_loading: 'Inspecionando...',
      insp_btn: 'Inspecionar',
      insp_domain_lbl: 'Domínio property:',
      insp_domain_note: 'A URL inspecionada deve pertencer a ele',
      insp_last_crawl: 'Último crawl',
      insp_indexing: 'Indexação',
      insp_yes: 'Sim',
      insp_no: 'Não',
      insp_canonical_decl: 'Canonical declarado',
      insp_canonical_diff: '⚠ Canonical Google (diferente)',
      insp_noindex: 'noindex detectado',
      insp_open_gsc: 'Abrir no Search Console',
      insp_err: 'Erro de inspeção de URL',
      cov_title: 'Coverage — Motivos',
      cov_real_data: 'Dados reais — Inspection API',
      cov_conf_high: 'Alta confiabilidade',
      cov_conf_medium: 'Confiabilidade média',
      cov_conf_low: 'Baixa confiabilidade',
      cov_updated: 'Atualizado:',
      cov_deselect: 'Desselecionar',
      cov_inspected_note: 'URLs inspecionadas · clique para filtrar',
      cov_none_inspected: 'Nenhuma inspeção',
      cov_no_data: 'Nenhum dado de coverage disponível',
      cov_no_data_desc: 'Os motivos de não indexação são criados automaticamente a cada inspeção de URL. Use "Iniciar scan automático" para preencher esta seção.',
      cov_solution: 'Solução recomendada',
      cov_filter_active: 'Filtro ativo no histórico',
      ih_worklist: 'Lista de tarefas SEO',
      ih_history: 'Histórico de inspeções',
      ih_filter_coverage: 'Filtro Coverage',
      ih_tab_all: 'Todas',
      ih_tab_not_ind: 'Não ind.',
      ih_tab_indexed: 'Indexadas',
      ih_tab_excluded: 'Excluídas',
      ih_tab_errors: 'Erros',
      ih_tab_with_imp: 'Com impr.',
      ih_tab_products: 'Produtos',
      ih_tab_collections: 'Coleções',
      ih_sort_priority: '↓ Prioridade',
      ih_sort_impressions: '↓ Impressões',
      ih_sort_clicks_est: '↓ Cliques est.',
      ih_sort_date: '↓ Data',
      ih_sort_state: '↓ Estado GSC',
      ih_clear: 'Limpar',
      ih_search: 'Pesquisar URL…',
      ih_open: 'Abrir',
      ih_indexing_state: 'Estado de indexação',
      ih_canonical_diff: '⚠ Canonical Google (escolhido, diferente)',
      ih_canonical_same: 'Canonical Google (igual)',
      ih_ai_fix: 'Otimizar com AI →',
      ih_total: '{{n}} URLs · {{total}} no total',
      ih_est_clicks: '· +{{n}} cliques/mês estimados',
      iai_title: 'Sugestões AI — Indexação',
      iai_filter_note: '· clique para filtrar',
      iai_prio_high: 'Alta prioridade',
      iai_prio_medium: 'Prioridade média',
      iai_prio_low: 'Baixa prioridade',
      iai_causes: 'Possíveis causas:',
      iai_actions: 'Ações recomendadas:',
      fix_apply_all: 'Aplicar tudo',
      fix_applied: 'Aplicado',
      fix_suggestion: 'Sugestão',
      fix_chars: 'caracteres',
      fix_content_impr: 'Melhorias de conteúdo',
      fix_int_links: 'Links internos sugeridos',
      fix_open_url: 'Abrir URL',
      fix_close: 'Fechar',
      fix_seo_opt: 'Otimização SEO',
      trend_title: 'Tendência de indexação',
      trend_updated: 'Atualizado em',
      trend_coverage: 'Cobertura',
      trend_30d_kpi: 'Tendência 30d',
      trend_no_data: 'Dados históricos em construção',
      trend_no_data_desc: 'A tendência estará disponível após coletar pelo menos 2 snapshots.',
      trend_one_snap: '1 snapshot coletado de 2.',
      trend_start_scan: 'Inicie um scan em lote para começar.',
      trend_ind: 'ind.',
      trend_not_ind: 'não ind.',
      trend_snap_note: 'Snapshot por scan',
      ic_loading: 'Carregando dados de indexação...',
      ic_load_err: 'Não foi possível carregar os dados de indexação',
      ic_clear_confirm: 'Limpar todo o histórico de inspeções?',
      ic_cleared: 'Histórico limpo',
      ic_clear_err: 'Erro ao limpar',
      ic_seo_opp: 'Oportunidades SEO — Executive Summary',
      ic_recoverable: 'URLs recuperáveis',
      ic_open_worklist: '⚡ Abrir lista de tarefas →',
      ic_view_all: 'Ver todas →',
      ic_crawled_ni: 'Rastreadas – não indexadas',
      ic_crawled_ni_note: 'Google as conhece mas não as serve',
      ic_discovered_ni: 'Descobertas – não indexadas',
      ic_discovered_ni_note: 'Encontradas mas nunca rastreadas',
      ic_with_imp_ni: 'Com impressões GSC',
      ic_with_imp_ni_note: 'Têm tráfego mas não estão indexadas',
      ic_other_ni: 'Outras não indexadas',
      ic_other_ni_note: 'Desconhecidas pelo Google ou erros',
      ic_refresh: 'Atualizar',
      rh_title: 'Histórico de alterações',
      rh_versions: 'versões',
      rh_confirm: "Restaurar a versão de {{date}}?\n\nAs alterações atuais do editor serão substituídas.",
      rh_restored_ok: 'v{{v}} restaurada no tema Shopify',
      rh_restored_editor: 'Versão v{{v}} carregada no editor — clique em Salvar para aplicá-la',
      rh_restore_err: 'Erro de restauração',
      rh_current: 'atual',
      rh_initial: 'Versão inicial',
      rh_no_diff: 'Sem alterações de texto',
      rh_more_added: '+ {{n}} mais adicionadas',
      rh_more_removed: '- {{n}} mais removidas',
      rh_restore_btn: 'Restaurar',
      rb_load_err: 'Erro ao carregar robots.txt',
      rb_save_err: 'Erro ao salvar',
      rb_analyze_err: 'Erro de análise',
      rb_score_good: 'Excelente',
      rb_score_ok: 'Precisa melhorar',
      rb_score_bad: 'Crítico',
      rb_analysis_title: 'Análise SEO Robots',
      rb_analyzing: 'Analisando…',
      rb_analyze: 'Analisar',
      rb_analyze_hint: 'Clique em "Analisar" para detectar automaticamente problemas de SEO e oportunidades de otimização',
      rb_no_issues: 'Nenhum problema detectado',
      rb_no_issues_desc: 'Seu robots.txt segue as melhores práticas do Shopify',
      rb_critical: 'CRÍTICO',
      rb_warning: 'AVISO',
      rb_validation_title: 'Validação Robots.txt',
      rb_reload: 'Recarregar',
      rb_editor_title: 'Editor Robots.txt',
      rb_modified: 'Modificado',
      rb_diff_close: 'Fechar diff',
      rb_editor_restore: 'Restaurar',
      rb_saving: 'Salvando…',
      rb_save: 'Salvar',
      rb_blocking_warning: '🚨 VOCÊ ESTÁ BLOQUEANDO TODO O SITE — "Disallow: /" impede o Google de indexar qualquer página',
      rb_diff_preview: 'Visualização de alterações:',
      rb_opportunity: 'OPORTUNIDADE',
      rb_checker_title: 'Verificar URL',
      rb_check_btn: 'Verificar',
      rb_allowed: 'Permitido',
      rb_blocked: 'Bloqueado',
      rb_sitemaps_title: 'Sitemaps declarados',
      ll_history_title: 'Histórico LLMs.txt',
      ll_generated: 'Gerado',
      ll_restored_editor: 'Versão v{{v}} carregada no editor — clique em Publicar para aplicá-la',
      ll_load_err: 'Erro ao carregar llms.txt',
      ll_generate_err: 'Erro de geração',
      ll_saved_ok: 'LLMs.txt publicado e verificado no tema Shopify',
      ll_not_configured: 'Não configurado',
      ll_validation_title: 'Validação LLMs.txt',
      ll_not_found: 'Nenhum llms.txt encontrado no site. Use "Gerar do Shopify" para criá-lo automaticamente.',
      ll_what_title: 'O que é LLMs.txt?',
      ll_what_desc: 'O padrão /llms.txt é um arquivo markdown que ajuda modelos AI (ChatGPT, Claude, Perplexity, Gemini) a entender seu site e citá-lo corretamente nas respostas. Aumenta a visibilidade nos motores de resposta AI.',
      ll_editor_title: 'Editor LLMs.txt',
      ll_generating: 'Gerando…',
      ll_generate_btn: 'Gerar do Shopify',
      tab_jsonld: 'JSON-LD',
      jl_load_err: 'Erro ao carregar visão geral JSON-LD',
      jl_sec_overview: 'Visão geral',
      jl_sec_schemas: 'Esquemas',
      jl_sec_problems: 'Problemas',
      jl_sec_generate: 'Otimização IA',
      jl_sec_preview: 'Pré-visualização JSON',
      jl_sec_validate: 'Validação',
      jl_sec_bulk: 'Operações em massa',
      jl_sec_stats: 'Estatísticas',
      jl_rich_results: 'Elegibilidade Rich Results',
      jl_eligible: 'Elegíveis',
      jl_warnings: 'Parciais',
      jl_not_eligible: 'Não elegíveis',
      jl_field_coverage: 'Cobertura de campos',
      jl_what_title: 'O que é JSON-LD?',
      jl_what_desc: 'JSON-LD é o formato recomendado pelo Google para dados estruturados. Ativa Rich Results na pesquisa (estrelas, preços, breadcrumbs) e ajuda os modelos de IA a entender melhor os seus produtos.',
      jl_score_poor: 'Cobertura fraca',
      jl_schemas_title: 'Tipos de esquema suportados',
      jl_status_valid: 'Válido',
      jl_status_partial: 'Parcial',
      jl_status_missing: 'Não configurado',
      jl_valid_items: 'válidos',
      jl_issues: 'problemas',
      jl_google_test: 'Testar no Google Rich Results',
      jl_google_test_desc: 'Após gerar o seu JSON-LD, teste-o diretamente na ferramenta do Google para verificar a elegibilidade.',
      jl_problems_title: 'Problemas de diagnóstico',
      jl_no_problems: 'Nenhum problema crítico encontrado. A sua cobertura JSON-LD está boa!',
      jl_products_affected: 'produtos afetados',
      jl_sev_critical: 'Crítico',
      jl_sev_warning: 'Aviso',
      jl_prob_brand: 'Marca / fornecedor ausente',
      jl_prob_desc: 'Descrição ausente',
      jl_prob_image: 'Imagem do produto ausente',
      jl_prob_sku: 'SKU ausente',
      jl_prob_gtin: 'GTIN / código de barras ausente',
      jl_prob_meta: 'Meta descrição ausente',
      jl_prob_offers: 'Preço não no JSON-LD (requer snippet no tema Shopify)',
      jl_problems_tip: 'Corrija os campos ausentes na seção Produtos ou use a Otimização IA para preenchê-los automaticamente.',
      jl_gen_title: 'Gerar JSON-LD',
      jl_schema_type: 'Tipo de esquema',
      jl_product_id: 'ID do produto (deixe vazio para exemplo)',
      jl_use_ai: 'Usar enriquecimento IA (GPT)',
      jl_gen_btn: 'Gerar JSON-LD',
      jl_gen_ok: 'JSON-LD gerado',
      jl_gen_err: 'Erro de geração',
      jl_copied: 'Copiado!',
      jl_copy: 'Copiar',
      jl_preview_title: 'Pré-visualização JSON-LD',
      jl_preview_err: 'Erro ao carregar pré-visualização',
      jl_load_preview: 'Carregar produto de exemplo',
      jl_preview_empty: 'Clique em "Carregar produto de exemplo" para pré-visualizar todos os esquemas JSON-LD',
      jl_val_title: 'Validação de esquema local',
      jl_invalid_json: 'JSON inválido',
      jl_val_btn: 'Validar JSON-LD',
      jl_val_clear: 'Limpar',
      jl_val_ok: 'Válido — elegível para Rich Results',
      jl_val_fail: 'Validação falhou',
      jl_val_note: 'Este validador verifica os requisitos do schema.org. Para o teste oficial do Google use o Rich Results Test.',
      jl_val_err: 'Erro de validação',
      jl_bulk_title: 'Operações em massa',
      jl_bulk_gen: 'Gerar tudo',
      jl_bulk_gen_desc: 'Construir Product JSON-LD para cada produto e guardar na DB',
      jl_bulk_val: 'Validar tudo',
      jl_bulk_val_desc: 'Executar validação schema.org no JSON-LD existente',
      jl_bulk_fix: 'Corrigir e enriquecer',
      jl_bulk_fix_desc: 'Reconstruir JSON-LD para produtos com erros',
      jl_bulk_started: 'Operação em massa iniciada',
      jl_bulk_err: 'Erro ao iniciar operação em massa',
      jl_bulk_running: 'Em progresso',
      jl_bulk_done: 'Concluído',
      jl_bulk_stop: 'Parar',
      jl_bulk_stopped: 'Operação em massa parada',
      jl_errors: 'erros',
      jl_stat_total: 'Produtos totais',
      jl_stat_eligible: 'Elegíveis Rich Results',
      jl_stat_gen_today: 'Gerados hoje',
      jl_stat_fixed: 'Corrigidos hoje',
      jl_coverage_by_type: 'Cobertura por tipo de conteúdo',
      jl_type: 'Tipo',
      jl_total: 'Total',
      jl_valid2: 'Válidos',
      jl_missing2: 'Ausentes',

      ll_revert: 'Reverter',
      ll_publishing: 'Publicando…',
      ll_publish: 'Publicar',
      lp_filter_url: 'Filtrar URL…',
      lp_copied: 'Copiado',
      lp_broken_empty: 'Nenhum link quebrado detectado',
      lp_broken_empty_sub: 'Todas as URLs da loja são acessíveis (404 / 410 / timeout)',
      lp_timeout: 'Timeout — sem resposta em 12s',
      lp_ratelimit_empty: 'Nenhuma limitação de taxa detectada',
      lp_ratelimit_empty_sub: 'O servidor não limitou as requisições do scanner',
      lp_ratelimit_note: 'Página acessível mas o servidor respondeu 429 durante o scan',
      lp_server_empty: 'Nenhum erro de servidor detectado',
      lp_server_empty_sub: 'Todas as URLs respondem corretamente (sem 5xx)',
      lp_server_note: 'HTTP {{code}} — erro do lado do servidor',
      lp_redirect_empty: 'Nenhum redirecionamento detectado',
      lp_redirect_total: 'Redirecionamentos totais',
      lp_chains: 'Cadeias (>1 salto)',
      lp_loops: 'Loops detectados',
      lp_chains_header: 'Cadeias de redirecionamento',
      lp_chains_badge: '{{n}} cadeias múltiplas',
      lp_final_status: 'Status final:',
      lp_canon_ok: 'Correto',
      lp_canon_miss: 'Ausente',
      lp_canon_wrong: 'URL incorreta',
      lp_canon_cross: 'Cross-domain',
      lp_canon_redir: 'Canonical→redirecionamento',
      lp_canon_action_missing: 'Adicionar uma tag canonical na seção head da página.',
      lp_canon_action_wrong: 'Corrigir o canonical para apontar para o URL definitivo desta página.',
      lp_canon_action_cross: 'O canonical aponta para um domínio externo. Verificar se é intencional ou um erro.',
      lp_canon_action_redir: 'O canonical aponta para um URL que redireciona. Atualizar com o destino final do redirect.',
      lp_canon_no_data: 'Dados canonical não disponíveis — iniciar a digitalização',
      lp_canon_issues: 'Problemas Canonical ({{n}})',
      lp_canon_no_issues: 'Nenhum problema canonical detectado',
      lp_canon_sample: 'Amostra analisada: {{n}} URL da sua loja (produtos, coleções, páginas, artigos)',
      il_tab_orphans: 'Páginas órfãs',
      il_tab_weak: 'Links fracos',
      il_tab_deep: 'Páginas profundas',
      il_kpi_weak: 'Links fracos ≤2',
      il_kpi_deep: 'Págs. profundas',
      il_orphan_empty: 'Sem páginas órfãs',
      il_orphan_empty_sub: 'Todas as páginas recebem pelo menos um link interno',
      il_orphan_header: 'Páginas sem links de entrada ({{n}})',
      il_weak_empty: 'Sem páginas com links fracos',
      il_weak_empty_sub: 'Todas as páginas recebem 3+ links internos',
      il_weak_header: 'Páginas com 1–2 links de entrada ({{n}})',
      il_anchor_empty: 'Textos âncora otimizados',
      il_anchor_empty_sub: 'Nenhuma âncora genérica, vazia ou duplicada detectada',
      il_anchor_generic: 'Âncoras genéricas',
      il_anchor_generic_desc: 'Textos como "clique aqui", "aqui", "descobrir"',
      il_anchor_empty_type: 'Âncoras vazias',
      il_anchor_empty_desc: 'Links sem texto descritivo',
      il_anchor_dup: 'Âncoras duplicadas',
      il_anchor_dup_desc: 'Mesmo texto → URLs diferentes',
      il_anchor_lbl_gen: 'Genérico',
      il_anchor_lbl_empty: 'Vazio',
      il_anchor_lbl_dup: 'Duplicado',
      il_deep_empty: 'Sem páginas muito profundas',
      il_deep_empty_sub: 'Todas as páginas são acessíveis em ≤3 cliques a partir da página principal',
      il_deep_header: 'Páginas a >3 cliques da página principal ({{n}})',
      il_deep_note: 'Páginas com ∞ não são acessíveis via links internos. Adicioná-las a menus ou coleções.',
      il_hub_empty: 'Sem dados hub disponíveis',
      il_hub_empty_sub: 'Iniciar uma digitalização para identificar páginas hub',
      il_hub_header: 'Páginas hub — as mais ligadas internamente',
      il_hub_count: '{{n}} links internos de entrada',
      lm_active: 'Ativo',
      lm_not_installed: 'Não instalado',
      lm_install_hint: 'Instalar no tema para monitorar a navegação real sem crawling',
      lm_refresh: 'Atualizar',
      lm_clear: 'Limpar dados',
      lm_remove: 'Remover do tema',
      lm_installing: 'Instalando…',
      lm_install: 'Instalar no tema',
      lm_tab_404: 'Erros 404',
      lm_tab_redirect: 'Oport. Redirecionamento',
      lm_tab_top: 'Páginas principais',
      lm_kpi_visits: 'Total de visitas',
      lm_kpi_404s: 'Erros 404 reais',
      lm_no_404: 'Nenhum erro 404 detectado pelos usuários',
      lm_visits: 'visitas',
      lm_theme_prefix: 'Tema: ',
      lm_last_activity: 'Última atividade: ',
      lm_no_activity: 'sem visitas ainda',
      lm_installed: 'Monitor instalado no tema "{{name}}"',
      lm_err_install: 'Erro de instalação',
      lm_confirm_remove: 'Remover o script de monitoramento do tema ativo?',
      lm_removed: 'Script removido do tema',
      lm_err_remove: 'Erro de remoção',
      lm_confirm_clear: 'Excluir todos os dados de monitoramento coletados?',
      lm_cleared: 'Dados excluídos',
      lm_err_clear: 'Erro ao excluir',
      lm_modal_title: 'Criar Redirecionamento 301',
      lm_modal_source: 'URL de origem (404)',
      lm_modal_dest: 'Destino',
      lm_redirect_created: 'Redirecionamento 301 criado no Shopify',
      lm_err_redirect: 'Erro ao criar redirecionamento',
      lm_create_redirect: 'Criar Redirecionamento',
      lm_creating: 'Criando…',
      lm_cancel: 'Cancelar',
      lm_info_title: 'Como funciona o Live Monitor',
      lm_info_1: 'O botão "Instalar no tema" adiciona automaticamente um script leve ao tema ativo via Shopify Themes API',
      lm_info_2: 'Para cada visita real coleta: URL, tipo de página, links internos, erros 404, referenciador interno',
      lm_info_3: 'Zero crawling — sem HTTP 429 — dados de visitantes reais em tempo real',
      lm_info_4: 'Constrói progressivamente o mapa de links internos e detecta páginas órfãs',
      lm_no_redirect: 'Nenhum redirecionamento necessário',
      lm_no_redirect_hint1: 'O Live Monitor ainda não registrou visitas. Oportunidades de redirecionamento aparecem quando usuários reais encontram páginas 404.',
      lm_no_redirect_hint2: 'Em {{n}} visitas analisadas nenhum usuário encontrou páginas 404. Ótimo!',
      lm_toolbar_ai: '{{count}} URL · {{ai}} com sugestão IA',
      lm_toolbar_ignored: '· {{n}} ignorados',
      lm_sort_visits: 'Visitas',
      lm_sort_date: 'Data',
      lm_selected: '{{n}} selecionado(s)',
      lm_no_match: 'sem correspondência automática',
      lm_create: 'Criar',
      lm_ignore: 'Ignorar',
      lm_err: 'Erro',
      lm_bulk_ignored: '{{n}} URL ignorada(s)',
      lm_bulk_created: '{{n}} redirecionamentos criados',
      lm_errors: 'erros',
      ls_scan_started: 'Análise iniciada — será concluída em segundo plano',
      ls_scan_err: 'Erro ao iniciar análise',
      ls_last_scan: 'Última análise: {{date}} · {{n}} URL',
      ls_no_scan_desc: 'Nenhuma análise realizada — detecta links quebrados, redirecionamentos, canônicos, páginas órfãs',
      ls_scanning: 'Analisando…',
      ls_rescan: 'Reanalisar',
      ls_start_scan: 'Iniciar análise',
      ls_canonical_issues: 'Problemas Canônicos',
      ls_scan_details: 'Detalhes da análise',
      ls_stat_total: 'URLs totais',
      ls_stat_errors: 'Erros',
      ls_no_scan: 'Nenhuma análise realizada',
      ls_no_scan_long: 'Inicie a análise para detectar links quebrados, cadeias de redirecionamento, problemas canônicos e páginas órfãs sem links de entrada',
      ls_first_scan: 'Iniciar primeira análise',
      db_gsc_connected: 'Google Search Console conectada!',
      db_gsc_err: 'Erro de conexão GSC: {{code}}',
      db_props_err: 'Não foi possível carregar as propriedades GSC',
      db_oauth_hint: 'Complete a autorização do Google na nova aba. A página será atualizada automaticamente.',
      db_conn_err: 'Erro de conexão GSC',
      db_prop_selected: 'Propriedade selecionada: {{url}}',
      db_prop_err: 'Erro ao selecionar propriedade',
      db_confirm_disconnect: 'Desconectar Google Search Console?',
      db_disconnected: 'GSC desconectada',
      db_disconnect_err: 'Erro de desconexão',
      db_connected: 'Search Console conectada',
      db_no_property: 'Nenhuma propriedade selecionada',
      db_not_connected: 'Não conectada',
      db_connect_hint: 'Conecte o GSC para desbloquear análises e monitoramento',
      db_change_prop: 'Mudar propriedade',
      db_disconnect: 'Desconectar',
      db_connect: 'Conectar GSC',
      db_idx_subtitle: 'Qualidade técnica SEO & indexação',
      db_lbl_gsc: 'GSC conectada',
      db_lbl_sitemap: 'Sitemaps enviados',
      db_lbl_indexed: 'URLs indexadas',
      db_health_real: 'Baseado em dados reais do Search Console',
      db_health_proxy: 'Baseado na qualidade do catálogo — conecte GSC para dados reais',
      db_lbl_position: 'Posição',
      db_lbl_trend: 'Tendência 28d',
      db_lbl_errors: 'Erros',
      db_connect_score: 'Conecte GSC para calcular o score',
      db_proxy_note: 'Proxy catálogo',
      db_stat_excluded: 'URLs excluídas',
      db_stat_seo_score: 'Score SEO médio',
      db_catalog_title: 'Saúde do catálogo',
      db_cat_alt: 'Texto ALT de imagens',
      db_cat_keywords: 'Keywords ausentes',
      db_cat_no_kw: '{{n}} produtos sem keywords',
      db_cat_count: '{{n}} / {{total}} produtos',
      tab_opportunities: 'Oportunidades SEO',
      tab_indexing: 'Indexação',
      locked_available: 'Disponível a partir do plano {{plan}}',
      locked_upgrade: 'Mudar para o plano {{plan}}',
      main_subtitle: 'SEO técnico · Indexação · Analytics · Automação IA',
      phase_3: 'Fase 3',
      interval_all: 'Tudo',
      click_monthly_est: 'cliques/mes est.',
      fix_title_updated: 'Tag de titulo atualizada',
      fix_meta_updated: 'Meta descricao atualizada',
      fix_both_updated: 'Titulo e meta descricao atualizados no Shopify',
      fix_apply_err: 'Erro de aplicacao',
      rb_save_ok: 'Robots.txt salvo e verificado no tema Shopify',
      rb_draft_with_err: 'Rascunho salvo ({{err}})',
      rb_draft_manual: 'Rascunho salvo — siga as instrucoes para aplica-lo ao tema',
      rb_critical_confirm: '🚨 AVISO CRITICO 🚨\n\nSeu robots.txt contem "Disallow: /" que BLOQUEIA COMPLETAMENTE o site:\nGoogle, Bing e todos os bots nao poderao rastrear nenhuma pagina.\n\nIsso pode causar a remocao do site dos resultados de pesquisa.\n\nVoce tem ABSOLUTA CERTEZA de que deseja prosseguir?',
      scan_err: 'Erro de varredura: {{msg}}',
      sm_send_err: 'Erro de envio',
      unknown_err: 'Desconhecido',
      dq_today: 'Hoje',
      dq_7d: 'Últimos 7 dias',
      dq_30d: 'Últimos 30 dias',
      dq_daily_avg: 'Média diária',
      dq_at_pace: 'no ritmo de ~{{n}}/dia',
      job_stopped: 'Parado em {{n}} URLs processadas',
      job_inspected: '{{n}} inspecionadas',
      job_errors: 'erros',
      quota_remaining: 'Cota restante:',
      lk_trend: 'Tendência de indexação',
      lk_batch: 'Inspeção em lote (varredura massiva)',
      lk_ai: 'Sugestões de IA de indexação',
      footer_apis: 'Sitemaps API + Search Analytics + Inspection API',
      prod_status_lbl: 'Status:',
      prod_desc_lbl: 'Descrição:',
      prod_missing: 'AUSENTE',
      state_disc: 'Desc.',
      state_crawl: 'Rastreada',
      insp_api_real: 'Inspection API ✓ real',
      sm_count: '{{n}} sitemaps',
      sm_reliability: 'Confiabilidade:',
      conf_high: 'Alta',
      conf_medium: 'Média',
      conf_low: 'Baixa',
      sm_urls: 'URLs no sitemap',
      sm_sample: 'Amostra',
      sm_est_indexed: 'Indexadas estim.',
      sm_est_nonidx: 'Não indexadas estim.',
      sm_coverage: 'Cobertura estim. ⓘ',
      sm_idx_of: '~{{n}} indexadas de {{t}} URLs do sitemap',
      sm_cov_est: 'Cobertura estimada:',
      sm_margin_err: 'margem de erro',
      sm_indexed_of: 'indexadas de',
      sm_sampled: 'amostradas',
      sm_th_sitemap: 'Sitemap',
      sm_th_submitted: 'Enviadas',
      sm_th_indexed: 'Indexadas',
      sm_th_gap: 'Lacuna',
      sm_th_coverage: 'Cobertura',
      sm_th_warning: 'Aviso',
      sm_th_errors: 'Erros',
      sm_th_lastmod: 'Última atualização',
      sm_th_actions: 'Ações',
      rb_verified_result: 'Salvo e verificado no tema Shopify ({{theme}}) — arquivo:',
      rb_draft_result: 'Rascunho salvo. Para aplicar manualmente: Shopify Admin → Temas → Editar código →',
      ll_draft_result: 'Rascunho salvo. Para aplicar manualmente: Shopify Admin → Temas → Editar código →',
      ls_section_redirects: 'Gestor de redirecionamentos',
      rm_tab: 'Gestor de redirecionamentos',
      rm_subtitle: 'Gerencie todos os redirecionamentos da sua loja em um só lugar.',
      rm_kpi_total: 'Regras totais',
      rm_kpi_active: 'Redirecionamentos ativos',
      rm_kpi_pending: '404 pendentes',
      rm_kpi_hits: 'Hits (30d)',
      rm_kpi_chains: 'Cadeias',
      rm_kpi_loops: 'Loops',
      rm_section_rules: 'Regras',
      rm_section_suggest: 'Sugestões IA',
      rm_section_health: 'Saúde',
      rm_section_import: 'Importar / Exportar',
      rm_section_history: 'Histórico',
      rm_create_title: 'Criar redirecionamento',
      rm_edit_title: 'Editar redirecionamento',
      rm_old_url: 'URL antiga',
      rm_new_url: 'URL nova',
      rm_old_url_ph: '/caminho-antigo',
      rm_new_url_ph: '/caminho-novo',
      rm_type: 'Tipo',
      rm_type_301: '301 – Permanente',
      rm_type_302: '302 – Temporário',
      rm_notes: 'Notas',
      rm_save: 'Salvar',
      rm_cancel: 'Cancelar',
      rm_create_ok: 'Redirecionamento criado com sucesso.',
      rm_edit_ok: 'Redirecionamento atualizado com sucesso.',
      rm_create_err: 'Erro ao criar redirecionamento.',
      rm_edit_err: 'Erro ao salvar redirecionamento.',
      rm_dup_err: 'Já existe um redirecionamento para esta URL de origem.',
      rm_empty_err: 'As URLs de origem e destino são obrigatórias.',
      rm_same_err: 'As URLs de origem e destino não podem ser iguais.',
      rm_search_ph: 'Pesquisar URLs…',
      rm_filter_all: 'Todos',
      rm_filter_active: 'Ativos',
      rm_filter_disabled: 'Desativados',
      rm_create_btn: 'Criar redirecionamento',
      rm_selected_items: '{{count}} selecionados',
      rm_bulk_enable: 'Ativar',
      rm_bulk_disable: 'Desativar',
      rm_bulk_delete: 'Excluir',
      rm_bulk_export: 'Exportar CSV',
      rm_bulk_ok: 'Operação concluída.',
      rm_table_old: 'URL antiga',
      rm_table_new: 'URL nova',
      rm_table_type: 'Tipo',
      rm_table_hits: 'Hits',
      rm_table_status: 'Status',
      rm_table_actions: 'Ações',
      rm_edit: 'Editar',
      rm_duplicate: 'Duplicar',
      rm_delete: 'Excluir',
      rm_delete_confirm: 'Excluir este redirecionamento?',
      rm_deleted_ok: 'Redirecionamento excluído.',
      rm_delete_err: 'Erro ao excluir.',
      rm_status_active: 'Ativo',
      rm_status_disabled: 'Desativado',
      rm_no_data: 'Nenhum redirecionamento encontrado.',
      rm_empty_state: 'Nenhum redirecionamento ainda. Crie o primeiro.',
      rm_total_redirects: '{{count}} redirecionamentos no total',
      rm_import_title: 'Importar redirecionamentos',
      rm_import_csv: 'CSV (old_url,new_url,type)',
      rm_import_shopify: 'Shopify Export CSV',
      rm_import_sf: 'Screaming Frog CSV',
      rm_import_btn: 'Importar',
      rm_import_ok: 'Importação concluída.',
      rm_import_err: 'Erro durante a importação.',
      rm_import_imported: '{{count}} importados',
      rm_import_skipped: '{{count}} ignorados',
      rm_export_title: 'Exportar redirecionamentos',
      rm_export_desc: 'Baixe todos os redirecionamentos nos formatos disponíveis.',
      rm_export_csv: 'Exportar CSV',
      rm_export_json: 'Exportar JSON',
      rm_ai_title: 'Sugestões IA',
      rm_ai_subtitle: 'A IA detectou URLs 404 e sugere redirecionamentos para produtos similares.',
      rm_ai_accept: 'Aceitar',
      rm_ai_reject: 'Rejeitar',
      rm_ai_accept_all: 'Aceitar todos',
      rm_ai_loading: 'Analisando…',
      rm_ai_empty: 'Nenhuma sugestão disponível no momento.',
      rm_chains_title: 'Cadeias de redirecionamento',
      rm_chains_desc: 'Vários redirecionamentos encadeados tornam o site mais lento.',
      rm_chains_fix: 'Corrigir cadeia',
      rm_chains_empty: 'Nenhuma cadeia detectada.',
      rm_chains_fixed: 'Cadeia corrigida.',
      rm_loops_title: 'Loops de redirecionamento',
      rm_loops_desc: 'Loops circulares causam erros. Requerem correção manual.',
      rm_loops_fix: 'Corrigir',
      rm_loops_empty: 'Nenhum loop detectado.',
      rm_gsc_title: '404 do Google Search Console',
      rm_gsc_subtitle: 'URLs não encontradas detectadas pelo GSC nos últimos 90 dias.',
      rm_gsc_empty: 'Nenhum 404 do GSC detectado.',
      rm_history_title: 'Histórico de atividades',
      rm_history_created: 'Criado',
      rm_history_edited: 'Editado',
      rm_history_deleted: 'Excluído',
      rm_history_disabled: 'Desativado',
      rm_history_enabled: 'Ativado',
      rm_history_imported: 'Importado',
      rm_history_bulk: 'Operação em massa',
      rm_history_empty: 'Nenhuma atividade registrada.',
      rm_sync_shopify: 'Sincronizar do Shopify',
      rm_sync_shopify_desc: 'Importar todos os redirecionamentos URL do Shopify. Novos redirecionamentos são enviados automaticamente ao Shopify.',
      rm_sync_btn: 'Sincronizar agora',
      error_label: 'Erro:',
      rb_checker_desc: 'Verifique se uma URL é permitida ou bloqueada por {{bot}} com base no robots.txt atual.',
      rb_rule: 'Regra:',
      rb_fix: 'Corrigir:',
      rb_gsc_note_title: 'Integração Search Console',
      rb_gsc_note_body: 'Na seção Indexação, as URLs com status "Bloqueada por robots" indicam páginas que o Google não pode rastrear.',
      rb_issues: 'problemas',
      rb_opps: 'oportunidades',
      rb_savings: 'Economia estimada:',
      never: 'Nunca',
      samples_conf: '{{n}} amostras · confiança {{c}}',
      batch_priority_note: 'URLs com impressões do Analytics inspecionadas primeiro · cota GSC 2.000/dia · processamento em segundo plano',
      sm_samples: 'amostras',
      sm_footnote_ec: '~ Valores "Em cálculo" = estimativa da Inspection API ({{n}} amostras · confiança {{c}}). Sitemaps API retorna 0 para índices de sitemap.',
      sm_footnote_noec: '~ Valores "Em cálculo" = estimativa proporcional. Inicie o scan em lote. Sitemaps API retorna 0 para índices de sitemap.',
      ic_quota_note: 'Calculado sobre {{n}} URLs inspecionadas via Inspection API (cota 2.000/dia). GSC Coverage mostra {{m}} URLs não indexadas no sitemap.',
      cov_crawled_ni: 'Conteúdo de baixa qualidade ou duplicado. Melhore o conteúdo, adicione texto único, verifique a tag canonical.',
      cov_disc_ni: 'O Google a encontrou mas ainda não a rastreou. Aumente o orçamento de rastreamento com links internos adicionais e sitemap atualizado.',
      cov_dup_nocanon: 'Adicione tag canonical apontando para a página principal.',
      cov_dup_googcanon: 'O Google ignora o canonical declarado. Verifique a consistência de URL e canonical entre versões desktop/mobile.',
      cov_redirect: 'Redirecionamento ativo. Se intencional, atualize os links internos para apontar diretamente para o destino.',
      cov_alternate: 'Página alternativa com canonical correto — nenhuma ação necessária se intencional.',
      cov_noindex: 'Remova a meta tag noindex se quiser que a página seja indexada.',
      cov_robots: 'Página bloqueada por robots.txt. Verifique as diretivas Disallow e atualize se necessário.',
      cov_removed: 'Removida manualmente do GSC. Revogue a remoção no painel do Search Console se desejar.',
      cov_404: 'Página não encontrada. Restaure a página, configure um redirecionamento 301 ou remova os links internos para esta URL.',
      cov_soft404: 'O servidor retorna 200 mas o Google a trata como página vazia. Certifique-se de que a página tem conteúdo relevante.',
      cov_server_err: 'Erro do servidor. Verifique os logs do servidor e a disponibilidade do hosting durante o rastreamento.',
      cov_unknown_url: 'O Google ainda não descobriu esta URL. Adicione links internos, atualize o sitemap e aguarde o próximo rastreamento.',
      qt_brand: 'Marca',
      qt_info: 'Info',
      qt_category: 'Categoria',
      qt_product: 'Produto',
      qt_generic: 'Genérico',
      sugg_title_improvement: 'Tag de título',
      sugg_meta: 'Meta descrição',
      sugg_content_gap: 'Conteúdo faltando',
      sugg_schema: 'Marcação de schema',
      sugg_links: 'Links internos',
      verdict_indexed: 'Indexado',
      verdict_not_indexed: 'Não indexado',
      verdict_excluded: 'Excluído',
      badge_col_header: 'Crachá',
      sitemap_label: 'Mapa do site',
      ls_tab_broken: 'Links quebrados',
      ls_tab_redirect: 'Redirecionamento',
      ls_tab_rate_limited: 'Limite de taxa',
      ls_tab_server_errors: 'Erros de servidor',
      ls_tab_canonical: 'Canônico',
      ls_tab_internal: 'Links internos',
      ls_section_monitor: 'Monitor ao vivo',
      ls_section_audit: 'Estrutura do site',
      db_idx_title: 'Pontuação de indexação',
      db_health_title: 'Pontuação de saúde SC',
      canonical_mismatch: 'Incompatibilidade canônica',
    },
    so: {
      load_err: 'Erro ao carregar Speed Optimizer',
      analyze_timeout: 'Tempo de análise esgotado (90s) — por favor tente novamente',
      analyze_done: 'Análise concluída!',
      analyze_failed: 'Análise falhou: {{error}}',
      rate_limited: 'Limite de requisições atingido — dados atualizados do cache',
      analyze_err: 'Erro de análise',
      opt_enabled: '{{label}} ativado no tema',
      opt_disabled: '{{label}} desativado',
      opt_err: 'Erro de otimização',
      scan_err: 'Erro de varredura do tema',
      img_err: 'Erro de análise de imagens',
      sg_protected: 'Safety Guard: Protected ativado',
      sg_standard: 'Safety Guard: Standard ativado',
      mode_err: 'Erro ao mudar modo',
      plan_err: 'Erro ao gerar plano',
      strategy_applied: 'Estratégia {{label}} aplicada ao tema',
      strategy_err: 'Erro ao aplicar estratégia',
      sessions_err: 'Erro ao carregar sessões',
      rollback_done: 'Rollback concluído — tema restaurado',
      rollback_err: 'Erro de rollback',
      subtitle: 'Otimizações seguras do tema Shopify com rollback instantâneo.',
      btn_rollback: 'Reverter tudo',
      btn_analyze: 'Analisar agora',
      analyzing_psi: 'Processando PSI…',
      analyzing_queue: 'Em fila…',
      analyzing: 'Analisando…',
      alert_no_token: 'Token Shopify ausente — as otimizações requerem uma conexão ativa com o store.',
      alert_no_scope: 'Permissões de tema ausentes — para aplicar otimizações você deve reinstalar o app.',
      perf_empty: 'Nenhuma análise disponível',
      perf_empty_hint: 'Clique em "Analisar agora" para medir o desempenho do seu store',
      suggestions: 'Sugestões',
      strategy_active: 'ativa',
      strategy_subtitle: 'Define o alvo de otimização. Clique para ver o plano antes de aplicar.',
      sg_header: 'Limita quais operações a estratégia pode executar.',
      sg_desc_protected: 'Bloqueia operações Standard — apenas otimizações seguras.',
      sg_desc_standard: 'Permite a execução completa da estratégia selecionada.',
      quick_opts: 'Otimizações rápidas',
      sg_warning: 'Safety Guard: Protected — as operações Standard estão bloqueadas. Mude para Standard acima.',
      lcp_section: 'Varredura de tema LCP',
      hist_section: 'Histórico de otimizações',
      hist_empty: 'Nenhuma otimização aplicada ainda.',
      sessions_section: 'Sessões & Impacto Lighthouse',
      sessions_empty: 'Carregue sessões para ver o impacto real nos Core Web Vitals.',
      img_count: '{{n}} imagens · {{kb}} KB totais',
      img_oversized: '{{n}} imagens >300KB',
      img_no_oversized: 'Sem imagens superdimensionadas — ótimo!',
      img_empty: 'Clique em "Analisar imagens" para encontrar imagens >300KB no tema.',
      btn_refresh: 'Recarregar',
      btn_load_sessions: 'Carregar sessões',
      btn_refresh_sessions: 'Atualizar',
      btn_analyze_img: 'Analisar imagens',
      btn_refresh_img: 'Atualizar',
      modal_risk_safe: 'Seguro — nenhum impacto visual esperado',
      modal_risk_medium: 'Verifique a aparência do site após a ativação',
      modal_risk_high: 'Pode afetar funcionalidades avançadas',
      modal_reversible: 'Reversível a qualquer momento — use "Reverter tudo" para restaurar o tema original.',
      modal_cancel: 'Cancelar',
      modal_enable: 'Ativar agora',
      opt_no_token: 'Reconecte o store Shopify para usar esta função',
      opt_blocked_guard: 'Bloqueado pelo Safety Guard (Protected) — mude para Standard para habilitar',
      opt_reversible: 'reversível',
      opt_blocked_label: 'Bloqueado pelo Safety Guard — mude para Standard',
      scan_scanning: 'Varredura em andamento...',
      scan_empty_title: 'Varredura de tema não executada',
      scan_empty_desc: 'Identifica seções hero e slideshow no tema para habilitar otimizações LCP do lado do servidor.',
      scan_btn: 'Varrer tema',
      scan_active_theme: 'Tema ativo',
      scan_files: '{{n}} arquivos Liquid varridos · {{s}} seções LCP identificadas',
      scan_hero_label: 'seção hero/LCP',
      scan_optimized: 'otimizado',
      scan_no_lcp: 'Nenhuma seção hero/LCP identificada automaticamente no tema.',
      scan_reload: 'Recarregar',
      plan_title: 'Plano: {{label}}',
      plan_ops: '{{n}} operações previstas',
      plan_action_enabled: 'já ativa',
      plan_action_enable: 'habilitar',
      plan_action_disable: 'desabilitar',
      plan_strategy: 'Estratégia: ',
      plan_guard: 'Safety Guard: ',
      plan_active_ops: 'Operações ativas: ',
      plan_blocked: '{{n}} bloqueadas pelo Safety Guard',
      plan_low_conf: 'Algumas otimizações têm baixa confiança para o tema detectado.',
      plan_cancel: 'Cancelar',
      plan_apply: 'Aplicar estratégia',
      plan_blocked_btn: 'Bloqueado (score baixo)',
      hist_rollback: 'Rollback completo — todas as otimizações removidas',
      hist_enabled: 'ativada',
      hist_disabled: 'desativada',
      hist_active: 'ativas',
      sess_no_sessions: 'Nenhuma sessão de otimização registrada. As sessões são criadas ao aplicar uma estratégia.',
      sess_waiting: 'aguardando PSI',
      strategy_label: 'Estratégia {{s}}',
      strategy_opts: '{{n}} otimizações',
      strategy_active: 'ATIVA',
      quota_err: 'Erro ao carregar cota PSI',
      quota_api_key: 'Chave API configurada:',
      quota_yes: '✓ SIM',
      quota_no: '✗ NÃO (usa cota pública)',
      quota_cache_ttl: 'Cache TTL:',
      quota_hourly: 'Limite por hora:',
      quota_daily: 'Limite diário:',
      quota_success: 'Sucessos hoje:',
      quota_hit_ratio: 'Taxa de acertos cache:',
      quota_circuit: 'Disjuntor:',
      quota_circuit_open: 'ABERTO ({{n}} falhas)',
      quota_circuit_closed: 'fechado',
      quota_loading: 'Carregando...',
      diag_err: 'Erro de diagnóstico',
      diag_refresh: 'Atualizar',
      diag_load: 'Carregar diagnósticos',
      diag_patches: 'Patches ativos ({{n}})',
      diag_none: 'nenhum',
      diag_unavailable: 'indisponível',
      diag_no_patches: 'Nenhum patch ativo',
      diag_calibrated: '📈 calibrado',
      diag_generated: 'Gerado:',
      badge_server_side: 'SERVER-SIDE',
      badge_standard: 'PADRÃO',
      badge_lcp: 'LCP',
      badge_critical: 'CRÍTICO',
      badge_safe: 'SEGURO',
      badge_medium: 'MÉDIO',
      badge_safety_guard: 'Guarda de segurança',
      diag_theme_fingerprint: 'Impressão digital do tema',
      diag_engine_confidence: 'Confiança do motor',
      perf_score_label: 'Pontuação de desempenho',
      section_perf_overview: 'Visão geral de desempenho',
      section_strategy_intent: 'Intenção de estratégia',
      safety_guard_title: 'Guarda de segurança',
      section_script_analyzer: 'Analisador de impacto de scripts',
      script_col_file: 'Arquivo',
      script_col_size: 'Tamanho',
      script_col_impact: 'Impacto',
      script_col_defer_risk: 'Risco de adiamento',
      metric_js_total: 'JS total',
      metric_css_total: 'CSS total',
      perf_updated: 'Atualizado:',
      perf_stale: 'dados desatualizados (PSI indisponível)',
      perf_from_cache: 'do cache',
      perf_psi_ok: 'PSI OK',
      debug_invalid_token_title: 'Token inválido (401) — o token no MongoDB expirou ou foi revogado.',
      debug_reconnect_desc: 'O callback OAuth NÃO sobrescreveu o token após a última reinstalação. Clique no botão abaixo para iniciar um novo OAuth.',
      debug_reconnect_btn: 'Reconectar OAuth agora (abre Shopify)',
      debug_reconnect_note: 'Após aprovar as permissões no Shopify, o callback atualizará o token no MongoDB automaticamente.',
    },
    drafts: {
      approved: 'Rascunho aprovado!',
      approve_err: 'Erro de aprovação',
      published: 'Publicado no Shopify!',
      publish_err: 'Erro de publicação',
      title: 'Rascunhos & Resultados',
      subtitle: 'Revise, aprove e publique o conteúdo otimizado',
      empty: 'Nenhum rascunho para revisar',
      empty_hint: 'Gere conteúdo IA para criar novos rascunhos',
      badge_approved: 'Aprovado',
      badge_draft: 'Rascunho',
      field_desc: 'Descrição',
      btn_view: 'Ver',
      btn_approve: 'Aprovar',
      btn_publish: 'Publicar',
      modal_title: 'Detalhes do rascunho',
      chars_seo: '/60 caracteres',
      chars_meta: '/160 caracteres',
      not_present: 'Não presente',
      not_present_pl: 'Não presentes',
      btn_close: 'Fechar',
      btn_publish_shopify: 'Publicar no Shopify',
      seo_title: 'Título SEO',
      meta_description: 'Meta descrição',
      keywords_label: 'Palavras-chave',
    },
    usage: {
      title: 'Uso e Plano',
      subtitle: 'Monitore o uso e gerencie sua assinatura',
      plan_badge: 'Plano:',
      current: 'Uso atual',
      credits: 'Créditos IA',
      used: 'Usados:',
      unlimited: 'Ilimitado ∞',
      remaining: 'Restantes: {{n}}',
      products_sync: 'Produtos sincronizados',
      plans_heading: 'Planos disponíveis',
      most_popular: '⭐ Mais popular',
      active_plan: 'Plano ativo',
      current_plan: 'Plano atual',
      btn_upgrade: 'Upgrade para {{name}}',
      trend_heading: 'Tendência de uso',
      trend_coming: 'Gráfico de uso (em breve)',
      stat_products: 'Produtos analisados',
      stat_content: 'Conteúdo gerado',
      stat_translations: 'Traduções',
      stat_images: 'Imagens otimizadas',
    },
    support: {
      msg_sent: 'Mensagem enviada!',
      msg_err: 'Erro ao enviar a mensagem',
      status_open: 'Aberto',
      status_progress: 'Em andamento',
      status_closed: 'Fechado',
      title: 'Suporte',
      subtitle: 'FAQ, guias e chat com nossa equipe',
      faq_heading: 'Perguntas frequentes',
      guide_heading: 'Guia rápido',
      chat_heading: 'Chat de suporte',
      no_msgs: 'Sem mensagens',
      no_msgs_hint: 'Inicie uma conversa com o suporte',
      placeholder: 'Escreva uma mensagem...',
      contacts_heading: 'Contatos',
      contact_hours_label: 'Horário',
      contact_hours: 'Seg-Sex 9:00-18:00 CET',
      contact_response_label: 'Tempo de resposta',
      contact_response: 'Em até 24 horas',
      guide_step1: 'Vá para a seção',
      guide_products: 'Produtos',
      guide_step1b: 'para ver seus produtos',
      guide_step2: 'Selecione um produto e vá para',
      guide_ai_content: 'Conteúdo AI',
      guide_step3: 'Gere descrição, título SEO, meta descrição e keywords',
      guide_step4: 'Veja os resultados em',
      guide_history: 'Histórico',
    },
    transl: {
      load_err: 'Erro ao carregar itens',
      published: 'Tradução publicada no Shopify!',
      pub_err: 'Erro de publicação',
      err_no_items: 'Selecione pelo menos um item',
      err_no_fields: 'Selecione pelo menos um campo para traduzir',
      item_err: 'Erro de tradução',
      done_one: 'Tradução concluída!',
      done_many: '{{n}} itens traduzidos!',
      copied: 'Copiado para a área de transferência',
      title: 'Traduções',
      gate_plan: 'Disponível a partir do plano Starter',
      gate_desc: 'Traduza produtos, coleções e artigos em 8 idiomas com AI',
      gate_btn: 'Mudar para o Plano Starter',
      subtitle: 'Traduza produtos, coleções, artigos e páginas para vários idiomas com AI',
      translating: 'Traduzindo…',
      search_placeholder: 'Pesquisar por título…',
      select_page: 'Selecionar página',
      sel_abbrev: 'sel.',
      total_items: 'total',
      loading: 'Carregando…',
      no_results: 'Nenhum resultado para esta pesquisa',
      prev: '← Ant',
      tot_abbrev: 'tot.',
      next: 'Próx →',
      deselect_all: 'Desmarcar tudo',
      lang_heading: 'Idioma alvo',
      fields_heading: 'Campos para traduzir',
      select_hint: 'Selecione itens da lista para habilitar a tradução',
      results_heading: 'Resultados',
      clear_results: 'Limpar resultados',
      badge_published: 'Publicado',
      publishing: 'Publicando…',
      done: 'Feito',
      publish: 'Publicar',
      copy: 'Copiar',
      tab_products: 'Produtos',
      tab_collections: 'Coleções',
      tab_articles: 'Artigos',
      tab_pages: 'Páginas',
      field_title: 'Título',
      field_description: 'Descrição',
      field_seo_title: 'SEO Title',
      field_meta_description: 'Meta Description',
      field_body_html: 'Descrição / Corpo',
      empty_hint_select: 'Selecione um ou mais itens da lista, escolha o idioma e clique em',
      translate_label: 'Traduzir',
      items_selected: 'itens',
      item_selected: 'item',
      selected_label: 'selecionado(s)',
      choose_fields_hint: 'escolha os campos e clique em Traduzir',
    },
  },

  nl: {
    nav: {
      overview: 'Overzicht',
      catalog: 'Catalogus',
      content: 'AI-inhoud',
      translations: 'Vertalingen',
      images: 'Afbeeldingen',
      batch: 'Batchbewerkingen',
      speed: 'Snelheidsoptimalisatie',
      history: 'Geschiedenis',
      usage: 'Gebruik & Plan',
      settings: 'Instellingen',
      support: 'Ondersteuning',
    },
    common: {
      save: 'Opslaan',
      cancel: 'Annuleren',
      delete: 'Verwijderen',
      close: 'Sluiten',
      confirm: 'Bevestigen',
      loading: 'Laden...',
      error: 'Fout',
      success: 'Succes',
      search: 'Zoeken',
      filter: 'Filteren',
      all: 'Alle',
      yes: 'Ja',
      no: 'Nee',
      back: 'Terug',
      next: 'Volgende',
      apply: 'Toepassen',
      generate: 'Genereren',
      publish: 'Publiceren',
      optimize: 'Optimaliseren',
      refresh: 'Vernieuwen',
    },
    settings: {
      title: 'Instellingen',
      subtitle: 'AI-controlecentrum',
      tabs: {
        general: 'Algemeen',
        localization: 'Lokalisatie',
        ai_engine: 'AI-engine',
        appearance: 'Uiterlijk',
        piano: 'Plan',
        advanced: 'Geavanceerd',
      },
      save_btn: 'Instellingen opslaan',
      unsaved: 'Niet-opgeslagen wijzigingen',
      action_loading: 'Bezig...',
      general: {
        contents: 'Inhoud',
        default_lang: 'Standaard inhoudsttaal',
        tone: 'Globale inhoutstoon',
        tone_hint: 'Toegepast op producten, collecties, artikelen en batches',
        seo_rules: 'SEO-regels',
        seo_title_max: 'Maximale SEO-titellengte',
        seo_title_hint: 'Aanbevolen: 50–60 tekens',
        meta_max: 'Maximale meta-beschrijvingslengte',
        meta_hint: 'Aanbevolen: 150–160 tekens',
        chars: 'tekens',
        images: 'Afbeeldingsvoorkeuren',
        img_format: 'Standaardformaat',
        img_square: 'Vierkant (1:1)',
        img_landscape: 'Landschap (4:3)',
        img_portrait: 'Portret (3:4)',
        img_quality: 'Compressiekwaliteit',
        img_quality_low: '50% (gecomprimeerd)',
        img_quality_high: '100% (maximaal)',
        store_info: 'Winkelinformatie',
        store_domain: 'Domein',
        store_plan: 'Plan',
        store_installed: 'Geïnstalleerd',
      },
      ai: {
        strategy: 'AI-strategie',
        params_title: 'Generatieparameters',
        creativity: 'Creativiteit',
        creative_low: 'Conservatief',
        creative_high: 'Creatief',
        seo_strictness: 'SEO-strengheid',
        seo_low: 'Flexibel',
        seo_high: 'Streng',
        tone_label: 'Globale toon',
        auto_title: 'AI-auto-optimalisatie',
        auto_hint: 'Inschakelen om inhoud automatisch te optimaliseren',
        on: 'Actief',
        off: 'Uit',
        threshold: 'Optimalisatiedrempel',
        threshold_low: 'Alles optimaliseren',
        threshold_high: 'Alleen de slechtste',
        threshold_hint: 'Werkt op items met SEO-score < {{n}}',
        frequency: 'Frequentie',
        scope: 'Bereik',
        triggers: 'Triggers',
        img_format: 'Afbeeldingsformaat',
        img_square: 'Vierkant 1:1',
        img_square_sub: '800×800 px',
        img_landscape: 'Landschap 4:3',
        img_landscape_sub: '800×600 px',
        img_portrait: 'Portret 3:4',
        img_portrait_sub: '600×800 px',
        img_no_resize: 'Geen resize',
        img_no_resize_sub: 'Originele afmetingen',
        compress: 'Compressie',
        compress_hint: 'Bestandsgrootte verkleinen',
        quality: 'Kwaliteit',
        daily_credits: 'AI-credits vandaag',
        remaining: '{{n}} resterend',
        reset_in: 'Reset over',
        running: 'Bezig — {{done}}/{{total}} producten',
        run_now: 'Nu uitvoeren',
        run_desc: 'Items met score < {{threshold}} optimaliseren in: {{scope}}',
        preview_title: 'Voorbeeld — Voor / Na',
        before: 'Voor',
        after: 'Na AI',
        no_keywords: 'geen zoekwoorden',
        preview_note: 'Voorbeeld op product «Hardloopschoen Pro X1» — directe update',
        alt_mode_label: 'ALT-tekstgeneratiemodus',
        alt_preview: 'Voorbeeld',
        alt_mode_ai: 'Slimme AI',
        alt_mode_ai_desc: 'OpenAI genereert geoptimaliseerde ALT voor elke afbeelding',
        alt_mode_template: 'Gratis sjabloon',
        alt_mode_template_desc: 'Geen AI-credits — gebruikt het onderstaande sjabloon',
        alt_mode_auto: 'Auto-fallback',
        alt_mode_auto_desc: 'AI indien beschikbaar, sjabloon als credits op zijn',
        alt_hint_template: 'Gratis modus: geen AI-credits verbruikt voor ALT-tekst.',
        alt_hint_auto: 'Auto-fallback: AI als credits beschikbaar, anders automatisch sjabloon.',
        pct_done: '{{pct}}% voltooid',
        n_errors: '{{n}} fouten',
        alt_template_label: 'Aangepast sjabloon',
        alt_vars_label: 'Beschikbare variabelen — klik om in te voegen',
      },
      piano: {
        credits_title: 'Creditgebruik',
        plan_label: 'Plan',
        extra_credits: 'Extra credits',
        unlimited: '∞ Onbeperkte credits',
        unlimited_sub: 'Elite-plan — geen maandelijks limiet',
        plan_credits: 'Plancredits',
        consumed: 'Verbruikt van plan',
        residual: 'Resterend van plan',
        extra_available: 'Extra credits beschikbaar',
        extra_sub: 'Verbruikt pas na het maandelijkse plan',
        total_available: 'Totaal beschikbaar',
        consumed_cycle: 'Credits verbruikt in huidige cyclus',
        status_active: 'Actief',
        status_pending: 'Wordt verwerkt',
        status_frozen: '⚠ Geblokkeerd',
        status_free: 'Gratis / Geen abonnement',
        trial_active: 'Proefperiode actief',
        trial_access: 'volledige toegang tot {{date}}.',
        sub_status: 'Abonnementsstatus',
        next_credit_reset: 'Volgende kredietreset',
        trial_end: 'Einde proefperiode',
        trial_label: 'Gratis proefperiode',
        trial_used: 'Al gebruikt',
        trial_available: '{{n}} dagen beschikbaar',
        cancel_btn: 'Abonnement opzeggen',
        cancelling: 'Bezig met opzeggen...',
        plans_title: 'Beschikbare plannen',
        plan_active: 'Actief plan',
        plan_current: 'Huidig plan',
        per_month: '/maand',
        downgrade: 'Terug naar Gratis',
        downgrading: 'Downgrade...',
        upgrade: 'Upgrade',
        downgrade_btn: 'Downgrade',
        redirecting: 'Doorsturen...',
        trial_btn: 'Gratis proberen',
        trial_btn_days: '({{n}}d)',
        plan_overage: 'Extra AI-credits: {{price}} per credit',
        plan_no_overage: 'Geen kosten voor extra AI-credits',
        plan_trial_line: 'Gratis proefperiode van {{n}} dagen',
        plans_note: 'Betaalde plannen bevatten een gratis proefperiode van {{n}} dagen. Geen activatiekosten. Betalingen via Shopify Billing.',
        credits_section: 'Extra credits kopen',
        credits_desc: 'Extra credits worden toegevoegd aan uw maandplan en verlopen nooit. Compatibel met alle plannen.',
        one_time: 'eenmalig',
        per_credit: '¢ per credit',
        buy: 'Kopen',
        payment_note: 'Betaling veilig verwerkt via Shopify Billing. Geen betalingsgegevens opgeslagen op onze server.',
        history_title: 'Aankoopgeschiedenis credits',
        history_count: '{{n}} aankoop{{suffix}}',
        hist_invested: 'Totaal geïnvesteerd',
        hist_bought: 'Gekochte credits',
        hist_available: 'Nog beschikbaar',
        hist_empty: 'Geen extra creditaankopen gedaan.',
        hist_date: 'Datum',
        hist_pkg: 'Pakket',
        hist_credits: 'Credits',
        hist_amount: 'Bedrag',
        hist_status: 'Status',
        hist_completed: 'Voltooid',
        hist_pending: 'In afwachting',
        hist_declined: 'Geweigerd',
        trend_title: 'Gebruikstrend',
        trend_placeholder: 'Gebruiksdiagram (beschikbaar met Shopify Billing)',
        stats_products: 'Geanalyseerde producten',
        stats_content: 'Gegenereerde inhoud',
        stats_translations: 'Vertalingen',
        stats_images: 'Geoptimaliseerde afbeeldingen',
        toast_sub_pending: 'Abonnement wordt verwerkt — u ontvangt binnenkort een bevestiging.',
        toast_sub_activated: '{{name}} geactiveerd!',
        toast_trial_suffix: '({{n}} dagen gratis proefperiode)',
        toast_sub_error: 'Abonnementsverificatiefout',
        toast_purchase_duplicate: 'Aankoop al geregistreerd.',
        toast_credits_added: '+{{n}} credits toegevoegd aan uw account!',
        toast_purchase_error: 'Aankoopverificatiefout',
        toast_purchase_start_error: 'Fout bij starten van aankoop',
        toast_sub_start_error: 'Fout bij starten van abonnement',
        toast_store_unavailable: 'Winkel nog niet verbonden. Herlaad de app in Shopify Admin en probeer het opnieuw.',
        toast_sub_cancelled: 'Abonnement opgezegd. Plan terug naar Gratis.',
        toast_sub_cancel_error: 'Fout bij opzeggen abonnement',
        pkg_100_label: '100 Credits',
        pkg_100_desc: 'Ideaal voor incidenteel gebruik',
        pkg_300_label: '300 Credits',
        pkg_300_desc: '17% besparen',
        pkg_300_badge: '⭐ Meest gevraagd',
        pkg_700_label: '700 Credits',
        pkg_700_desc: '29% besparen',
        pkg_1500_label: '1.500 Credits',
        pkg_1500_desc: '33% besparen',
        pkg_1500_badge: '🔥 Beste waarde',
        plan_starter_badge: '⭐ Meest Populair',
        plan_starter_benefit: 'Bespaar uren werk elke maand.',
        plan_pro_badge: '🔥 SEO-groei',
        plan_pro_benefit: 'Verbetert indexering en SEO-prestaties.',
        plan_elite_badge: '🚀 Bureaus',
        plan_elite_benefit: 'Ontworpen voor bureaus en enterprise-catalogi.',
      },
      toast: {
        saved_at: 'Opgeslagen om {{time}}',
        save_error: 'Opslagfout',
        budget_exceeded: 'Dagelijks krediet uitgeput — {{done}} van {{total}} producten geoptimaliseerd',
        autopilot_stopped: 'Autopilot gestopt — {{done}} van {{total}} producten geoptimaliseerd',
        images_optimized: 'Afbeeldingen geoptimaliseerd — {{n}} producten',
        images_failed: '{{n}} afbeeldingen niet geoptimaliseerd',
        autopilot_done: 'Autopilot voltooid — {{started}} producten in de wachtrij',
        autopilot_empty: 'Geen items onder de drempel',
        autopilot_stopping: 'Autopilot wordt gestopt...',
        reindex_started: 'Herindexering gestart',
        resync_started: 'Hersynchronisatie gestart',
        cache_cleared: 'Cache geleegd',
        sync_reset: 'Synchronisatiestatus gereset',
      },
      advanced: {
        warning: 'De volgende acties beïnvloeden het systeemgedrag. Gebruik ze alleen indien nodig.',
        sync_title: 'Synchronisatie',
        reindex: 'Producten herindexeren',
        reindex_desc: 'SEO-gegevens herberekenen voor alle producten in de database',
        resync: 'Hersynchroniseren met Shopify',
        resync_desc: 'Volledige synchronisatie van producten en collecties afdwingen',
        cache_title: 'Cache',
        clear_cache: 'Applicatiecache leegmaken',
        clear_cache_desc: 'Verwijdert lopende batches in de browser. Onvoltooide bewerkingen gaan verloren.',
        reset_credits: 'Dagelijkse credits resetten',
        reset_credits_desc: 'AI-creditteller van vandaag resetten (dev). Limiet: 5.000/dag.',
        danger_zone: 'Gevarenzone',
        reset_sync: 'Synchronisatiestatus resetten',
        reset_sync_desc: 'Reset afdwingen. Alleen gebruiken als de synchronisatie meer dan 30 minuten vastloopt.',
      },
    },
    ai_engine: {
      preset: {
        growth_desc: 'Maximaliseert conversies en betrokkenheid',
        luxury_desc: 'Premiummerk en exclusieve verhalen',
        seo_desc: 'Maximaliseert organische zichtbaarheid op Google',
        balanced_desc: 'Optimale balans tussen kwaliteit en SEO',
      },
      tone: {
        professional: 'Professioneel',
        professional_desc: 'Formeel, gezaghebbend, bouwt vertrouwen op',
        luxury: 'Luxury',
        luxury_desc: 'Elegant, exclusief, premium',
        technical: 'Technisch',
        technical_desc: 'Precies, specificaties, meetbare gegevens',
        conversational: 'Conversationeel',
        conversational_desc: 'Direct, vriendelijk, boeiend',
      },
      frequency: {
        daily: 'Dagelijks',
        daily_desc: '1× per dag',
        hourly: 'Elk uur',
        hourly_desc: 'Continu',
        realtime: 'Direct',
        realtime_desc: 'Zo snel mogelijk',
      },
      scope: {
        products: 'Producten',
        collections: 'Collecties',
        articles: 'Artikelen',
        pages: 'Pagina\'s',
      },
      trigger: {
        seo_score: 'Lage SEO-score',
        missing_meta: 'Ontbrekende metadata',
        missing_alt: 'Ontbrekende ALT-tekst',
        outdated_desc: 'Verouderde beschrijving',
        keywords: 'Ontbrekende zoekwoorden',
        image_quality: 'Niet-geoptimaliseerde afbeeldingen',
      },
    },
    appearance: {
      title: 'Uiterlijk',
      theme_title: 'Thema',
      theme: {
        light: 'Licht',
        dark: 'Donker',
        system: 'Systeem',
      },
      density_title: 'Dichtheid',
      density: {
        compact: 'Compact',
        comfortable: 'Comfortabel',
        spacious: 'Ruim',
        compact_desc: 'Meer inhoud',
        comfortable_desc: 'Gebalanceerd',
        spacious_desc: 'Meer ruimte',
      },
      sidebar_title: 'Zijbalk',
      sidebar: {
        expanded: 'Uitgevouwen',
        collapsed: 'Ingeklapt',
        hidden: 'Verborgen',
        expanded_desc: 'Altijd zichtbaar',
        collapsed_desc: 'Alleen pictogrammen',
        hidden_desc: 'Bij hover',
      },
    },
    localization: {
      ui_language: 'Interfacetaal',
      select_language: 'Selecteer de app-taal',
      reload_note: 'De taal wordt onmiddellijk toegepast',
    },
    dashboard: {
      title: 'Overzicht',
      subtitle: 'Samenvatting winkelactiviteit',
      products: 'Producten',
      optimized: 'Geoptimaliseerd',
      pending: 'In behandeling',
      seo_score: 'SEO-score',
      audit_center: 'Audit Center',
      sync_products: 'Producten synchroniseren',
      analyze_products: 'Producten analyseren',
      audit_site: 'Site-audit 360',
      syncing: 'Sync...',
      analyzing: 'Analyse...',
      auditing: 'Audit...',
      section_account: 'Account & Plan',
      section_catalog: 'Catalogusstatus',
      section_images: 'Afbeeldingen',
      section_seo_tech: 'Technische SEO — Gedetailleerde site-audit',
      section_ux_trust: 'UX & Trust — Highlights',
      section_actions: 'Door AI aanbevolen acties',
      recent_activity: 'Recente activiteit',
      hint_plan: 'Plan- en creditstatus',
      hint_never_synced: 'Nooit gesynchroniseerd',
      hint_priority: 'Gesorteerd op prioriteit',
      hint_last_sync: 'Laatste sync {{date}}',
      current_plan: 'Huidig plan',
      credits_used: 'Gebruikte credits',
      credits_remaining: 'Resterende credits',
      public_domain: 'Publiek domein',
      credit_usage: 'Creditgebruik',
      hint_installed: 'Geïnstalleerd op {{date}}',
      hint_pct_plan: '{{pct}}% van het plan',
      hint_limit: 'Limiet {{n}}',
      hint_last_audit: 'Laatste audit {{date}}',
      hint_no_audit: 'Audit niet uitgevoerd',
      no_audit: 'Geen audit uitgevoerd',
      no_audit_desc: 'Start een audit om title, meta, H1, canonical, robots, sitemap, HTTPS, OG, JSON-LD, prestaties, afbeeldingen en links te analyseren.',
      run_audit: 'Audit starten',
      in_progress: 'Bezig...',
      audit_phase: 'Audit bezig (fase: {{phase}})...',
      ux_highlights: 'UX Highlights',
      trust_compliance: 'Trust & Compliance',
      mobile_viewport: 'Mobile viewport:',
      favicon: 'Favicon:',
      images_without_alt_label: 'Afbeeldingen zonder ALT:',
      lazy_loading: 'Lazy loading:',
      images_suffix: 'afbeeldingen',
      internal_links: 'Interne links:',
      data_unavailable: 'Gegevens niet beschikbaar: {{reason}}',
      analysis_not_run: 'Analyse niet uitgevoerd',
      not_detected: 'Niet gedetecteerd',
      no_trust_data: 'Geen trustgegevens beschikbaar',
      no_activity: 'Geen recente activiteit.',
      activity_completed: 'Voltooid',
      activity_error: 'Fout',
      no_store_title: 'Geen winkel verbonden',
      no_store_desc: 'Installeer de app in een Shopify-winkel om te beginnen',
      connect_store: 'Shopify-winkel verbinden',
      no_token_title: 'OAuth-token ontbreekt',
      no_token_desc: 'Winkel {{domain}} is geregistreerd maar heeft geen token. Installeer de app opnieuw.',
      reinstall_app: 'App opnieuw installeren via OAuth',
      sync_in_progress: 'Productsynchronisatie bezig…',
      sync_in_progress_detail: '{{synced}} / {{total}} producten. Dashboardgegevens worden bijgewerkt na afronding.',
      stale_data: 'Verouderde gegevens: laatste geldige cijfers worden weergegeven terwijl de synchronisatie loopt.',
      catalog_score_label: 'Catalog Score',
      seo_distribution: 'SEO-verdeling',
      n_products: '{{n}} producten',
      pct_of_catalog: '{{pct}}% van de catalogus',
      no_description: 'Zonder beschrijving',
      no_meta_description: 'Zonder meta description',
      seo_needs_improvement: 'SEO te verbeteren',
      view: 'Bekijk',
      seo_good_desc: 'De catalogus heeft een goede SEO-dekking. Houd de standaard hoog door nieuwe producten te optimaliseren.',
      seo_medium_desc: 'De catalogus heeft een gemiddelde SEO-dekking. Prioriteit: meta descriptions en productbeschrijvingen.',
      seo_poor_desc: 'De catalogus heeft een lage SEO-dekking. Prioriteit: meta descriptions, beschrijvingen en ontbrekende afbeeldingen.',
      seo_optimized: 'Geoptimaliseerd',
      seo_medium: 'Gemiddeld',
      seo_poor: 'Te verbeteren',
      content_seo_title: 'SEO-status per inhoudstype',
      open_catalog: 'Catalogus openen',
      row_collections: 'Collecties',
      row_articles: 'Artikelen',
      row_pages: "Pagina's",
      coming_soon: 'Binnenkort',
      not_synced: 'Niet gesynchroniseerd',
      seo_coverage_fmt: '{{opt}}/{{total}} geoptimaliseerd · {{score}}/100',
      alt_coverage: 'ALT text-dekking',
      with_alt_count: '{{n}} met ALT van {{total}}',
      image_optimization_label: 'Afbeeldingsoptimalisatie',
      optimized_count: '{{n}} geoptimaliseerd van {{total}}',
      with_alt: 'Met ALT',
      without_alt: 'Zonder ALT',
      image_optimized: 'Geoptimaliseerd',
      image_needs_improvement: 'Te verbeteren',
      no_image: 'Geen afbeelding',
      savings: 'Besparingen',
      optimize_images_btn: 'Afbeeldingen optimaliseren',
      view_no_image: 'Producten zonder afbeelding bekijken',
      alt_manager: 'ALT Text Manager',
      toast_sync_done: 'Synchronisatie voltooid. Catalogus worden verzoend...',
      toast_catalog_reconciled: 'Catalogus verzoend: {{n}} producten ({{removed}} verweesde verwijderd)',
      toast_sync_first: 'Synchroniseer eerst de producten',
      toast_avg_score: 'Gemiddelde score {{score}}/100',
      toast_audit_done: 'Audit voltooid: {{score}}/100',
      toast_sync_reset: 'Syncstatus gereset',
      toast_sync_reset_error: 'Syncstatus kan niet worden gereset',
      op_description: 'AI-beschrijving',
      op_seo_title: 'SEO Title',
      op_meta_description: 'Meta Description',
      op_keywords: 'Keywords',
      op_translation: 'Vertaling',
      op_image_opt: 'Afbeeldingsoptimalisatie',
      op_sync: 'Sync Shopify',
      op_seo_analysis: 'Winkel-SEO-analyse',
      op_site_audit: 'Site-audit 360',
      prompt_domain: 'Voer het domein van je Shopify-winkel in',
      hint_force_reset: 'Synchronisatiestatus resetten (verwijdert geen producten)',
    },
    products: {
      title: 'Productcatalogus',
      search: 'Producten zoeken...',
      all: 'Alle',
      optimized: 'Geoptimaliseerd',
      pending: 'In behandeling',
      status_generating: 'Genereren',
      status_writing: 'Schrijven',
      status_validating: 'Valideren',
      status_failed: 'Mislukt',
      status_sync_failed: 'Sync Shopify',
      status_optimized: 'Geoptimaliseerd',
      status_medium: 'Gemiddeld',
      status_needs_improvement: 'Te verbeteren',
      type_collection_singular: 'collectie',
      type_collection_plural: 'collecties',
      sync_collections: 'Collecties synchroniseren',
      empty_collections: 'Geen collecties. Klik op "Collecties synchroniseren" om ze vanuit Shopify te importeren.',
      search_collections: 'Collectie zoeken op titel of handle...',
      col_label_products: 'Producten',
      type_article_singular: 'artikel',
      type_article_plural: 'artikelen',
      sync_articles: 'Artikelen synchroniseren',
      empty_articles: 'Geen artikelen. Klik op "Artikelen synchroniseren" om ze vanuit Shopify te importeren.',
      search_articles: 'Artikel zoeken op titel, handle of blog...',
      col_label_blog: 'Blog',
      type_page_singular: 'pagina',
      type_page_plural: "pagina's",
      sync_pages: "Pagina's synchroniseren",
      empty_pages: "Geen pagina's. Klik op \"Pagina's synchroniseren\" om ze vanuit Shopify te importeren.",
      search_pages: "Pagina zoeken op titel of handle...",
      col_label_author: 'Auteur',
      catalog_title: 'Catalogus',
      no_store: 'Geen winkel',
      tab_products: 'Producten',
      tab_collections: 'Collecties',
      tab_articles: 'Artikelen',
      tab_pages: "Pagina's",
      sort_updated: 'Bijgewerkt',
      sort_seo_score: 'SEO-score',
      sort_title: 'Titel',
      sort_vendor: 'Vendor',
      sort_created: 'Aangemaakt',
      sort_desc: 'Aflopend',
      sort_asc: 'Oplopend',
      filter_seo_all: 'SEO: alle',
      filter_optimized: 'Geoptimaliseerd',
      filter_medium: 'Gemiddeld',
      filter_needs_improvement: 'Te verbeteren',
      filter_image_all: 'Afbeeldingen: alle',
      filter_image_yes: 'Met afbeeldingen',
      filter_image_no: 'Zonder afbeeldingen',
      filter_meta_all: 'Meta: alle',
      filter_meta_yes: 'Met meta',
      filter_meta_no: 'Zonder meta',
      filter_desc_all: 'Beschrijving: alle',
      filter_desc_yes: 'Met beschrijving',
      filter_desc_no: 'Zonder beschrijving',
      filter_vendor_all: 'Vendor: alle',
      filter_collection_all: 'Collectie: alle',
      filter_type_all: 'Type: alle',
      reset_filters: 'Filters resetten',
      th_image: 'Afbeelding',
      th_title: 'Titel',
      th_seo_score: 'SEO-score',
      th_alt: 'ALT',
      th_meta: 'Meta',
      th_status: 'Status',
      th_actions: 'Acties',
      no_products_filters: 'Geen producten gevonden met deze filters',
      no_products: 'Geen producten. Synchroniseer vanuit je Shopify winkel.',
      pagination: 'Pagina {{page}} van {{total}} · {{count}} producten',
      batch_btn: 'Batchbewerkingen',
      dialog_status: 'Status',
      dialog_seo_score: 'SEO-score',
      dialog_shopify_id: 'Shopify-ID',
      dialog_vendor: 'Vendor',
      dialog_serp: 'SERP-voorbeeld',
      dialog_issues: 'SEO-problemen',
      dialog_suggestions: 'Suggesties',
      generating: 'Genereren...',
      generate_all: 'Alle inhoud genereren',
      action_generate_ai: 'AI-inhoud genereren',
      action_translate: 'Vertalen',
      action_optimize_image: 'Afbeelding optimaliseren',
      syncing: 'Synchroniseren...',
      draft_ready: 'Concept klaar',
      seo_ai_btn: 'SEO AI',
      batch_ops_btn: 'Batchbewerkingen',
      diagnosis: 'Diagnostiek',
      current_score: 'Huidige score',
      projected: '→ verwacht {{score}}/100',
      meta_title: 'Meta Title',
      meta_desc_label: 'Meta Description',
      description_label: 'Beschrijving',
      generate_desc_btn: 'AI-beschrijving genereren',
      generating_desc: 'Genereren...',
      generate_ai_btn: 'Genereren met AI',
      publish_shopify_btn: 'Publiceren op Shopify',
      publishing: 'Publiceren...',
      discard_draft_btn: 'Concept verwijderen',
      seo_ai_dialog_title: 'SEO AI',
      seo_all: 'SEO: alle',
      seo_optimized: 'Geoptimaliseerd',
      seo_medium: 'Gemiddeld',
      seo_needs: 'Te verbeteren',
      page_of: 'Pagina {{page}} van {{total}}',
      search_placeholder: 'Zoeken op titel, SKU, EAN, leverancier, handle...',
      chars_count: '{{n}}/{{max}} tekens',
      n_selected_info: 'geselecteerd',
      filtered: 'gefilterd',
      soon_tooltip: 'Binnenkort beschikbaar',
      resource_subtitle: '{{type}} Shopify en hun SEO-status',
      articles_blog: 'Artikelen (blog)',
      select_visible_title: 'Alle zichtbare selecteren/deselecteren',
      toast_draft_ready: 'SEO-concept gegenereerd. Controleer en publiceer.',
      toast_error_ai: 'AI-generatiefout',
      toast_desc_generated: 'AI-beschrijving gegenereerd.',
      toast_error_desc: 'Fout bij het genereren van de beschrijving',
      toast_empty_draft: 'Genereer of vul minstens één veld in',
      toast_published_score: 'Gepubliceerd op Shopify · Score {{score}}/100',
      toast_error_publish: 'Fout bij publiceren op Shopify',
      toast_draft_discarded: 'Concept verwijderd',
      toast_select_items: 'Selecteer minstens één item',
      toast_mode_publish: 'Publicatie',
      toast_mode_both: 'Genereren+Publiceren',
      toast_mode_generate: 'AI SEO-generatie',
      toast_batch_launched: '{{label}} gestart op {{count}} {{type}}.',
      toast_batch_errors: '{{label}} voltooid met {{count}} fouten',
      toast_batch_done: '{{label}} voltooid op {{count}} {{type}}',
      toast_synced: '{{type}} gesynchroniseerd: {{count}}',
      toast_sync_error: 'Synchronisatiefout {{type}}',
      toast_token_error: 'Shopify-token verlopen of zonder rechten',
      reinstall_label: 'Opnieuw installeren',
      toast_sync_started: '{{type}} synchronisatie gestart',
      toast_error_sync_start: 'Fout bij starten synchronisatie',
      toast_perms_ok: 'Rechten ok ({{kind}})',
      toast_token_revoked: 'Token ingetrokken',
      toast_perms_missing: 'Ontbrekende rechten',
      toast_diag_error: 'Diagnostische fout',
      toast_score: 'Score {{score}}/100',
      toast_error_analyze: 'Analysefout',
      toast_generated: 'Inhoud gegenereerd',
      toast_error_generate: 'Generatiefout',
    },
    content: {
      title: 'Inhoudgeneratie',
      generate: 'Inhoud genereren',
      language: 'Taal',
      tone: 'Toon',
      subtitle: 'Genereer beschrijvingen, SEO-titel, meta description en keywords met AI',
      tab_products: 'Producten',
      tab_collections: 'Collecties',
      tab_articles: 'Artikelen',
      tab_pages: "Pagina's",
      type_description_label: 'Beschrijving',
      type_description_hint: 'Aantrekkelijke en SEO-vriendelijke producttekst',
      type_seo_title_label: 'SEO-titel',
      type_seo_title_hint: 'Voor SERP geoptimaliseerde titel (max 60 tekens)',
      type_meta_desc_label: 'Meta Description',
      type_meta_desc_hint: 'Google-fragment (max 160 tekens)',
      type_keywords_label: 'Keywords',
      type_keywords_hint: 'Primaire en secundaire keywords',
      type_body_label: 'Beschrijving / Hoofdtekst',
      type_body_hint: 'Hoofdtekst van de bron',
      filter_all: 'Alle',
      filter_needs: 'Te verbeteren',
      filter_medium: 'Gemiddeld',
      filter_optimized: 'Geoptimaliseerd',
      no_results_filters: 'Geen elementen komen overeen met de filters',
      select_all: 'Alles selecteren',
      deselect: 'Deselecteren',
      selected_count: '{{count}} geselecteerd',
      selected_max: '(max)',
      deselect_all: 'Alles deselecteren',
      pagination_of: '{{page}} / {{total}}',
      total_count: '({{count}} tot.)',
      content_type_section: 'Inhoudstype',
      batch_generating: 'Genereren… {{done}}/{{total}}',
      batch_generate_btn: 'Batch genereren ({{count}})',
      generating_count: 'Genereren ({{count}})',
      generate_btn: 'Genereren',
      generating: 'Genereren…',
      generate_all_btn: 'Alle',
      hint_select: '← Selecteer een element of vink meerdere aan voor batch',
      hint_batch_ready: '{{count}} element(en) klaar voor batch',
      batch_done_title: '✓ Batch voltooid',
      batch_pending_title: 'Batch in afwachting…',
      batch_in_progress_title: 'Batchgeneratie bezig…',
      batch_done_msg: 'Alle inhoud gegenereerd. De selectie wordt automatisch gewist.',
      results_section: 'Resultaten',
      publishing: 'Publiceren…',
      published: 'Gepubliceerd',
      publish_btn: 'Publiceren op Shopify',
      clear_results: 'Wissen',
      chars_unit: 'tekens',
      cache_label: 'cache',
      preview_section: 'Huidig voorbeeld',
      loading_detail: 'Detail laden…',
      not_present: 'Niet aanwezig',
      not_present_plural: 'Niet aanwezig',
      empty_state: 'Klik op een element om het te bekijken, of vink meerdere aan en gebruik Batch genereren',
      copy_btn: 'Kopiëren',
      type_seo_title_hint_content: 'Metatitel voor SERP (max. 60 tek.)',
      no_items: 'Geen {{type}} gevonden',
      item_deselect: 'Deselecteren',
      item_select: 'Aan selectie toevoegen',
      generate_all_title: 'Alle beschikbare typen genereren',
      prev_item: 'Vorig item',
      next_item: 'Volgend item',
      toast_load_error: 'Fout bij het laden van items',
      toast_batch_done: 'Batch voltooid: {{done}}/{{total}} producten',
      toast_batch_failed: 'Batch mislukt: {{failed}} fouten van {{total}}',
      toast_batch_cancelled: 'Batch geannuleerd',
      toast_batch_resumed: 'Actieve batch hervat…',
      toast_max_select: 'Maximaal {{max}} items selecteerbaar',
      toast_select_item: 'Selecteer een item uit de lijst',
      toast_select_type: 'Selecteer minimaal één inhoudstype',
      toast_from_cache: 'Inhoud uit cache!',
      toast_generated: 'Succesvol gegenereerd!',
      toast_generate_error: 'Fout bij het genereren van inhoud',
      toast_batch_running: 'Er is al een batchproces actief',
      toast_no_store: 'Winkel niet beschikbaar',
      toast_batch_started: 'Batch gestart: {{n}} producten in wachtrij',
      toast_batch_start_error: 'Fout bij het starten van de batch',
      toast_batch_item_error: 'Generatiefout: {{title}}',
      toast_batch_complete: 'Batch voltooid: {{done}}/{{total}} items',
      toast_cancel_error: 'Fout bij het annuleren van de batch',
      toast_published: 'Inhoud gepubliceerd op Shopify!',
      toast_publish_error: 'Fout bij het publiceren',
      toast_copied: 'Gekopieerd naar klembord',
      present: 'aanwezig',
      missing: 'ontbrekend',
      lang_it: 'Italiaans',
      lang_en: 'Engels',
      lang_fr: 'Frans',
      lang_de: 'Duits',
      lang_es: 'Spaans',
      lang_pt: 'Portugees',
      tone_professional: 'Professioneel',
      tone_luxury: 'Luxe',
      tone_technical: 'Technisch',
      tone_conversational: 'Conversationeel',
    },
    images: {
      title: 'Afbeeldingsoptimalisatie',
      optimize: 'Optimaliseren',
      format: 'Formaat',
      compress: 'Comprimeren',
      quality: 'Kwaliteit',
      alt_mode_label: 'ALT-generatiemodus',
      alt_mode_ai: 'AI-intelligent',
      alt_mode_template: 'Gratis template',
      alt_mode_auto: 'Auto fallback',
      subtitle: 'Optimaliseer afbeeldingen, beheer ALT-tekst en publiceer op Shopify.',
      tab_optimize: 'Afbeeldingen optimaliseren',
      tab_alt: 'ALT-tekst',
      alt_coverage: 'ALT-dekking',
      with_alt_count: 'met ALT van',
      stat_with_alt: 'Met ALT: {{count}}',
      stat_without_alt: 'Zonder ALT: {{count}}',
      stat_no_image: 'Zonder afbeelding: {{count}}',
      sync_alt_btn: 'ALT-gegevens bijwerken vanuit Shopify',
      syncing_alt: 'ALT bijwerken...',
      sync_status_label: 'Status:',
      analyzed_label: 'Geanalyseerd:',
      last_updated_label: 'Laatste update:',
      stalled: 'vastgelopen',
      force_stop: 'Geforceerd stoppen (60s vastgelopen)',
      free_badge: '● Gratis — geen credits',
      configure_btn: '▼ Configureren',
      hide_btn: '▲ Verbergen',
      template_free_hint: 'Gratis modus actief — nul AI-credits. Template:',
      template_auto_hint: 'Automatisch terugvallen — AI als credits beschikbaar, anders lokaal template.',
      template_config_title: 'ALT-template configureren',
      template_label: 'Aangepast template',
      template_preview: 'Voorbeeld:',
      variables_label: 'Beschikbare variabelen — klik om in te voegen:',
      restore_default: 'Standaard herstellen',
      save_config: 'Configuratie opslaan',
      saving: 'Opslaan...',
      search_placeholder: 'Zoeken op titel, vendor, handle...',
      filter_all_images: 'Alle',
      filter_with_alt: 'Met ALT',
      filter_without_alt: 'Zonder ALT',
      selected_images: '{{count}} afbeeldingen geselecteerd (max 50 per batch)',
      generate_batch_btn: 'ALT genereren voor geselecteerde',
      batch_alt_in_progress: 'ALT-batch bezig: {{done}} / {{total}}',
      batch_errors: '{{n}} fouten',
      select_all_label: 'Alles selecteren',
      deselect_all_label: 'Alles deselecteren',
      total_products_label: '{{count}} producten',
      timeout_title: 'Laden duurde te lang (20s)',
      timeout_desc: 'De database verwerkt veel producten. Probeer het over enkele seconden opnieuw.',
      error_title: 'Fout bij laden van lijst',
      no_products_filter: 'Geen producten komen overeen met de filters',
      alt_placeholder: 'ALT-tekst (max 125 tekens)',
      status_published: 'Gepubliceerd',
      status_saved: 'Opgeslagen',
      status_draft_alt: 'Concept',
      status_missing: 'Geen ALT',
      generate_alt_btn: 'ALT genereren',
      save_alt_btn: 'ALT opslaan',
      publish_alt_btn: 'Publiceren',
      prec: 'Vorige',
      succ: 'Volgende',
      select_products: 'Producten selecteren',
      filter_collection_all: 'Collectie: alle',
      filter_vendor_all: 'Vendor: alle',
      filter_kb_all: 'KB: alle',
      filter_kb_100: 'Bestanden boven 100 KB',
      filter_kb_500: 'Bestanden boven 500 KB',
      filter_kb_1mb: 'Bestanden boven 1 MB',
      filter_format_all: 'Formaat: alle',
      filter_landscape: 'Breedte groter dan hoogte',
      filter_portrait: 'Hoogte groter dan breedte',
      filter_square: 'Vierkant',
      filter_status_all: 'Status: alle',
      filter_status_optimized: 'Al geoptimaliseerd',
      filter_status_needs: 'Te optimaliseren',
      visible_total: '{{visible}} zichtbaar · {{total}} totaal',
      reset_filters: 'Filters resetten',
      clear_selection: 'Selectie wissen',
      no_image_products: 'Geen producten met afbeelding',
      ready_badge: 'Klaar',
      settings_title: 'Instellingen',
      format_title: 'Afbeeldingsformaat',
      format_square: 'Vierkant 1:1',
      format_landscape: 'Liggend 4:3',
      format_portrait: 'Staand 3:4',
      format_none: 'Geen aanpassing',
      format_none_sub: 'Originele afmetingen',
      compress_label: 'Compressie',
      compress_desc: 'Bestandsgrootte verkleinen',
      quality_label: 'Kwaliteit',
      batch_opt_running: 'Optimalisatie bezig',
      batch_opt_cancelled: 'Optimalisatie geannuleerd',
      batch_opt_completed: 'Optimalisatie voltooid',
      batch_apply_running: 'Toepassing bezig',
      batch_apply_cancelled: 'Toepassing geannuleerd',
      batch_apply_completed: 'Toepassing voltooid',
      background_note: 'Je kunt van sectie wisselen, gaat door op de achtergrond',
      optimizing: 'Optimaliseren...',
      optimize_n: '{{count}} afbeeldingen optimaliseren',
      optimize_one: 'Afbeelding optimaliseren',
      applying: 'Toepassen...',
      apply_n: '{{count}} toepassen op Shopify',
      apply_one: 'Toepassen op Shopify',
      preview_title: 'Voorbeeld',
      ready_optimizations: '{{count}} optimalisaties klaar',
      select_preview_hint: 'Selecteer een of meer producten om het voorbeeld te zien',
      first_product_preview: 'Voorbeeld voor het eerste geselecteerde product:',
      original_label: 'Origineel',
      optimized_label: 'Geoptimaliseerd',
      optimize_click_hint: 'Klik op "Optimaliseren" voor het resultaat',
      reduction_label: 'Reductie',
      apply_btn: 'Toepassen',
      history_opt_title: 'Optimalisatiegeschiedenis',
      history_opt_subtitle: 'Operaties toegepast op Shopify, fouten en herstel.',
      stat_running_label: 'Bezig',
      stat_completed_label: 'Voltooid',
      stat_errors_label: 'Onvolledig',
      stat_undo_label: 'Ongedaan maken',
      total_savings: 'Totale besparing',
      history_loading: 'Geschiedenis laden...',
      no_history: 'Nog geen operaties toegepast.',
      restoring: 'Herstellen...',
      undo_btn: 'Ongedaan maken',
      kb_warning: 'KB-grootte is niet in lokale gegevens. Om het nauwkeurig te maken moet het door de backend worden opgeslagen tijdens de afbeeldingssynchronisatie.',
      senza_vendor: 'Geen vendor',
      alt_stat_coverage: '{{n}} met ALT van {{total}}',
      apply_batch_cancelled: 'Toepassing geannuleerd',
      apply_batch_done_label: 'Toepassing voltooid',
      apply_batch_running: 'Toepassing bezig',
      apply_n_btn: '{{n}} toepassen op Shopify',
      applying_btn: 'Toepassen...',
      auto_fallback_hint: 'Auto fallback — AI als credits beschikbaar zijn, lokaal template als ze op zijn.',
      background_hint: 'U kunt van sectie wisselen, gaat door op de achtergrond',
      badge_draft: 'Concept',
      badge_missing: 'Geen ALT',
      badge_published: 'Gepubliceerd',
      badge_ready: 'Klaar',
      badge_saved: 'Opgeslagen',
      batch_close: 'Sluiten',
      batch_generate_btn: 'ALT genereren voor geselecteerde',
      batch_progress: 'ALT Batch bezig: {{done}} / {{total}}',
      batch_selected: '{{n}} afbeeldingen geselecteerd (max 50 per batch)',
      collection_all: 'Collectie: alle',
      compress_sub: 'Bestandsgrootte verkleinen',
      config_btn: '▼ Configureren',
      deselect_all: 'Alles deselecteren',
      empty_filtered: 'Geen producten die overeenkomen met de filters',
      filter_all: 'Alle',
      format_label: 'Afbeeldingsformaat',
      gen_alt_btn: 'ALT genereren',
      history_completed: 'Voltooid',
      history_empty: 'Nog geen bewerkingen toegepast.',
      history_incomplete: 'Onvolledig',
      history_running: 'Bezig',
      history_savings: 'Totale besparing',
      history_subtitle: 'Bewerkingen toegepast op Shopify, fouten en herstel.',
      history_title: 'Optimalisatiegeschiedenis',
      history_undo_label: 'Ongedaan maken',
      last_update_label: 'Laatste update:',
      load_error: 'Fout bij laden van lijst',
      n_errors: '{{n}} fouten',
      n_products: '{{n}} producten',
      n_selected: '{{n}} geselecteerd',
      next_page: 'Volg.',
      no_products: 'Geen producten met afbeelding',
      no_vendor: 'Geen vendor',
      opt_batch_cancelled: 'Optimalisatie geannuleerd',
      opt_batch_done: 'Optimalisatie voltooid',
      opt_batch_running: 'Optimalisatie bezig',
      optimize_n_btn: '{{n}} afbeeldingen optimaliseren',
      optimize_one_btn: 'Afbeelding optimaliseren',
      optimizing_btn: 'Optimaliseren...',
      orientation_all: 'Formaat: alle',
      orientation_landscape: 'Breedte groter dan hoogte',
      orientation_portrait: 'Hoogte groter dan breedte',
      orientation_square: 'Vierkant',
      page_info: 'Pagina {{page}} van {{total}}',
      pagination: 'Pagina {{page}} van {{total}}',
      prev: 'Vorig.',
      publish_btn: 'Publiceren',
      retry: 'Opnieuw proberen',
      select_all: 'Alles selecteren',
      size_100kb: 'Bestanden groter dan 100 KB',
      size_1mb: 'Bestanden groter dan 1 MB',
      size_500kb: 'Bestanden groter dan 500 KB',
      size_all: 'KB: alle',
      status_all: 'Status: alle',
      status_label: 'Status:',
      status_needs: 'Te optimaliseren',
      status_optimized: 'Al geoptimaliseerd',
      status_stalled: 'geblokkeerd',
      sync_btn: 'ALT-gegevens bijwerken vanuit Shopify',
      sync_btn_title: 'Herleest afbeeldingen en echte ALT-teksten van Shopify',
      syncing: 'ALT bijwerken...',
      template_active: 'Gratis modus actief — nul AI-credits. Template:',
      template_custom_label: 'Aangepast template',
      template_free_badge: '● Gratis — geen credits',
      template_preview_label: 'Voorbeeld:',
      template_reset: 'Standaard herstellen',
      template_save: 'Configuratie opslaan',
      template_saving: 'Opslaan...',
      template_vars_label: 'Beschikbare variabelen — klik om in te voegen:',
      timeout_msg: 'De database verwerkt veel producten. Probeer het over een paar seconden opnieuw.',
      toast_alt_ai: 'ALT gegenereerd via AI',
      toast_alt_cancelled: 'ALT-update geannuleerd — u kunt het opnieuw starten',
      toast_alt_empty: 'Lege ALT',
      toast_alt_from_cache: 'ALT uit cache',
      toast_alt_gen_error: 'Fout bij genereren ALT',
      toast_alt_publish_error: 'Publicatiefout',
      toast_alt_published: 'Gepubliceerd op Shopify',
      toast_alt_save_error: 'Opslagfout',
      toast_alt_saved: 'ALT opgeslagen',
      toast_alt_sync_start_error: 'Fout bij starten ALT-update',
      toast_alt_sync_started: 'ALT-gegevens bijwerken gestart',
      toast_alt_template: 'ALT gegenereerd via template (gratis)',
      toast_alt_template_fallback: 'ALT via template (credits op)',
      toast_alt_update_error: 'Fout bij bijwerken ALT',
      toast_alt_updated: 'ALT-gegevens bijgewerkt: {{n}} producten geanalyseerd',
      toast_applied: 'Afbeelding toegepast op Shopify',
      toast_apply_batch_done: '{{n}} afbeeldingen toegepast op Shopify',
      toast_apply_batch_errors: 'Toepassing voltooid met {{n}} fouten',
      toast_apply_batch_started: 'Toepassing gestart: {{n}} afbeeldingen. U kunt van sectie wisselen.',
      toast_batch_alt_done: 'Batch voltooid',
      toast_batch_alt_started: 'Batch gestart: {{n}} afbeeldingen, {{c}} tegelijk',
      toast_batch_done: 'Batch voltooid: {{n}} afbeeldingen geoptimaliseerd. U kunt ze toepassen op Shopify.',
      toast_batch_errors: '{{n}} afbeeldingen niet verwerkt. Probeer opnieuw of controleer de logs.',
      toast_batch_started: 'Batch gestart: {{n}} afbeeldingen. U kunt van sectie wisselen, gaat door op de achtergrond.',
      toast_cancel_error: 'Annuleringsfout',
      toast_no_draft: 'Geen geoptimaliseerde afbeelding om toe te passen',
      toast_no_images: 'Geen afbeelding geselecteerd',
      toast_no_ready: 'Geen optimalisatie klaar om toe te passen',
      toast_no_store: 'Winkel niet beschikbaar',
      toast_optimize_error: 'Optimalisatiefout',
      toast_optimized: 'Afbeelding geoptimaliseerd. U kunt deze nu toepassen op Shopify.',
      toast_select_product: 'Selecteer ten minste één product',
      toast_template_save_error: 'Fout bij opslaan van template',
      toast_template_saved: 'Templateconfiguratie opgeslagen',
      toast_undo_done: 'Originele afbeelding hersteld',
      toast_undo_error: 'Fout tijdens herstellen',
      undoing_btn: 'Herstellen...',
      vendor_all: 'Vendor: alle',
      toast_no_product: 'Selecteer een product',
      toast_no_image: 'Het product heeft geen afbeelding',
      toast_no_preview: 'Optimaliseer eerst een afbeelding',
      toast_apply_error: 'Fout bij toepassen op Shopify',
      n_ready: '{{n}} optimalisaties klaar',
      preview_hint: 'Selecteer een of meer producten om het voorbeeld te zien',
      preview_first: 'Voorbeeld van het eerste geselecteerde product:',
      click_optimize_hint: 'Klik op "Optimaliseren" voor het resultaat',
      apply_single_btn: 'Toepassen',
    },
    alt_template: {
      section_title: 'ALT-template',
      mode_label: 'ALT-tekst generatiemodus',
      textarea_label: 'Aangepast template',
      preview_label: 'Voorbeeld',
      vars_label: 'Beschikbare variabelen — klik om in te voegen',
      hint_template: 'Gratis modus: geen AI-credits verbruikt voor ALT-tekst.',
      hint_auto: 'Auto fallback: AI als credits beschikbaar, anders lokaal template.',
    },
    batch: {
      title: 'Batchbewerkingen',
      start: 'Starten',
      cancel: 'Annuleren',
      subtitle: 'Persistente serververwerking — gaat door ook als je van pagina wisselt of het tabblad sluit',
      locked_title: 'Batchbewerkingen niet beschikbaar',
      locked_desc: 'Batchbewerkingen zijn beschikbaar vanaf het Starter-plan. Verwerk honderden producten parallel met één klik.',
      upgrade_btn: 'Upgraden naar Starter',
      op_content_label: 'AI-inhoud genereren',
      op_content_desc: 'Beschrijving, SEO-titel, meta description, keywords',
      op_translate_label: 'Producten vertalen',
      op_translate_desc: 'Volledige vertaling naar geselecteerde taal',
      op_images_label: 'Afbeeldingen optimaliseren',
      op_images_desc: '1:1 aanpassing en afbeeldingscompressie',
      field_description_label: 'Beschrijving',
      field_description_hint: '150-250 woorden',
      field_seo_title_label: 'SEO-titel',
      field_seo_title_hint: 'max 60 tekens',
      field_meta_desc_label: 'Meta Description',
      field_meta_desc_hint: '100-160 tekens',
      field_keywords_label: 'Keywords',
      field_keywords_hint: '5-10 keywords',
      count_all: 'Alle',
      status_pending: 'In wachtrij',
      status_running: 'Bezig',
      status_completed: 'Voltooid',
      status_failed_job: 'Mislukt',
      status_cancelled: 'Geannuleerd',
      opt_in_progress: 'Afbeeldingsoptimalisatie bezig…',
      batch_in_progress: 'AI-batch bezig…',
      images_progress: '{{done}} / {{total}} afbeeldingen',
      products_progress: '{{done}} / {{total}} producten',
      errors_count: '{{count}} fouten',
      duration_label: 'Duur: {{time}}',
      starting: 'Starten...',
      seo_gen_in_progress: 'SEO genereren + publiceren bezig',
      gen_publish_auto: 'Automatisch genereren en publiceren op Shopify',
      section_operation: 'Bewerking',
      section_fields: 'Te genereren velden',
      fields_selected: '{{count}}/{{total}} geselecteerd',
      fields_warning: 'Selecteer minimaal één veld om de batch te starten',
      fields_hint: 'Één AI-aanroep per product genereert alle geselecteerde velden — lagere latentie en lagere kosten.',
      section_options: 'Opties',
      label_language: 'Taal',
      label_tone: 'Toon',
      tone_professional: 'Professioneel',
      tone_luxury: 'Luxe',
      tone_technical: 'Technisch',
      tone_conversational: 'Conversationeel',
      label_target_lang: 'Doeltaal',
      images_note: '1:1 aanpassing (800×800) + 85% kwaliteitscompressie.',
      section_quantity: 'Producthoeveelheid',
      available_count: '{{count}} beschikbaar',
      catalog_selection: '{{count}} product(en) geselecteerd uit catalogus',
      remove_selection: 'Selectie verwijderen',
      products_selected_count: '{{count}} product(en) geselecteerd',
      processing: 'Verwerking bezig…',
      start_btn: 'Verwerking starten',
      history_title: 'Batchgeschiedenis',
      history_subtitle: 'bijgewerkt vanuit DB',
      stat_running: 'Bezig',
      stat_completed: 'Voltooid',
      stat_products_ok: 'Producten OK',
      no_batch: 'Geen batch uitgevoerd',
      no_batch_hint: 'Taken verschijnen hier na de eerste verwerking',
      job_content: 'AI-inhoud genereren',
      job_translate: 'Vertaling',
      job_images: 'Afbeeldingsoptimalisatie',
      job_products: '{{done}}/{{total}} producten',
      log_lang: 'Taal:',
      log_tone: 'Toon:',
      toast_completed: 'Batch voltooid: {{done}}/{{total}} producten verwerkt',
      toast_failed: 'Batch mislukt: {{count}} fouten',
      toast_no_products: 'Geen producten beschikbaar',
      soon_lbl: 'binnenkort',
      btn_analyze_seo: 'SEO analyseren',
      btn_view: 'Bekijken',
      toast_no_fields: 'Selecteer minstens één veld om te genereren',
      toast_images_started: 'Beeldoptimalisatie gestart: {{count}} producten',
      toast_started: 'Batch gestart: {{count}} producten',
      toast_start_error: 'Startfout',
      toast_cancelled: 'Batch geannuleerd',
      toast_cancel_error: 'Annuleringsfout',
      fields_label: 'Velden',
      log_summary: 'Enkelvoudige bewerkingslogboeken',
    },
    history: {
      title: 'Geschiedenis',
      empty: 'Geen bewerkingen gevonden',
      subtitle: 'Volledig audit van alle AI-uitvoeringen — {{n}} bewerkingen totaal',
      refresh_btn: 'Vernieuwen',
      total_operations: 'Totaal bewerkingen',
      success_rate: 'Slagingspercentage',
      n_successes: '{{n}} successen',
      credits_today: 'Credits vandaag',
      products_today: 'Producten vandaag',
      avg_duration: 'Gemiddelde duur',
      last_autopilot: 'Laatste Autopilot',
      filters: 'Filters',
      filters_active: 'actief',
      reset_all: 'Alles resetten',
      search_placeholder: 'Product zoeken...',
      op_all: 'Alle typen',
      op_description: 'AI-beschrijving',
      op_seo_title: 'SEO Title AI',
      op_meta_description: 'Meta Description AI',
      op_batch: 'Batchgeneratie',
      op_translation: 'Vertaling',
      op_image: 'Afbeelding',
      op_sync: 'Sync Shopify',
      trigger_all: 'Alle triggers',
      status_all: 'Alle statussen',
      status_success: 'Succes',
      status_partial: 'Gedeeltelijk',
      status_error: 'Fout',
      th_status: 'Status',
      th_type: 'Bewerkingstype',
      th_product: 'Product',
      th_trigger: 'Trigger',
      th_seo_delta: 'SEO Delta',
      th_credits: 'Credits',
      th_duration: 'Duur',
      th_timestamp: 'Tijdstempel',
      loading: 'Laden...',
      remove_filters: 'Filters verwijderen',
      load_more: 'Meer laden ({{shown}} van {{total}} weergegeven)',
      details_title: 'Uitvoeringsdetails',
      detail_op_id: 'Bewerkings-ID',
      detail_product_id: 'Product-ID',
      detail_store_id: 'Store ID',
      detail_type: 'Type',
      detail_trigger: 'Trigger',
      detail_status: 'Status',
      detail_language: 'Taal',
      detail_tone: 'Toon',
      detail_tokens: 'Gebruikte tokens',
      detail_fields: 'Velden',
      detail_credits: 'Credits',
      detail_duration: 'Duur',
      detail_seo_before: 'SEO voor',
      detail_seo_after: 'SEO na',
      detail_timestamp: 'Tijdstempel',
      error_prefix: 'Fout: ',
      label_description: 'AI-beschrijving',
      label_seo_title: 'SEO Title AI',
      label_meta_description: 'Meta Description AI',
      label_keywords: 'Keywords AI',
      label_batch: 'Batchgeneratie',
      label_translation: 'Vertaling',
      label_image: 'Afbeeldingsoptimalisatie',
      label_sync: 'Sync Shopify',
      label_push: 'Shopify-publicatie',
    },
    batch_banner: {
      errors: 'fouten',
      optimizing: 'Beeldoptimalisatie',
      optimizing_cancelled: 'Optimalisatie geannuleerd',
      optimizing_completed: 'Optimalisatie voltooid',
      applying: 'Toepassen op Shopify',
      applying_cancelled: 'Toepassing geannuleerd',
      applying_completed: 'Toepassing voltooid',
      open_images: 'Afbeeldingen openen',
      open_catalog: 'Catalogus openen',
      type_collections: 'Collecties',
      type_articles: 'Artikelen',
      type_pages: "Pagina's",
      type_contents: 'Inhoud',
      mode_publish: 'Publicatie',
      mode_both: 'Genereren+Publiceren',
      mode_generate: 'AI SEO-generatie',
      state_cancelled: '(geannuleerd)',
      state_completed: '(voltooid)',
    },
    app_banner: {
      expired: 'Shopify-token verlopen of ingetrokken.',
      reconnect_desc: 'Verbind de app opnieuw om sync en publicatie te herstellen.',
      detected_in: 'gedetecteerd in',
      reconnect_btn: 'Nu opnieuw verbinden',
    },
    review_popup: {
      greeting: 'Hallo! Ik ben hier 👋',
      subtitle: 'Ik hoop dat alles goed gaat met AI Optimizer!',
      rating_title: 'Vind je de app leuk?',
      rating_desc: 'Jouw mening helpt ons te verbeteren en andere Shopify-handelaars te bereiken.',
      rating_tap: 'Tik op een ster om te beoordelen',
      star: {
        terrible: 'Verschrikkelijk',
        bad: 'Niet goed',
        average: 'Gemiddeld',
        good: 'Goed!',
        excellent: 'Uitstekend! 🚀',
      },
      positive_title: 'Fantastisch! Hartelijk bedankt 🎉',
      positive_desc: 'Het duurt maar 1 minuut!',
      negative_title: 'Bedankt voor de feedback 🙏',
      negative_desc: 'Heb je ideeën over wat we beter kunnen doen?',
      review_btn: '⭐ Een recensie achterlaten',
      close_btn: 'Sluiten',
      dismiss: 'Niet meer tonen',
      skip: 'Overslaan →',
    },
    support: {
      title: 'Ondersteuning',
      send: 'Verzenden',
      placeholder: 'Schrijf uw bericht...',
    },
    editor: {
      placeholder: 'Schrijf hier...',
      bold: 'Vet',
      italic: 'Cursief',
      underline: 'Onderstrepen',
      h2: 'Koptekst H2',
      h3: 'Koptekst H3',
      paragraph: 'Alinea',
      ul: 'Opsommingslijst',
      ol: 'Genummerde lijst',
      blockquote: 'Citaat',
      link: 'Link invoegen',
      remove_format: 'Opmaak verwijderen',
      link_prompt: 'Link-URL',
    },
    recommendations: {
      empty: 'Geen kritieke acties op dit moment. Geweldig werk!',
      filter_all_prio: 'Alle prioriteiten',
      filter_all_cat: 'Alle categorieën',
      count_shown: '{{n}} acties weergegeven',
      see: 'Bekijk',
      sev_high: 'Hoog',
      sev_medium: 'Gemiddeld',
      sev_low: 'Laag',
      cat_catalog: 'Catalogus',
      missing_meta_description: '{{count}} producten zonder meta beschrijving',
      missing_description: '{{count}} producten zonder beschrijving',
      missing_alt_text: '{{count}} afbeeldingen zonder ALT-tekst',
      missing_product_image: '{{count}} producten zonder afbeelding',
    },
    audit: {
      not_detected: 'Niet gedetecteerd',
      disabled: 'Uitgeschakeld',
      not_scanned: 'Analyse niet uitgevoerd',
      status_warning: 'Waarschuwing',
      status_error: 'Fout',
      cat_performance: 'Prestaties',
      cat_trust: 'Vertrouwen',
      cat_catalog: 'Catalogus',
      checks_suffix: 'controles',
      badge_err: 'fout',
      badge_warn: 'warn',
      badge_ok: 'ok',
      value_label: 'Waarde',
      checks: {
        title: { name: 'Titel', hint: 'Paginatitel' },
        meta_description: { name: 'Meta beschrijving', hint: 'Meta beschrijving van de homepage' },
        h1: { name: 'H1', hint: 'Precies 1 H1 per pagina is optimaal' },
        h2: { name: 'H2', hint: 'Minimaal één H2 aanbevolen' },
        canonical: { name: 'Canonical', hint: 'Canonieke URL' },
        lang: { name: 'Taal', hint: 'Taalattribuut' },
        json_ld_structured_data: { name: 'JSON-LD / Gestructureerde Data', hint: 'Gestructureerde data' },
        open_graph: { name: 'Open Graph', hint: 'Social meta' },
        twitter_card: { name: 'Twitter Card', hint: 'Meta Twitter/X' },
        robots_txt: { name: 'robots.txt', hint: 'Robots' },
        sitemap_xml: { name: 'Sitemap.xml', hint: 'Sitemap' },
        status_code: { name: 'Statuscode', hint: 'HTTP-statuscode' },
        indexability: { name: 'Indexeerbaarheid', hint: 'Indexeerbaarheid' },
        redirects: { name: 'Doorverwijzingen', hint: 'Definitieve URL' },
        https: { name: 'HTTPS', hint: 'HTTPS' },
        load_time: { name: 'Laadtijd', hint: 'Server-naar-server gemeten' },
        page_weight: { name: 'Paginagewicht', hint: 'HTML-grootte van de homepage' },
        image_lazy_loading: { name: 'Lazy loading afbeeldingen', hint: 'Lazy afbeeldingen' },
        mobile_viewport: { name: 'Mobiele viewport', hint: 'Mobiele viewport' },
        favicon: { name: 'Favicon', hint: 'Favicon' },
        images_with_alt: { name: 'Afbeeldingen met ALT', hint: 'Toegankelijkheid afbeeldingen' },
        privacy_policy: { name: 'Privacybeleid', hint: 'Privacy' },
        cookie_policy: { name: 'Cookiebeleid', hint: 'Cookie' },
        terms_conditions: { name: 'Algemene voorwaarden', hint: 'Voorwaarden' },
        contact_page: { name: 'Contactpagina', hint: 'Contact' },
        shipping_policy: { name: 'Verzendbeleid', hint: 'Verzending' },
        returns_refunds: { name: 'Retournering & Terugbetaling', hint: 'Retouren' },
        social_links: { name: 'Sociale links', hint: 'Social' },
        products_without_description: { name: 'Producten zonder beschrijving', hint: 'Productbeschrijvingen' },
        products_without_images: { name: 'Producten zonder afbeeldingen', hint: 'Productafbeeldingen' },
        products_without_meta_description: { name: 'Producten zonder meta beschrijving', hint: 'Product meta beschrijvingen' },
        duplicate_titles: { name: 'Dubbele titels', hint: 'Producttitels' },
        duplicate_meta_descriptions: { name: 'Dubbele meta beschrijvingen', hint: 'Product meta beschrijvingen' },
        thin_content_200_char: { name: 'Dunne inhoud (<200 tekens)', hint: 'Productinhoud' },
      },
    },
    score_card: {
      pillar_technical_seo: 'Technische SEO',
      pillar_ux: 'UX',
      pillar_performance: 'Performance',
      pillar_trust: 'Trust',
      pillar_catalog: 'Catalogus',
      label_excellent: 'Uitstekend',
      label_good: 'Verbeterbaar',
      label_critical: 'Kritiek',
      no_audit_desc: 'Audit nog niet uitgevoerd — voer de audit uit om Technische SEO, UX, Trust en Performance te krijgen.',
      auditing: 'Audit bezig...',
      run_audit: 'Site-audit 360° uitvoeren',
      calculated_on: 'Berekend voor',
    },
    upgrade: {
      popular: '⭐ Meest Populair',
      period: '/maand',
      plan_header: 'Plan',
      cta: 'Upgrade naar {{name}} — {{price}}{{period}}',
      dismiss: 'Niet nu',
      feature_available: '{{feature}} is beschikbaar vanaf het plan {{plan}}.',
      reason_credits_title: 'AI-credits uitgeput',
      reason_credits_body: 'U heeft de maandelijkse limiet van uw plan bereikt. Upgrade om door te gaan met het genereren van inhoud.',
      reason_products_title: 'Cataloguslimiet bereikt',
      reason_products_body: 'Uw Shopify-catalogus overschrijdt de limiet van het huidige plan. Upgrade om alle producten te synchroniseren.',
      reason_feature_title: 'Premium Functie',
      reason_feature_body: 'Deze functie is beschikbaar in hogere plannen.',
    },
    gsc: {
      connect_title: 'Google Search Console verbinden',
      connect_desc: 'Monitor impressies, klikken, CTR en gemiddelde positie. Vraag herindexering aan na AI-optimalisaties.',
      connect_feat_analytics: 'Zoekanalyses',
      connect_feat_indexing: 'Indexeringsmonitoring',
      connect_feat_keywords: 'Keyword tracking',
      connect_feat_sitemap: 'Sitemap beheer',
      connect_btn_loading: 'Verbinden...',
      connect_btn: 'Google-account verbinden',
      prop_modal_title: 'Eigenschap selecteren',
      prop_modal_desc: 'Kies de Search Console eigenschap om te koppelen.',
      prop_modal_empty: 'Geen eigenschappen gevonden. Controleer of je eigenschappen hebt in Google Search Console.',
      prop_modal_cancel: 'Annuleren',
      prop_modal_confirm: 'Bevestigen',
      coming_soon_desc: 'Beschikbaar in {{phase}}',
      top_opp_title: 'Top SEO-kansen',
      top_opp_sub: 'Top 10 zoekopdrachten op Opportunity Score',
      copy: 'Kopiëren',
      copied: 'Gekopieerd!',
      badge_quick_win: '🔥 Quick Win',
      badge_low_ctr: '⚡ Lage CTR',
      badge_page_1: '🚀 Pagina 1',
      badge_high_imp: '📈 Hoge zichtbaarheid',
      badge_brand: '🏷️ Brand',
      qt_category: 'Categorie',
      qt_product: 'Product',
      qt_generic: 'Generiek',
      qt_info: 'Info',
      qt_brand: 'Brand',
      seo_analysis: 'SEO-analyse',
      generating_ai: 'AI-analyse wordt gegenereerd...',
      analysis_error: 'Fout bij genereren analyse. Probeer later opnieuw.',
      estimated_value: 'Geschatte waarde',
      clicks_monthly: 'Potentiële klikken/maand',
      ctr_at_pos: 'CTR op pos. {{pos}}',
      traffic_increase: 'Verkeerstoename',
      current_stats: 'Huidig: {{clicks}} klikken/maand · +{{pts}} pp geschatte CTR',
      priority_action: 'Prioriteitsactie',
      content_opt: 'Inhoudsoptimalisatie',
      title_seo: 'Title SEO',
      title_chars: '(50–60 tekens)',
      title_copied: 'Title gekopieerd!',
      h1_suggested: 'Voorgestelde H1',
      h1_page_title: '(paginatitel)',
      h1_copied: 'H1 gekopieerd!',
      meta_desc: 'Meta Description',
      meta_chars: '(150–160 tekens)',
      meta_copied: 'Meta gekopieerd!',
      faq_all_copied: "Alle FAQ's gekopieerd!",
      faq_suggested: "Voorgestelde FAQ's",
      copy_all: 'Alles kopiëren',
      faq_copied: 'FAQ gekopieerd!',
      related_kw: 'Gerelateerde keywords',
      click_to_copy: '· klik om te kopiëren',
      kw_copied: '"{{kw}}" gekopieerd!',
      tech_suggestions: 'Technische suggesties',
      copy_keyword: 'Keyword kopiëren',
      kw_copied_plain: 'Keyword gekopieerd!',
      shopify_products: 'Shopify-producten',
      search_store: 'Zoeken in winkel',
      optimize_content: 'Inhoud optimaliseren',
      col_impressions: 'Vertoningen',
      col_position: 'Positie',
      no_queries: 'Geen zoekopdrachten gevonden met de huidige filters.',
      ai_panel_title: 'AI-suggesties',
      analyze_query: 'Zoekopdracht analyseren →',
      sugg_title_improvement: 'Title tag',
      sugg_meta: 'Meta description',
      sugg_content_gap: 'Ontbrekende inhoud',
      sugg_schema: 'Schema markup',
      sugg_links: 'Interne links',
      opp_load_err: 'Fout bij laden SEO-kansen',
      cache_updated: 'Cache bijgewerkt — gegevens worden herladen',
      cache_error: 'Fout bij vernieuwen cache',
      loading_data: 'Search Console-gegevens laden...',
      load_error_title: 'Kan kansen niet laden',
      retry: 'Opnieuw proberen',
      tracked_queries: 'Bijgehouden zoekopdrachten',
      sku_excluded: '{{n}} SKU/EAN uitgesloten',
      total_impressions: 'Totale vertoningen (28d)',
      total_clicks: 'Totale klikken (28d)',
      avg_ctr: 'Gemiddelde CTR',
      ai_generating: 'AI-analyse wordt gegenereerd...',
      ai_generating_sub: 'AI-suggesties verschijnen hier over enkele ogenblikken.',
      no_ai_insights: 'Geen AI-inzichten beschikbaar',
      no_ai_insights_sub: 'Er zijn geen zoekopdrachten gevonden met significante optimalisatiemogelijkheden.',
      filter_all: 'Alle ({{n}})',
      search_placeholder: 'Zoekopdrachten zoeken...',
      refresh_title: 'Gegevens vernieuwen',
      page_prev: '← Vorige',
      page_info: 'Pag. {{page}} / {{total}} · {{count}} zoekopdrachten',
      page_next: 'Volgende →',
      footer_note: 'Search Console-gegevens laatste 28 dagen · 6u cache · eigenschap: {{url}}',
      footer_excluded: ' · {{n}} SKU/EAN uitgesloten',
      verdict_pass: 'Geïndexeerd',
      verdict_fail: 'Niet geïndexeerd',
      verdict_neutral: 'Uitgesloten',
      stato_title: 'Google-status — Gegevensbronnen',
      in_sitemap: 'In sitemap',
      sitemap_registered_lbl: 'Geregistreerde sitemaps',
      sitemap_errors_lbl: 'Sitemap-fouten',
      with_impressions: 'Met vertoningen',
      search_appear_note: "Pagina's verschenen in zoeken · {{days}}d",
      not_real_indexed: "≠ werkelijk geïndexeerde pagina's",
      index_estimate_lbl: 'Indexeringsschatting',
      estimate_unavail: "Schatting beschikbaar na 200 geïnspecteerde URL's. Start batchscan om de steekproef te verzamelen.",
      inspected_lbl: 'Geïnspecteerd',
      indexed_confirmed: 'Bevestigd geïndexeerd',
      not_indexed_lbl: 'Niet geïndexeerd',
      excluded_lbl: 'Uitgesloten',
      certain_data: "Zekere data voor geïnspecteerde URL's",
      batch_title: 'Batchscan — Inspection API',
      batch_priority: 'Analytics Prioriteit',
      batch_progress: 'Voortgang sitemap-inspectie',
      batch_stopping: 'Wordt gestopt…',
      batch_running: 'Scannen…',
      batch_starting: 'Starten...',
      batch_done_lbl: 'Sitemap voltooid ✓',
      batch_start_btn: 'Scan starten ({{n}} beschikbaar)',
      batch_timeout: 'Timeout — klik om te resetten',
      batch_stopping_wait: 'Stoppen — even wachten…',
      batch_stop_btn: 'Scan stoppen',
      batch_remaining: '{{n}} URL nog te inspecteren',
      batch_quota_out: 'Dagelijks quotum uitgeput — morgen opnieuw proberen',
      batch_start_err: 'Fout bij starten scan',
      batch_complete: 'Scan voltooid: {{n}} URL geïnspecteerd',
      dq_title: 'API Technische details',
      dq_api_status: 'API-status',
      dq_daily_quota: 'Dagelijks quotum',
      dq_used_today: 'Vandaag gebruikt',
      dq_remaining: 'Resterend',
      dq_history: 'Inspectiegeschiedenis',
      dq_completion: 'Voltooiing',
      dq_days_est: 'geschatte dagen',
      dq_start_for_eta: 'Start scan om ETA te berekenen',
      sm_no_sitemap: 'Geen sitemap gevonden',
      sm_no_sitemap_desc: 'Voeg een sitemap.xml toe aan Google Search Console om indexering te monitoren.',
      sm_submit_ok: 'Sitemap ingediend bij Google',
      sm_in_progress: 'Berekenen…',
      sm_submit_btn: 'Indienen',
      insp_title: 'URL inspecteren',
      insp_quota: '{{used}}/{{limit}} inspecties vandaag',
      insp_loading: 'Inspecteren...',
      insp_btn: 'Inspecteren',
      insp_domain_lbl: 'Property-domein:',
      insp_domain_note: 'De geïnspecteerde URL moet hieronder vallen',
      insp_last_crawl: 'Laatste crawl',
      insp_indexing: 'Indexering',
      insp_yes: 'Ja',
      insp_no: 'Nee',
      insp_canonical_decl: 'Opgegeven canonical',
      insp_canonical_diff: '⚠ Google canonical (afwijkend)',
      insp_noindex: 'noindex gedetecteerd',
      insp_open_gsc: 'Openen in Search Console',
      insp_err: 'Fout bij URL-inspectie',
      cov_title: 'Coverage — Redenen',
      cov_real_data: 'Echte gegevens — Inspection API',
      cov_conf_high: 'Hoge betrouwbaarheid',
      cov_conf_medium: 'Gemiddelde betrouwbaarheid',
      cov_conf_low: 'Lage betrouwbaarheid',
      cov_updated: 'Bijgewerkt:',
      cov_deselect: 'Deselecteren',
      cov_inspected_note: 'Geïnspecteerde URLs · klik om te filteren',
      cov_none_inspected: 'Geen inspecties',
      cov_no_data: 'Geen coveragegegevens beschikbaar',
      cov_no_data_desc: 'Niet-indexeringsredenen worden automatisch bij elke URL-inspectie aangemaakt. Gebruik "Automatische scan starten" om dit gedeelte te vullen.',
      cov_solution: 'Aanbevolen oplossing',
      cov_filter_active: 'Filter actief in Geschiedenis',
      ih_worklist: 'SEO-taakoverzicht',
      ih_history: 'Inspectiegeschiedenis',
      ih_filter_coverage: 'Coveragefilter',
      ih_tab_all: 'Alle',
      ih_tab_not_ind: 'Niet gei.',
      ih_tab_indexed: 'Geïndexeerd',
      ih_tab_excluded: 'Uitgesloten',
      ih_tab_errors: 'Fouten',
      ih_tab_with_imp: 'Met impr.',
      ih_tab_products: 'Producten',
      ih_tab_collections: 'Collecties',
      ih_sort_priority: '↓ Prioriteit',
      ih_sort_impressions: '↓ Vertoningen',
      ih_sort_clicks_est: '↓ Gesch. klikken',
      ih_sort_date: '↓ Datum',
      ih_sort_state: '↓ GSC-status',
      ih_clear: 'Wissen',
      ih_search: 'URL zoeken…',
      ih_open: 'Openen',
      ih_indexing_state: 'Indexeringsstatus',
      ih_canonical_diff: '⚠ Google canonical (gekozen, afwijkend)',
      ih_canonical_same: 'Google canonical (gelijk)',
      ih_ai_fix: 'Optimaliseren met AI →',
      ih_total: '{{n}} URLs · {{total}} totaal',
      ih_est_clicks: '· +{{n}} gesch. klikken/maand',
      iai_title: 'AI-suggesties — Indexering',
      iai_filter_note: '· klik om te filteren',
      iai_prio_high: 'Hoge prioriteit',
      iai_prio_medium: 'Gemiddelde prioriteit',
      iai_prio_low: 'Lage prioriteit',
      iai_causes: 'Mogelijke oorzaken:',
      iai_actions: 'Aanbevolen acties:',
      fix_apply_all: 'Alles toepassen',
      fix_applied: 'Toegepast',
      fix_suggestion: 'Suggestie',
      fix_chars: 'tekens',
      fix_content_impr: 'Inhoudsverbeteringen',
      fix_int_links: 'Voorgestelde interne links',
      fix_open_url: 'URL openen',
      fix_close: 'Sluiten',
      fix_seo_opt: 'SEO-optimalisatie',
      trend_title: 'Indexeringstrend',
      trend_updated: 'Bijgewerkt tot',
      trend_coverage: 'Dekking',
      trend_30d_kpi: 'Trend 30d',
      trend_no_data: 'Historische gegevens worden opgebouwd',
      trend_no_data_desc: 'De trend is beschikbaar nadat minimaal 2 snapshots zijn verzameld.',
      trend_one_snap: '1 snapshot verzameld van 2.',
      trend_start_scan: 'Start een batchscan om te beginnen.',
      trend_ind: 'gei.',
      trend_not_ind: 'niet gei.',
      trend_snap_note: 'Snapshot per scan',
      ic_loading: 'Indexeringsgegevens laden...',
      ic_load_err: 'Kan indexeringsgegevens niet laden',
      ic_clear_confirm: 'Gehele inspectiegeschiedenis wissen?',
      ic_cleared: 'Geschiedenis gewist',
      ic_clear_err: 'Fout bij wissen',
      ic_seo_opp: 'SEO-kansen — Executive Summary',
      ic_recoverable: 'Herstelbare URLs',
      ic_open_worklist: '⚡ Taakoverzicht openen →',
      ic_view_all: 'Alles bekijken →',
      ic_crawled_ni: 'Gecrawld – niet geïndexeerd',
      ic_crawled_ni_note: 'Google kent ze maar serveert ze niet',
      ic_discovered_ni: 'Ontdekt – niet geïndexeerd',
      ic_discovered_ni_note: 'Gevonden maar nooit gecrawld',
      ic_with_imp_ni: 'Met GSC-vertoningen',
      ic_with_imp_ni_note: 'Hebben verkeer maar zijn niet geïndexeerd',
      ic_other_ni: 'Andere niet geïndexeerd',
      ic_other_ni_note: 'Onbekend bij Google of fouten',
      ic_refresh: 'Vernieuwen',
      rh_title: 'Wijzigingsgeschiedenis',
      rh_versions: 'versies',
      rh_confirm: "Versie van {{date}} herstellen?\n\nDe huidige wijzigingen in de editor worden vervangen.",
      rh_restored_ok: 'v{{v}} hersteld in Shopify-thema',
      rh_restored_editor: "Versie v{{v}} geladen in de editor — klik op Opslaan om het toe te passen",
      rh_restore_err: 'Herstelfout',
      rh_current: 'huidig',
      rh_initial: 'Beginversie',
      rh_no_diff: 'Geen tekstwijzigingen',
      rh_more_added: '+ {{n}} meer toegevoegd',
      rh_more_removed: '- {{n}} meer verwijderd',
      rh_restore_btn: 'Herstellen',
      rb_load_err: 'Fout bij laden van robots.txt',
      rb_save_err: 'Opslagfout',
      rb_analyze_err: 'Analysefout',
      rb_score_good: 'Uitstekend',
      rb_score_ok: 'Verbetering nodig',
      rb_score_bad: 'Kritiek',
      rb_analysis_title: 'SEO Robots-analyse',
      rb_analyzing: 'Analyseren…',
      rb_analyze: 'Analyseren',
      rb_analyze_hint: 'Klik op "Analyseren" om automatisch SEO-problemen en optimalisatiemogelijkheden te detecteren',
      rb_no_issues: 'Geen problemen gedetecteerd',
      rb_no_issues_desc: 'Uw robots.txt volgt de Shopify-best practices',
      rb_critical: 'KRITIEK',
      rb_warning: 'WAARSCHUWING',
      rb_validation_title: 'Robots.txt-validatie',
      rb_reload: 'Herladen',
      rb_editor_title: 'Robots.txt-editor',
      rb_modified: 'Gewijzigd',
      rb_diff_close: 'Diff sluiten',
      rb_editor_restore: 'Herstellen',
      rb_saving: 'Opslaan…',
      rb_save: 'Opslaan',
      rb_blocking_warning: '🚨 U BLOKKEERT DE GEHELE WEBSITE — "Disallow: /" voorkomt dat Google een pagina indexeert',
      rb_diff_preview: 'Wijzigingenvoorbeeld:',
      rb_opportunity: 'KANS',
      rb_checker_title: 'URL controleren',
      rb_check_btn: 'Controleren',
      rb_allowed: 'Toegestaan',
      rb_blocked: 'Geblokkeerd',
      rb_sitemaps_title: 'Gedeclareerde sitemaps',
      ll_history_title: 'LLMs.txt-geschiedenis',
      ll_generated: 'Gegenereerd',
      ll_restored_editor: 'Versie v{{v}} geladen in de editor — klik op Publiceren om het toe te passen',
      ll_load_err: 'Fout bij laden van llms.txt',
      ll_generate_err: 'Generatiefout',
      ll_saved_ok: 'LLMs.txt gepubliceerd en geverifieerd in Shopify-thema',
      ll_not_configured: 'Niet geconfigureerd',
      ll_validation_title: 'LLMs.txt-validatie',
      ll_not_found: 'Geen llms.txt gevonden op de site. Gebruik "Genereren vanuit Shopify" om het automatisch te maken.',
      ll_what_title: 'Wat is LLMs.txt?',
      ll_what_desc: 'De /llms.txt-standaard is een markdown-bestand dat AI-modellen (ChatGPT, Claude, Perplexity, Gemini) helpt uw site te begrijpen en correct te citeren in antwoorden. Vergroot de zichtbaarheid in AI-antwoordmotoren.',
      ll_editor_title: 'LLMs.txt-editor',
      ll_generating: 'Genereren…',
      ll_generate_btn: 'Genereren vanuit Shopify',
      tab_jsonld: 'JSON-LD',
      jl_load_err: 'Fout bij laden JSON-LD overzicht',
      jl_sec_overview: 'Overzicht',
      jl_sec_schemas: "Schema's",
      jl_sec_problems: 'Problemen',
      jl_sec_generate: 'AI-optimalisatie',
      jl_sec_preview: 'JSON-voorbeeld',
      jl_sec_validate: 'Validatie',
      jl_sec_bulk: 'Bulkbewerkingen',
      jl_sec_stats: 'Statistieken',
      jl_rich_results: 'Rich Results-geschiktheid',
      jl_eligible: 'Geschikt',
      jl_warnings: 'Gedeeltelijk',
      jl_not_eligible: 'Niet geschikt',
      jl_field_coverage: 'Velddekking',
      jl_what_title: 'Wat is JSON-LD?',
      jl_what_desc: 'JSON-LD is het door Google aanbevolen formaat voor gestructureerde data. Het maakt Rich Results in zoekresultaten mogelijk (sterren, prijzen, breadcrumbs) en helpt AI-modellen uw producten beter te begrijpen.',
      jl_score_poor: 'Slechte dekking',
      jl_schemas_title: 'Ondersteunde schematypen',
      jl_status_valid: 'Geldig',
      jl_status_partial: 'Gedeeltelijk',
      jl_status_missing: 'Niet geconfigureerd',
      jl_valid_items: 'geldig',
      jl_issues: 'problemen',
      jl_google_test: 'Testen in Google Rich Results',
      jl_google_test_desc: 'Test uw JSON-LD na het genereren direct in het Google-hulpprogramma om geschiktheid te verifiëren.',
      jl_problems_title: 'Diagnostische problemen',
      jl_no_problems: 'Geen kritieke problemen gevonden. Uw JSON-LD-dekking ziet er goed uit!',
      jl_products_affected: 'getroffen producten',
      jl_sev_critical: 'Kritiek',
      jl_sev_warning: 'Waarschuwing',
      jl_prob_brand: 'Ontbrekend merk / leverancier',
      jl_prob_desc: 'Ontbrekende beschrijving',
      jl_prob_image: 'Ontbrekende productafbeelding',
      jl_prob_sku: 'Ontbrekende SKU',
      jl_prob_gtin: 'Ontbrekende GTIN / barcode',
      jl_prob_meta: 'Ontbrekende metabeschrijving',
      jl_prob_offers: 'Prijs niet in JSON-LD (Shopify-themasnippet vereist)',
      jl_problems_tip: 'Corrigeer ontbrekende velden in de sectie Producten of gebruik AI-optimalisatie.',
      jl_gen_title: 'JSON-LD genereren',
      jl_schema_type: 'Schematype',
      jl_product_id: 'Product-ID (leeg laten voor voorbeeld)',
      jl_use_ai: 'AI-verrijking gebruiken (GPT)',
      jl_gen_btn: 'JSON-LD genereren',
      jl_gen_ok: 'JSON-LD gegenereerd',
      jl_gen_err: 'Generatiefout',
      jl_copied: 'Gekopieerd!',
      jl_copy: 'Kopiëren',
      jl_preview_title: 'JSON-LD-voorbeeld',
      jl_preview_err: 'Fout bij laden voorbeeld',
      jl_load_preview: 'Voorbeeldproduct laden',
      jl_preview_empty: "Klik op \"Voorbeeldproduct laden\" om alle JSON-LD-schema's te bekijken",
      jl_val_title: 'Lokale schemavalidatie',
      jl_invalid_json: 'Ongeldige JSON',
      jl_val_btn: 'JSON-LD valideren',
      jl_val_clear: 'Wissen',
      jl_val_ok: 'Geldig — geschikt voor Rich Results',
      jl_val_fail: 'Validatie mislukt',
      jl_val_note: 'Deze validator controleert schema.org-vereisten. Gebruik voor de officiële Google-test de Rich Results Test.',
      jl_val_err: 'Validatiefout',
      jl_bulk_title: 'Bulkbewerkingen',
      jl_bulk_gen: 'Alles genereren',
      jl_bulk_gen_desc: 'Product JSON-LD voor elk product bouwen en opslaan in DB',
      jl_bulk_val: 'Alles valideren',
      jl_bulk_val_desc: 'schema.org-validatie uitvoeren op bestaande JSON-LD',
      jl_bulk_fix: 'Corrigeren en verrijken',
      jl_bulk_fix_desc: 'JSON-LD herbouwen voor producten met fouten',
      jl_bulk_started: 'Bulkbewerking gestart',
      jl_bulk_err: 'Fout bij starten bulkbewerking',
      jl_bulk_running: 'Bezig',
      jl_bulk_done: 'Voltooid',
      jl_bulk_stop: 'Stoppen',
      jl_bulk_stopped: 'Bulkbewerking gestopt',
      jl_errors: 'fouten',
      jl_stat_total: 'Totale producten',
      jl_stat_eligible: 'Rich Results-geschikt',
      jl_stat_gen_today: 'Vandaag gegenereerd',
      jl_stat_fixed: 'Vandaag gecorrigeerd',
      jl_coverage_by_type: 'Dekking per inhoudstype',
      jl_type: 'Type',
      jl_total: 'Totaal',
      jl_valid2: 'Geldig',
      jl_missing2: 'Ontbrekend',

      ll_revert: 'Ongedaan maken',
      ll_publishing: 'Publiceren…',
      ll_publish: 'Publiceren',
      lp_filter_url: 'URL filteren…',
      lp_copied: 'Gekopieerd',
      lp_broken_empty: 'Geen gebroken links gedetecteerd',
      lp_broken_empty_sub: "Alle winkel-URL's zijn bereikbaar (404 / 410 / timeout)",
      lp_timeout: 'Timeout — geen reactie binnen 12s',
      lp_ratelimit_empty: 'Geen snelheidsbeperking gedetecteerd',
      lp_ratelimit_empty_sub: 'De server heeft de scannerverzoeken niet beperkt',
      lp_ratelimit_note: 'Pagina bereikbaar maar server reageerde 429 tijdens het scannen',
      lp_server_empty: 'Geen serverfouten gedetecteerd',
      lp_server_empty_sub: "Alle URL's reageren correct (geen 5xx)",
      lp_server_note: 'HTTP {{code}} — serverfout',
      lp_redirect_empty: 'Geen omleidingen gedetecteerd',
      lp_redirect_total: 'Totale omleidingen',
      lp_chains: 'Ketens (>1 hop)',
      lp_loops: 'Lussen gedetecteerd',
      lp_chains_header: 'Omleidingsketens',
      lp_chains_badge: '{{n}} meervoudige ketens',
      lp_final_status: 'Eindstatus:',
      lp_canon_ok: 'Correct',
      lp_canon_miss: 'Ontbreekt',
      lp_canon_wrong: 'Verkeerde URL',
      lp_canon_cross: 'Cross-domain',
      lp_canon_redir: 'Canonical→redirect',
      lp_canon_action_missing: 'Voeg een canonical link tag toe in de head sectie van de pagina.',
      lp_canon_action_wrong: 'Corrigeer de canonical zodat deze wijst naar de definitieve URL van deze pagina.',
      lp_canon_action_cross: 'De canonical wijst naar een extern domein. Controleer of dit opzettelijk is of een fout.',
      lp_canon_action_redir: 'De canonical wijst naar een doorsturende URL. Bijwerken met de uiteindelijke redirect-bestemming.',
      lp_canon_no_data: 'Canonical-gegevens niet beschikbaar — start de scan',
      lp_canon_issues: 'Canonical-problemen ({{n}})',
      lp_canon_no_issues: 'Geen canonical-problemen gedetecteerd',
      lp_canon_sample: "Geanalyseerde steekproef: {{n}} URL's uit uw winkel (producten, collecties, pagina's, artikelen)",
      il_tab_orphans: "Zwevende pagina's",
      il_tab_weak: 'Zwakke links',
      il_tab_deep: "Diepe pagina's",
      il_kpi_weak: 'Zwakke links ≤2',
      il_kpi_deep: 'Diepe paginas',
      il_orphan_empty: "Geen zwevende pagina's",
      il_orphan_empty_sub: "Alle pagina's ontvangen minimaal één interne link",
      il_orphan_header: "Pagina's zonder binnenkomende links ({{n}})",
      il_weak_empty: "Geen pagina's met zwakke links",
      il_weak_empty_sub: "Alle pagina's ontvangen 3+ interne links",
      il_weak_header: "Pagina's met 1–2 binnenkomende links ({{n}})",
      il_anchor_empty: 'Ankerteksten geoptimaliseerd',
      il_anchor_empty_sub: 'Geen generieke, lege of dubbele ankers gedetecteerd',
      il_anchor_generic: 'Generieke ankers',
      il_anchor_generic_desc: 'Teksten zoals "klik hier", "hier", "ontdekken"',
      il_anchor_empty_type: 'Lege ankers',
      il_anchor_empty_desc: 'Links zonder beschrijvende tekst',
      il_anchor_dup: 'Dubbele ankers',
      il_anchor_dup_desc: 'Dezelfde tekst → verschillende URLs',
      il_anchor_lbl_gen: 'Generiek',
      il_anchor_lbl_empty: 'Leeg',
      il_anchor_lbl_dup: 'Duplicaat',
      il_deep_empty: "Geen te diepe pagina's",
      il_deep_empty_sub: "Alle pagina's zijn bereikbaar in ≤3 klikken van de homepage",
      il_deep_header: "Pagina's >3 klikken van de homepage ({{n}})",
      il_deep_note: "Pagina's met ∞ zijn niet bereikbaar via interne links. Voeg ze toe aan menu's of collecties.",
      il_hub_empty: 'Geen hub-gegevens beschikbaar',
      il_hub_empty_sub: 'Start een scan om hub-paginas te identificeren',
      il_hub_header: "Hub-pagina's — meest intern gelinkt",
      il_hub_count: '{{n}} inkomende interne links',
      lm_active: 'Actief',
      lm_not_installed: 'Niet geïnstalleerd',
      lm_install_hint: 'Installeer in het thema om echte navigatie zonder crawling te bewaken',
      lm_refresh: 'Vernieuwen',
      lm_clear: 'Gegevens wissen',
      lm_remove: 'Verwijderen uit thema',
      lm_installing: 'Installeren…',
      lm_install: 'Installeren in thema',
      lm_tab_404: '404-fouten',
      lm_tab_redirect: 'Redirect Opp.',
      lm_tab_top: 'Toppaginas',
      lm_kpi_visits: 'Totale bezoeken',
      lm_kpi_404s: 'Echte 404-fouten',
      lm_no_404: 'Geen 404-fouten gedetecteerd door gebruikers',
      lm_visits: 'bezoeken',
      lm_theme_prefix: 'Thema: ',
      lm_last_activity: 'Laatste activiteit: ',
      lm_no_activity: 'nog geen bezoeken',
      lm_installed: 'Monitor geïnstalleerd in thema "{{name}}"',
      lm_err_install: 'Installatiefout',
      lm_confirm_remove: 'Monitoringscript uit het actieve thema verwijderen?',
      lm_removed: 'Script verwijderd uit thema',
      lm_err_remove: 'Verwijderingsfout',
      lm_confirm_clear: 'Alle verzamelde monitoringgegevens verwijderen?',
      lm_cleared: 'Gegevens verwijderd',
      lm_err_clear: 'Fout bij verwijderen',
      lm_modal_title: 'Redirect 301 aanmaken',
      lm_modal_source: 'Bron-URL (404)',
      lm_modal_dest: 'Bestemming',
      lm_redirect_created: 'Redirect 301 aangemaakt op Shopify',
      lm_err_redirect: 'Fout bij aanmaken redirect',
      lm_create_redirect: 'Redirect aanmaken',
      lm_creating: 'Aanmaken…',
      lm_cancel: 'Annuleren',
      lm_info_title: 'Hoe de Live Monitor werkt',
      lm_info_1: 'De knop "In thema installeren" voegt automatisch een lichtgewicht script toe aan het actieve thema via de Shopify Themes API',
      lm_info_2: 'Voor elk echt bezoek verzamelt het: URL, paginatype, interne links, 404-fouten, interne verwijzer',
      lm_info_3: 'Nul crawling — geen HTTP 429 — gegevens van echte bezoekers in realtime',
      lm_info_4: "Bouwt progressief de interne linkkaart op en detecteert wees-pagina's",
      lm_no_redirect: 'Geen redirect nodig',
      lm_no_redirect_hint1: "De Live Monitor heeft nog geen bezoeken vastgelegd. Redirect-kansen verschijnen wanneer echte gebruikers 404-pagina's tegenkomen.",
      lm_no_redirect_hint2: 'In {{n}} geanalyseerde bezoeken heeft geen gebruiker 404-paginas aangetroffen. Uitstekend!',
      lm_toolbar_ai: '{{count}} URL · {{ai}} met AI-suggestie',
      lm_toolbar_ignored: '· {{n}} genegeerd',
      lm_sort_visits: 'Bezoeken',
      lm_sort_date: 'Datum',
      lm_selected: '{{n}} geselecteerd',
      lm_no_match: 'geen automatische overeenkomst',
      lm_create: 'Aanmaken',
      lm_ignore: 'Negeren',
      lm_err: 'Fout',
      lm_bulk_ignored: '{{n}} URL genegeerd',
      lm_bulk_created: '{{n}} redirects aangemaakt',
      lm_errors: 'fouten',
      ls_scan_started: 'Scan gestart — wordt op de achtergrond voltooid',
      ls_scan_err: 'Fout bij starten scan',
      ls_last_scan: 'Laatste scan: {{date}} · {{n}} URL',
      ls_no_scan_desc: 'Geen scan uitgevoerd — detecteert kapotte links, omleidingen, canonicals, wees-paginas',
      ls_scanning: 'Scannen…',
      ls_rescan: 'Opnieuw scannen',
      ls_start_scan: 'Scan starten',
      ls_canonical_issues: 'Canonical-problemen',
      ls_scan_details: 'Scandetails',
      ls_stat_total: 'URL totaal',
      ls_stat_errors: 'Fouten',
      ls_no_scan: 'Geen scan uitgevoerd',
      ls_no_scan_long: 'Start de scan om kapotte links, omleidingsketens, canonical-problemen en wees-paginas zonder inkomende links te detecteren',
      ls_first_scan: 'Eerste scan starten',
      db_gsc_connected: 'Google Search Console verbonden!',
      db_gsc_err: 'GSC verbindingsfout: {{code}}',
      db_props_err: 'Kan GSC-eigenschappen niet laden',
      db_oauth_hint: 'Voltooi de Google-autorisatie in het nieuwe tabblad. De pagina wordt automatisch vernieuwd.',
      db_conn_err: 'GSC verbindingsfout',
      db_prop_selected: 'Eigenschap geselecteerd: {{url}}',
      db_prop_err: 'Fout bij selecteren eigenschap',
      db_confirm_disconnect: 'Google Search Console verbreken?',
      db_disconnected: 'GSC verbroken',
      db_disconnect_err: 'Verbreekfout',
      db_connected: 'Search Console verbonden',
      db_no_property: 'Geen eigenschap geselecteerd',
      db_not_connected: 'Niet verbonden',
      db_connect_hint: 'Verbind GSC om analyses en monitoring te ontgrendelen',
      db_change_prop: 'Eigenschap wijzigen',
      db_disconnect: 'Verbreken',
      db_connect: 'GSC verbinden',
      db_idx_subtitle: 'Technische SEO-kwaliteit & indexering',
      db_lbl_gsc: 'GSC verbonden',
      db_lbl_sitemap: 'Sitemaps ingediend',
      db_lbl_indexed: 'Geïndexeerde URLs',
      db_health_real: 'Gebaseerd op echte Search Console-gegevens',
      db_health_proxy: 'Gebaseerd op cataloguskwaliteit — verbind GSC voor echte gegevens',
      db_lbl_position: 'Positie',
      db_lbl_trend: 'Trend 28d',
      db_lbl_errors: 'Fouten',
      db_connect_score: 'Verbind GSC om de score te berekenen',
      db_proxy_note: 'Catalogusproxy',
      db_stat_excluded: 'Uitgesloten URLs',
      db_stat_seo_score: 'Gemiddelde SEO-score',
      db_catalog_title: 'Catalogusgezondheid',
      db_cat_alt: 'ALT-tekst afbeeldingen',
      db_cat_keywords: 'Ontbrekende zoekwoorden',
      db_cat_no_kw: '{{n}} producten zonder zoekwoorden',
      db_cat_count: '{{n}} / {{total}} producten',
      tab_opportunities: 'SEO-kansen',
      tab_indexing: 'Indexering',
      locked_available: 'Beschikbaar vanaf het {{plan}}-plan',
      locked_upgrade: 'Upgraden naar {{plan}}-plan',
      main_subtitle: 'Technische SEO · Indexering · Analytics · AI-automatisering',
      phase_3: 'Fase 3',
      interval_all: 'Alles',
      click_monthly_est: 'gesch. klikken/mnd',
      fix_title_updated: 'Titeltag bijgewerkt',
      fix_meta_updated: 'Metabeschrijving bijgewerkt',
      fix_both_updated: 'Titel en metabeschrijving bijgewerkt in Shopify',
      fix_apply_err: 'Toepassingsfout',
      rb_save_ok: 'Robots.txt opgeslagen en geverifieerd in Shopify-thema',
      rb_draft_with_err: 'Concept opgeslagen ({{err}})',
      rb_draft_manual: 'Concept opgeslagen — volg de instructies om het toe te passen',
      rb_critical_confirm: '🚨 KRITIEKE WAARSCHUWING 🚨\n\nUw robots.txt bevat "Disallow: /" waardoor de volledige site VOLLEDIG GEBLOKKEERD is:\nGoogle, Bing en alle bots kunnen geen enkele pagina meer crawlen.\n\nDit kan ertoe leiden dat de site wordt verwijderd uit de zoekresultaten.\n\nWeet u ABSOLUUT ZEKER dat u wilt doorgaan?',
      scan_err: 'Scanfout: {{msg}}',
      sm_send_err: 'Verzendfout',
      unknown_err: 'Onbekend',
      dq_today: 'Vandaag',
      dq_7d: 'Afgelopen 7 dagen',
      dq_30d: 'Afgelopen 30 dagen',
      dq_daily_avg: 'Daggemiddelde',
      dq_at_pace: 'op een tempo van ~{{n}}/dag',
      job_stopped: 'Gestopt bij {{n}} verwerkte URLs',
      job_inspected: '{{n}} geïnspecteerd',
      job_errors: 'fouten',
      quota_remaining: 'Resterende quota:',
      lk_trend: 'Indexeringstendens',
      lk_batch: 'Batch-inspectie (massale URL-scan)',
      lk_ai: 'AI-indexeringsuggesties',
      footer_apis: 'Sitemaps API + Search Analytics + Inspection API',
      prod_status_lbl: 'Status:',
      prod_desc_lbl: 'Beschrijving:',
      prod_missing: 'ONTBREEKT',
      state_disc: 'Ontd.',
      state_crawl: 'Gecrawld',
      insp_api_real: 'Inspection API ✓ real',
      sm_count: '{{n}} sitemaps',
      sm_reliability: 'Betrouwbaarheid:',
      conf_high: 'Hoog',
      conf_medium: 'Gemiddeld',
      conf_low: 'Laag',
      sm_urls: "URL's in sitemap",
      sm_sample: 'Steekproef',
      sm_est_indexed: 'Gesch. geïndexeerd',
      sm_est_nonidx: 'Gesch. niet geïndexeerd',
      sm_coverage: 'Gesch. dekking ⓘ',
      sm_idx_of: "~{{n}} geïndexeerd van {{t}} sitemap-URL's",
      sm_cov_est: 'Geschatte dekking:',
      sm_margin_err: 'foutmarge',
      sm_indexed_of: 'geïndexeerd van',
      sm_sampled: 'gesampled',
      sm_th_sitemap: 'Sitemap',
      sm_th_submitted: 'Ingediend',
      sm_th_indexed: 'Geïndexeerd',
      sm_th_gap: 'Kloof',
      sm_th_coverage: 'Dekking',
      sm_th_warning: 'Waarschuwing',
      sm_th_errors: 'Fouten',
      sm_th_lastmod: 'Laatste update',
      sm_th_actions: 'Acties',
      rb_verified_result: 'Opgeslagen en geverifieerd in Shopify-thema ({{theme}}) — bestand:',
      rb_draft_result: "Concept opgeslagen. Handmatig toepassen: Shopify Admin → Thema's → Code bewerken →",
      ll_draft_result: "Concept opgeslagen. Handmatig toepassen: Shopify Admin → Thema's → Code bewerken →",
      ls_section_redirects: 'Redirect Manager',
      rm_tab: 'Redirect Manager',
      rm_subtitle: 'Beheer alle redirects van je winkel op één plek.',
      rm_kpi_total: 'Totale regels',
      rm_kpi_active: 'Actieve redirects',
      rm_kpi_pending: 'Wachtende 404s',
      rm_kpi_hits: 'Hits (30d)',
      rm_kpi_chains: 'Ketens',
      rm_kpi_loops: 'Lussen',
      rm_section_rules: 'Regels',
      rm_section_suggest: 'AI-suggesties',
      rm_section_health: 'Gezondheid',
      rm_section_import: 'Import / Export',
      rm_section_history: 'Geschiedenis',
      rm_create_title: 'Redirect aanmaken',
      rm_edit_title: 'Redirect bewerken',
      rm_old_url: 'Oude URL',
      rm_new_url: 'Nieuwe URL',
      rm_old_url_ph: '/oud-pad',
      rm_new_url_ph: '/nieuw-pad',
      rm_type: 'Type',
      rm_type_301: '301 – Permanent',
      rm_type_302: '302 – Tijdelijk',
      rm_notes: 'Notities',
      rm_save: 'Opslaan',
      rm_cancel: 'Annuleren',
      rm_create_ok: 'Redirect succesvol aangemaakt.',
      rm_edit_ok: 'Redirect succesvol bijgewerkt.',
      rm_create_err: 'Fout bij het aanmaken van de redirect.',
      rm_edit_err: 'Fout bij het opslaan van de redirect.',
      rm_dup_err: 'Er bestaat al een redirect voor deze bron-URL.',
      rm_empty_err: 'Bron- en doel-URL zijn verplicht.',
      rm_same_err: 'Bron- en doel-URL mogen niet gelijk zijn.',
      rm_search_ph: 'URL’s zoeken…',
      rm_filter_all: 'Alle',
      rm_filter_active: 'Actief',
      rm_filter_disabled: 'Uitgeschakeld',
      rm_create_btn: 'Redirect aanmaken',
      rm_selected_items: '{{count}} geselecteerd',
      rm_bulk_enable: 'Inschakelen',
      rm_bulk_disable: 'Uitschakelen',
      rm_bulk_delete: 'Verwijderen',
      rm_bulk_export: 'CSV exporteren',
      rm_bulk_ok: 'Bewerking voltooid.',
      rm_table_old: 'Oude URL',
      rm_table_new: 'Nieuwe URL',
      rm_table_type: 'Type',
      rm_table_hits: 'Hits',
      rm_table_status: 'Status',
      rm_table_actions: 'Acties',
      rm_edit: 'Bewerken',
      rm_duplicate: 'Dupliceren',
      rm_delete: 'Verwijderen',
      rm_delete_confirm: 'Deze redirect verwijderen?',
      rm_deleted_ok: 'Redirect verwijderd.',
      rm_delete_err: 'Fout bij het verwijderen.',
      rm_status_active: 'Actief',
      rm_status_disabled: 'Uitgeschakeld',
      rm_no_data: 'Geen redirects gevonden.',
      rm_empty_state: 'Nog geen redirects. Maak je eerste redirect aan.',
      rm_total_redirects: '{{count}} redirects in totaal',
      rm_import_title: 'Redirects importeren',
      rm_import_csv: 'CSV (old_url,new_url,type)',
      rm_import_shopify: 'Shopify Export CSV',
      rm_import_sf: 'Screaming Frog CSV',
      rm_import_btn: 'Importeren',
      rm_import_ok: 'Import voltooid.',
      rm_import_err: 'Fout tijdens import.',
      rm_import_imported: '{{count}} geïmporteerd',
      rm_import_skipped: '{{count}} overgeslagen',
      rm_export_title: 'Redirects exporteren',
      rm_export_desc: 'Download alle redirects in beschikbare formaten.',
      rm_export_csv: 'CSV exporteren',
      rm_export_json: 'JSON exporteren',
      rm_ai_title: 'AI-suggesties',
      rm_ai_subtitle: 'AI detecteerde 404-URL’s en stelt redirects voor naar vergelijkbare producten.',
      rm_ai_accept: 'Accepteren',
      rm_ai_reject: 'Afwijzen',
      rm_ai_accept_all: 'Alles accepteren',
      rm_ai_loading: 'Analyseren…',
      rm_ai_empty: 'Momenteel geen suggesties beschikbaar.',
      rm_chains_title: 'Redirect-ketens',
      rm_chains_desc: 'Meerdere aaneengesloten redirects vertragen je site.',
      rm_chains_fix: 'Keten repareren',
      rm_chains_empty: 'Geen ketens gedetecteerd.',
      rm_chains_fixed: 'Keten gerepareerd.',
      rm_loops_title: 'Redirect-lussen',
      rm_loops_desc: 'Circulaire lussen veroorzaken fouten. Handmatige correctie vereist.',
      rm_loops_fix: 'Repareren',
      rm_loops_empty: 'Geen lussen gedetecteerd.',
      rm_gsc_title: '404’s van Google Search Console',
      rm_gsc_subtitle: 'Niet-gevonden URL’s gedetecteerd door GSC in de afgelopen 90 dagen.',
      rm_gsc_empty: 'Geen GSC-404’s gedetecteerd.',
      rm_history_title: 'Activiteitengeschiedenis',
      rm_history_created: 'Aangemaakt',
      rm_history_edited: 'Bewerkt',
      rm_history_deleted: 'Verwijderd',
      rm_history_disabled: 'Uitgeschakeld',
      rm_history_enabled: 'Ingeschakeld',
      rm_history_imported: 'Geïmporteerd',
      rm_history_bulk: 'Bulkbewerking',
      rm_history_empty: 'Geen activiteit geregistreerd.',
      rm_sync_shopify: 'Synchroniseren met Shopify',
      rm_sync_shopify_desc: 'Alle URL-redirects uit Shopify importeren. Nieuwe redirects worden automatisch naar Shopify gestuurd.',
      rm_sync_btn: 'Nu synchroniseren',
      error_label: 'Fout:',
      rb_checker_desc: 'Controleer of een URL is toegestaan of geblokkeerd door {{bot}} op basis van de huidige robots.txt.',
      rb_rule: 'Regel:',
      rb_fix: 'Oplossen:',
      rb_gsc_note_title: 'Search Console Integratie',
      rb_gsc_note_body: "In de sectie Indexering geven URL's met de status 'Geblokkeerd door robots' pagina's aan die Google niet kan crawlen.",
      rb_issues: 'problemen',
      rb_opps: 'kansen',
      rb_savings: 'Geschatte besparing:',
      never: 'Nooit',
      samples_conf: '{{n}} steekproeven · betrouwbaarheid {{c}}',
      batch_priority_note: "URL's met Analytics-impressies eerst geïnspecteerd · GSC-quotum 2.000/dag · achtergrondverwerking",
      sm_samples: 'steekproeven',
      sm_footnote_ec: '~ "In berekening"-waarden = schatting van Inspection API ({{n}} steekproeven · betrouwbaarheid {{c}}). Sitemaps API geeft 0 terug voor sitemap-indexen.',
      sm_footnote_noec: '~ "In berekening"-waarden = proportionele schatting. Start batch-scan. Sitemaps API geeft 0 terug voor sitemap-indexen.',
      ic_quota_note: "Berekend op {{n}} URL's geïnspecteerd via Inspection API (quotum 2.000/dag). GSC Coverage toont {{m}} niet-geïndexeerde URL's in de sitemap.",
      cov_crawled_ni: 'Slechte kwaliteit of duplicaat inhoud. Verbeter de inhoud, voeg unieke tekst toe, controleer de canonical-tag.',
      cov_disc_ni: 'Google heeft het gevonden maar nog niet gecrawld. Vergroot het crawlbudget met extra interne links en bijgewerkte sitemap.',
      cov_dup_nocanon: 'Voeg canonical-tag toe die verwijst naar de hoofdpagina.',
      cov_dup_googcanon: 'Google negeert de gedeclareerde canonical. Controleer URL- en canonical-consistentie tussen desktop/mobiele versies.',
      cov_redirect: 'Actieve omleiding. Indien bedoeld, interne links bijwerken om direct naar de bestemming te verwijzen.',
      cov_alternate: 'Alternatieve pagina met correct canonical — geen actie nodig indien bedoeld.',
      cov_noindex: 'Verwijder de meta-tag noindex als u wilt dat de pagina geïndexeerd wordt.',
      cov_robots: 'Pagina geblokkeerd door robots.txt. Disallow-richtlijnen controleren en bijwerken indien nodig.',
      cov_removed: 'Handmatig verwijderd uit GSC. Verwijdering intrekken in het Search Console-paneel indien gewenst.',
      cov_404: 'Pagina niet gevonden. Herstel de pagina, stel een 301-omleiding in of verwijder interne links naar deze URL.',
      cov_soft404: 'Server geeft 200 terug maar Google behandelt het als een lege pagina. Zorg voor relevante inhoud op de pagina.',
      cov_server_err: 'Serverfout. Controleer serverlogboeken en hostingbeschikbaarheid tijdens crawl.',
      cov_unknown_url: 'Google heeft deze URL nog niet ontdekt. Voeg interne links toe, werk de sitemap bij en wacht op de volgende crawl.',
      qt_brand: 'Merk',
      qt_info: 'Info',
      qt_category: 'Categorie',
      qt_product: 'Product',
      qt_generic: 'Generiek',
      sugg_title_improvement: 'Titeltag',
      sugg_meta: 'Meta omschrijving',
      sugg_content_gap: 'Ontbrekende inhoud',
      sugg_schema: 'Schema-opmaak',
      sugg_links: 'Interne links',
      verdict_indexed: 'Geïndexeerd',
      verdict_not_indexed: 'Niet geïndexeerd',
      verdict_excluded: 'Uitgesloten',
      badge_col_header: 'Badge',
      sitemap_label: 'Sitemap',
      ls_tab_broken: 'Verbroken links',
      ls_tab_redirect: 'Omleiding',
      ls_tab_rate_limited: 'Snelheidsbeperkt',
      ls_tab_server_errors: 'Serverfouten',
      ls_tab_canonical: 'Canoniek',
      ls_tab_internal: 'Interne links',
      ls_section_monitor: 'Live monitor',
      ls_section_audit: 'Sitestructuur',
      db_idx_title: 'Indexeringscore',
      db_health_title: 'SC-gezondheidsscore',
      canonical_mismatch: 'Canonieke afwijking',
    },
    so: {
      load_err: 'Laadifout Speed Optimizer',
      analyze_timeout: 'Analyse-time-out (90s) — probeer opnieuw',
      analyze_done: 'Analyse voltooid!',
      analyze_failed: 'Analyse mislukt: {{error}}',
      rate_limited: 'Verzoeklimiet bereikt — gegevens bijgewerkt vanuit cache',
      analyze_err: 'Analysefout',
      opt_enabled: '{{label}} ingeschakeld op thema',
      opt_disabled: '{{label}} uitgeschakeld',
      opt_err: 'Optimalisatiefout',
      scan_err: 'Themascannerfout',
      img_err: 'Beeldanalysefout',
      sg_protected: 'Safety Guard: Protected ingeschakeld',
      sg_standard: 'Safety Guard: Standard ingeschakeld',
      mode_err: 'Fout bij moduswisseling',
      plan_err: 'Fout bij het genereren van plan',
      strategy_applied: 'Strategie {{label}} toegepast op thema',
      strategy_err: 'Fout bij het toepassen van strategie',
      sessions_err: 'Fout bij het laden van sessies',
      rollback_done: 'Rollback voltooid — thema hersteld',
      rollback_err: 'Rollback-fout',
      subtitle: 'Veilige Shopify-thema-optimalisaties met directe rollback.',
      btn_rollback: 'Alles terugdraaien',
      btn_analyze: 'Nu analyseren',
      analyzing_psi: 'PSI verwerken…',
      analyzing_queue: 'In wachtrij…',
      analyzing: 'Analyseren…',
      alert_no_token: 'Shopify-token ontbreekt — optimalisaties vereisen een actieve store-verbinding.',
      alert_no_scope: 'Thema-machtigingen ontbreken — om optimalisaties toe te passen moet u de app opnieuw installeren.',
      perf_empty: 'Geen analyse beschikbaar',
      perf_empty_hint: 'Klik op "Nu analyseren" om de prestaties van uw store te meten',
      suggestions: 'Suggesties',
      strategy_active: 'actief',
      strategy_subtitle: 'Stelt het optimalisatiedoel in. Klik om het plan te bekijken voor toepassing.',
      sg_header: 'Beperkt welke bewerkingen de strategie kan uitvoeren.',
      sg_desc_protected: 'Blokkeert Standard-bewerkingen — alleen veilige optimalisaties.',
      sg_desc_standard: 'Maakt volledige uitvoering van de geselecteerde strategie mogelijk.',
      quick_opts: 'Snelle optimalisaties',
      sg_warning: 'Safety Guard: Protected — Standard-bewerkingen zijn geblokkeerd. Schakel hierboven naar Standard.',
      lcp_section: 'LCP-themascan',
      hist_section: 'Optimalisatiegeschiedenis',
      hist_empty: 'Nog geen optimalisaties toegepast.',
      sessions_section: 'Sessies & Lighthouse-impact',
      sessions_empty: 'Laad sessies om de werkelijke impact op Core Web Vitals te zien.',
      img_count: '{{n}} afbeeldingen · {{kb}} KB totaal',
      img_oversized: '{{n}} afbeeldingen >300KB',
      img_no_oversized: 'Geen te grote afbeeldingen — geweldig!',
      img_empty: 'Klik op "Afbeeldingen analyseren" om afbeeldingen >300KB in het thema te vinden.',
      btn_refresh: 'Opnieuw laden',
      btn_load_sessions: 'Sessies laden',
      btn_refresh_sessions: 'Vernieuwen',
      btn_analyze_img: 'Afbeeldingen analyseren',
      btn_refresh_img: 'Vernieuwen',
      modal_risk_safe: 'Veilig — geen visuele impact verwacht',
      modal_risk_medium: 'Controleer het uiterlijk van de site na activering',
      modal_risk_high: 'Kan geavanceerde functies beïnvloeden',
      modal_reversible: 'Op elk moment omkeerbaar — gebruik "Alles terugdraaien" om het originele thema te herstellen.',
      modal_cancel: 'Annuleren',
      modal_enable: 'Nu inschakelen',
      opt_no_token: 'Verbind de Shopify-store opnieuw om deze functie te gebruiken',
      opt_blocked_guard: 'Geblokkeerd door Safety Guard (Protected) — schakel naar Standard om in te schakelen',
      opt_reversible: 'omkeerbaar',
      opt_blocked_label: 'Geblokkeerd door Safety Guard — schakel naar Standard',
      scan_scanning: 'Scan bezig...',
      scan_empty_title: 'Themascan niet uitgevoerd',
      scan_empty_desc: 'Identificeert hero- en slideshowsecties in het thema voor server-side LCP-optimalisaties.',
      scan_btn: 'Thema scannen',
      scan_active_theme: 'Actief thema',
      scan_files: '{{n}} Liquid-bestanden gescand · {{s}} LCP-secties geïdentificeerd',
      scan_hero_label: 'hero/LCP-sectie',
      scan_optimized: 'geoptimaliseerd',
      scan_no_lcp: 'Geen hero/LCP-secties automatisch geïdentificeerd in het thema.',
      scan_reload: 'Opnieuw laden',
      plan_title: 'Plan: {{label}}',
      plan_ops: '{{n}} geplande bewerkingen',
      plan_action_enabled: 'al actief',
      plan_action_enable: 'inschakelen',
      plan_action_disable: 'uitschakelen',
      plan_strategy: 'Strategie: ',
      plan_guard: 'Safety Guard: ',
      plan_active_ops: 'Actieve bewerkingen: ',
      plan_blocked: '{{n}} geblokkeerd door Safety Guard',
      plan_low_conf: 'Sommige optimalisaties hebben lage betrouwbaarheid voor het gedetecteerde thema.',
      plan_cancel: 'Annuleren',
      plan_apply: 'Strategie toepassen',
      plan_blocked_btn: 'Geblokkeerd (lage score)',
      hist_rollback: 'Volledig rollback — alle optimalisaties verwijderd',
      hist_enabled: 'ingeschakeld',
      hist_disabled: 'uitgeschakeld',
      hist_active: 'actief',
      sess_no_sessions: 'Geen optimalisatiesessies opgenomen. Sessies worden gemaakt wanneer u een strategie toepast.',
      sess_waiting: 'wacht op PSI',
      strategy_label: 'Strategie {{s}}',
      strategy_opts: '{{n}} optimalisaties',
      strategy_active: 'ACTIEF',
      quota_err: 'Fout bij laden PSI-quota',
      quota_api_key: 'API-sleutel geconfigureerd:',
      quota_yes: '✓ JA',
      quota_no: '✗ NEE (openbaar quota)',
      quota_cache_ttl: 'Cache TTL:',
      quota_hourly: 'Uurlimiet:',
      quota_daily: 'Daglimiet:',
      quota_success: 'Successen vandaag:',
      quota_hit_ratio: 'Cache-trefferverhouding:',
      quota_circuit: 'Stroomonderbreker:',
      quota_circuit_open: 'OPEN ({{n}} storingen)',
      quota_circuit_closed: 'gesloten',
      quota_loading: 'Laden...',
      diag_err: 'Diagnosefout',
      diag_refresh: 'Vernieuwen',
      diag_load: 'Diagnose laden',
      diag_patches: 'Actieve patches ({{n}})',
      diag_none: 'geen',
      diag_unavailable: 'niet beschikbaar',
      diag_no_patches: 'Geen actieve patches',
      diag_calibrated: '📈 gekalibreerd',
      diag_generated: 'Gegenereerd:',
      badge_server_side: 'SERVER-ZIJDE',
      badge_standard: 'STANDAARD',
      badge_lcp: 'LCP',
      badge_critical: 'KRITISCH',
      badge_safe: 'VEILIG',
      badge_medium: 'GEMIDDELD',
      badge_safety_guard: 'Veiligheidsbewaker',
      diag_theme_fingerprint: 'Thema-vingerafdruk',
      diag_engine_confidence: 'Motor-vertrouwen',
      perf_score_label: 'Prestatiescore',
      section_perf_overview: 'Prestatieoverzicht',
      section_strategy_intent: 'Strategische intentie',
      safety_guard_title: 'Veiligheidsbewaker',
      section_script_analyzer: 'Script-impactanalyse',
      script_col_file: 'Bestand',
      script_col_size: 'Grootte',
      script_col_impact: 'Impact',
      script_col_defer_risk: 'Uitstelrisico',
      metric_js_total: 'Totaal JS',
      metric_css_total: 'Totaal CSS',
      perf_updated: 'Bijgewerkt:',
      perf_stale: 'verouderde gegevens (PSI niet beschikbaar)',
      perf_from_cache: 'uit cache',
      perf_psi_ok: 'PSI OK',
      debug_invalid_token_title: 'Ongeldig token (401) — het token in MongoDB is verlopen of ingetrokken.',
      debug_reconnect_desc: 'De OAuth-callback heeft het token NIET overschreven na de laatste herinstallatie. Klik op de knop hieronder om een nieuwe OAuth te starten.',
      debug_reconnect_btn: 'OAuth nu opnieuw verbinden (opent Shopify)',
      debug_reconnect_note: 'Na het goedkeuren van machtigingen op Shopify, zal de callback het token in MongoDB automatisch bijwerken.',
    },
    drafts: {
      approved: 'Concept goedgekeurd!',
      approve_err: 'Goedkeuringsfout',
      published: 'Gepubliceerd op Shopify!',
      publish_err: 'Publicatiefout',
      title: 'Concepten & Resultaten',
      subtitle: 'Bekijk, keur goed en publiceer geoptimaliseerde inhoud',
      empty: 'Geen concepten om te beoordelen',
      empty_hint: 'Genereer AI-inhoud om nieuwe concepten te maken',
      badge_approved: 'Goedgekeurd',
      badge_draft: 'Concept',
      field_desc: 'Beschrijving',
      btn_view: 'Bekijken',
      btn_approve: 'Goedkeuren',
      btn_publish: 'Publiceren',
      modal_title: 'Conceptdetail',
      chars_seo: '/60 tekens',
      chars_meta: '/160 tekens',
      not_present: 'Niet aanwezig',
      not_present_pl: 'Niet aanwezig',
      btn_close: 'Sluiten',
      btn_publish_shopify: 'Publiceren op Shopify',
      seo_title: 'SEO-titel',
      meta_description: 'Meta omschrijving',
      keywords_label: 'Sleutelwoorden',
    },
    usage: {
      title: 'Gebruik & Plan',
      subtitle: 'Gebruik bewaken en abonnement beheren',
      plan_badge: 'Plan:',
      current: 'Huidig gebruik',
      credits: 'AI-credits',
      used: 'Gebruikt:',
      unlimited: 'Onbeperkt ∞',
      remaining: 'Resterend: {{n}}',
      products_sync: 'Gesynchroniseerde producten',
      plans_heading: 'Beschikbare plannen',
      most_popular: '⭐ Meest populair',
      active_plan: 'Actief plan',
      current_plan: 'Huidig plan',
      btn_upgrade: 'Upgrade naar {{name}}',
      trend_heading: 'Gebruikstrend',
      trend_coming: 'Gebruiksdiagram (binnenkort)',
      stat_products: 'Geanalyseerde producten',
      stat_content: 'Gegenereerde inhoud',
      stat_translations: 'Vertalingen',
      stat_images: 'Geoptimaliseerde afbeeldingen',
    },
    support: {
      msg_sent: 'Bericht verzonden!',
      msg_err: 'Fout bij het verzenden van het bericht',
      status_open: 'Open',
      status_progress: 'In behandeling',
      status_closed: 'Gesloten',
      title: 'Ondersteuning',
      subtitle: 'FAQ, handleidingen en chat met ons team',
      faq_heading: 'Veelgestelde vragen',
      guide_heading: 'Snelgids',
      chat_heading: 'Ondersteuningschat',
      no_msgs: 'Geen berichten',
      no_msgs_hint: 'Start een gesprek met de ondersteuning',
      placeholder: 'Schrijf een bericht...',
      contacts_heading: 'Contacten',
      contact_hours_label: 'Tijden',
      contact_hours: 'Ma-Vr 9:00-18:00 CET',
      contact_response_label: 'Reactietijd',
      contact_response: 'Binnen 24 uur',
      guide_step1: 'Ga naar de sectie',
      guide_products: 'Producten',
      guide_step1b: 'om uw producten te bekijken',
      guide_step2: 'Selecteer een product en ga naar',
      guide_ai_content: 'AI-inhoud',
      guide_step3: 'Genereer beschrijving, SEO-titel, meta-beschrijving en trefwoorden',
      guide_step4: 'Bekijk de resultaten in',
      guide_history: 'Geschiedenis',
    },
    transl: {
      load_err: 'Fout bij het laden van elementen',
      published: 'Vertaling gepubliceerd op Shopify!',
      pub_err: 'Publicatiefout',
      err_no_items: 'Selecteer ten minste één element',
      err_no_fields: 'Selecteer ten minste één veld om te vertalen',
      item_err: 'Vertaalfout',
      done_one: 'Vertaling voltooid!',
      done_many: '{{n}} elementen vertaald!',
      copied: 'Gekopieerd naar klembord',
      title: 'Vertalingen',
      gate_plan: 'Beschikbaar vanaf het Starter-abonnement',
      gate_desc: 'Vertaal producten, collecties en artikelen in 8 talen met AI',
      gate_btn: 'Overstappen naar Starter-abonnement',
      subtitle: "Vertaal producten, collecties, artikelen en pagina's naar meerdere talen met AI",
      translating: 'Vertalen…',
      search_placeholder: 'Zoeken op titel…',
      select_page: 'Pagina selecteren',
      sel_abbrev: 'sel.',
      total_items: 'totaal',
      loading: 'Laden…',
      no_results: 'Geen resultaten voor deze zoekopdracht',
      prev: '← Vorig',
      tot_abbrev: 'tot.',
      next: 'Volg →',
      deselect_all: 'Alles deselecteren',
      lang_heading: 'Doeltaal',
      fields_heading: 'Te vertalen velden',
      select_hint: 'Selecteer items uit de lijst om vertaling in te schakelen',
      results_heading: 'Resultaten',
      clear_results: 'Resultaten wissen',
      badge_published: 'Gepubliceerd',
      publishing: 'Publiceren…',
      done: 'Klaar',
      publish: 'Publiceren',
      copy: 'Kopiëren',
      tab_products: 'Producten',
      tab_collections: 'Collecties',
      tab_articles: 'Artikelen',
      tab_pages: "Pagina's",
      field_title: 'Titel',
      field_description: 'Beschrijving',
      field_seo_title: 'SEO Title',
      field_meta_description: 'Meta Description',
      field_body_html: 'Beschrijving / Inhoud',
      empty_hint_select: 'Selecteer een of meer items, kies de taal en klik op',
      translate_label: 'Vertalen',
      items_selected: 'items',
      item_selected: 'item',
      selected_label: 'geselecteerd',
      choose_fields_hint: 'kies de velden en klik op Vertalen',
    },
  },

  pl: {
    nav: {
      overview: 'Przegląd',
      catalog: 'Katalog',
      content: 'Treści AI',
      translations: 'Tłumaczenia',
      images: 'Obrazy',
      batch: 'Operacje wsadowe',
      speed: 'Optymalizator prędkości',
      history: 'Historia',
      usage: 'Użycie i Plan',
      settings: 'Ustawienia',
      support: 'Wsparcie',
    },
    common: {
      save: 'Zapisz',
      cancel: 'Anuluj',
      delete: 'Usuń',
      close: 'Zamknij',
      confirm: 'Potwierdź',
      loading: 'Ładowanie...',
      error: 'Błąd',
      success: 'Sukces',
      search: 'Szukaj',
      filter: 'Filtruj',
      all: 'Wszystkie',
      yes: 'Tak',
      no: 'Nie',
      back: 'Wstecz',
      next: 'Dalej',
      apply: 'Zastosuj',
      generate: 'Generuj',
      publish: 'Opublikuj',
      optimize: 'Optymalizuj',
      refresh: 'Odśwież',
    },
    settings: {
      title: 'Ustawienia',
      subtitle: 'Centrum sterowania AI',
      tabs: {
        general: 'Ogólne',
        localization: 'Lokalizacja',
        ai_engine: 'Silnik AI',
        appearance: 'Wygląd',
        piano: 'Plan',
        advanced: 'Zaawansowane',
      },
      save_btn: 'Zapisz ustawienia',
      unsaved: 'Niezapisane zmiany',
      action_loading: 'W toku...',
      general: {
        contents: 'Treści',
        default_lang: 'Domyślny język treści',
        tone: 'Globalny ton treści',
        tone_hint: 'Stosowany do produktów, kolekcji, artykułów i wsadów',
        seo_rules: 'Zasady SEO',
        seo_title_max: 'Maksymalna długość tytułu SEO',
        seo_title_hint: 'Zalecane: 50–60 znaków',
        meta_max: 'Maksymalna długość meta opisu',
        meta_hint: 'Zalecane: 150–160 znaków',
        chars: 'znaków',
        images: 'Preferencje obrazów',
        img_format: 'Domyślny format',
        img_square: 'Kwadrat (1:1)',
        img_landscape: 'Poziomy (4:3)',
        img_portrait: 'Pionowy (3:4)',
        img_quality: 'Jakość kompresji',
        img_quality_low: '50% (skompresowany)',
        img_quality_high: '100% (maksymalna)',
        store_info: 'Informacje o sklepie',
        store_domain: 'Domena',
        store_plan: 'Plan',
        store_installed: 'Zainstalowano',
      },
      ai: {
        strategy: 'Strategia AI',
        params_title: 'Parametry generowania',
        creativity: 'Kreatywność',
        creative_low: 'Konserwatywny',
        creative_high: 'Kreatywny',
        seo_strictness: 'Rygorystyczność SEO',
        seo_low: 'Elastyczny',
        seo_high: 'Rygorystyczny',
        tone_label: 'Globalny ton',
        auto_title: 'Auto-optymalizacja AI',
        auto_hint: 'Włącz, aby automatycznie optymalizować treści',
        on: 'Aktywny',
        off: 'Wyłącz',
        threshold: 'Próg optymalizacji',
        threshold_low: 'Optymalizuj wszystko',
        threshold_high: 'Tylko najgorsze',
        threshold_hint: 'Działa na elementy z wynikiem SEO < {{n}}',
        frequency: 'Częstotliwość',
        scope: 'Zakres',
        triggers: 'Wyzwalacze',
        img_format: 'Format obrazu',
        img_square: 'Kwadrat 1:1',
        img_square_sub: '800×800 px',
        img_landscape: 'Poziomy 4:3',
        img_landscape_sub: '800×600 px',
        img_portrait: 'Pionowy 3:4',
        img_portrait_sub: '600×800 px',
        img_no_resize: 'Bez zmiany rozmiaru',
        img_no_resize_sub: 'Oryginalne wymiary',
        compress: 'Kompresja',
        compress_hint: 'Zmniejsz rozmiar pliku',
        quality: 'Jakość',
        daily_credits: 'Kredyty AI dzisiaj',
        remaining: '{{n}} pozostałych',
        reset_in: 'Reset za',
        running: 'W toku — {{done}}/{{total}} produktów',
        run_now: 'Uruchom teraz',
        run_desc: 'Optymalizuj elementy z wynikiem < {{threshold}} w: {{scope}}',
        preview_title: 'Podgląd — Przed / Po',
        before: 'Przed',
        after: 'Po AI',
        no_keywords: 'brak słów kluczowych',
        preview_note: 'Przykład na produkcie «Buty do biegania Pro X1» — natychmiastowa aktualizacja',
        alt_mode_label: 'Tryb generowania tekstu ALT',
        alt_preview: 'Podgląd',
        alt_mode_ai: 'Inteligentna AI',
        alt_mode_ai_desc: 'OpenAI generuje zoptymalizowany ALT dla każdego obrazu',
        alt_mode_template: 'Darmowy szablon',
        alt_mode_template_desc: 'Bez kredytów AI — używa szablonu poniżej',
        alt_mode_auto: 'Automatyczny fallback',
        alt_mode_auto_desc: 'AI gdy dostępna, szablon gdy kredyty wyczerpane',
        alt_hint_template: 'Tryb darmowy: brak kredytów AI zużytych dla tekstu ALT.',
        alt_hint_auto: 'Auto-fallback: AI jeśli kredyty dostępne, w przeciwnym razie automatyczny szablon.',
        pct_done: '{{pct}}% ukończono',
        n_errors: '{{n}} błędów',
        alt_template_label: 'Niestandardowy szablon',
        alt_vars_label: 'Dostępne zmienne — kliknij, aby wstawić',
      },
      piano: {
        credits_title: 'Użycie kredytów',
        plan_label: 'Plan',
        extra_credits: 'Dodatkowe kredyty',
        unlimited: '∞ Nieograniczone kredyty',
        unlimited_sub: 'Plan Elite — bez miesięcznego limitu',
        plan_credits: 'Kredyty planu',
        consumed: 'Zużyte z planu',
        residual: 'Pozostałe z planu',
        extra_available: 'Dostępne dodatkowe kredyty',
        extra_sub: 'Zużywane dopiero po planie miesięcznym',
        total_available: 'Łącznie dostępne',
        consumed_cycle: 'Kredyty zużyte w bieżącym cyklu',
        status_active: 'Aktywny',
        status_pending: 'Przetwarzanie',
        status_frozen: '⚠ Zawieszony',
        status_free: 'Free / Brak subskrypcji',
        trial_active: 'Próba aktywna',
        trial_access: 'pełny dostęp do {{date}}.',
        sub_status: 'Status subskrypcji',
        next_credit_reset: 'Następny reset kredytów',
        trial_end: 'Koniec próby',
        trial_label: 'Bezpłatna próba',
        trial_used: 'Już wykorzystano',
        trial_available: '{{n}} dni dostępnych',
        cancel_btn: 'Anuluj subskrypcję',
        cancelling: 'Anulowanie...',
        plans_title: 'Dostępne plany',
        plan_active: 'Aktywny plan',
        plan_current: 'Obecny plan',
        per_month: '/miesiąc',
        downgrade: 'Wróć do Free',
        downgrading: 'Obniżanie planu...',
        upgrade: 'Upgrade',
        downgrade_btn: 'Downgrade',
        redirecting: 'Przekierowanie...',
        trial_btn: 'Wypróbuj za darmo',
        trial_btn_days: '({{n}}d)',
        plan_overage: 'Dodatkowe kredyty AI: {{price}} za kredyt',
        plan_no_overage: 'Bez opłat za dodatkowe kredyty AI',
        plan_trial_line: '{{n}}-dniowy bezpłatny okres próbny',
        plans_note: 'Plany płatne zawierają {{n}}-dniowy bezpłatny okres próbny. Bez opłat aktywacyjnych. Płatności przez Shopify Billing.',
        credits_section: 'Kup dodatkowe kredyty',
        credits_desc: 'Dodatkowe kredyty są dodawane do planu miesięcznego i nigdy nie wygasają. Kompatybilne ze wszystkimi planami.',
        one_time: 'jednorazowy',
        per_credit: '¢ za kredyt',
        buy: 'Kup',
        payment_note: 'Płatność przetwarzana bezpiecznie przez Shopify Billing. Żadne dane płatności nie są przechowywane na naszym serwerze.',
        history_title: 'Historia zakupów kredytów',
        history_count: '{{n}} zakup{{suffix}}',
        hist_invested: 'Łącznie zainwestowano',
        hist_bought: 'Zakupione kredyty',
        hist_available: 'Jeszcze dostępne',
        hist_empty: 'Nie dokonano żadnych zakupów dodatkowych kredytów.',
        hist_date: 'Data',
        hist_pkg: 'Pakiet',
        hist_credits: 'Kredyty',
        hist_amount: 'Kwota',
        hist_status: 'Status',
        hist_completed: 'Ukończony',
        hist_pending: 'Oczekujący',
        hist_declined: 'Odrzucony',
        trend_title: 'Trend użycia',
        trend_placeholder: 'Wykres użycia (dostępny z Shopify Billing)',
        stats_products: 'Przeanalizowane produkty',
        stats_content: 'Wygenerowane treści',
        stats_translations: 'Tłumaczenia',
        stats_images: 'Zoptymalizowane obrazy',
        toast_sub_pending: 'Subskrypcja w toku — wkrótce otrzymasz potwierdzenie.',
        toast_sub_activated: '{{name}} aktywowany!',
        toast_trial_suffix: '({{n}} dni bezpłatnej próby)',
        toast_sub_error: 'Błąd weryfikacji subskrypcji',
        toast_purchase_duplicate: 'Zakup już zarejestrowany.',
        toast_credits_added: '+{{n}} kredytów dodanych do Twojego konta!',
        toast_purchase_error: 'Błąd weryfikacji zakupu',
        toast_purchase_start_error: 'Błąd podczas uruchamiania zakupu',
        toast_sub_start_error: 'Błąd podczas uruchamiania subskrypcji',
        toast_store_unavailable: 'Sklep nie jest jeszcze połączony. Odśwież aplikację w Shopify Admin i spróbuj ponownie.',
        toast_sub_cancelled: 'Subskrypcja anulowana. Plan powrócił do Free.',
        toast_sub_cancel_error: 'Błąd anulowania subskrypcji',
        pkg_100_label: '100 Kredytów',
        pkg_100_desc: 'Idealne do okazjonalnego użytku',
        pkg_300_label: '300 Kredytów',
        pkg_300_desc: 'Zaoszczędź 17%',
        pkg_300_badge: '⭐ Najczęściej wybierany',
        pkg_700_label: '700 Kredytów',
        pkg_700_desc: 'Zaoszczędź 29%',
        pkg_1500_label: '1500 Kredytów',
        pkg_1500_desc: 'Zaoszczędź 33%',
        pkg_1500_badge: '🔥 Najlepsza wartość',
        plan_starter_badge: '⭐ Najpopularniejszy',
        plan_starter_benefit: 'Zaoszczędź godziny pracy każdego miesiąca.',
        plan_pro_badge: '🔥 Wzrost SEO',
        plan_pro_benefit: 'Poprawia indeksowanie i wydajność SEO.',
        plan_elite_badge: '🚀 Agencje',
        plan_elite_benefit: 'Zaprojektowane dla agencji i katalogów enterprise.',
      },
      toast: {
        saved_at: 'Zapisano o {{time}}',
        save_error: 'Błąd zapisu',
        budget_exceeded: 'Dzienny limit kredytów wyczerpany — {{done}} z {{total}} produktów zoptymalizowanych',
        autopilot_stopped: 'Autopilot zatrzymany — {{done}} z {{total}} produktów zoptymalizowanych',
        images_optimized: 'Obrazy zoptymalizowane — {{n}} produktów',
        images_failed: '{{n}} obrazów nie zoptymalizowanych',
        autopilot_done: 'Autopilot zakończony — {{started}} produktów w kolejce',
        autopilot_empty: 'Brak elementów poniżej progu',
        autopilot_stopping: 'Autopilot jest zatrzymywany...',
        reindex_started: 'Reindeksacja rozpoczęta',
        resync_started: 'Resynchronizacja rozpoczęta',
        cache_cleared: 'Cache wyczyszczone',
        sync_reset: 'Stan synchronizacji zresetowany',
      },
      advanced: {
        warning: 'Poniższe działania wpływają na zachowanie systemu. Używaj tylko w razie potrzeby.',
        sync_title: 'Synchronizacja',
        reindex: 'Reindeksuj produkty',
        reindex_desc: 'Przelicz dane SEO dla wszystkich produktów w bazie danych',
        resync: 'Synchronizuj ponownie z Shopify',
        resync_desc: 'Wymuś pełną synchronizację produktów i kolekcji',
        cache_title: 'Cache',
        clear_cache: 'Wyczyść pamięć podręczną aplikacji',
        clear_cache_desc: 'Usuwa trwające wsady w przeglądarce. Niezakończone operacje zostaną utracone.',
        reset_credits: 'Resetuj dzienne kredyty',
        reset_credits_desc: 'Resetuje licznik kredytów AI na dziś (dev). Limit: 5.000/dzień.',
        danger_zone: 'Strefa niebezpieczna',
        reset_sync: 'Resetuj stan synchronizacji',
        reset_sync_desc: 'Wymuś reset synchronizacji. Używaj tylko jeśli synchronizacja jest zablokowana od ponad 30 minut.',
      },
    },
    ai_engine: {
      preset: {
        growth_desc: 'Maksymalizuje konwersje i zaangażowanie',
        luxury_desc: 'Marka premium i ekskluzywna narracja',
        seo_desc: 'Maksymalizuje organiczną widoczność w Google',
        balanced_desc: 'Optymalna równowaga między jakością a SEO',
      },
      tone: {
        professional: 'Profesjonalny',
        professional_desc: 'Formalny, autorytatywny, buduje zaufanie',
        luxury: 'Luxury',
        luxury_desc: 'Elegancki, ekskluzywny, premium',
        technical: 'Techniczny',
        technical_desc: 'Precyzyjny, specyfikacje, mierzalne dane',
        conversational: 'Konwersacyjny',
        conversational_desc: 'Bezpośredni, przyjazny, angażujący',
      },
      frequency: {
        daily: 'Codziennie',
        daily_desc: '1× dziennie',
        hourly: 'Co godzinę',
        hourly_desc: 'Ciągłe',
        realtime: 'Natychmiast',
        realtime_desc: 'Tak szybko jak możliwe',
      },
      scope: {
        products: 'Produkty',
        collections: 'Kolekcje',
        articles: 'Artykuły',
        pages: 'Strony',
      },
      trigger: {
        seo_score: 'Niski wynik SEO',
        missing_meta: 'Brakujące metadane',
        missing_alt: 'Brakujący tekst ALT',
        outdated_desc: 'Nieaktualne opisy',
        keywords: 'Brakujące słowa kluczowe',
        image_quality: 'Niezoptymalizowane obrazy',
      },
    },
    appearance: {
      title: 'Wygląd',
      theme_title: 'Motyw',
      theme: {
        light: 'Jasny',
        dark: 'Ciemny',
        system: 'Systemowy',
      },
      density_title: 'Gęstość',
      density: {
        compact: 'Kompaktowy',
        comfortable: 'Wygodny',
        spacious: 'Przestronny',
        compact_desc: 'Więcej treści',
        comfortable_desc: 'Zrównoważony',
        spacious_desc: 'Więcej przestrzeni',
      },
      sidebar_title: 'Pasek boczny',
      sidebar: {
        expanded: 'Rozwinięty',
        collapsed: 'Zwinięty',
        hidden: 'Ukryty',
        expanded_desc: 'Zawsze widoczny',
        collapsed_desc: 'Tylko ikony',
        hidden_desc: 'Po najechaniu',
      },
    },
    localization: {
      ui_language: 'Język interfejsu',
      select_language: 'Wybierz język aplikacji',
      reload_note: 'Język jest stosowany natychmiast',
    },
    dashboard: {
      title: 'Przegląd',
      subtitle: 'Podsumowanie aktywności sklepu',
      products: 'Produkty',
      optimized: 'Zoptymalizowane',
      pending: 'Oczekujące',
      seo_score: 'Wynik SEO',
      audit_center: 'Audit Center',
      sync_products: 'Synchronizuj produkty',
      analyze_products: 'Analizuj produkty',
      audit_site: 'Audyt strony 360',
      syncing: 'Sync...',
      analyzing: 'Analiza...',
      auditing: 'Audit...',
      section_account: 'Konto i Plan',
      section_catalog: 'Stan katalogu',
      section_images: 'Obrazy',
      section_seo_tech: 'Techniczne SEO — szczegółowy audyt strony',
      section_ux_trust: 'UX & Trust — Highlights',
      section_actions: 'Działania zalecane przez AI',
      recent_activity: 'Ostatnia aktywność',
      hint_plan: 'Stan planu i kredytów',
      hint_never_synced: 'Nigdy nie synchronizowano',
      hint_priority: 'Posortowane według priorytetu',
      hint_last_sync: 'Ostatnia sync {{date}}',
      current_plan: 'Aktualny plan',
      credits_used: 'Użyte kredyty',
      credits_remaining: 'Pozostałe kredyty',
      public_domain: 'Domena publiczna',
      credit_usage: 'Wykorzystanie kredytów',
      hint_installed: 'Zainstalowano {{date}}',
      hint_pct_plan: '{{pct}}% planu',
      hint_limit: 'Limit {{n}}',
      hint_last_audit: 'Ostatni audyt {{date}}',
      hint_no_audit: 'Audyt nie wykonany',
      no_audit: 'Brak wykonanego audytu',
      no_audit_desc: 'Uruchom audyt, aby przeanalizować title, meta, H1, canonical, robots, sitemap, HTTPS, OG, JSON-LD, wydajność, obrazy i linki.',
      run_audit: 'Uruchom audyt',
      in_progress: 'W toku...',
      audit_phase: 'Audyt w toku (faza: {{phase}})...',
      ux_highlights: 'UX Highlights',
      trust_compliance: 'Trust & Compliance',
      mobile_viewport: 'Mobile viewport:',
      favicon: 'Favicon:',
      images_without_alt_label: 'Obrazy bez ALT:',
      lazy_loading: 'Lazy loading:',
      images_suffix: 'obrazów',
      internal_links: 'Linki wewnętrzne:',
      data_unavailable: 'Dane niedostępne: {{reason}}',
      analysis_not_run: 'Analiza nie wykonana',
      not_detected: 'Nie wykryto',
      no_trust_data: 'Brak danych zaufania',
      no_activity: 'Brak ostatniej aktywności.',
      activity_completed: 'Ukończono',
      activity_error: 'Błąd',
      no_store_title: 'Brak połączonego sklepu',
      no_store_desc: 'Zainstaluj aplikację w sklepie Shopify, aby zacząć',
      connect_store: 'Połącz sklep Shopify',
      no_token_title: 'Brak tokenu OAuth',
      no_token_desc: 'Sklep {{domain}} jest zarejestrowany, ale nie ma tokenu. Zainstaluj ponownie aplikację.',
      reinstall_app: 'Zainstaluj ponownie przez OAuth',
      sync_in_progress: 'Synchronizacja produktów w toku…',
      sync_in_progress_detail: '{{synced}} / {{total}} produktów. Dane dashboardu zostaną zaktualizowane po zakończeniu synchronizacji.',
      stale_data: 'Przestarzałe dane: wyświetlane są ostatnie prawidłowe liczby podczas synchronizacji.',
      catalog_score_label: 'Catalog Score',
      seo_distribution: 'Dystrybucja SEO',
      n_products: '{{n}} produktów',
      pct_of_catalog: '{{pct}}% katalogu',
      no_description: 'Bez opisu',
      no_meta_description: 'Bez meta description',
      seo_needs_improvement: 'SEO do poprawy',
      view: 'Zobacz',
      seo_good_desc: 'Katalog ma dobrą pokrycie SEO. Utrzymuj standard, optymalizując nowe produkty.',
      seo_medium_desc: 'Katalog ma średnie pokrycie SEO. Priorytet: meta descriptions i opisy produktów.',
      seo_poor_desc: 'Katalog ma słabe pokrycie SEO. Priorytet: meta descriptions, opisy i brakujące obrazy.',
      seo_optimized: 'Zoptymalizowane',
      seo_medium: 'Średnie',
      seo_poor: 'Do poprawy',
      content_seo_title: 'Stan SEO według typu treści',
      open_catalog: 'Otwórz katalog',
      row_collections: 'Kolekcje',
      row_articles: 'Artykuły',
      row_pages: 'Strony',
      coming_soon: 'Wkrótce',
      not_synced: 'Niesynchronizowane',
      seo_coverage_fmt: '{{opt}}/{{total}} zoptymalizowanych · {{score}}/100',
      alt_coverage: 'Pokrycie ALT text',
      with_alt_count: '{{n}} z ALT z {{total}}',
      image_optimization_label: 'Optymalizacja obrazów',
      optimized_count: '{{n}} zoptymalizowanych z {{total}}',
      with_alt: 'Z ALT',
      without_alt: 'Bez ALT',
      image_optimized: 'Zoptymalizowane',
      image_needs_improvement: 'Do poprawy',
      no_image: 'Bez obrazu',
      savings: 'Oszczędności',
      optimize_images_btn: 'Optymalizuj obrazy',
      view_no_image: 'Zobacz produkty bez obrazu',
      alt_manager: 'ALT Text Manager',
      toast_sync_done: 'Synchronizacja zakończona. Pojednywanie katalogu...',
      toast_catalog_reconciled: 'Katalog pojednany: {{n}} produktów (usunięto {{removed}} osieroconych)',
      toast_sync_first: 'Najpierw zsynchronizuj produkty',
      toast_avg_score: 'Średni wynik {{score}}/100',
      toast_audit_done: 'Audyt zakończony: {{score}}/100',
      toast_sync_reset: 'Stan sync zresetowany',
      toast_sync_reset_error: 'Nie można zresetować stanu',
      op_description: 'Opis AI',
      op_seo_title: 'SEO Title',
      op_meta_description: 'Meta Description',
      op_keywords: 'Keywords',
      op_translation: 'Tłumaczenie',
      op_image_opt: 'Optymalizacja obrazu',
      op_sync: 'Sync Shopify',
      op_seo_analysis: 'Analiza SEO sklepu',
      op_site_audit: 'Audyt strony 360',
      prompt_domain: 'Wprowadź domenę swojego sklepu Shopify',
      hint_force_reset: 'Wymuś reset stanu synchronizacji (nie usuwa produktów)',
    },
    products: {
      title: 'Katalog produktów',
      search: 'Szukaj produktów...',
      all: 'Wszystkie',
      optimized: 'Zoptymalizowane',
      pending: 'Oczekujące',
      status_generating: 'Generowanie',
      status_writing: 'Pisanie',
      status_validating: 'Walidacja',
      status_failed: 'Błąd',
      status_sync_failed: 'Sync Shopify',
      status_optimized: 'Zoptymalizowany',
      status_medium: 'Średni',
      status_needs_improvement: 'Do poprawy',
      type_collection_singular: 'kolekcja',
      type_collection_plural: 'kolekcje',
      sync_collections: 'Synchronizuj kolekcje',
      empty_collections: 'Brak kolekcji. Kliknij "Synchronizuj kolekcje" aby zaimportować je ze Shopify.',
      search_collections: 'Szukaj kolekcji po tytule lub handle...',
      col_label_products: 'Produkty',
      type_article_singular: 'artykuł',
      type_article_plural: 'artykuły',
      sync_articles: 'Synchronizuj artykuły',
      empty_articles: 'Brak artykułów. Kliknij "Synchronizuj artykuły" aby zaimportować je ze Shopify.',
      search_articles: 'Szukaj artykułu po tytule, handle lub blogu...',
      col_label_blog: 'Blog',
      type_page_singular: 'strona',
      type_page_plural: 'strony',
      sync_pages: 'Synchronizuj strony',
      empty_pages: 'Brak stron. Kliknij "Synchronizuj strony" aby zaimportować je ze Shopify.',
      search_pages: 'Szukaj strony po tytule lub handle...',
      col_label_author: 'Autor',
      catalog_title: 'Katalog',
      no_store: 'Brak sklepu',
      tab_products: 'Produkty',
      tab_collections: 'Kolekcje',
      tab_articles: 'Artykuły',
      tab_pages: 'Strony',
      sort_updated: 'Zaktualizowano',
      sort_seo_score: 'Wynik SEO',
      sort_title: 'Tytuł',
      sort_vendor: 'Vendor',
      sort_created: 'Utworzono',
      sort_desc: 'Malejąco',
      sort_asc: 'Rosnąco',
      filter_seo_all: 'SEO: wszystkie',
      filter_optimized: 'Zoptymalizowane',
      filter_medium: 'Średnie',
      filter_needs_improvement: 'Do poprawy',
      filter_image_all: 'Obrazy: wszystkie',
      filter_image_yes: 'Z obrazami',
      filter_image_no: 'Bez obrazów',
      filter_meta_all: 'Meta: wszystkie',
      filter_meta_yes: 'Z meta',
      filter_meta_no: 'Bez meta',
      filter_desc_all: 'Opis: wszystkie',
      filter_desc_yes: 'Z opisem',
      filter_desc_no: 'Bez opisu',
      filter_vendor_all: 'Vendor: wszystkie',
      filter_collection_all: 'Kolekcja: wszystkie',
      filter_type_all: 'Typ: wszystkie',
      reset_filters: 'Resetuj filtry',
      th_image: 'Obraz',
      th_title: 'Tytuł',
      th_seo_score: 'Wynik SEO',
      th_alt: 'ALT',
      th_meta: 'Meta',
      th_status: 'Status',
      th_actions: 'Akcje',
      no_products_filters: 'Nie znaleziono produktów z tymi filtrami',
      no_products: 'Brak produktów. Synchronizuj ze sklepem Shopify.',
      pagination: 'Strona {{page}} z {{total}} · {{count}} produktów',
      batch_btn: 'Operacje wsadowe',
      dialog_status: 'Status',
      dialog_seo_score: 'Wynik SEO',
      dialog_shopify_id: 'ID Shopify',
      dialog_vendor: 'Vendor',
      dialog_serp: 'Podgląd SERP',
      dialog_issues: 'Problemy SEO',
      dialog_suggestions: 'Sugestie',
      generating: 'Generowanie...',
      generate_all: 'Wygeneruj całą treść',
      action_generate_ai: 'Generuj treść AI',
      action_translate: 'Tłumacz',
      action_optimize_image: 'Optymalizuj obraz',
      syncing: 'Synchronizowanie...',
      draft_ready: 'Szkic gotowy',
      seo_ai_btn: 'SEO AI',
      batch_ops_btn: 'Operacje wsadowe',
      diagnosis: 'Diagnostyka',
      current_score: 'Aktualny wynik',
      projected: '→ przewidywany {{score}}/100',
      meta_title: 'Meta Title',
      meta_desc_label: 'Meta Description',
      description_label: 'Opis',
      generate_desc_btn: 'Generuj opis AI',
      generating_desc: 'Generowanie...',
      generate_ai_btn: 'Generuj z AI',
      publish_shopify_btn: 'Opublikuj na Shopify',
      publishing: 'Publikowanie...',
      discard_draft_btn: 'Odrzuć szkic',
      seo_ai_dialog_title: 'SEO AI',
      seo_all: 'SEO: wszystkie',
      seo_optimized: 'Zoptymalizowane',
      seo_medium: 'Średnie',
      seo_needs: 'Do poprawy',
      page_of: 'Strona {{page}} z {{total}}',
      search_placeholder: 'Szukaj po tytule, SKU, EAN, dostawcy, handle...',
      chars_count: '{{n}}/{{max}} znaków',
      n_selected_info: 'zaznaczonych',
      filtered: 'filtrowane',
      soon_tooltip: 'Dostępne wkrótce',
      resource_subtitle: '{{type}} Shopify i ich status SEO',
      articles_blog: 'Artykuły (blog)',
      select_visible_title: 'Zaznacz/odznacz wszystkie widoczne',
      toast_draft_ready: 'Wygenerowano wersję roboczą SEO. Sprawdź i opublikuj.',
      toast_error_ai: 'Błąd generowania AI',
      toast_desc_generated: 'Opis AI wygenerowany.',
      toast_error_desc: 'Błąd generowania opisu',
      toast_empty_draft: 'Wygeneruj lub wypełnij przynajmniej jedno pole',
      toast_published_score: 'Opublikowano na Shopify · Wynik {{score}}/100',
      toast_error_publish: 'Błąd publikowania na Shopify',
      toast_draft_discarded: 'Wersja robocza odrzucona',
      toast_select_items: 'Wybierz co najmniej jeden element',
      toast_mode_publish: 'Publikacja',
      toast_mode_both: 'Generuj+Publikuj',
      toast_mode_generate: 'Generowanie SEO AI',
      toast_batch_launched: '{{label}} uruchomiona dla {{count}} {{type}}.',
      toast_batch_errors: '{{label}} zakończona z {{count}} błędami',
      toast_batch_done: '{{label}} zakończona dla {{count}} {{type}}',
      toast_synced: '{{type}} zsynchronizowane: {{count}}',
      toast_sync_error: 'Błąd synchronizacji {{type}}',
      toast_token_error: 'Token Shopify wygasł lub brak uprawnień',
      reinstall_label: 'Zainstaluj ponownie',
      toast_sync_started: 'Synchronizacja {{type}} uruchomiona',
      toast_error_sync_start: 'Błąd uruchamiania synchronizacji',
      toast_perms_ok: 'Uprawnienia ok ({{kind}})',
      toast_token_revoked: 'Token odwołany',
      toast_perms_missing: 'Brakujące uprawnienia',
      toast_diag_error: 'Błąd diagnostyki',
      toast_score: 'Wynik {{score}}/100',
      toast_error_analyze: 'Błąd analizy',
      toast_generated: 'Treść wygenerowana',
      toast_error_generate: 'Błąd generowania',
    },
    content: {
      title: 'Generowanie treści',
      generate: 'Generuj treść',
      language: 'Język',
      tone: 'Ton',
      subtitle: 'Generuj opisy, SEO title, meta description i keywords z AI',
      tab_products: 'Produkty',
      tab_collections: 'Kolekcje',
      tab_articles: 'Artykuły',
      tab_pages: 'Strony',
      type_description_label: 'Opis',
      type_description_hint: 'Atrakcyjny i przyjazny SEO tekst produktu',
      type_seo_title_label: 'SEO Title',
      type_seo_title_hint: 'Tytuł zoptymalizowany pod SERP (max 60 zn.)',
      type_meta_desc_label: 'Meta Description',
      type_meta_desc_hint: 'Snippet Google (max 160 zn.)',
      type_keywords_label: 'Keywords',
      type_keywords_hint: 'Główne i poboczne słowa kluczowe',
      type_body_label: 'Opis / Treść',
      type_body_hint: 'Główny tekst zasobu',
      filter_all: 'Wszystkie',
      filter_needs: 'Do poprawy',
      filter_medium: 'Średnie',
      filter_optimized: 'Zoptymalizowane',
      no_results_filters: 'Żaden element nie odpowiada filtrom',
      select_all: 'Zaznacz wszystko',
      deselect: 'Odznacz',
      selected_count: '{{count}} zaznaczonych',
      selected_max: '(max)',
      deselect_all: 'Odznacz wszystko',
      pagination_of: '{{page}} / {{total}}',
      total_count: '({{count}} łącznie)',
      content_type_section: 'Typ treści',
      batch_generating: 'Generowanie… {{done}}/{{total}}',
      batch_generate_btn: 'Generuj wsadowo ({{count}})',
      generating_count: 'Generuj ({{count}})',
      generate_btn: 'Generuj',
      generating: 'Generowanie…',
      generate_all_btn: 'Wszystkie',
      hint_select: '← Wybierz element lub zaznacz kilka do wsadu',
      hint_batch_ready: '{{count}} element(ów) gotowych do wsadu',
      batch_done_title: '✓ Wsad ukończony',
      batch_pending_title: 'Wsad oczekujący…',
      batch_in_progress_title: 'Generowanie wsadowe w toku…',
      batch_done_msg: 'Wszystkie treści wygenerowane. Zaznaczenie zostanie automatycznie wyczyszczone.',
      results_section: 'Wyniki',
      publishing: 'Publikowanie…',
      published: 'Opublikowano',
      publish_btn: 'Opublikuj na Shopify',
      clear_results: 'Wyczyść',
      chars_unit: 'zn.',
      cache_label: 'cache',
      preview_section: 'Aktualny podgląd',
      loading_detail: 'Ładowanie szczegółów…',
      not_present: 'Nie obecne',
      not_present_plural: 'Nie obecne',
      empty_state: 'Kliknij element aby go zobaczyć, lub zaznacz kilka i użyj Generuj wsadowo',
      copy_btn: 'Kopiuj',
      type_seo_title_hint_content: 'Metatytuł dla SERP (maks. 60 zn.)',
      no_items: 'Nie znaleziono {{type}}',
      item_deselect: 'Odznacz',
      item_select: 'Dodaj do zaznaczenia',
      generate_all_title: 'Generuj wszystkie dostępne typy',
      prev_item: 'Poprzedni element',
      next_item: 'Następny element',
      toast_load_error: 'Błąd podczas ładowania elementów',
      toast_batch_done: 'Partia ukończona: {{done}}/{{total}} produktów',
      toast_batch_failed: 'Partia nie powiodła się: {{failed}} błędów z {{total}}',
      toast_batch_cancelled: 'Partia anulowana',
      toast_batch_resumed: 'Aktywna partia wznowiona…',
      toast_max_select: 'Maksymalnie {{max}} elementów do zaznaczenia',
      toast_select_item: 'Wybierz element z listy',
      toast_select_type: 'Wybierz co najmniej jeden typ treści',
      toast_from_cache: 'Treść z pamięci podręcznej!',
      toast_generated: 'Wygenerowano pomyślnie!',
      toast_generate_error: 'Błąd podczas generowania treści',
      toast_batch_running: 'Proces wsadowy jest już uruchomiony',
      toast_no_store: 'Sklep niedostępny',
      toast_batch_started: 'Partia uruchomiona: {{n}} produktów w kolejce',
      toast_batch_start_error: 'Błąd uruchamiania partii',
      toast_batch_item_error: 'Błąd generowania: {{title}}',
      toast_batch_complete: 'Partia ukończona: {{done}}/{{total}} elementów',
      toast_cancel_error: 'Błąd anulowania partii',
      toast_published: 'Treść opublikowana w Shopify!',
      toast_publish_error: 'Błąd podczas publikowania',
      toast_copied: 'Skopiowano do schowka',
      present: 'obecny',
      missing: 'brakujący',
      lang_it: 'Włoski',
      lang_en: 'Angielski',
      lang_fr: 'Francuski',
      lang_de: 'Niemiecki',
      lang_es: 'Hiszpański',
      lang_pt: 'Portugalski',
      tone_professional: 'Profesjonalny',
      tone_luxury: 'Luksus',
      tone_technical: 'Techniczny',
      tone_conversational: 'Konwersacyjny',
    },
    images: {
      title: 'Optymalizacja obrazów',
      optimize: 'Optymalizuj',
      format: 'Format',
      compress: 'Kompresuj',
      quality: 'Jakość',
      alt_mode_label: 'Tryb generowania ALT',
      alt_mode_ai: 'Inteligentne AI',
      alt_mode_template: 'Darmowy szablon',
      alt_mode_auto: 'Auto fallback',
      subtitle: 'Optymalizuj obrazy, zarządzaj tekstem ALT i publikuj na Shopify.',
      tab_optimize: 'Optymalizuj obrazy',
      tab_alt: 'Tekst ALT',
      alt_coverage: 'Pokrycie ALT',
      with_alt_count: 'z ALT z',
      stat_with_alt: 'Z ALT: {{count}}',
      stat_without_alt: 'Bez ALT: {{count}}',
      stat_no_image: 'Bez obrazu: {{count}}',
      sync_alt_btn: 'Aktualizuj dane ALT ze Shopify',
      syncing_alt: 'Aktualizacja ALT...',
      sync_status_label: 'Status:',
      analyzed_label: 'Przeanalizowane:',
      last_updated_label: 'Ostatnia aktualizacja:',
      stalled: 'zablokowany',
      force_stop: 'Wymuś zatrzymanie (zablokowany od 60s)',
      free_badge: '● Bezpłatny — brak kredytów',
      configure_btn: '▼ Konfiguruj',
      hide_btn: '▲ Ukryj',
      template_free_hint: 'Tryb bezpłatny aktywny — zero kredytów AI. Template:',
      template_auto_hint: 'Automatyczny fallback — AI jeśli dostępne kredyty, lokalny template jeśli wyczerpane.',
      template_config_title: 'Konfiguruj template ALT',
      template_label: 'Niestandardowy template',
      template_preview: 'Podgląd:',
      variables_label: 'Dostępne zmienne — kliknij aby wstawić:',
      restore_default: 'Przywróć domyślne',
      save_config: 'Zapisz konfigurację',
      saving: 'Zapisywanie...',
      search_placeholder: 'Szukaj po tytule, vendorze, handle...',
      filter_all_images: 'Wszystkie',
      filter_with_alt: 'Z ALT',
      filter_without_alt: 'Bez ALT',
      selected_images: '{{count}} obrazów wybranych (max 50 na wsad)',
      generate_batch_btn: 'Generuj ALT dla wybranych',
      batch_alt_in_progress: 'Wsad ALT w toku: {{done}} / {{total}}',
      batch_errors: '{{n}} błędów',
      select_all_label: 'Zaznacz wszystko',
      deselect_all_label: 'Odznacz wszystko',
      total_products_label: '{{count}} produktów',
      timeout_title: 'Ładowanie trwało zbyt długo (20s)',
      timeout_desc: 'Baza danych przetwarza wiele produktów. Spróbuj ponownie za kilka sekund.',
      error_title: 'Błąd ładowania listy',
      no_products_filter: 'Żaden produkt nie odpowiada filtrom',
      alt_placeholder: 'Tekst ALT (max 125 znaków)',
      status_published: 'Opublikowany',
      status_saved: 'Zapisany',
      status_draft_alt: 'Szkic',
      status_missing: 'Brak ALT',
      generate_alt_btn: 'Generuj ALT',
      save_alt_btn: 'Zapisz ALT',
      publish_alt_btn: 'Opublikuj',
      prec: 'Poprz.',
      succ: 'Nast.',
      select_products: 'Wybierz produkty',
      filter_collection_all: 'Kolekcja: wszystkie',
      filter_vendor_all: 'Vendor: wszystkie',
      filter_kb_all: 'KB: wszystkie',
      filter_kb_100: 'Pliki powyżej 100 KB',
      filter_kb_500: 'Pliki powyżej 500 KB',
      filter_kb_1mb: 'Pliki powyżej 1 MB',
      filter_format_all: 'Format: wszystkie',
      filter_landscape: 'Szerokość większa niż wysokość',
      filter_portrait: 'Wysokość większa niż szerokość',
      filter_square: 'Kwadratowe',
      filter_status_all: 'Status: wszystkie',
      filter_status_optimized: 'Już zoptymalizowane',
      filter_status_needs: 'Do optymalizacji',
      visible_total: '{{visible}} widocznych · {{total}} łącznie',
      reset_filters: 'Resetuj filtry',
      clear_selection: 'Wyczyść zaznaczenie',
      no_image_products: 'Brak produktów z obrazem',
      ready_badge: 'Gotowy',
      settings_title: 'Ustawienia',
      format_title: 'Format obrazu',
      format_square: 'Kwadrat 1:1',
      format_landscape: 'Landscape 4:3',
      format_portrait: 'Portrait 3:4',
      format_none: 'Bez zmiany rozmiaru',
      format_none_sub: 'Oryginalne wymiary',
      compress_label: 'Kompresja',
      compress_desc: 'Zmniejsz rozmiar pliku',
      quality_label: 'Jakość',
      batch_opt_running: 'Optymalizacja w toku',
      batch_opt_cancelled: 'Optymalizacja anulowana',
      batch_opt_completed: 'Optymalizacja ukończona',
      batch_apply_running: 'Stosowanie w toku',
      batch_apply_cancelled: 'Stosowanie anulowane',
      batch_apply_completed: 'Stosowanie ukończone',
      background_note: 'Możesz zmienić sekcję, kontynuuje w tle',
      optimizing: 'Optymalizacja...',
      optimize_n: 'Optymalizuj {{count}} obrazów',
      optimize_one: 'Optymalizuj obraz',
      applying: 'Stosowanie...',
      apply_n: 'Zastosuj {{count}} na Shopify',
      apply_one: 'Zastosuj na Shopify',
      preview_title: 'Podgląd',
      ready_optimizations: '{{count}} optymalizacji gotowych',
      select_preview_hint: 'Wybierz jeden lub więcej produktów aby zobaczyć podgląd',
      first_product_preview: 'Podgląd dla pierwszego wybranego produktu:',
      original_label: 'Oryginał',
      optimized_label: 'Zoptymalizowany',
      optimize_click_hint: 'Kliknij "Optymalizuj" aby zobaczyć wynik',
      reduction_label: 'Redukcja',
      apply_btn: 'Zastosuj',
      history_opt_title: 'Historia optymalizacji',
      history_opt_subtitle: 'Operacje zastosowane na Shopify, błędy i przywrócenia.',
      stat_running_label: 'W toku',
      stat_completed_label: 'Ukończone',
      stat_errors_label: 'Niekompletne',
      stat_undo_label: 'Cofnij',
      total_savings: 'Łączne oszczędności',
      history_loading: 'Ładowanie historii...',
      no_history: 'Nie zastosowano jeszcze żadnych operacji.',
      restoring: 'Przywracanie...',
      undo_btn: 'Cofnij',
      kb_warning: 'Rozmiar KB nie jest w lokalnych danych. Aby go dokładnie określić musi być zapisany przez backend podczas synchronizacji obrazów.',
      senza_vendor: 'Bez vendora',
      alt_stat_coverage: '{{n}} z ALT z {{total}}',
      apply_batch_cancelled: 'Stosowanie anulowane',
      apply_batch_done_label: 'Stosowanie zakończone',
      apply_batch_running: 'Stosowanie w toku',
      apply_n_btn: 'Zastosuj {{n}} na Shopify',
      applying_btn: 'Stosowanie...',
      auto_fallback_hint: 'Auto fallback — AI jeśli kredyty dostępne, lokalny szablon jeśli wyczerpane.',
      background_hint: 'Możesz zmienić sekcję, kontynuuje w tle',
      badge_draft: 'Szkic',
      badge_missing: 'Bez ALT',
      badge_published: 'Opublikowany',
      badge_ready: 'Gotowy',
      badge_saved: 'Zapisany',
      batch_close: 'Zamknij',
      batch_generate_btn: 'Generuj ALT dla zaznaczonych',
      batch_progress: 'Batch ALT w toku: {{done}} / {{total}}',
      batch_selected: '{{n}} obrazów zaznaczonych (maks. 50 na batch)',
      collection_all: 'Kolekcja: wszystkie',
      compress_sub: 'Zmniejsz rozmiar pliku',
      config_btn: '▼ Konfiguruj',
      deselect_all: 'Odznacz wszystkie',
      empty_filtered: 'Brak produktów spełniających filtry',
      filter_all: 'Wszystkie',
      format_label: 'Format obrazu',
      gen_alt_btn: 'Generuj ALT',
      history_completed: 'Ukończone',
      history_empty: 'Brak zastosowanych operacji.',
      history_incomplete: 'Niekompletne',
      history_running: 'W toku',
      history_savings: 'Łączne oszczędności',
      history_subtitle: 'Operacje zastosowane na Shopify, błędy i przywrócenia.',
      history_title: 'Historia optymalizacji',
      history_undo_label: 'Cofnij',
      last_update_label: 'Ostatnia aktualizacja:',
      load_error: 'Błąd ładowania listy',
      n_errors: '{{n}} błędów',
      n_products: '{{n}} produktów',
      n_selected: '{{n}} zaznaczonych',
      next_page: 'Nast.',
      no_products: 'Brak produktów z obrazem',
      no_vendor: 'Bez vendora',
      opt_batch_cancelled: 'Optymalizacja anulowana',
      opt_batch_done: 'Optymalizacja zakończona',
      opt_batch_running: 'Optymalizacja w toku',
      optimize_n_btn: 'Optymalizuj {{n}} obrazów',
      optimize_one_btn: 'Optymalizuj obraz',
      optimizing_btn: 'Optymalizowanie...',
      orientation_all: 'Format: wszystkie',
      orientation_landscape: 'Szerokość większa od wysokości',
      orientation_portrait: 'Wysokość większa od szerokości',
      orientation_square: 'Kwadrat',
      page_info: 'Strona {{page}} z {{total}}',
      pagination: 'Strona {{page}} z {{total}}',
      prev: 'Poprz.',
      publish_btn: 'Opublikuj',
      retry: 'Ponów',
      select_all: 'Zaznacz wszystkie',
      size_100kb: 'Pliki powyżej 100 KB',
      size_1mb: 'Pliki powyżej 1 MB',
      size_500kb: 'Pliki powyżej 500 KB',
      size_all: 'KB: wszystkie',
      status_all: 'Stan: wszystkie',
      status_label: 'Stan:',
      status_needs: 'Do optymalizacji',
      status_optimized: 'Już zoptymalizowane',
      status_stalled: 'zablokowany',
      sync_btn: 'Zaktualizuj dane ALT z Shopify',
      sync_btn_title: 'Ponownie odczytuje obrazy i prawdziwe ALT z Shopify',
      syncing: 'Aktualizacja ALT...',
      template_active: 'Tryb bezpłatny aktywny — zero kredytów AI. Szablon:',
      template_custom_label: 'Niestandardowy szablon',
      template_free_badge: '● Bezpłatny — brak kredytów',
      template_preview_label: 'Podgląd:',
      template_reset: 'Przywróć domyślne',
      template_save: 'Zapisz konfigurację',
      template_saving: 'Zapisywanie...',
      template_vars_label: 'Dostępne zmienne — kliknij, aby wstawić:',
      timeout_msg: 'Baza danych przetwarza wiele produktów. Spróbuj ponownie za kilka sekund.',
      toast_alt_ai: 'ALT wygenerowany przez AI',
      toast_alt_cancelled: 'Aktualizacja ALT anulowana — możesz ją ponownie uruchomić',
      toast_alt_empty: 'Pusty ALT',
      toast_alt_from_cache: 'ALT z pamięci podręcznej',
      toast_alt_gen_error: 'Błąd generowania ALT',
      toast_alt_publish_error: 'Błąd publikacji',
      toast_alt_published: 'Opublikowano na Shopify',
      toast_alt_save_error: 'Błąd zapisu',
      toast_alt_saved: 'ALT zapisany',
      toast_alt_sync_start_error: 'Błąd uruchamiania aktualizacji ALT',
      toast_alt_sync_started: 'Aktualizacja danych ALT uruchomiona',
      toast_alt_template: 'ALT wygenerowany przez szablon (bezpłatny)',
      toast_alt_template_fallback: 'ALT przez szablon (kredyty wyczerpane)',
      toast_alt_update_error: 'Błąd aktualizacji ALT',
      toast_alt_updated: 'Dane ALT zaktualizowane: {{n}} produktów przeanalizowanych',
      toast_applied: 'Obraz zastosowany na Shopify',
      toast_apply_batch_done: '{{n}} obrazów zastosowanych na Shopify',
      toast_apply_batch_errors: 'Stosowanie zakończone z {{n}} błędami',
      toast_apply_batch_started: 'Stosowanie uruchomione: {{n}} obrazów. Możesz zmienić sekcję.',
      toast_batch_alt_done: 'Batch zakończony',
      toast_batch_alt_started: 'Batch uruchomiony: {{n}} obrazów, {{c}} naraz',
      toast_batch_done: 'Batch zakończony: {{n}} obrazów zoptymalizowanych. Możesz zastosować je na Shopify.',
      toast_batch_errors: '{{n}} obrazów nieprzetworzonych. Ponów lub sprawdź logi.',
      toast_batch_started: 'Batch uruchomiony: {{n}} obrazów. Możesz zmienić sekcję, kontynuuje w tle.',
      toast_cancel_error: 'Błąd anulowania',
      toast_no_draft: 'Brak zoptymalizowanego obrazu do zastosowania',
      toast_no_images: 'Brak wybranego obrazu',
      toast_no_ready: 'Brak gotowej optymalizacji do zastosowania',
      toast_no_store: 'Sklep niedostępny',
      toast_optimize_error: 'Błąd optymalizacji',
      toast_optimized: 'Obraz zoptymalizowany. Możesz teraz zastosować go na Shopify.',
      toast_select_product: 'Wybierz co najmniej jeden produkt',
      toast_template_save_error: 'Błąd zapisu szablonu',
      toast_template_saved: 'Konfiguracja szablonu zapisana',
      toast_undo_done: 'Oryginalny obraz przywrócony',
      toast_undo_error: 'Błąd podczas przywracania',
      undoing_btn: 'Przywracanie...',
      vendor_all: 'Vendor: wszystkie',
      toast_no_product: 'Wybierz produkt',
      toast_no_image: 'Produkt nie ma obrazu',
      toast_no_preview: 'Najpierw optymalizuj obraz',
      toast_apply_error: 'Błąd zastosowania na Shopify',
      n_ready: '{{n}} optymalizacji gotowych',
      preview_hint: 'Wybierz jeden lub więcej produktów aby zobaczyć podgląd',
      preview_first: 'Podgląd dla pierwszego wybranego produktu:',
      click_optimize_hint: 'Kliknij "Optymalizuj" aby zobaczyć wynik',
      apply_single_btn: 'Zastosuj',
    },
    alt_template: {
      section_title: 'Szablon ALT',
      mode_label: 'Tryb generowania tekstu ALT',
      textarea_label: 'Niestandardowy szablon',
      preview_label: 'Podgląd',
      vars_label: 'Dostępne zmienne — kliknij, aby wstawić',
      hint_template: 'Tryb bezpłatny: bez kredytów AI dla tekstu ALT.',
      hint_auto: 'Auto fallback: AI jeśli kredyty dostępne, w przeciwnym razie lokalny szablon.',
    },
    batch: {
      title: 'Operacje wsadowe',
      start: 'Uruchom',
      cancel: 'Anuluj',
      subtitle: 'Trwałe przetwarzanie po stronie serwera — kontynuuje nawet gdy zmienisz stronę lub zamkniesz kartę',
      locked_title: 'Operacje wsadowe niedostępne',
      locked_desc: 'Operacje wsadowe są dostępne od planu Starter. Przetwarzaj setki produktów równolegle jednym kliknięciem.',
      upgrade_btn: 'Przejdź na Starter',
      op_content_label: 'Generuj treść AI',
      op_content_desc: 'Opis, SEO title, meta description, keywords',
      op_translate_label: 'Tłumacz produkty',
      op_translate_desc: 'Pełne tłumaczenie na wybrany język',
      op_images_label: 'Optymalizuj obrazy',
      op_images_desc: 'Zmiana rozmiaru 1:1 i kompresja obrazów',
      field_description_label: 'Opis',
      field_description_hint: '150-250 słów',
      field_seo_title_label: 'SEO Title',
      field_seo_title_hint: 'max 60 znaków',
      field_meta_desc_label: 'Meta Description',
      field_meta_desc_hint: '100-160 znaków',
      field_keywords_label: 'Keywords',
      field_keywords_hint: '5-10 słów kluczowych',
      count_all: 'Wszystkie',
      status_pending: 'W kolejce',
      status_running: 'W toku',
      status_completed: 'Ukończony',
      status_failed_job: 'Błąd',
      status_cancelled: 'Anulowany',
      opt_in_progress: 'Optymalizacja obrazów w toku…',
      batch_in_progress: 'Wsad AI w toku…',
      images_progress: '{{done}} / {{total}} obrazów',
      products_progress: '{{done}} / {{total}} produktów',
      errors_count: '{{count}} błędów',
      duration_label: 'Czas trwania: {{time}}',
      starting: 'Uruchamianie...',
      seo_gen_in_progress: 'Generuj + Publikuj SEO w toku',
      gen_publish_auto: 'Automatyczne generowanie i publikowanie na Shopify',
      section_operation: 'Operacja',
      section_fields: 'Pola do wygenerowania',
      fields_selected: '{{count}}/{{total}} zaznaczonych',
      fields_warning: 'Zaznacz przynajmniej jedno pole aby uruchomić wsad',
      fields_hint: 'Jedno wywołanie AI na produkt generuje wszystkie zaznaczone pola — mniejsze opóźnienie i niższe koszty.',
      section_options: 'Opcje',
      label_language: 'Język',
      label_tone: 'Ton',
      tone_professional: 'Profesjonalny',
      tone_luxury: 'Luksusowy',
      tone_technical: 'Techniczny',
      tone_conversational: 'Konwersacyjny',
      label_target_lang: 'Język docelowy',
      images_note: 'Zmiana rozmiaru 1:1 (800×800) + kompresja jakości 85%.',
      section_quantity: 'Ilość produktów',
      available_count: '{{count}} dostępnych',
      catalog_selection: '{{count}} produkt(ów) wybranych z katalogu',
      remove_selection: 'Usuń zaznaczenie',
      products_selected_count: '{{count}} produkt(ów) wybranych',
      processing: 'Przetwarzanie…',
      start_btn: 'Uruchom przetwarzanie',
      history_title: 'Historia wsadów',
      history_subtitle: 'zaktualizowano z BD',
      stat_running: 'W toku',
      stat_completed: 'Ukończone',
      stat_products_ok: 'Produkty OK',
      no_batch: 'Nie wykonano żadnego wsadu',
      no_batch_hint: 'Zadania pojawią się tutaj po pierwszym przetwarzaniu',
      job_content: 'Generuj treść AI',
      job_translate: 'Tłumaczenie',
      job_images: 'Optymalizacja obrazów',
      job_products: '{{done}}/{{total}} produktów',
      log_lang: 'Język:',
      log_tone: 'Ton:',
      toast_completed: 'Wsad zakończony: {{done}}/{{total}} produktów przetworzonych',
      toast_failed: 'Wsad nieudany: {{count}} błędów',
      toast_no_products: 'Brak dostępnych produktów',
      soon_lbl: 'wkrótce',
      btn_analyze_seo: 'Analizuj SEO',
      btn_view: 'Wyświetl',
      toast_no_fields: 'Wybierz co najmniej jedno pole do wygenerowania',
      toast_images_started: 'Optymalizacja obrazów uruchomiona: {{count}} produktów',
      toast_started: 'Wsad uruchomiony: {{count}} produktów',
      toast_start_error: 'Błąd uruchamiania',
      toast_cancelled: 'Wsad anulowany',
      toast_cancel_error: 'Błąd anulowania',
      fields_label: 'Pola',
      log_summary: 'Dzienniki pojedynczych operacji',
    },
    history: {
      title: 'Historia',
      empty: 'Nie znaleziono operacji',
      subtitle: 'Pełny audyt wszystkich wykonań AI — {{n}} operacji łącznie',
      refresh_btn: 'Odśwież',
      total_operations: 'Łączna liczba operacji',
      success_rate: 'Wskaźnik sukcesu',
      n_successes: '{{n}} sukcesów',
      credits_today: 'Kredyty dzisiaj',
      products_today: 'Produkty dzisiaj',
      avg_duration: 'Średni czas trwania',
      last_autopilot: 'Ostatni Autopilot',
      filters: 'Filtry',
      filters_active: 'aktywne',
      reset_all: 'Zresetuj wszystko',
      search_placeholder: 'Szukaj produktu...',
      op_all: 'Wszystkie typy',
      op_description: 'Opis AI',
      op_seo_title: 'SEO Title AI',
      op_meta_description: 'Meta Description AI',
      op_batch: 'Generowanie wsadowe',
      op_translation: 'Tłumaczenie',
      op_image: 'Obraz',
      op_sync: 'Sync Shopify',
      trigger_all: 'Wszystkie wyzwalacze',
      status_all: 'Wszystkie statusy',
      status_success: 'Sukces',
      status_partial: 'Częściowy',
      status_error: 'Błąd',
      th_status: 'Status',
      th_type: 'Typ operacji',
      th_product: 'Produkt',
      th_trigger: 'Wyzwalacz',
      th_seo_delta: 'SEO Delta',
      th_credits: 'Kredyty',
      th_duration: 'Czas trwania',
      th_timestamp: 'Znacznik czasu',
      loading: 'Ładowanie...',
      remove_filters: 'Usuń filtry',
      load_more: 'Załaduj więcej (wyświetlono {{shown}} z {{total}})',
      details_title: 'Szczegóły wykonania',
      detail_op_id: 'ID operacji',
      detail_product_id: 'ID produktu',
      detail_store_id: 'Store ID',
      detail_type: 'Typ',
      detail_trigger: 'Wyzwalacz',
      detail_status: 'Status',
      detail_language: 'Język',
      detail_tone: 'Ton',
      detail_tokens: 'Użyte tokeny',
      detail_fields: 'Pola',
      detail_credits: 'Kredyty',
      detail_duration: 'Czas trwania',
      detail_seo_before: 'SEO przed',
      detail_seo_after: 'SEO po',
      detail_timestamp: 'Znacznik czasu',
      error_prefix: 'Błąd: ',
      label_description: 'Opis AI',
      label_seo_title: 'SEO Title AI',
      label_meta_description: 'Meta Description AI',
      label_keywords: 'Keywords AI',
      label_batch: 'Generowanie wsadowe',
      label_translation: 'Tłumaczenie',
      label_image: 'Optymalizacja obrazu',
      label_sync: 'Sync Shopify',
      label_push: 'Publikacja Shopify',
    },
    batch_banner: {
      errors: 'błędów',
      optimizing: 'Optymalizacja obrazów',
      optimizing_cancelled: 'Optymalizacja anulowana',
      optimizing_completed: 'Optymalizacja zakończona',
      applying: 'Stosowanie w Shopify',
      applying_cancelled: 'Zastosowanie anulowane',
      applying_completed: 'Zastosowanie zakończone',
      open_images: 'Otwórz Obrazy',
      open_catalog: 'Otwórz Katalog',
      type_collections: 'Kolekcje',
      type_articles: 'Artykuły',
      type_pages: 'Strony',
      type_contents: 'Treści',
      mode_publish: 'Publikacja',
      mode_both: 'Generuj+Publikuj',
      mode_generate: 'Generowanie SEO AI',
      state_cancelled: '(anulowane)',
      state_completed: '(ukończone)',
    },
    app_banner: {
      expired: 'Token Shopify wygasł lub został odwołany.',
      reconnect_desc: 'Połącz ponownie aplikację, aby przywrócić synchronizację i publikowanie.',
      detected_in: 'wykryto w',
      reconnect_btn: 'Połącz ponownie',
    },
    review_popup: {
      greeting: 'Cześć! Jestem tutaj 👋',
      subtitle: 'Mam nadzieję, że wszystko świetnie idzie z AI Optimizer!',
      rating_title: 'Czy podoba Ci się aplikacja?',
      rating_desc: 'Twoja opinia pomaga nam się poprawić i dotrzeć do innych sprzedawców Shopify.',
      rating_tap: 'Dotknij gwiazdkę, aby ocenić',
      star: {
        terrible: 'Straszny',
        bad: 'Niedobry',
        average: 'Przeciętny',
        good: 'Dobry!',
        excellent: 'Doskonały! 🚀',
      },
      positive_title: 'Fantastycznie! Bardzo dziękuję 🎉',
      positive_desc: 'Zajmuje tylko 1 minutę!',
      negative_title: 'Dziękujemy za opinię 🙏',
      negative_desc: 'Masz pomysły na to, co moglibyśmy zrobić lepiej?',
      review_btn: '⭐ Zostaw recenzję',
      close_btn: 'Zamknij',
      dismiss: 'Nie pokazuj więcej',
      skip: 'Pomiń →',
    },
    support: {
      title: 'Wsparcie',
      send: 'Wyślij',
      placeholder: 'Napisz swoją wiadomość...',
    },
    editor: {
      placeholder: 'Pisz tutaj...',
      bold: 'Pogrubienie',
      italic: 'Kursywa',
      underline: 'Podkreślenie',
      h2: 'Nagłówek H2',
      h3: 'Nagłówek H3',
      paragraph: 'Akapit',
      ul: 'Lista punktowana',
      ol: 'Lista numerowana',
      blockquote: 'Cytat',
      link: 'Wstaw link',
      remove_format: 'Usuń formatowanie',
      link_prompt: 'URL linku',
    },
    recommendations: {
      empty: 'Brak krytycznych działań w tej chwili. Świetna robota!',
      filter_all_prio: 'Wszystkie priorytety',
      filter_all_cat: 'Wszystkie kategorie',
      count_shown: '{{n}} działań wyświetlonych',
      see: 'Zobacz',
      sev_high: 'Wysoki',
      sev_medium: 'Średni',
      sev_low: 'Niski',
      cat_catalog: 'Katalog',
      missing_meta_description: '{{count}} produktów bez opisu meta',
      missing_description: '{{count}} produktów bez opisu',
      missing_alt_text: '{{count}} obrazów bez tekstu ALT',
      missing_product_image: '{{count}} produktów bez zdjęcia',
    },
    audit: {
      not_detected: 'Nie wykryto',
      disabled: 'Wyłączony',
      not_scanned: 'Analiza nie przeprowadzona',
      status_warning: 'Ostrzeżenie',
      status_error: 'Błąd',
      cat_performance: 'Wydajność',
      cat_trust: 'Zaufanie',
      cat_catalog: 'Katalog',
      checks_suffix: 'sprawdzeń',
      badge_err: 'błąd',
      badge_warn: 'ostrzeż',
      badge_ok: 'ok',
      value_label: 'Wartość',
      checks: {
        title: { name: 'Tytuł', hint: 'Tytuł strony' },
        meta_description: { name: 'Meta opis', hint: 'Meta opis strony głównej' },
        h1: { name: 'H1', hint: 'Dokładnie 1 H1 na stronę jest optymalne' },
        h2: { name: 'H2', hint: 'Zalecany co najmniej jeden H2' },
        canonical: { name: 'Canonical', hint: 'Kanoniczny URL' },
        lang: { name: 'Język', hint: 'Atrybut języka' },
        json_ld_structured_data: { name: 'JSON-LD / Dane strukturalne', hint: 'Dane strukturalne' },
        open_graph: { name: 'Open Graph', hint: 'Meta społecznościowe' },
        twitter_card: { name: 'Twitter Card', hint: 'Meta Twitter/X' },
        robots_txt: { name: 'robots.txt', hint: 'Robots' },
        sitemap_xml: { name: 'Sitemap.xml', hint: 'Sitemap' },
        status_code: { name: 'Kod statusu', hint: 'Kod HTTP' },
        indexability: { name: 'Indeksowalność', hint: 'Indeksowalność' },
        redirects: { name: 'Przekierowania', hint: 'Końcowy URL' },
        https: { name: 'HTTPS', hint: 'HTTPS' },
        load_time: { name: 'Czas ładowania', hint: 'Mierzone serwer-serwer' },
        page_weight: { name: 'Rozmiar strony', hint: 'Rozmiar HTML strony głównej' },
        image_lazy_loading: { name: 'Lazy loading obrazów', hint: 'Obrazy lazy' },
        mobile_viewport: { name: 'Viewport mobilny', hint: 'Viewport mobilny' },
        favicon: { name: 'Favicon', hint: 'Favicon' },
        images_with_alt: { name: 'Obrazy z ALT', hint: 'Dostępność obrazów' },
        privacy_policy: { name: 'Polityka prywatności', hint: 'Prywatność' },
        cookie_policy: { name: 'Polityka cookies', hint: 'Cookie' },
        terms_conditions: { name: 'Regulamin', hint: 'Warunki' },
        contact_page: { name: 'Strona kontaktowa', hint: 'Kontakt' },
        shipping_policy: { name: 'Polityka wysyłki', hint: 'Wysyłka' },
        returns_refunds: { name: 'Zwroty i Refundacje', hint: 'Zwroty' },
        social_links: { name: 'Linki społecznościowe', hint: 'Social' },
        products_without_description: { name: 'Produkty bez opisu', hint: 'Opisy produktów' },
        products_without_images: { name: 'Produkty bez zdjęć', hint: 'Zdjęcia produktów' },
        products_without_meta_description: { name: 'Produkty bez opisu meta', hint: 'Opisy meta produktów' },
        duplicate_titles: { name: 'Zduplikowane tytuły', hint: 'Tytuły produktów' },
        duplicate_meta_descriptions: { name: 'Zduplikowane opisy meta', hint: 'Opisy meta produktów' },
        thin_content_200_char: { name: 'Cienka treść (<200 znaków)', hint: 'Treść produktu' },
      },
    },
    score_card: {
      pillar_technical_seo: 'Techniczne SEO',
      pillar_ux: 'UX',
      pillar_performance: 'Performance',
      pillar_trust: 'Trust',
      pillar_catalog: 'Katalog',
      label_excellent: 'Doskonały',
      label_good: 'Do poprawy',
      label_critical: 'Krytyczny',
      no_audit_desc: 'Audyt jeszcze nie uruchomiony — uruchom audyt, aby uzyskać Techniczne SEO, UX, Trust i Performance.',
      auditing: 'Audyt w toku...',
      run_audit: 'Uruchom Audyt Strony 360°',
      calculated_on: 'Obliczone dla',
    },
    upgrade: {
      popular: '⭐ Najpopularniejszy',
      period: '/miesiąc',
      plan_header: 'Plan',
      cta: 'Ulepsz do {{name}} — {{price}}{{period}}',
      dismiss: 'Nie teraz',
      feature_available: '{{feature}} jest dostępna od planu {{plan}}.',
      reason_credits_title: 'Kredyty AI wyczerpane',
      reason_credits_body: 'Osiągnąłeś miesięczny limit swojego planu. Ulepsz plan, aby kontynuować generowanie treści.',
      reason_products_title: 'Limit katalogu osiągnięty',
      reason_products_body: 'Twój katalog Shopify przekracza limit aktualnego planu. Ulepsz plan, aby zsynchronizować wszystkie produkty.',
      reason_feature_title: 'Funkcja Premium',
      reason_feature_body: 'Ta funkcja jest dostępna w wyższych planach.',
    },
    gsc: {
      connect_title: 'Połącz Google Search Console',
      connect_desc: 'Monitoruj wyświetlenia, kliknięcia, CTR i średnią pozycję. Żądaj ponownego indeksowania po optymalizacjach AI.',
      connect_feat_analytics: 'Analityka wyszukiwania',
      connect_feat_indexing: 'Monitorowanie indeksowania',
      connect_feat_keywords: 'Śledzenie słów kluczowych',
      connect_feat_sitemap: 'Menedżer mapy strony',
      connect_btn_loading: 'Łączenie...',
      connect_btn: 'Połącz konto Google',
      prop_modal_title: 'Wybierz właściwość',
      prop_modal_desc: 'Wybierz właściwość Search Console do połączenia.',
      prop_modal_empty: 'Nie znaleziono właściwości. Sprawdź, czy masz właściwości w Google Search Console.',
      prop_modal_cancel: 'Anuluj',
      prop_modal_confirm: 'Potwierdź',
      coming_soon_desc: 'Dostępne w {{phase}}',
      top_opp_title: 'Top możliwości SEO',
      top_opp_sub: 'Top 10 zapytań wg Opportunity Score',
      copy: 'Kopiuj',
      copied: 'Skopiowano!',
      badge_quick_win: '🔥 Quick Win',
      badge_low_ctr: '⚡ Niski CTR',
      badge_page_1: '🚀 Strona 1',
      badge_high_imp: '📈 Wysoka widoczność',
      badge_brand: '🏷️ Brand',
      qt_category: 'Kategoria',
      qt_product: 'Produkt',
      qt_generic: 'Ogólne',
      qt_info: 'Info',
      qt_brand: 'Brand',
      seo_analysis: 'Analiza SEO',
      generating_ai: 'Generowanie analizy AI...',
      analysis_error: 'Błąd generowania analizy. Spróbuj ponownie później.',
      estimated_value: 'Szacowana wartość',
      clicks_monthly: 'Potencjalne kliknięcia/miesiąc',
      ctr_at_pos: 'CTR na poz. {{pos}}',
      traffic_increase: 'Wzrost ruchu',
      current_stats: 'Obecne: {{clicks}} kliknięć/miesiąc · +{{pts}} pp szacowany CTR',
      priority_action: 'Działanie priorytetowe',
      content_opt: 'Optymalizacja treści',
      title_seo: 'Title SEO',
      title_chars: '(50–60 znaków)',
      title_copied: 'Title skopiowany!',
      h1_suggested: 'Sugerowany H1',
      h1_page_title: '(tytuł strony)',
      h1_copied: 'H1 skopiowany!',
      meta_desc: 'Meta Description',
      meta_chars: '(150–160 znaków)',
      meta_copied: 'Meta skopiowana!',
      faq_all_copied: 'Wszystkie FAQ skopiowane!',
      faq_suggested: 'Sugerowane FAQ',
      copy_all: 'Kopiuj wszystko',
      faq_copied: 'FAQ skopiowane!',
      related_kw: 'Powiązane słowa kluczowe',
      click_to_copy: '· kliknij aby skopiować',
      kw_copied: '"{{kw}}" skopiowane!',
      tech_suggestions: 'Sugestie techniczne',
      copy_keyword: 'Kopiuj słowo kluczowe',
      kw_copied_plain: 'Słowo kluczowe skopiowane!',
      shopify_products: 'Produkty Shopify',
      search_store: 'Szukaj w sklepie',
      optimize_content: 'Optymalizuj treść',
      col_impressions: 'Wyświetlenia',
      col_position: 'Pozycja',
      no_queries: 'Nie znaleziono zapytań z bieżącymi filtrami.',
      ai_panel_title: 'Sugestie AI',
      analyze_query: 'Analizuj zapytanie →',
      sugg_title_improvement: 'Title tag',
      sugg_meta: 'Meta description',
      sugg_content_gap: 'Brakująca treść',
      sugg_schema: 'Schema markup',
      sugg_links: 'Linki wewnętrzne',
      opp_load_err: 'Błąd ładowania możliwości SEO',
      cache_updated: 'Pamięć podręczna zaktualizowana — ponowne ładowanie danych',
      cache_error: 'Błąd odświeżania pamięci podręcznej',
      loading_data: 'Ładowanie danych Search Console...',
      load_error_title: 'Nie można załadować możliwości',
      retry: 'Spróbuj ponownie',
      tracked_queries: 'Śledzone zapytania',
      sku_excluded: '{{n}} SKU/EAN wykluczone',
      total_impressions: 'Łączne wyświetlenia (28d)',
      total_clicks: 'Łączne kliknięcia (28d)',
      avg_ctr: 'Średni CTR',
      ai_generating: 'Generowanie analizy AI...',
      ai_generating_sub: 'Sugestie AI pojawią się tutaj za chwilę.',
      no_ai_insights: 'Brak dostępnych wskazówek AI',
      no_ai_insights_sub: 'Nie znaleziono zapytań ze znaczącymi możliwościami optymalizacji.',
      filter_all: 'Wszystkie ({{n}})',
      search_placeholder: 'Szukaj zapytań...',
      refresh_title: 'Odśwież dane',
      page_prev: '← Poprz.',
      page_info: 'Str. {{page}} / {{total}} · {{count}} zapytań',
      page_next: 'Nast. →',
      footer_note: 'Dane Search Console z ostatnich 28 dni · cache 6h · właściwość: {{url}}',
      footer_excluded: ' · {{n}} SKU/EAN wykluczone',
      verdict_pass: 'Zindeksowana',
      verdict_fail: 'Niezindeksowana',
      verdict_neutral: 'Wykluczona',
      stato_title: 'Status Google — Źródła danych',
      in_sitemap: 'W sitemap',
      sitemap_registered_lbl: 'Zarejestrowane sitemapy',
      sitemap_errors_lbl: 'Błędy sitemapy',
      with_impressions: 'Z wyświetleniami',
      search_appear_note: 'Strony pojawiające się w wynikach · {{days}}d',
      not_real_indexed: '≠ strony faktycznie zindeksowane',
      index_estimate_lbl: 'Szacowanie indeksacji',
      estimate_unavail: 'Szacowanie dostępne po 200 sprawdzonych URL. Uruchom skanowanie wsadowe, aby zebrać próbkę.',
      inspected_lbl: 'Sprawdzone',
      indexed_confirmed: 'Potwierdzone zindeksowane',
      not_indexed_lbl: 'Niezindeksowane',
      excluded_lbl: 'Wykluczone',
      certain_data: 'Pewne dane dla sprawdzonych URL',
      batch_title: 'Skanowanie wsadowe — Inspection API',
      batch_priority: 'Priorytet Analytics',
      batch_progress: 'Postęp inspekcji sitemapy',
      batch_stopping: 'Zatrzymywanie…',
      batch_running: 'Skanowanie…',
      batch_starting: 'Uruchamianie...',
      batch_done_lbl: 'Sitemap ukończona ✓',
      batch_start_btn: 'Uruchom skanowanie ({{n}} dostępnych)',
      batch_timeout: 'Timeout — kliknij aby zresetować',
      batch_stopping_wait: 'Zatrzymywanie — proszę czekać…',
      batch_stop_btn: 'Zatrzymaj skanowanie',
      batch_remaining: '{{n}} URL do sprawdzenia',
      batch_quota_out: 'Dzienny limit wyczerpany — spróbuj jutro',
      batch_start_err: 'Błąd uruchamiania skanowania',
      batch_complete: 'Skanowanie zakończone: {{n}} URL sprawdzonych',
      dq_title: 'Szczegóły techniczne API',
      dq_api_status: 'Status API',
      dq_daily_quota: 'Dzienny limit',
      dq_used_today: 'Użyte dziś',
      dq_remaining: 'Pozostałe',
      dq_history: 'Historia inspekcji',
      dq_completion: 'Ukończenie',
      dq_days_est: 'szacowane dni',
      dq_start_for_eta: 'Uruchom skanowanie aby obliczyć ETA',
      sm_no_sitemap: 'Nie znaleziono sitemapy',
      sm_no_sitemap_desc: 'Dodaj sitemap.xml do Google Search Console, aby monitorować indeksację.',
      sm_submit_ok: 'Sitemap przesłana do Google',
      sm_in_progress: 'Obliczanie…',
      sm_submit_btn: 'Prześlij',
      insp_title: 'Sprawdź URL',
      insp_quota: '{{used}}/{{limit}} sprawdzeń dziś',
      insp_loading: 'Sprawdzanie...',
      insp_btn: 'Sprawdź',
      insp_domain_lbl: 'Domena property:',
      insp_domain_note: 'Sprawdzany URL musi do niej należeć',
      insp_last_crawl: 'Ostatni crawl',
      insp_indexing: 'Indeksacja',
      insp_yes: 'Tak',
      insp_no: 'Nie',
      insp_canonical_decl: 'Zadeklarowany canonical',
      insp_canonical_diff: '⚠ Canonical Google (inny)',
      insp_noindex: 'wykryto noindex',
      insp_open_gsc: 'Otwórz w Search Console',
      insp_err: 'Błąd inspekcji URL',
      cov_title: 'Coverage — Przyczyny',
      cov_real_data: 'Rzeczywiste dane — Inspection API',
      cov_conf_high: 'Wysoka wiarygodność',
      cov_conf_medium: 'Średnia wiarygodność',
      cov_conf_low: 'Niska wiarygodność',
      cov_updated: 'Zaktualizowano:',
      cov_deselect: 'Odznacz',
      cov_inspected_note: 'Sprawdzone URL · kliknij aby filtrować',
      cov_none_inspected: 'Brak inspekcji',
      cov_no_data: 'Brak danych coverage',
      cov_no_data_desc: 'Przyczyny braku indeksacji są budowane automatycznie przy każdej inspekcji URL. Uruchom automatyczne skanowanie, aby wypełnić tę sekcję.',
      cov_solution: 'Zalecane rozwiązanie',
      cov_filter_active: 'Filtr aktywny w historii',
      ih_worklist: 'Lista zadań SEO',
      ih_history: 'Historia inspekcji',
      ih_filter_coverage: 'Filtr Coverage',
      ih_tab_all: 'Wszystkie',
      ih_tab_not_ind: 'Niezind.',
      ih_tab_indexed: 'Zindeksowane',
      ih_tab_excluded: 'Wykluczone',
      ih_tab_errors: 'Błędy',
      ih_tab_with_imp: 'Z wyśw.',
      ih_tab_products: 'Produkty',
      ih_tab_collections: 'Kolekcje',
      ih_sort_priority: '↓ Priorytet',
      ih_sort_impressions: '↓ Wyświetlenia',
      ih_sort_clicks_est: '↓ Kliknięcia est.',
      ih_sort_date: '↓ Data',
      ih_sort_state: '↓ Stan GSC',
      ih_clear: 'Wyczyść',
      ih_search: 'Szukaj URL…',
      ih_open: 'Otwórz',
      ih_indexing_state: 'Status indeksacji',
      ih_canonical_diff: '⚠ Canonical Google (wybrany, inny)',
      ih_canonical_same: 'Canonical Google (taki sam)',
      ih_ai_fix: 'Optymalizuj z AI →',
      ih_total: '{{n}} URL · {{total}} łącznie',
      ih_est_clicks: '· +{{n}} kliknięć/mies. szac.',
      iai_title: 'Sugestie AI — Indeksacja',
      iai_filter_note: '· kliknij aby filtrować',
      iai_prio_high: 'Wysoki priorytet',
      iai_prio_medium: 'Średni priorytet',
      iai_prio_low: 'Niski priorytet',
      iai_causes: 'Możliwe przyczyny:',
      iai_actions: 'Zalecane działania:',
      fix_apply_all: 'Zastosuj wszystko',
      fix_applied: 'Zastosowano',
      fix_suggestion: 'Sugestia',
      fix_chars: 'znaków',
      fix_content_impr: 'Ulepszenia treści',
      fix_int_links: 'Sugerowane linki wewnętrzne',
      fix_open_url: 'Otwórz URL',
      fix_close: 'Zamknij',
      fix_seo_opt: 'Optymalizacja SEO',
      trend_title: 'Trend indeksacji',
      trend_updated: 'Zaktualizowano do',
      trend_coverage: 'Pokrycie',
      trend_30d_kpi: 'Trend 30d',
      trend_no_data: 'Dane historyczne w budowie',
      trend_no_data_desc: 'Trend będzie dostępny po zebraniu co najmniej 2 snapshotów.',
      trend_one_snap: '1 snapshot zebrany z 2.',
      trend_start_scan: 'Uruchom skanowanie wsadowe aby rozpocząć.',
      trend_ind: 'zind.',
      trend_not_ind: 'niezind.',
      trend_snap_note: 'Snapshot na skan',
      ic_loading: 'Ładowanie danych indeksacji...',
      ic_load_err: 'Nie można załadować danych indeksacji',
      ic_clear_confirm: 'Wyczyścić całą historię inspekcji?',
      ic_cleared: 'Historia wyczyszczona',
      ic_clear_err: 'Błąd czyszczenia',
      ic_seo_opp: 'Możliwości SEO — Executive Summary',
      ic_recoverable: 'URL do odzyskania',
      ic_open_worklist: '⚡ Otwórz listę zadań →',
      ic_view_all: 'Pokaż wszystkie →',
      ic_crawled_ni: 'Crawlowane – niezindeksowane',
      ic_crawled_ni_note: 'Google je zna, ale nie serwuje',
      ic_discovered_ni: 'Odkryte – niezindeksowane',
      ic_discovered_ni_note: 'Znalezione, ale nigdy nie crawlowane',
      ic_with_imp_ni: 'Z wyświetleniami GSC',
      ic_with_imp_ni_note: 'Mają ruch, ale nie są zindeksowane',
      ic_other_ni: 'Inne niezindeksowane',
      ic_other_ni_note: 'Nieznane Google lub błędy',
      ic_refresh: 'Odśwież',
      rh_title: 'Historia zmian',
      rh_versions: 'wersji',
      rh_confirm: "Przywrócić wersję z {{date}}?\n\nAktualne zmiany w edytorze zostaną zastąpione.",
      rh_restored_ok: 'v{{v}} przywrócona w motywie Shopify',
      rh_restored_editor: 'Wersja v{{v}} załadowana do edytora — kliknij Zapisz aby ją zastosować',
      rh_restore_err: 'Błąd przywracania',
      rh_current: 'bieżąca',
      rh_initial: 'Wersja początkowa',
      rh_no_diff: 'Brak zmian tekstowych',
      rh_more_added: '+ {{n}} więcej dodanych',
      rh_more_removed: '- {{n}} więcej usuniętych',
      rh_restore_btn: 'Przywróć',
      rb_load_err: 'Błąd ładowania robots.txt',
      rb_save_err: 'Błąd zapisu',
      rb_analyze_err: 'Błąd analizy',
      rb_score_good: 'Doskonały',
      rb_score_ok: 'Do poprawy',
      rb_score_bad: 'Krytyczny',
      rb_analysis_title: 'Analiza SEO Robots',
      rb_analyzing: 'Analizowanie…',
      rb_analyze: 'Analizuj',
      rb_analyze_hint: 'Kliknij "Analizuj" aby automatycznie wykryć problemy SEO i możliwości optymalizacji',
      rb_no_issues: 'Nie wykryto problemów',
      rb_no_issues_desc: 'Twój robots.txt jest zgodny z najlepszymi praktykami Shopify',
      rb_critical: 'KRYTYCZNY',
      rb_warning: 'OSTRZEŻENIE',
      rb_validation_title: 'Walidacja Robots.txt',
      rb_reload: 'Przeładuj',
      rb_editor_title: 'Edytor Robots.txt',
      rb_modified: 'Zmodyfikowano',
      rb_diff_close: 'Zamknij diff',
      rb_editor_restore: 'Przywróć',
      rb_saving: 'Zapisywanie…',
      rb_save: 'Zapisz',
      rb_blocking_warning: '🚨 BLOKUJESZ CAŁĄ WITRYNĘ — "Disallow: /" uniemożliwia Google indeksowanie jakiejkolwiek strony',
      rb_diff_preview: 'Podgląd zmian:',
      rb_opportunity: 'SZANSA',
      rb_checker_title: 'Sprawdź URL',
      rb_check_btn: 'Sprawdź',
      rb_allowed: 'Dozwolony',
      rb_blocked: 'Zablokowany',
      rb_sitemaps_title: 'Zadeklarowane mapy witryn',
      ll_history_title: 'Historia LLMs.txt',
      ll_generated: 'Wygenerowano',
      ll_restored_editor: 'Wersja v{{v}} załadowana do edytora — kliknij Opublikuj aby ją zastosować',
      ll_load_err: 'Błąd ładowania llms.txt',
      ll_generate_err: 'Błąd generowania',
      ll_saved_ok: 'LLMs.txt opublikowany i zweryfikowany w motywie Shopify',
      ll_not_configured: 'Nieskonfigurowany',
      ll_validation_title: 'Walidacja LLMs.txt',
      ll_not_found: 'Nie znaleziono llms.txt na stronie. Użyj "Generuj z Shopify" aby go automatycznie utworzyć.',
      ll_what_title: 'Co to jest LLMs.txt?',
      ll_what_desc: 'Standard /llms.txt to plik markdown, który pomaga modelom AI (ChatGPT, Claude, Perplexity, Gemini) zrozumieć Twoją witrynę i poprawnie ją cytować w odpowiedziach. Zwiększa widoczność w silnikach odpowiedzi AI.',
      ll_editor_title: 'Edytor LLMs.txt',
      ll_generating: 'Generowanie…',
      ll_generate_btn: 'Generuj z Shopify',
      tab_jsonld: 'JSON-LD',
      jl_load_err: 'Błąd ładowania przeglądu JSON-LD',
      jl_sec_overview: 'Przegląd',
      jl_sec_schemas: 'Schematy',
      jl_sec_problems: 'Problemy',
      jl_sec_generate: 'Optymalizacja AI',
      jl_sec_preview: 'Podgląd JSON',
      jl_sec_validate: 'Walidacja',
      jl_sec_bulk: 'Operacje masowe',
      jl_sec_stats: 'Statystyki',
      jl_rich_results: 'Kwalifikowalność Rich Results',
      jl_eligible: 'Kwalifikowalne',
      jl_warnings: 'Częściowe',
      jl_not_eligible: 'Niekwalifikowalne',
      jl_field_coverage: 'Pokrycie pól',
      jl_what_title: 'Co to jest JSON-LD?',
      jl_what_desc: 'JSON-LD to zalecany przez Google format danych strukturalnych. Umożliwia Rich Results w wyszukiwarce (gwiazdki, ceny, breadcrumbs) i pomaga modelom AI lepiej rozumieć Twoje produkty.',
      jl_score_poor: 'Słabe pokrycie',
      jl_schemas_title: 'Obsługiwane typy schematów',
      jl_status_valid: 'Poprawny',
      jl_status_partial: 'Częściowy',
      jl_status_missing: 'Nieskonfigurowany',
      jl_valid_items: 'poprawnych',
      jl_issues: 'problemów',
      jl_google_test: 'Testuj w Google Rich Results',
      jl_google_test_desc: 'Po wygenerowaniu JSON-LD przetestuj go bezpośrednio w narzędziu Google, aby sprawdzić kwalifikowalność.',
      jl_problems_title: 'Problemy diagnostyczne',
      jl_no_problems: 'Nie znaleziono problemów krytycznych. Twoje pokrycie JSON-LD wygląda dobrze!',
      jl_products_affected: 'produktów dotkniętych problemem',
      jl_sev_critical: 'Krytyczny',
      jl_sev_warning: 'Ostrzeżenie',
      jl_prob_brand: 'Brakująca marka / dostawca',
      jl_prob_desc: 'Brakujący opis',
      jl_prob_image: 'Brakujące zdjęcie produktu',
      jl_prob_sku: 'Brakujące SKU',
      jl_prob_gtin: 'Brakujący GTIN / kod kreskowy',
      jl_prob_meta: 'Brakujący meta opis',
      jl_prob_offers: 'Cena nie w JSON-LD (wymaga snippetu w motywie Shopify)',
      jl_problems_tip: 'Popraw brakujące pola w sekcji Produkty lub użyj optymalizacji AI.',
      jl_gen_title: 'Generuj JSON-LD',
      jl_schema_type: 'Typ schematu',
      jl_product_id: 'ID produktu (zostaw puste dla przykładu)',
      jl_use_ai: 'Użyj wzbogacania AI (GPT)',
      jl_gen_btn: 'Generuj JSON-LD',
      jl_gen_ok: 'JSON-LD wygenerowany',
      jl_gen_err: 'Błąd generowania',
      jl_copied: 'Skopiowano!',
      jl_copy: 'Kopiuj',
      jl_preview_title: 'Podgląd JSON-LD',
      jl_preview_err: 'Błąd ładowania podglądu',
      jl_load_preview: 'Załaduj przykładowy produkt',
      jl_preview_empty: 'Kliknij "Załaduj przykładowy produkt", aby wyświetlić podgląd wszystkich schematów JSON-LD',
      jl_val_title: 'Lokalna walidacja schematu',
      jl_invalid_json: 'Nieprawidłowy JSON',
      jl_val_btn: 'Waliduj JSON-LD',
      jl_val_clear: 'Wyczyść',
      jl_val_ok: 'Poprawny — kwalifikuje się do Rich Results',
      jl_val_fail: 'Walidacja nie powiodła się',
      jl_val_note: 'Ten walidator sprawdza wymagania schema.org. W przypadku oficjalnego testu Google użyj Rich Results Test.',
      jl_val_err: 'Błąd walidacji',
      jl_bulk_title: 'Operacje masowe',
      jl_bulk_gen: 'Generuj wszystko',
      jl_bulk_gen_desc: 'Twórz Product JSON-LD dla każdego produktu i zapisuj do bazy danych',
      jl_bulk_val: 'Waliduj wszystko',
      jl_bulk_val_desc: 'Uruchom walidację schema.org dla istniejącego JSON-LD',
      jl_bulk_fix: 'Napraw i wzbogać',
      jl_bulk_fix_desc: 'Odbuduj JSON-LD dla produktów z błędami',
      jl_bulk_started: 'Operacja masowa uruchomiona',
      jl_bulk_err: 'Błąd uruchamiania operacji masowej',
      jl_bulk_running: 'W toku',
      jl_bulk_done: 'Ukończono',
      jl_bulk_stop: 'Zatrzymaj',
      jl_bulk_stopped: 'Operacja masowa zatrzymana',
      jl_errors: 'błędów',
      jl_stat_total: 'Łączna liczba produktów',
      jl_stat_eligible: 'Kwalifikuje się do Rich Results',
      jl_stat_gen_today: 'Wygenerowano dzisiaj',
      jl_stat_fixed: 'Naprawiono dzisiaj',
      jl_coverage_by_type: 'Pokrycie według typu treści',
      jl_type: 'Typ',
      jl_total: 'Łącznie',
      jl_valid2: 'Poprawne',
      jl_missing2: 'Brakujące',

      ll_revert: 'Cofnij',
      ll_publishing: 'Publikowanie…',
      ll_publish: 'Opublikuj',
      lp_filter_url: 'Filtruj URL…',
      lp_copied: 'Skopiowano',
      lp_broken_empty: 'Nie wykryto uszkodzonych linków',
      lp_broken_empty_sub: 'Wszystkie URL-e sklepu są dostępne (404 / 410 / timeout)',
      lp_timeout: 'Timeout — brak odpowiedzi w ciągu 12s',
      lp_ratelimit_empty: 'Nie wykryto ograniczenia szybkości',
      lp_ratelimit_empty_sub: 'Serwer nie ograniczył żądań skanera',
      lp_ratelimit_note: 'Strona dostępna ale serwer odpowiedział 429 podczas skanowania',
      lp_server_empty: 'Nie wykryto błędów serwera',
      lp_server_empty_sub: 'Wszystkie URL-e odpowiadają poprawnie (brak 5xx)',
      lp_server_note: 'HTTP {{code}} — błąd po stronie serwera',
      lp_redirect_empty: 'Nie wykryto przekierowań',
      lp_redirect_total: 'Przekierowania łącznie',
      lp_chains: 'Łańcuchy (>1 hop)',
      lp_loops: 'Wykryte pętle',
      lp_chains_header: 'Łańcuchy przekierowań',
      lp_chains_badge: '{{n}} łańcuchy wielokrotne',
      lp_final_status: 'Status końcowy:',
      lp_canon_ok: 'Poprawny',
      lp_canon_miss: 'Brakujący',
      lp_canon_wrong: 'Błędny URL',
      lp_canon_cross: 'Cross-domain',
      lp_canon_redir: 'Canonical→przekierowanie',
      lp_canon_action_missing: 'Dodaj tag canonical w sekcji head strony.',
      lp_canon_action_wrong: 'Popraw canonical aby wskazywał na ostateczny URL tej strony.',
      lp_canon_action_cross: 'Canonical wskazuje na zewnętrzną domenę. Sprawdź czy to zamierzone czy błąd.',
      lp_canon_action_redir: 'Canonical wskazuje na URL który przekierowuje. Zaktualizuj z ostatecznym celem.',
      lp_canon_no_data: 'Dane canonical niedostępne — uruchom skanowanie',
      lp_canon_issues: 'Problemy Canonical ({{n}})',
      lp_canon_no_issues: 'Nie wykryto problemów canonical',
      lp_canon_sample: 'Przeanalizowana próbka: {{n}} URL z Twojego sklepu (produkty, kolekcje, strony, artykuły)',
      il_tab_orphans: 'Osierocone',
      il_tab_weak: 'Słabe linki',
      il_tab_deep: 'Głębokie strony',
      il_kpi_weak: 'Słabe linki ≤2',
      il_kpi_deep: 'Głębokie str.',
      il_orphan_empty: 'Brak osieroconych stron',
      il_orphan_empty_sub: 'Wszystkie strony mają co najmniej jeden link wewnętrzny',
      il_orphan_header: 'Strony bez linków przychodzących ({{n}})',
      il_weak_empty: 'Brak stron ze słabymi linkami',
      il_weak_empty_sub: 'Wszystkie strony mają 3+ linki wewnętrzne',
      il_weak_header: 'Strony z 1–2 linkami przychodzącymi ({{n}})',
      il_anchor_empty: 'Teksty kotwicy zoptymalizowane',
      il_anchor_empty_sub: 'Nie wykryto generycznych, pustych ani zduplikowanych kotwic',
      il_anchor_generic: 'Generyczne kotwice',
      il_anchor_generic_desc: 'Teksty jak "kliknij tutaj", "tutaj", "odkryj"',
      il_anchor_empty_type: 'Puste kotwice',
      il_anchor_empty_desc: 'Linki bez tekstu opisowego',
      il_anchor_dup: 'Zduplikowane kotwice',
      il_anchor_dup_desc: 'Ten sam tekst → różne URL-e',
      il_anchor_lbl_gen: 'Generyczny',
      il_anchor_lbl_empty: 'Pusty',
      il_anchor_lbl_dup: 'Duplikat',
      il_deep_empty: 'Brak zbyt głębokich stron',
      il_deep_empty_sub: 'Wszystkie strony są dostępne w ≤3 kliknięciach od strony głównej',
      il_deep_header: 'Strony >3 kliknięcia od strony głównej ({{n}})',
      il_deep_note: 'Strony z ∞ nie są dostępne przez linki wewnętrzne. Dodaj je do menu lub kolekcji.',
      il_hub_empty: 'Brak danych hub',
      il_hub_empty_sub: 'Uruchom skanowanie aby zidentyfikować strony hub',
      il_hub_header: 'Strony hub — najczęściej linkowane wewnętrznie',
      il_hub_count: '{{n}} przychodzące linki wewnętrzne',
      lm_active: 'Aktywny',
      lm_not_installed: 'Nie zainstalowany',
      lm_install_hint: 'Zainstaluj w motywie aby monitorować prawdziwą nawigację bez crawlingu',
      lm_refresh: 'Odśwież',
      lm_clear: 'Wyczyść dane',
      lm_remove: 'Usuń z motywu',
      lm_installing: 'Instalowanie…',
      lm_install: 'Zainstaluj w motywie',
      lm_tab_404: 'Błędy 404',
      lm_tab_redirect: 'Okazje przekierowań',
      lm_tab_top: 'Popularne strony',
      lm_kpi_visits: 'Wizyty łącznie',
      lm_kpi_404s: 'Prawdziwe błędy 404',
      lm_no_404: 'Nie wykryto błędów 404 przez użytkowników',
      lm_visits: 'wizyty',
      lm_theme_prefix: 'Motyw: ',
      lm_last_activity: 'Ostatnia aktywność: ',
      lm_no_activity: 'brak wizyt',
      lm_installed: 'Monitor zainstalowany w motywie "{{name}}"',
      lm_err_install: 'Błąd instalacji',
      lm_confirm_remove: 'Usunąć skrypt monitorujący z aktywnego motywu?',
      lm_removed: 'Skrypt usunięty z motywu',
      lm_err_remove: 'Błąd usuwania',
      lm_confirm_clear: 'Usunąć wszystkie zebrane dane monitoringu?',
      lm_cleared: 'Dane usunięte',
      lm_err_clear: 'Błąd usuwania danych',
      lm_modal_title: 'Utwórz przekierowanie 301',
      lm_modal_source: 'URL źródłowy (404)',
      lm_modal_dest: 'Cel',
      lm_redirect_created: 'Przekierowanie 301 utworzone w Shopify',
      lm_err_redirect: 'Błąd tworzenia przekierowania',
      lm_create_redirect: 'Utwórz przekierowanie',
      lm_creating: 'Tworzenie…',
      lm_cancel: 'Anuluj',
      lm_info_title: 'Jak działa Live Monitor',
      lm_info_1: 'Przycisk "Zainstaluj w motywie" automatycznie dodaje lekki skrypt do aktywnego motywu przez Shopify Themes API',
      lm_info_2: 'Dla każdej prawdziwej wizyty zbiera: URL, typ strony, linki wewnętrzne, błędy 404, wewnętrzny referrer',
      lm_info_3: 'Zero crawlingu — brak HTTP 429 — dane od prawdziwych odwiedzających w czasie rzeczywistym',
      lm_info_4: 'Stopniowo buduje mapę linków wewnętrznych i wykrywa osierocone strony',
      lm_no_redirect: 'Nie potrzeba przekierowania',
      lm_no_redirect_hint1: 'Live Monitor nie zarejestrował jeszcze wizyt. Okazje przekierowań pojawiają się gdy prawdziwi użytkownicy natrafiają na strony 404.',
      lm_no_redirect_hint2: 'W {{n}} przeanalizowanych wizytach żaden użytkownik nie napotkał stron 404. Doskonale!',
      lm_toolbar_ai: '{{count}} URL · {{ai}} z sugestią AI',
      lm_toolbar_ignored: '· {{n}} zignorowanych',
      lm_sort_visits: 'Wizyty',
      lm_sort_date: 'Data',
      lm_selected: '{{n}} zaznaczono',
      lm_no_match: 'brak automatycznego dopasowania',
      lm_create: 'Utwórz',
      lm_ignore: 'Ignoruj',
      lm_err: 'Błąd',
      lm_bulk_ignored: '{{n}} URL zignorowano',
      lm_bulk_created: '{{n}} przekierowań utworzono',
      lm_errors: 'błędy',
      ls_scan_started: 'Skanowanie uruchomione — zakończy się w tle',
      ls_scan_err: 'Błąd uruchamiania skanowania',
      ls_last_scan: 'Ostatnie skanowanie: {{date}} · {{n}} URL',
      ls_no_scan_desc: 'Nie wykonano skanowania — wykrywa uszkodzone linki, przekierowania, kanoniczne, strony osierocone',
      ls_scanning: 'Skanowanie…',
      ls_rescan: 'Skanuj ponownie',
      ls_start_scan: 'Uruchom skanowanie',
      ls_canonical_issues: 'Problemy kanoniczne',
      ls_scan_details: 'Szczegóły skanowania',
      ls_stat_total: 'URL łącznie',
      ls_stat_errors: 'Błędy',
      ls_no_scan: 'Nie wykonano skanowania',
      ls_no_scan_long: 'Uruchom skanowanie aby wykryć uszkodzone linki, łańcuchy przekierowań, problemy kanoniczne i strony osierocone bez linków przychodzących',
      ls_first_scan: 'Uruchom pierwsze skanowanie',
      db_gsc_connected: 'Google Search Console połączona!',
      db_gsc_err: 'Błąd połączenia GSC: {{code}}',
      db_props_err: 'Nie można załadować properties GSC',
      db_oauth_hint: 'Ukończ autoryzację Google w nowej karcie. Strona odświeży się automatycznie.',
      db_conn_err: 'Błąd połączenia GSC',
      db_prop_selected: 'Wybrano property: {{url}}',
      db_prop_err: 'Błąd wyboru property',
      db_confirm_disconnect: 'Rozłączyć Google Search Console?',
      db_disconnected: 'GSC rozłączona',
      db_disconnect_err: 'Błąd rozłączenia',
      db_connected: 'Search Console połączona',
      db_no_property: 'Nie wybrano property',
      db_not_connected: 'Nie połączono',
      db_connect_hint: 'Połącz GSC aby odblokować analitykę i monitoring',
      db_change_prop: 'Zmień property',
      db_disconnect: 'Rozłącz',
      db_connect: 'Połącz GSC',
      db_idx_subtitle: 'Jakość techniczna SEO & indeksowanie',
      db_lbl_gsc: 'GSC połączona',
      db_lbl_sitemap: 'Sitemaps przesłane',
      db_lbl_indexed: 'Zaindeksowane URL',
      db_health_real: 'Oparte na rzeczywistych danych Search Console',
      db_health_proxy: 'Oparte na jakości katalogu — połącz GSC dla prawdziwych danych',
      db_lbl_position: 'Pozycja',
      db_lbl_trend: 'Trend 28d',
      db_lbl_errors: 'Błędy',
      db_connect_score: 'Połącz GSC aby obliczyć score',
      db_proxy_note: 'Proxy katalogu',
      db_stat_excluded: 'Wykluczone URL',
      db_stat_seo_score: 'Średni score SEO',
      db_catalog_title: 'Kondycja katalogu',
      db_cat_alt: 'Tekst ALT obrazów',
      db_cat_keywords: 'Brakujące słowa kluczowe',
      db_cat_no_kw: '{{n}} produktów bez słów kluczowych',
      db_cat_count: '{{n}} / {{total}} produktów',
      tab_opportunities: 'Możliwości SEO',
      tab_indexing: 'Indeksowanie',
      locked_available: 'Dostępne od planu {{plan}}',
      locked_upgrade: 'Przejdź na plan {{plan}}',
      main_subtitle: 'Techniczne SEO · Indeksowanie · Analytics · Automatyzacja AI',
      phase_3: 'Faza 3',
      interval_all: 'Wszystko',
      click_monthly_est: 'szac. klikniec/mies.',
      fix_title_updated: 'Tag tytulu zaktualizowany',
      fix_meta_updated: 'Meta opis zaktualizowany',
      fix_both_updated: 'Tytul i meta opis zaktualizowane w Shopify',
      fix_apply_err: 'Blad aplikacji',
      rb_save_ok: 'Robots.txt zapisany i zweryfikowany w motywie Shopify',
      rb_draft_with_err: 'Wersja robocza zapisana ({{err}})',
      rb_draft_manual: 'Wersja robocza zapisana — postepuj zgodnie z instrukcjami',
      rb_critical_confirm: '🚨 KRYTYCZNE OSTRZEZENIE 🚨\n\nPlik robots.txt zawiera "Disallow: /" ktory CALKOWICIE BLOKUJE witryne:\nGoogle, Bing i wszystkie boty nie beda mogly indeksowac zadnej strony.\n\nMoze to spowodowac usuniecie witryny z wynikow wyszukiwania.\n\nCzy jestes ABSOLUTNIE PEWNY ze chcesz kontynuowac?',
      scan_err: 'Blad skanowania: {{msg}}',
      sm_send_err: 'Blad wysylania',
      unknown_err: 'Nieznany',
      dq_today: 'Dzisiaj',
      dq_7d: 'Ostatnie 7 dni',
      dq_30d: 'Ostatnie 30 dni',
      dq_daily_avg: 'Śred. dzienna',
      dq_at_pace: 'w tempie ~{{n}}/dzień',
      job_stopped: 'Zatrzymano przy {{n}} przetworzonych URL',
      job_inspected: '{{n}} sprawdzonych',
      job_errors: 'błędy',
      quota_remaining: 'Pozostały limit:',
      lk_trend: 'Trend indeksowania',
      lk_batch: 'Inspekcja wsadowa (masowe skanowanie URL)',
      lk_ai: 'Sugestie AI dotyczące indeksowania',
      footer_apis: 'Sitemaps API + Search Analytics + Inspection API',
      prod_status_lbl: 'Status:',
      prod_desc_lbl: 'Opis:',
      prod_missing: 'BRAK',
      state_disc: 'Odkryta',
      state_crawl: 'Crawlowana',
      insp_api_real: 'Inspection API ✓ rzeczywiste',
      sm_count: '{{n}} sitemapów',
      sm_reliability: 'Wiarygodność:',
      conf_high: 'Wysoka',
      conf_medium: 'Średnia',
      conf_low: 'Niska',
      sm_urls: 'URL-e w sitemap',
      sm_sample: 'Próbka',
      sm_est_indexed: 'Szac. zindeksowane',
      sm_est_nonidx: 'Szac. niezindeksowane',
      sm_coverage: 'Szac. pokrycie ⓘ',
      sm_idx_of: '~{{n}} zindeksowanych z {{t}} URL-i sitemap',
      sm_cov_est: 'Szac. pokrycie:',
      sm_margin_err: 'margines błędu',
      sm_indexed_of: 'zindeksowanych z',
      sm_sampled: 'próbkowanych',
      sm_th_sitemap: 'Sitemap',
      sm_th_submitted: 'Przesłane',
      sm_th_indexed: 'Zindeksowane',
      sm_th_gap: 'Luka',
      sm_th_coverage: 'Pokrycie',
      sm_th_warning: 'Ostrzeżenie',
      sm_th_errors: 'Błędy',
      sm_th_lastmod: 'Ostatnia aktualizacja',
      sm_th_actions: 'Akcje',
      rb_verified_result: 'Zapisano i zweryfikowano w motywie Shopify ({{theme}}) — plik:',
      rb_draft_result: 'Wersja robocza zapisana. Aby zastosować ręcznie: Shopify Admin → Motywy → Edytuj kod →',
      ll_draft_result: 'Wersja robocza zapisana. Aby zastosować ręcznie: Shopify Admin → Motywy → Edytuj kod →',
      ls_section_redirects: 'Menedżer przekierowań',
      rm_tab: 'Menedżer przekierowań',
      rm_subtitle: 'Zarządzaj wszystkimi przekierowaniami sklepu w jednym miejscu.',
      rm_kpi_total: 'Wszystkie reguły',
      rm_kpi_active: 'Aktywne przekierowania',
      rm_kpi_pending: 'Oczekujące 404',
      rm_kpi_hits: 'Trafienia (30d)',
      rm_kpi_chains: 'Łańcuchy',
      rm_kpi_loops: 'Pętle',
      rm_section_rules: 'Reguły',
      rm_section_suggest: 'Sugestie AI',
      rm_section_health: 'Kondycja',
      rm_section_import: 'Import / Eksport',
      rm_section_history: 'Historia',
      rm_create_title: 'Utwórz przekierowanie',
      rm_edit_title: 'Edytuj przekierowanie',
      rm_old_url: 'Stary URL',
      rm_new_url: 'Nowy URL',
      rm_old_url_ph: '/stara-ścieżka',
      rm_new_url_ph: '/nowa-ścieżka',
      rm_type: 'Typ',
      rm_type_301: '301 – Stałe',
      rm_type_302: '302 – Tymczasowe',
      rm_notes: 'Notatki',
      rm_save: 'Zapisz',
      rm_cancel: 'Anuluj',
      rm_create_ok: 'Przekierowanie utworzone pomyślnie.',
      rm_edit_ok: 'Przekierowanie zaktualizowane pomyślnie.',
      rm_create_err: 'Błąd podczas tworzenia przekierowania.',
      rm_edit_err: 'Błąd podczas zapisywania przekierowania.',
      rm_dup_err: 'Przekierowanie dla tego źródłowego URL już istnieje.',
      rm_empty_err: 'Źródłowy i docelowy URL są wymagane.',
      rm_same_err: 'Źródłowy i docelowy URL nie mogą być takie same.',
      rm_search_ph: 'Szukaj URL…',
      rm_filter_all: 'Wszystkie',
      rm_filter_active: 'Aktywne',
      rm_filter_disabled: 'Wyłączone',
      rm_create_btn: 'Utwórz przekierowanie',
      rm_selected_items: '{{count}} zaznaczonych',
      rm_bulk_enable: 'Włącz',
      rm_bulk_disable: 'Wyłącz',
      rm_bulk_delete: 'Usuń',
      rm_bulk_export: 'Eksportuj CSV',
      rm_bulk_ok: 'Operacja zakończona.',
      rm_table_old: 'Stary URL',
      rm_table_new: 'Nowy URL',
      rm_table_type: 'Typ',
      rm_table_hits: 'Trafienia',
      rm_table_status: 'Status',
      rm_table_actions: 'Akcje',
      rm_edit: 'Edytuj',
      rm_duplicate: 'Duplikuj',
      rm_delete: 'Usuń',
      rm_delete_confirm: 'Usunąć to przekierowanie?',
      rm_deleted_ok: 'Przekierowanie usunięte.',
      rm_delete_err: 'Błąd podczas usuwania.',
      rm_status_active: 'Aktywne',
      rm_status_disabled: 'Wyłączone',
      rm_no_data: 'Nie znaleziono przekierowań.',
      rm_empty_state: 'Brak przekierowań. Utwórz pierwsze.',
      rm_total_redirects: '{{count}} przekierowań łącznie',
      rm_import_title: 'Importuj przekierowania',
      rm_import_csv: 'CSV (old_url,new_url,type)',
      rm_import_shopify: 'Shopify Export CSV',
      rm_import_sf: 'Screaming Frog CSV',
      rm_import_btn: 'Importuj',
      rm_import_ok: 'Import zakończony.',
      rm_import_err: 'Błąd podczas importu.',
      rm_import_imported: '{{count}} zaimportowanych',
      rm_import_skipped: '{{count}} pominiętych',
      rm_export_title: 'Eksportuj przekierowania',
      rm_export_desc: 'Pobierz wszystkie przekierowania w dostępnych formatach.',
      rm_export_csv: 'Eksportuj CSV',
      rm_export_json: 'Eksportuj JSON',
      rm_ai_title: 'Sugestie AI',
      rm_ai_subtitle: 'AI wykryło URL 404 i sugeruje przekierowania do podobnych produktów.',
      rm_ai_accept: 'Akceptuj',
      rm_ai_reject: 'Odrzuć',
      rm_ai_accept_all: 'Akceptuj wszystkie',
      rm_ai_loading: 'Analizowanie…',
      rm_ai_empty: 'Brak sugestii w tej chwili.',
      rm_chains_title: 'Łańcuchy przekierowań',
      rm_chains_desc: 'Wiele połączonych przekierowań spowalnia witrynę.',
      rm_chains_fix: 'Napraw łańcuch',
      rm_chains_empty: 'Nie wykryto łańcuchów.',
      rm_chains_fixed: 'Łańcuch naprawiony.',
      rm_loops_title: 'Pętle przekierowań',
      rm_loops_desc: 'Cyrkularne pętle powodują błędy. Wymagana ręczna korekta.',
      rm_loops_fix: 'Napraw',
      rm_loops_empty: 'Nie wykryto pętli.',
      rm_gsc_title: '404 z Google Search Console',
      rm_gsc_subtitle: 'Adresy URL nie znalezione wykryte przez GSC w ciągu ostatnich 90 dni.',
      rm_gsc_empty: 'Nie wykryto 404 GSC.',
      rm_history_title: 'Historia aktywności',
      rm_history_created: 'Utworzono',
      rm_history_edited: 'Edytowano',
      rm_history_deleted: 'Usunięto',
      rm_history_disabled: 'Wyłączono',
      rm_history_enabled: 'Włączono',
      rm_history_imported: 'Zaimportowano',
      rm_history_bulk: 'Operacja masowa',
      rm_history_empty: 'Brak zarejestrowanej aktywności.',
      rm_sync_shopify: 'Synchronizuj z Shopify',
      rm_sync_shopify_desc: 'Importuj wszystkie przekierowania URL z Shopify. Nowe przekierowania są automatycznie wysyłane do Shopify.',
      rm_sync_btn: 'Synchronizuj teraz',
      error_label: 'Błąd:',
      rb_checker_desc: 'Sprawdź, czy URL jest dozwolony lub zablokowany przez {{bot}} na podstawie aktualnego robots.txt.',
      rb_rule: 'Reguła:',
      rb_fix: 'Popraw:',
      rb_gsc_note_title: 'Integracja Search Console',
      rb_gsc_note_body: 'W sekcji Indeksowanie adresy URL ze statusem "Zablokowany przez robots" wskazują strony, których Google nie może indeksować.',
      rb_issues: 'problemy',
      rb_opps: 'możliwości',
      rb_savings: 'Szacowane oszczędności:',
      never: 'Nigdy',
      samples_conf: '{{n}} próbek · pewność {{c}}',
      batch_priority_note: 'URL-e z wyświetleniami Analytics sprawdzane jako pierwsze · limit GSC 2000/dzień · przetwarzanie w tle',
      sm_samples: 'próbek',
      sm_footnote_ec: '~ Wartości "W trakcie" = szacunek z Inspection API ({{n}} próbek · pewność {{c}}). Sitemaps API zwraca 0 dla indeksów sitemap.',
      sm_footnote_noec: '~ Wartości "W trakcie" = szacunek proporcjonalny. Uruchom skan wsadowy. Sitemaps API zwraca 0 dla indeksów sitemap.',
      ic_quota_note: 'Obliczone na {{n}} URL-ach sprawdzonych przez Inspection API (limit 2000/dzień). GSC Coverage pokazuje {{m}} nieindeksowanych URL-i w sitemap.',
      cov_crawled_ni: 'Niska jakość lub duplikat treści. Popraw treść, dodaj unikalny tekst, sprawdź tag canonical.',
      cov_disc_ni: 'Google ją znalazło, ale jeszcze nie zindeksowało. Zwiększ budżet crawlowania za pomocą dodatkowych linków wewnętrznych i zaktualizowanej mapy witryny.',
      cov_dup_nocanon: 'Dodaj tag canonical wskazujący na stronę główną.',
      cov_dup_googcanon: 'Google ignoruje zadeklarowany canonical. Sprawdź spójność URL i canonical między wersjami desktop/mobile.',
      cov_redirect: 'Aktywne przekierowanie. Jeśli zamierzone, zaktualizuj linki wewnętrzne, aby wskazywały bezpośrednio na cel.',
      cov_alternate: 'Alternatywna strona z poprawnym canonical — nie wymagana żadna akcja, jeśli zamierzona.',
      cov_noindex: 'Usuń meta tag noindex, jeśli chcesz, aby strona była indeksowana.',
      cov_robots: 'Strona zablokowana przez robots.txt. Sprawdź dyrektywy Disallow i zaktualizuj w razie potrzeby.',
      cov_removed: 'Ręcznie usunięta z GSC. Cofnij usunięcie w panelu Search Console, jeśli jest to pożądane.',
      cov_404: 'Strona nie znaleziona. Przywróć stronę, ustaw przekierowanie 301 lub usuń linki wewnętrzne do tego URL.',
      cov_soft404: 'Serwer zwraca 200, ale Google traktuje ją jako pustą stronę. Upewnij się, że strona ma odpowiednią treść.',
      cov_server_err: 'Błąd serwera. Sprawdź logi serwera i dostępność hostingu podczas indeksowania.',
      cov_unknown_url: 'Google jeszcze nie odkryło tego URL. Dodaj linki wewnętrzne, zaktualizuj mapę witryny i poczekaj na następny crawl.',
      qt_brand: 'Marka',
      qt_info: 'Info',
      qt_category: 'Kategoria',
      qt_product: 'Produkt',
      qt_generic: 'Ogólny',
      sugg_title_improvement: 'Tag tytułu',
      sugg_meta: 'Meta opis',
      sugg_content_gap: 'Brakująca treść',
      sugg_schema: 'Znaczniki schema',
      sugg_links: 'Linki wewnętrzne',
      verdict_indexed: 'Zaindeksowany',
      verdict_not_indexed: 'Niezaindeksowany',
      verdict_excluded: 'Wykluczony',
      badge_col_header: 'Odznaka',
      sitemap_label: 'Mapa witryny',
      ls_tab_broken: 'Uszkodzone linki',
      ls_tab_redirect: 'Przekierowanie',
      ls_tab_rate_limited: 'Ograniczenie szybkości',
      ls_tab_server_errors: 'Błędy serwera',
      ls_tab_canonical: 'Kanoniczny',
      ls_tab_internal: 'Linki wewnętrzne',
      ls_section_monitor: 'Monitor na żywo',
      ls_section_audit: 'Struktura witryny',
      db_idx_title: 'Wynik indeksowania',
      db_health_title: 'Wynik zdrowia SC',
      canonical_mismatch: 'Niezgodność kanoniczna',
    },
    so: {
      load_err: 'Błąd ładowania Speed Optimizer',
      analyze_timeout: 'Przekroczono czas analizy (90s) — spróbuj ponownie',
      analyze_done: 'Analiza zakończona!',
      analyze_failed: 'Analiza nie powiodła się: {{error}}',
      rate_limited: 'Osiągnięto limit żądań — dane zaktualizowane z pamięci podręcznej',
      analyze_err: 'Błąd analizy',
      opt_enabled: '{{label}} włączony w motywie',
      opt_disabled: '{{label}} wyłączony',
      opt_err: 'Błąd optymalizacji',
      scan_err: 'Błąd skanowania motywu',
      img_err: 'Błąd analizy obrazów',
      sg_protected: 'Safety Guard: Protected włączony',
      sg_standard: 'Safety Guard: Standard włączony',
      mode_err: 'Błąd zmiany trybu',
      plan_err: 'Błąd generowania planu',
      strategy_applied: 'Strategia {{label}} zastosowana do motywu',
      strategy_err: 'Błąd stosowania strategii',
      sessions_err: 'Błąd ładowania sesji',
      rollback_done: 'Rollback zakończony — motyw przywrócony',
      rollback_err: 'Błąd rollbacku',
      subtitle: 'Bezpieczne optymalizacje motywu Shopify z natychmiastowym rollbackiem.',
      btn_rollback: 'Cofnij wszystko',
      btn_analyze: 'Analizuj teraz',
      analyzing_psi: 'Przetwarzanie PSI…',
      analyzing_queue: 'W kolejce…',
      analyzing: 'Analizowanie…',
      alert_no_token: 'Brak tokena Shopify — optymalizacje wymagają aktywnego połączenia ze sklepem.',
      alert_no_scope: 'Brak uprawnień motywu — aby zastosować optymalizacje, musisz ponownie zainstalować aplikację.',
      perf_empty: 'Brak dostępnej analizy',
      perf_empty_hint: 'Kliknij "Analizuj teraz" aby zmierzyć wydajność swojego sklepu',
      suggestions: 'Sugestie',
      strategy_active: 'aktywna',
      strategy_subtitle: 'Definiuje cel optymalizacji. Kliknij, aby zobaczyć plan przed zastosowaniem.',
      sg_header: 'Ogranicza jakie operacje strategia może wykonać.',
      sg_desc_protected: 'Blokuje operacje Standard — tylko bezpieczne optymalizacje.',
      sg_desc_standard: 'Umożliwia pełne wykonanie wybranej strategii.',
      quick_opts: 'Szybkie optymalizacje',
      sg_warning: 'Safety Guard: Protected — operacje Standard są zablokowane. Przełącz na Standard powyżej.',
      lcp_section: 'Skanowanie motywu LCP',
      hist_section: 'Historia optymalizacji',
      hist_empty: 'Brak dotychczas zastosowanych optymalizacji.',
      sessions_section: 'Sesje & Wpływ Lighthouse',
      sessions_empty: 'Załaduj sesje, aby zobaczyć rzeczywisty wpływ na Core Web Vitals.',
      img_count: '{{n}} obrazów · {{kb}} KB łącznie',
      img_oversized: '{{n}} obrazów >300KB',
      img_no_oversized: 'Brak zbyt dużych obrazów — świetnie!',
      img_empty: 'Kliknij "Analizuj obrazy" aby znaleźć obrazy >300KB w motywie.',
      btn_refresh: 'Odśwież',
      btn_load_sessions: 'Załaduj sesje',
      btn_refresh_sessions: 'Odśwież',
      btn_analyze_img: 'Analizuj obrazy',
      btn_refresh_img: 'Odśwież',
      modal_risk_safe: 'Bezpieczne — brak oczekiwanego wpływu wizualnego',
      modal_risk_medium: 'Sprawdź wygląd strony po aktywacji',
      modal_risk_high: 'Może wpłynąć na zaawansowane funkcje',
      modal_reversible: 'Odwracalne w dowolnym momencie — użyj "Cofnij wszystko" aby przywrócić oryginalny motyw.',
      modal_cancel: 'Anuluj',
      modal_enable: 'Aktywuj teraz',
      opt_no_token: 'Ponownie połącz sklep Shopify aby korzystać z tej funkcji',
      opt_blocked_guard: 'Zablokowane przez Safety Guard (Protected) — przełącz na Standard aby włączyć',
      opt_reversible: 'odwracalne',
      opt_blocked_label: 'Zablokowane przez Safety Guard — przełącz na Standard',
      scan_scanning: 'Skanowanie w toku...',
      scan_empty_title: 'Skanowanie motywu niewykonane',
      scan_empty_desc: 'Identyfikuje sekcje hero i slideshow w motywie, aby umożliwić optymalizacje LCP po stronie serwera.',
      scan_btn: 'Skanuj motyw',
      scan_active_theme: 'Aktywny motyw',
      scan_files: '{{n}} pliki Liquid przeskanowane · {{s}} sekcji LCP zidentyfikowanych',
      scan_hero_label: 'sekcja hero/LCP',
      scan_optimized: 'zoptymalizowany',
      scan_no_lcp: 'Brak automatycznie zidentyfikowanych sekcji hero/LCP w motywie.',
      scan_reload: 'Odśwież',
      plan_title: 'Plan: {{label}}',
      plan_ops: '{{n}} zaplanowanych operacji',
      plan_action_enabled: 'już aktywna',
      plan_action_enable: 'włącz',
      plan_action_disable: 'wyłącz',
      plan_strategy: 'Strategia: ',
      plan_guard: 'Safety Guard: ',
      plan_active_ops: 'Aktywne operacje: ',
      plan_blocked: '{{n}} zablokowanych przez Safety Guard',
      plan_low_conf: 'Niektóre optymalizacje mają niską pewność dla wykrytego motywu.',
      plan_cancel: 'Anuluj',
      plan_apply: 'Zastosuj strategię',
      plan_blocked_btn: 'Zablokowane (niski score)',
      hist_rollback: 'Pełny rollback — wszystkie optymalizacje usunięte',
      hist_enabled: 'włączona',
      hist_disabled: 'wyłączona',
      hist_active: 'aktywnych',
      sess_no_sessions: 'Brak zarejestrowanych sesji optymalizacji. Sesje są tworzone po zastosowaniu strategii.',
      sess_waiting: 'oczekuje na PSI',
      strategy_label: 'Strategia {{s}}',
      strategy_opts: '{{n}} optymalizacji',
      strategy_active: 'AKTYWNA',
      quota_err: 'Błąd ładowania limitu PSI',
      quota_api_key: 'Klucz API skonfigurowany:',
      quota_yes: '✓ TAK',
      quota_no: '✗ NIE (publiczny limit)',
      quota_cache_ttl: 'Cache TTL:',
      quota_hourly: 'Limit godzinowy:',
      quota_daily: 'Limit dzienny:',
      quota_success: 'Sukcesy dzisiaj:',
      quota_hit_ratio: 'Współczynnik trafień cache:',
      quota_circuit: 'Wyłącznik obwodowy:',
      quota_circuit_open: 'OTWARTY ({{n}} awarii)',
      quota_circuit_closed: 'zamknięty',
      quota_loading: 'Ładowanie...',
      diag_err: 'Błąd diagnostyki',
      diag_refresh: 'Odśwież',
      diag_load: 'Załaduj diagnostykę',
      diag_patches: 'Aktywne łatki ({{n}})',
      diag_none: 'brak',
      diag_unavailable: 'niedostępne',
      diag_no_patches: 'Brak aktywnych łatek',
      diag_calibrated: '📈 skalibrowany',
      diag_generated: 'Wygenerowano:',
      badge_server_side: 'PO STRONIE SERWERA',
      badge_standard: 'STANDARD',
      badge_lcp: 'LCP',
      badge_critical: 'KRYTYCZNY',
      badge_safe: 'BEZPIECZNY',
      badge_medium: 'ŚREDNI',
      badge_safety_guard: 'Strażnik bezpieczeństwa',
      diag_theme_fingerprint: 'Odcisk palca motywu',
      diag_engine_confidence: 'Pewność silnika',
      perf_score_label: 'Wynik wydajności',
      section_perf_overview: 'Przegląd wydajności',
      section_strategy_intent: 'Zamiar strategii',
      safety_guard_title: 'Strażnik bezpieczeństwa',
      section_script_analyzer: 'Analizator wpływu skryptów',
      script_col_file: 'Plik',
      script_col_size: 'Rozmiar',
      script_col_impact: 'Wpływ',
      script_col_defer_risk: 'Ryzyko opóźnienia',
      metric_js_total: 'Łączny JS',
      metric_css_total: 'Łączny CSS',
      perf_updated: 'Zaktualizowano:',
      perf_stale: 'nieaktualne dane (PSI niedostępne)',
      perf_from_cache: 'z pamięci podręcznej',
      perf_psi_ok: 'PSI OK',
      debug_invalid_token_title: 'Nieprawidłowy token (401) — token w MongoDB wygasł lub został odwołany.',
      debug_reconnect_desc: 'Callback OAuth NIE nadpisał tokenu po ostatniej reinstalacji. Kliknij przycisk poniżej, aby rozpocząć nowy OAuth.',
      debug_reconnect_btn: 'Ponownie połącz OAuth teraz (otwiera Shopify)',
      debug_reconnect_note: 'Po zatwierdzeniu uprawnień na Shopify, callback automatycznie zaktualizuje token w MongoDB.',
    },
    drafts: {
      approved: 'Wersja robocza zatwierdzona!',
      approve_err: 'Błąd zatwierdzania',
      published: 'Opublikowano w Shopify!',
      publish_err: 'Błąd publikacji',
      title: 'Wersje robocze i wyniki',
      subtitle: 'Przeglądaj, zatwierdzaj i publikuj zoptymalizowane treści',
      empty: 'Brak wersji roboczych do przejrzenia',
      empty_hint: 'Generuj treści AI, aby tworzyć nowe wersje robocze',
      badge_approved: 'Zatwierdzone',
      badge_draft: 'Wersja robocza',
      field_desc: 'Opis',
      btn_view: 'Wyświetl',
      btn_approve: 'Zatwierdź',
      btn_publish: 'Opublikuj',
      modal_title: 'Szczegóły wersji roboczej',
      chars_seo: '/60 znaków',
      chars_meta: '/160 znaków',
      not_present: 'Nie ma',
      not_present_pl: 'Nie ma',
      btn_close: 'Zamknij',
      btn_publish_shopify: 'Opublikuj w Shopify',
      seo_title: 'Tytuł SEO',
      meta_description: 'Meta opis',
      keywords_label: 'Słowa kluczowe',
    },
    usage: {
      title: 'Użycie i Plan',
      subtitle: 'Monitoruj użycie i zarządzaj subskrypcją',
      plan_badge: 'Plan:',
      current: 'Bieżące użycie',
      credits: 'Kredyty AI',
      used: 'Wykorzystane:',
      unlimited: 'Nieograniczone ∞',
      remaining: 'Pozostałe: {{n}}',
      products_sync: 'Zsynchronizowane produkty',
      plans_heading: 'Dostępne plany',
      most_popular: '⭐ Najpopularniejszy',
      active_plan: 'Aktywny plan',
      current_plan: 'Bieżący plan',
      btn_upgrade: 'Upgrade do {{name}}',
      trend_heading: 'Trend użycia',
      trend_coming: 'Wykres użycia (wkrótce)',
      stat_products: 'Przeanalizowane produkty',
      stat_content: 'Wygenerowane treści',
      stat_translations: 'Tłumaczenia',
      stat_images: 'Zoptymalizowane obrazy',
    },
    support: {
      msg_sent: 'Wiadomość wysłana!',
      msg_err: 'Błąd wysyłania wiadomości',
      status_open: 'Otwarte',
      status_progress: 'W toku',
      status_closed: 'Zamknięte',
      title: 'Wsparcie',
      subtitle: 'FAQ, przewodniki i czat z naszym zespołem',
      faq_heading: 'Często zadawane pytania',
      guide_heading: 'Szybki przewodnik',
      chat_heading: 'Czat wsparcia',
      no_msgs: 'Brak wiadomości',
      no_msgs_hint: 'Rozpocznij rozmowę z pomocą techniczną',
      placeholder: 'Napisz wiadomość...',
      contacts_heading: 'Kontakty',
      contact_hours_label: 'Godziny',
      contact_hours: 'Pon-Pt 9:00-18:00 CET',
      contact_response_label: 'Czas odpowiedzi',
      contact_response: 'W ciągu 24 godzin',
      guide_step1: 'Przejdź do sekcji',
      guide_products: 'Produkty',
      guide_step1b: 'aby zobaczyć swoje produkty',
      guide_step2: 'Wybierz produkt i przejdź do',
      guide_ai_content: 'Treści AI',
      guide_step3: 'Wygeneruj opis, tytuł SEO, meta opis i słowa kluczowe',
      guide_step4: 'Sprawdź wyniki w',
      guide_history: 'Historia',
    },
    transl: {
      load_err: 'Błąd ładowania elementów',
      published: 'Tłumaczenie opublikowane w Shopify!',
      pub_err: 'Błąd publikacji',
      err_no_items: 'Wybierz co najmniej jeden element',
      err_no_fields: 'Wybierz co najmniej jedno pole do przetłumaczenia',
      item_err: 'Błąd tłumaczenia',
      done_one: 'Tłumaczenie ukończone!',
      done_many: '{{n}} elementów przetłumaczonych!',
      copied: 'Skopiowano do schowka',
      title: 'Tłumaczenia',
      gate_plan: 'Dostępne od planu Starter',
      gate_desc: 'Tłumacz produkty, kolekcje i artykuły na 8 języków z AI',
      gate_btn: 'Przejdź do planu Starter',
      subtitle: 'Tłumacz produkty, kolekcje, artykuły i strony na wiele języków z AI',
      translating: 'Tłumaczenie…',
      search_placeholder: 'Szukaj po tytule…',
      select_page: 'Wybierz stronę',
      sel_abbrev: 'wybr.',
      total_items: 'łącznie',
      loading: 'Ładowanie…',
      no_results: 'Brak wyników dla tego wyszukiwania',
      prev: '← Poprz',
      tot_abbrev: 'łącz.',
      next: 'Nast →',
      deselect_all: 'Odznacz wszystko',
      lang_heading: 'Język docelowy',
      fields_heading: 'Pola do przetłumaczenia',
      select_hint: 'Wybierz elementy z listy, aby włączyć tłumaczenie',
      results_heading: 'Wyniki',
      clear_results: 'Wyczyść wyniki',
      badge_published: 'Opublikowano',
      publishing: 'Publikowanie…',
      done: 'Gotowe',
      publish: 'Opublikuj',
      copy: 'Kopiuj',
      tab_products: 'Produkty',
      tab_collections: 'Kolekcje',
      tab_articles: 'Artykuły',
      tab_pages: 'Strony',
      field_title: 'Tytuł',
      field_description: 'Opis',
      field_seo_title: 'SEO Title',
      field_meta_description: 'Meta Description',
      field_body_html: 'Opis / Treść',
      empty_hint_select: 'Wybierz jeden lub więcej elementów, wybierz język i kliknij',
      translate_label: 'Przetłumacz',
      items_selected: 'elementów',
      item_selected: 'element',
      selected_label: 'wybranych',
      choose_fields_hint: 'wybierz pola i kliknij Przetłumacz',
    },
  },

  ar: {
    nav: {
      overview: 'نظرة عامة',
      catalog: 'الكتالوج',
      content: 'محتوى الذكاء الاصطناعي',
      translations: 'الترجمات',
      images: 'الصور',
      batch: 'العمليات الدفعية',
      speed: 'محسّن السرعة',
      history: 'السجل',
      usage: 'الاستخدام والخطة',
      settings: 'الإعدادات',
      support: 'الدعم',
    },
    common: {
      save: 'حفظ',
      cancel: 'إلغاء',
      delete: 'حذف',
      close: 'إغلاق',
      confirm: 'تأكيد',
      loading: 'جارٍ التحميل...',
      error: 'خطأ',
      success: 'نجاح',
      search: 'بحث',
      filter: 'تصفية',
      all: 'الكل',
      yes: 'نعم',
      no: 'لا',
      back: 'رجوع',
      next: 'التالي',
      apply: 'تطبيق',
      generate: 'توليد',
      publish: 'نشر',
      optimize: 'تحسين',
      refresh: 'تحديث',
    },
    settings: {
      title: 'الإعدادات',
      subtitle: 'مركز التحكم بالذكاء الاصطناعي',
      tabs: {
        general: 'عام',
        localization: 'التوطين',
        ai_engine: 'محرك الذكاء الاصطناعي',
        appearance: 'المظهر',
        piano: 'الخطة',
        advanced: 'متقدم',
      },
      save_btn: 'حفظ الإعدادات',
      unsaved: 'تغييرات غير محفوظة',
      action_loading: 'جارٍ...',
      general: {
        contents: 'المحتويات',
        default_lang: 'لغة المحتوى الافتراضية',
        tone: 'نبرة المحتوى العامة',
        tone_hint: 'تُطبَّق على المنتجات والمجموعات والمقالات والدُّفعات',
        seo_rules: 'قواعد SEO',
        seo_title_max: 'الحد الأقصى لطول عنوان SEO',
        seo_title_hint: 'الموصى به: 50–60 حرفًا',
        meta_max: 'الحد الأقصى لطول الوصف التعريفي',
        meta_hint: 'الموصى به: 150–160 حرفًا',
        chars: 'حرفًا',
        images: 'تفضيلات الصور',
        img_format: 'الصيغة الافتراضية',
        img_square: 'مربع (1:1)',
        img_landscape: 'أفقي (4:3)',
        img_portrait: 'عمودي (3:4)',
        img_quality: 'جودة الضغط',
        img_quality_low: '50% (مضغوط)',
        img_quality_high: '100% (أقصى جودة)',
        store_info: 'معلومات المتجر',
        store_domain: 'النطاق',
        store_plan: 'الخطة',
        store_installed: 'تاريخ التثبيت',
      },
      ai: {
        strategy: 'استراتيجية الذكاء الاصطناعي',
        params_title: 'معاملات الإنشاء',
        creativity: 'الإبداعية',
        creative_low: 'محافظ',
        creative_high: 'إبداعي',
        seo_strictness: 'صرامة SEO',
        seo_low: 'مرن',
        seo_high: 'صارم',
        tone_label: 'النبرة العامة',
        auto_title: 'التحسين التلقائي بالذكاء الاصطناعي',
        auto_hint: 'فعِّل لتحسين المحتوى تلقائيًا',
        on: 'نشط',
        off: 'إيقاف',
        threshold: 'عتبة التحسين',
        threshold_low: 'تحسين كل شيء',
        threshold_high: 'الأسوأ فقط',
        threshold_hint: 'يعمل على العناصر ذات نقاط SEO < {{n}}',
        frequency: 'التكرار',
        scope: 'النطاق',
        triggers: 'المشغّلات',
        img_format: 'صيغة الصورة',
        img_square: 'مربع 1:1',
        img_square_sub: '800×800 بكسل',
        img_landscape: 'أفقي 4:3',
        img_landscape_sub: '800×600 بكسل',
        img_portrait: 'عمودي 3:4',
        img_portrait_sub: '600×800 بكسل',
        img_no_resize: 'بدون تغيير حجم',
        img_no_resize_sub: 'الأبعاد الأصلية',
        compress: 'الضغط',
        compress_hint: 'تقليل حجم الملف',
        quality: 'الجودة',
        daily_credits: 'أرصدة الذكاء الاصطناعي اليوم',
        remaining: '{{n}} متبقية',
        reset_in: 'إعادة التعيين خلال',
        running: 'جارٍ — {{done}}/{{total}} منتج',
        run_now: 'تشغيل الآن',
        run_desc: 'تحسين العناصر ذات النقاط < {{threshold}} في: {{scope}}',
        preview_title: 'معاينة — قبل / بعد',
        before: 'قبل',
        after: 'بعد الذكاء الاصطناعي',
        no_keywords: 'لا كلمات مفتاحية',
        preview_note: 'مثال على المنتج «حذاء الجري Pro X1» — تحديث فوري',
        alt_mode_label: 'وضع إنشاء نص ALT',
        alt_preview: 'معاينة',
        alt_mode_ai: 'ذكاء اصطناعي ذكي',
        alt_mode_ai_desc: 'يُنشئ OpenAI نص ALT محسَّن لكل صورة',
        alt_mode_template: 'قالب مجاني',
        alt_mode_template_desc: 'بدون أرصدة الذكاء الاصطناعي — يستخدم القالب أدناه',
        alt_mode_auto: 'رجوع تلقائي',
        alt_mode_auto_desc: 'الذكاء الاصطناعي عند توفره، القالب عند نفاد الأرصدة',
        alt_hint_template: 'الوضع المجاني: لا أرصدة ذكاء اصطناعي تُستهلك لنص ALT.',
        alt_hint_auto: 'رجوع تلقائي: الذكاء الاصطناعي إذا كانت الأرصدة متاحة، وإلا قالب تلقائي.',
        pct_done: '{{pct}}% مكتمل',
        n_errors: '{{n}} أخطاء',
        alt_template_label: 'قالب مخصص',
        alt_vars_label: 'المتغيرات المتاحة — انقر للإدراج',
      },
      piano: {
        credits_title: 'استخدام الأرصدة',
        plan_label: 'الخطة',
        extra_credits: 'أرصدة إضافية',
        unlimited: '∞ أرصدة غير محدودة',
        unlimited_sub: 'الخطة النخبة — بدون حد شهري',
        plan_credits: 'أرصدة الخطة',
        consumed: 'المستهلك من الخطة',
        residual: 'المتبقي من الخطة',
        extra_available: 'الأرصدة الإضافية المتاحة',
        extra_sub: 'تُستهلك فقط بعد الخطة الشهرية',
        total_available: 'إجمالي المتاح',
        consumed_cycle: 'الأرصدة المستهلكة في الدورة الحالية',
        status_active: 'نشط',
        status_pending: 'قيد المعالجة',
        status_frozen: '⚠ معلّق',
        status_free: 'مجاني / بدون اشتراك',
        trial_active: 'الإصدار التجريبي نشط',
        trial_access: 'وصول كامل حتى {{date}}.',
        sub_status: 'حالة الاشتراك',
        next_credit_reset: 'إعادة تعيين الأرصدة التالية',
        trial_end: 'انتهاء الإصدار التجريبي',
        trial_label: 'إصدار تجريبي مجاني',
        trial_used: 'مُستخدم بالفعل',
        trial_available: '{{n}} يوم متاح',
        cancel_btn: 'إلغاء الاشتراك',
        cancelling: 'جارٍ الإلغاء...',
        plans_title: 'الخطط المتاحة',
        plan_active: 'الخطة النشطة',
        plan_current: 'الخطة الحالية',
        per_month: '/شهر',
        downgrade: 'العودة إلى المجاني',
        downgrading: 'جارٍ التخفيض...',
        upgrade: 'ترقية',
        downgrade_btn: 'تخفيض',
        redirecting: 'جارٍ إعادة التوجيه...',
        trial_btn: 'تجربة مجانية',
        trial_btn_days: '({{n}} يوم)',
        plan_overage: 'أرصدة ذكاء اصطناعي إضافية: {{price}} لكل رصيد',
        plan_no_overage: 'لا توجد رسوم على الأرصدة الإضافية',
        plan_trial_line: 'تجربة مجانية لمدة {{n}} أيام',
        plans_note: 'تشمل الخطط المدفوعة تجربة مجانية لمدة {{n}} أيام. بدون رسوم تفعيل. المدفوعات عبر Shopify Billing.',
        credits_section: 'شراء أرصدة إضافية',
        credits_desc: 'تُضاف الأرصدة الإضافية إلى خطتك الشهرية ولا تنتهي صلاحيتها. متوافقة مع جميع الخطط.',
        one_time: 'مرة واحدة',
        per_credit: '¢ لكل رصيد',
        buy: 'شراء',
        payment_note: 'تتم معالجة الدفع بأمان عبر Shopify Billing. لا يتم تخزين بيانات الدفع على خادمنا.',
        history_title: 'سجل شراء الأرصدة',
        history_count: '{{n}} عملية شراء',
        hist_invested: 'إجمالي الاستثمار',
        hist_bought: 'الأرصدة المشتراة',
        hist_available: 'لا تزال متاحة',
        hist_empty: 'لم يتم إجراء أي عمليات شراء للأرصدة الإضافية.',
        hist_date: 'التاريخ',
        hist_pkg: 'الحزمة',
        hist_credits: 'الأرصدة',
        hist_amount: 'المبلغ',
        hist_status: 'الحالة',
        hist_completed: 'مكتمل',
        hist_pending: 'معلّق',
        hist_declined: 'مرفوض',
        trend_title: 'اتجاه الاستخدام',
        trend_placeholder: 'مخطط الاستخدام (متاح مع Shopify Billing)',
        stats_products: 'المنتجات المحللة',
        stats_content: 'المحتوى المُنشأ',
        stats_translations: 'الترجمات',
        stats_images: 'الصور المحسَّنة',
        toast_sub_pending: 'الاشتراك قيد المعالجة — ستتلقى تأكيدًا قريبًا.',
        toast_sub_activated: 'تم تفعيل {{name}}!',
        toast_trial_suffix: '({{n}} يوم تجريبي مجاني)',
        toast_sub_error: 'خطأ في التحقق من الاشتراك',
        toast_purchase_duplicate: 'عملية الشراء مسجلة بالفعل.',
        toast_credits_added: '+{{n}} رصيد أضيف إلى حسابك!',
        toast_purchase_error: 'خطأ في التحقق من الشراء',
        toast_purchase_start_error: 'خطأ عند بدء الشراء',
        toast_sub_start_error: 'خطأ عند بدء الاشتراك',
        toast_store_unavailable: 'لم يتم ربط المتجر بعد. أعد تحميل التطبيق في Shopify Admin وحاول مرة أخرى.',
        toast_sub_cancelled: 'تم إلغاء الاشتراك. عادت الخطة إلى المجاني.',
        toast_sub_cancel_error: 'خطأ في إلغاء الاشتراك',
        pkg_100_label: '100 رصيد',
        pkg_100_desc: 'مثالي للاستخدام العرضي',
        pkg_300_label: '300 رصيد',
        pkg_300_desc: 'وفّر 17%',
        pkg_300_badge: '⭐ الأكثر طلبًا',
        pkg_700_label: '700 رصيد',
        pkg_700_desc: 'وفّر 29%',
        pkg_1500_label: '1500 رصيد',
        pkg_1500_desc: 'وفّر 33%',
        pkg_1500_badge: '🔥 أفضل قيمة',
        plan_starter_badge: '⭐ الأكثر شعبية',
        plan_starter_benefit: 'وفّر ساعات عمل كل شهر.',
        plan_pro_badge: '🔥 نمو SEO',
        plan_pro_benefit: 'يحسّن الفهرسة وأداء SEO.',
        plan_elite_badge: '🚀 الوكالات',
        plan_elite_benefit: 'مصمّم للوكالات وكتالوجات المؤسسات.',
      },
      toast: {
        saved_at: 'تم الحفظ في {{time}}',
        save_error: 'خطأ في الحفظ',
        budget_exceeded: 'نفدت الأرصدة اليومية — تم تحسين {{done}} من أصل {{total}} منتج',
        autopilot_stopped: 'توقف الطيار الآلي — تم تحسين {{done}} من أصل {{total}} منتج',
        images_optimized: 'تم تحسين الصور — {{n}} منتج',
        images_failed: 'فشل تحسين {{n}} صورة',
        autopilot_done: 'اكتمل الطيار الآلي — {{started}} منتج في قائمة الانتظار',
        autopilot_empty: 'لا توجد عناصر دون العتبة',
        autopilot_stopping: 'جارٍ إيقاف الطيار الآلي...',
        reindex_started: 'بدأ إعادة الفهرسة',
        resync_started: 'بدأ إعادة المزامنة',
        cache_cleared: 'تم مسح ذاكرة التخزين المؤقت',
        sync_reset: 'تمت إعادة تعيين حالة المزامنة',
      },
      advanced: {
        warning: 'الإجراءات التالية تؤثر على سلوك النظام. استخدمها فقط عند الضرورة.',
        sync_title: 'المزامنة',
        reindex: 'إعادة فهرسة المنتجات',
        reindex_desc: 'إعادة حساب بيانات SEO لجميع المنتجات في قاعدة البيانات',
        resync: 'إعادة المزامنة مع Shopify',
        resync_desc: 'فرض مزامنة كاملة للمنتجات والمجموعات',
        cache_title: 'ذاكرة التخزين المؤقت',
        clear_cache: 'مسح ذاكرة التخزين المؤقت للتطبيق',
        clear_cache_desc: 'يحذف الدُّفعات الجارية في المتصفح. ستُفقد العمليات غير المكتملة.',
        reset_credits: 'إعادة تعيين الأرصدة اليومية',
        reset_credits_desc: 'إعادة تعيين عداد أرصدة الذكاء الاصطناعي لهذا اليوم (dev). الحد: 5.000/يوم.',
        danger_zone: 'المنطقة الخطرة',
        reset_sync: 'إعادة تعيين حالة المزامنة',
        reset_sync_desc: 'فرض إعادة التعيين. استخدم فقط إذا كانت المزامنة متوقفة لأكثر من 30 دقيقة.',
      },
    },
    ai_engine: {
      preset: {
        growth_desc: 'يزيد التحويلات والتفاعل',
        luxury_desc: 'علامة تجارية فاخرة وسرد حصري',
        seo_desc: 'يزيد الظهور العضوي على Google',
        balanced_desc: 'توازن مثالي بين الجودة وSEO',
      },
      tone: {
        professional: 'احترافي',
        professional_desc: 'رسمي، موثوق، يبني الثقة',
        luxury: 'فاخر',
        luxury_desc: 'أنيق، حصري، راقٍ',
        technical: 'تقني',
        technical_desc: 'دقيق، مواصفات، بيانات قابلة للقياس',
        conversational: 'محادثي',
        conversational_desc: 'مباشر، ودّي، جذاب',
      },
      frequency: {
        daily: 'يومي',
        daily_desc: 'مرة واحدة يوميًا',
        hourly: 'كل ساعة',
        hourly_desc: 'مستمر',
        realtime: 'فوري',
        realtime_desc: 'في أسرع وقت ممكن',
      },
      scope: {
        products: 'المنتجات',
        collections: 'المجموعات',
        articles: 'المقالات',
        pages: 'الصفحات',
      },
      trigger: {
        seo_score: 'نقاط SEO منخفضة',
        missing_meta: 'بيانات وصفية مفقودة',
        missing_alt: 'نص ALT مفقود',
        outdated_desc: 'وصف قديم',
        keywords: 'كلمات مفتاحية مفقودة',
        image_quality: 'صور غير محسَّنة',
      },
    },
    appearance: {
      title: 'المظهر',
      theme_title: 'السمة',
      theme: {
        light: 'فاتح',
        dark: 'داكن',
        system: 'النظام',
      },
      density_title: 'الكثافة',
      density: {
        compact: 'مضغوط',
        comfortable: 'مريح',
        spacious: 'فسيح',
        compact_desc: 'محتوى أكثر',
        comfortable_desc: 'متوازن',
        spacious_desc: 'مساحة أكبر',
      },
      sidebar_title: 'الشريط الجانبي',
      sidebar: {
        expanded: 'موسّع',
        collapsed: 'مطوي',
        hidden: 'مخفي',
        expanded_desc: 'دائمًا مرئي',
        collapsed_desc: 'الأيقونات فقط',
        hidden_desc: 'عند التحويم',
      },
    },
    localization: {
      ui_language: 'لغة الواجهة',
      select_language: 'اختر لغة التطبيق',
      reload_note: 'يتم تطبيق اللغة فوراً',
    },
    dashboard: {
      title: 'نظرة عامة',
      subtitle: 'ملخص نشاط المتجر',
      products: 'المنتجات',
      optimized: 'محسّنة',
      pending: 'قيد الانتظار',
      seo_score: 'نقاط تحسين محركات البحث',
      audit_center: 'Audit Center',
      sync_products: 'مزامنة المنتجات',
      analyze_products: 'تحليل المنتجات',
      audit_site: 'تدقيق الموقع 360',
      syncing: 'مزامنة...',
      analyzing: 'تحليل...',
      auditing: 'Audit...',
      section_account: 'الحساب والخطة',
      section_catalog: 'حالة الكتالوج',
      section_images: 'الصور',
      section_seo_tech: 'SEO التقني — تدقيق شامل للموقع',
      section_ux_trust: 'UX & Trust — Highlights',
      section_actions: 'الإجراءات الموصى بها من الذكاء الاصطناعي',
      recent_activity: 'النشاط الأخير',
      hint_plan: 'حالة الخطة والأرصدة',
      hint_never_synced: 'لم تتم المزامنة قط',
      hint_priority: 'مرتب حسب الأولوية',
      hint_last_sync: 'آخر مزامنة {{date}}',
      current_plan: 'الخطة الحالية',
      credits_used: 'الأرصدة المستخدمة',
      credits_remaining: 'الأرصدة المتبقية',
      public_domain: 'النطاق العام',
      credit_usage: 'استخدام الأرصدة',
      hint_installed: 'مثبّت في {{date}}',
      hint_pct_plan: '{{pct}}% من الخطة',
      hint_limit: 'الحد {{n}}',
      hint_last_audit: 'آخر تدقيق {{date}}',
      hint_no_audit: 'لم يُنفَّذ التدقيق',
      no_audit: 'لم يُنفَّذ أي تدقيق',
      no_audit_desc: 'شغّل تدقيقاً لتحليل العنوان، والميتا، وH1، والرابط الأساسي، والروبوتات، وخريطة الموقع، وHTTPS، وOG، وJSON-LD، والأداء، والصور والروابط.',
      run_audit: 'تشغيل التدقيق',
      in_progress: 'جارٍ...',
      audit_phase: 'التدقيق جارٍ (المرحلة: {{phase}})...',
      ux_highlights: 'UX Highlights',
      trust_compliance: 'Trust & Compliance',
      mobile_viewport: ':Mobile viewport',
      favicon: ':Favicon',
      images_without_alt_label: 'صور بدون ALT:',
      lazy_loading: ':Lazy loading',
      images_suffix: 'صور',
      internal_links: 'روابط داخلية:',
      data_unavailable: 'البيانات غير متاحة: {{reason}}',
      analysis_not_run: 'لم يُنفَّذ التحليل',
      not_detected: 'غير مكتشف',
      no_trust_data: 'لا توجد بيانات ثقة متاحة',
      no_activity: 'لا يوجد نشاط حديث.',
      activity_completed: 'مكتمل',
      activity_error: 'خطأ',
      no_store_title: 'لا يوجد متجر متصل',
      no_store_desc: 'قم بتثبيت التطبيق على متجر Shopify للبدء',
      connect_store: 'ربط متجر Shopify',
      no_token_title: 'رمز OAuth مفقود',
      no_token_desc: 'المتجر {{domain}} مسجّل لكن لا يملك رمزاً. أعد تثبيت التطبيق.',
      reinstall_app: 'إعادة تثبيت التطبيق عبر OAuth',
      sync_in_progress: 'مزامنة المنتجات جارية…',
      sync_in_progress_detail: '{{synced}} / {{total}} منتج. ستُحدَّث بيانات لوحة التحكم عند انتهاء المزامنة.',
      stale_data: 'بيانات قديمة: عرض آخر أرقام صالحة أثناء المزامنة.',
      catalog_score_label: 'Catalog Score',
      seo_distribution: 'توزيع SEO',
      n_products: '{{n}} منتج',
      pct_of_catalog: '{{pct}}% من الكتالوج',
      no_description: 'بدون وصف',
      no_meta_description: 'بدون meta description',
      seo_needs_improvement: 'SEO يحتاج تحسين',
      view: 'عرض',
      seo_good_desc: 'يتمتع الكتالوج بتغطية SEO جيدة. حافظ على المعيار بتحسين المنتجات الجديدة.',
      seo_medium_desc: 'يتمتع الكتالوج بتغطية SEO متوسطة. الأولوية: meta descriptions وأوصاف المنتجات.',
      seo_poor_desc: 'يتمتع الكتالوج بتغطية SEO منخفضة. الأولوية: meta descriptions والأوصاف والصور المفقودة.',
      seo_optimized: 'محسّنة',
      seo_medium: 'متوسطة',
      seo_poor: 'تحتاج تحسين',
      content_seo_title: 'حالة SEO حسب نوع المحتوى',
      open_catalog: 'فتح الكتالوج',
      row_collections: 'المجموعات',
      row_articles: 'المقالات',
      row_pages: 'الصفحات',
      coming_soon: 'قريباً',
      not_synced: 'غير متزامنة',
      seo_coverage_fmt: '{{opt}}/{{total}} محسّنة · {{score}}/100',
      alt_coverage: 'تغطية ALT text',
      with_alt_count: '{{n}} مع ALT من {{total}}',
      image_optimization_label: 'تحسين الصور',
      optimized_count: '{{n}} محسّنة من {{total}}',
      with_alt: 'مع ALT',
      without_alt: 'بدون ALT',
      image_optimized: 'محسّنة',
      image_needs_improvement: 'تحتاج تحسين',
      no_image: 'بدون صورة',
      savings: 'وفورات',
      optimize_images_btn: 'تحسين الصور',
      view_no_image: 'عرض المنتجات بدون صورة',
      alt_manager: 'ALT Text Manager',
      toast_sync_done: 'اكتملت المزامنة. جارٍ تسوية الكتالوج...',
      toast_catalog_reconciled: 'تمت تسوية الكتالوج: {{n}} منتج (تمت إزالة {{removed}} يتيم)',
      toast_sync_first: 'قم بمزامنة المنتجات أولاً',
      toast_avg_score: 'متوسط النقاط {{score}}/100',
      toast_audit_done: 'اكتمل التدقيق: {{score}}/100',
      toast_sync_reset: 'تمت إعادة تعيين حالة المزامنة',
      toast_sync_reset_error: 'تعذّر إعادة تعيين الحالة',
      op_description: 'وصف الذكاء الاصطناعي',
      op_seo_title: 'SEO Title',
      op_meta_description: 'Meta Description',
      op_keywords: 'Keywords',
      op_translation: 'ترجمة',
      op_image_opt: 'تحسين الصورة',
      op_sync: 'Sync Shopify',
      op_seo_analysis: 'تحليل SEO للمتجر',
      op_site_audit: 'تدقيق الموقع 360',
      prompt_domain: 'أدخل نطاق متجر Shopify الخاص بك',
      hint_force_reset: 'إعادة تعيين حالة المزامنة (لا يحذف المنتجات)',
    },
    products: {
      title: 'كتالوج المنتجات',
      search: 'البحث عن المنتجات...',
      all: 'الكل',
      optimized: 'محسّنة',
      pending: 'قيد الانتظار',
      status_generating: 'جارٍ التوليد',
      status_writing: 'جارٍ الكتابة',
      status_validating: 'جارٍ التحقق',
      status_failed: 'فشل',
      status_sync_failed: 'Sync Shopify',
      status_optimized: 'محسَّن',
      status_medium: 'متوسط',
      status_needs_improvement: 'يحتاج تحسين',
      type_collection_singular: 'collection',
      type_collection_plural: 'collections',
      sync_collections: 'Sync Collections',
      empty_collections: 'No collections. Click "Sync Collections" to import from Shopify.',
      search_collections: 'Search collection by title or handle...',
      col_label_products: 'المنتجات',
      type_article_singular: 'article',
      type_article_plural: 'articles',
      sync_articles: 'Sync Articles',
      empty_articles: 'No articles. Click "Sync Articles" to import from Shopify.',
      search_articles: 'Search article by title, handle or blog...',
      col_label_blog: 'Blog',
      type_page_singular: 'page',
      type_page_plural: 'pages',
      sync_pages: 'Sync Pages',
      empty_pages: 'No pages. Click "Sync Pages" to import from Shopify.',
      search_pages: 'Search page by title or handle...',
      col_label_author: 'Author',
      catalog_title: 'الكتالوج',
      no_store: 'لا يوجد متجر',
      tab_products: 'المنتجات',
      tab_collections: 'المجموعات',
      tab_articles: 'المقالات',
      tab_pages: 'الصفحات',
      sort_updated: 'Updated',
      sort_seo_score: 'SEO Score',
      sort_title: 'Title',
      sort_vendor: 'Vendor',
      sort_created: 'Created',
      sort_desc: 'Descending',
      sort_asc: 'Ascending',
      filter_seo_all: 'SEO: all',
      filter_optimized: 'Optimized',
      filter_medium: 'Medium',
      filter_needs_improvement: 'Needs improvement',
      filter_image_all: 'Images: all',
      filter_image_yes: 'With images',
      filter_image_no: 'Without images',
      filter_meta_all: 'Meta: all',
      filter_meta_yes: 'With meta',
      filter_meta_no: 'Without meta',
      filter_desc_all: 'Description: all',
      filter_desc_yes: 'With description',
      filter_desc_no: 'Without description',
      filter_vendor_all: 'Vendor: all',
      filter_collection_all: 'Collection: all',
      filter_type_all: 'Type: all',
      reset_filters: 'Reset filters',
      th_image: 'Image',
      th_title: 'Title',
      th_seo_score: 'SEO Score',
      th_alt: 'ALT',
      th_meta: 'Meta',
      th_status: 'الحالة',
      th_actions: 'Actions',
      no_products_filters: 'No products found with these filters',
      no_products: 'No products. Sync from your Shopify store.',
      pagination: 'Page {{page}} of {{total}} · {{count}} products',
      batch_btn: 'Batch Operations',
      dialog_status: 'الحالة',
      dialog_seo_score: 'SEO Score',
      dialog_shopify_id: 'Shopify ID',
      dialog_vendor: 'Vendor',
      dialog_serp: 'SERP Preview',
      dialog_issues: 'SEO Issues',
      dialog_suggestions: 'Suggestions',
      generating: 'جارٍ التوليد...',
      generate_all: 'توليد كل المحتوى',
      action_generate_ai: 'Generate AI Content',
      action_translate: 'Translate',
      action_optimize_image: 'Optimize Image',
      syncing: 'جارٍ المزامنة...',
      draft_ready: 'المسودة جاهزة',
      seo_ai_btn: 'SEO AI',
      batch_ops_btn: 'Batch Operations',
      diagnosis: 'Diagnostics',
      current_score: 'Current score',
      projected: '→ projected {{score}}/100',
      meta_title: 'Meta Title',
      meta_desc_label: 'Meta Description',
      description_label: 'Description',
      generate_desc_btn: 'Generate AI description',
      generating_desc: 'Generating...',
      generate_ai_btn: 'Generate with AI',
      publish_shopify_btn: 'نشر على Shopify',
      publishing: 'جارٍ النشر...',
      discard_draft_btn: 'Discard draft',
      seo_ai_dialog_title: 'SEO AI',
      seo_all: 'SEO: all',
      seo_optimized: 'Optimized',
      seo_medium: 'Medium',
      seo_needs: 'يحتاج إلى تحسين',
      page_of: 'الصفحة {{page}} من {{total}}',
      search_placeholder: 'البحث بالعنوان أو SKU أو EAN أو المورد أو المقبض...',
      chars_count: '{{n}}/{{max}} حرف',
      n_selected_info: 'محدد',
      filtered: 'مصفاة',
      soon_tooltip: 'متاح قريباً',
      resource_subtitle: '{{type}} Shopify وحالة SEO',
      articles_blog: 'المقالات (مدونة)',
      select_visible_title: 'تحديد/إلغاء تحديد كل المرئيات',
      toast_draft_ready: 'تم إنشاء مسودة SEO. راجع وانشر.',
      toast_error_ai: 'خطأ في الإنشاء بالذكاء الاصطناعي',
      toast_desc_generated: 'تم إنشاء وصف الذكاء الاصطناعي.',
      toast_error_desc: 'خطأ في إنشاء الوصف',
      toast_empty_draft: 'أنشئ أو أدخل حقلاً واحداً على الأقل',
      toast_published_score: 'تم النشر على Shopify · النتيجة {{score}}/100',
      toast_error_publish: 'خطأ في النشر على Shopify',
      toast_draft_discarded: 'تم تجاهل المسودة',
      toast_select_items: 'حدد عنصراً واحداً على الأقل',
      toast_mode_publish: 'النشر',
      toast_mode_both: 'إنشاء+نشر',
      toast_mode_generate: 'إنشاء SEO بالذكاء الاصطناعي',
      toast_batch_launched: 'تم بدء {{label}} على {{count}} {{type}}.',
      toast_batch_errors: 'اكتمل {{label}} مع {{count}} أخطاء',
      toast_batch_done: 'اكتمل {{label}} على {{count}} {{type}}',
      toast_synced: 'تمت مزامنة {{type}}: {{count}}',
      toast_sync_error: 'خطأ في المزامنة {{type}}',
      toast_token_error: 'انتهت صلاحية رمز Shopify أو لا توجد أذونات',
      reinstall_label: 'إعادة التثبيت',
      toast_sync_started: 'بدأت مزامنة {{type}}',
      toast_error_sync_start: 'خطأ في بدء المزامنة',
      toast_perms_ok: 'الأذونات موافقة ({{kind}})',
      toast_token_revoked: 'تم إلغاء الرمز',
      toast_perms_missing: 'أذونات مفقودة',
      toast_diag_error: 'خطأ في التشخيص',
      toast_score: 'النتيجة {{score}}/100',
      toast_error_analyze: 'خطأ في التحليل',
      toast_generated: 'تم إنشاء المحتوى',
      toast_error_generate: 'خطأ في الإنشاء',
    },
    content: {
      title: 'توليد المحتوى',
      generate: 'توليد المحتوى',
      language: 'اللغة',
      tone: 'النبرة',
      subtitle: 'Generate descriptions, SEO title, meta description and keywords with AI',
      tab_products: 'المنتجات',
      tab_collections: 'المجموعات',
      tab_articles: 'المقالات',
      tab_pages: 'الصفحات',
      type_description_label: 'Description',
      type_description_hint: 'Engaging and SEO-friendly product text',
      type_seo_title_label: 'SEO Title',
      type_seo_title_hint: 'SERP-optimized title (max 60 chars)',
      type_meta_desc_label: 'Meta Description',
      type_meta_desc_hint: 'Google snippet (max 160 chars)',
      type_keywords_label: 'Keywords',
      type_keywords_hint: 'Primary and secondary keywords',
      type_body_label: 'Description / Body',
      type_body_hint: 'Main resource text',
      filter_all: 'الكل',
      filter_needs: 'Needs improvement',
      filter_medium: 'Medium',
      filter_optimized: 'Optimized',
      no_results_filters: 'No items match the filters',
      select_all: 'Select all',
      deselect: 'Deselect',
      selected_count: '{{count}} selected',
      selected_max: '(max)',
      deselect_all: 'Deselect all',
      pagination_of: '{{page}} / {{total}}',
      total_count: '({{count}} total)',
      content_type_section: 'Content Type',
      batch_generating: 'Generating… {{done}}/{{total}}',
      batch_generate_btn: 'Generate Batch ({{count}})',
      generating_count: 'Generate ({{count}})',
      generate_btn: 'Generate',
      generating: 'جارٍ التوليد...',
      generate_all_btn: 'All',
      hint_select: '← Select an item or tick multiple items for batch',
      hint_batch_ready: '{{count}} item(s) ready for batch',
      batch_done_title: '✓ Batch completed',
      batch_pending_title: 'Batch pending…',
      batch_in_progress_title: 'Batch Generation in progress…',
      batch_done_msg: 'All content generated. Selection will be cleared automatically.',
      results_section: 'Results',
      publishing: 'جارٍ النشر...',
      published: 'Published',
      publish_btn: 'نشر على Shopify',
      clear_results: 'Clear',
      chars_unit: 'chars',
      cache_label: 'cache',
      preview_section: 'Current preview',
      loading_detail: 'Loading detail…',
      not_present: 'Not present',
      not_present_plural: 'Not present',
      empty_state: 'Click an item to view it, or tick multiple items and use Generate Batch',
      copy_btn: 'Copy',
      type_seo_title_hint_content: 'عنوان ميتا لنتائج البحث (الحد الأقصى 60 حرفاً)',
      no_items: 'لم يتم العثور على {{type}}',
      item_deselect: 'إلغاء التحديد',
      item_select: 'إضافة إلى التحديد',
      generate_all_title: 'إنشاء جميع الأنواع المتاحة',
      prev_item: 'العنصر السابق',
      next_item: 'العنصر التالي',
      toast_load_error: 'خطأ في تحميل العناصر',
      toast_batch_done: 'اكتملت الدفعة: {{done}}/{{total}} منتج',
      toast_batch_failed: 'فشلت الدفعة: {{failed}} أخطاء من {{total}}',
      toast_batch_cancelled: 'تم إلغاء الدفعة',
      toast_batch_resumed: 'استؤنفت الدفعة النشطة…',
      toast_max_select: 'الحد الأقصى {{max}} عناصر قابلة للتحديد',
      toast_select_item: 'حدد عنصراً من القائمة',
      toast_select_type: 'حدد نوع محتوى واحداً على الأقل',
      toast_from_cache: 'المحتوى من الذاكرة المؤقتة!',
      toast_generated: 'تم الإنشاء بنجاح!',
      toast_generate_error: 'خطأ في إنشاء المحتوى',
      toast_batch_running: 'عملية دفعية قيد التشغيل بالفعل',
      toast_no_store: 'المتجر غير متاح',
      toast_batch_started: 'بدأت الدفعة: {{n}} منتج في قائمة الانتظار',
      toast_batch_start_error: 'خطأ في بدء الدفعة',
      toast_batch_item_error: 'خطأ في الإنشاء: {{title}}',
      toast_batch_complete: 'اكتملت الدفعة: {{done}}/{{total}} عنصر',
      toast_cancel_error: 'خطأ في إلغاء الدفعة',
      toast_published: 'تم نشر المحتوى على Shopify!',
      toast_publish_error: 'خطأ في نشر المحتوى',
      toast_copied: 'تم النسخ إلى الحافظة',
      present: 'موجود',
      missing: 'مفقود',
      lang_it: 'الإيطالية',
      lang_en: 'الإنجليزية',
      lang_fr: 'الفرنسية',
      lang_de: 'الألمانية',
      lang_es: 'الإسبانية',
      lang_pt: 'البرتغالية',
      tone_professional: 'احترافي',
      tone_luxury: 'فاخر',
      tone_technical: 'تقني',
      tone_conversational: 'محادثاتي',
    },
    images: {
      title: 'تحسين الصور',
      optimize: 'تحسين',
      format: 'التنسيق',
      compress: 'ضغط',
      quality: 'الجودة',
      alt_mode_label: 'وضع توليد النص البديل',
      alt_mode_ai: 'ذكاء اصطناعي ذكي',
      alt_mode_template: 'قالب مجاني',
      alt_mode_auto: 'احتياطي تلقائي',
      subtitle: 'Optimize images, manage ALT text and publish to Shopify.',
      tab_optimize: 'Optimize Images',
      tab_alt: 'ALT Text',
      alt_coverage: 'ALT Coverage',
      with_alt_count: 'with ALT out of',
      sync_alt_btn: 'Update ALT data from Shopify',
      syncing_alt: 'Updating ALT...',
      sync_status_label: 'Status:',
      analyzed_label: 'Analyzed:',
      last_updated_label: 'Last update:',
      stalled: 'stalled',
      force_stop: 'Force stop (stalled for 60s)',
      free_badge: '● Free — no credits',
      configure_btn: '▼ Configure',
      hide_btn: '▲ Hide',
      template_free_hint: 'Free mode active — zero AI credits. Template:',
      template_auto_hint: 'Auto fallback — AI if credits available, local template if exhausted.',
      template_config_title: 'Configure ALT Template',
      template_label: 'Custom template',
      template_preview: 'Preview:',
      variables_label: 'Available variables — click to insert:',
      restore_default: 'Restore default',
      save_config: 'Save configuration',
      saving: 'Saving...',
      search_placeholder: 'Search by title, vendor, handle...',
      filter_all_images: 'All',
      filter_with_alt: 'With ALT',
      filter_without_alt: 'Without ALT',
      selected_images: '{{count}} images selected (max 50 per batch)',
      generate_batch_btn: 'Generate ALT for selected',
      batch_alt_in_progress: 'ALT Batch in progress: {{done}} / {{total}}',
      batch_errors: '{{n}} أخطاء',
      select_all_label: 'Select all',
      deselect_all_label: 'Deselect all',
      total_products_label: '{{count}} products',
      timeout_title: 'Loading took too long (20s)',
      timeout_desc: 'The database is processing many products. Try again in a few seconds.',
      error_title: 'List loading error',
      no_products_filter: 'No products matching the filters',
      alt_placeholder: 'ALT text (max 125 characters)',
      status_published: 'Published',
      status_saved: 'Saved',
      status_draft_alt: 'Draft',
      status_missing: 'No ALT',
      generate_alt_btn: 'Generate ALT',
      save_alt_btn: 'Save ALT',
      publish_alt_btn: 'Publish',
      prec: 'Prev',
      succ: 'Next',
      select_products: 'Select Products',
      filter_collection_all: 'Collection: all',
      filter_vendor_all: 'Vendor: all',
      filter_kb_all: 'KB: all',
      filter_kb_100: 'Files over 100 KB',
      filter_kb_500: 'Files over 500 KB',
      filter_kb_1mb: 'Files over 1 MB',
      filter_format_all: 'Format: all',
      filter_landscape: 'Width greater than Height',
      filter_portrait: 'Height greater than Width',
      filter_square: 'Square',
      filter_status_all: 'Status: all',
      filter_status_optimized: 'Already optimized',
      filter_status_needs: 'To optimize',
      visible_total: '{{visible}} visible · {{total}} total',
      reset_filters: 'Reset filters',
      clear_selection: 'Clear selection',
      no_image_products: 'No products with image',
      ready_badge: 'Ready',
      settings_title: 'Settings',
      format_title: 'Image Format',
      format_square: 'Square 1:1',
      format_landscape: 'Landscape 4:3',
      format_portrait: 'Portrait 3:4',
      format_none: 'No resize',
      format_none_sub: 'Original dimensions',
      compress_label: 'Compression',
      compress_desc: 'Reduce file size',
      quality_label: 'Quality',
      batch_opt_running: 'Optimization in progress',
      batch_opt_cancelled: 'Optimization cancelled',
      batch_opt_completed: 'Optimization completed',
      batch_apply_running: 'Application in progress',
      batch_apply_cancelled: 'Application cancelled',
      batch_apply_completed: 'Application completed',
      background_note: 'You can change section, continues in background',
      optimizing: 'Optimizing...',
      optimize_n: 'Optimize {{count}} images',
      optimize_one: 'Optimize Image',
      applying: 'Applying...',
      apply_n: 'Apply {{count}} to Shopify',
      apply_one: 'Apply to Shopify',
      preview_title: 'Preview',
      ready_optimizations: '{{count}} optimizations ready',
      select_preview_hint: 'Select one or more products to see the preview',
      first_product_preview: 'Preview shown for the first selected product:',
      original_label: 'Original',
      optimized_label: 'Optimized',
      optimize_click_hint: 'Click "Optimize" for the result',
      reduction_label: 'Reduction',
      apply_btn: 'Apply',
      history_opt_title: 'Optimization history',
      history_opt_subtitle: 'Operations applied to Shopify, errors and restores.',
      stat_running_label: 'Running',
      stat_completed_label: 'Completed',
      stat_errors_label: 'Incomplete',
      stat_undo_label: 'Undo',
      total_savings: 'Total savings',
      no_history: 'No operations applied yet.',
      restoring: 'Restoring...',
      undo_btn: 'Undo',
      kb_warning: 'KB size is not in local data. To make it accurate it needs to be saved by the backend during image sync.',
      senza_vendor: 'No vendor',
      alt_stat_coverage: '{{n}} مع ALT من {{total}}',
      apply_batch_cancelled: 'تم إلغاء التطبيق',
      apply_batch_done_label: 'اكتمل التطبيق',
      apply_batch_running: 'التطبيق جارن',
      apply_n_btn: 'تطبيق {{n}} على Shopify',
      applying_btn: 'جارن التطبيق...',
      auto_fallback_hint: 'الرجوع التلقائي — ذكاء اصطناعي إذا كانت الاعتمادات متاحة، قالب محلي إذا نفدت.',
      background_hint: 'يمكنك تغيير القسم، يستمر في الخلفية',
      badge_draft: 'مسودة',
      badge_missing: 'بدون ALT',
      badge_published: 'منشور',
      badge_ready: 'جاهز',
      badge_saved: 'محفوظ',
      batch_close: 'إغلاق',
      batch_generate_btn: 'إنشاء ALT للمحددة',
      batch_progress: 'دفعة ALT جارية: {{done}} / {{total}}',
      batch_selected: '{{n}} صورة محددة (حد أقصى 50 لكل دفعة)',
      collection_all: 'المجموعة: الكل',
      compress_sub: 'تقليل حجم الملف',
      config_btn: '▼ تكوين',
      deselect_all: 'إلغاء تحديد الكل',
      empty_filtered: 'لا توجد منتجات تطابق الفلاتر',
      filter_all: 'الكل',
      format_label: 'صيغة الصورة',
      gen_alt_btn: 'إنشاء ALT',
      history_completed: 'مكتملة',
      history_empty: 'لم تُطبَّق أي عمليات بعد.',
      history_incomplete: 'غير مكتملة',
      history_loading: 'تحميل السجل...',
      history_running: 'جارن',
      history_savings: 'إجمالي الوفورات',
      history_subtitle: 'العمليات المطبقة على Shopify والأخطاء والاستعادات.',
      history_title: 'سجل التحسينات',
      history_undo_label: 'تراجع',
      last_update_label: 'آخر تحديث:',
      load_error: 'خطأ في تحميل القائمة',
      n_errors: '{{n}} أخطاء',
      n_products: '{{n}} منتجات',
      n_selected: '{{n}} محدد',
      next_page: 'التالي',
      no_products: 'لا توجد منتجات بصورة',
      no_vendor: 'بدون vendor',
      opt_batch_cancelled: 'تم إلغاء التحسين',
      opt_batch_done: 'اكتمل التحسين',
      opt_batch_running: 'التحسين جارن',
      optimize_n_btn: 'تحسين {{n}} صور',
      optimize_one_btn: 'تحسين الصورة',
      optimizing_btn: 'جارن التحسين...',
      orientation_all: 'الصيغة: الكل',
      orientation_landscape: 'العرض أكبر من الارتفاع',
      orientation_portrait: 'الارتفاع أكبر من العرض',
      orientation_square: 'مربع',
      page_info: 'الصفحة {{page}} من {{total}}',
      pagination: 'الصفحة {{page}} من {{total}}',
      prev: 'السابق',
      publish_btn: 'نشر',
      retry: 'إعادة المحاولة',
      select_all: 'تحديد الكل',
      size_100kb: 'ملفات تتجاوز 100 كيلوبايت',
      size_1mb: 'ملفات تتجاوز 1 ميغابايت',
      size_500kb: 'ملفات تتجاوز 500 كيلوبايت',
      size_all: 'كيلوبايت: الكل',
      stat_no_image: 'بدون صورة: {{count}}',
      stat_with_alt: 'مع ALT: {{count}}',
      stat_without_alt: 'بدون ALT: {{count}}',
      status_all: 'الحالة: الكل',
      status_label: 'الحالة:',
      status_needs: 'للتحسين',
      status_optimized: 'محسَّن بالفعل',
      status_stalled: 'متوقف',
      sync_btn: 'تحديث بيانات ALT من Shopify',
      sync_btn_title: 'يعيد قراءة الصور و ALT texts الحقيقية من Shopify',
      syncing: 'تحديث ALT...',
      template_active: 'الوضع المجاني نشط — صفر اعتمادات ذكاء اصطناعي. القالب:',
      template_custom_label: 'قالب مخصص',
      template_free_badge: '● مجاني — لا اعتمادات',
      template_preview_label: 'معاينة:',
      template_reset: 'استعادة الافتراضي',
      template_save: 'حفظ التكوين',
      template_saving: 'جارن الحفظ...',
      template_vars_label: 'المتغيرات المتاحة — انقر للإدراج:',
      timeout_msg: 'قاعدة البيانات تعالج منتجات كثيرة. أعد المحاولة بعد بضع ثوانن.',
      toast_alt_ai: 'تم إنشاء ALT عبر الذكاء الاصطناعي',
      toast_alt_cancelled: 'تم إلغاء تحديث ALT — يمكنك إعادة تشغيله',
      toast_alt_empty: 'ALT فارغ',
      toast_alt_from_cache: 'ALT من الذاكرة المؤقتة',
      toast_alt_gen_error: 'خطأ في إنشاء ALT',
      toast_alt_publish_error: 'خطأ في النشر',
      toast_alt_published: 'تم النشر على Shopify',
      toast_alt_save_error: 'خطأ في الحفظ',
      toast_alt_saved: 'تم حفظ ALT',
      toast_alt_sync_start_error: 'خطأ في بدء تحديث ALT',
      toast_alt_sync_started: 'بدأ تحديث بيانات ALT',
      toast_alt_template: 'تم إنشاء ALT عبر القالب (مجاني)',
      toast_alt_template_fallback: 'ALT عبر القالب (نفدت الاعتمادات)',
      toast_alt_update_error: 'خطأ في تحديث ALT',
      toast_alt_updated: 'تم تحديث بيانات ALT: {{n}} منتجاً تم تحليله',
      toast_applied: 'تم تطبيق الصورة على Shopify',
      toast_apply_batch_done: 'تم تطبيق {{n}} صور على Shopify',
      toast_apply_batch_errors: 'اكتمل التطبيق مع {{n}} أخطاء',
      toast_apply_batch_started: 'بدأ التطبيق: {{n}} صور. يمكنك تغيير القسم.',
      toast_batch_alt_done: 'اكتملت الدفعة',
      toast_batch_alt_started: 'بدأت الدفعة: {{n}} صور، {{c}} في كل مرة',
      toast_batch_done: 'اكتملت الدفعة: {{n}} صور محسَّنة. يمكنك تطبيقها على Shopify.',
      toast_batch_errors: '{{n}} صور لم تُعالَج. أعد المحاولة أو تحقق من السجلات.',
      toast_batch_started: 'بدأت الدفعة: {{n}} صور. يمكنك تغيير القسم، تستمر في الخلفية.',
      toast_cancel_error: 'خطأ في الإلغاء',
      toast_no_draft: 'لا توجد صورة محسَّنة للتطبيق',
      toast_no_images: 'لم يتم تحديد أي صورة',
      toast_no_ready: 'لا يوجد تحسين جاهز للتطبيق',
      toast_no_store: 'المتجر غير متاح',
      toast_optimize_error: 'خطأ في التحسين',
      toast_optimized: 'تمت معالجة الصورة. يمكنك الآن تطبيقها على Shopify.',
      toast_select_product: 'حدد منتجاً واحداً على الأقل',
      toast_template_save_error: 'خطأ في حفظ القالب',
      toast_template_saved: 'تم حفظ تكوين القالب',
      toast_undo_done: 'تمت استعادة الصورة الأصلية',
      toast_undo_error: 'خطأ أثناء الاستعادة',
      undoing_btn: 'جارن الاستعادة...',
      vendor_all: 'Vendor: الكل',
      toast_no_product: 'حدد منتجاً',
      toast_no_image: 'المنتج ليس له صورة',
      toast_no_preview: 'حسِّن صورة أولاً',
      toast_apply_error: 'خطأ في التطبيق على Shopify',
      n_ready: '{{n}} تحسينات جاهزة',
      preview_hint: 'حدد منتجاً أو أكثر لرؤية المعاينة',
      preview_first: 'المعاينة للمنتج الأول المحدد:',
      click_optimize_hint: 'انقر على "تحسين" للحصول على النتيجة',
      apply_single_btn: 'تطبيق',
    },
    alt_template: {
      section_title: 'قالب النص البديل',
      mode_label: 'وضع توليد النص البديل ALT',
      textarea_label: 'قالب مخصص',
      preview_label: 'معاينة',
      vars_label: 'المتغيرات المتاحة — انقر للإدراج',
      hint_template: 'الوضع المجاني: لا تُستهلك اعتمادات ذكاء اصطناعي للنص البديل.',
      hint_auto: 'احتياطي تلقائي: ذكاء اصطناعي إذا توفرت اعتمادات، وإلا قالب محلي.',
    },
    batch: {
      title: 'العمليات الدفعية',
      start: 'بدء',
      cancel: 'إلغاء',
      subtitle: 'Persistent server-side processing — continues even if you change page or close the tab',
      locked_title: 'Batch Operations not available',
      locked_desc: 'Batch Operations are available from the Starter plan. Process hundreds of products in parallel with one click.',
      upgrade_btn: 'Upgrade to Starter',
      op_content_label: 'Generate AI Content',
      op_content_desc: 'Description, SEO title, meta description, keywords',
      op_translate_label: 'Translate Products',
      op_translate_desc: 'Full translation into selected language',
      op_images_label: 'Optimize Images',
      op_images_desc: '1:1 resize and image compression',
      field_description_label: 'Description',
      field_description_hint: '150-250 words',
      field_seo_title_label: 'SEO Title',
      field_seo_title_hint: 'max 60 characters',
      field_meta_desc_label: 'Meta Description',
      field_meta_desc_hint: '100-160 characters',
      field_keywords_label: 'Keywords',
      field_keywords_hint: '5-10 keywords',
      count_all: 'الكل',
      status_pending: 'Queued',
      status_running: 'Running',
      status_completed: 'Completed',
      status_failed_job: 'Failed',
      status_cancelled: 'Cancelled',
      opt_in_progress: 'Image optimization in progress…',
      batch_in_progress: 'AI Batch in progress…',
      images_progress: '{{done}} / {{total}} images',
      products_progress: '{{done}} / {{total}} products',
      errors_count: '{{count}} errors',
      duration_label: 'Duration: {{time}}',
      starting: 'Starting...',
      seo_gen_in_progress: 'Generate + Publish SEO in progress',
      gen_publish_auto: 'Automatic generation and publishing to Shopify',
      section_operation: 'Operation',
      section_fields: 'Fields to generate',
      fields_selected: '{{count}}/{{total}} selected',
      fields_warning: 'Select at least one field to start the batch',
      fields_hint: 'One AI call per product generates all selected fields — lower latency and reduced costs.',
      section_options: 'Options',
      label_language: 'اللغة',
      label_tone: 'النبرة',
      tone_professional: 'Professional',
      tone_luxury: 'Luxury',
      tone_technical: 'Technical',
      tone_conversational: 'Conversational',
      label_target_lang: 'Target Language',
      images_note: '1:1 resize (800×800) + 85% quality compression.',
      section_quantity: 'Product Quantity',
      available_count: '{{count}} available',
      catalog_selection: '{{count}} product(s) selected from Catalog',
      remove_selection: 'Remove selection',
      products_selected_count: '{{count}} product(s) selected',
      processing: 'Processing…',
      start_btn: 'Start Processing',
      history_title: 'Batch History',
      history_subtitle: 'updated from DB',
      stat_running: 'Running',
      stat_completed: 'Completed',
      stat_products_ok: 'Products OK',
      no_batch: 'No batch executed',
      no_batch_hint: 'Jobs will appear here after the first processing',
      job_content: 'Generate AI Content',
      job_translate: 'Translation',
      job_images: 'Image Optimization',
      job_products: '{{done}}/{{total}} products',
      log_lang: 'Language:',
      log_tone: 'Tone:',
      toast_completed: 'اكتملت الدفعة: {{done}}/{{total}} منتج تمت معالجته',
      toast_failed: 'فشلت الدفعة: {{count}} أخطاء',
      toast_no_products: 'لا توجد منتجات متاحة',
      soon_lbl: 'قريباً',
      btn_analyze_seo: 'تحليل SEO',
      btn_view: 'عرض',
      toast_no_fields: 'حدد حقلاً واحداً على الأقل للإنشاء',
      toast_images_started: 'بدأ تحسين الصور: {{count}} منتج',
      toast_started: 'بدأت الدفعة: {{count}} منتج',
      toast_start_error: 'خطأ في البدء',
      toast_cancelled: 'تم إلغاء الدفعة',
      toast_cancel_error: 'خطأ في الإلغاء',
      fields_label: 'الحقول',
      log_summary: 'سجلات العمليات الفردية',
    },
    history: {
      title: 'السجل',
      empty: 'لم يتم العثور على عمليات',
      subtitle: 'تدقيق كامل لجميع تنفيذات الذكاء الاصطناعي — {{n}} عملية إجمالاً',
      refresh_btn: 'تحديث',
      total_operations: 'إجمالي العمليات',
      success_rate: 'معدل النجاح',
      n_successes: '{{n}} نجاح',
      credits_today: 'الأرصدة اليوم',
      products_today: 'المنتجات اليوم',
      avg_duration: 'متوسط المدة',
      last_autopilot: 'آخر Autopilot',
      filters: 'الفلاتر',
      filters_active: 'نشطة',
      reset_all: 'إعادة تعيين الكل',
      search_placeholder: 'البحث عن منتج...',
      op_all: 'كل الأنواع',
      op_description: 'وصف الذكاء الاصطناعي',
      op_seo_title: 'SEO Title AI',
      op_meta_description: 'Meta Description AI',
      op_batch: 'توليد دفعي',
      op_translation: 'ترجمة',
      op_image: 'صورة',
      op_sync: 'Sync Shopify',
      trigger_all: 'كل المشغّلات',
      status_all: 'كل الحالات',
      status_success: 'نجاح',
      status_partial: 'جزئي',
      status_error: 'خطأ',
      th_status: 'الحالة',
      th_type: 'نوع العملية',
      th_product: 'المنتج',
      th_trigger: 'المشغّل',
      th_seo_delta: 'SEO Delta',
      th_credits: 'الأرصدة',
      th_duration: 'المدة',
      th_timestamp: 'الطابع الزمني',
      loading: 'جارٍ التحميل...',
      remove_filters: 'إزالة الفلاتر',
      load_more: 'تحميل المزيد (عرض {{shown}} من {{total}})',
      details_title: 'تفاصيل التنفيذ',
      detail_op_id: 'معرّف العملية',
      detail_product_id: 'معرّف المنتج',
      detail_store_id: 'Store ID',
      detail_type: 'النوع',
      detail_trigger: 'المشغّل',
      detail_status: 'الحالة',
      detail_language: 'اللغة',
      detail_tone: 'النبرة',
      detail_tokens: 'الرموز المستخدمة',
      detail_fields: 'الحقول',
      detail_credits: 'الأرصدة',
      detail_duration: 'المدة',
      detail_seo_before: 'SEO قبل',
      detail_seo_after: 'SEO بعد',
      detail_timestamp: 'الطابع الزمني',
      error_prefix: 'خطأ: ',
      label_description: 'وصف الذكاء الاصطناعي',
      label_seo_title: 'SEO Title AI',
      label_meta_description: 'Meta Description AI',
      label_keywords: 'Keywords AI',
      label_batch: 'توليد دفعي',
      label_translation: 'ترجمة',
      label_image: 'تحسين الصورة',
      label_sync: 'Sync Shopify',
      label_push: 'نشر على Shopify',
    },
    batch_banner: {
      errors: 'أخطاء',
      optimizing: 'تحسين الصور',
      optimizing_cancelled: 'تم إلغاء التحسين',
      optimizing_completed: 'اكتمل التحسين',
      applying: 'التطبيق على Shopify',
      applying_cancelled: 'تم إلغاء التطبيق',
      applying_completed: 'اكتمل التطبيق',
      open_images: 'فتح الصور',
      open_catalog: 'فتح الكتالوج',
      type_collections: 'المجموعات',
      type_articles: 'المقالات',
      type_pages: 'الصفحات',
      type_contents: 'المحتويات',
      mode_publish: 'النشر',
      mode_both: 'إنشاء+نشر',
      mode_generate: 'إنشاء SEO بالذكاء الاصطناعي',
      state_cancelled: '(ملغى)',
      state_completed: '(مكتمل)',
    },
    app_banner: {
      expired: 'انتهت صلاحية رمز Shopify أو تم إلغاؤه.',
      reconnect_desc: 'أعد توصيل التطبيق لاستعادة المزامنة والنشر.',
      detected_in: 'تم الكشف في',
      reconnect_btn: 'أعد الاتصال الآن',
    },
    review_popup: {
      greeting: 'مرحباً! أنا هنا 👋',
      subtitle: 'آمل أن يسير كل شيء بشكل رائع مع AI Optimizer!',
      rating_title: 'هل تستمتع بالتطبيق؟',
      rating_desc: 'رأيك يساعدنا على التحسين والوصول إلى تجار Shopify الآخرين.',
      rating_tap: 'انقر على نجمة للتقييم',
      star: {
        terrible: 'فظيع',
        bad: 'ليس جيداً',
        average: 'متوسط',
        good: 'جيد!',
        excellent: 'ممتاز! 🚀',
      },
      positive_title: 'رائع! شكراً جزيلاً 🎉',
      positive_desc: 'تستغرق دقيقة واحدة فقط!',
      negative_title: 'شكراً على الملاحظات 🙏',
      negative_desc: 'هل لديك أفكار حول ما يمكننا تحسينه؟',
      review_btn: '⭐ اترك مراجعة',
      close_btn: 'إغلاق',
      dismiss: 'لا تظهر مرة أخرى',
      skip: 'تخطى →',
    },
    support: {
      title: 'الدعم',
      send: 'إرسال',
      placeholder: 'اكتب رسالتك...',
    },
    editor: {
      placeholder: 'اكتب هنا...',
      bold: 'عريض',
      italic: 'مائل',
      underline: 'تحت خط',
      h2: 'عنوان H2',
      h3: 'عنوان H3',
      paragraph: 'فقرة',
      ul: 'قائمة نقطية',
      ol: 'قائمة مرقمة',
      blockquote: 'اقتباس',
      link: 'إدراج رابط',
      remove_format: 'إزالة التنسيق',
      link_prompt: 'رابط URL',
    },
    recommendations: {
      empty: 'لا توجد إجراءات حرجة في الوقت الحالي. عمل رائع!',
      filter_all_prio: 'جميع الأولويات',
      filter_all_cat: 'جميع الفئات',
      count_shown: '{{n}} إجراء معروض',
      see: 'عرض',
      sev_high: 'عالي',
      sev_medium: 'متوسط',
      sev_low: 'منخفض',
      cat_catalog: 'الكتالوج',
      missing_meta_description: '{{count}} منتج بدون وصف ميتا',
      missing_description: '{{count}} منتج بدون وصف',
      missing_alt_text: '{{count}} صورة بدون نص ALT',
      missing_product_image: '{{count}} منتج بدون صورة',
    },
    audit: {
      not_detected: 'غير مكتشف',
      disabled: 'معطل',
      not_scanned: 'لم يتم التحليل',
      status_warning: 'تحذير',
      status_error: 'خطأ',
      cat_performance: 'الأداء',
      cat_trust: 'الثقة',
      cat_catalog: 'الكتالوج',
      checks_suffix: 'فحوصات',
      badge_err: 'خطأ',
      badge_warn: 'تحذير',
      badge_ok: 'موافق',
      value_label: 'القيمة',
      checks: {
        title: { name: 'العنوان', hint: 'عنوان الصفحة' },
        meta_description: { name: 'الوصف التعريفي', hint: 'وصف الصفحة الرئيسية التعريفي' },
        h1: { name: 'H1', hint: 'H1 واحد بالضبط لكل صفحة هو الأمثل' },
        h2: { name: 'H2', hint: 'يوصى بوجود H2 واحد على الأقل' },
        canonical: { name: 'Canonical', hint: 'رابط URL الأساسي' },
        lang: { name: 'اللغة', hint: 'سمة اللغة' },
        json_ld_structured_data: { name: 'JSON-LD / البيانات المنظمة', hint: 'البيانات المنظمة' },
        open_graph: { name: 'Open Graph', hint: 'ميتا الشبكات الاجتماعية' },
        twitter_card: { name: 'Twitter Card', hint: 'ميتا تويتر/X' },
        robots_txt: { name: 'robots.txt', hint: 'روبوتس' },
        sitemap_xml: { name: 'Sitemap.xml', hint: 'خريطة الموقع' },
        status_code: { name: 'رمز الحالة', hint: 'رمز HTTP' },
        indexability: { name: 'قابلية الفهرسة', hint: 'قابلية الفهرسة' },
        redirects: { name: 'إعادة التوجيه', hint: 'URL النهائي' },
        https: { name: 'HTTPS', hint: 'HTTPS' },
        load_time: { name: 'وقت التحميل', hint: 'مقاس من خادم إلى خادم' },
        page_weight: { name: 'حجم الصفحة', hint: 'حجم HTML للصفحة الرئيسية' },
        image_lazy_loading: { name: 'التحميل الكسول للصور', hint: 'الصور الكسولة' },
        mobile_viewport: { name: 'إطار العرض للجوال', hint: 'إطار العرض للجوال' },
        favicon: { name: 'Favicon', hint: 'Favicon' },
        images_with_alt: { name: 'صور مع ALT', hint: 'إمكانية الوصول للصور' },
        privacy_policy: { name: 'سياسة الخصوصية', hint: 'الخصوصية' },
        cookie_policy: { name: 'سياسة ملفات تعريف الارتباط', hint: 'كوكيز' },
        terms_conditions: { name: 'الشروط والأحكام', hint: 'الشروط' },
        contact_page: { name: 'صفحة الاتصال', hint: 'الاتصال' },
        shipping_policy: { name: 'سياسة الشحن', hint: 'الشحن' },
        returns_refunds: { name: 'الإرجاع والاسترداد', hint: 'الإرجاع' },
        social_links: { name: 'روابط التواصل الاجتماعي', hint: 'اجتماعي' },
        products_without_description: { name: 'منتجات بدون وصف', hint: 'أوصاف المنتجات' },
        products_without_images: { name: 'منتجات بدون صور', hint: 'صور المنتجات' },
        products_without_meta_description: { name: 'منتجات بدون وصف ميتا', hint: 'أوصاف ميتا للمنتجات' },
        duplicate_titles: { name: 'عناوين مكررة', hint: 'عناوين المنتجات' },
        duplicate_meta_descriptions: { name: 'أوصاف ميتا مكررة', hint: 'أوصاف ميتا للمنتجات' },
        thin_content_200_char: { name: 'محتوى رفيع (<200 حرف)', hint: 'محتوى المنتج' },
      },
    },
    score_card: {
      pillar_technical_seo: 'SEO التقني',
      pillar_ux: 'تجربة المستخدم',
      pillar_performance: 'الأداء',
      pillar_trust: 'الثقة',
      pillar_catalog: 'الكتالوج',
      label_excellent: 'ممتاز',
      label_good: 'قابل للتحسين',
      label_critical: 'حرج',
      no_audit_desc: 'التدقيق لم يُنفَّذ بعد — شغّل التدقيق للحصول على SEO التقني وتجربة المستخدم والثقة والأداء.',
      auditing: 'التدقيق جارٍ...',
      run_audit: 'تشغيل تدقيق الموقع 360°',
      calculated_on: 'محسوب في',
    },
    upgrade: {
      popular: '⭐ الأكثر شعبية',
      period: '/شهر',
      plan_header: 'الخطة',
      cta: 'الترقية إلى {{name}} — {{price}}{{period}}',
      dismiss: 'ليس الآن',
      feature_available: '{{feature}} متاح من خطة {{plan}}.',
      reason_credits_title: 'استنفاد رصيد الذكاء الاصطناعي',
      reason_credits_body: 'لقد وصلت إلى الحد الشهري لخطتك. قم بالترقية لمواصلة إنشاء المحتوى.',
      reason_products_title: 'تم الوصول إلى حد الكتالوج',
      reason_products_body: 'يتجاوز كتالوج Shopify الخاص بك حد الخطة الحالية. قم بالترقية لمزامنة جميع المنتجات.',
      reason_feature_title: 'ميزة مميزة',
      reason_feature_body: 'هذه الميزة متاحة في الخطط الأعلى.',
    },
    gsc: {
      connect_title: 'ربط Google Search Console',
      connect_desc: 'راقب مرات الظهور والنقرات ومعدل النقر والموضع المتوسط. اطلب إعادة الفهرسة بعد تحسينات الذكاء الاصطناعي.',
      connect_feat_analytics: 'تحليلات البحث',
      connect_feat_indexing: 'مراقبة الفهرسة',
      connect_feat_keywords: 'تتبع الكلمات المفتاحية',
      connect_feat_sitemap: 'مدير خريطة الموقع',
      connect_btn_loading: 'جارٍ الاتصال...',
      connect_btn: 'ربط حساب Google',
      prop_modal_title: 'اختر العقار',
      prop_modal_desc: 'اختر عقار Search Console للربط.',
      prop_modal_empty: 'لم يتم العثور على عقارات. تحقق من وجود عقارات في Google Search Console.',
      prop_modal_cancel: 'إلغاء',
      prop_modal_confirm: 'تأكيد',
      coming_soon_desc: 'متاح في {{phase}}',
      top_opp_title: 'أفضل فرص السيو',
      top_opp_sub: 'أفضل 10 استعلامات حسب Opportunity Score',
      copy: 'نسخ',
      copied: 'تم النسخ!',
      badge_quick_win: '🔥 Quick Win',
      badge_low_ctr: '⚡ CTR منخفض',
      badge_page_1: '🚀 صفحة 1',
      badge_high_imp: '📈 رؤية عالية',
      badge_brand: '🏷️ Brand',
      qt_category: 'فئة',
      qt_product: 'منتج',
      qt_generic: 'عام',
      qt_info: 'معلومات',
      qt_brand: 'Brand',
      seo_analysis: 'تحليل السيو',
      generating_ai: 'جارٍ إنشاء تحليل الذكاء الاصطناعي...',
      analysis_error: 'خطأ في إنشاء التحليل. حاول مرة أخرى لاحقاً.',
      estimated_value: 'القيمة المقدرة',
      clicks_monthly: 'نقرات محتملة/شهر',
      ctr_at_pos: 'CTR في الموضع {{pos}}',
      traffic_increase: 'زيادة الزيارات',
      current_stats: 'الحالي: {{clicks}} نقرة/شهر · +{{pts}} نقطة CTR مقدرة',
      priority_action: 'الإجراء ذو الأولوية',
      content_opt: 'تحسين المحتوى',
      title_seo: 'Title SEO',
      title_chars: '(50–60 حرفاً)',
      title_copied: 'تم نسخ العنوان!',
      h1_suggested: 'H1 مقترح',
      h1_page_title: '(عنوان الصفحة)',
      h1_copied: 'تم نسخ H1!',
      meta_desc: 'Meta Description',
      meta_chars: '(150–160 حرفاً)',
      meta_copied: 'تم نسخ الوصف!',
      faq_all_copied: 'تم نسخ جميع الأسئلة!',
      faq_suggested: 'أسئلة شائعة مقترحة',
      copy_all: 'نسخ الكل',
      faq_copied: 'تم نسخ السؤال!',
      related_kw: 'الكلمات المفتاحية ذات الصلة',
      click_to_copy: '· انقر للنسخ',
      kw_copied: 'تم نسخ "{{kw}}"!',
      tech_suggestions: 'اقتراحات تقنية',
      copy_keyword: 'نسخ الكلمة المفتاحية',
      kw_copied_plain: 'تم نسخ الكلمة المفتاحية!',
      shopify_products: 'منتجات Shopify',
      search_store: 'البحث في المتجر',
      optimize_content: 'تحسين المحتوى',
      col_impressions: 'مرات الظهور',
      col_position: 'الموضع',
      no_queries: 'لم يتم العثور على استعلامات بالمرشحات الحالية.',
      ai_panel_title: 'اقتراحات الذكاء الاصطناعي',
      analyze_query: 'تحليل الاستعلام →',
      sugg_title_improvement: 'Title tag',
      sugg_meta: 'Meta description',
      sugg_content_gap: 'محتوى مفقود',
      sugg_schema: 'Schema markup',
      sugg_links: 'روابط داخلية',
      opp_load_err: 'خطأ في تحميل فرص السيو',
      cache_updated: 'تم تحديث الكاش — إعادة تحميل البيانات',
      cache_error: 'خطأ في تحديث الكاش',
      loading_data: 'جارٍ تحميل بيانات Search Console...',
      load_error_title: 'تعذر تحميل الفرص',
      retry: 'إعادة المحاولة',
      tracked_queries: 'الاستعلامات المتتبعة',
      sku_excluded: '{{n}} SKU/EAN مستبعدة',
      total_impressions: 'إجمالي مرات الظهور (28 يوماً)',
      total_clicks: 'إجمالي النقرات (28 يوماً)',
      avg_ctr: 'متوسط CTR',
      ai_generating: 'جارٍ إنشاء تحليل الذكاء الاصطناعي...',
      ai_generating_sub: 'ستظهر اقتراحات الذكاء الاصطناعي هنا خلال لحظات.',
      no_ai_insights: 'لا تتوفر رؤى ذكاء اصطناعي',
      no_ai_insights_sub: 'لم يتم العثور على استعلامات ذات فرص تحسين كبيرة.',
      filter_all: 'الكل ({{n}})',
      search_placeholder: 'البحث في الاستعلامات...',
      refresh_title: 'تحديث البيانات',
      page_prev: '→ السابق',
      page_info: 'صفحة {{page}} / {{total}} · {{count}} استعلام',
      page_next: 'التالي ←',
      footer_note: 'بيانات Search Console آخر 28 يوماً · كاش 6 ساعات · العقار: {{url}}',
      footer_excluded: ' · {{n}} SKU/EAN مستبعدة',
      verdict_pass: 'مفهرسة',
      verdict_fail: 'غير مفهرسة',
      verdict_neutral: 'مستبعدة',
      stato_title: 'حالة Google — مصادر البيانات',
      in_sitemap: 'في خريطة الموقع',
      sitemap_registered_lbl: 'خرائط مواقع مسجلة',
      sitemap_errors_lbl: 'أخطاء خريطة الموقع',
      with_impressions: 'مع مرات الظهور',
      search_appear_note: 'صفحات ظهرت في البحث · {{days}} يوماً',
      not_real_indexed: '≠ صفحات مفهرسة فعلياً',
      index_estimate_lbl: 'تقدير الفهرسة',
      estimate_unavail: 'التقدير متاح بعد فحص 200 رابط. ابدأ المسح الجماعي لجمع العينة.',
      inspected_lbl: 'تم فحصها',
      indexed_confirmed: 'مفهرسة مؤكدة',
      not_indexed_lbl: 'غير مفهرسة',
      excluded_lbl: 'مستبعدة',
      certain_data: 'بيانات مؤكدة للروابط المفحوصة',
      batch_title: 'مسح جماعي — Inspection API',
      batch_priority: 'أولوية Analytics',
      batch_progress: 'تقدم فحص خريطة الموقع',
      batch_stopping: 'جارٍ الإيقاف…',
      batch_running: 'جارٍ المسح…',
      batch_starting: 'بدء التشغيل...',
      batch_done_lbl: 'اكتمل خريطة الموقع ✓',
      batch_start_btn: 'بدء المسح ({{n}} متاح)',
      batch_timeout: 'انتهت المهلة — انقر لإعادة الضبط',
      batch_stopping_wait: 'جارٍ الإيقاف — يرجى الانتظار…',
      batch_stop_btn: 'إيقاف المسح',
      batch_remaining: '{{n}} رابط لا يزال بحاجة للفحص',
      batch_quota_out: 'استُنفد الحصة اليومية — أعد المحاولة غداً',
      batch_start_err: 'خطأ في بدء المسح',
      batch_complete: 'اكتمل المسح: {{n}} رابط تم فحصه',
      dq_title: 'التفاصيل التقنية للـ API',
      dq_api_status: 'حالة الـ API',
      dq_daily_quota: 'الحصة اليومية',
      dq_used_today: 'مستخدمة اليوم',
      dq_remaining: 'المتبقية',
      dq_history: 'سجل الفحوصات',
      dq_completion: 'الإكمال',
      dq_days_est: 'أيام مقدرة',
      dq_start_for_eta: 'ابدأ المسح لحساب ETA',
      sm_no_sitemap: 'لم يتم العثور على خريطة موقع',
      sm_no_sitemap_desc: 'أضف sitemap.xml إلى Google Search Console لمراقبة الفهرسة.',
      sm_submit_ok: 'تم إرسال خريطة الموقع إلى Google',
      sm_in_progress: 'جارٍ الحساب…',
      sm_submit_btn: 'إرسال',
      insp_title: 'فحص الرابط',
      insp_quota: '{{used}}/{{limit}} فحوصات اليوم',
      insp_loading: 'جارٍ الفحص...',
      insp_btn: 'فحص',
      insp_domain_lbl: 'نطاق الموقع:',
      insp_domain_note: 'يجب أن ينتمي الرابط المفحوص إليه',
      insp_last_crawl: 'آخر زحف',
      insp_indexing: 'الفهرسة',
      insp_yes: 'نعم',
      insp_no: 'لا',
      insp_canonical_decl: 'Canonical المُعلَن',
      insp_canonical_diff: '⚠ Canonical من Google (مختلف)',
      insp_noindex: 'تم اكتشاف noindex',
      insp_open_gsc: 'فتح في Search Console',
      insp_err: 'خطأ في فحص الرابط',
      cov_title: 'التغطية — الأسباب',
      cov_real_data: 'بيانات حقيقية — Inspection API',
      cov_conf_high: 'موثوقية عالية',
      cov_conf_medium: 'موثوقية متوسطة',
      cov_conf_low: 'موثوقية منخفضة',
      cov_updated: 'تم التحديث:',
      cov_deselect: 'إلغاء التحديد',
      cov_inspected_note: 'روابط مفحوصة · انقر للتصفية',
      cov_none_inspected: 'لا فحوصات',
      cov_no_data: 'لا تتوفر بيانات تغطية',
      cov_no_data_desc: 'يتم إنشاء أسباب عدم الفهرسة تلقائياً مع كل فحص URL. استخدم "بدء المسح التلقائي" لملء هذا القسم.',
      cov_solution: 'الحل الموصى به',
      cov_filter_active: 'الفلتر نشط في السجل',
      ih_worklist: 'قائمة مهام السيو',
      ih_history: 'سجل الفحوصات',
      ih_filter_coverage: 'فلتر التغطية',
      ih_tab_all: 'الكل',
      ih_tab_not_ind: 'غير مفه.',
      ih_tab_indexed: 'مفهرسة',
      ih_tab_excluded: 'مستبعدة',
      ih_tab_errors: 'أخطاء',
      ih_tab_with_imp: 'مع ظهور',
      ih_tab_products: 'منتجات',
      ih_tab_collections: 'مجموعات',
      ih_sort_priority: '↓ الأولوية',
      ih_sort_impressions: '↓ الظهور',
      ih_sort_clicks_est: '↓ النقرات المقدرة',
      ih_sort_date: '↓ التاريخ',
      ih_sort_state: '↓ حالة GSC',
      ih_clear: 'مسح',
      ih_search: 'ابحث عن URL…',
      ih_open: 'فتح',
      ih_indexing_state: 'حالة الفهرسة',
      ih_canonical_diff: '⚠ Canonical من Google (مختار، مختلف)',
      ih_canonical_same: 'Canonical من Google (مطابق)',
      ih_ai_fix: 'تحسين بالذكاء الاصطناعي →',
      ih_total: '{{n}} رابط · {{total}} إجمالاً',
      ih_est_clicks: '· +{{n}} نقرة/شهر مقدرة',
      iai_title: 'اقتراحات AI — الفهرسة',
      iai_filter_note: '· انقر للتصفية',
      iai_prio_high: 'أولوية عالية',
      iai_prio_medium: 'أولوية متوسطة',
      iai_prio_low: 'أولوية منخفضة',
      iai_causes: 'الأسباب المحتملة:',
      iai_actions: 'الإجراءات الموصى بها:',
      fix_apply_all: 'تطبيق الكل',
      fix_applied: 'تم التطبيق',
      fix_suggestion: 'اقتراح',
      fix_chars: 'حرف',
      fix_content_impr: 'تحسينات المحتوى',
      fix_int_links: 'روابط داخلية مقترحة',
      fix_open_url: 'فتح الرابط',
      fix_close: 'إغلاق',
      fix_seo_opt: 'تحسين SEO',
      trend_title: 'اتجاه الفهرسة',
      trend_updated: 'محدث إلى',
      trend_coverage: 'التغطية',
      trend_30d_kpi: 'اتجاه 30 يوم',
      trend_no_data: 'البيانات التاريخية قيد البناء',
      trend_no_data_desc: 'سيكون الاتجاه متاحاً بعد جمع 2 لقطة على الأقل.',
      trend_one_snap: 'تم جمع لقطة واحدة من 2.',
      trend_start_scan: 'ابدأ مسحاً جماعياً للبدء.',
      trend_ind: 'مفه.',
      trend_not_ind: 'غير مفه.',
      trend_snap_note: 'لقطة لكل مسح',
      ic_loading: 'تحميل بيانات الفهرسة...',
      ic_load_err: 'تعذر تحميل بيانات الفهرسة',
      ic_clear_confirm: 'مسح كل سجل الفحوصات؟',
      ic_cleared: 'تم مسح السجل',
      ic_clear_err: 'خطأ في المسح',
      ic_seo_opp: 'فرص السيو — ملخص تنفيذي',
      ic_recoverable: 'روابط قابلة للاسترداد',
      ic_open_worklist: '⚡ فتح قائمة المهام →',
      ic_view_all: 'عرض الكل →',
      ic_crawled_ni: 'مُزاحَفة – غير مفهرسة',
      ic_crawled_ni_note: 'Google تعرفها لكن لا تعرضها',
      ic_discovered_ni: 'مكتشفة – غير مفهرسة',
      ic_discovered_ni_note: 'تم العثور عليها لكن لم تُزحف قط',
      ic_with_imp_ni: 'مع مرات ظهور GSC',
      ic_with_imp_ni_note: 'لها حركة مرور لكنها غير مفهرسة',
      ic_other_ni: 'أخرى غير مفهرسة',
      ic_other_ni_note: 'مجهولة لـ Google أو أخطاء',
      ic_refresh: 'تحديث',
      rh_title: 'سجل التغييرات',
      rh_versions: 'إصدار',
      rh_confirm: "استعادة الإصدار من {{date}}؟\n\nسيتم استبدال التغييرات الحالية في المحرر.",
      rh_restored_ok: 'تمت استعادة v{{v}} في قالب Shopify',
      rh_restored_editor: 'تم تحميل الإصدار v{{v}} في المحرر — انقر على حفظ لتطبيقه',
      rh_restore_err: 'خطأ في الاستعادة',
      rh_current: 'الحالي',
      rh_initial: 'الإصدار الأولي',
      rh_no_diff: 'لا توجد تغييرات نصية',
      rh_more_added: '+ {{n}} إضافة أخرى',
      rh_more_removed: '- {{n}} حذف آخر',
      rh_restore_btn: 'استعادة',
      rb_load_err: 'خطأ في تحميل robots.txt',
      rb_save_err: 'خطأ في الحفظ',
      rb_analyze_err: 'خطأ في التحليل',
      rb_score_good: 'ممتاز',
      rb_score_ok: 'يحتاج تحسين',
      rb_score_bad: 'حرج',
      rb_analysis_title: 'تحليل SEO للروبوتات',
      rb_analyzing: 'جارٍ التحليل…',
      rb_analyze: 'تحليل',
      rb_analyze_hint: 'انقر على "تحليل" للكشف التلقائي عن مشكلات SEO وفرص التحسين',
      rb_no_issues: 'لم يتم اكتشاف مشكلات',
      rb_no_issues_desc: 'ملف robots.txt الخاص بك يتبع أفضل ممارسات Shopify',
      rb_critical: 'حرج',
      rb_warning: 'تحذير',
      rb_validation_title: 'التحقق من Robots.txt',
      rb_reload: 'إعادة تحميل',
      rb_editor_title: 'محرر Robots.txt',
      rb_modified: 'معدّل',
      rb_diff_close: 'إغلاق الفرق',
      rb_editor_restore: 'استعادة',
      rb_saving: 'جارٍ الحفظ…',
      rb_save: 'حفظ',
      rb_blocking_warning: '🚨 أنت تحجب الموقع بالكامل — "Disallow: /" يمنع Google من فهرسة أي صفحة',
      rb_diff_preview: 'معاينة التغييرات:',
      rb_opportunity: 'فرصة',
      rb_checker_title: 'فحص الرابط',
      rb_check_btn: 'فحص',
      rb_allowed: 'مسموح',
      rb_blocked: 'محجوب',
      rb_sitemaps_title: 'خرائط الموقع المعلنة',
      ll_history_title: 'سجل LLMs.txt',
      ll_generated: 'مُوَلَّد',
      ll_restored_editor: 'تم تحميل الإصدار v{{v}} في المحرر — انقر على نشر لتطبيقه',
      ll_load_err: 'خطأ في تحميل llms.txt',
      ll_generate_err: 'خطأ في التوليد',
      ll_saved_ok: 'تم نشر LLMs.txt والتحقق منه في قالب Shopify',
      ll_not_configured: 'غير مُهيَّأ',
      ll_validation_title: 'التحقق من LLMs.txt',
      ll_not_found: 'لم يتم العثور على llms.txt في الموقع. استخدم "توليد من Shopify" لإنشائه تلقائياً.',
      ll_what_title: 'ما هو LLMs.txt؟',
      ll_what_desc: 'معيار /llms.txt هو ملف markdown يساعد نماذج AI (ChatGPT, Claude, Perplexity, Gemini) على فهم موقعك واستشهاده بشكل صحيح في الإجابات. يزيد الظهور في محركات إجابات AI.',
      ll_editor_title: 'محرر LLMs.txt',
      ll_generating: 'جارٍ التوليد…',
      ll_generate_btn: 'توليد من Shopify',
      tab_jsonld: 'JSON-LD',
      jl_load_err: 'خطأ في تحميل نظرة عامة على JSON-LD',
      jl_sec_overview: 'نظرة عامة',
      jl_sec_schemas: 'المخططات',
      jl_sec_problems: 'المشكلات',
      jl_sec_generate: 'تحسين بالذكاء الاصطناعي',
      jl_sec_preview: 'معاينة JSON',
      jl_sec_validate: 'التحقق',
      jl_sec_bulk: 'العمليات الجماعية',
      jl_sec_stats: 'الإحصائيات',
      jl_rich_results: 'أهلية النتائج الغنية',
      jl_eligible: 'مؤهل',
      jl_warnings: 'جزئي',
      jl_not_eligible: 'غير مؤهل',
      jl_field_coverage: 'تغطية الحقول',
      jl_what_title: 'ما هو JSON-LD؟',
      jl_what_desc: 'JSON-LD هو التنسيق الموصى به من Google للبيانات المنظمة. يُتيح النتائج الغنية في البحث (النجوم والأسعار ومسارات التنقل) ويساعد نماذج الذكاء الاصطناعي على فهم منتجاتك بشكل أفضل.',
      jl_score_poor: 'تغطية ضعيفة',
      jl_schemas_title: 'أنواع المخططات المدعومة',
      jl_status_valid: 'صالح',
      jl_status_partial: 'جزئي',
      jl_status_missing: 'غير مُهيَّأ',
      jl_valid_items: 'صالح',
      jl_issues: 'مشكلات',
      jl_google_test: 'اختبار في نتائج Google الغنية',
      jl_google_test_desc: 'بعد إنشاء JSON-LD، اختبره مباشرةً في أداة Google للتحقق من الأهلية.',
      jl_problems_title: 'مشكلات التشخيص',
      jl_no_problems: 'لم يتم العثور على مشكلات حرجة. تغطية JSON-LD تبدو جيدة!',
      jl_products_affected: 'منتجات متأثرة',
      jl_sev_critical: 'حرج',
      jl_sev_warning: 'تحذير',
      jl_prob_brand: 'العلامة التجارية / المورد مفقود',
      jl_prob_desc: 'الوصف مفقود',
      jl_prob_image: 'صورة المنتج مفقودة',
      jl_prob_sku: 'رقم SKU مفقود',
      jl_prob_gtin: 'GTIN / الباركود مفقود',
      jl_prob_meta: 'الوصف التعريفي مفقود',
      jl_prob_offers: 'السعر غير موجود في JSON-LD (يتطلب مقتطفاً في قالب Shopify)',
      jl_problems_tip: 'صحح الحقول المفقودة في قسم المنتجات أو استخدم تحسين الذكاء الاصطناعي.',
      jl_gen_title: 'إنشاء JSON-LD',
      jl_schema_type: 'نوع المخطط',
      jl_product_id: 'معرف المنتج (اتركه فارغاً للعينة)',
      jl_use_ai: 'استخدام إثراء الذكاء الاصطناعي (GPT)',
      jl_gen_btn: 'إنشاء JSON-LD',
      jl_gen_ok: 'تم إنشاء JSON-LD',
      jl_gen_err: 'خطأ في الإنشاء',
      jl_copied: 'تم النسخ!',
      jl_copy: 'نسخ',
      jl_preview_title: 'معاينة JSON-LD',
      jl_preview_err: 'خطأ في تحميل المعاينة',
      jl_load_preview: 'تحميل منتج نموذجي',
      jl_preview_empty: 'انقر على "تحميل منتج نموذجي" لمعاينة جميع مخططات JSON-LD',
      jl_val_title: 'التحقق المحلي من المخطط',
      jl_invalid_json: 'JSON غير صالح',
      jl_val_btn: 'التحقق من JSON-LD',
      jl_val_clear: 'مسح',
      jl_val_ok: 'صالح — مؤهل للنتائج الغنية',
      jl_val_fail: 'فشل التحقق',
      jl_val_note: 'يتحقق هذا المُحقق من متطلبات schema.org. للاختبار الرسمي من Google، استخدم Rich Results Test.',
      jl_val_err: 'خطأ في التحقق',
      jl_bulk_title: 'العمليات الجماعية',
      jl_bulk_gen: 'إنشاء الكل',
      jl_bulk_gen_desc: 'بناء Product JSON-LD لكل منتج وحفظه في قاعدة البيانات',
      jl_bulk_val: 'التحقق من الكل',
      jl_bulk_val_desc: 'تشغيل التحقق schema.org على JSON-LD الموجود',
      jl_bulk_fix: 'إصلاح وإثراء',
      jl_bulk_fix_desc: 'إعادة بناء JSON-LD للمنتجات التي تحتوي على أخطاء',
      jl_bulk_started: 'بدأت العملية الجماعية',
      jl_bulk_err: 'خطأ في بدء العملية الجماعية',
      jl_bulk_running: 'جارٍ التنفيذ',
      jl_bulk_done: 'مكتمل',
      jl_bulk_stop: 'إيقاف',
      jl_bulk_stopped: 'تم إيقاف العملية الجماعية',
      jl_errors: 'أخطاء',
      jl_stat_total: 'إجمالي المنتجات',
      jl_stat_eligible: 'مؤهل للنتائج الغنية',
      jl_stat_gen_today: 'تم الإنشاء اليوم',
      jl_stat_fixed: 'تم الإصلاح اليوم',
      jl_coverage_by_type: 'التغطية حسب نوع المحتوى',
      jl_type: 'النوع',
      jl_total: 'الإجمالي',
      jl_valid2: 'صالح',
      jl_missing2: 'مفقود',

      ll_revert: 'تراجع',
      ll_publishing: 'جارٍ النشر…',
      ll_publish: 'نشر',
      lp_filter_url: 'تصفية URL…',
      lp_copied: 'تم النسخ',
      lp_broken_empty: 'لم يتم اكتشاف روابط معطلة',
      lp_broken_empty_sub: 'جميع عناوين URL للمتجر في متناول (404 / 410 / timeout)',
      lp_timeout: 'Timeout — لا استجابة خلال 12 ثانية',
      lp_ratelimit_empty: 'لم يتم اكتشاف تحديد معدل',
      lp_ratelimit_empty_sub: 'الخادم لم يحدد طلبات الماسح الضوئي',
      lp_ratelimit_note: 'الصفحة في متناول لكن الخادم استجاب بـ429 أثناء الفحص',
      lp_server_empty: 'لم يتم اكتشاف أخطاء الخادم',
      lp_server_empty_sub: 'جميع عناوين URL تستجيب بشكل صحيح (لا 5xx)',
      lp_server_note: 'HTTP {{code}} — خطأ من جانب الخادم',
      lp_redirect_empty: 'لم يتم اكتشاف إعادة توجيه',
      lp_redirect_total: 'إجمالي إعادة التوجيه',
      lp_chains: 'السلاسل (>1 قفزة)',
      lp_loops: 'تم اكتشاف حلقات',
      lp_chains_header: 'سلاسل إعادة التوجيه',
      lp_chains_badge: '{{n}} سلاسل متعددة',
      lp_final_status: 'الحالة النهائية:',
      lp_canon_ok: 'صحيح',
      lp_canon_miss: 'مفقود',
      lp_canon_wrong: 'URL خاطئة',
      lp_canon_cross: 'عبر النطاق',
      lp_canon_redir: 'Canonical←إعادة توجيه',
      lp_canon_action_missing: 'أضف وسم canonical في قسم head من الصفحة.',
      lp_canon_action_wrong: 'صحح الـ canonical ليشير إلى URL النهائي لهذه الصفحة.',
      lp_canon_action_cross: 'يشير الـ canonical إلى نطاق خارجي. تحقق مما إذا كان مقصوداً أم خطأ.',
      lp_canon_action_redir: 'يشير الـ canonical إلى URL يعيد التوجيه. تحديثه بوجهة إعادة التوجيه النهائية.',
      lp_canon_no_data: 'بيانات canonical غير متاحة — ابدأ الفحص',
      lp_canon_issues: 'مشاكل Canonical ({{n}})',
      lp_canon_no_issues: 'لم يتم اكتشاف مشاكل canonical',
      lp_canon_sample: 'عينة محللة: {{n}} عنوان URL من متجرك (منتجات، مجموعات، صفحات، مقالات)',
      il_tab_orphans: 'الصفحات اليتيمة',
      il_tab_weak: 'روابط ضعيفة',
      il_tab_deep: 'صفحات عميقة',
      il_kpi_weak: 'روابط ضعيفة ≤2',
      il_kpi_deep: 'صفحات عميقة',
      il_orphan_empty: 'لا توجد صفحات يتيمة',
      il_orphan_empty_sub: 'جميع الصفحات تتلقى رابطاً داخلياً واحداً على الأقل',
      il_orphan_header: 'صفحات بدون روابط واردة ({{n}})',
      il_weak_empty: 'لا توجد صفحات ذات روابط ضعيفة',
      il_weak_empty_sub: 'جميع الصفحات تتلقى 3+ روابط داخلية',
      il_weak_header: 'صفحات ذات 1–2 رابط وارد ({{n}})',
      il_anchor_empty: 'نصوص الارتساء محسنة',
      il_anchor_empty_sub: 'لم يتم اكتشاف نصوص ارتساء عامة أو فارغة أو مكررة',
      il_anchor_generic: 'نصوص ارتساء عامة',
      il_anchor_generic_desc: 'نصوص مثل "انقر هنا"، "هنا"، "اكتشف"',
      il_anchor_empty_type: 'نصوص ارتساء فارغة',
      il_anchor_empty_desc: 'روابط بدون نص وصفي',
      il_anchor_dup: 'نصوص ارتساء مكررة',
      il_anchor_dup_desc: 'نفس النص → عناوين URL مختلفة',
      il_anchor_lbl_gen: 'عام',
      il_anchor_lbl_empty: 'فارغ',
      il_anchor_lbl_dup: 'مكرر',
      il_deep_empty: 'لا توجد صفحات عميقة جداً',
      il_deep_empty_sub: 'جميع الصفحات يمكن الوصول إليها في ≤3 نقرات من الصفحة الرئيسية',
      il_deep_header: 'صفحات >3 نقرات من الصفحة الرئيسية ({{n}})',
      il_deep_note: 'الصفحات ذات ∞ غير قابلة للوصول عبر الروابط الداخلية. أضفها إلى القوائم أو المجموعات.',
      il_hub_empty: 'لا توجد بيانات hub',
      il_hub_empty_sub: 'قم بتشغيل فحص لتحديد صفحات hub',
      il_hub_header: 'صفحات hub — الأكثر ارتباطاً داخلياً',
      il_hub_count: '{{n}} روابط داخلية واردة',
      lm_active: 'نشط',
      lm_not_installed: 'غير مثبت',
      lm_install_hint: 'التثبيت في القالب لمراقبة التنقل الحقيقي بدون crawling',
      lm_refresh: 'تحديث',
      lm_clear: 'مسح البيانات',
      lm_remove: 'إزالة من القالب',
      lm_installing: 'جارٍ التثبيت…',
      lm_install: 'تثبيت في القالب',
      lm_tab_404: 'أخطاء 404',
      lm_tab_redirect: 'فرص إعادة التوجيه',
      lm_tab_top: 'أفضل الصفحات',
      lm_kpi_visits: 'إجمالي الزيارات',
      lm_kpi_404s: 'أخطاء 404 حقيقية',
      lm_no_404: 'لم يتم اكتشاف أخطاء 404 من قبل المستخدمين',
      lm_visits: 'زيارات',
      lm_theme_prefix: 'القالب: ',
      lm_last_activity: 'آخر نشاط: ',
      lm_no_activity: 'لا زيارات بعد',
      lm_installed: 'تم تثبيت Monitor في القالب "{{name}}"',
      lm_err_install: 'خطأ في التثبيت',
      lm_confirm_remove: 'إزالة سكريبت المراقبة من القالب النشط؟',
      lm_removed: 'تمت إزالة السكريبت من القالب',
      lm_err_remove: 'خطأ في الإزالة',
      lm_confirm_clear: 'حذف جميع بيانات المراقبة المجمعة؟',
      lm_cleared: 'تم حذف البيانات',
      lm_err_clear: 'خطأ في الحذف',
      lm_modal_title: 'إنشاء إعادة توجيه 301',
      lm_modal_source: 'URL المصدر (404)',
      lm_modal_dest: 'الوجهة',
      lm_redirect_created: 'تم إنشاء إعادة توجيه 301 على Shopify',
      lm_err_redirect: 'خطأ في إنشاء إعادة التوجيه',
      lm_create_redirect: 'إنشاء إعادة توجيه',
      lm_creating: 'جارٍ الإنشاء…',
      lm_cancel: 'إلغاء',
      lm_info_title: 'كيف يعمل Live Monitor',
      lm_info_1: 'يضيف زر "التثبيت في القالب" تلقائياً سكريبت خفيف الوزن إلى القالب النشط عبر Shopify Themes API',
      lm_info_2: 'لكل زيارة حقيقية يجمع: URL، نوع الصفحة، الروابط الداخلية، أخطاء 404، المرجع الداخلي',
      lm_info_3: 'بدون crawling — بدون HTTP 429 — بيانات من زوار حقيقيين في الوقت الفعلي',
      lm_info_4: 'يبني تدريجياً خريطة الروابط الداخلية ويكتشف الصفحات اليتيمة',
      lm_no_redirect: 'لا حاجة لإعادة توجيه',
      lm_no_redirect_hint1: 'لم يسجل Live Monitor أي زيارات بعد. تظهر فرص إعادة التوجيه عندما يصادف المستخدمون الحقيقيون صفحات 404.',
      lm_no_redirect_hint2: 'في {{n}} زيارة تم تحليلها لم يصادف أي مستخدم صفحات 404. ممتاز!',
      lm_toolbar_ai: '{{count}} URL · {{ai}} مع اقتراح ذكاء اصطناعي',
      lm_toolbar_ignored: '· {{n}} مُتجاهَل',
      lm_sort_visits: 'الزيارات',
      lm_sort_date: 'التاريخ',
      lm_selected: '{{n}} محدد',
      lm_no_match: 'لا تطابق تلقائي',
      lm_create: 'إنشاء',
      lm_ignore: 'تجاهل',
      lm_err: 'خطأ',
      lm_bulk_ignored: 'تم تجاهل {{n}} URL',
      lm_bulk_created: 'تم إنشاء {{n}} إعادة توجيه',
      lm_errors: 'أخطاء',
      ls_scan_started: 'بدأ الفحص — سيكتمل في الخلفية',
      ls_scan_err: 'خطأ في بدء الفحص',
      ls_last_scan: 'آخر فحص: {{date}} · {{n}} URL',
      ls_no_scan_desc: 'لم يتم إجراء فحص — يكتشف الروابط المعطوبة وإعادة التوجيه والكانونيكال والصفحات اليتيمة',
      ls_scanning: 'جارٍ الفحص…',
      ls_rescan: 'إعادة الفحص',
      ls_start_scan: 'بدء الفحص',
      ls_canonical_issues: 'مشاكل Canonical',
      ls_scan_details: 'تفاصيل الفحص',
      ls_stat_total: 'إجمالي URL',
      ls_stat_errors: 'أخطاء',
      ls_no_scan: 'لم يتم إجراء فحص',
      ls_no_scan_long: 'ابدأ الفحص للكشف عن الروابط المعطوبة وسلاسل إعادة التوجيه ومشاكل Canonical والصفحات اليتيمة بدون روابط واردة',
      ls_first_scan: 'بدء الفحص الأول',
      db_gsc_connected: 'تم ربط Google Search Console!',
      db_gsc_err: 'خطأ في الاتصال بـ GSC: {{code}}',
      db_props_err: 'تعذر تحميل خصائص GSC',
      db_oauth_hint: 'أكمل تفويض Google في علامة التبويب الجديدة. ستتحدث الصفحة تلقائياً.',
      db_conn_err: 'خطأ في الاتصال بـ GSC',
      db_prop_selected: 'تم اختيار الخاصية: {{url}}',
      db_prop_err: 'خطأ في اختيار الخاصية',
      db_confirm_disconnect: 'قطع الاتصال بـ Google Search Console؟',
      db_disconnected: 'تم قطع الاتصال بـ GSC',
      db_disconnect_err: 'خطأ في قطع الاتصال',
      db_connected: 'Search Console متصلة',
      db_no_property: 'لم يتم اختيار خاصية',
      db_not_connected: 'غير متصل',
      db_connect_hint: 'ربط GSC لفتح التحليلات والمراقبة',
      db_change_prop: 'تغيير الخاصية',
      db_disconnect: 'قطع الاتصال',
      db_connect: 'ربط GSC',
      db_idx_subtitle: 'جودة SEO التقنية والفهرسة',
      db_lbl_gsc: 'GSC متصلة',
      db_lbl_sitemap: 'خرائط المواقع مُقدَّمة',
      db_lbl_indexed: 'URLs مفهرسة',
      db_health_real: 'مبني على بيانات Search Console الحقيقية',
      db_health_proxy: 'مبني على جودة الكتالوج — اربط GSC للبيانات الحقيقية',
      db_lbl_position: 'الترتيب',
      db_lbl_trend: 'الاتجاه 28 يوم',
      db_lbl_errors: 'أخطاء',
      db_connect_score: 'اربط GSC لحساب النتيجة',
      db_proxy_note: 'وكيل الكتالوج',
      db_stat_excluded: 'URLs مستبعدة',
      db_stat_seo_score: 'متوسط نقاط SEO',
      db_catalog_title: 'صحة الكتالوج',
      db_cat_alt: 'نص ALT للصور',
      db_cat_keywords: 'الكلمات المفتاحية المفقودة',
      db_cat_no_kw: '{{n}} منتج بدون كلمات مفتاحية',
      db_cat_count: '{{n}} / {{total}} منتج',
      tab_opportunities: 'فرص SEO',
      tab_indexing: 'الفهرسة',
      locked_available: 'متاح من خطة {{plan}}',
      locked_upgrade: 'الترقية إلى خطة {{plan}}',
      main_subtitle: 'SEO التقني · الفهرسة · Analytics · أتمتة الذكاء الاصطناعي',
      phase_3: 'المرحلة 3',
      interval_all: 'الكل',
      click_monthly_est: 'نقرات/شهر مقدرة',
      fix_title_updated: 'تم تحديث وسم العنوان',
      fix_meta_updated: 'تم تحديث الوصف التعريفي',
      fix_both_updated: 'تم تحديث العنوان والوصف التعريفي في Shopify',
      fix_apply_err: 'خطأ في التطبيق',
      rb_save_ok: 'تم حفظ robots.txt والتحقق منه في قالب Shopify',
      rb_draft_with_err: 'تم حفظ المسودة ({{err}})',
      rb_draft_manual: 'تم حفظ المسودة — اتبع التعليمات لتطبيقها على القالب',
      rb_critical_confirm: '🚨 تحذير حرج 🚨\n\nيحتوي ملف robots.txt على "Disallow: /" مما يحكم غلق الموقع بالكامل:\nلن يتمكن Google و Bing وجميع الروبوتات من الزحف الى اي صفحة.\n\nقد يؤدي ذلك الى ازالة الموقع من نتائج البحث.\n\nهل انت متاكد تماما انك تريد المتابعة؟',
      scan_err: 'خطأ في الفحص: {{msg}}',
      sm_send_err: 'خطأ في الإرسال',
      unknown_err: 'غير معروف',
      dq_today: 'اليوم',
      dq_7d: 'آخر 7 أيام',
      dq_30d: 'آخر 30 يومًا',
      dq_daily_avg: 'المتوسط اليومي',
      dq_at_pace: 'بمعدل ~{{n}}/يوم',
      job_stopped: 'توقف عند {{n}} رابط معالج',
      job_inspected: '{{n}} تم فحصها',
      job_errors: 'أخطاء',
      quota_remaining: 'الحصة المتبقية:',
      lk_trend: 'اتجاه الفهرسة',
      lk_batch: 'فحص دفعي (مسح شامل للروابط)',
      lk_ai: 'اقتراحات الذكاء الاصطناعي للفهرسة',
      footer_apis: 'Sitemaps API + Search Analytics + Inspection API',
      prod_status_lbl: 'الحالة:',
      prod_desc_lbl: 'الوصف:',
      prod_missing: 'غائب',
      state_disc: 'مكتشف',
      state_crawl: 'مُزاحَف',
      insp_api_real: 'Inspection API ✓ حقيقي',
      sm_count: '{{n}} خرائط موقع',
      sm_reliability: 'الموثوقية:',
      conf_high: 'عالية',
      conf_medium: 'متوسطة',
      conf_low: 'منخفضة',
      sm_urls: 'روابط URL في خريطة الموقع',
      sm_sample: 'العينة',
      sm_est_indexed: 'مقدر مفهرس',
      sm_est_nonidx: 'مقدر غير مفهرس',
      sm_coverage: 'التغطية المقدرة ⓘ',
      sm_idx_of: '~{{n}} مفهرسة من أصل {{t}} رابط في خريطة الموقع',
      sm_cov_est: 'التغطية المقدرة:',
      sm_margin_err: 'هامش الخطأ',
      sm_indexed_of: 'مفهرسة من',
      sm_sampled: 'مُعاينة',
      sm_th_sitemap: 'خريطة الموقع',
      sm_th_submitted: 'مُرسلة',
      sm_th_indexed: 'مفهرسة',
      sm_th_gap: 'الفجوة',
      sm_th_coverage: 'التغطية',
      sm_th_warning: 'تحذير',
      sm_th_errors: 'أخطاء',
      sm_th_lastmod: 'آخر تحديث',
      sm_th_actions: 'الإجراءات',
      rb_verified_result: 'تم الحفظ والتحقق في قالب Shopify ({{theme}}) — الملف:',
      rb_draft_result: 'تم حفظ المسودة. للتطبيق يدويًا: Shopify Admin → الثيمات → تعديل الكود →',
      ll_draft_result: 'تم حفظ المسودة. للتطبيق يدويًا: Shopify Admin → الثيمات → تعديل الكود →',
      ls_section_redirects: 'مدير إعادة التوجيه',
      rm_tab: 'مدير إعادة التوجيه',
      rm_subtitle: 'أدر جميع عمليات إعادة التوجيه في متجرك من مكان واحد.',
      rm_kpi_total: 'إجمالي القواعد',
      rm_kpi_active: 'إعادات التوجيه النشطة',
      rm_kpi_pending: '404 معلقة',
      rm_kpi_hits: 'الزيارات (30ي)',
      rm_kpi_chains: 'سلاسل',
      rm_kpi_loops: 'حلقات',
      rm_section_rules: 'القواعد',
      rm_section_suggest: 'اقتراحات الذكاء الاصطناعي',
      rm_section_health: 'السلامة',
      rm_section_import: 'استيراد / تصدير',
      rm_section_history: 'السجل',
      rm_create_title: 'إنشاء إعادة توجيه',
      rm_edit_title: 'تعديل إعادة التوجيه',
      rm_old_url: 'الرابط القديم',
      rm_new_url: 'الرابط الجديد',
      rm_old_url_ph: '/المسار-القديم',
      rm_new_url_ph: '/المسار-الجديد',
      rm_type: 'النوع',
      rm_type_301: '301 – دائم',
      rm_type_302: '302 – مؤقت',
      rm_notes: 'ملاحظات',
      rm_save: 'حفظ',
      rm_cancel: 'إلغاء',
      rm_create_ok: 'تم إنشاء إعادة التوجيه بنجاح.',
      rm_edit_ok: 'تم تحديث إعادة التوجيه بنجاح.',
      rm_create_err: 'خطأ أثناء إنشاء إعادة التوجيه.',
      rm_edit_err: 'خطأ أثناء حفظ إعادة التوجيه.',
      rm_dup_err: 'توجد بالفعل إعادة توجيه لهذا الرابط المصدر.',
      rm_empty_err: 'رابطا المصدر والوجهة مطلوبان.',
      rm_same_err: 'رابطا المصدر والوجهة لا يمكن أن يكونا متطابقين.',
      rm_search_ph: 'ابحث عن روابط…',
      rm_filter_all: 'الكل',
      rm_filter_active: 'نشطة',
      rm_filter_disabled: 'معطلة',
      rm_create_btn: 'إنشاء إعادة توجيه',
      rm_selected_items: '{{count}} محدد',
      rm_bulk_enable: 'تفعيل',
      rm_bulk_disable: 'تعطيل',
      rm_bulk_delete: 'حذف',
      rm_bulk_export: 'تصدير CSV',
      rm_bulk_ok: 'اكتملت العملية.',
      rm_table_old: 'الرابط القديم',
      rm_table_new: 'الرابط الجديد',
      rm_table_type: 'النوع',
      rm_table_hits: 'الزيارات',
      rm_table_status: 'الحالة',
      rm_table_actions: 'الإجراءات',
      rm_edit: 'تعديل',
      rm_duplicate: 'تكرار',
      rm_delete: 'حذف',
      rm_delete_confirm: 'حذف إعادة التوجيه هذه؟',
      rm_deleted_ok: 'تم حذف إعادة التوجيه.',
      rm_delete_err: 'خطأ أثناء الحذف.',
      rm_status_active: 'نشط',
      rm_status_disabled: 'معطل',
      rm_no_data: 'لم يتم العثور على إعادات توجيه.',
      rm_empty_state: 'لا توجد إعادات توجيه بعد. أنشئ أولى إعادة توجيه.',
      rm_total_redirects: '{{count}} إعادة توجيه إجمالاً',
      rm_import_title: 'استيراد إعادات التوجيه',
      rm_import_csv: 'CSV (old_url,new_url,type)',
      rm_import_shopify: 'Shopify Export CSV',
      rm_import_sf: 'Screaming Frog CSV',
      rm_import_btn: 'استيراد',
      rm_import_ok: 'اكتمل الاستيراد.',
      rm_import_err: 'خطأ أثناء الاستيراد.',
      rm_import_imported: 'تم استيراد {{count}}',
      rm_import_skipped: 'تم تخطي {{count}}',
      rm_export_title: 'تصدير إعادات التوجيه',
      rm_export_desc: 'تنزيل جميع إعادات التوجيه بالتنسيقات المتاحة.',
      rm_export_csv: 'تصدير CSV',
      rm_export_json: 'تصدير JSON',
      rm_ai_title: 'اقتراحات الذكاء الاصطناعي',
      rm_ai_subtitle: 'اكتشف الذكاء الاصطناعي روابط 404 ويقترح إعادات توجيه لمنتجات مشابهة.',
      rm_ai_accept: 'قبول',
      rm_ai_reject: 'رفض',
      rm_ai_accept_all: 'قبول الكل',
      rm_ai_loading: 'جاري التحليل…',
      rm_ai_empty: 'لا توجد اقتراحات في الوقت الحالي.',
      rm_chains_title: 'سلاسل إعادة التوجيه',
      rm_chains_desc: 'إعادات توجيه متسلسلة تبطّئ الموقع.',
      rm_chains_fix: 'إصلاح السلسلة',
      rm_chains_empty: 'لم يتم اكتشاف سلاسل.',
      rm_chains_fixed: 'تم إصلاح السلسلة.',
      rm_loops_title: 'حلقات إعادة التوجيه',
      rm_loops_desc: 'حلقات دائرية تسبّب أخطاء. تتطلّب إصلاحًا يدويًا.',
      rm_loops_fix: 'إصلاح',
      rm_loops_empty: 'لم يتم اكتشاف حلقات.',
      rm_gsc_title: '404 من Google Search Console',
      rm_gsc_subtitle: 'روابط غير موجودة رصدها GSC خلال 90 يومًا الماضية.',
      rm_gsc_empty: 'لم يتم اكتشاف 404 من GSC.',
      rm_history_title: 'سجل النشاط',
      rm_history_created: 'تم الإنشاء',
      rm_history_edited: 'تم التعديل',
      rm_history_deleted: 'تم الحذف',
      rm_history_disabled: 'تم التعطيل',
      rm_history_enabled: 'تم التفعيل',
      rm_history_imported: 'تم الاستيراد',
      rm_history_bulk: 'عملية جماعية',
      rm_history_empty: 'لم يتم تسجيل أي نشاط.',
      rm_sync_shopify: 'مزامنة من Shopify',
      rm_sync_shopify_desc: 'استيراد جميع إعادات التوجيه من Shopify. يتم إرسال إعادات التوجيه الجديدة تلقائياً إلى Shopify.',
      rm_sync_btn: 'مزامنة الآن',
      error_label: 'خطأ:',
      rb_checker_desc: 'تحقق مما إذا كان الرابط مسموحًا أو محظورًا بواسطة {{bot}} بناءً على robots.txt الحالي.',
      rb_rule: 'القاعدة:',
      rb_fix: 'إصلاح:',
      rb_gsc_note_title: 'تكامل Search Console',
      rb_gsc_note_body: 'في قسم الفهرسة، تشير الروابط ذات حالة "محظورة بواسطة robots" إلى صفحات لا يمكن لـ Google الزحف إليها.',
      rb_issues: 'مشاكل',
      rb_opps: 'فرص',
      rb_savings: 'الوفورات المقدرة:',
      never: 'أبدًا',
      samples_conf: '{{n}} عينة · الثقة {{c}}',
      batch_priority_note: 'روابط ذات ظهور Analytics تُفحص أولاً · حصة GSC 2000/يوم · معالجة في الخلفية',
      sm_samples: 'عينات',
      sm_footnote_ec: '~ قيم "قيد الحساب" = تقدير من Inspection API ({{n}} عينة · ثقة {{c}}). Sitemaps API تعيد 0 لفهارس الخريطة.',
      sm_footnote_noec: '~ قيم "قيد الحساب" = تقدير تناسبي. ابدأ الفحص الدفعي. Sitemaps API تعيد 0 لفهارس الخريطة.',
      ic_quota_note: 'محسوب على {{n}} رابط تم فحصها عبر Inspection API (حصة 2000/يوم). GSC Coverage يُظهر {{m}} رابطًا غير مفهرس في خريطة الموقع.',
      cov_crawled_ni: 'محتوى منخفض الجودة أو مكرر. حسّن المحتوى، أضف نصًا فريدًا، تحقق من وسم canonical.',
      cov_disc_ni: 'عثر عليه Google لكنه لم يزحف إليه بعد. زد ميزانية الزحف بروابط داخلية إضافية وخريطة موقع محدثة.',
      cov_dup_nocanon: 'أضف وسم canonical يشير إلى الصفحة الرئيسية.',
      cov_dup_googcanon: 'يتجاهل Google الـ canonical المعلن. تحقق من اتساق URL والـ canonical بين إصدارات سطح المكتب والجوال.',
      cov_redirect: 'إعادة توجيه نشطة. إذا كان مقصودًا، حدّث الروابط الداخلية للإشارة مباشرة إلى الوجهة.',
      cov_alternate: 'صفحة بديلة مع canonical صحيح — لا إجراء مطلوب إذا كان مقصودًا.',
      cov_noindex: 'أزل وسم meta noindex إذا أردت فهرسة الصفحة.',
      cov_robots: 'الصفحة محظورة بواسطة robots.txt. تحقق من توجيهات Disallow وحدّثها إذا لزم الأمر.',
      cov_removed: 'تمت إزالتها يدويًا من GSC. ألغِ الإزالة من لوحة Search Console إذا رغبت في ذلك.',
      cov_404: 'الصفحة غير موجودة. أعد الصفحة، أنشئ إعادة توجيه 301، أو أزل الروابط الداخلية لهذا الرابط.',
      cov_soft404: 'يعيد الخادم 200 لكن Google يتعامل معها كصفحة فارغة. تأكد من احتواء الصفحة على محتوى ذي صلة.',
      cov_server_err: 'خطأ في الخادم. تحقق من سجلات الخادم وتوافر الاستضافة أثناء الزحف.',
      cov_unknown_url: 'لم يكتشف Google هذا الرابط بعد. أضف روابط داخلية، حدّث خريطة الموقع، وانتظر عملية الزحف التالية.',
      qt_brand: 'علامة تجارية',
      qt_info: 'معلومات',
      qt_category: 'فئة',
      qt_product: 'منتج',
      qt_generic: 'عام',
      sugg_title_improvement: 'وسم العنوان',
      sugg_meta: 'وصف ميتا',
      sugg_content_gap: 'محتوى مفقود',
      sugg_schema: 'ترميز المخطط',
      sugg_links: 'روابط داخلية',
      verdict_indexed: 'مُفهرَس',
      verdict_not_indexed: 'غير مُفهرَس',
      verdict_excluded: 'مستبعد',
      badge_col_header: 'شارة',
      sitemap_label: 'خريطة الموقع',
      ls_tab_broken: 'روابط معطلة',
      ls_tab_redirect: 'إعادة توجيه',
      ls_tab_rate_limited: 'محدود المعدل',
      ls_tab_server_errors: 'أخطاء الخادم',
      ls_tab_canonical: 'العنوان الأساسي',
      ls_tab_internal: 'روابط داخلية',
      ls_section_monitor: 'مراقب مباشر',
      ls_section_audit: 'بنية الموقع',
      db_idx_title: 'نقاط الفهرسة',
      db_health_title: 'نقاط صحة SC',
      canonical_mismatch: 'تعارض Canonical',
    },
    so: {
      load_err: 'خطأ في تحميل Speed Optimizer',
      analyze_timeout: 'انتهت مهلة التحليل (90 ثانية) — يرجى المحاولة مجدداً',
      analyze_done: 'اكتمل التحليل!',
      analyze_failed: 'فشل التحليل: {{error}}',
      rate_limited: 'تم بلوغ حد الطلبات — تم تحديث البيانات من الذاكرة المؤقتة',
      analyze_err: 'خطأ في التحليل',
      opt_enabled: 'تم تفعيل {{label}} في القالب',
      opt_disabled: 'تم تعطيل {{label}}',
      opt_err: 'خطأ في التحسين',
      scan_err: 'خطأ في فحص القالب',
      img_err: 'خطأ في تحليل الصور',
      sg_protected: 'Safety Guard: تم تفعيل Protected',
      sg_standard: 'Safety Guard: تم تفعيل Standard',
      mode_err: 'خطأ في تغيير الوضع',
      plan_err: 'خطأ في إنشاء الخطة',
      strategy_applied: 'تم تطبيق استراتيجية {{label}} على القالب',
      strategy_err: 'خطأ في تطبيق الاستراتيجية',
      sessions_err: 'خطأ في تحميل الجلسات',
      rollback_done: 'اكتمل الاسترجاع — تمت استعادة القالب',
      rollback_err: 'خطأ في الاسترجاع',
      subtitle: 'تحسينات آمنة لقالب Shopify مع استرجاع فوري.',
      btn_rollback: 'استرجاع الكل',
      btn_analyze: 'تحليل الآن',
      analyzing_psi: 'معالجة PSI…',
      analyzing_queue: 'في قائمة الانتظار…',
      analyzing: 'جارٍ التحليل…',
      alert_no_token: 'رمز Shopify مفقود — تتطلب التحسينات اتصالاً نشطاً بالمتجر.',
      alert_no_scope: 'أذونات القالب مفقودة — لتطبيق التحسينات يجب إعادة تثبيت التطبيق.',
      perf_empty: 'لا يوجد تحليل متاح',
      perf_empty_hint: 'انقر على "تحليل الآن" لقياس أداء متجرك',
      suggestions: 'اقتراحات',
      strategy_active: 'نشطة',
      strategy_subtitle: 'يحدد هدف التحسين. انقر لمعاينة الخطة قبل التطبيق.',
      sg_header: 'يحد من العمليات التي يمكن للاستراتيجية تنفيذها.',
      sg_desc_protected: 'يحجب العمليات القياسية — التحسينات الآمنة فقط.',
      sg_desc_standard: 'يسمح بالتنفيذ الكامل للاستراتيجية المحددة.',
      quick_opts: 'تحسينات سريعة',
      sg_warning: 'Safety Guard: Protected — العمليات القياسية محجوبة. التحول إلى Standard أعلاه.',
      lcp_section: 'فحص قالب LCP',
      hist_section: 'سجل التحسينات',
      hist_empty: 'لم يتم تطبيق أي تحسينات بعد.',
      sessions_section: 'الجلسات وتأثير Lighthouse',
      sessions_empty: 'قم بتحميل الجلسات لرؤية التأثير الفعلي على Core Web Vitals.',
      img_count: '{{n}} صورة · {{kb}} كيلوبايت إجمالاً',
      img_oversized: '{{n}} صور >300 كيلوبايت',
      img_no_oversized: 'لا توجد صور كبيرة الحجم — ممتاز!',
      img_empty: 'انقر على "تحليل الصور" لإيجاد صور >300 كيلوبايت في القالب.',
      btn_refresh: 'إعادة تحميل',
      btn_load_sessions: 'تحميل الجلسات',
      btn_refresh_sessions: 'تحديث',
      btn_analyze_img: 'تحليل الصور',
      btn_refresh_img: 'تحديث',
      modal_risk_safe: 'آمن — لا يوجد تأثير بصري متوقع',
      modal_risk_medium: 'تحقق من مظهر الموقع بعد التفعيل',
      modal_risk_high: 'قد يؤثر على الوظائف المتقدمة',
      modal_reversible: 'قابل للتراجع في أي وقت — استخدم "استرجاع الكل" لاستعادة القالب الأصلي.',
      modal_cancel: 'إلغاء',
      modal_enable: 'تفعيل الآن',
      opt_no_token: 'أعد ربط متجر Shopify لاستخدام هذه الميزة',
      opt_blocked_guard: 'محجوب بواسطة Safety Guard (Protected) — التحول إلى Standard للتفعيل',
      opt_reversible: 'قابل للتراجع',
      opt_blocked_label: 'محجوب بواسطة Safety Guard — التحول إلى Standard',
      scan_scanning: 'الفحص جارٍ...',
      scan_empty_title: 'لم يتم تشغيل فحص القالب',
      scan_empty_desc: 'يحدد أقسام hero وslideshow في القالب لتمكين تحسينات LCP من جانب الخادم.',
      scan_btn: 'فحص القالب',
      scan_active_theme: 'القالب النشط',
      scan_files: '{{n}} ملف Liquid تم فحصها · {{s}} أقسام LCP محددة',
      scan_hero_label: 'قسم hero/LCP',
      scan_optimized: 'محسّن',
      scan_no_lcp: 'لم يتم تحديد أي أقسام hero/LCP تلقائياً في القالب.',
      scan_reload: 'إعادة تحميل',
      plan_title: 'الخطة: {{label}}',
      plan_ops: '{{n}} عملية مخططة',
      plan_action_enabled: 'نشطة بالفعل',
      plan_action_enable: 'تفعيل',
      plan_action_disable: 'تعطيل',
      plan_strategy: 'الاستراتيجية: ',
      plan_guard: 'Safety Guard: ',
      plan_active_ops: 'العمليات النشطة: ',
      plan_blocked: '{{n}} محجوبة بواسطة Safety Guard',
      plan_low_conf: 'بعض التحسينات لها ثقة منخفضة للقالب المكتشف.',
      plan_cancel: 'إلغاء',
      plan_apply: 'تطبيق الاستراتيجية',
      plan_blocked_btn: 'محجوب (نتيجة منخفضة)',
      hist_rollback: 'استرجاع كامل — جميع التحسينات أُزيلت',
      hist_enabled: 'مُفعَّل',
      hist_disabled: 'مُعطَّل',
      hist_active: 'نشط',
      sess_no_sessions: 'لا توجد جلسات تحسين مسجلة. يتم إنشاء الجلسات عند تطبيق استراتيجية.',
      sess_waiting: 'في انتظار PSI',
      strategy_label: 'استراتيجية {{s}}',
      strategy_opts: '{{n}} تحسينات',
      strategy_active: 'نشطة',
      quota_err: 'خطأ في تحميل حصة PSI',
      quota_api_key: 'مفتاح API مُهيأ:',
      quota_yes: '✓ نعم',
      quota_no: '✗ لا (حصة عامة)',
      quota_cache_ttl: 'TTL الكاش:',
      quota_hourly: 'الحد الساعي:',
      quota_daily: 'الحد اليومي:',
      quota_success: 'النجاحات اليوم:',
      quota_hit_ratio: 'نسبة إصابات الكاش:',
      quota_circuit: 'قاطع الدائرة:',
      quota_circuit_open: 'مفتوح ({{n}} أعطال)',
      quota_circuit_closed: 'مغلق',
      quota_loading: 'جارٍ التحميل...',
      diag_err: 'خطأ التشخيص',
      diag_refresh: 'تحديث',
      diag_load: 'تحميل التشخيص',
      diag_patches: 'التصحيحات النشطة ({{n}})',
      diag_none: 'لا شيء',
      diag_unavailable: 'غير متاح',
      diag_no_patches: 'لا توجد تصحيحات نشطة',
      diag_calibrated: '📈 مُعايَر',
      diag_generated: 'تم الإنشاء:',
      badge_server_side: 'من جانب الخادم',
      badge_standard: 'قياسي',
      badge_lcp: 'LCP',
      badge_critical: 'حرج',
      badge_safe: 'آمن',
      badge_medium: 'متوسط',
      badge_safety_guard: 'حارس الأمان',
      diag_theme_fingerprint: 'بصمة القالب',
      diag_engine_confidence: 'ثقة المحرك',
      perf_score_label: 'نقاط الأداء',
      section_perf_overview: 'نظرة عامة على الأداء',
      section_strategy_intent: 'النية الاستراتيجية',
      safety_guard_title: 'حارس الأمان',
      section_script_analyzer: 'محلل تأثير السكريبت',
      script_col_file: 'ملف',
      script_col_size: 'الحجم',
      script_col_impact: 'التأثير',
      script_col_defer_risk: 'خطر التأجيل',
      metric_js_total: 'إجمالي JS',
      metric_css_total: 'إجمالي CSS',
      perf_updated: 'تم التحديث:',
      perf_stale: 'بيانات قديمة (PSI غير متاح)',
      perf_from_cache: 'من الذاكرة المؤقتة',
      perf_psi_ok: 'PSI بخير',
      debug_invalid_token_title: 'رمز غير صالح (401) — انتهت صلاحية الرمز في MongoDB أو تم إلغاؤه.',
      debug_reconnect_desc: 'لم يقم callback OAuth باستبدال الرمز بعد إعادة التثبيت الأخيرة. انقر على الزر أدناه لبدء OAuth جديد.',
      debug_reconnect_btn: 'إعادة الاتصال بـ OAuth الآن (يفتح Shopify)',
      debug_reconnect_note: 'بعد الموافقة على الأذونات في Shopify، سيقوم الـ callback بتحديث الرمز في MongoDB تلقائياً.',
    },
    drafts: {
      approved: 'تمت الموافقة على المسودة!',
      approve_err: 'خطأ في الموافقة',
      published: 'تم النشر على Shopify!',
      publish_err: 'خطأ في النشر',
      title: 'المسودات والنتائج',
      subtitle: 'راجع وافق ونشر المحتوى المحسّن',
      empty: 'لا توجد مسودات للمراجعة',
      empty_hint: 'قم بإنشاء محتوى ذكاء اصطناعي لإنشاء مسودات جديدة',
      badge_approved: 'معتمد',
      badge_draft: 'مسودة',
      field_desc: 'الوصف',
      btn_view: 'عرض',
      btn_approve: 'موافقة',
      btn_publish: 'نشر',
      modal_title: 'تفاصيل المسودة',
      chars_seo: '/60 حرفاً',
      chars_meta: '/160 حرفاً',
      not_present: 'غير موجود',
      not_present_pl: 'غير موجودة',
      btn_close: 'إغلاق',
      btn_publish_shopify: 'نشر على Shopify',
      seo_title: 'عنوان SEO',
      meta_description: 'وصف ميتا',
      keywords_label: 'الكلمات المفتاحية',
    },
    usage: {
      title: 'الاستخدام والخطة',
      subtitle: 'راقب الاستخدام وأدر اشتراكك',
      plan_badge: 'الخطة:',
      current: 'الاستخدام الحالي',
      credits: 'رصيد الذكاء الاصطناعي',
      used: 'المستخدم:',
      unlimited: 'غير محدود ∞',
      remaining: 'المتبقي: {{n}}',
      products_sync: 'المنتجات المتزامنة',
      plans_heading: 'الخطط المتاحة',
      most_popular: '⭐ الأكثر شعبية',
      active_plan: 'الخطة النشطة',
      current_plan: 'الخطة الحالية',
      btn_upgrade: 'الترقية إلى {{name}}',
      trend_heading: 'اتجاه الاستخدام',
      trend_coming: 'مخطط الاستخدام (قريباً)',
      stat_products: 'المنتجات المحللة',
      stat_content: 'المحتوى المُنشأ',
      stat_translations: 'الترجمات',
      stat_images: 'الصور المحسّنة',
    },
    support: {
      msg_sent: 'تم إرسال الرسالة!',
      msg_err: 'خطأ في إرسال الرسالة',
      status_open: 'مفتوح',
      status_progress: 'قيد التنفيذ',
      status_closed: 'مغلق',
      title: 'الدعم',
      subtitle: 'الأسئلة الشائعة والأدلة والدردشة مع فريقنا',
      faq_heading: 'الأسئلة الشائعة',
      guide_heading: 'الدليل السريع',
      chat_heading: 'دردشة الدعم',
      no_msgs: 'لا توجد رسائل',
      no_msgs_hint: 'ابدأ محادثة مع الدعم',
      placeholder: 'اكتب رسالة...',
      contacts_heading: 'جهات الاتصال',
      contact_hours_label: 'الأوقات',
      contact_hours: 'الاثنين-الجمعة 9:00-18:00 CET',
      contact_response_label: 'وقت الاستجابة',
      contact_response: 'خلال 24 ساعة',
      guide_step1: 'اذهب إلى قسم',
      guide_products: 'المنتجات',
      guide_step1b: 'لرؤية منتجاتك',
      guide_step2: 'حدد منتجًا واذهب إلى',
      guide_ai_content: 'محتوى AI',
      guide_step3: 'أنشئ وصفًا وعنوان SEO وميتا وصف وكلمات مفتاحية',
      guide_step4: 'تحقق من النتائج في',
      guide_history: 'السجل',
    },
    transl: {
      load_err: 'خطأ في تحميل العناصر',
      published: 'تم نشر الترجمة على Shopify!',
      pub_err: 'خطأ في النشر',
      err_no_items: 'حدد عنصرًا واحدًا على الأقل',
      err_no_fields: 'حدد حقلًا واحدًا على الأقل للترجمة',
      item_err: 'خطأ في الترجمة',
      done_one: 'اكتملت الترجمة!',
      done_many: 'تُرجم {{n}} عنصر!',
      copied: 'تم النسخ إلى الحافظة',
      title: 'الترجمات',
      gate_plan: 'متاح من خطة Starter',
      gate_desc: 'ترجم المنتجات والمجموعات والمقالات إلى 8 لغات باستخدام الذكاء الاصطناعي',
      gate_btn: 'الانتقال إلى خطة Starter',
      subtitle: 'ترجم المنتجات والمجموعات والمقالات والصفحات إلى لغات متعددة باستخدام الذكاء الاصطناعي',
      translating: 'جارٍ الترجمة…',
      search_placeholder: 'البحث بالعنوان…',
      select_page: 'تحديد الصفحة',
      sel_abbrev: 'محدد',
      total_items: 'المجموع',
      loading: 'جارٍ التحميل…',
      no_results: 'لا توجد نتائج لهذا البحث',
      prev: '→ السابق',
      tot_abbrev: 'مجموع',
      next: 'التالي ←',
      deselect_all: 'إلغاء تحديد الكل',
      lang_heading: 'اللغة المستهدفة',
      fields_heading: 'الحقول للترجمة',
      select_hint: 'حدد عناصر من القائمة لتفعيل الترجمة',
      results_heading: 'النتائج',
      clear_results: 'مسح النتائج',
      badge_published: 'منشور',
      publishing: 'جارٍ النشر…',
      done: 'تم',
      publish: 'نشر',
      copy: 'نسخ',
      tab_products: 'المنتجات',
      tab_collections: 'المجموعات',
      tab_articles: 'المقالات',
      tab_pages: 'الصفحات',
      field_title: 'العنوان',
      field_description: 'الوصف',
      field_seo_title: 'SEO Title',
      field_meta_description: 'Meta Description',
      field_body_html: 'الوصف / المحتوى',
      empty_hint_select: 'حدد عنصرًا أو أكثر من القائمة واختر اللغة ثم انقر',
      translate_label: 'ترجم',
      items_selected: 'عناصر',
      item_selected: 'عنصر',
      selected_label: 'محدد',
      choose_fields_hint: 'اختر الحقول وانقر على ترجم',
    },
  },

  ja: {
    nav: {
      overview: '概要',
      catalog: 'カタログ',
      content: 'AIコンテンツ',
      translations: '翻訳',
      images: '画像',
      batch: 'バッチ操作',
      speed: 'スピードオプティマイザー',
      history: '履歴',
      usage: '使用状況とプラン',
      settings: '設定',
      support: 'サポート',
    },
    common: {
      save: '保存',
      cancel: 'キャンセル',
      delete: '削除',
      close: '閉じる',
      confirm: '確認',
      loading: '読み込み中...',
      error: 'エラー',
      success: '成功',
      search: '検索',
      filter: 'フィルター',
      all: 'すべて',
      yes: 'はい',
      no: 'いいえ',
      back: '戻る',
      next: '次へ',
      apply: '適用',
      generate: '生成',
      publish: '公開',
      optimize: '最適化',
      refresh: '更新',
    },
    settings: {
      title: '設定',
      subtitle: 'AIコントロールセンター',
      tabs: {
        general: '一般',
        localization: 'ローカライゼーション',
        ai_engine: 'AIエンジン',
        appearance: '外観',
        piano: 'プラン',
        advanced: '詳細設定',
      },
      save_btn: '設定を保存',
      unsaved: '未保存の変更',
      action_loading: '処理中...',
      general: {
        contents: 'コンテンツ',
        default_lang: 'デフォルトコンテンツ言語',
        tone: 'グローバルコンテンツトーン',
        tone_hint: '商品・コレクション・記事・バッチに適用',
        seo_rules: 'SEOルール',
        seo_title_max: 'SEOタイトルの最大文字数',
        seo_title_hint: '推奨: 50〜60文字',
        meta_max: 'メタディスクリプションの最大文字数',
        meta_hint: '推奨: 150〜160文字',
        chars: '文字',
        images: '画像設定',
        img_format: 'デフォルト形式',
        img_square: 'スクエア (1:1)',
        img_landscape: 'ランドスケープ (4:3)',
        img_portrait: 'ポートレート (3:4)',
        img_quality: '圧縮品質',
        img_quality_low: '50% (圧縮)',
        img_quality_high: '100% (最高品質)',
        store_info: 'ストア情報',
        store_domain: 'ドメイン',
        store_plan: 'プラン',
        store_installed: 'インストール日',
      },
      ai: {
        strategy: 'AI戦略',
        params_title: '生成パラメータ',
        creativity: 'クリエイティビティ',
        creative_low: '保守的',
        creative_high: 'クリエイティブ',
        seo_strictness: 'SEO厳格度',
        seo_low: '柔軟',
        seo_high: '厳格',
        tone_label: 'グローバルトーン',
        auto_title: 'AI自動最適化',
        auto_hint: 'コンテンツを自動的に最適化するには有効にしてください',
        on: 'アクティブ',
        off: 'オフ',
        threshold: '最適化しきい値',
        threshold_low: 'すべて最適化',
        threshold_high: '最悪のもののみ',
        threshold_hint: 'SEOスコア < {{n}} のアイテムに適用',
        frequency: '頻度',
        scope: '範囲',
        triggers: 'トリガー',
        img_format: '画像形式',
        img_square: 'スクエア 1:1',
        img_square_sub: '800×800 px',
        img_landscape: 'ランドスケープ 4:3',
        img_landscape_sub: '800×600 px',
        img_portrait: 'ポートレート 3:4',
        img_portrait_sub: '600×800 px',
        img_no_resize: 'リサイズなし',
        img_no_resize_sub: '元のサイズ',
        compress: '圧縮',
        compress_hint: 'ファイルサイズを削減',
        quality: '品質',
        daily_credits: '本日のAIクレジット',
        remaining: '残り {{n}}',
        reset_in: 'リセットまで',
        running: '処理中 — {{done}}/{{total}} 商品',
        run_now: '今すぐ実行',
        run_desc: 'スコア < {{threshold}} のアイテムを最適化: {{scope}}',
        preview_title: 'プレビュー — 前 / 後',
        before: '前',
        after: 'AI後',
        no_keywords: 'キーワードなし',
        preview_note: '商品「ランニングシューズ Pro X1」の例 — 即時更新',
        alt_mode_label: 'ALTテキスト生成モード',
        alt_preview: 'プレビュー',
        alt_mode_ai: 'スマートAI',
        alt_mode_ai_desc: 'OpenAIが各画像に最適化されたALTを生成',
        alt_mode_template: '無料テンプレート',
        alt_mode_template_desc: 'AIクレジット不要 — 以下のテンプレートを使用',
        alt_mode_auto: '自動フォールバック',
        alt_mode_auto_desc: 'AI優先、クレジット切れ時はテンプレート',
        alt_hint_template: '無料モード: ALTテキストにAIクレジットを消費しません。',
        alt_hint_auto: '自動フォールバック: クレジットがあればAI、なければ自動テンプレート。',
        pct_done: '{{pct}}% 完了',
        n_errors: '{{n}} エラー',
        alt_template_label: 'カスタムテンプレート',
        alt_vars_label: '利用可能な変数 — クリックして挿入',
      },
      piano: {
        credits_title: 'クレジット使用状況',
        plan_label: 'プラン',
        extra_credits: '追加クレジット',
        unlimited: '∞ 無制限クレジット',
        unlimited_sub: 'エリートプラン — 月次制限なし',
        plan_credits: 'プランクレジット',
        consumed: 'プランから消費済み',
        residual: 'プランの残り',
        extra_available: '利用可能な追加クレジット',
        extra_sub: '月次プラン後にのみ消費',
        total_available: '合計利用可能',
        consumed_cycle: '現在のサイクルで消費したクレジット',
        status_active: 'アクティブ',
        status_pending: '処理中',
        status_frozen: '⚠ 停止中',
        status_free: '無料 / サブスクリプションなし',
        trial_active: 'トライアル中',
        trial_access: '{{date}}まで全機能利用可能。',
        sub_status: 'サブスクリプション状態',
        next_credit_reset: '次回クレジットリセット',
        trial_end: 'トライアル終了',
        trial_label: '無料トライアル',
        trial_used: '使用済み',
        trial_available: '{{n}}日間利用可能',
        cancel_btn: 'サブスクリプションをキャンセル',
        cancelling: 'キャンセル中...',
        plans_title: '利用可能なプラン',
        plan_active: 'アクティブプラン',
        plan_current: '現在のプラン',
        per_month: '/月',
        downgrade: '無料に戻す',
        downgrading: 'ダウングレード中...',
        upgrade: 'アップグレード',
        downgrade_btn: 'ダウングレード',
        redirecting: 'リダイレクト中...',
        trial_btn: '無料で試す',
        trial_btn_days: '({{n}}日)',
        plan_overage: '追加AIクレジット: 1クレジットあたり{{price}}',
        plan_no_overage: '追加AIクレジット料金なし',
        plan_trial_line: '{{n}}日間の無料トライアル',
        plans_note: '有料プランには{{n}}日間の無料トライアルが含まれます。初期費用なし。Shopify Billingで決済。',
        credits_section: '追加クレジットを購入',
        credits_desc: '追加クレジットは月次プランに加算され、有効期限なし。全プラン対応。',
        one_time: '一回限り',
        per_credit: '¢/クレジット',
        buy: '購入',
        payment_note: 'Shopify Billingで安全に処理。サーバーに支払情報は保存しません。',
        history_title: 'クレジット購入履歴',
        history_count: '{{n}}件の購入',
        hist_invested: '合計投資額',
        hist_bought: '購入済みクレジット',
        hist_available: 'まだ利用可能',
        hist_empty: '追加クレジットの購入はありません。',
        hist_date: '日付',
        hist_pkg: 'パッケージ',
        hist_credits: 'クレジット',
        hist_amount: '金額',
        hist_status: 'ステータス',
        hist_completed: '完了',
        hist_pending: '保留中',
        hist_declined: '拒否',
        trend_title: '使用トレンド',
        trend_placeholder: '使用グラフ (Shopify Billingで利用可能)',
        stats_products: '分析した商品',
        stats_content: '生成したコンテンツ',
        stats_translations: '翻訳',
        stats_images: '最適化した画像',
        toast_sub_pending: 'サブスクリプション処理中 — まもなく確認メールが届きます。',
        toast_sub_activated: '{{name}} が有効になりました!',
        toast_trial_suffix: '({{n}}日間無料トライアル)',
        toast_sub_error: 'サブスクリプション確認エラー',
        toast_purchase_duplicate: '購入は既に登録されています。',
        toast_credits_added: '+{{n}} クレジットがアカウントに追加されました!',
        toast_purchase_error: '購入確認エラー',
        toast_purchase_start_error: '購入開始エラー',
        toast_sub_start_error: 'サブスクリプション開始エラー',
        toast_store_unavailable: 'ストアはまだ接続されていません。Shopify管理画面でアプリを再読み込みしてお試しください。',
        toast_sub_cancelled: 'サブスクリプションをキャンセルしました。プランは無料に戻りました。',
        toast_sub_cancel_error: 'サブスクリプションキャンセルエラー',
        pkg_100_label: '100クレジット',
        pkg_100_desc: '指定払いに最適',
        pkg_300_label: '300クレジット',
        pkg_300_desc: '17%節約',
        pkg_300_badge: '⭐ 最も人気',
        pkg_700_label: '700クレジット',
        pkg_700_desc: '29%節約',
        pkg_1500_label: '1,500クレジット',
        pkg_1500_desc: '33%節約',
        pkg_1500_badge: '🔥 最高のコスパ',
        plan_starter_badge: '⭐ 最も人気のプラン',
        plan_starter_benefit: '毎月何時間もの作業を節約。',
        plan_pro_badge: '🔥 SEO成長',
        plan_pro_benefit: 'インデックスとSEOパフォーマンスを改善。',
        plan_elite_badge: '🚀 代理店向け',
        plan_elite_benefit: '代理店とエンタープライズカタログ向けに設計。',
      },
      toast: {
        saved_at: '{{time}} に保存しました',
        save_error: '保存エラー',
        budget_exceeded: '日次クレジット不足 — {{total}}件中{{done}}件の商品を最適化しました',
        autopilot_stopped: 'オートパイロット停止 — {{total}}件中{{done}}件の商品を最適化しました',
        images_optimized: '画像を最適化 — {{n}}件の商品',
        images_failed: '{{n}}件の画像を最適化できませんでした',
        autopilot_done: 'オートパイロット完了 — {{started}}件の商品がキューに入りました',
        autopilot_empty: 'しきい値以下のアイテムなし',
        autopilot_stopping: 'オートパイロット停止中...',
        reindex_started: '再インデックスを開始しました',
        resync_started: '再同期を開始しました',
        cache_cleared: 'キャッシュをクリアしました',
        sync_reset: '同期状態をリセットしました',
      },
      advanced: {
        warning: '以下の操作はシステムの動作に影響します。必要な場合のみ使用してください。',
        sync_title: '同期',
        reindex: '商品を再インデックス',
        reindex_desc: 'データベース内の全商品のSEOデータを再計算',
        resync: 'Shopifyと再同期',
        resync_desc: '商品とコレクションの完全同期を強制実行',
        cache_title: 'キャッシュ',
        clear_cache: 'アプリキャッシュをクリア',
        clear_cache_desc: 'ブラウザ内の進行中のバッチを削除します。未完了の操作は失われます。',
        reset_credits: '日次クレジットをリセット',
        reset_credits_desc: '本日のAIクレジットカウンターをリセット (dev)。上限: 5,000/日。',
        danger_zone: '危険ゾーン',
        reset_sync: '同期状態をリセット',
        reset_sync_desc: '強制リセット。同期が30分以上停止している場合のみ使用してください。',
      },
    },
    ai_engine: {
      preset: {
        growth_desc: 'コンバージョンとエンゲージメントを最大化',
        luxury_desc: 'プレミアムブランドと独自のナレーション',
        seo_desc: 'Googleでのオーガニック検索露出を最大化',
        balanced_desc: '品質とSEOの最適なバランス',
      },
      tone: {
        professional: 'プロフェッショナル',
        professional_desc: 'フォーマル、権威ある、信頼を構築',
        luxury: 'ラグジュアリー',
        luxury_desc: 'エレガント、エクスクルーシブ、プレミアム',
        technical: 'テクニカル',
        technical_desc: '精密、仕様、測定可能なデータ',
        conversational: 'カジュアル',
        conversational_desc: '直接的、フレンドリー、魅力的',
      },
      frequency: {
        daily: '毎日',
        daily_desc: '1日1回',
        hourly: '毎時',
        hourly_desc: '継続的',
        realtime: 'リアルタイム',
        realtime_desc: 'できる限り早く',
      },
      scope: {
        products: '商品',
        collections: 'コレクション',
        articles: '記事',
        pages: 'ページ',
      },
      trigger: {
        seo_score: '低いSEOスコア',
        missing_meta: 'メタデータなし',
        missing_alt: 'ALTテキストなし',
        outdated_desc: '古い説明',
        keywords: 'キーワードなし',
        image_quality: '未最適化の画像',
      },
    },
    appearance: {
      title: '外観',
      theme_title: 'テーマ',
      theme: {
        light: 'ライト',
        dark: 'ダーク',
        system: 'システム',
      },
      density_title: '密度',
      density: {
        compact: 'コンパクト',
        comfortable: '快適',
        spacious: '広々',
        compact_desc: 'コンテンツ重視',
        comfortable_desc: 'バランス',
        spacious_desc: '余白重視',
      },
      sidebar_title: 'サイドバー',
      sidebar: {
        expanded: '展開',
        collapsed: '折りたたみ',
        hidden: '非表示',
        expanded_desc: '常時表示',
        collapsed_desc: 'アイコンのみ',
        hidden_desc: 'ホバー時',
      },
    },
    localization: {
      ui_language: 'インターフェース言語',
      select_language: 'アプリの言語を選択',
      reload_note: '言語は即座に適用されます',
    },
    dashboard: {
      title: '概要',
      subtitle: 'ストアアクティビティの概要',
      products: '製品',
      optimized: '最適化済み',
      pending: '保留中',
      seo_score: 'SEOスコア',
      audit_center: 'Audit Center',
      sync_products: '製品を同期',
      analyze_products: '製品を分析',
      audit_site: 'サイト審査 360',
      syncing: '同期中...',
      analyzing: '分析中...',
      auditing: '審査中...',
      section_account: 'アカウント & プラン',
      section_catalog: 'カタログの状態',
      section_images: '画像',
      section_seo_tech: '技術的SEO — 詳細サイト審査',
      section_ux_trust: 'UX & Trust — ハイライト',
      section_actions: 'AIの推奨アクション',
      recent_activity: '最近のアクティビティ',
      hint_plan: 'プランとクレジットの状況',
      hint_never_synced: '未同期',
      hint_priority: '優先度順',
      hint_last_sync: '最終同期 {{date}}',
      current_plan: '現在のプラン',
      credits_used: '使用済みクレジット',
      credits_remaining: '残クレジット',
      public_domain: 'パブリックドメイン',
      credit_usage: 'クレジット使用状況',
      hint_installed: '{{date}} インストール',
      hint_pct_plan: 'プランの {{pct}}%',
      hint_limit: '上限 {{n}}',
      hint_last_audit: '最終審査 {{date}}',
      hint_no_audit: '審査未実行',
      no_audit: '審査未実行',
      no_audit_desc: 'タイトル、meta、H1、canonical、robots、sitemap、HTTPS、OG、JSON-LD、パフォーマンス、画像、リンクを分析するための審査を実行してください。',
      run_audit: '審査を実行',
      in_progress: '実行中...',
      audit_phase: '審査中 (フェーズ: {{phase}})...',
      ux_highlights: 'UX ハイライト',
      trust_compliance: 'Trust & Compliance',
      mobile_viewport: 'モバイルビューポート:',
      favicon: 'Favicon:',
      images_without_alt_label: 'ALTなし画像:',
      lazy_loading: '遅延読み込み:',
      images_suffix: '画像',
      internal_links: '内部リンク:',
      data_unavailable: 'データ利用不可: {{reason}}',
      analysis_not_run: '分析未実行',
      not_detected: '未検出',
      no_trust_data: 'Trustデータなし',
      no_activity: '最近のアクティビティなし',
      activity_completed: '完了',
      activity_error: 'エラー',
      no_store_title: 'ストア未接続',
      no_store_desc: 'Shopifyストアにアプリをインストールして開始してください',
      connect_store: 'Shopifyストアを接続',
      no_token_title: 'OAuthトークンがありません',
      no_token_desc: 'ストア {{domain}} は登録済みですがトークンがありません。アプリを再インストールしてください。',
      reinstall_app: 'OAuthでアプリを再インストール',
      sync_in_progress: '製品の同期中…',
      sync_in_progress_detail: '{{synced}} / {{total}} 製品。同期完了後にダッシュボードデータが更新されます。',
      stale_data: '古いデータ: 同期中のため最新の有効な数値を表示しています。',
      catalog_score_label: 'カタログスコア',
      seo_distribution: 'SEO分布',
      n_products: '{{n}} 製品',
      pct_of_catalog: 'カタログの {{pct}}%',
      no_description: '説明なし',
      no_meta_description: 'メタ説明なし',
      seo_needs_improvement: 'SEO改善が必要',
      view: '表示',
      seo_good_desc: 'カタログのSEOカバレッジは良好です。新製品を最適化して基準を維持してください。',
      seo_medium_desc: 'カタログのSEOカバレッジは中程度です。優先事項: メタ説明と製品説明。',
      seo_poor_desc: 'カタログのSEOカバレッジは低いです。優先事項: メタ説明、説明、欠落している画像。',
      seo_optimized: '最適化済み',
      seo_medium: '中程度',
      seo_poor: '改善が必要',
      content_seo_title: 'コンテンツタイプ別SEO状態',
      open_catalog: 'カタログを開く',
      row_collections: 'コレクション',
      row_articles: '記事',
      row_pages: 'ページ',
      coming_soon: '近日公開',
      not_synced: '未同期',
      seo_coverage_fmt: '{{opt}}/{{total}} 最適化済み · {{score}}/100',
      alt_coverage: 'ALTテキストカバレッジ',
      with_alt_count: '{{total}} 中 {{n}} がALTあり',
      image_optimization_label: '画像最適化',
      optimized_count: '{{total}} 中 {{n}} が最適化済み',
      with_alt: 'ALTあり',
      without_alt: 'ALTなし',
      image_optimized: '最適化済み',
      image_needs_improvement: '改善が必要',
      no_image: '画像なし',
      savings: '節約',
      optimize_images_btn: '画像を最適化',
      view_no_image: '画像なし製品を表示',
      alt_manager: 'ALT Text Manager',
      toast_sync_done: '同期完了。カタログを調整中...',
      toast_catalog_reconciled: 'カタログ調整完了: {{n}} 製品 ({{removed}} 件削除)',
      toast_sync_first: '最初に製品を同期してください',
      toast_avg_score: '平均スコア {{score}}/100',
      toast_audit_done: '審査完了: {{score}}/100',
      toast_sync_reset: '同期状態をリセットしました',
      toast_sync_reset_error: '同期状態をリセットできません',
      op_description: 'AI説明文',
      op_seo_title: 'SEOタイトル',
      op_meta_description: 'メタ説明',
      op_keywords: 'キーワード',
      op_translation: '翻訳',
      op_image_opt: '画像最適化',
      op_sync: 'Shopify同期',
      op_seo_analysis: 'ストアSEO分析',
      op_site_audit: 'サイト審査 360',
      prompt_domain: 'ShopifyストアのドメインURLを入力してください',
      hint_force_reset: '同期状態を強制リセット（商品は削除されません）',
    },
    products: {
      title: '製品カタログ',
      search: '製品を検索...',
      all: 'すべて',
      optimized: '最適化済み',
      pending: '保留中',
      status_generating: '生成中',
      status_writing: '書き込み中',
      status_validating: '検証中',
      status_failed: '失敗',
      status_sync_failed: 'Shopify Sync',
      status_optimized: '最適化済み',
      status_medium: '中程度',
      status_needs_improvement: '改善が必要',
      type_collection_singular: 'collection',
      type_collection_plural: 'collections',
      sync_collections: 'Sync Collections',
      empty_collections: 'No collections. Click "Sync Collections" to import from Shopify.',
      search_collections: 'Search collection by title or handle...',
      col_label_products: '製品',
      type_article_singular: 'article',
      type_article_plural: 'articles',
      sync_articles: 'Sync Articles',
      empty_articles: 'No articles. Click "Sync Articles" to import from Shopify.',
      search_articles: 'Search article by title, handle or blog...',
      col_label_blog: 'Blog',
      type_page_singular: 'page',
      type_page_plural: 'pages',
      sync_pages: 'Sync Pages',
      empty_pages: 'No pages. Click "Sync Pages" to import from Shopify.',
      search_pages: 'Search page by title or handle...',
      col_label_author: 'Author',
      catalog_title: 'カタログ',
      no_store: 'ストアなし',
      tab_products: '製品',
      tab_collections: 'コレクション',
      tab_articles: '記事',
      tab_pages: 'ページ',
      sort_updated: 'Updated',
      sort_seo_score: 'SEO Score',
      sort_title: 'Title',
      sort_vendor: 'Vendor',
      sort_created: 'Created',
      sort_desc: 'Descending',
      sort_asc: 'Ascending',
      filter_seo_all: 'SEO: all',
      filter_optimized: 'Optimized',
      filter_medium: 'Medium',
      filter_needs_improvement: 'Needs improvement',
      filter_image_all: 'Images: all',
      filter_image_yes: 'With images',
      filter_image_no: 'Without images',
      filter_meta_all: 'Meta: all',
      filter_meta_yes: 'With meta',
      filter_meta_no: 'Without meta',
      filter_desc_all: 'Description: all',
      filter_desc_yes: 'With description',
      filter_desc_no: 'Without description',
      filter_vendor_all: 'Vendor: all',
      filter_collection_all: 'Collection: all',
      filter_type_all: 'Type: all',
      reset_filters: 'Reset filters',
      th_image: 'Image',
      th_title: 'Title',
      th_seo_score: 'SEO Score',
      th_alt: 'ALT',
      th_meta: 'Meta',
      th_status: 'ステータス',
      th_actions: 'Actions',
      no_products_filters: 'No products found with these filters',
      no_products: 'No products. Sync from your Shopify store.',
      pagination: 'Page {{page}} of {{total}} · {{count}} products',
      batch_btn: 'Batch Operations',
      dialog_status: 'ステータス',
      dialog_seo_score: 'SEO Score',
      dialog_shopify_id: 'Shopify ID',
      dialog_vendor: 'Vendor',
      dialog_serp: 'SERP Preview',
      dialog_issues: 'SEO Issues',
      dialog_suggestions: 'Suggestions',
      generating: '生成中...',
      generate_all: 'すべてのコンテンツを生成',
      action_generate_ai: 'Generate AI Content',
      action_translate: 'Translate',
      action_optimize_image: 'Optimize Image',
      syncing: '同期中...',
      draft_ready: '下書き準備完了',
      seo_ai_btn: 'SEO AI',
      batch_ops_btn: 'Batch Operations',
      diagnosis: 'Diagnostics',
      current_score: 'Current score',
      projected: '→ projected {{score}}/100',
      meta_title: 'Meta Title',
      meta_desc_label: 'Meta Description',
      description_label: 'Description',
      generate_desc_btn: 'Generate AI description',
      generating_desc: 'Generating...',
      generate_ai_btn: 'Generate with AI',
      publish_shopify_btn: 'Shopifyに公開',
      publishing: '公開中...',
      discard_draft_btn: 'Discard draft',
      seo_ai_dialog_title: 'SEO AI',
      seo_all: 'SEO: all',
      seo_optimized: 'Optimized',
      seo_medium: 'Medium',
      seo_needs: '改善が必要',
      page_of: '{{page}} / {{total}} ページ',
      search_placeholder: 'タイトル、SKU、EAN、ベンダー、ハンドルで検索...',
      chars_count: '{{n}}/{{max}} 文字',
      n_selected_info: '選択済み',
      filtered: 'フィルター済み',
      soon_tooltip: 'まもなく利用可能',
      resource_subtitle: '{{type}} Shopify とSEOステータス',
      articles_blog: '記事（ブログ）',
      select_visible_title: '表示中を全選択/全解除',
      toast_draft_ready: 'SEO下書きを生成しました。確認して公開してください。',
      toast_error_ai: 'AI生成エラー',
      toast_desc_generated: 'AI説明を生成しました。',
      toast_error_desc: '説明生成エラー',
      toast_empty_draft: '少なくとも1つのフィールドを生成または入力してください',
      toast_published_score: 'Shopifyに公開済み · スコア {{score}}/100',
      toast_error_publish: 'Shopifyへの公開エラー',
      toast_draft_discarded: '下書きを破棄しました',
      toast_select_items: '少なくとも1つのアイテムを選択してください',
      toast_mode_publish: '公開',
      toast_mode_both: '生成+公開',
      toast_mode_generate: 'AI SEO生成',
      toast_batch_launched: '{{label}}が{{count}}件の{{type}}で開始しました。',
      toast_batch_errors: '{{label}}が{{count}}件のエラーで完了しました',
      toast_batch_done: '{{label}}が{{count}}件の{{type}}で完了しました',
      toast_synced: '{{type}}を同期しました: {{count}}',
      toast_sync_error: '{{type}}の同期エラー',
      toast_token_error: 'Shopifyトークンが期限切れまたは権限なし',
      reinstall_label: '再インストール',
      toast_sync_started: '{{type}}の同期を開始しました',
      toast_error_sync_start: '同期の開始エラー',
      toast_perms_ok: '権限OK ({{kind}})',
      toast_token_revoked: 'トークンが失効しました',
      toast_perms_missing: '権限が不足しています',
      toast_diag_error: '診断エラー',
      toast_score: 'スコア {{score}}/100',
      toast_error_analyze: '分析エラー',
      toast_generated: 'コンテンツを生成しました',
      toast_error_generate: '生成エラー',
    },
    content: {
      title: 'コンテンツ生成',
      generate: 'コンテンツを生成',
      language: '言語',
      tone: 'トーン',
      subtitle: 'Generate descriptions, SEO title, meta description and keywords with AI',
      tab_products: '製品',
      tab_collections: 'コレクション',
      tab_articles: '記事',
      tab_pages: 'ページ',
      type_description_label: 'Description',
      type_description_hint: 'Engaging and SEO-friendly product text',
      type_seo_title_label: 'SEO Title',
      type_seo_title_hint: 'SERP-optimized title (max 60 chars)',
      type_meta_desc_label: 'Meta Description',
      type_meta_desc_hint: 'Google snippet (max 160 chars)',
      type_keywords_label: 'Keywords',
      type_keywords_hint: 'Primary and secondary keywords',
      type_body_label: 'Description / Body',
      type_body_hint: 'Main resource text',
      filter_all: 'すべて',
      filter_needs: 'Needs improvement',
      filter_medium: 'Medium',
      filter_optimized: 'Optimized',
      no_results_filters: 'No items match the filters',
      select_all: 'Select all',
      deselect: 'Deselect',
      selected_count: '{{count}} selected',
      selected_max: '(max)',
      deselect_all: 'Deselect all',
      pagination_of: '{{page}} / {{total}}',
      total_count: '({{count}} total)',
      content_type_section: 'Content Type',
      batch_generating: 'Generating… {{done}}/{{total}}',
      batch_generate_btn: 'Generate Batch ({{count}})',
      generating_count: 'Generate ({{count}})',
      generate_btn: 'Generate',
      generating: '生成中...',
      generate_all_btn: 'All',
      hint_select: '← Select an item or tick multiple items for batch',
      hint_batch_ready: '{{count}} item(s) ready for batch',
      batch_done_title: '✓ Batch completed',
      batch_pending_title: 'Batch pending…',
      batch_in_progress_title: 'Batch Generation in progress…',
      batch_done_msg: 'All content generated. Selection will be cleared automatically.',
      results_section: 'Results',
      publishing: '公開中...',
      published: 'Published',
      publish_btn: 'Shopifyに公開',
      clear_results: 'Clear',
      chars_unit: 'chars',
      cache_label: 'cache',
      preview_section: 'Current preview',
      loading_detail: 'Loading detail…',
      not_present: 'Not present',
      not_present_plural: 'Not present',
      empty_state: 'Click an item to view it, or tick multiple items and use Generate Batch',
      copy_btn: 'Copy',
      type_seo_title_hint_content: 'SERP用メタタイトル（最大60文字）',
      no_items: '{{type}}が見つかりません',
      item_deselect: '選択解除',
      item_select: '選択に追加',
      generate_all_title: '利用可能なすべてのタイプを生成',
      prev_item: '前のアイテム',
      next_item: '次のアイテム',
      toast_load_error: 'アイテムの読み込みエラー',
      toast_batch_done: 'バッチ完了: {{done}}/{{total}}製品',
      toast_batch_failed: 'バッチ失敗: {{total}}中{{failed}}エラー',
      toast_batch_cancelled: 'バッチがキャンセルされました',
      toast_batch_resumed: 'アクティブなバッチを再開しました…',
      toast_max_select: '最大{{max}}アイテムを選択できます',
      toast_select_item: 'リストからアイテムを選択してください',
      toast_select_type: '少なくとも1つのコンテンツタイプを選択してください',
      toast_from_cache: 'キャッシュからのコンテンツ！',
      toast_generated: '正常に生成されました！',
      toast_generate_error: 'コンテンツ生成エラー',
      toast_batch_running: 'バッチプロセスはすでに実行中です',
      toast_no_store: 'ストアが利用できません',
      toast_batch_started: 'バッチ開始: {{n}}製品がキューに追加されました',
      toast_batch_start_error: 'バッチ開始エラー',
      toast_batch_item_error: '生成エラー: {{title}}',
      toast_batch_complete: 'バッチ完了: {{done}}/{{total}}アイテム',
      toast_cancel_error: 'バッチキャンセルエラー',
      toast_published: 'Shopifyにコンテンツを公開しました！',
      toast_publish_error: '公開エラー',
      toast_copied: 'クリップボードにコピーしました',
      present: 'あり',
      missing: 'なし',
      lang_it: 'イタリア語',
      lang_en: '英語',
      lang_fr: 'フランス語',
      lang_de: 'ドイツ語',
      lang_es: 'スペイン語',
      lang_pt: 'ポルトガル語',
      tone_professional: 'プロフェッショナル',
      tone_luxury: 'ラグジュアリー',
      tone_technical: 'テクニカル',
      tone_conversational: 'カジュアル',
    },
    images: {
      title: '画像最適化',
      optimize: '最適化',
      format: 'フォーマット',
      compress: '圧縮',
      quality: '品質',
      alt_mode_label: 'ALT生成モード',
      alt_mode_ai: 'AIスマート',
      alt_mode_template: '無料テンプレート',
      alt_mode_auto: '自動フォールバック',
      subtitle: 'Optimize images, manage ALT text and publish to Shopify.',
      tab_optimize: 'Optimize Images',
      tab_alt: 'ALT Text',
      alt_coverage: 'ALT Coverage',
      with_alt_count: 'with ALT out of',
      sync_alt_btn: 'Update ALT data from Shopify',
      syncing_alt: 'Updating ALT...',
      sync_status_label: 'Status:',
      analyzed_label: 'Analyzed:',
      last_updated_label: 'Last update:',
      stalled: 'stalled',
      force_stop: 'Force stop (stalled for 60s)',
      free_badge: '● Free — no credits',
      configure_btn: '▼ Configure',
      hide_btn: '▲ Hide',
      template_free_hint: 'Free mode active — zero AI credits. Template:',
      template_auto_hint: 'Auto fallback — AI if credits available, local template if exhausted.',
      template_config_title: 'Configure ALT Template',
      template_label: 'Custom template',
      template_preview: 'Preview:',
      variables_label: 'Available variables — click to insert:',
      restore_default: 'Restore default',
      save_config: 'Save configuration',
      saving: 'Saving...',
      search_placeholder: 'Search by title, vendor, handle...',
      filter_all_images: 'All',
      filter_with_alt: 'With ALT',
      filter_without_alt: 'Without ALT',
      selected_images: '{{count}} images selected (max 50 per batch)',
      generate_batch_btn: 'Generate ALT for selected',
      batch_alt_in_progress: 'ALT Batch in progress: {{done}} / {{total}}',
      batch_errors: '{{n}} 件のエラー',
      select_all_label: 'Select all',
      deselect_all_label: 'Deselect all',
      total_products_label: '{{count}} products',
      timeout_title: 'Loading took too long (20s)',
      timeout_desc: 'The database is processing many products. Try again in a few seconds.',
      error_title: 'List loading error',
      no_products_filter: 'No products matching the filters',
      alt_placeholder: 'ALT text (max 125 characters)',
      status_published: 'Published',
      status_saved: 'Saved',
      status_draft_alt: 'Draft',
      status_missing: 'No ALT',
      generate_alt_btn: 'Generate ALT',
      save_alt_btn: 'Save ALT',
      publish_alt_btn: 'Publish',
      prec: 'Prev',
      succ: 'Next',
      select_products: 'Select Products',
      filter_collection_all: 'Collection: all',
      filter_vendor_all: 'Vendor: all',
      filter_kb_all: 'KB: all',
      filter_kb_100: 'Files over 100 KB',
      filter_kb_500: 'Files over 500 KB',
      filter_kb_1mb: 'Files over 1 MB',
      filter_format_all: 'Format: all',
      filter_landscape: 'Width greater than Height',
      filter_portrait: 'Height greater than Width',
      filter_square: 'Square',
      filter_status_all: 'Status: all',
      filter_status_optimized: 'Already optimized',
      filter_status_needs: 'To optimize',
      visible_total: '{{visible}} visible · {{total}} total',
      reset_filters: 'Reset filters',
      clear_selection: 'Clear selection',
      no_image_products: 'No products with image',
      ready_badge: 'Ready',
      settings_title: 'Settings',
      format_title: 'Image Format',
      format_square: 'Square 1:1',
      format_landscape: 'Landscape 4:3',
      format_portrait: 'Portrait 3:4',
      format_none: 'No resize',
      format_none_sub: 'Original dimensions',
      compress_label: 'Compression',
      compress_desc: 'Reduce file size',
      quality_label: 'Quality',
      batch_opt_running: 'Optimization in progress',
      batch_opt_cancelled: 'Optimization cancelled',
      batch_opt_completed: 'Optimization completed',
      batch_apply_running: 'Application in progress',
      batch_apply_cancelled: 'Application cancelled',
      batch_apply_completed: 'Application completed',
      background_note: 'You can change section, continues in background',
      optimizing: 'Optimizing...',
      optimize_n: 'Optimize {{count}} images',
      optimize_one: 'Optimize Image',
      applying: 'Applying...',
      apply_n: 'Apply {{count}} to Shopify',
      apply_one: 'Apply to Shopify',
      preview_title: 'Preview',
      ready_optimizations: '{{count}} optimizations ready',
      select_preview_hint: 'Select one or more products to see the preview',
      first_product_preview: 'Preview shown for the first selected product:',
      original_label: 'Original',
      optimized_label: 'Optimized',
      optimize_click_hint: 'Click "Optimize" for the result',
      reduction_label: 'Reduction',
      apply_btn: 'Apply',
      history_opt_title: 'Optimization history',
      history_opt_subtitle: 'Operations applied to Shopify, errors and restores.',
      stat_running_label: 'Running',
      stat_completed_label: 'Completed',
      stat_errors_label: 'Incomplete',
      stat_undo_label: 'Undo',
      total_savings: 'Total savings',
      no_history: 'No operations applied yet.',
      restoring: 'Restoring...',
      undo_btn: 'Undo',
      kb_warning: 'KB size is not in local data. To make it accurate it needs to be saved by the backend during image sync.',
      senza_vendor: 'No vendor',
      alt_stat_coverage: '{{total}}件中{{n}}件にALTあり',
      apply_batch_cancelled: '適用がキャンセルされました',
      apply_batch_done_label: '適用が完了しました',
      apply_batch_running: '適用中',
      apply_n_btn: '{{n}}件をShopifyに適用',
      applying_btn: '適用中...',
      auto_fallback_hint: 'オートフォールバック — クレジットがあればAI、なければローカルテンプレート。',
      background_hint: 'セクションを変更できます。バックグラウンドで続行します',
      badge_draft: '下書き',
      badge_missing: 'ALTなし',
      badge_published: '公開済み',
      badge_ready: '準備完了',
      badge_saved: '保存済み',
      batch_close: '閉じる',
      batch_generate_btn: '選択項目のALTを生成',
      batch_progress: 'ALTバッチ処理中: {{done}} / {{total}}',
      batch_selected: '{{n}}件の画像を選択済み（バッチあたり最大50件）',
      collection_all: 'コレクション: すべて',
      compress_sub: 'ファイルサイズを削減',
      config_btn: '▼ 設定',
      deselect_all: 'すべて解除',
      empty_filtered: 'フィルターに一致する商品がありません',
      filter_all: 'すべて',
      format_label: '画像フォーマット',
      gen_alt_btn: 'ALTを生成',
      history_completed: '完了',
      history_empty: 'まだ操作が適用されていません。',
      history_incomplete: '不完全',
      history_loading: '履歴を読み込み中...',
      history_running: '実行中',
      history_savings: '合計節約量',
      history_subtitle: 'Shopifyに適用された操作、エラー、復元。',
      history_title: '最適化履歴',
      history_undo_label: '元に戻す',
      last_update_label: '最終更新:',
      load_error: 'リストの読み込みエラー',
      n_errors: '{{n}}件のエラー',
      n_products: '{{n}}件の商品',
      n_selected: '{{n}}件選択済み',
      next_page: '次へ',
      no_products: '画像付き商品がありません',
      no_vendor: 'ベンダーなし',
      opt_batch_cancelled: '最適化がキャンセルされました',
      opt_batch_done: '最適化が完了しました',
      opt_batch_running: '最適化中',
      optimize_n_btn: '{{n}}件の画像を最適化',
      optimize_one_btn: '画像を最適化',
      optimizing_btn: '最適化中...',
      orientation_all: 'フォーマット: すべて',
      orientation_landscape: '横幅が縦より大きい',
      orientation_portrait: '縦が横幅より大きい',
      orientation_square: '正方形',
      page_info: '{{total}}ページ中{{page}}ページ',
      pagination: '{{total}}ページ中{{page}}ページ',
      prev: '前へ',
      publish_btn: '公開',
      retry: '再試行',
      select_all: 'すべて選択',
      size_100kb: '100KB超のファイル',
      size_1mb: '1MB超のファイル',
      size_500kb: '500KB超のファイル',
      size_all: 'KB: すべて',
      stat_no_image: '画像なし: {{count}}',
      stat_with_alt: 'ALTあり: {{count}}',
      stat_without_alt: 'ALTなし: {{count}}',
      status_all: 'ステータス: すべて',
      status_label: 'ステータス:',
      status_needs: '最適化が必要',
      status_optimized: '最適化済み',
      status_stalled: '停止中',
      sync_btn: 'ShopifyからALTデータを更新',
      sync_btn_title: 'Shopifyから実際の画像とALTテキストを再読み込みします',
      syncing: 'ALTを更新中...',
      template_active: '無料モード有効 — AIクレジット不使用。テンプレート:',
      template_custom_label: 'カスタムテンプレート',
      template_free_badge: '● 無料 — クレジット不要',
      template_preview_label: 'プレビュー:',
      template_reset: 'デフォルトに戻す',
      template_save: '設定を保存',
      template_saving: '保存中...',
      template_vars_label: '利用可能な変数 — クリックして挿入:',
      timeout_msg: 'データベースが多くの商品を処理中です。数秒後に再試行してください。',
      toast_alt_ai: 'AIでALTを生成しました',
      toast_alt_cancelled: 'ALT更新がキャンセルされました — 再開できます',
      toast_alt_empty: 'ALTが空です',
      toast_alt_from_cache: 'キャッシュからALT',
      toast_alt_gen_error: 'ALT生成エラー',
      toast_alt_publish_error: '公開エラー',
      toast_alt_published: 'Shopifyに公開しました',
      toast_alt_save_error: '保存エラー',
      toast_alt_saved: 'ALTを保存しました',
      toast_alt_sync_start_error: 'ALT更新の開始エラー',
      toast_alt_sync_started: 'ALTデータの更新を開始しました',
      toast_alt_template: 'テンプレートでALTを生成しました（無料）',
      toast_alt_template_fallback: 'テンプレートでALT（クレジット不足）',
      toast_alt_update_error: 'ALT更新エラー',
      toast_alt_updated: 'ALTデータを更新しました: {{n}}件の商品を分析',
      toast_applied: 'Shopifyに画像を適用しました',
      toast_apply_batch_done: '{{n}}件の画像をShopifyに適用しました',
      toast_apply_batch_errors: '{{n}}件のエラーで適用が完了しました',
      toast_apply_batch_started: '適用を開始しました: {{n}}件の画像。セクションを変更できます。',
      toast_batch_alt_done: 'バッチが完了しました',
      toast_batch_alt_started: 'バッチを開始しました: {{n}}件の画像、{{c}}件ずつ',
      toast_batch_done: 'バッチが完了しました: {{n}}件の画像を最適化しました。Shopifyに適用できます。',
      toast_batch_errors: '{{n}}件の画像が処理されませんでした。再試行またはログを確認してください。',
      toast_batch_started: 'バッチを開始しました: {{n}}件の画像。セクションを変更できます。バックグラウンドで続行します。',
      toast_cancel_error: 'キャンセルエラー',
      toast_no_draft: '適用する最適化済み画像がありません',
      toast_no_images: '画像が選択されていません',
      toast_no_ready: '適用する準備完了の最適化がありません',
      toast_no_store: 'ストアが利用できません',
      toast_optimize_error: '最適化エラー',
      toast_optimized: '画像を最適化しました。Shopifyに適用できます。',
      toast_select_product: '少なくとㄇ1つの商品を選択してください',
      toast_template_save_error: 'テンプレートの保存エラー',
      toast_template_saved: 'テンプレートの設定を保存しました',
      toast_undo_done: '元の画像を復元しました',
      toast_undo_error: '復元中にエラーが発生しました',
      undoing_btn: '復元中...',
      vendor_all: 'Vendor: すべて',
      toast_no_product: '商品を選択してください',
      toast_no_image: '商品に画像がありません',
      toast_no_preview: '最初に画像を最適化してください',
      toast_apply_error: 'Shopifyへの適用エラー',
      n_ready: '{{n}}件の最適化が準備完了',
      preview_hint: '1つ以上の商品を選択してプレビューを表示',
      preview_first: '最初に選択した商品のプレビュー:',
      click_optimize_hint: '"最適化"をクリックして結果を確認',
      apply_single_btn: '適用',
    },
    alt_template: {
      section_title: 'ALTテンプレート',
      mode_label: 'ALTテキスト生成モード',
      textarea_label: 'カスタムテンプレート',
      preview_label: 'プレビュー',
      vars_label: '使用可能な変数 — クリックして挿入',
      hint_template: '無料モード：ALTテキストにAIクレジットは消費しません。',
      hint_auto: '自動フォールバック：クレジットがあればAI、なければローカルテンプレート。',
    },
    batch: {
      title: 'バッチ操作',
      start: '開始',
      cancel: 'キャンセル',
      subtitle: 'Persistent server-side processing — continues even if you change page or close the tab',
      locked_title: 'Batch Operations not available',
      locked_desc: 'Batch Operations are available from the Starter plan. Process hundreds of products in parallel with one click.',
      upgrade_btn: 'Upgrade to Starter',
      op_content_label: 'Generate AI Content',
      op_content_desc: 'Description, SEO title, meta description, keywords',
      op_translate_label: 'Translate Products',
      op_translate_desc: 'Full translation into selected language',
      op_images_label: 'Optimize Images',
      op_images_desc: '1:1 resize and image compression',
      field_description_label: 'Description',
      field_description_hint: '150-250 words',
      field_seo_title_label: 'SEO Title',
      field_seo_title_hint: 'max 60 characters',
      field_meta_desc_label: 'Meta Description',
      field_meta_desc_hint: '100-160 characters',
      field_keywords_label: 'Keywords',
      field_keywords_hint: '5-10 keywords',
      count_all: 'すべて',
      status_pending: 'Queued',
      status_running: 'Running',
      status_completed: 'Completed',
      status_failed_job: 'Failed',
      status_cancelled: 'Cancelled',
      opt_in_progress: 'Image optimization in progress…',
      batch_in_progress: 'AI Batch in progress…',
      images_progress: '{{done}} / {{total}} images',
      products_progress: '{{done}} / {{total}} products',
      errors_count: '{{count}} errors',
      duration_label: 'Duration: {{time}}',
      starting: 'Starting...',
      seo_gen_in_progress: 'Generate + Publish SEO in progress',
      gen_publish_auto: 'Automatic generation and publishing to Shopify',
      section_operation: 'Operation',
      section_fields: 'Fields to generate',
      fields_selected: '{{count}}/{{total}} selected',
      fields_warning: 'Select at least one field to start the batch',
      fields_hint: 'One AI call per product generates all selected fields — lower latency and reduced costs.',
      section_options: 'Options',
      label_language: '言語',
      label_tone: 'トーン',
      tone_professional: 'Professional',
      tone_luxury: 'Luxury',
      tone_technical: 'Technical',
      tone_conversational: 'Conversational',
      label_target_lang: 'Target Language',
      images_note: '1:1 resize (800×800) + 85% quality compression.',
      section_quantity: 'Product Quantity',
      available_count: '{{count}} available',
      catalog_selection: '{{count}} product(s) selected from Catalog',
      remove_selection: 'Remove selection',
      products_selected_count: '{{count}} product(s) selected',
      processing: 'Processing…',
      start_btn: 'Start Processing',
      history_title: 'Batch History',
      history_subtitle: 'updated from DB',
      stat_running: 'Running',
      stat_completed: 'Completed',
      stat_products_ok: 'Products OK',
      no_batch: 'No batch executed',
      no_batch_hint: 'Jobs will appear here after the first processing',
      job_content: 'Generate AI Content',
      job_translate: 'Translation',
      job_images: 'Image Optimization',
      job_products: '{{done}}/{{total}} products',
      log_lang: 'Language:',
      log_tone: 'Tone:',
      toast_completed: 'バッチ完了: {{done}}/{{total}}件の製品を処理しました',
      toast_failed: 'バッチ失敗: {{count}}件のエラー',
      toast_no_products: '利用可能な製品がありません',
      soon_lbl: '近日公開',
      btn_analyze_seo: 'SEO分析',
      btn_view: '表示',
      toast_no_fields: '少なくとも1つのフィールドを選択して生成してください',
      toast_images_started: '画像最適化を開始しました: {{count}}件の製品',
      toast_started: 'バッチ開始: {{count}}件の製品',
      toast_start_error: '開始エラー',
      toast_cancelled: 'バッチがキャンセルされました',
      toast_cancel_error: 'キャンセルエラー',
      fields_label: 'フィールド',
      log_summary: '個別操作ログ',
    },
    history: {
      title: '履歴',
      empty: '操作が見つかりません',
      subtitle: 'すべてのAI実行の完全な監査 — 合計 {{n}} 件',
      refresh_btn: '更新',
      total_operations: '総操作数',
      success_rate: '成功率',
      n_successes: '{{n}} 件成功',
      credits_today: '本日のクレジット',
      products_today: '本日の製品',
      avg_duration: '平均処理時間',
      last_autopilot: '最終オートパイロット',
      filters: 'フィルター',
      filters_active: '適用中',
      reset_all: 'すべてリセット',
      search_placeholder: '製品を検索...',
      op_all: 'すべての種類',
      op_description: 'AI説明文',
      op_seo_title: 'SEOタイトル AI',
      op_meta_description: 'メタ説明 AI',
      op_batch: 'バッチ生成',
      op_translation: '翻訳',
      op_image: '画像',
      op_sync: 'Shopify同期',
      trigger_all: 'すべてのトリガー',
      status_all: 'すべてのステータス',
      status_success: '成功',
      status_partial: '部分的',
      status_error: 'エラー',
      th_status: 'ステータス',
      th_type: '操作タイプ',
      th_product: '製品',
      th_trigger: 'トリガー',
      th_seo_delta: 'SEO Delta',
      th_credits: 'クレジット',
      th_duration: '処理時間',
      th_timestamp: 'タイムスタンプ',
      loading: '読み込み中...',
      remove_filters: 'フィルターを削除',
      load_more: 'さらに読み込む ({{shown}} / {{total}} 表示中)',
      details_title: '実行詳細',
      detail_op_id: '操作ID',
      detail_product_id: '製品ID',
      detail_store_id: 'ストアID',
      detail_type: '種類',
      detail_trigger: 'トリガー',
      detail_status: 'ステータス',
      detail_language: '言語',
      detail_tone: 'トーン',
      detail_tokens: '使用トークン',
      detail_fields: 'フィールド',
      detail_credits: 'クレジット',
      detail_duration: '処理時間',
      detail_seo_before: 'SEO (前)',
      detail_seo_after: 'SEO (後)',
      detail_timestamp: 'タイムスタンプ',
      error_prefix: 'エラー: ',
      label_description: 'AI説明文',
      label_seo_title: 'SEOタイトル AI',
      label_meta_description: 'メタ説明 AI',
      label_keywords: 'キーワード AI',
      label_batch: 'バッチ生成',
      label_translation: '翻訳',
      label_image: '画像最適化',
      label_sync: 'Shopify同期',
      label_push: 'Shopify公開',
    },
    batch_banner: {
      errors: 'エラー',
      optimizing: '画像最適化',
      optimizing_cancelled: '最適化をキャンセルしました',
      optimizing_completed: '最適化が完了しました',
      applying: 'Shopifyに適用中',
      applying_cancelled: '適用をキャンセルしました',
      applying_completed: '適用が完了しました',
      open_images: '画像を開く',
      open_catalog: 'カタログを開く',
      type_collections: 'コレクション',
      type_articles: '記事',
      type_pages: 'ページ',
      type_contents: 'コンテンツ',
      mode_publish: '公開',
      mode_both: '生成+公開',
      mode_generate: 'AI SEO生成',
      state_cancelled: '(キャンセル済み)',
      state_completed: '(完了)',
    },
    app_banner: {
      expired: 'Shopifyトークンが期限切れまたは失効しました。',
      reconnect_desc: 'アプリを再接続して同期と公開を復元してください。',
      detected_in: '検出場所',
      reconnect_btn: '今すぐ再接続',
    },
    review_popup: {
      greeting: 'こんにちは！ここにいます 👋',
      subtitle: 'AI Optimizerで全てうまくいっていることを願っています！',
      rating_title: 'アプリを楽しんでいますか？',
      rating_desc: 'あなたのご意見は、私たちの改善と他のShopify販売者へのリーチに役立ちます。',
      rating_tap: '星をタップして評価する',
      star: {
        terrible: 'ひどい',
        bad: '良くない',
        average: '普通',
        good: '良い！',
        excellent: '素晴らしい！ 🚀',
      },
      positive_title: '素晴らしい！ありがとうございます 🎉',
      positive_desc: 'わずか1分です！',
      negative_title: 'フィードバックありがとうございます 🙏',
      negative_desc: '改善できることについてアイデアはありますか？',
      review_btn: '⭐ レビューを書く',
      close_btn: '閉じる',
      dismiss: '二度と表示しない',
      skip: 'スキップ →',
    },
    support: {
      title: 'サポート',
      send: '送信',
      placeholder: 'メッセージを入力してください...',
    },
    editor: {
      placeholder: 'ここに入力...',
      bold: '太字',
      italic: 'イタリック',
      underline: '下線',
      h2: '見出し H2',
      h3: '見出し H3',
      paragraph: '段落',
      ul: '箇条書きリスト',
      ol: '番号付きリスト',
      blockquote: '引用',
      link: 'リンクを挿入',
      remove_format: '書式を削除',
      link_prompt: 'リンクURL',
    },
    recommendations: {
      empty: '現在、重要なアクションはありません。素晴らしい！',
      filter_all_prio: 'すべての優先度',
      filter_all_cat: 'すべてのカテゴリ',
      count_shown: '{{n}} 件のアクションを表示',
      see: '表示',
      sev_high: '高',
      sev_medium: '中',
      sev_low: '低',
      cat_catalog: 'カタログ',
      missing_meta_description: '{{count}}件のメタディスクリプションなし商品',
      missing_description: '{{count}}件の説明なし商品',
      missing_alt_text: '{{count}}件のALTテキストなし画像',
      missing_product_image: '{{count}}件の画像なし商品',
    },
    audit: {
      not_detected: '検出されません',
      disabled: '無効',
      not_scanned: '分析未実施',
      status_warning: '警告',
      status_error: 'エラー',
      cat_performance: 'パフォーマンス',
      cat_trust: '信頼性',
      cat_catalog: 'カタログ',
      checks_suffix: 'チェック',
      badge_err: 'エラー',
      badge_warn: '警告',
      badge_ok: 'OK',
      value_label: '値',
      checks: {
        title: { name: 'タイトル', hint: 'ページタイトル' },
        meta_description: { name: 'メタディスクリプション', hint: 'ホームページのメタディスクリプション' },
        h1: { name: 'H1', hint: '1ページにH1が1つが最適' },
        h2: { name: 'H2', hint: '最低1つのH2を推奨' },
        canonical: { name: 'Canonical', hint: '正規URL' },
        lang: { name: '言語', hint: '言語属性' },
        json_ld_structured_data: { name: 'JSON-LD / 構造化データ', hint: '構造化データ' },
        open_graph: { name: 'Open Graph', hint: 'ソーシャルメタ' },
        twitter_card: { name: 'Twitter Card', hint: 'メタ Twitter/X' },
        robots_txt: { name: 'robots.txt', hint: 'ロボッツ' },
        sitemap_xml: { name: 'Sitemap.xml', hint: 'サイトマップ' },
        status_code: { name: 'ステータスコード', hint: 'HTTPステータスコード' },
        indexability: { name: 'インデックス可能性', hint: 'インデックス可能性' },
        redirects: { name: 'リダイレクト', hint: '最終URL' },
        https: { name: 'HTTPS', hint: 'HTTPS' },
        load_time: { name: '読み込み時間', hint: 'サーバー間で測定' },
        page_weight: { name: 'ページサイズ', hint: 'ホームページのHTMLサイズ' },
        image_lazy_loading: { name: '画像の遅延読み込み', hint: '遅延読み込み画像' },
        mobile_viewport: { name: 'モバイルビューポート', hint: 'モバイルビューポート' },
        favicon: { name: 'Favicon', hint: 'Favicon' },
        images_with_alt: { name: 'ALT付き画像', hint: '画像のアクセシビリティ' },
        privacy_policy: { name: 'プライバシーポリシー', hint: 'プライバシー' },
        cookie_policy: { name: 'Cookieポリシー', hint: 'Cookie' },
        terms_conditions: { name: '利用規約', hint: '規約' },
        contact_page: { name: 'お問い合わせページ', hint: 'お問い合わせ' },
        shipping_policy: { name: '配送ポリシー', hint: '配送' },
        returns_refunds: { name: '返品・返金', hint: '返品' },
        social_links: { name: 'ソーシャルリンク', hint: 'ソーシャル' },
        products_without_description: { name: '説明なし商品', hint: '商品説明' },
        products_without_images: { name: '画像なし商品', hint: '商品画像' },
        products_without_meta_description: { name: 'メタディスクリプションなし商品', hint: '商品メタディスクリプション' },
        duplicate_titles: { name: '重複タイトル', hint: '商品タイトル' },
        duplicate_meta_descriptions: { name: '重複メタディスクリプション', hint: '商品メタディスクリプション' },
        thin_content_200_char: { name: '薄いコンテンツ (<200文字)', hint: '商品コンテンツ' },
      },
    },
    score_card: {
      pillar_technical_seo: 'テクニカルSEO',
      pillar_ux: 'UX',
      pillar_performance: 'パフォーマンス',
      pillar_trust: 'トラスト',
      pillar_catalog: 'カタログ',
      label_excellent: '優秀',
      label_good: '改善可能',
      label_critical: '重要',
      no_audit_desc: '監査未実施 — テクニカルSEO、UX、トラスト、パフォーマンスを取得するには監査を実行してください。',
      auditing: '監査中...',
      run_audit: 'サイト監査 360° を実行',
      calculated_on: '計算対象',
    },
    upgrade: {
      popular: '⭐ 最も人気',
      period: '/月',
      plan_header: 'プラン',
      cta: '{{name}}にアップグレード — {{price}}{{period}}',
      dismiss: '後で',
      feature_available: '{{feature}}は{{plan}}プランから利用できます。',
      reason_credits_title: 'AIクレジットを消費しました',
      reason_credits_body: 'プランの月次制限に達しました。コンテンツ生成を続けるにはアップグレードしてください。',
      reason_products_title: 'カタログ制限に達しました',
      reason_products_body: 'Shopifyカタログが現在のプランの制限を超えています。全製品を同期するにはアップグレードしてください。',
      reason_feature_title: 'プレミアム機能',
      reason_feature_body: 'この機能はより高いプランで利用できます。',
    },
    gsc: {
      connect_title: 'Google Search Console を接続',
      connect_desc: 'インプレッション、クリック、CTR、平均掲載順位を監視。AI最適化後に再インデックスをリクエスト。',
      connect_feat_analytics: '検索アナリティクス',
      connect_feat_indexing: 'インデックス監視',
      connect_feat_keywords: 'キーワードトラッキング',
      connect_feat_sitemap: 'サイトマップ管理',
      connect_btn_loading: '接続中...',
      connect_btn: 'Googleアカウントを接続',
      prop_modal_title: 'プロパティを選択',
      prop_modal_desc: '接続するSearch Consoleのプロパティを選択してください。',
      prop_modal_empty: 'プロパティが見つかりません。Google Search Consoleにプロパティがあるか確認してください。',
      prop_modal_cancel: 'キャンセル',
      prop_modal_confirm: '確認',
      coming_soon_desc: '{{phase}}で利用可能',
      top_opp_title: 'SEO上位機会',
      top_opp_sub: 'Opportunity Scoreトップ10クエリ',
      copy: 'コピー',
      copied: 'コピー済み!',
      badge_quick_win: '🔥 Quick Win',
      badge_low_ctr: '⚡ 低CTR',
      badge_page_1: '🚀 1ページ目',
      badge_high_imp: '📈 高インプレッション',
      badge_brand: '🏷️ Brand',
      qt_category: 'カテゴリ',
      qt_product: '商品',
      qt_generic: '一般',
      qt_info: 'Info',
      qt_brand: 'Brand',
      seo_analysis: 'SEO分析',
      generating_ai: 'AI分析を生成中...',
      analysis_error: '分析生成エラー。後でもう一度お試しください。',
      estimated_value: '推定値',
      clicks_monthly: '潜在クリック数/月',
      ctr_at_pos: '{{pos}}位のCTR',
      traffic_increase: 'トラフィック増加',
      current_stats: '現在: {{clicks}}クリック/月 · +{{pts}}pp 推定CTR',
      priority_action: '優先アクション',
      content_opt: 'コンテンツ最適化',
      title_seo: 'Title SEO',
      title_chars: '(50〜60文字)',
      title_copied: 'Titleをコピーしました!',
      h1_suggested: '推奨H1',
      h1_page_title: '(ページタイトル)',
      h1_copied: 'H1をコピーしました!',
      meta_desc: 'Meta Description',
      meta_chars: '(150〜160文字)',
      meta_copied: 'Metaをコピーしました!',
      faq_all_copied: 'すべてのFAQをコピーしました!',
      faq_suggested: 'FAQ候補',
      copy_all: 'すべてコピー',
      faq_copied: 'FAQをコピーしました!',
      related_kw: '関連キーワード',
      click_to_copy: '· クリックしてコピー',
      kw_copied: '"{{kw}}"をコピーしました!',
      tech_suggestions: '技術的な提案',
      copy_keyword: 'キーワードをコピー',
      kw_copied_plain: 'キーワードをコピーしました!',
      shopify_products: 'Shopify商品',
      search_store: 'ストアで検索',
      optimize_content: 'コンテンツを最適化',
      col_impressions: 'インプレッション',
      col_position: '掲載順位',
      no_queries: '現在のフィルターに一致するクエリが見つかりません。',
      ai_panel_title: 'AI提案',
      analyze_query: 'クエリを分析 →',
      sugg_title_improvement: 'Title tag',
      sugg_meta: 'Meta description',
      sugg_content_gap: 'コンテンツ不足',
      sugg_schema: 'Schema markup',
      sugg_links: '内部リンク',
      opp_load_err: 'SEO機会のロードエラー',
      cache_updated: 'キャッシュ更新済み — データを再読み込み',
      cache_error: 'キャッシュ更新エラー',
      loading_data: 'Search Consoleデータを読み込み中...',
      load_error_title: '機会を読み込めません',
      retry: '再試行',
      tracked_queries: 'トラッキング中のクエリ',
      sku_excluded: '{{n}}件のSKU/EANを除外',
      total_impressions: '総インプレッション数（28日間）',
      total_clicks: '総クリック数（28日間）',
      avg_ctr: '平均CTR',
      ai_generating: 'AI分析を生成中...',
      ai_generating_sub: 'AI提案はまもなくここに表示されます。',
      no_ai_insights: 'AIインサイトなし',
      no_ai_insights_sub: '最適化の機会が有意な照会が見つかりませんでした。',
      filter_all: 'すべて ({{n}})',
      search_placeholder: 'クエリを検索...',
      refresh_title: 'データを更新',
      page_prev: '← 前へ',
      page_info: '{{page}} / {{total}} ページ · {{count}} クエリ',
      page_next: '次へ →',
      footer_note: 'Search Consoleデータ過去28日間 · キャッシュ6時間 · プロパティ: {{url}}',
      footer_excluded: ' · {{n}}件のSKU/EANを除外',
      verdict_pass: 'インデックス済み',
      verdict_fail: '未インデックス',
      verdict_neutral: '除外',
      stato_title: 'Googleステータス — データソース',
      in_sitemap: 'サイトマップ内',
      sitemap_registered_lbl: '登録済みサイトマップ',
      sitemap_errors_lbl: 'サイトマップエラー',
      with_impressions: 'インプレッションあり',
      search_appear_note: '検索に表示されたページ · {{days}}日',
      not_real_indexed: '≠ 実際にインデックスされたページ',
      index_estimate_lbl: 'インデックス推定',
      estimate_unavail: '200件のURL検査後に推定値が利用可能になります。バッチスキャンを開始してサンプルを収集してください。',
      inspected_lbl: '検査済み',
      indexed_confirmed: 'インデックス確認済み',
      not_indexed_lbl: '未インデックス',
      excluded_lbl: '除外',
      certain_data: '検査済みURLの確実なデータ',
      batch_title: 'バッチスキャン — Inspection API',
      batch_priority: 'Analyticsの優先順位',
      batch_progress: 'サイトマップ検査の進捗',
      batch_stopping: '停止中…',
      batch_running: 'スキャン中…',
      batch_starting: '開始中...',
      batch_done_lbl: 'サイトマップ完了 ✓',
      batch_start_btn: 'スキャン開始 ({{n}} 件利用可能)',
      batch_timeout: 'タイムアウト — クリックしてリセット',
      batch_stopping_wait: '停止中 — お待ちください…',
      batch_stop_btn: 'スキャン停止',
      batch_remaining: 'あと{{n}}件のURLを検査',
      batch_quota_out: '1日の上限に達しました — 明日再試行',
      batch_start_err: 'スキャン開始エラー',
      batch_complete: 'スキャン完了: {{n}}件のURLを検査',
      dq_title: 'API技術詳細',
      dq_api_status: 'APIステータス',
      dq_daily_quota: '1日の上限',
      dq_used_today: '本日使用済み',
      dq_remaining: '残り',
      dq_history: '検査履歴',
      dq_completion: '完了',
      dq_days_est: '推定日数',
      dq_start_for_eta: 'ETAを計算するためスキャンを開始',
      sm_no_sitemap: 'サイトマップが見つかりません',
      sm_no_sitemap_desc: 'インデックスを監視するにはGoogle Search ConsoleにsitemapをXMLを追加してください。',
      sm_submit_ok: 'サイトマップをGoogleに送信しました',
      sm_in_progress: '計算中…',
      sm_submit_btn: '送信',
      insp_title: 'URL検査',
      insp_quota: '{{used}}/{{limit}} 本日の検査数',
      insp_loading: '検査中...',
      insp_btn: '検査',
      insp_domain_lbl: 'プロパティドメイン:',
      insp_domain_note: '検査するURLはこのドメインに属している必要があります',
      insp_last_crawl: '最終クロール',
      insp_indexing: 'インデックス状態',
      insp_yes: 'はい',
      insp_no: 'いいえ',
      insp_canonical_decl: '宣言されたcanonical',
      insp_canonical_diff: '⚠ Googleのcanonical（異なる）',
      insp_noindex: 'noindexを検出',
      insp_open_gsc: 'Search Consoleで開く',
      insp_err: 'URL検査エラー',
      cov_title: 'カバレッジ — 理由',
      cov_real_data: '実データ — Inspection API',
      cov_conf_high: '高信頼度',
      cov_conf_medium: '中信頼度',
      cov_conf_low: '低信頼度',
      cov_updated: '更新:',
      cov_deselect: '選択解除',
      cov_inspected_note: '検査済みURL · クリックしてフィルタ',
      cov_none_inspected: '検査なし',
      cov_no_data: 'カバレッジデータなし',
      cov_no_data_desc: '非インデックスの理由はURL検査のたびに自動生成されます。「自動スキャン開始」でこのセクションを埋めてください。',
      cov_solution: '推奨の対処法',
      cov_filter_active: '履歴でフィルタ有効',
      ih_worklist: 'SEOワークリスト',
      ih_history: '検査履歴',
      ih_filter_coverage: 'カバレッジフィルタ',
      ih_tab_all: 'すべて',
      ih_tab_not_ind: '未インデックス',
      ih_tab_indexed: 'インデックス済',
      ih_tab_excluded: '除外',
      ih_tab_errors: 'エラー',
      ih_tab_with_imp: 'インプレあり',
      ih_tab_products: '製品',
      ih_tab_collections: 'コレクション',
      ih_sort_priority: '↓ 優先度',
      ih_sort_impressions: '↓ インプレッション',
      ih_sort_clicks_est: '↓ 推定クリック',
      ih_sort_date: '↓ 日付',
      ih_sort_state: '↓ GSC状態',
      ih_clear: 'クリア',
      ih_search: 'URLを検索…',
      ih_open: '開く',
      ih_indexing_state: 'インデックス状態',
      ih_canonical_diff: '⚠ Googleが選択したcanonical（異なる）',
      ih_canonical_same: 'Googleのcanonical（同一）',
      ih_ai_fix: 'AIで最適化 →',
      ih_total: '{{n}} URL · 合計{{total}}件',
      ih_est_clicks: '· +{{n}}クリック/月（推定）',
      iai_title: 'AI提案 — インデックス',
      iai_filter_note: '· クリックしてフィルタ',
      iai_prio_high: '高優先度',
      iai_prio_medium: '中優先度',
      iai_prio_low: '低優先度',
      iai_causes: '考えられる原因:',
      iai_actions: '推奨アクション:',
      fix_apply_all: 'すべて適用',
      fix_applied: '適用済み',
      fix_suggestion: '提案',
      fix_chars: '文字',
      fix_content_impr: 'コンテンツの改善',
      fix_int_links: '推奨内部リンク',
      fix_open_url: 'URLを開く',
      fix_close: '閉じる',
      fix_seo_opt: 'SEO最適化',
      trend_title: 'インデックストレンド',
      trend_updated: '更新日:',
      trend_coverage: 'カバレッジ',
      trend_30d_kpi: '30日トレンド',
      trend_no_data: '履歴データ構築中',
      trend_no_data_desc: '少なくとも2つのスナップショットが収集された後にトレンドが利用可能になります。',
      trend_one_snap: '2件中1件のスナップショットを収集済み。',
      trend_start_scan: 'バッチスキャンを開始してください。',
      trend_ind: 'インデックス済',
      trend_not_ind: '未インデックス',
      trend_snap_note: 'スキャンごとのスナップショット',
      ic_loading: 'インデックスデータを読み込み中...',
      ic_load_err: 'インデックスデータを読み込めません',
      ic_clear_confirm: 'すべての検査履歴を削除しますか？',
      ic_cleared: '履歴を削除しました',
      ic_clear_err: '削除エラー',
      ic_seo_opp: 'SEO機会 — エグゼクティブサマリー',
      ic_recoverable: '回復可能なURL',
      ic_open_worklist: '⚡ ワークリストを開く →',
      ic_view_all: 'すべて表示 →',
      ic_crawled_ni: 'クロール済み – 未インデックス',
      ic_crawled_ni_note: 'Googleは認識しているが提供していない',
      ic_discovered_ni: '発見済み – 未インデックス',
      ic_discovered_ni_note: '発見されたがクロールされていない',
      ic_with_imp_ni: 'GSCインプレッションあり',
      ic_with_imp_ni_note: 'トラフィックがあるが未インデックス',
      ic_other_ni: 'その他の未インデックス',
      ic_other_ni_note: 'Googleに未知またはエラー',
      ic_refresh: '更新',
      rh_title: '変更履歴',
      rh_versions: 'バージョン',
      rh_confirm: "{{date}}のバージョンを復元しますか？\n\nエディターの現在の変更は置き換えられます。",
      rh_restored_ok: 'v{{v}}をShopifyテーマに復元しました',
      rh_restored_editor: 'v{{v}}をエディターに読み込みました — 保存をクリックして適用',
      rh_restore_err: '復元エラー',
      rh_current: '現在',
      rh_initial: '初期バージョン',
      rh_no_diff: 'テキスト変更なし',
      rh_more_added: '+ {{n}}件追加',
      rh_more_removed: '- {{n}}件削除',
      rh_restore_btn: '復元',
      rb_load_err: 'robots.txtの読み込みエラー',
      rb_save_err: '保存エラー',
      rb_analyze_err: '分析エラー',
      rb_score_good: '優秀',
      rb_score_ok: '要改善',
      rb_score_bad: '重大',
      rb_analysis_title: 'SEO Robots分析',
      rb_analyzing: '分析中…',
      rb_analyze: '分析',
      rb_analyze_hint: '「分析」をクリックしてSEOの問題と最適化の機会を自動検出',
      rb_no_issues: '問題は検出されませんでした',
      rb_no_issues_desc: 'robots.txtはShopifyのベストプラクティスに従っています',
      rb_critical: '重大',
      rb_warning: '警告',
      rb_validation_title: 'Robots.txt検証',
      rb_reload: '再読み込み',
      rb_editor_title: 'Robots.txtエディター',
      rb_modified: '変更済み',
      rb_diff_close: 'diffを閉じる',
      rb_editor_restore: '復元',
      rb_saving: '保存中…',
      rb_save: '保存',
      rb_blocking_warning: '🚨 サイト全体をブロックしています — "Disallow: /" でGoogleはどのページもインデックスできません',
      rb_diff_preview: '変更プレビュー:',
      rb_opportunity: 'チャンス',
      rb_checker_title: 'URL確認',
      rb_check_btn: '確認',
      rb_allowed: '許可',
      rb_blocked: 'ブロック',
      rb_sitemaps_title: '宣言されたサイトマップ',
      ll_history_title: 'LLMs.txt履歴',
      ll_generated: '生成済み',
      ll_restored_editor: 'v{{v}}をエディターに読み込みました — 公開をクリックして適用',
      ll_load_err: 'llms.txtの読み込みエラー',
      ll_generate_err: '生成エラー',
      ll_saved_ok: 'LLMs.txtをShopifyテーマに公開・確認しました',
      ll_not_configured: '未設定',
      ll_validation_title: 'LLMs.txt検証',
      ll_not_found: 'サイトにllms.txtが見つかりません。「Shopifyから生成」を使用して自動作成してください。',
      ll_what_title: 'LLMs.txtとは？',
      ll_what_desc: '/llms.txt標準は、AIモデル（ChatGPT、Claude、Perplexity、Gemini）がサイトを理解し回答で正確に引用するためのmarkdownファイルです。AI回答エンジンでの可視性を向上させます。',
      ll_editor_title: 'LLMs.txtエディター',
      ll_generating: '生成中…',
      ll_generate_btn: 'Shopifyから生成',
      tab_jsonld: 'JSON-LD',
      jl_load_err: 'JSON-LD概要の読み込みエラー',
      jl_sec_overview: '概要',
      jl_sec_schemas: 'スキーマ',
      jl_sec_problems: '問題',
      jl_sec_generate: 'AI最適化',
      jl_sec_preview: 'JSONプレビュー',
      jl_sec_validate: '検証',
      jl_sec_bulk: '一括操作',
      jl_sec_stats: '統計',
      jl_rich_results: 'リッチリザルト資格',
      jl_eligible: '適格',
      jl_warnings: '部分的',
      jl_not_eligible: '不適格',
      jl_field_coverage: 'フィールドカバレッジ',
      jl_what_title: 'JSON-LDとは？',
      jl_what_desc: 'JSON-LDはGoogleが推奨する構造化データ形式です。検索でのリッチリザルト（星、価格、パンくずリスト）を有効にし、AIモデルが商品をより理解できるようにします。',
      jl_score_poor: 'カバレッジ不足',
      jl_schemas_title: 'サポートされるスキーマタイプ',
      jl_status_valid: '有効',
      jl_status_partial: '部分的',
      jl_status_missing: '未設定',
      jl_valid_items: '有効',
      jl_issues: '問題',
      jl_google_test: 'Googleリッチリザルトでテスト',
      jl_google_test_desc: 'JSON-LD生成後、GoogleのツールでTester資格を直接確認できます。',
      jl_problems_title: '診断上の問題',
      jl_no_problems: '重大な問題は見つかりません。JSON-LDカバレッジは良好です！',
      jl_products_affected: '件の商品が影響を受けています',
      jl_sev_critical: '重大',
      jl_sev_warning: '警告',
      jl_prob_brand: 'ブランド/ベンダーが欠落',
      jl_prob_desc: '説明が欠落',
      jl_prob_image: '商品画像が欠落',
      jl_prob_sku: 'SKUが欠落',
      jl_prob_gtin: 'GTIN/バーコードが欠落',
      jl_prob_meta: 'メタ説明が欠落',
      jl_prob_offers: '価格がJSON-LDにない（Shopifyテーマスニペットが必要）',
      jl_problems_tip: '商品セクションで欠落フィールドを修正するか、AI最適化を使用して自動入力してください。',
      jl_gen_title: 'JSON-LD生成',
      jl_schema_type: 'スキーマタイプ',
      jl_product_id: '商品ID（空白でサンプル使用）',
      jl_use_ai: 'AI強化を使用（GPT）',
      jl_gen_btn: 'JSON-LDを生成',
      jl_gen_ok: 'JSON-LDが生成されました',
      jl_gen_err: '生成エラー',
      jl_copied: 'コピーしました！',
      jl_copy: 'コピー',
      jl_preview_title: 'JSON-LDプレビュー',
      jl_preview_err: 'プレビューの読み込みエラー',
      jl_load_preview: 'サンプル商品を読み込む',
      jl_preview_empty: '「サンプル商品を読み込む」をクリックして、すべてのJSON-LDスキーマをプレビュー',
      jl_val_title: 'ローカルスキーマ検証',
      jl_invalid_json: '無効なJSON',
      jl_val_btn: 'JSON-LDを検証',
      jl_val_clear: 'クリア',
      jl_val_ok: '有効 — リッチリザルト適格',
      jl_val_fail: '検証失敗',
      jl_val_note: 'このバリデーターはschema.orgの要件を確認します。公式Googleテストにはリッチリザルトテストを使用してください。',
      jl_val_err: '検証エラー',
      jl_bulk_title: '一括操作',
      jl_bulk_gen: '全件生成',
      jl_bulk_gen_desc: 'すべての商品のProduct JSON-LDを構築してDBに保存',
      jl_bulk_val: '全件検証',
      jl_bulk_val_desc: '既存のJSON-LDでschema.org検証を実行',
      jl_bulk_fix: '修正と強化',
      jl_bulk_fix_desc: 'エラーのある商品のJSON-LDを再構築',
      jl_bulk_started: '一括操作が開始されました',
      jl_bulk_err: '一括操作の開始エラー',
      jl_bulk_running: '処理中',
      jl_bulk_done: '完了',
      jl_bulk_stop: '停止',
      jl_bulk_stopped: '一括操作が停止されました',
      jl_errors: 'エラー',
      jl_stat_total: '合計商品数',
      jl_stat_eligible: 'リッチリザルト適格',
      jl_stat_gen_today: '本日生成',
      jl_stat_fixed: '本日修正',
      jl_coverage_by_type: 'コンテンツタイプ別カバレッジ',
      jl_type: 'タイプ',
      jl_total: '合計',
      jl_valid2: '有効',
      jl_missing2: '欠落',

      ll_revert: '元に戻す',
      ll_publishing: '公開中…',
      ll_publish: '公開',
      lp_filter_url: 'URLを絞り込む…',
      lp_copied: 'コピーしました',
      lp_broken_empty: '壊れたリンクは検出されませんでした',
      lp_broken_empty_sub: 'すべてのストアURLに到達可能です (404 / 410 / timeout)',
      lp_timeout: 'タイムアウト — 12秒以内に応答なし',
      lp_ratelimit_empty: 'レート制限は検出されませんでした',
      lp_ratelimit_empty_sub: 'サーバーはスキャナーのリクエストを制限しませんでした',
      lp_ratelimit_note: 'ページ到達可能ですがスキャン中にサーバーが429を返しました',
      lp_server_empty: 'サーバーエラーは検出されませんでした',
      lp_server_empty_sub: 'すべてのURLが正常に応答しています (5xxなし)',
      lp_server_note: 'HTTP {{code}} — サーバー側エラー',
      lp_redirect_empty: 'リダイレクトは検出されませんでした',
      lp_redirect_total: '合計リダイレクト',
      lp_chains: 'チェーン (>1ホップ)',
      lp_loops: '検出されたループ',
      lp_chains_header: 'リダイレクトチェーン',
      lp_chains_badge: '{{n}}件の多段チェーン',
      lp_final_status: '最終ステータス:',
      lp_canon_ok: '正常',
      lp_canon_miss: '欠如',
      lp_canon_wrong: 'URL誤り',
      lp_canon_cross: 'クロスドメイン',
      lp_canon_redir: 'Canonical→リダイレクト',
      lp_canon_action_missing: 'ページのhead内にcanonicalタグを追加してください。',
      lp_canon_action_wrong: 'このページの最終URLを指すようにcanonicalを修正してください。',
      lp_canon_action_cross: 'canonicalが外部ドメインを指しています。意図的かエラーか確認してください。',
      lp_canon_action_redir: 'canonicalがリダイレクトするURLを指しています。最終URLに更新してください。',
      lp_canon_no_data: 'Canonicalデータが利用できません — スキャンを開始してください',
      lp_canon_issues: 'Canonicalの問題 ({{n}})',
      lp_canon_no_issues: 'Canonicalの問題は検出されませんでした',
      lp_canon_sample: '分析済みサンプル: ストアの{{n}}件のURL（商品、コレクション、ページ、記事）',
      il_tab_orphans: '孤立ページ',
      il_tab_weak: '弱いリンク',
      il_tab_deep: '深いページ',
      il_kpi_weak: '弱いリンク ≤2',
      il_kpi_deep: '深いページ',
      il_orphan_empty: '孤立ページなし',
      il_orphan_empty_sub: 'すべてのページに少なくとも1つの内部リンクがあります',
      il_orphan_header: '入力リンクのないページ ({{n}})',
      il_weak_empty: '弱いリンクのあるページなし',
      il_weak_empty_sub: 'すべてのページに3つ以上の内部リンクがあります',
      il_weak_header: '入力リンクが1–2个のページ ({{n}})',
      il_anchor_empty: 'アンカーテキスト最適化済み',
      il_anchor_empty_sub: '汎用・空・重複アンカーは検出されませんでした',
      il_anchor_generic: '汎用アンカー',
      il_anchor_generic_desc: '「こちらをクリック」「こちら」「詳しく」などのテキスト',
      il_anchor_empty_type: '空のアンカー',
      il_anchor_empty_desc: '説明テキストのないリンク',
      il_anchor_dup: '重複アンカー',
      il_anchor_dup_desc: '同じテキスト → 異なるURL',
      il_anchor_lbl_gen: '汎用',
      il_anchor_lbl_empty: '空',
      il_anchor_lbl_dup: '重複',
      il_deep_empty: '過度に深いページなし',
      il_deep_empty_sub: 'すべてのページはホームページから≤3クリックで到達可能',
      il_deep_header: 'ホームページから>3クリックのページ ({{n}})',
      il_deep_note: '∞のページは内部リンク経由で到達不可。メニューやコレクションに追加してください。',
      il_hub_empty: 'ハブデータがありません',
      il_hub_empty_sub: 'スキャンを実行してハブページを特定してください',
      il_hub_header: 'ハブページ — 最も内部リンクされている',
      il_hub_count: '{{n}}件の内部被リンク',
      lm_active: 'アクティブ',
      lm_not_installed: '未インストール',
      lm_install_hint: 'テーマにインストールしてクロールなしで実際のナビゲーションを監視',
      lm_refresh: '更新',
      lm_clear: 'データ消去',
      lm_remove: 'テーマから削除',
      lm_installing: 'インストール中…',
      lm_install: 'テーマにインストール',
      lm_tab_404: '404エラー',
      lm_tab_redirect: 'リダイレクト機会',
      lm_tab_top: 'トップページ',
      lm_kpi_visits: '総訪問数',
      lm_kpi_404s: '実際の404エラー',
      lm_no_404: 'ユーザーによる404エラーは検出されませんでした',
      lm_visits: '訪問',
      lm_theme_prefix: 'テーマ: ',
      lm_last_activity: '最終アクティビティ: ',
      lm_no_activity: 'まだ訪問なし',
      lm_installed: 'テーマ "{{name}}" にMonitorをインストールしました',
      lm_err_install: 'インストールエラー',
      lm_confirm_remove: 'アクティブなテーマから監視スクリプトを削除しますか？',
      lm_removed: 'テーマからスクリプトを削除しました',
      lm_err_remove: '削除エラー',
      lm_confirm_clear: '収集したすべての監視データを削除しますか？',
      lm_cleared: 'データを削除しました',
      lm_err_clear: 'データ削除エラー',
      lm_modal_title: 'リダイレクト 301 を作成',
      lm_modal_source: 'ソース URL (404)',
      lm_modal_dest: '転送先',
      lm_redirect_created: 'リダイレクト 301 を Shopify に作成しました',
      lm_err_redirect: 'リダイレクト作成エラー',
      lm_create_redirect: 'リダイレクトを作成',
      lm_creating: '作成中…',
      lm_cancel: 'キャンセル',
      lm_info_title: 'Live Monitor の仕組み',
      lm_info_1: '「テーマにインストール」ボタンは Shopify Themes API を通じて軽量スクリプトをアクティブテーマに自動追加します',
      lm_info_2: '各実訪問で収集するデータ：URL、ページタイプ、内部リンク、404エラー、内部リファラー',
      lm_info_3: 'クロールなし — HTTP 429 なし — リアルタイムで実際の訪問者データを収集',
      lm_info_4: '内部リンクマップを段階的に構築し、孤立したページを検出します',
      lm_no_redirect: 'リダイレクト不要',
      lm_no_redirect_hint1: 'Live Monitorはまだ訪問を記録していません。実際のユーザーが404ページに遭遇するとリダイレクト機会が表示されます。',
      lm_no_redirect_hint2: '分析した{{n}}回の訪問で404ページに遭遇したユーザーはいませんでした。素晴らしい！',
      lm_toolbar_ai: '{{count}} URL · {{ai}} AI提案あり',
      lm_toolbar_ignored: '· {{n}} 無視済み',
      lm_sort_visits: '訪問数',
      lm_sort_date: '日付',
      lm_selected: '{{n}} 選択済み',
      lm_no_match: '自動マッチなし',
      lm_create: '作成',
      lm_ignore: '無視',
      lm_err: 'エラー',
      lm_bulk_ignored: '{{n}} URL を無視しました',
      lm_bulk_created: '{{n}} リダイレクトを作成しました',
      lm_errors: 'エラー',
      ls_scan_started: 'スキャンを開始しました — バックグラウンドで完了します',
      ls_scan_err: 'スキャン開始エラー',
      ls_last_scan: '最終スキャン: {{date}} · {{n}} URL',
      ls_no_scan_desc: 'スキャン未実施 — 壊れたリンク、リダイレクト、canonical、孤立ページを検出',
      ls_scanning: 'スキャン中…',
      ls_rescan: '再スキャン',
      ls_start_scan: 'スキャン開始',
      ls_canonical_issues: 'Canonicalの問題',
      ls_scan_details: 'スキャン詳細',
      ls_stat_total: '総URL数',
      ls_stat_errors: 'エラー',
      ls_no_scan: 'スキャン未実施',
      ls_no_scan_long: '壊れたリンク、リダイレクトチェーン、canonical問題、受信リンクのない孤立ページを検出するためスキャンを開始してください',
      ls_first_scan: '最初のスキャンを開始',
      db_gsc_connected: 'Google Search Consoleが接続されました！',
      db_gsc_err: 'GSC接続エラー: {{code}}',
      db_props_err: 'GSCプロパティを読み込めません',
      db_oauth_hint: '新しいタブでGoogle認証を完了してください。ページは自動的に更新されます。',
      db_conn_err: 'GSC接続エラー',
      db_prop_selected: 'プロパティを選択しました: {{url}}',
      db_prop_err: 'プロパティ選択エラー',
      db_confirm_disconnect: 'Google Search Consoleを切断しますか？',
      db_disconnected: 'GSCを切断しました',
      db_disconnect_err: '切断エラー',
      db_connected: 'Search Console接続済み',
      db_no_property: 'プロパティが選択されていません',
      db_not_connected: '未接続',
      db_connect_hint: 'GSCを接続してアナリティクスとモニタリングを有効にする',
      db_change_prop: 'プロパティを変更',
      db_disconnect: '切断',
      db_connect: 'GSCを接続',
      db_idx_subtitle: '技術的SEO品質 & インデックス',
      db_lbl_gsc: 'GSC接続済み',
      db_lbl_sitemap: 'サイトマップ送信済み',
      db_lbl_indexed: 'インデックス済みURL',
      db_health_real: '実際のSearch Consoleデータに基づく',
      db_health_proxy: 'カタログ品質に基づく — 実データにはGSCを接続',
      db_lbl_position: '順位',
      db_lbl_trend: 'トレンド28日',
      db_lbl_errors: 'エラー',
      db_connect_score: 'スコアを計算するにはGSCを接続',
      db_proxy_note: 'カタログプロキシ',
      db_stat_excluded: '除外済みURL',
      db_stat_seo_score: '平均SEOスコア',
      db_catalog_title: 'カタログ健全性',
      db_cat_alt: '画像ALTテキスト',
      db_cat_keywords: 'キーワード未設定',
      db_cat_no_kw: 'キーワードなし商品: {{n}}件',
      db_cat_count: '{{n}} / {{total}} 商品',
      tab_opportunities: 'SEOチャンス',
      tab_indexing: 'インデックス',
      locked_available: '{{plan}}プランから利用可能',
      locked_upgrade: '{{plan}}プランにアップグレード',
      main_subtitle: '技術的SEO · インデックス · Analytics · AI自動化',
      phase_3: 'フェーズ3',
      interval_all: 'すべて',
      click_monthly_est: '推定クリック数/月',
      fix_title_updated: 'タイトルタグが更新されました',
      fix_meta_updated: 'メタ説明が更新されました',
      fix_both_updated: 'タイトルとメタ説明がShopifyで更新されました',
      fix_apply_err: 'アプリケーションエラー',
      rb_save_ok: 'robots.txtがShopifyテーマに保存・確認されました',
      rb_draft_with_err: '下書きが保存されました ({{err}})',
      rb_draft_manual: '下書きが保存されました — テーマに適用するための手順に従ってください',
      rb_critical_confirm: '🚨 重大な警告 🚨\n\nrobots.txtに"Disallow: /"が含まれており、サイト全体が完全にブロックされています:\nGoogle、Bingおよびすべてのボットはどのページもクロールできなくなります。\n\nこれにより、サイトが検索結果から削除される可能性があります。\n\n続行してよろしいですか？',
      scan_err: 'スキャンエラー: {{msg}}',
      sm_send_err: '送信エラー',
      unknown_err: '不明',
      dq_today: '今日',
      dq_7d: '過去7日間',
      dq_30d: '過去30日間',
      dq_daily_avg: '1日平均',
      dq_at_pace: 'ペース: ~{{n}}/日',
      job_stopped: '{{n}} URL処理時点で停止',
      job_inspected: '{{n}}件検査済み',
      job_errors: 'エラー',
      quota_remaining: '残りクォータ:',
      lk_trend: 'インデックスト レンド',
      lk_batch: 'バッチ検査 (一括URLスキャン)',
      lk_ai: 'AIインデックス提案',
      footer_apis: 'Sitemaps API + Search Analytics + Inspection API',
      prod_status_lbl: 'ステータス:',
      prod_desc_lbl: '説明:',
      prod_missing: '未設定',
      state_disc: '発見済',
      state_crawl: 'クロール済',
      insp_api_real: 'Inspection API ✓ 実データ',
      sm_count: '{{n}}件のサイトマップ',
      sm_reliability: '信頼性:',
      conf_high: '高',
      conf_medium: '中',
      conf_low: '低',
      sm_urls: 'サイトマップのURL',
      sm_sample: 'サンプル',
      sm_est_indexed: '推定インデックス済',
      sm_est_nonidx: '推定未インデックス',
      sm_coverage: '推定カバレッジ ⓘ',
      sm_idx_of: 'サイトマップ{{t}}URL中{{n}}件インデックス済',
      sm_cov_est: '推定カバレッジ:',
      sm_margin_err: '誤差範囲',
      sm_indexed_of: 'インデックス済 /',
      sm_sampled: 'サンプル中',
      sm_th_sitemap: 'サイトマップ',
      sm_th_submitted: '送信済',
      sm_th_indexed: 'インデックス済',
      sm_th_gap: 'ギャップ',
      sm_th_coverage: 'カバレッジ',
      sm_th_warning: '警告',
      sm_th_errors: 'エラー',
      sm_th_lastmod: '最終更新',
      sm_th_actions: 'アクション',
      rb_verified_result: 'Shopifyテーマに保存・確認済 ({{theme}}) — ファイル:',
      rb_draft_result: '下書き保存。手動適用: Shopify管理 → テーマ → コード編集 →',
      ll_draft_result: '下書き保存。手動適用: Shopify管理 → テーマ → コード編集 →',
      ls_section_redirects: 'リダイレクト管理',
      rm_tab: 'リダイレクト管理',
      rm_subtitle: 'ストアのリダイレクトを一か所にまとめて管理。',
      rm_kpi_total: 'ルール合計',
      rm_kpi_active: '有効なリダイレクト',
      rm_kpi_pending: '保留中の404',
      rm_kpi_hits: 'ヒット（30日）',
      rm_kpi_chains: 'チェーン',
      rm_kpi_loops: 'ループ',
      rm_section_rules: 'ルール',
      rm_section_suggest: 'AIさってい',
      rm_section_health: 'ヘルス',
      rm_section_import: 'インポート / エクスポート',
      rm_section_history: '履歴',
      rm_create_title: 'リダイレクトを作成',
      rm_edit_title: 'リダイレクトを編集',
      rm_old_url: '古いURL',
      rm_new_url: '新しいURL',
      rm_old_url_ph: '/古いパス',
      rm_new_url_ph: '/新しいパス',
      rm_type: 'タイプ',
      rm_type_301: '301 – 永久',
      rm_type_302: '302 – 一時',
      rm_notes: 'メモ',
      rm_save: '保存',
      rm_cancel: 'キャンセル',
      rm_create_ok: 'リダイレクトを作成しました。',
      rm_edit_ok: 'リダイレクトを更新しました。',
      rm_create_err: 'リダイレクトの作成中にエラーが発生しました。',
      rm_edit_err: 'リダイレクトの保存中にエラーが発生しました。',
      rm_dup_err: 'このソースURLのリダイレクトは既に存在します。',
      rm_empty_err: 'ソースURLと転送先URLは必須です。',
      rm_same_err: 'ソースURLと転送先URLは同じにできません。',
      rm_search_ph: 'URLを検索…',
      rm_filter_all: 'すべて',
      rm_filter_active: '有効',
      rm_filter_disabled: '無効',
      rm_create_btn: 'リダイレクトを作成',
      rm_selected_items: '{{count}}件選択中',
      rm_bulk_enable: '有効化',
      rm_bulk_disable: '無効化',
      rm_bulk_delete: '削除',
      rm_bulk_export: 'CSVをエクスポート',
      rm_bulk_ok: '操作が完了しました。',
      rm_table_old: '古いURL',
      rm_table_new: '新しいURL',
      rm_table_type: 'タイプ',
      rm_table_hits: 'ヒット',
      rm_table_status: 'ステータス',
      rm_table_actions: 'アクション',
      rm_edit: '編集',
      rm_duplicate: '複製',
      rm_delete: '削除',
      rm_delete_confirm: 'このリダイレクトを削除しますか？',
      rm_deleted_ok: 'リダイレクトを削除しました。',
      rm_delete_err: '削除中にエラーが発生しました。',
      rm_status_active: '有効',
      rm_status_disabled: '無効',
      rm_no_data: 'リダイレクトが見つかりません。',
      rm_empty_state: 'リダイレクトがまだありません。最初のリダイレクトを作成してください。',
      rm_total_redirects: '合計{{count}}件',
      rm_import_title: 'リダイレクトをインポート',
      rm_import_csv: 'CSV (old_url,new_url,type)',
      rm_import_shopify: 'Shopify Export CSV',
      rm_import_sf: 'Screaming Frog CSV',
      rm_import_btn: 'インポート',
      rm_import_ok: 'インポートが完了しました。',
      rm_import_err: 'インポート中にエラーが発生しました。',
      rm_import_imported: '{{count}}件インポート済み',
      rm_import_skipped: '{{count}}件スキップ',
      rm_export_title: 'リダイレクトをエクスポート',
      rm_export_desc: '利用可能な形式でリダイレクトをダウンロード。',
      rm_export_csv: 'CSVをエクスポート',
      rm_export_json: 'JSONをエクスポート',
      rm_ai_title: 'AIさってい',
      rm_ai_subtitle: 'AIが404 URLを検出し、類似商品へのリダイレクトを指尾。',
      rm_ai_accept: '承諾',
      rm_ai_reject: '拒否',
      rm_ai_accept_all: 'すべて承諾',
      rm_ai_loading: '分析中…',
      rm_ai_empty: '現在、さっていはありません。',
      rm_chains_title: 'リダイレクトチェーン',
      rm_chains_desc: '連鎖したリダイレクトはサイトを遅くします。',
      rm_chains_fix: 'チェーンを修正',
      rm_chains_empty: 'チェーンは検出されませんでした。',
      rm_chains_fixed: 'チェーンを修正しました。',
      rm_loops_title: 'リダイレクトループ',
      rm_loops_desc: '循環ループはエラーを引き起こします。手動修正が必要です。',
      rm_loops_fix: '修正',
      rm_loops_empty: 'ループは検出されませんでした。',
      rm_gsc_title: 'Google Search Consoleの404',
      rm_gsc_subtitle: '遠く90日間にGSCが検出した未発見URL。',
      rm_gsc_empty: 'GSCの404は検出されませんでした。',
      rm_history_title: 'アクティビティ履歴',
      rm_history_created: '作成',
      rm_history_edited: '編集',
      rm_history_deleted: '削除',
      rm_history_disabled: '無効化',
      rm_history_enabled: '有効化',
      rm_history_imported: 'インポート',
      rm_history_bulk: '一括操作',
      rm_history_empty: 'アクティビティは記録されていません。',
      rm_sync_shopify: 'Shopifyから同期',
      rm_sync_shopify_desc: 'ShopifyのすべてのURLリダイレクトをインポート。新しいリダイレクトは自動的にShopifyに送信されます。',
      rm_sync_btn: '今すぐ同期',
      error_label: 'エラー:',
      rb_checker_desc: '現在のrobots.txtに基づき、URLが{{bot}}によって許可または拒否されるか確認します。',
      rb_rule: 'ルール:',
      rb_fix: '修正:',
      rb_gsc_note_title: 'Search Consoleとの統合',
      rb_gsc_note_body: 'インデックスセクションで「robotsによりブロック」ステータスのURLは、Googleがクロールできないページを示します。',
      rb_issues: '問題',
      rb_opps: '改善機会',
      rb_savings: '推定改善効果:',
      never: '未実行',
      samples_conf: '{{n}}件サンプル · 信頼度 {{c}}',
      batch_priority_note: 'Analytics表示回数のあるURLを優先検査 · GSCクォータ2,000/日 · バックグラウンド処理',
      sm_samples: 'サンプル',
      sm_footnote_ec: '~ "計算中"の値 = Inspection APIからの推定値 ({{n}}件サンプル · 信頼度 {{c}})。サイトマップインデックスはSitemaps APIが0を返します。',
      sm_footnote_noec: '~ "計算中"の値 = 比例推定値。バッチスキャンを開始してください。サイトマップインデックスはSitemaps APIが0を返します。',
      ic_quota_note: 'Inspection API経由で{{n}}件のURLを基に計算 (クォータ2,000件/日)。GSC Coverageでは{{m}}件の未インデックスURLがサイトマップに表示されています。',
      cov_crawled_ni: '低品質またはコンテンツの重複。コンテンツを改善し、ユニークなテキストを追加し、canonicalタグを確認してください。',
      cov_disc_ni: 'Googleは発見しましたが、まだクロールしていません。内部リンクを追加してサイトマップを更新し、クロールバジェットを増やしてください。',
      cov_dup_nocanon: 'メインページを指すcanonicalタグを追加してください。',
      cov_dup_googcanon: 'Googleは宣言されたcanonicalを無視しています。デスクトップ/モバイルバージョン間でURLとcanonicalの一貫性を確認してください。',
      cov_redirect: 'アクティブなリダイレクト。意図的な場合は、内部リンクを更新して直接宛先を指すようにしてください。',
      cov_alternate: '正しいcanonicalを持つ代替ページ — 意図的な場合はアクションは不要です。',
      cov_noindex: 'ページをインデックスしたい場合は、meta noindexタグを削除してください。',
      cov_robots: 'robots.txtによってブロックされたページ。Disallowディレクティブを確認し、必要に応じて更新してください。',
      cov_removed: 'GSCから手動で削除されました。必要に応じてSearch Consoleパネルから削除を取り消してください。',
      cov_404: 'ページが見つかりません。ページを復元するか、301リダイレクトを設定するか、このURLへの内部リンクを削除してください。',
      cov_soft404: 'サーバーは200を返しますが、Googleは空のページとして扱います。ページに関連するコンテンツがあることを確認してください。',
      cov_server_err: 'サーバーエラー。クロール中のサーバーログとホスティングの可用性を確認してください。',
      cov_unknown_url: 'GoogleはまだこのURLを発見していません。内部リンクを追加し、サイトマップを更新し、次回のクロールを待ってください。',
      qt_brand: 'ブランド',
      qt_info: '情報',
      qt_category: 'カテゴリ',
      qt_product: '商品',
      qt_generic: 'ジェネリック',
      sugg_title_improvement: 'タイトルタグ',
      sugg_meta: 'メタディスクリプション',
      sugg_content_gap: 'コンテンツ不足',
      sugg_schema: 'スキーママークアップ',
      sugg_links: '内部リンク',
      verdict_indexed: 'インデックス済み',
      verdict_not_indexed: '未インデックス',
      verdict_excluded: '除外済み',
      badge_col_header: 'バッジ',
      sitemap_label: 'サイトマップ',
      ls_tab_broken: '壊れたリンク',
      ls_tab_redirect: 'リダイレクト',
      ls_tab_rate_limited: 'レート制限',
      ls_tab_server_errors: 'サーバーエラー',
      ls_tab_canonical: 'カノニカル',
      ls_tab_internal: '内部リンク',
      ls_section_monitor: 'ライブモニター',
      ls_section_audit: 'サイト構造',
      db_idx_title: 'インデックススコア',
      db_health_title: 'SC健全スコア',
      canonical_mismatch: 'カノニカル不一致',
    },
    so: {
      load_err: 'Speed Optimizerの読み込みエラー',
      analyze_timeout: '分析タイムアウト(90秒) — もう一度お試しください',
      analyze_done: '分析完了!',
      analyze_failed: '分析失敗: {{error}}',
      rate_limited: 'リクエスト制限に達しました — キャッシュからデータを更新しました',
      analyze_err: '分析エラー',
      opt_enabled: '{{label}}をテーマで有効化しました',
      opt_disabled: '{{label}}を無効化しました',
      opt_err: '最適化エラー',
      scan_err: 'テーマスキャンエラー',
      img_err: '画像分析エラー',
      sg_protected: 'Safety Guard: Protectedを有効化しました',
      sg_standard: 'Safety Guard: Standardを有効化しました',
      mode_err: 'モード変更エラー',
      plan_err: 'プラン生成エラー',
      strategy_applied: 'ストラテジー{{label}}をテーマに適用しました',
      strategy_err: 'ストラテジー適用エラー',
      sessions_err: 'セッション読み込みエラー',
      rollback_done: 'ロールバック完了 — テーマを復元しました',
      rollback_err: 'ロールバックエラー',
      subtitle: 'Shopifyテーマの安全な最適化と即時ロールバック。',
      btn_rollback: 'すべてロールバック',
      btn_analyze: '今すぐ分析',
      analyzing_psi: 'PSI処理中…',
      analyzing_queue: 'キュー中…',
      analyzing: '分析中…',
      alert_no_token: 'Shopifyトークンがありません — 最適化にはアクティブなストア接続が必要です。',
      alert_no_scope: 'テーマ権限がありません — 最適化を適用するにはアプリを再インストールしてください。',
      perf_empty: '利用可能な分析がありません',
      perf_empty_hint: '"今すぐ分析"をクリックしてストアのパフォーマンスを測定してください',
      suggestions: '提案',
      strategy_active: 'アクティブ',
      strategy_subtitle: '最適化ターゲットを設定します。適用前にプランを確認するにはクリックしてください。',
      sg_header: 'ストラテジーが実行できる操作を制限します。',
      sg_desc_protected: 'Standard操作をブロック — 安全な最適化のみ。',
      sg_desc_standard: '選択したストラテジーの完全実行を許可します。',
      quick_opts: 'クイック最適化',
      sg_warning: 'Safety Guard: Protected — Standard操作がブロックされています。上でStandardに切り替えてください。',
      lcp_section: 'LCPテーマスキャン',
      hist_section: '最適化履歴',
      hist_empty: 'まだ最適化は適用されていません。',
      sessions_section: 'セッション & Lighthouse影響',
      sessions_empty: 'Core Web Vitalsへの実際の影響を見るにはセッションを読み込んでください。',
      img_count: '{{n}}枚の画像 · {{kb}} KB合計',
      img_oversized: '{{n}}枚の画像 >300KB',
      img_no_oversized: 'サイズオーバーの画像なし — 素晴らしい!',
      img_empty: '"画像分析"をクリックしてテーマ内の>300KB画像を見つけてください。',
      btn_refresh: '再読み込み',
      btn_load_sessions: 'セッションを読み込む',
      btn_refresh_sessions: '更新',
      btn_analyze_img: '画像を分析',
      btn_refresh_img: '更新',
      modal_risk_safe: '安全 — 視覚的な影響は予想されません',
      modal_risk_medium: '有効化後にサイトの外観を確認してください',
      modal_risk_high: '高度な機能に影響を与える可能性があります',
      modal_reversible: 'いつでも元に戻せます — "すべてロールバック"で元のテーマを復元できます。',
      modal_cancel: 'キャンセル',
      modal_enable: '今すぐ有効化',
      opt_no_token: 'この機能を使用するにはShopifyストアを再接続してください',
      opt_blocked_guard: 'Safety Guard (Protected) によりブロックされています — Standardに切り替えて有効化してください',
      opt_reversible: '元に戻せます',
      opt_blocked_label: 'Safety Guardによりブロック — Standardに切り替えてください',
      scan_scanning: 'スキャン中...',
      scan_empty_title: 'テーマスキャン未実行',
      scan_empty_desc: 'テーマ内のheroとスライドショーセクションを特定して、サーバーサイドLCP最適化を有効にします。',
      scan_btn: 'テーマをスキャン',
      scan_active_theme: 'アクティブなテーマ',
      scan_files: '{{n}}個のLiquidファイルをスキャン · {{s}}個のLCPセクションを特定',
      scan_hero_label: 'hero/LCPセクション',
      scan_optimized: '最適化済み',
      scan_no_lcp: 'テーマ内にhero/LCPセクションが自動的に特定されませんでした。',
      scan_reload: '再読み込み',
      plan_title: 'プラン: {{label}}',
      plan_ops: '{{n}}件の操作予定',
      plan_action_enabled: '既に有効',
      plan_action_enable: '有効化',
      plan_action_disable: '無効化',
      plan_strategy: 'ストラテジー: ',
      plan_guard: 'Safety Guard: ',
      plan_active_ops: 'アクティブな操作: ',
      plan_blocked: '{{n}}件がSafety Guardによりブロック',
      plan_low_conf: '一部の最適化は検出されたテーマに対して信頼度が低いです。',
      plan_cancel: 'キャンセル',
      plan_apply: 'ストラテジーを適用',
      plan_blocked_btn: 'ブロック中 (スコア低)',
      hist_rollback: '完全ロールバック — 全ての最適化を削除',
      hist_enabled: '有効化済み',
      hist_disabled: '無効化済み',
      hist_active: 'アクティブ',
      sess_no_sessions: '最適化セッションが記録されていません。ストラテジーを適用するとセッションが作成されます。',
      sess_waiting: 'PSI待機中',
      strategy_label: 'ストラテジー {{s}}',
      strategy_opts: '{{n}}件の最適化',
      strategy_active: 'アクティブ',
      quota_err: 'PSIクォータの読み込みエラー',
      quota_api_key: 'APIキー設定済み:',
      quota_yes: '✓ はい',
      quota_no: '✗ いいえ (公開クォータ使用)',
      quota_cache_ttl: 'キャッシュTTL:',
      quota_hourly: '時間制限:',
      quota_daily: '日次制限:',
      quota_success: '本日の成功:',
      quota_hit_ratio: 'キャッシュヒット率:',
      quota_circuit: 'サーキットブレーカー:',
      quota_circuit_open: 'オープン ({{n}} 件の障害)',
      quota_circuit_closed: 'クローズ',
      quota_loading: '読み込み中...',
      diag_err: '診断エラー',
      diag_refresh: '更新',
      diag_load: '診断を読み込む',
      diag_patches: 'アクティブなパッチ ({{n}})',
      diag_none: 'なし',
      diag_unavailable: '利用不可',
      diag_no_patches: 'アクティブなパッチなし',
      diag_calibrated: '📈 キャリブレーション済み',
      diag_generated: '生成日時:',
      badge_server_side: 'サーバーサイド',
      badge_standard: 'スタンダード',
      badge_lcp: 'LCP',
      badge_critical: 'クリティカル',
      badge_safe: '安全',
      badge_medium: '中程度',
      badge_safety_guard: 'セーフティガード',
      diag_theme_fingerprint: 'テーマフィンガープリント',
      diag_engine_confidence: 'エンジン信頼度',
      perf_score_label: 'パフォーマンススコア',
      section_perf_overview: 'パフォーマンス概要',
      section_strategy_intent: '戦略的意図',
      safety_guard_title: 'セーフティガード',
      section_script_analyzer: 'スクリプト影響分析',
      script_col_file: 'ファイル',
      script_col_size: 'サイズ',
      script_col_impact: 'インパクト',
      script_col_defer_risk: '遅延リスク',
      metric_js_total: 'JS合計',
      metric_css_total: 'CSS合計',
      perf_updated: '更新日時:',
      perf_stale: '古いデータ（PSI利用不可）',
      perf_from_cache: 'キャッシュから',
      perf_psi_ok: 'PSI OK',
      debug_invalid_token_title: '無効なトークン（401）— MongoDBのトークンが期限切れまたは取り消されました。',
      debug_reconnect_desc: 'OAuthコールバックは最後の再インストール後にトークンを上書きしませんでした。以下のボタンをクリックして新しいOAuthを開始してください。',
      debug_reconnect_btn: '今すぐOAuthに再接続（Shopifyを開く）',
      debug_reconnect_note: 'Shopifyでの権限承認後、コールバックがMongoDBのトークンを自動的に更新します。',
    },
    drafts: {
      approved: '下書きが承認されました！',
      approve_err: '承認エラー',
      published: 'Shopifyに公開されました！',
      publish_err: '公開エラー',
      title: '下書きと結果',
      subtitle: '最適化されたコンテンツを確認、承認、公開する',
      empty: '確認する下書きはありません',
      empty_hint: 'AIコンテンツを生成して新しい下書きを作成する',
      badge_approved: '承認済み',
      badge_draft: '下書き',
      field_desc: '説明',
      btn_view: '表示',
      btn_approve: '承認',
      btn_publish: '公開',
      modal_title: '下書き詳細',
      chars_seo: '/60文字',
      chars_meta: '/160文字',
      not_present: 'なし',
      not_present_pl: 'なし',
      btn_close: '閉じる',
      btn_publish_shopify: 'Shopifyに公開',
      seo_title: 'SEOタイトル',
      meta_description: 'メタディスクリプション',
      keywords_label: 'キーワード',
    },
    usage: {
      title: '利用状況とプラン',
      subtitle: '利用状況を監視してサブスクリプションを管理する',
      plan_badge: 'プラン:',
      current: '現在の利用状況',
      credits: 'AIクレジット',
      used: '使用済み:',
      unlimited: '無制限 ∞',
      remaining: '残り: {{n}}',
      products_sync: '同期済み製品',
      plans_heading: '利用可能なプラン',
      most_popular: '⭐ 最も人気',
      active_plan: 'アクティブなプラン',
      current_plan: '現在のプラン',
      btn_upgrade: '{{name}}にアップグレード',
      trend_heading: '利用トレンド',
      trend_coming: '利用グラフ (近日公開)',
      stat_products: '分析済み製品',
      stat_content: '生成されたコンテンツ',
      stat_translations: '翻訳',
      stat_images: '最適化済み画像',
    },
    support: {
      msg_sent: 'メッセージを送信しました！',
      msg_err: 'メッセージの送信エラー',
      status_open: 'オープン',
      status_progress: '対応中',
      status_closed: 'クローズ',
      title: 'サポート',
      subtitle: 'FAQ、ガイド、チームとのチャット',
      faq_heading: 'よくある質問',
      guide_heading: 'クイックガイド',
      chat_heading: 'サポートチャット',
      no_msgs: 'メッセージなし',
      no_msgs_hint: 'サポートとの会話を開始する',
      placeholder: 'メッセージを入力...',
      contacts_heading: '連絡先',
      contact_hours_label: '時間',
      contact_hours: '月-金 9:00-18:00 CET',
      contact_response_label: '返答時間',
      contact_response: '24時間以内',
      guide_step1: 'セクションへ移動',
      guide_products: '製品',
      guide_step1b: '製品を確認する',
      guide_step2: '製品を選択して移動',
      guide_ai_content: 'AIコンテンツ',
      guide_step3: '説明、SEOタイトル、メタ説明、キーワードを生成',
      guide_step4: '結果を確認',
      guide_history: '履歴',
    },
    transl: {
      load_err: '要素の読み込みエラー',
      published: 'Shopifyに翻訳を公開しました！',
      pub_err: '公開エラー',
      err_no_items: '少なくとも1つの要素を選択してください',
      err_no_fields: '翻訳するフィールドを少なくとも1つ選択してください',
      item_err: '翻訳エラー',
      done_one: '翻訳完了！',
      done_many: '{{n}} 件翻訳されました！',
      copied: 'クリップボードにコピーしました',
      title: '翻訳',
      gate_plan: 'Starterプランから利用可能',
      gate_desc: 'AIで製品、コレクション、記事を8言語に翻訳',
      gate_btn: 'Starterプランに切り替え',
      subtitle: 'AIで製品、コレクション、記事、ページを複数言語に翻訳',
      translating: '翻訳中…',
      search_placeholder: 'タイトルで検索…',
      select_page: 'ページを選択',
      sel_abbrev: '選択',
      total_items: '合計',
      loading: '読み込み中…',
      no_results: 'この検索の結果はありません',
      prev: '← 前',
      tot_abbrev: '合計',
      next: '次 →',
      deselect_all: 'すべて選択解除',
      lang_heading: '翻訳先言語',
      fields_heading: '翻訳するフィールド',
      select_hint: '翻訳を有効にするにはリストから項目を選択してください',
      results_heading: '結果',
      clear_results: '結果をクリア',
      badge_published: '公開済み',
      publishing: '公開中…',
      done: '完了',
      publish: '公開',
      copy: 'コピー',
      tab_products: '製品',
      tab_collections: 'コレクション',
      tab_articles: '記事',
      tab_pages: 'ページ',
      field_title: 'タイトル',
      field_description: '説明',
      field_seo_title: 'SEO Title',
      field_meta_description: 'Meta Description',
      field_body_html: '説明 / 本文',
      empty_hint_select: 'リストから1つ以上の項目を選択し、言語を選んでクリック',
      translate_label: '翻訳',
      items_selected: '項目',
      item_selected: '項目',
      selected_label: '選択済み',
      choose_fields_hint: 'フィールドを選択して翻訳をクリック',
    },
  },

  zh: {
    nav: {
      overview: '概览',
      catalog: '目录',
      content: 'AI内容',
      translations: '翻译',
      images: '图片',
      batch: '批量操作',
      speed: '速度优化器',
      history: '历史记录',
      usage: '使用情况与套餐',
      settings: '设置',
      support: '支持',
    },
    common: {
      save: '保存',
      cancel: '取消',
      delete: '删除',
      close: '关闭',
      confirm: '确认',
      loading: '加载中...',
      error: '错误',
      success: '成功',
      search: '搜索',
      filter: '筛选',
      all: '全部',
      yes: '是',
      no: '否',
      back: '返回',
      next: '下一步',
      apply: '应用',
      generate: '生成',
      publish: '发布',
      optimize: '优化',
      refresh: '刷新',
    },
    settings: {
      title: '设置',
      subtitle: 'AI控制中心',
      tabs: {
        general: '常规',
        localization: '本地化',
        ai_engine: 'AI引擎',
        appearance: '外观',
        piano: '方案',
        advanced: '高级',
      },
      save_btn: '保存设置',
      unsaved: '未保存的更改',
      action_loading: '处理中...',
      general: {
        contents: '内容',
        default_lang: '默认内容语言',
        tone: '全局内容语气',
        tone_hint: '应用于产品、系列、文章和批次',
        seo_rules: 'SEO规则',
        seo_title_max: 'SEO标题最大长度',
        seo_title_hint: '推荐：50–60个字符',
        meta_max: '元描述最大长度',
        meta_hint: '推荐：150–160个字符',
        chars: '个字符',
        images: '图片偏好',
        img_format: '默认格式',
        img_square: '正方形 (1:1)',
        img_landscape: '横向 (4:3)',
        img_portrait: '纵向 (3:4)',
        img_quality: '压缩质量',
        img_quality_low: '50%（压缩）',
        img_quality_high: '100%（最高质量）',
        store_info: '店铺信息',
        store_domain: '域名',
        store_plan: '套餐',
        store_installed: '安装日期',
      },
      ai: {
        strategy: 'AI策略',
        params_title: '生成参数',
        creativity: '创造力',
        creative_low: '保守',
        creative_high: '富有创意',
        seo_strictness: 'SEO严格度',
        seo_low: '灵活',
        seo_high: '严格',
        tone_label: '全局语气',
        auto_title: 'AI自动优化',
        auto_hint: '启用以自动优化内容',
        on: '已激活',
        off: '关闭',
        threshold: '优化阈值',
        threshold_low: '优化全部',
        threshold_high: '仅最差的',
        threshold_hint: '作用于SEO得分 < {{n}} 的条目',
        frequency: '频率',
        scope: '范围',
        triggers: '触发器',
        img_format: '图片格式',
        img_square: '正方形 1:1',
        img_square_sub: '800×800 px',
        img_landscape: '横向 4:3',
        img_landscape_sub: '800×600 px',
        img_portrait: '纵向 3:4',
        img_portrait_sub: '600×800 px',
        img_no_resize: '不调整大小',
        img_no_resize_sub: '原始尺寸',
        compress: '压缩',
        compress_hint: '减少文件大小',
        quality: '质量',
        daily_credits: '今日AI点数',
        remaining: '剩余 {{n}}',
        reset_in: '重置于',
        running: '处理中 — {{done}}/{{total}} 个产品',
        run_now: '立即运行',
        run_desc: '优化得分 < {{threshold}} 的条目：{{scope}}',
        preview_title: '预览 — 前 / 后',
        before: '之前',
        after: 'AI之后',
        no_keywords: '无关键词',
        preview_note: '产品「跑步鞋 Pro X1」示例 — 即时更新',
        alt_mode_label: 'ALT文本生成模式',
        alt_preview: '预览',
        alt_mode_ai: '智能AI',
        alt_mode_ai_desc: 'OpenAI为每张图片生成优化的ALT文本',
        alt_mode_template: '免费模板',
        alt_mode_template_desc: '无需AI点数 — 使用下方模板',
        alt_mode_auto: '自动回退',
        alt_mode_auto_desc: 'AI优先，点数耗尽时使用模板',
        alt_hint_template: '免费模式：ALT文本不消耗AI点数。',
        alt_hint_auto: '自动回退：有点数时使用AI，否则自动使用模板。',
        pct_done: '{{pct}}%完成',
        n_errors: '{{n}}个错误',
        alt_template_label: '自定义模板',
        alt_vars_label: '可用变量 — 点击插入',
      },
      piano: {
        credits_title: '点数使用情况',
        plan_label: '套餐',
        extra_credits: '额外点数',
        unlimited: '∞ 无限点数',
        unlimited_sub: '精英套餐 — 无月度限制',
        plan_credits: '套餐点数',
        consumed: '套餐已消耗',
        residual: '套餐剩余',
        extra_available: '可用额外点数',
        extra_sub: '仅在月度套餐用完后消耗',
        total_available: '总可用',
        consumed_cycle: '当前周期已消耗点数',
        status_active: '已激活',
        status_pending: '处理中',
        status_frozen: '⚠ 已暂停',
        status_free: '免费 / 无订阅',
        trial_active: '试用期激活',
        trial_access: '完整访问至 {{date}}。',
        sub_status: '订阅状态',
        next_credit_reset: '下次积分重置',
        trial_end: '试用期结束',
        trial_label: '免费试用',
        trial_used: '已使用',
        trial_available: '可用 {{n}} 天',
        cancel_btn: '取消订阅',
        cancelling: '取消中...',
        plans_title: '可用套餐',
        plan_active: '当前套餐',
        plan_current: '现有套餐',
        per_month: '/月',
        downgrade: '降回免费版',
        downgrading: '降级中...',
        upgrade: '升级',
        downgrade_btn: '降级',
        redirecting: '跳转中...',
        trial_btn: '免费试用',
        trial_btn_days: '({{n}}天)',
        plan_overage: '额外AI积分：每积分{{price}}',
        plan_no_overage: '无额外AI积分费用',
        plan_trial_line: '{{n}}天免费试用',
        plans_note: '付费套餐包含{{n}}天免费试用。无激活费用。通过Shopify Billing付款。',
        credits_section: '购买额外点数',
        credits_desc: '额外点数添加到您的月度套餐，永不过期。兼容所有套餐。',
        one_time: '一次性',
        per_credit: '¢/点数',
        buy: '购买',
        payment_note: '通过Shopify Billing安全处理付款。无支付数据存储在我们的服务器。',
        history_title: '点数购买历史',
        history_count: '{{n}} 笔购买',
        hist_invested: '总投资',
        hist_bought: '已购点数',
        hist_available: '仍可用',
        hist_empty: '尚未购买任何额外点数。',
        hist_date: '日期',
        hist_pkg: '套餐',
        hist_credits: '点数',
        hist_amount: '金额',
        hist_status: '状态',
        hist_completed: '已完成',
        hist_pending: '待处理',
        hist_declined: '已拒绝',
        trend_title: '使用趋势',
        trend_placeholder: '使用图表（通过Shopify Billing获取）',
        stats_products: '已分析产品',
        stats_content: '已生成内容',
        stats_translations: '翻译',
        stats_images: '已优化图片',
        toast_sub_pending: '订阅处理中 — 您将很快收到确认。',
        toast_sub_activated: '{{name}} 已激活！',
        toast_trial_suffix: '（{{n}}天免费试用）',
        toast_sub_error: '订阅验证错误',
        toast_purchase_duplicate: '购买已登记。',
        toast_credits_added: '+{{n}} 点数已添加到您的账户！',
        toast_purchase_error: '购买验证错误',
        toast_purchase_start_error: '启动购买时出错',
        toast_sub_start_error: '启动订阅时出错',
        toast_store_unavailable: '商店尚未连接。请在 Shopify 管理后台重新加载应用后重试。',
        toast_sub_cancelled: '订阅已取消。套餐已恢复为免费版。',
        toast_sub_cancel_error: '取消订阅错误',
        pkg_100_label: '100积分',
        pkg_100_desc: '适合偶尔使用',
        pkg_300_label: '300积分',
        pkg_300_desc: '节倗17%',
        pkg_300_badge: '⭐ 最受欢迎',
        pkg_700_label: '700积分',
        pkg_700_desc: '节倗29%',
        pkg_1500_label: '1,500积分',
        pkg_1500_desc: '节倗33%',
        pkg_1500_badge: '🔥 最佳性价比',
        plan_starter_badge: '⭐ 最受欢迎',
        plan_starter_benefit: '每月节省数小时工作时间。',
        plan_pro_badge: '🔥 SEO增长',
        plan_pro_benefit: '改善索引和SEO表现。',
        plan_elite_badge: '🚀 机构',
        plan_elite_benefit: '专为机构和企业目录设计。',
      },
      toast: {
        saved_at: '已于 {{time}} 保存',
        save_error: '保存错误',
        budget_exceeded: '每日点数已耗尽 — 已优化 {{total}} 个产品中的 {{done}} 个',
        autopilot_stopped: '自动驾驶已停止 — 已优化 {{total}} 个产品中的 {{done}} 个',
        images_optimized: '图片已优化 — {{n}} 个产品',
        images_failed: '{{n}} 张图片未能优化',
        autopilot_done: '自动驾驶完成 — {{started}} 个产品已入队',
        autopilot_empty: '没有低于阈值的条目',
        autopilot_stopping: '正在停止自动驾驶...',
        reindex_started: '重新索引已开始',
        resync_started: '重新同步已开始',
        cache_cleared: '缓存已清除',
        sync_reset: '同步状态已重置',
      },
      advanced: {
        warning: '以下操作会影响系统行为。仅在必要时使用。',
        sync_title: '同步',
        reindex: '重新索引产品',
        reindex_desc: '重新计算数据库中所有产品的SEO数据',
        resync: '与Shopify重新同步',
        resync_desc: '强制完整同步产品和系列',
        cache_title: '缓存',
        clear_cache: '清除应用缓存',
        clear_cache_desc: '删除浏览器中正在进行的批次。未完成的操作将丢失。',
        reset_credits: '重置每日点数',
        reset_credits_desc: '重置今日AI点数计数器（开发）。限制：5,000/天。',
        danger_zone: '危险区域',
        reset_sync: '重置同步状态',
        reset_sync_desc: '强制重置。仅在同步卡住超过30分钟时使用。',
      },
    },
    ai_engine: {
      preset: {
        growth_desc: '最大化转化率和参与度',
        luxury_desc: '高端品牌和独特叙事',
        seo_desc: '最大化谷歌自然搜索可见度',
        balanced_desc: '质量与SEO的最佳平衡',
      },
      tone: {
        professional: '专业',
        professional_desc: '正式、权威、建立信任',
        luxury: '奢华',
        luxury_desc: '优雅、独特、高端',
        technical: '技术性',
        technical_desc: '精确、规格、可量化数据',
        conversational: '对话式',
        conversational_desc: '直接、友好、吸引人',
      },
      frequency: {
        daily: '每日',
        daily_desc: '每天1次',
        hourly: '每小时',
        hourly_desc: '持续',
        realtime: '即时',
        realtime_desc: '尽快',
      },
      scope: {
        products: '产品',
        collections: '系列',
        articles: '文章',
        pages: '页面',
      },
      trigger: {
        seo_score: 'SEO得分低',
        missing_meta: '缺少元数据',
        missing_alt: '缺少ALT文本',
        outdated_desc: '描述过时',
        keywords: '缺少关键词',
        image_quality: '图片未优化',
      },
    },
    appearance: {
      title: '外观',
      theme_title: '主题',
      theme: {
        light: '浅色',
        dark: '深色',
        system: '系统',
      },
      density_title: '密度',
      density: {
        compact: '紧凑',
        comfortable: '舒适',
        spacious: '宽敞',
        compact_desc: '更多内容',
        comfortable_desc: '平衡',
        spacious_desc: '更多空间',
      },
      sidebar_title: '侧边栏',
      sidebar: {
        expanded: '展开',
        collapsed: '收起',
        hidden: '隐藏',
        expanded_desc: '始终可见',
        collapsed_desc: '仅图标',
        hidden_desc: '悬停时',
      },
    },
    localization: {
      ui_language: '界面语言',
      select_language: '选择应用语言',
      reload_note: '语言立即生效',
    },
    dashboard: {
      title: '概览',
      subtitle: '店铺活动摘要',
      products: '产品',
      optimized: '已优化',
      pending: '待处理',
      seo_score: 'SEO得分',
      audit_center: 'Audit Center',
      sync_products: '同步产品',
      analyze_products: '分析产品',
      audit_site: '站点审计 360',
      syncing: '同步中...',
      analyzing: '分析中...',
      auditing: '审计中...',
      section_account: '账户与套餐',
      section_catalog: '目录状态',
      section_images: '图片',
      section_seo_tech: '技术SEO — 详细站点审计',
      section_ux_trust: 'UX & Trust — 亮点',
      section_actions: 'AI推荐操作',
      recent_activity: '最近活动',
      hint_plan: '套餐与额度状态',
      hint_never_synced: '从未同步',
      hint_priority: '按优先级排序',
      hint_last_sync: '最近同步 {{date}}',
      current_plan: '当前套餐',
      credits_used: '已用额度',
      credits_remaining: '剩余额度',
      public_domain: '公开域名',
      credit_usage: '额度使用情况',
      hint_installed: '安装于 {{date}}',
      hint_pct_plan: '套餐的 {{pct}}%',
      hint_limit: '上限 {{n}}',
      hint_last_audit: '上次审计 {{date}}',
      hint_no_audit: '未执行审计',
      no_audit: '未执行审计',
      no_audit_desc: '运行审计以分析标题、meta、H1、canonical、robots、sitemap、HTTPS、OG、JSON-LD、性能、图片和链接。',
      run_audit: '运行审计',
      in_progress: '进行中...',
      audit_phase: '审计中 (阶段: {{phase}})...',
      ux_highlights: 'UX 亮点',
      trust_compliance: 'Trust & Compliance',
      mobile_viewport: '移动端视口:',
      favicon: 'Favicon:',
      images_without_alt_label: '无ALT图片:',
      lazy_loading: '延迟加载:',
      images_suffix: '张图片',
      internal_links: '内部链接:',
      data_unavailable: '数据不可用: {{reason}}',
      analysis_not_run: '分析未执行',
      not_detected: '未检测到',
      no_trust_data: '无信任数据',
      no_activity: '暂无最近活动。',
      activity_completed: '已完成',
      activity_error: '错误',
      no_store_title: '未连接店铺',
      no_store_desc: '在Shopify店铺安装应用以开始使用',
      connect_store: '连接Shopify店铺',
      no_token_title: 'OAuth令牌缺失',
      no_token_desc: '店铺 {{domain}} 已注册但无令牌，请重新安装应用。',
      reinstall_app: '通过OAuth重新安装',
      sync_in_progress: '产品同步中…',
      sync_in_progress_detail: '{{synced}} / {{total}} 个产品。同步完成后控制台数据将更新。',
      stale_data: '数据过期：同步进行中，显示上次有效数据。',
      catalog_score_label: '目录得分',
      seo_distribution: 'SEO分布',
      n_products: '{{n}} 个产品',
      pct_of_catalog: '目录的 {{pct}}%',
      no_description: '无描述',
      no_meta_description: '无meta描述',
      seo_needs_improvement: 'SEO待改善',
      view: '查看',
      seo_good_desc: '目录SEO覆盖率良好。持续优化新产品以保持高标准。',
      seo_medium_desc: '目录SEO覆盖率中等。优先处理：meta描述和产品描述。',
      seo_poor_desc: '目录SEO覆盖率较低。优先处理：meta描述、产品描述和缺失图片。',
      seo_optimized: '已优化',
      seo_medium: '中等',
      seo_poor: '待改善',
      content_seo_title: '按内容类型的SEO状态',
      open_catalog: '打开目录',
      row_collections: '系列',
      row_articles: '文章',
      row_pages: '页面',
      coming_soon: '即将推出',
      not_synced: '未同步',
      seo_coverage_fmt: '{{opt}}/{{total}} 已优化 · {{score}}/100',
      alt_coverage: 'ALT文本覆盖率',
      with_alt_count: '{{total}} 中 {{n}} 有ALT',
      image_optimization_label: '图片优化',
      optimized_count: '{{total}} 中 {{n}} 已优化',
      with_alt: '有ALT',
      without_alt: '无ALT',
      image_optimized: '已优化',
      image_needs_improvement: '待改善',
      no_image: '无图片',
      savings: '节省',
      optimize_images_btn: '优化图片',
      view_no_image: '查看无图片产品',
      alt_manager: 'ALT Text Manager',
      toast_sync_done: '同步完成。正在对账目录...',
      toast_catalog_reconciled: '目录已对账: {{n}} 个产品 (已删除 {{removed}} 个孤立项)',
      toast_sync_first: '请先同步产品',
      toast_avg_score: '平均得分 {{score}}/100',
      toast_audit_done: '审计完成: {{score}}/100',
      toast_sync_reset: '同步状态已重置',
      toast_sync_reset_error: '无法重置同步状态',
      op_description: 'AI描述',
      op_seo_title: 'SEO标题',
      op_meta_description: 'Meta描述',
      op_keywords: '关键词',
      op_translation: '翻译',
      op_image_opt: '图片优化',
      op_sync: 'Shopify同步',
      op_seo_analysis: '店铺SEO分析',
      op_site_audit: '站点审计 360',
      prompt_domain: '请输入您的Shopify商店域名',
      hint_force_reset: '强制重置同步状态（不删除产品）',
    },
    products: {
      title: '产品目录',
      search: '搜索产品...',
      all: '全部',
      optimized: '已优化',
      pending: '待处理',
      status_generating: '生成中',
      status_writing: '写入中',
      status_validating: '验证中',
      status_failed: '失败',
      status_sync_failed: 'Shopify Sync',
      status_optimized: '已优化',
      status_medium: '中等',
      status_needs_improvement: '需改进',
      type_collection_singular: 'collection',
      type_collection_plural: 'collections',
      sync_collections: 'Sync Collections',
      empty_collections: 'No collections. Click "Sync Collections" to import from Shopify.',
      search_collections: 'Search collection by title or handle...',
      col_label_products: '产品',
      type_article_singular: 'article',
      type_article_plural: 'articles',
      sync_articles: 'Sync Articles',
      empty_articles: 'No articles. Click "Sync Articles" to import from Shopify.',
      search_articles: 'Search article by title, handle or blog...',
      col_label_blog: 'Blog',
      type_page_singular: 'page',
      type_page_plural: 'pages',
      sync_pages: 'Sync Pages',
      empty_pages: 'No pages. Click "Sync Pages" to import from Shopify.',
      search_pages: 'Search page by title or handle...',
      col_label_author: 'Author',
      catalog_title: '目录',
      no_store: '无商店',
      tab_products: '产品',
      tab_collections: '系列',
      tab_articles: '文章',
      tab_pages: '页面',
      sort_updated: 'Updated',
      sort_seo_score: 'SEO Score',
      sort_title: 'Title',
      sort_vendor: 'Vendor',
      sort_created: 'Created',
      sort_desc: 'Descending',
      sort_asc: 'Ascending',
      filter_seo_all: 'SEO: all',
      filter_optimized: 'Optimized',
      filter_medium: 'Medium',
      filter_needs_improvement: 'Needs improvement',
      filter_image_all: 'Images: all',
      filter_image_yes: 'With images',
      filter_image_no: 'Without images',
      filter_meta_all: 'Meta: all',
      filter_meta_yes: 'With meta',
      filter_meta_no: 'Without meta',
      filter_desc_all: 'Description: all',
      filter_desc_yes: 'With description',
      filter_desc_no: 'Without description',
      filter_vendor_all: 'Vendor: all',
      filter_collection_all: 'Collection: all',
      filter_type_all: 'Type: all',
      reset_filters: 'Reset filters',
      th_image: 'Image',
      th_title: 'Title',
      th_seo_score: 'SEO Score',
      th_alt: 'ALT',
      th_meta: 'Meta',
      th_status: '状态',
      th_actions: 'Actions',
      no_products_filters: 'No products found with these filters',
      no_products: 'No products. Sync from your Shopify store.',
      pagination: 'Page {{page}} of {{total}} · {{count}} products',
      batch_btn: 'Batch Operations',
      dialog_status: '状态',
      dialog_seo_score: 'SEO Score',
      dialog_shopify_id: 'Shopify ID',
      dialog_vendor: 'Vendor',
      dialog_serp: 'SERP Preview',
      dialog_issues: 'SEO Issues',
      dialog_suggestions: 'Suggestions',
      generating: '生成中...',
      generate_all: '生成所有内容',
      action_generate_ai: 'Generate AI Content',
      action_translate: 'Translate',
      action_optimize_image: 'Optimize Image',
      syncing: '同步中...',
      draft_ready: '草稿已就绪',
      seo_ai_btn: 'SEO AI',
      batch_ops_btn: 'Batch Operations',
      diagnosis: 'Diagnostics',
      current_score: 'Current score',
      projected: '→ projected {{score}}/100',
      meta_title: 'Meta Title',
      meta_desc_label: 'Meta Description',
      description_label: 'Description',
      generate_desc_btn: 'Generate AI description',
      generating_desc: 'Generating...',
      generate_ai_btn: 'Generate with AI',
      publish_shopify_btn: '发布到Shopify',
      publishing: '发布中...',
      discard_draft_btn: 'Discard draft',
      seo_ai_dialog_title: 'SEO AI',
      seo_all: 'SEO: all',
      seo_optimized: 'Optimized',
      seo_medium: 'Medium',
      seo_needs: '需要改进',
      page_of: '第 {{page}} 页 / 共 {{total}} 页',
      search_placeholder: '按标题、SKU、EAN、供应商、句柄搜索...',
      chars_count: '{{n}}/{{max}} 字符',
      n_selected_info: '已选中',
      filtered: '已过滤',
      soon_tooltip: '即将推出',
      resource_subtitle: '{{type}} Shopify 及其SEO状态',
      articles_blog: '文章（博客）',
      select_visible_title: '全选/取消全选可见项目',
      toast_draft_ready: '已生成SEO草稿。请查看并发布。',
      toast_error_ai: 'AI生成错误',
      toast_desc_generated: '已生成AI描述。',
      toast_error_desc: '描述生成错误',
      toast_empty_draft: '请生成或输入至少一个字段',
      toast_published_score: '已发布到Shopify · 分数 {{score}}/100',
      toast_error_publish: '发布到Shopify时出错',
      toast_draft_discarded: '草稿已丢弃',
      toast_select_items: '请至少选择一个项目',
      toast_mode_publish: '发布',
      toast_mode_both: '生成+发布',
      toast_mode_generate: 'AI SEO生成',
      toast_batch_launched: '{{label}}已在{{count}}个{{type}}上启动。',
      toast_batch_errors: '{{label}}完成，有{{count}}个错误',
      toast_batch_done: '{{label}}在{{count}}个{{type}}上完成',
      toast_synced: '{{type}}已同步: {{count}}',
      toast_sync_error: '{{type}}同步错误',
      toast_token_error: 'Shopify令牌已过期或无权限',
      reinstall_label: '重新安装',
      toast_sync_started: '{{type}}同步已启动',
      toast_error_sync_start: '启动同步时出错',
      toast_perms_ok: '权限正常 ({{kind}})',
      toast_token_revoked: '令牌已撤销',
      toast_perms_missing: '权限缺失',
      toast_diag_error: '诊断错误',
      toast_score: '分数 {{score}}/100',
      toast_error_analyze: '分析错误',
      toast_generated: '内容已生成',
      toast_error_generate: '生成错误',
    },
    content: {
      title: '内容生成',
      generate: '生成内容',
      language: '语言',
      tone: '语气',
      subtitle: 'Generate descriptions, SEO title, meta description and keywords with AI',
      tab_products: '产品',
      tab_collections: '系列',
      tab_articles: '文章',
      tab_pages: '页面',
      type_description_label: 'Description',
      type_description_hint: 'Engaging and SEO-friendly product text',
      type_seo_title_label: 'SEO Title',
      type_seo_title_hint: 'SERP-optimized title (max 60 chars)',
      type_meta_desc_label: 'Meta Description',
      type_meta_desc_hint: 'Google snippet (max 160 chars)',
      type_keywords_label: 'Keywords',
      type_keywords_hint: 'Primary and secondary keywords',
      type_body_label: 'Description / Body',
      type_body_hint: 'Main resource text',
      filter_all: '全部',
      filter_needs: 'Needs improvement',
      filter_medium: 'Medium',
      filter_optimized: 'Optimized',
      no_results_filters: 'No items match the filters',
      select_all: 'Select all',
      deselect: 'Deselect',
      selected_count: '{{count}} selected',
      selected_max: '(max)',
      deselect_all: 'Deselect all',
      pagination_of: '{{page}} / {{total}}',
      total_count: '({{count}} total)',
      content_type_section: 'Content Type',
      batch_generating: 'Generating… {{done}}/{{total}}',
      batch_generate_btn: 'Generate Batch ({{count}})',
      generating_count: 'Generate ({{count}})',
      generate_btn: 'Generate',
      generating: '生成中...',
      generate_all_btn: 'All',
      hint_select: '← Select an item or tick multiple items for batch',
      hint_batch_ready: '{{count}} item(s) ready for batch',
      batch_done_title: '✓ Batch completed',
      batch_pending_title: 'Batch pending…',
      batch_in_progress_title: 'Batch Generation in progress…',
      batch_done_msg: 'All content generated. Selection will be cleared automatically.',
      results_section: 'Results',
      publishing: '发布中...',
      published: 'Published',
      publish_btn: '发布到Shopify',
      clear_results: 'Clear',
      chars_unit: 'chars',
      cache_label: 'cache',
      preview_section: 'Current preview',
      loading_detail: 'Loading detail…',
      not_present: 'Not present',
      not_present_plural: 'Not present',
      empty_state: 'Click an item to view it, or tick multiple items and use Generate Batch',
      copy_btn: 'Copy',
      type_seo_title_hint_content: 'SERP元标题（最多60个字符）',
      no_items: '未找到{{type}}',
      item_deselect: '取消选择',
      item_select: '添加到选择',
      generate_all_title: '生成所有可用类型',
      prev_item: '上一个项目',
      next_item: '下一个项目',
      toast_load_error: '加载项目时出错',
      toast_batch_done: '批处理完成：{{done}}/{{total}}个产品',
      toast_batch_failed: '批处理失败：{{total}}中有{{failed}}个错误',
      toast_batch_cancelled: '批处理已取消',
      toast_batch_resumed: '活动批处理已恢复…',
      toast_max_select: '最多可选择{{max}}个项目',
      toast_select_item: '从列表中选择一个项目',
      toast_select_type: '请至少选择一种内容类型',
      toast_from_cache: '来自缓存的内容！',
      toast_generated: '生成成功！',
      toast_generate_error: '生成内容时出错',
      toast_batch_running: '批处理进程已在运行',
      toast_no_store: '商店不可用',
      toast_batch_started: '批处理已启动：{{n}}个产品已加入队列',
      toast_batch_start_error: '启动批处理时出错',
      toast_batch_item_error: '生成错误：{{title}}',
      toast_batch_complete: '批处理完成：{{done}}/{{total}}个项目',
      toast_cancel_error: '取消批处理时出错',
      toast_published: '内容已发布到Shopify！',
      toast_publish_error: '发布内容时出错',
      toast_copied: '已复制到剪贴板',
      present: '存在',
      missing: '缺失',
      lang_it: '意大利语',
      lang_en: '英语',
      lang_fr: '法语',
      lang_de: '德语',
      lang_es: '西班牙语',
      lang_pt: '葡萄牙语',
      tone_professional: '专业',
      tone_luxury: '奢华',
      tone_technical: '技术性',
      tone_conversational: '口语化',
    },
    images: {
      title: '图片优化',
      optimize: '优化',
      format: '格式',
      compress: '压缩',
      quality: '质量',
      alt_mode_label: 'ALT生成模式',
      alt_mode_ai: 'AI智能',
      alt_mode_template: '免费模板',
      alt_mode_auto: '自动回退',
      subtitle: 'Optimize images, manage ALT text and publish to Shopify.',
      tab_optimize: 'Optimize Images',
      tab_alt: 'ALT Text',
      alt_coverage: 'ALT Coverage',
      with_alt_count: 'with ALT out of',
      sync_alt_btn: 'Update ALT data from Shopify',
      syncing_alt: 'Updating ALT...',
      sync_status_label: 'Status:',
      analyzed_label: 'Analyzed:',
      last_updated_label: 'Last update:',
      stalled: 'stalled',
      force_stop: 'Force stop (stalled for 60s)',
      free_badge: '● Free — no credits',
      configure_btn: '▼ Configure',
      hide_btn: '▲ Hide',
      template_free_hint: 'Free mode active — zero AI credits. Template:',
      template_auto_hint: 'Auto fallback — AI if credits available, local template if exhausted.',
      template_config_title: 'Configure ALT Template',
      template_label: 'Custom template',
      template_preview: 'Preview:',
      variables_label: 'Available variables — click to insert:',
      restore_default: 'Restore default',
      save_config: 'Save configuration',
      saving: 'Saving...',
      search_placeholder: 'Search by title, vendor, handle...',
      filter_all_images: 'All',
      filter_with_alt: 'With ALT',
      filter_without_alt: 'Without ALT',
      selected_images: '{{count}} images selected (max 50 per batch)',
      generate_batch_btn: 'Generate ALT for selected',
      batch_alt_in_progress: 'ALT Batch in progress: {{done}} / {{total}}',
      batch_errors: '{{n}} 个错误',
      select_all_label: 'Select all',
      deselect_all_label: 'Deselect all',
      total_products_label: '{{count}} products',
      timeout_title: 'Loading took too long (20s)',
      timeout_desc: 'The database is processing many products. Try again in a few seconds.',
      error_title: 'List loading error',
      no_products_filter: 'No products matching the filters',
      alt_placeholder: 'ALT text (max 125 characters)',
      status_published: 'Published',
      status_saved: 'Saved',
      status_draft_alt: 'Draft',
      status_missing: 'No ALT',
      generate_alt_btn: 'Generate ALT',
      save_alt_btn: 'Save ALT',
      publish_alt_btn: 'Publish',
      prec: 'Prev',
      succ: 'Next',
      select_products: 'Select Products',
      filter_collection_all: 'Collection: all',
      filter_vendor_all: 'Vendor: all',
      filter_kb_all: 'KB: all',
      filter_kb_100: 'Files over 100 KB',
      filter_kb_500: 'Files over 500 KB',
      filter_kb_1mb: 'Files over 1 MB',
      filter_format_all: 'Format: all',
      filter_landscape: 'Width greater than Height',
      filter_portrait: 'Height greater than Width',
      filter_square: 'Square',
      filter_status_all: 'Status: all',
      filter_status_optimized: 'Already optimized',
      filter_status_needs: 'To optimize',
      visible_total: '{{visible}} visible · {{total}} total',
      reset_filters: 'Reset filters',
      clear_selection: 'Clear selection',
      no_image_products: 'No products with image',
      ready_badge: 'Ready',
      settings_title: 'Settings',
      format_title: 'Image Format',
      format_square: 'Square 1:1',
      format_landscape: 'Landscape 4:3',
      format_portrait: 'Portrait 3:4',
      format_none: 'No resize',
      format_none_sub: 'Original dimensions',
      compress_label: 'Compression',
      compress_desc: 'Reduce file size',
      quality_label: 'Quality',
      batch_opt_running: 'Optimization in progress',
      batch_opt_cancelled: 'Optimization cancelled',
      batch_opt_completed: 'Optimization completed',
      batch_apply_running: 'Application in progress',
      batch_apply_cancelled: 'Application cancelled',
      batch_apply_completed: 'Application completed',
      background_note: 'You can change section, continues in background',
      optimizing: 'Optimizing...',
      optimize_n: 'Optimize {{count}} images',
      optimize_one: 'Optimize Image',
      applying: 'Applying...',
      apply_n: 'Apply {{count}} to Shopify',
      apply_one: 'Apply to Shopify',
      preview_title: 'Preview',
      ready_optimizations: '{{count}} optimizations ready',
      select_preview_hint: 'Select one or more products to see the preview',
      first_product_preview: 'Preview shown for the first selected product:',
      original_label: 'Original',
      optimized_label: 'Optimized',
      optimize_click_hint: 'Click "Optimize" for the result',
      reduction_label: 'Reduction',
      apply_btn: 'Apply',
      history_opt_title: 'Optimization history',
      history_opt_subtitle: 'Operations applied to Shopify, errors and restores.',
      stat_running_label: 'Running',
      stat_completed_label: 'Completed',
      stat_errors_label: 'Incomplete',
      stat_undo_label: 'Undo',
      total_savings: 'Total savings',
      no_history: 'No operations applied yet.',
      restoring: 'Restoring...',
      undo_btn: 'Undo',
      kb_warning: 'KB size is not in local data. To make it accurate it needs to be saved by the backend during image sync.',
      senza_vendor: 'No vendor',
      alt_stat_coverage: '{{total}}个产品中{{n}}个有ALT',
      apply_batch_cancelled: '应用已取消',
      apply_batch_done_label: '应用已完成',
      apply_batch_running: '应用中',
      apply_n_btn: '将{{n}}个应用到Shopify',
      applying_btn: '应用中...',
      auto_fallback_hint: '自动回退 — 如有积分则使用AI，积分耗尽则使用本地模板。',
      background_hint: '您可以切换部分，在后台继续',
      badge_draft: '草稿',
      badge_missing: '无ALT',
      badge_published: '已发布',
      badge_ready: '就绪',
      badge_saved: '已保存',
      batch_close: '关闭',
      batch_generate_btn: '为所选项目生成ALT',
      batch_progress: 'ALT批处理中: {{done}} / {{total}}',
      batch_selected: '已选{{n}}张图片（每批最多50张）',
      collection_all: '系列: 全部',
      compress_sub: '减小文件大小',
      config_btn: '▼ 配置',
      deselect_all: '取消全选',
      empty_filtered: '没有符合筛选条件的产品',
      filter_all: '全部',
      format_label: '图片格式',
      gen_alt_btn: '生成ALT',
      history_completed: '已完成',
      history_empty: '尚未应用任何操作。',
      history_incomplete: '未完成',
      history_loading: '加载历史记录...',
      history_running: '进行中',
      history_savings: '总节省量',
      history_subtitle: '已应用到Shopify的操作、错误和恢复。',
      history_title: '优化历史',
      history_undo_label: '撤销',
      last_update_label: '最后更新:',
      load_error: '加载列表错误',
      n_errors: '{{n}}个错误',
      n_products: '{{n}}个产品',
      n_selected: '已选{{n}}个',
      next_page: '下一页',
      no_products: '没有带图片的产品',
      no_vendor: '无vendor',
      opt_batch_cancelled: '优化已取消',
      opt_batch_done: '优化已完成',
      opt_batch_running: '优化中',
      optimize_n_btn: '优化{{n}}张图片',
      optimize_one_btn: '优化图片',
      optimizing_btn: '优化中...',
      orientation_all: '格式: 全部',
      orientation_landscape: '宽度大于高度',
      orientation_portrait: '高度大于宽度',
      orientation_square: '正方形',
      page_info: '第{{page}}页/共{{total}}页',
      pagination: '第{{page}}页/共{{total}}页',
      prev: '上一页',
      publish_btn: '发布',
      retry: '重试',
      select_all: '全选',
      size_100kb: '超过100 KB的文件',
      size_1mb: '超过1 MB的文件',
      size_500kb: '超过500 KB的文件',
      size_all: 'KB: 全部',
      stat_no_image: '无图片: {{count}}',
      stat_with_alt: '有ALT: {{count}}',
      stat_without_alt: '无ALT: {{count}}',
      status_all: '状态: 全部',
      status_label: '状态:',
      status_needs: '待优化',
      status_optimized: '已优化',
      status_stalled: '卡住',
      sync_btn: '从 Shopify 更新ALT数据',
      sync_btn_title: '从 Shopify 重新读取实际图片和ALT文本',
      syncing: '更新ALT中...',
      template_active: '免费模式已激活 — 零AI积分。模板:',
      template_custom_label: '自定义模板',
      template_free_badge: '● 免费 — 无需积分',
      template_preview_label: '预览:',
      template_reset: '恢复默认',
      template_save: '保存配置',
      template_saving: '保存中...',
      template_vars_label: '可用变量 — 点击插入:',
      timeout_msg: '数据库正在处理大量产品。请几秒后再试。',
      toast_alt_ai: '通过AI生成了ALT',
      toast_alt_cancelled: 'ALT更新已取消 — 您可以重新启动',
      toast_alt_empty: 'ALT为空',
      toast_alt_from_cache: '来自缓存的ALT',
      toast_alt_gen_error: 'ALT生成错误',
      toast_alt_publish_error: '发布错误',
      toast_alt_published: '已发布到Shopify',
      toast_alt_save_error: '保存错误',
      toast_alt_saved: 'ALT已保存',
      toast_alt_sync_start_error: '启动ALT更新时出错',
      toast_alt_sync_started: 'ALT数据更新已开始',
      toast_alt_template: '通过模板生成了ALT（免费）',
      toast_alt_template_fallback: '通过模板的ALT（积分耗尽）',
      toast_alt_update_error: 'ALT更新错误',
      toast_alt_updated: 'ALT数据已更新: 分析了{{n}}个产品',
      toast_applied: '图片已应用到Shopify',
      toast_apply_batch_done: '已将{{n}}张图片应用到Shopify',
      toast_apply_batch_errors: '应用完成，有{{n}}个错误',
      toast_apply_batch_started: '应用已开始: {{n}}张图片。您可以切换部分。',
      toast_batch_alt_done: '批处理已完成',
      toast_batch_alt_started: '批处理已开始: {{n}}张图片，每次{{c}}张',
      toast_batch_done: '批处理已完成: {{n}}张图片已优化。您可以将其应用到Shopify。',
      toast_batch_errors: '{{n}}张图片未处理。请重试或查看日志。',
      toast_batch_started: '批处理已开始: {{n}}张图片。您可以切换部分，在后台继续。',
      toast_cancel_error: '取消错误',
      toast_no_draft: '没有已优化的图片可供应用',
      toast_no_images: '未选择任何图片',
      toast_no_ready: '没有就绪的优化可供应用',
      toast_no_store: '店铺不可用',
      toast_optimize_error: '优化错误',
      toast_optimized: '图片已优化。您现在可以将其应用到Shopify。',
      toast_select_product: '请至少选择一个产品',
      toast_template_save_error: '保存模板时出错',
      toast_template_saved: '模板配置已保存',
      toast_undo_done: '原始图片已恢复',
      toast_undo_error: '恢复时出错',
      undoing_btn: '恢复中...',
      vendor_all: 'Vendor: 全部',
      toast_no_product: '请选择一个产品',
      toast_no_image: '该产品没有图片',
      toast_no_preview: '请先优化一张图片',
      toast_apply_error: '应用到Shopify时出错',
      n_ready: '{{n}}个优化已就绪',
      preview_hint: '选择一个或多个产品以查看预览',
      preview_first: '显示第一个选定产品的预览:',
      click_optimize_hint: '点击"优化"查看结果',
      apply_single_btn: '应用',
    },
    alt_template: {
      section_title: 'ALT模板',
      mode_label: 'ALT文本生成模式',
      textarea_label: '自定义模板',
      preview_label: '预览',
      vars_label: '可用变量 — 点击插入',
      hint_template: '免费模式：ALT文本不消耗AI积分。',
      hint_auto: '自动回退：有积分时用AI，否则用本地模板。',
    },
    batch: {
      title: '批量操作',
      start: '开始',
      cancel: '取消',
      subtitle: 'Persistent server-side processing — continues even if you change page or close the tab',
      locked_title: 'Batch Operations not available',
      locked_desc: 'Batch Operations are available from the Starter plan. Process hundreds of products in parallel with one click.',
      upgrade_btn: 'Upgrade to Starter',
      op_content_label: 'Generate AI Content',
      op_content_desc: 'Description, SEO title, meta description, keywords',
      op_translate_label: 'Translate Products',
      op_translate_desc: 'Full translation into selected language',
      op_images_label: 'Optimize Images',
      op_images_desc: '1:1 resize and image compression',
      field_description_label: 'Description',
      field_description_hint: '150-250 words',
      field_seo_title_label: 'SEO Title',
      field_seo_title_hint: 'max 60 characters',
      field_meta_desc_label: 'Meta Description',
      field_meta_desc_hint: '100-160 characters',
      field_keywords_label: 'Keywords',
      field_keywords_hint: '5-10 keywords',
      count_all: '全部',
      status_pending: 'Queued',
      status_running: 'Running',
      status_completed: 'Completed',
      status_failed_job: 'Failed',
      status_cancelled: 'Cancelled',
      opt_in_progress: 'Image optimization in progress…',
      batch_in_progress: 'AI Batch in progress…',
      images_progress: '{{done}} / {{total}} images',
      products_progress: '{{done}} / {{total}} products',
      errors_count: '{{count}} errors',
      duration_label: 'Duration: {{time}}',
      starting: 'Starting...',
      seo_gen_in_progress: 'Generate + Publish SEO in progress',
      gen_publish_auto: 'Automatic generation and publishing to Shopify',
      section_operation: 'Operation',
      section_fields: 'Fields to generate',
      fields_selected: '{{count}}/{{total}} selected',
      fields_warning: 'Select at least one field to start the batch',
      fields_hint: 'One AI call per product generates all selected fields — lower latency and reduced costs.',
      section_options: 'Options',
      label_language: '语言',
      label_tone: '语气',
      tone_professional: 'Professional',
      tone_luxury: 'Luxury',
      tone_technical: 'Technical',
      tone_conversational: 'Conversational',
      label_target_lang: 'Target Language',
      images_note: '1:1 resize (800×800) + 85% quality compression.',
      section_quantity: 'Product Quantity',
      available_count: '{{count}} available',
      catalog_selection: '{{count}} product(s) selected from Catalog',
      remove_selection: 'Remove selection',
      products_selected_count: '{{count}} product(s) selected',
      processing: 'Processing…',
      start_btn: 'Start Processing',
      history_title: 'Batch History',
      history_subtitle: 'updated from DB',
      stat_running: 'Running',
      stat_completed: 'Completed',
      stat_products_ok: 'Products OK',
      no_batch: 'No batch executed',
      no_batch_hint: 'Jobs will appear here after the first processing',
      job_content: 'Generate AI Content',
      job_translate: 'Translation',
      job_images: 'Image Optimization',
      job_products: '{{done}}/{{total}} products',
      log_lang: 'Language:',
      log_tone: 'Tone:',
      toast_completed: '批处理完成: {{done}}/{{total}} 个产品已处理',
      toast_failed: '批处理失败: {{count}} 个错误',
      toast_no_products: '没有可用的产品',
      soon_lbl: '即将推出',
      btn_analyze_seo: '分析SEO',
      btn_view: '查看',
      toast_no_fields: '请选择至少一个要生成的字段',
      toast_images_started: '图片优化已启动: {{count}} 个产品',
      toast_started: '批处理已启动: {{count}} 个产品',
      toast_start_error: '启动错误',
      toast_cancelled: '批处理已取消',
      toast_cancel_error: '取消错误',
      fields_label: '字段',
      log_summary: '单次操作日志',
    },
    history: {
      title: '历史记录',
      empty: '未找到操作记录',
      subtitle: '所有AI执行的完整审计 — 共 {{n}} 次操作',
      refresh_btn: '刷新',
      total_operations: '总操作数',
      success_rate: '成功率',
      n_successes: '{{n}} 次成功',
      credits_today: '今日额度',
      products_today: '今日产品',
      avg_duration: '平均时长',
      last_autopilot: '最近自动驾驶',
      filters: '筛选',
      filters_active: '已启用',
      reset_all: '重置全部',
      search_placeholder: '搜索产品...',
      op_all: '所有类型',
      op_description: 'AI描述',
      op_seo_title: 'SEO标题 AI',
      op_meta_description: 'Meta描述 AI',
      op_batch: '批量生成',
      op_translation: '翻译',
      op_image: '图片',
      op_sync: 'Shopify同步',
      trigger_all: '所有触发器',
      status_all: '所有状态',
      status_success: '成功',
      status_partial: '部分',
      status_error: '错误',
      th_status: '状态',
      th_type: '操作类型',
      th_product: '产品',
      th_trigger: '触发器',
      th_seo_delta: 'SEO Delta',
      th_credits: '额度',
      th_duration: '时长',
      th_timestamp: '时间戳',
      loading: '加载中...',
      remove_filters: '移除筛选',
      load_more: '加载更多 (已显示 {{shown}} / {{total}})',
      details_title: '执行详情',
      detail_op_id: '操作ID',
      detail_product_id: '产品ID',
      detail_store_id: '店铺ID',
      detail_type: '类型',
      detail_trigger: '触发器',
      detail_status: '状态',
      detail_language: '语言',
      detail_tone: '语气',
      detail_tokens: '已用Token',
      detail_fields: '字段',
      detail_credits: '额度',
      detail_duration: '时长',
      detail_seo_before: 'SEO (前)',
      detail_seo_after: 'SEO (后)',
      detail_timestamp: '时间戳',
      error_prefix: '错误: ',
      label_description: 'AI描述',
      label_seo_title: 'SEO标题 AI',
      label_meta_description: 'Meta描述 AI',
      label_keywords: '关键词 AI',
      label_batch: '批量生成',
      label_translation: '翻译',
      label_image: '图片优化',
      label_sync: 'Shopify同步',
      label_push: 'Shopify发布',
    },
    batch_banner: {
      errors: '错误',
      optimizing: '图片优化',
      optimizing_cancelled: '优化已取消',
      optimizing_completed: '优化已完成',
      applying: '正在应用到Shopify',
      applying_cancelled: '应用已取消',
      applying_completed: '应用已完成',
      open_images: '打开图片',
      open_catalog: '打开目录',
      type_collections: '系列',
      type_articles: '文章',
      type_pages: '页面',
      type_contents: '内容',
      mode_publish: '发布',
      mode_both: '生成+发布',
      mode_generate: 'AI SEO生成',
      state_cancelled: '(已取消)',
      state_completed: '(已完成)',
    },
    app_banner: {
      expired: 'Shopify令牌已过期或被撤销。',
      reconnect_desc: '重新连接应用程序以恢复同步和发布。',
      detected_in: '检测于',
      reconnect_btn: '立即重新连接',
    },
    review_popup: {
      greeting: '你好！我在这里 👋',
      subtitle: '希望您使用AI Optimizer一切顺利！',
      rating_title: '您喜欢这个应用吗？',
      rating_desc: '您的意见帮助我们改进并接触其他Shopify商家。',
      rating_tap: '点击星星进行评分',
      star: {
        terrible: '糟糕',
        bad: '不好',
        average: '一般',
        good: '好！',
        excellent: '优秀！ 🚀',
      },
      positive_title: '太棒了！非常感谢 🎉',
      positive_desc: '只需1分钟！',
      negative_title: '感谢您的反馈 🙏',
      negative_desc: '您有关于我们可以改进的地方的想法吗？',
      review_btn: '⭐ 留下评价',
      close_btn: '关闭',
      dismiss: '不再显示',
      skip: '跳过 →',
    },
    support: {
      title: '支持',
      send: '发送',
      placeholder: '请输入您的消息...',
    },
    editor: {
      placeholder: '在此输入...',
      bold: '粗体',
      italic: '斜体',
      underline: '下划线',
      h2: '标题 H2',
      h3: '标题 H3',
      paragraph: '段落',
      ul: '无序列表',
      ol: '有序列表',
      blockquote: '引用',
      link: '插入链接',
      remove_format: '删除格式',
      link_prompt: '链接 URL',
    },
    recommendations: {
      empty: '目前没有关键操作。做得很好！',
      filter_all_prio: '所有优先级',
      filter_all_cat: '所有类别',
      count_shown: '显示 {{n}} 个操作',
      see: '查看',
      sev_high: '高',
      sev_medium: '中',
      sev_low: '低',
      cat_catalog: '目录',
      missing_meta_description: '{{count}}个产品缺少元描述',
      missing_description: '{{count}}个产品缺少描述',
      missing_alt_text: '{{count}}张图片缺少ALT文字',
      missing_product_image: '{{count}}个产品缺少图片',
    },
    audit: {
      not_detected: '未检测到',
      disabled: '已禁用',
      not_scanned: '未执行分析',
      status_warning: '警告',
      status_error: '错误',
      cat_performance: '性能',
      cat_trust: '信任',
      cat_catalog: '目录',
      checks_suffix: '检查',
      badge_err: '错误',
      badge_warn: '警告',
      badge_ok: '正常',
      value_label: '值',
      checks: {
        title: { name: '标题', hint: '页面标题' },
        meta_description: { name: '元描述', hint: '首页元描述' },
        h1: { name: 'H1', hint: '每页恰好1个H1是最优的' },
        h2: { name: 'H2', hint: '建议至少有一个H2' },
        canonical: { name: 'Canonical', hint: '规范URL' },
        lang: { name: '语言', hint: '语言属性' },
        json_ld_structured_data: { name: 'JSON-LD / 结构化数据', hint: '结构化数据' },
        open_graph: { name: 'Open Graph', hint: '社交媒体元标签' },
        twitter_card: { name: 'Twitter Card', hint: '推特/X元标签' },
        robots_txt: { name: 'robots.txt', hint: 'Robots' },
        sitemap_xml: { name: 'Sitemap.xml', hint: '网站地图' },
        status_code: { name: '状态码', hint: 'HTTP状态码' },
        indexability: { name: '可索引性', hint: '可索引性' },
        redirects: { name: '重定向', hint: '最终URL' },
        https: { name: 'HTTPS', hint: 'HTTPS' },
        load_time: { name: '加载时间', hint: '服务器间测量' },
        page_weight: { name: '页面大小', hint: '首页HTML大小' },
        image_lazy_loading: { name: '图片懒加载', hint: '懒加载图片' },
        mobile_viewport: { name: '移动端视口', hint: '移动端视口' },
        favicon: { name: 'Favicon', hint: 'Favicon' },
        images_with_alt: { name: '带ALT的图片', hint: '图片可访问性' },
        privacy_policy: { name: '隐私政策', hint: '隐私' },
        cookie_policy: { name: 'Cookie政策', hint: 'Cookie' },
        terms_conditions: { name: '条款和条件', hint: '条款' },
        contact_page: { name: '联系页面', hint: '联系' },
        shipping_policy: { name: '运输政策', hint: '运输' },
        returns_refunds: { name: '退货与退款', hint: '退货' },
        social_links: { name: '社交链接', hint: '社交' },
        products_without_description: { name: '无描述产品', hint: '产品描述' },
        products_without_images: { name: '无图片产品', hint: '产品图片' },
        products_without_meta_description: { name: '无元描述产品', hint: '产品元描述' },
        duplicate_titles: { name: '重复标题', hint: '产品标题' },
        duplicate_meta_descriptions: { name: '重复元描述', hint: '产品元描述' },
        thin_content_200_char: { name: '内容稀薄 (<200字符)', hint: '产品内容' },
      },
    },
    score_card: {
      pillar_technical_seo: '技术SEO',
      pillar_ux: 'UX',
      pillar_performance: '性能',
      pillar_trust: '信任',
      pillar_catalog: '目录',
      label_excellent: '优秀',
      label_good: '可改善',
      label_critical: '关键',
      no_audit_desc: '审核尚未运行 — 运行审核以获取技术SEO、UX、信任和性能数据。',
      auditing: '审核中...',
      run_audit: '运行网站审核 360°',
      calculated_on: '计算于',
    },
    upgrade: {
      popular: '⭐ 最受欢迎',
      period: '/月',
      plan_header: '套餐',
      cta: '升级到 {{name}} — {{price}}{{period}}',
      dismiss: '暂不',
      feature_available: '{{feature}} 从 {{plan}} 套餐起可用。',
      reason_credits_title: 'AI积分已用完',
      reason_credits_body: '您已达到套餐的每月限额。升级以继续生成内容。',
      reason_products_title: '目录限制已达到',
      reason_products_body: '您的Shopify目录超出了当前套餐限制。升级以同步所有产品。',
      reason_feature_title: '高级功能',
      reason_feature_body: '此功能在更高套餐中可用。',
    },
    gsc: {
      connect_title: '连接 Google Search Console',
      connect_desc: '监控展示次数、点击量、点击率和平均排名。在AI优化后请求重新索引。',
      connect_feat_analytics: '搜索分析',
      connect_feat_indexing: '索引监控',
      connect_feat_keywords: '关键词追踪',
      connect_feat_sitemap: '网站地图管理',
      connect_btn_loading: '连接中...',
      connect_btn: '连接Google账户',
      prop_modal_title: '选择属性',
      prop_modal_desc: '选择要连接的Search Console属性。',
      prop_modal_empty: '未找到属性。请确认您在Google Search Console中有属性。',
      prop_modal_cancel: '取消',
      prop_modal_confirm: '确认',
      coming_soon_desc: '在{{phase}}中可用',
      top_opp_title: 'SEO顶级机会',
      top_opp_sub: '按机会分数排名的前10个查询',
      copy: '复制',
      copied: '已复制!',
      badge_quick_win: '🔥 Quick Win',
      badge_low_ctr: '⚡ 低点击率',
      badge_page_1: '🚀 第1页',
      badge_high_imp: '📈 高曝光',
      badge_brand: '🏷️ Brand',
      qt_category: '类别',
      qt_product: '产品',
      qt_generic: '通用',
      qt_info: 'Info',
      qt_brand: 'Brand',
      seo_analysis: 'SEO分析',
      generating_ai: '正在生成AI分析...',
      analysis_error: '生成分析出错。请稍后再试。',
      estimated_value: '预估价值',
      clicks_monthly: '潜在点击量/月',
      ctr_at_pos: '第{{pos}}位的CTR',
      traffic_increase: '流量增长',
      current_stats: '当前: {{clicks}}次点击/月 · +{{pts}}pp 预估CTR',
      priority_action: '优先行动',
      content_opt: '内容优化',
      title_seo: 'Title SEO',
      title_chars: '(50–60个字符)',
      title_copied: 'Title已复制!',
      h1_suggested: '建议H1',
      h1_page_title: '(页面标题)',
      h1_copied: 'H1已复制!',
      meta_desc: 'Meta Description',
      meta_chars: '(150–160个字符)',
      meta_copied: 'Meta已复制!',
      faq_all_copied: '所有FAQ已复制!',
      faq_suggested: '建议FAQ',
      copy_all: '全部复制',
      faq_copied: 'FAQ已复制!',
      related_kw: '相关关键词',
      click_to_copy: '· 点击复制',
      kw_copied: '"{{kw}}"已复制!',
      tech_suggestions: '技术建议',
      copy_keyword: '复制关键词',
      kw_copied_plain: '关键词已复制!',
      shopify_products: 'Shopify产品',
      search_store: '在店铺搜索',
      optimize_content: '优化内容',
      col_impressions: '展示次数',
      col_position: '排名',
      no_queries: '当前筛选条件下未找到查询。',
      ai_panel_title: 'AI建议',
      analyze_query: '分析查询 →',
      sugg_title_improvement: 'Title tag',
      sugg_meta: 'Meta description',
      sugg_content_gap: '缺失内容',
      sugg_schema: 'Schema markup',
      sugg_links: '内部链接',
      opp_load_err: '加载SEO机会出错',
      cache_updated: '缓存已更新 — 重新加载数据',
      cache_error: '刷新缓存出错',
      loading_data: '正在加载Search Console数据...',
      load_error_title: '无法加载机会',
      retry: '重试',
      tracked_queries: '跟踪的查询',
      sku_excluded: '已排除{{n}}个SKU/EAN',
      total_impressions: '总展示次数（28天）',
      total_clicks: '总点击量（28天）',
      avg_ctr: '平均CTR',
      ai_generating: '正在生成AI分析...',
      ai_generating_sub: 'AI建议将在片刻后显示。',
      no_ai_insights: '无可用AI洞察',
      no_ai_insights_sub: '未找到具有显著优化机会的查询。',
      filter_all: '全部 ({{n}})',
      search_placeholder: '搜索查询...',
      refresh_title: '刷新数据',
      page_prev: '← 上一页',
      page_info: '第{{page}}/{{total}}页 · {{count}}个查询',
      page_next: '下一页 →',
      footer_note: 'Search Console数据最近28天 · 缓存6h · 属性: {{url}}',
      footer_excluded: ' · 已排除{{n}}个SKU/EAN',
      verdict_pass: '已收录',
      verdict_fail: '未收录',
      verdict_neutral: '已排除',
      stato_title: 'Google状态 — 数据来源',
      in_sitemap: '在Sitemap中',
      sitemap_registered_lbl: '已注册的Sitemap',
      sitemap_errors_lbl: 'Sitemap错误',
      with_impressions: '有展示次数',
      search_appear_note: '出现在搜索中的页面 · {{days}}天',
      not_real_indexed: '≠ 实际被收录的页面',
      index_estimate_lbl: '收录估算',
      estimate_unavail: '检查200个URL后将显示估算值。启动批量扫描以收集样本。',
      inspected_lbl: '已检查',
      indexed_confirmed: '已确认收录',
      not_indexed_lbl: '未收录',
      excluded_lbl: '已排除',
      certain_data: '已检查URL的确定数据',
      batch_title: '批量扫描 — Inspection API',
      batch_priority: 'Analytics优先级',
      batch_progress: 'Sitemap检查进度',
      batch_stopping: '正在停止…',
      batch_running: '扫描中…',
      batch_starting: '正在启动...',
      batch_done_lbl: 'Sitemap完成 ✓',
      batch_start_btn: '开始扫描 ({{n}} 个可用)',
      batch_timeout: '超时 — 点击重置',
      batch_stopping_wait: '正在停止 — 请等待…',
      batch_stop_btn: '停止扫描',
      batch_remaining: '还有{{n}}个URL待检查',
      batch_quota_out: '每日配额已用完 — 明天再试',
      batch_start_err: '启动扫描出错',
      batch_complete: '扫描完成: 已检查{{n}}个URL',
      dq_title: 'API技术详情',
      dq_api_status: 'API状态',
      dq_daily_quota: '每日配额',
      dq_used_today: '今日已用',
      dq_remaining: '剩余',
      dq_history: '检查历史',
      dq_completion: '完成度',
      dq_days_est: '预计天数',
      dq_start_for_eta: '开始扫描以计算ETA',
      sm_no_sitemap: '未找到Sitemap',
      sm_no_sitemap_desc: '将sitemap.xml添加到Google Search Console以监控收录情况。',
      sm_submit_ok: 'Sitemap已提交到Google',
      sm_in_progress: '计算中…',
      sm_submit_btn: '提交',
      insp_title: '检查URL',
      insp_quota: '今日已用{{used}}/{{limit}}次检查',
      insp_loading: '检查中...',
      insp_btn: '检查',
      insp_domain_lbl: 'Property域名:',
      insp_domain_note: '被检查的URL必须属于该域名',
      insp_last_crawl: '最近抓取',
      insp_indexing: '索引状态',
      insp_yes: '是',
      insp_no: '否',
      insp_canonical_decl: '声明的canonical',
      insp_canonical_diff: '⚠ Google canonical（不同）',
      insp_noindex: '检测到noindex',
      insp_open_gsc: '在Search Console中打开',
      insp_err: 'URL检查错误',
      cov_title: '收录情况 — 原因',
      cov_real_data: '真实数据 — Inspection API',
      cov_conf_high: '高可信度',
      cov_conf_medium: '中可信度',
      cov_conf_low: '低可信度',
      cov_updated: '更新时间:',
      cov_deselect: '取消选择',
      cov_inspected_note: '已检查URL · 点击筛选',
      cov_none_inspected: '无检查记录',
      cov_no_data: '无收录数据',
      cov_no_data_desc: '未收录原因随每次URL检查自动生成。使用"启动自动扫描"来填充此部分。',
      cov_solution: '推荐修复方案',
      cov_filter_active: '历史记录中筛选器已激活',
      ih_worklist: 'SEO任务清单',
      ih_history: '检查历史',
      ih_filter_coverage: '收录筛选',
      ih_tab_all: '全部',
      ih_tab_not_ind: '未收录',
      ih_tab_indexed: '已收录',
      ih_tab_excluded: '已排除',
      ih_tab_errors: '错误',
      ih_tab_with_imp: '有展示',
      ih_tab_products: '产品',
      ih_tab_collections: '分类',
      ih_sort_priority: '↓ 优先级',
      ih_sort_impressions: '↓ 展示次数',
      ih_sort_clicks_est: '↓ 预计点击',
      ih_sort_date: '↓ 日期',
      ih_sort_state: '↓ GSC状态',
      ih_clear: '清除',
      ih_search: '搜索URL…',
      ih_open: '打开',
      ih_indexing_state: '索引状态',
      ih_canonical_diff: '⚠ Google选择的canonical（不同）',
      ih_canonical_same: 'Google canonical（相同）',
      ih_ai_fix: '用AI优化 →',
      ih_total: '{{n}}个URL · 共{{total}}个',
      ih_est_clicks: '· +{{n}}次点击/月（预计）',
      iai_title: 'AI建议 — 收录',
      iai_filter_note: '· 点击筛选',
      iai_prio_high: '高优先级',
      iai_prio_medium: '中优先级',
      iai_prio_low: '低优先级',
      iai_causes: '可能原因:',
      iai_actions: '推荐操作:',
      fix_apply_all: '全部应用',
      fix_applied: '已应用',
      fix_suggestion: '建议',
      fix_chars: '字符',
      fix_content_impr: '内容改进',
      fix_int_links: '建议内部链接',
      fix_open_url: '打开URL',
      fix_close: '关闭',
      fix_seo_opt: 'SEO优化',
      trend_title: '收录趋势',
      trend_updated: '更新至',
      trend_coverage: '覆盖率',
      trend_30d_kpi: '30天趋势',
      trend_no_data: '历史数据构建中',
      trend_no_data_desc: '收集至少2个快照后趋势将可用。',
      trend_one_snap: '已收集1/2个快照。',
      trend_start_scan: '启动批量扫描以开始。',
      trend_ind: '已收录',
      trend_not_ind: '未收录',
      trend_snap_note: '每次扫描快照',
      ic_loading: '正在加载收录数据...',
      ic_load_err: '无法加载收录数据',
      ic_clear_confirm: '清除所有检查历史记录？',
      ic_cleared: '历史记录已清除',
      ic_clear_err: '清除错误',
      ic_seo_opp: 'SEO机会 — 执行摘要',
      ic_recoverable: '可恢复的URL',
      ic_open_worklist: '⚡ 打开任务清单 →',
      ic_view_all: '查看全部 →',
      ic_crawled_ni: '已抓取 – 未收录',
      ic_crawled_ni_note: 'Google知道它们但不提供服务',
      ic_discovered_ni: '已发现 – 未收录',
      ic_discovered_ni_note: '已发现但从未被抓取',
      ic_with_imp_ni: '有GSC展示次数',
      ic_with_imp_ni_note: '有流量但未收录',
      ic_other_ni: '其他未收录',
      ic_other_ni_note: 'Google不知道或有错误',
      ic_refresh: '刷新',
      rh_title: '更改历史',
      rh_versions: '个版本',
      rh_confirm: "恢复{{date}}的版本？\n\n编辑器中的当前更改将被替换。",
      rh_restored_ok: 'v{{v}}已恢复到Shopify主题',
      rh_restored_editor: 'v{{v}}已加载到编辑器 — 点击保存以应用',
      rh_restore_err: '恢复错误',
      rh_current: '当前',
      rh_initial: '初始版本',
      rh_no_diff: '无文本更改',
      rh_more_added: '+ {{n}}个新增',
      rh_more_removed: '- {{n}}个删除',
      rh_restore_btn: '恢复',
      rb_load_err: '加载robots.txt时出错',
      rb_save_err: '保存错误',
      rb_analyze_err: '分析错误',
      rb_score_good: '优秀',
      rb_score_ok: '需要改进',
      rb_score_bad: '严重',
      rb_analysis_title: 'SEO机器人分析',
      rb_analyzing: '分析中…',
      rb_analyze: '分析',
      rb_analyze_hint: '点击"分析"自动检测SEO问题和优化机会',
      rb_no_issues: '未检测到问题',
      rb_no_issues_desc: '您的robots.txt遵循Shopify最佳实践',
      rb_critical: '严重',
      rb_warning: '警告',
      rb_validation_title: 'Robots.txt验证',
      rb_reload: '重新加载',
      rb_editor_title: 'Robots.txt编辑器',
      rb_modified: '已修改',
      rb_diff_close: '关闭差异',
      rb_editor_restore: '恢复',
      rb_saving: '保存中…',
      rb_save: '保存',
      rb_blocking_warning: '🚨 您正在阻止整个网站 — "Disallow: /" 阻止Google索引任何页面',
      rb_diff_preview: '更改预览:',
      rb_opportunity: '机会',
      rb_checker_title: '验证URL',
      rb_check_btn: '验证',
      rb_allowed: '允许',
      rb_blocked: '已阻止',
      rb_sitemaps_title: '已声明的站点地图',
      ll_history_title: 'LLMs.txt历史',
      ll_generated: '已生成',
      ll_restored_editor: 'v{{v}}已加载到编辑器 — 点击发布以应用',
      ll_load_err: '加载llms.txt时出错',
      ll_generate_err: '生成错误',
      ll_saved_ok: 'LLMs.txt已发布并在Shopify主题中验证',
      ll_not_configured: '未配置',
      ll_validation_title: 'LLMs.txt验证',
      ll_not_found: '网站上未找到llms.txt。使用"从Shopify生成"自动创建它。',
      ll_what_title: '什么是LLMs.txt？',
      ll_what_desc: '/llms.txt标准是一个markdown文件，帮助AI模型（ChatGPT、Claude、Perplexity、Gemini）理解您的网站并在回答中正确引用它。提高在AI回答引擎中的可见度。',
      ll_editor_title: 'LLMs.txt编辑器',
      ll_generating: '生成中…',
      ll_generate_btn: '从Shopify生成',
      tab_jsonld: 'JSON-LD',
      jl_load_err: '加载JSON-LD概览时出错',
      jl_sec_overview: '概览',
      jl_sec_schemas: '模式',
      jl_sec_problems: '问题',
      jl_sec_generate: 'AI优化',
      jl_sec_preview: 'JSON预览',
      jl_sec_validate: '验证',
      jl_sec_bulk: '批量操作',
      jl_sec_stats: '统计',
      jl_rich_results: '富搜索结果资格',
      jl_eligible: '符合资格',
      jl_warnings: '部分符合',
      jl_not_eligible: '不符合资格',
      jl_field_coverage: '字段覆盖率',
      jl_what_title: '什么是JSON-LD？',
      jl_what_desc: 'JSON-LD是Google推荐的结构化数据格式。它在搜索结果中启用富文本（星级、价格、面包屑），并帮助AI模型更好地理解您的产品。',
      jl_score_poor: '覆盖率差',
      jl_schemas_title: '支持的模式类型',
      jl_status_valid: '有效',
      jl_status_partial: '部分',
      jl_status_missing: '未配置',
      jl_valid_items: '有效',
      jl_issues: '问题',
      jl_google_test: '在Google富搜索结果中测试',
      jl_google_test_desc: '生成JSON-LD后，直接在Google工具中测试以验证资格。',
      jl_problems_title: '诊断问题',
      jl_no_problems: '未发现严重问题。您的JSON-LD覆盖率看起来很好！',
      jl_products_affected: '个产品受影响',
      jl_sev_critical: '严重',
      jl_sev_warning: '警告',
      jl_prob_brand: '缺少品牌/供应商',
      jl_prob_desc: '缺少描述',
      jl_prob_image: '缺少产品图片',
      jl_prob_sku: '缺少SKU',
      jl_prob_gtin: '缺少GTIN/条形码',
      jl_prob_meta: '缺少元描述',
      jl_prob_offers: '价格不在JSON-LD中（需要Shopify主题代码片段）',
      jl_problems_tip: '在产品部分修复缺失字段，或使用AI优化自动填写。',
      jl_gen_title: '生成JSON-LD',
      jl_schema_type: '模式类型',
      jl_product_id: '产品ID（留空使用示例）',
      jl_use_ai: '使用AI增强（GPT）',
      jl_gen_btn: '生成JSON-LD',
      jl_gen_ok: 'JSON-LD已生成',
      jl_gen_err: '生成错误',
      jl_copied: '已复制！',
      jl_copy: '复制',
      jl_preview_title: 'JSON-LD预览',
      jl_preview_err: '加载预览时出错',
      jl_load_preview: '加载示例产品',
      jl_preview_empty: '点击"加载示例产品"预览所有JSON-LD模式',
      jl_val_title: '本地模式验证',
      jl_invalid_json: 'JSON无效',
      jl_val_btn: '验证JSON-LD',
      jl_val_clear: '清除',
      jl_val_ok: '有效 — 符合富搜索结果资格',
      jl_val_fail: '验证失败',
      jl_val_note: '此验证器检查schema.org要求。如需官方Google测试，请使用富搜索结果测试工具。',
      jl_val_err: '验证错误',
      jl_bulk_title: '批量操作',
      jl_bulk_gen: '全部生成',
      jl_bulk_gen_desc: '为每个产品构建Product JSON-LD并保存到数据库',
      jl_bulk_val: '全部验证',
      jl_bulk_val_desc: '对现有JSON-LD运行schema.org验证',
      jl_bulk_fix: '修复和丰富',
      jl_bulk_fix_desc: '为有错误的产品重建JSON-LD',
      jl_bulk_started: '批量操作已启动',
      jl_bulk_err: '启动批量操作时出错',
      jl_bulk_running: '进行中',
      jl_bulk_done: '已完成',
      jl_bulk_stop: '停止',
      jl_bulk_stopped: '批量操作已停止',
      jl_errors: '错误',
      jl_stat_total: '产品总数',
      jl_stat_eligible: '富搜索结果符合资格',
      jl_stat_gen_today: '今日生成',
      jl_stat_fixed: '今日修复',
      jl_coverage_by_type: '按内容类型划分的覆盖率',
      jl_type: '类型',
      jl_total: '总计',
      jl_valid2: '有效',
      jl_missing2: '缺失',

      ll_revert: '撤销',
      ll_publishing: '发布中…',
      ll_publish: '发布',
      lp_filter_url: '过滤URL…',
      lp_copied: '已复制',
      lp_broken_empty: '未检测到断链',
      lp_broken_empty_sub: '所有商店URL均可访问 (404 / 410 / timeout)',
      lp_timeout: '超时 — 12秒内无响应',
      lp_ratelimit_empty: '未检测到速率限制',
      lp_ratelimit_empty_sub: '服务器未限制扫描器请求',
      lp_ratelimit_note: '页面可访问但服务器在扫描期间响应了429',
      lp_server_empty: '未检测到服务器错误',
      lp_server_empty_sub: '所有URL均正常响应 (无5xx)',
      lp_server_note: 'HTTP {{code}} — 服务器端错误',
      lp_redirect_empty: '未检测到重定向',
      lp_redirect_total: '总重定向数',
      lp_chains: '链式重定向 (>1跳)',
      lp_loops: '检测到循环',
      lp_chains_header: '重定向链',
      lp_chains_badge: '{{n}}条多重链',
      lp_final_status: '最终状态:',
      lp_canon_ok: '正确',
      lp_canon_miss: '缺失',
      lp_canon_wrong: 'URL错误',
      lp_canon_cross: '跨域',
      lp_canon_redir: 'Canonical→重定向',
      lp_canon_action_missing: '在页面的head部分添加canonical标签。',
      lp_canon_action_wrong: '修正canonical使其指向本页面的最终URL。',
      lp_canon_action_cross: 'canonical指向外部域名。检查是故意的还是错误。',
      lp_canon_action_redir: 'canonical指向会重定向的URL。用重定向的最终目标更新它。',
      lp_canon_no_data: 'Canonical数据不可用 — 开始扫描',
      lp_canon_issues: 'Canonical问题 ({{n}})',
      lp_canon_no_issues: '未检测到canonical问题',
      lp_canon_sample: '已分析样本：{{n}}个来自您商店的URL（产品、系列、页面、文章）',
      il_tab_orphans: '孤立页面',
      il_tab_weak: '弱链接',
      il_tab_deep: '深层页面',
      il_kpi_weak: '弱链接 ≤2',
      il_kpi_deep: '深层页面',
      il_orphan_empty: '无孤立页面',
      il_orphan_empty_sub: '所有页面至少有一个内部链接',
      il_orphan_header: '无入站链接的页面 ({{n}})',
      il_weak_empty: '无弱链接页面',
      il_weak_empty_sub: '所有页面有3个以上的内部链接',
      il_weak_header: '1–2个入站链接的页面 ({{n}})',
      il_anchor_empty: '锚文本已优化',
      il_anchor_empty_sub: '未检测到通用、空或重复的锚文本',
      il_anchor_generic: '通用锚文本',
      il_anchor_generic_desc: '如"点击这里"、"这里"、"了解更多"等文本',
      il_anchor_empty_type: '空锚文本',
      il_anchor_empty_desc: '没有描述性文本的链接',
      il_anchor_dup: '重复锚文本',
      il_anchor_dup_desc: '相同文本 → 不同URL',
      il_anchor_lbl_gen: '通用',
      il_anchor_lbl_empty: '空',
      il_anchor_lbl_dup: '重复',
      il_deep_empty: '无过深页面',
      il_deep_empty_sub: '所有页面可在≤3次点击内从首页访问',
      il_deep_header: '距首页>3次点击的页面 ({{n}})',
      il_deep_note: '标记∞的页面无法通过内部链接访问。将其添加到菜单或系列中。',
      il_hub_empty: '无枢纽数据可用',
      il_hub_empty_sub: '运行扫描以识别枢纽页面',
      il_hub_header: '枢纽页面 — 内部链接最多',
      il_hub_count: '{{n}}个内部入站链接',
      lm_active: '已激活',
      lm_not_installed: '未安装',
      lm_install_hint: '安装到主题以监控真实导航，无需爬虫',
      lm_refresh: '刷新',
      lm_clear: '清除数据',
      lm_remove: '从主题删除',
      lm_installing: '安装中…',
      lm_install: '安装到主题',
      lm_tab_404: '404错误',
      lm_tab_redirect: '重定向机会',
      lm_tab_top: '热门页面',
      lm_kpi_visits: '总访问量',
      lm_kpi_404s: '真实404错误',
      lm_no_404: '未检测到用户遇到的404错误',
      lm_visits: '次访问',
      lm_theme_prefix: '主题：',
      lm_last_activity: '最后活动：',
      lm_no_activity: '暂无访问',
      lm_installed: 'Monitor已安装到主题"{{name}}"',
      lm_err_install: '安装错误',
      lm_confirm_remove: '从活动主题中删除监控脚本？',
      lm_removed: '脚本已从主题中删除',
      lm_err_remove: '删除错误',
      lm_confirm_clear: '删除所有收集的监控数据？',
      lm_cleared: '数据已删除',
      lm_err_clear: '删除数据错误',
      lm_modal_title: '创建 301 重定向',
      lm_modal_source: '来源 URL (404)',
      lm_modal_dest: '目标',
      lm_redirect_created: '301 重定向已在 Shopify 上创建',
      lm_err_redirect: '创建重定向错误',
      lm_create_redirect: '创建重定向',
      lm_creating: '创建中…',
      lm_cancel: '取消',
      lm_info_title: 'Live Monitor 工作原理',
      lm_info_1: '"安装到主题"按钮通过 Shopify Themes API 自动向活动主题添加轻量级脚本',
      lm_info_2: '每次真实访问收集：URL、页面类型、内部链接、404错误、内部来源页',
      lm_info_3: '零爬虫 — 无 HTTP 429 — 实时获取真实访客数据',
      lm_info_4: '逐步构建内部链接地图并检测孤立页面',
      lm_no_redirect: '无需重定向',
      lm_no_redirect_hint1: 'Live Monitor尚未记录任何访问。当真实用户遇到404页面时，重定向机会将会显示。',
      lm_no_redirect_hint2: '在分析的{{n}}次访问中，没有用户遇到404页面。太棒了！',
      lm_toolbar_ai: '{{count}} 个URL · {{ai}} 个有AI建议',
      lm_toolbar_ignored: '· {{n}} 已忽略',
      lm_sort_visits: '访问量',
      lm_sort_date: '日期',
      lm_selected: '已选 {{n}} 个',
      lm_no_match: '无自动匹配',
      lm_create: '创建',
      lm_ignore: '忽略',
      lm_err: '错误',
      lm_bulk_ignored: '已忽略 {{n}} 个URL',
      lm_bulk_created: '已创建 {{n}} 个重定向',
      lm_errors: '个错误',
      ls_scan_started: '扫描已开始 — 将在后台完成',
      ls_scan_err: '启动扫描错误',
      ls_last_scan: '上次扫描：{{date}} · {{n}} 个URL',
      ls_no_scan_desc: '未执行扫描 — 检测断链、重定向、canonical、孤立页面',
      ls_scanning: '扫描中…',
      ls_rescan: '重新扫描',
      ls_start_scan: '开始扫描',
      ls_canonical_issues: 'Canonical问题',
      ls_scan_details: '扫描详情',
      ls_stat_total: '总URL数',
      ls_stat_errors: '错误',
      ls_no_scan: '未执行扫描',
      ls_no_scan_long: '启动扫描以检测断链、重定向链、canonical问题和没有入链的孤立页面',
      ls_first_scan: '开始首次扫描',
      db_gsc_connected: 'Google Search Console已连接！',
      db_gsc_err: 'GSC连接错误：{{code}}',
      db_props_err: '无法加载GSC属性',
      db_oauth_hint: '请在新标签页中完成Google授权。页面将自动刷新。',
      db_conn_err: 'GSC连接错误',
      db_prop_selected: '已选择属性：{{url}}',
      db_prop_err: '属性选择错误',
      db_confirm_disconnect: '断开Google Search Console连接？',
      db_disconnected: 'GSC已断开连接',
      db_disconnect_err: '断开连接错误',
      db_connected: 'Search Console已连接',
      db_no_property: '未选择属性',
      db_not_connected: '未连接',
      db_connect_hint: '连接GSC以解锁分析和监控功能',
      db_change_prop: '更改属性',
      db_disconnect: '断开连接',
      db_connect: '连接GSC',
      db_idx_subtitle: '技术SEO质量与索引',
      db_lbl_gsc: 'GSC已连接',
      db_lbl_sitemap: '已提交网站地图',
      db_lbl_indexed: '已索引URL',
      db_health_real: '基于真实Search Console数据',
      db_health_proxy: '基于目录质量 — 连接GSC获取真实数据',
      db_lbl_position: '排名',
      db_lbl_trend: '28天趋势',
      db_lbl_errors: '错误',
      db_connect_score: '连接GSC以计算分数',
      db_proxy_note: '目录代理',
      db_stat_excluded: '已排除URL',
      db_stat_seo_score: '平均SEO分数',
      db_catalog_title: '目录健康状况',
      db_cat_alt: '图片ALT文字',
      db_cat_keywords: '缺少关键词',
      db_cat_no_kw: '{{n}} 个产品没有关键词',
      db_cat_count: '{{n}} / {{total}} 个产品',
      tab_opportunities: 'SEO机会',
      tab_indexing: '索引',
      locked_available: '从{{plan}}计划起可用',
      locked_upgrade: '升级到{{plan}}计划',
      main_subtitle: '技术SEO · 索引 · Analytics · AI自动化',
      phase_3: '阶段3',
      interval_all: '全部',
      click_monthly_est: '预计点击数/月',
      fix_title_updated: '标题标签已更新',
      fix_meta_updated: '元描述已更新',
      fix_both_updated: '标题和元描述已在Shopify更新',
      fix_apply_err: '应用错误',
      rb_save_ok: 'Robots.txt已保存并在Shopify主题中验证',
      rb_draft_with_err: '草稿已保存 ({{err}})',
      rb_draft_manual: '草稿已保存 — 按照说明在主题中应用',
      rb_critical_confirm: '🚨 严重警告 🚨\n\n您的robots.txt包含"Disallow: /"，这将完全封锁整个网站:\nGoogle、Bing和所有机器人将无法抓取任何页面。\n\n这可能导致网站从搜索结果中被移除。\n\n您确定要继续吗？',
      scan_err: '扫描错误：{{msg}}',
      sm_send_err: '发送错误',
      unknown_err: '未知',
      dq_today: '今天',
      dq_7d: '过去7天',
      dq_30d: '过去30天',
      dq_daily_avg: '日均',
      dq_at_pace: '速率约{{n}}/天',
      job_stopped: '在处理{{n}}个URL时停止',
      job_inspected: '已检查{{n}}个',
      job_errors: '错误',
      quota_remaining: '剩余配额:',
      lk_trend: '索引趋势',
      lk_batch: '批量检查（批量URL扫描）',
      lk_ai: 'AI索引建议',
      footer_apis: 'Sitemaps API + Search Analytics + Inspection API',
      prod_status_lbl: '状态:',
      prod_desc_lbl: '描述:',
      prod_missing: '缺失',
      state_disc: '已发现',
      state_crawl: '已抓取',
      insp_api_real: 'Inspection API ✓ 实时',
      sm_count: '{{n}}个站点地图',
      sm_reliability: '可靠性:',
      conf_high: '高',
      conf_medium: '中',
      conf_low: '低',
      sm_urls: '站点地图中的URL',
      sm_sample: '样本',
      sm_est_indexed: '预计已索引',
      sm_est_nonidx: '预计未索引',
      sm_coverage: '预计覆盖率 ⓘ',
      sm_idx_of: '站点地图{{t}}个URL中~{{n}}个已索引',
      sm_cov_est: '预计覆盖率:',
      sm_margin_err: '误差范围',
      sm_indexed_of: '已索引/',
      sm_sampled: '已采样',
      sm_th_sitemap: '站点地图',
      sm_th_submitted: '已提交',
      sm_th_indexed: '已索引',
      sm_th_gap: '差距',
      sm_th_coverage: '覆盖率',
      sm_th_warning: '警告',
      sm_th_errors: '错误',
      sm_th_lastmod: '最后更新',
      sm_th_actions: '操作',
      rb_verified_result: '已保存并在Shopify主题({{theme}})中验证 — 文件:',
      rb_draft_result: '草稿已保存。手动应用: Shopify管理 → 主题 → 编辑代码 →',
      ll_draft_result: '草稿已保存。手动应用: Shopify管理 → 主题 → 编辑代码 →',
      ls_section_redirects: '重定向管理器',
      rm_tab: '重定向管理器',
      rm_subtitle: '在一个地方管理您商店的所有重定向。',
      rm_kpi_total: '总规则数',
      rm_kpi_active: '活跃重定向',
      rm_kpi_pending: '待处理404',
      rm_kpi_hits: '点击次数（30天）',
      rm_kpi_chains: '链式重定向',
      rm_kpi_loops: '循环重定向',
      rm_section_rules: '规则',
      rm_section_suggest: 'AI建议',
      rm_section_health: '健康检查',
      rm_section_import: '导入 / 导出',
      rm_section_history: '操作历史',
      rm_create_title: '创建重定向',
      rm_edit_title: '编辑重定向',
      rm_old_url: '旧URL',
      rm_new_url: '新URL',
      rm_old_url_ph: '/旧路径',
      rm_new_url_ph: '/新路径',
      rm_type: '类型',
      rm_type_301: '301 – 永久跳转',
      rm_type_302: '302 – 临时跳转',
      rm_notes: '备注',
      rm_save: '保存',
      rm_cancel: '取消',
      rm_create_ok: '重定向创建成功。',
      rm_edit_ok: '重定向更新成功。',
      rm_create_err: '创建重定向时出错。',
      rm_edit_err: '保存重定向时出错。',
      rm_dup_err: '该来源URL的重定向已存在。',
      rm_empty_err: '来源URL和目标URL为必填项。',
      rm_same_err: '来源URL和目标URL不能相同。',
      rm_search_ph: '搜索URL…',
      rm_filter_all: '全部',
      rm_filter_active: '活跃',
      rm_filter_disabled: '已禁用',
      rm_create_btn: '创建重定向',
      rm_selected_items: '已选{{count}}项',
      rm_bulk_enable: '启用',
      rm_bulk_disable: '禁用',
      rm_bulk_delete: '删除',
      rm_bulk_export: '导出CSV',
      rm_bulk_ok: '操作已完成。',
      rm_table_old: '旧URL',
      rm_table_new: '新URL',
      rm_table_type: '类型',
      rm_table_hits: '点击',
      rm_table_status: '状态',
      rm_table_actions: '操作',
      rm_edit: '编辑',
      rm_duplicate: '复制',
      rm_delete: '删除',
      rm_delete_confirm: '确认删除此重定向？',
      rm_deleted_ok: '重定向已删除。',
      rm_delete_err: '删除时出错。',
      rm_status_active: '活跃',
      rm_status_disabled: '已禁用',
      rm_no_data: '未找到重定向。',
      rm_empty_state: '暂无重定向。创建第一个重定向。',
      rm_total_redirects: '共{{count}}个重定向',
      rm_import_title: '导入重定向',
      rm_import_csv: 'CSV (old_url,new_url,type)',
      rm_import_shopify: 'Shopify Export CSV',
      rm_import_sf: 'Screaming Frog CSV',
      rm_import_btn: '导入',
      rm_import_ok: '导入已完成。',
      rm_import_err: '导入时出错。',
      rm_import_imported: '已导入{{count}}条',
      rm_import_skipped: '已跳过{{count}}条',
      rm_export_title: '导出重定向',
      rm_export_desc: '以可用格式下载所有重定向。',
      rm_export_csv: '导出CSV',
      rm_export_json: '导出JSON',
      rm_ai_title: 'AI建议',
      rm_ai_subtitle: 'AI检测到30404 URL，并建议重定向到相似产品。',
      rm_ai_accept: '接受',
      rm_ai_reject: '拒绝',
      rm_ai_accept_all: '全部接受',
      rm_ai_loading: '分析中…',
      rm_ai_empty: '目前暂无建议。',
      rm_chains_title: '链式重定向',
      rm_chains_desc: '多个链式重定向会展慢网站速度。',
      rm_chains_fix: '修复链式',
      rm_chains_empty: '未检测到链式重定向。',
      rm_chains_fixed: '链式重定向已修复。',
      rm_loops_title: '循环重定向',
      rm_loops_desc: '循环重定向导致错误，需要手动修复。',
      rm_loops_fix: '修复',
      rm_loops_empty: '未检测到循环重定向。',
      rm_gsc_title: '来自Google Search Console的404',
      rm_gsc_subtitle: 'GSC在过90天内检测到的未找到URL。',
      rm_gsc_empty: '未检测到GSC 404。',
      rm_history_title: '操作历史',
      rm_history_created: '已创建',
      rm_history_edited: '已编辑',
      rm_history_deleted: '已删除',
      rm_history_disabled: '已禁用',
      rm_history_enabled: '已启用',
      rm_history_imported: '已导入',
      rm_history_bulk: '批量操作',
      rm_history_empty: '暂无操作记录。',
      rm_sync_shopify: '从Shopify同步',
      rm_sync_shopify_desc: '导入Shopify中的所有URL重定向。新建的重定向自动推送到Shopify。',
      rm_sync_btn: '立即同步',
      error_label: '错误:',
      rb_checker_desc: '检查URL是否被{{bot}}基于当前robots.txt允许或阻止。',
      rb_rule: '规则:',
      rb_fix: '修正:',
      rb_gsc_note_title: 'Search Console集成',
      rb_gsc_note_body: '在索引部分，状态为"被robots阻止"的URL表示Google无法抓取的页面。',
      rb_issues: '问题',
      rb_opps: '机会',
      rb_savings: '预计节省:',
      never: '从未',
      samples_conf: '{{n}}个样本 · 置信度 {{c}}',
      batch_priority_note: '优先检查有Analytics展示量的URL · GSC配额2,000/天 · 后台处理',
      sm_samples: '个样本',
      sm_footnote_ec: '~ "计算中"的值 = Inspection API估算值（{{n}}个样本 · 置信度 {{c}}）。Sitemaps API对站点地图索引返回0。',
      sm_footnote_noec: '~ "计算中"的值 = 比例估算值。请启动批量扫描以获取估算。Sitemaps API对站点地图索引返回0。',
      ic_quota_note: '基于通过Inspection API检查的{{n}}个URL计算（配额2,000/天）。GSC Coverage显示站点地图中{{m}}个未索引URL。',
      cov_crawled_ni: '低质量或重复内容。改善内容，添加独特文本，验证canonical标签。',
      cov_disc_ni: 'Google已发现但尚未抓取。通过额外内部链接和更新的站点地图增加抓取预算。',
      cov_dup_nocanon: '添加指向主页面的canonical标签。',
      cov_dup_googcanon: 'Google忽略了声明的canonical。验证桌面/移动版本之间URL和canonical的一致性。',
      cov_redirect: '活跃重定向。如果是有意为之，更新内部链接以直接指向目标。',
      cov_alternate: '具有正确canonical的替代页面 — 如果是有意为之则无需操作。',
      cov_noindex: '如果希望页面被索引，请删除noindex元标签。',
      cov_robots: '页面被robots.txt阻止。验证Disallow指令并在必要时更新。',
      cov_removed: '已从GSC手动删除。如需要，在Search Console面板中撤销删除。',
      cov_404: '页面未找到。恢复页面，设置301重定向，或删除指向此URL的内部链接。',
      cov_soft404: '服务器返回200但Google将其视为空页面。确保页面有相关内容。',
      cov_server_err: '服务器错误。检查服务器日志和爬取期间的托管可用性。',
      cov_unknown_url: 'Google尚未发现此URL。添加内部链接，更新站点地图，等待下次爬取。',
      qt_brand: '品牌',
      qt_info: '信息',
      qt_category: '分类',
      qt_product: '产品',
      qt_generic: '通用',
      sugg_title_improvement: '标题标签',
      sugg_meta: '元描述',
      sugg_content_gap: '缺少内容',
      sugg_schema: 'Schema标记',
      sugg_links: '内部链接',
      verdict_indexed: '已收录',
      verdict_not_indexed: '未收录',
      verdict_excluded: '已排除',
      badge_col_header: '徽章',
      sitemap_label: '网站地图',
      ls_tab_broken: '死链',
      ls_tab_redirect: '重定向',
      ls_tab_rate_limited: '速率限制',
      ls_tab_server_errors: '服务器错误',
      ls_tab_canonical: '规范标签',
      ls_tab_internal: '内部链接',
      ls_section_monitor: '实时监控',
      ls_section_audit: '站点结构',
      db_idx_title: '索引评分',
      db_health_title: 'SC健康评分',
      canonical_mismatch: '规范标签不匹配',
    },
    so: {
      load_err: 'Speed Optimizer加载错误',
      analyze_timeout: '分析超时(90秒) — 请重试',
      analyze_done: '分析完成!',
      analyze_failed: '分析失败: {{error}}',
      rate_limited: '已达到请求限制 — 数据已从缓存更新',
      analyze_err: '分析错误',
      opt_enabled: '{{label}}已在主题中启用',
      opt_disabled: '{{label}}已禁用',
      opt_err: '优化错误',
      scan_err: '主题扫描错误',
      img_err: '图像分析错误',
      sg_protected: 'Safety Guard: Protected已启用',
      sg_standard: 'Safety Guard: Standard已启用',
      mode_err: '模式更改错误',
      plan_err: '计划生成错误',
      strategy_applied: '策略{{label}}已应用于主题',
      strategy_err: '策略应用错误',
      sessions_err: '会话加载错误',
      rollback_done: '回滚完成 — 主题已恢复',
      rollback_err: '回滚错误',
      subtitle: '安全的Shopify主题优化，支持即时回滚。',
      btn_rollback: '全部回滚',
      btn_analyze: '立即分析',
      analyzing_psi: 'PSI处理中…',
      analyzing_queue: '排队中…',
      analyzing: '分析中…',
      alert_no_token: 'Shopify令牌缺失 — 优化需要活跃的店铺连接。',
      alert_no_scope: '主题权限缺失 — 要应用优化，您需要重新安装应用。',
      perf_empty: '没有可用的分析',
      perf_empty_hint: '点击"立即分析"来测量您的店铺性能',
      suggestions: '建议',
      strategy_active: '活跃',
      strategy_subtitle: '设置优化目标。点击在应用前查看计划。',
      sg_header: '限制策略可以执行的操作。',
      sg_desc_protected: '阻止Standard操作 — 仅限安全优化。',
      sg_desc_standard: '允许完整执行所选策略。',
      quick_opts: '快速优化',
      sg_warning: 'Safety Guard: Protected — Standard操作已阻止。在上方切换到Standard。',
      lcp_section: 'LCP主题扫描',
      hist_section: '优化历史',
      hist_empty: '尚未应用任何优化。',
      sessions_section: '会话 & Lighthouse影响',
      sessions_empty: '加载会话以查看对Core Web Vitals的实际影响。',
      img_count: '{{n}}张图片 · {{kb}} KB总计',
      img_oversized: '{{n}}张图片 >300KB',
      img_no_oversized: '没有超大图片 — 太棒了!',
      img_empty: '点击"分析图片"查找主题中>300KB的图片。',
      btn_refresh: '重新加载',
      btn_load_sessions: '加载会话',
      btn_refresh_sessions: '刷新',
      btn_analyze_img: '分析图片',
      btn_refresh_img: '刷新',
      modal_risk_safe: '安全 — 预计不会有视觉影响',
      modal_risk_medium: '激活后请检查网站外观',
      modal_risk_high: '可能影响高级功能',
      modal_reversible: '随时可逆 — 使用"全部回滚"恢复原始主题。',
      modal_cancel: '取消',
      modal_enable: '立即启用',
      opt_no_token: '重新连接Shopify店铺以使用此功能',
      opt_blocked_guard: '被Safety Guard (Protected)阻止 — 切换到Standard以启用',
      opt_reversible: '可逆',
      opt_blocked_label: '被Safety Guard阻止 — 切换到Standard',
      scan_scanning: '扫描中...',
      scan_empty_title: '主题扫描未执行',
      scan_empty_desc: '识别主题中的hero和幻灯片部分，以启用服务器端LCP优化。',
      scan_btn: '扫描主题',
      scan_active_theme: '当前主题',
      scan_files: '已扫描{{n}}个Liquid文件 · 识别{{s}}个LCP部分',
      scan_hero_label: 'hero/LCP部分',
      scan_optimized: '已优化',
      scan_no_lcp: '未在主题中自动识别任何hero/LCP部分。',
      scan_reload: '重新加载',
      plan_title: '计划: {{label}}',
      plan_ops: '{{n}}个计划操作',
      plan_action_enabled: '已激活',
      plan_action_enable: '启用',
      plan_action_disable: '禁用',
      plan_strategy: '策略: ',
      plan_guard: 'Safety Guard: ',
      plan_active_ops: '活动操作: ',
      plan_blocked: '{{n}}个被Safety Guard阻止',
      plan_low_conf: '某些优化对检测到的主题信心较低。',
      plan_cancel: '取消',
      plan_apply: '应用策略',
      plan_blocked_btn: '已阻止 (分数低)',
      hist_rollback: '完全回滚 — 所有优化已删除',
      hist_enabled: '已启用',
      hist_disabled: '已禁用',
      hist_active: '活跃',
      sess_no_sessions: '没有记录优化会话。应用策略时会创建会话。',
      sess_waiting: '等待PSI',
      strategy_label: '策略 {{s}}',
      strategy_opts: '{{n}}个优化',
      strategy_active: '活跃',
      quota_err: '加载PSI配额时出错',
      quota_api_key: 'API密钥已配置:',
      quota_yes: '✓ 是',
      quota_no: '✗ 否 (使用公共配额)',
      quota_cache_ttl: '缓存TTL:',
      quota_hourly: '每小时限制:',
      quota_daily: '每日限制:',
      quota_success: '今日成功:',
      quota_hit_ratio: '缓存命中率:',
      quota_circuit: '断路器:',
      quota_circuit_open: '断开 ({{n}} 次故障)',
      quota_circuit_closed: '关闭',
      quota_loading: '加载中...',
      diag_err: '诊断错误',
      diag_refresh: '刷新',
      diag_load: '加载诊断',
      diag_patches: '活动补丁 ({{n}})',
      diag_none: '无',
      diag_unavailable: '不可用',
      diag_no_patches: '无活动补丁',
      diag_calibrated: '📈 已校准',
      diag_generated: '生成时间:',
      badge_server_side: '服务端',
      badge_standard: '标准',
      badge_lcp: 'LCP',
      badge_critical: '严重',
      badge_safe: '安全',
      badge_medium: '中等',
      badge_safety_guard: '安全卫士',
      diag_theme_fingerprint: '主题指纹',
      diag_engine_confidence: '引擎可信度',
      perf_score_label: '性能评分',
      section_perf_overview: '性能概览',
      section_strategy_intent: '战略意图',
      safety_guard_title: '安全卫士',
      section_script_analyzer: '脚本影响分析',
      script_col_file: '文件',
      script_col_size: '大小',
      script_col_impact: '影响',
      script_col_defer_risk: '延迟风险',
      metric_js_total: 'JS总计',
      metric_css_total: 'CSS总计',
      perf_updated: '更新时间:',
      perf_stale: '过时数据（PSI不可用）',
      perf_from_cache: '来自缓存',
      perf_psi_ok: 'PSI正常',
      debug_invalid_token_title: '无效令牌（401）— MongoDB中的令牌已过期或被撤销。',
      debug_reconnect_desc: 'OAuth回调在最后一次重新安装后没有覆盖令牌。点击下面的按钮开始新的OAuth认证。',
      debug_reconnect_btn: '立即重新连接OAuth（打开Shopify）',
      debug_reconnect_note: '在Shopify上批准权限后，回调将自动更新MongoDB中的令牌。',
    },
    drafts: {
      approved: '草稿已批准！',
      approve_err: '批准错误',
      published: '已发布到Shopify！',
      publish_err: '发布错误',
      title: '草稿与结果',
      subtitle: '审查、批准并发布优化内容',
      empty: '没有需要审查的草稿',
      empty_hint: '生成AI内容以创建新草稿',
      badge_approved: '已批准',
      badge_draft: '草稿',
      field_desc: '描述',
      btn_view: '查看',
      btn_approve: '批准',
      btn_publish: '发布',
      modal_title: '草稿详情',
      chars_seo: '/60字符',
      chars_meta: '/160字符',
      not_present: '未填写',
      not_present_pl: '未填写',
      btn_close: '关闭',
      btn_publish_shopify: '发布到Shopify',
      seo_title: 'SEO标题',
      meta_description: '元描述',
      keywords_label: '关键词',
    },
    usage: {
      title: '使用情况与计划',
      subtitle: '监控使用情况并管理订阅',
      plan_badge: '计划:',
      current: '当前使用情况',
      credits: 'AI积分',
      used: '已使用:',
      unlimited: '无限制 ∞',
      remaining: '剩余: {{n}}',
      products_sync: '已同步产品',
      plans_heading: '可用计划',
      most_popular: '⭐ 最受欢迎',
      active_plan: '当前激活计划',
      current_plan: '当前计划',
      btn_upgrade: '升级到{{name}}',
      trend_heading: '使用趋势',
      trend_coming: '使用图表（即将推出）',
      stat_products: '已分析产品',
      stat_content: '已生成内容',
      stat_translations: '翻译',
      stat_images: '已优化图片',
    },
    support: {
      msg_sent: '消息已发送！',
      msg_err: '发送消息失败',
      status_open: '开放',
      status_progress: '处理中',
      status_closed: '已关闭',
      title: '支持',
      subtitle: '常见问题、指南和与团队聊天',
      faq_heading: '常见问题',
      guide_heading: '快速指南',
      chat_heading: '支持聊天',
      no_msgs: '暂无消息',
      no_msgs_hint: '开始与支持团队对话',
      placeholder: '输入消息...',
      contacts_heading: '联系方式',
      contact_hours_label: '时间',
      contact_hours: '周一至周五 9:00-18:00 CET',
      contact_response_label: '响应时间',
      contact_response: '24小时内',
      guide_step1: '前往',
      guide_products: '产品',
      guide_step1b: '部分查看您的产品',
      guide_step2: '选择产品并前往',
      guide_ai_content: 'AI内容',
      guide_step3: '生成描述、SEO标题、元描述和关键词',
      guide_step4: '在以下查看结果',
      guide_history: '历史记录',
    },
    transl: {
      load_err: '加载元素时出错',
      published: '翻译已发布到Shopify！',
      pub_err: '发布错误',
      err_no_items: '请至少选择一个元素',
      err_no_fields: '请至少选择一个要翻译的字段',
      item_err: '翻译错误',
      done_one: '翻译完成！',
      done_many: '已翻译{{n}}个元素！',
      copied: '已复制到剪贴板',
      title: '翻译',
      gate_plan: '从Starter计划起可用',
      gate_desc: '使用AI将产品、合集和文章翻译成8种语言',
      gate_btn: '切换到Starter计划',
      subtitle: '使用AI将产品、合集、文章和页面翻译成多种语言',
      translating: '翻译中…',
      search_placeholder: '按标题搜索…',
      select_page: '选择页面',
      sel_abbrev: '已选',
      total_items: '总计',
      loading: '加载中…',
      no_results: '此搜索无结果',
      prev: '← 上一页',
      tot_abbrev: '共',
      next: '下一页 →',
      deselect_all: '取消全选',
      lang_heading: '目标语言',
      fields_heading: '要翻译的字段',
      select_hint: '从列表中选择项目以启用翻译',
      results_heading: '结果',
      clear_results: '清除结果',
      badge_published: '已发布',
      publishing: '发布中…',
      done: '完成',
      publish: '发布',
      copy: '复制',
      tab_products: '产品',
      tab_collections: '合集',
      tab_articles: '文章',
      tab_pages: '页面',
      field_title: '标题',
      field_description: '描述',
      field_seo_title: 'SEO Title',
      field_meta_description: 'Meta Description',
      field_body_html: '描述 / 正文',
      empty_hint_select: '从列表中选择一个或多个项目，选择语言并点击',
      translate_label: '翻译',
      items_selected: '个项目',
      item_selected: '个项目',
      selected_label: '已选择',
      choose_fields_hint: '选择字段并点击翻译',
    },
  },
};

export default translations;
